var _wrapNativeSuper = require("/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/wrapNativeSuper");
var _construct = require("/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/construct");
var _defineProperty = require("/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/defineProperty");
var _objectSpread = require("/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectSpread");
var _get = require("/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/get");
var _assertThisInitialized = require("/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/assertThisInitialized");
var _slicedToArray = require("/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");
var _toConsumableArray = require("/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/toConsumableArray");
var _possibleConstructorReturn = require("/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");
var _getPrototypeOf = require("/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");
var _inherits = require("/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");
var _classCallCheck = require("/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");
var _createClass = require("/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == typeof h && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(typeof e + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function _superPropGet(t, o, e, r) { var p = _get(_getPrototypeOf(1 & r ? t.prototype : t), o, e); return 2 & r && "function" == typeof p ? function (t) { return p.apply(e, t); } : p; }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n30 = 0, F = function F() {}; return { s: F, n: function n() { return _n30 >= r.length ? { done: !0 } : { done: !1, value: r[_n30++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
!function (e) {
  var t = e.en = e.en || {};
  t.dictionary = Object.assign(t.dictionary || {}, {
    "%0 of %1": "%0 of %1",
    Aquamarine: "Aquamarine",
    Black: "Black",
    Blue: "Blue",
    Cancel: "Cancel",
    "Dim grey": "Dim grey",
    "Dropdown toolbar": "Dropdown toolbar",
    "Edit block": "Edit block",
    "Editor toolbar": "Editor toolbar",
    Green: "Green",
    Grey: "Grey",
    "Insert paragraph after block": "Insert paragraph after block",
    "Insert paragraph before block": "Insert paragraph before block",
    "Light blue": "Light blue",
    "Light green": "Light green",
    "Light grey": "Light grey",
    Next: "Next",
    Orange: "Orange",
    Previous: "Previous",
    Purple: "Purple",
    Red: "Red",
    Redo: "Redo",
    "Remove color": "Remove color",
    "Restore default": "Restore default",
    "Rich Text Editor": "Rich Text Editor",
    "Rich Text Editor, %0": "Rich Text Editor, %0",
    Save: "Save",
    "Select all": "Select all",
    "Show more items": "Show more items",
    Turquoise: "Turquoise",
    Undo: "Undo",
    "Upload in progress": "Upload in progress",
    White: "White",
    "Widget toolbar": "Widget toolbar",
    Yellow: "Yellow"
  });
}(window.CKEDITOR_TRANSLATIONS || (window.CKEDITOR_TRANSLATIONS = {})),
/*!
 * @license Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md.
 */
function () {
  var e = {
      "./node_modules/css-loader/dist/cjs.js!./node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].use[2]!./packages/ckeditor5-clipboard/theme/clipboard.css": function _node_modules_cssLoader_dist_cjsJs_node_modules_postcssLoader_dist_cjsJsRuleSet1Rules1Use2_packages_ckeditor5Clipboard_theme_clipboardCss(e, t, s) {
        "use strict";

        s.d(t, {
          Z: function Z() {
            return r;
          }
        });
        var o = s("./node_modules/css-loader/dist/runtime/api.js"),
          i = s.n(o)()(function (e) {
            return e[1];
          });
        i.push([e.id, '.ck.ck-editor__editable .ck.ck-clipboard-drop-target-position{display:inline;position:relative;pointer-events:none}.ck.ck-editor__editable .ck.ck-clipboard-drop-target-position span{position:absolute;width:0}.ck.ck-editor__editable .ck-widget:-webkit-drag>.ck-widget__selection-handle,.ck.ck-editor__editable .ck-widget:-webkit-drag>.ck-widget__type-around{display:none}:root{--ck-clipboard-drop-target-dot-width:12px;--ck-clipboard-drop-target-dot-height:8px;--ck-clipboard-drop-target-color:var(--ck-color-focus-border)}.ck.ck-editor__editable .ck.ck-clipboard-drop-target-position span{bottom:calc(var(--ck-clipboard-drop-target-dot-height)*-0.5);top:calc(var(--ck-clipboard-drop-target-dot-height)*-0.5);border:1px solid var(--ck-clipboard-drop-target-color);background:var(--ck-clipboard-drop-target-color);margin-left:-1px}.ck.ck-editor__editable .ck.ck-clipboard-drop-target-position span:after{content:"";width:0;height:0;display:block;position:absolute;left:50%;top:calc(var(--ck-clipboard-drop-target-dot-height)*-0.5);transform:translateX(-50%);border-left:calc(var(--ck-clipboard-drop-target-dot-width)*0.5) solid transparent;border-bottom:0 solid transparent;border-right:calc(var(--ck-clipboard-drop-target-dot-width)*0.5) solid transparent;border-top:calc(var(--ck-clipboard-drop-target-dot-height)) solid var(--ck-clipboard-drop-target-color)}.ck.ck-editor__editable .ck-widget.ck-clipboard-drop-target-range{outline:var(--ck-widget-outline-thickness) solid var(--ck-clipboard-drop-target-color)!important}.ck.ck-editor__editable .ck-widget:-webkit-drag{zoom:.6;outline:none!important}', ""]);
        var r = i;
      },
      "./node_modules/css-loader/dist/cjs.js!./node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].use[2]!./packages/ckeditor5-engine/theme/placeholder.css": function _node_modules_cssLoader_dist_cjsJs_node_modules_postcssLoader_dist_cjsJsRuleSet1Rules1Use2_packages_ckeditor5Engine_theme_placeholderCss(e, t, s) {
        "use strict";

        s.d(t, {
          Z: function Z() {
            return r;
          }
        });
        var o = s("./node_modules/css-loader/dist/runtime/api.js"),
          i = s.n(o)()(function (e) {
            return e[1];
          });
        i.push([e.id, ".ck.ck-placeholder,.ck .ck-placeholder{position:relative}.ck.ck-placeholder:before,.ck .ck-placeholder:before{position:absolute;left:0;right:0;content:attr(data-placeholder);pointer-events:none}.ck.ck-read-only .ck-placeholder:before{display:none}.ck.ck-reset_all .ck-placeholder{position:relative}.ck.ck-placeholder:before,.ck .ck-placeholder:before{cursor:text;color:var(--ck-color-engine-placeholder-text)}", ""]);
        var r = i;
      },
      "./node_modules/css-loader/dist/cjs.js!./node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].use[2]!./packages/ckeditor5-engine/theme/renderer.css": function _node_modules_cssLoader_dist_cjsJs_node_modules_postcssLoader_dist_cjsJsRuleSet1Rules1Use2_packages_ckeditor5Engine_theme_rendererCss(e, t, s) {
        "use strict";

        s.d(t, {
          Z: function Z() {
            return r;
          }
        });
        var o = s("./node_modules/css-loader/dist/runtime/api.js"),
          i = s.n(o)()(function (e) {
            return e[1];
          });
        i.push([e.id, ".ck.ck-editor__editable span[data-ck-unsafe-element]{display:none}", ""]);
        var r = i;
      },
      "./node_modules/css-loader/dist/cjs.js!./node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].use[2]!./packages/ckeditor5-ui/theme/components/button/button.css": function _node_modules_cssLoader_dist_cjsJs_node_modules_postcssLoader_dist_cjsJsRuleSet1Rules1Use2_packages_ckeditor5Ui_theme_components_button_buttonCss(e, t, s) {
        "use strict";

        s.d(t, {
          Z: function Z() {
            return r;
          }
        });
        var o = s("./node_modules/css-loader/dist/runtime/api.js"),
          i = s.n(o)()(function (e) {
            return e[1];
          });
        i.push([e.id, ".ck.ck-button,a.ck.ck-button{-moz-user-select:none;-webkit-user-select:none;-ms-user-select:none;user-select:none}.ck.ck-button .ck-tooltip,a.ck.ck-button .ck-tooltip{display:block}@media (hover:none){.ck.ck-button .ck-tooltip,a.ck.ck-button .ck-tooltip{display:none}}.ck.ck-button,a.ck.ck-button{position:relative;display:inline-flex;align-items:center;justify-content:left}.ck.ck-button .ck-button__label,a.ck.ck-button .ck-button__label{display:none}.ck.ck-button.ck-button_with-text .ck-button__label,a.ck.ck-button.ck-button_with-text .ck-button__label{display:inline-block}.ck.ck-button:not(.ck-button_with-text),a.ck.ck-button:not(.ck-button_with-text){justify-content:center}.ck.ck-button:hover .ck-tooltip,a.ck.ck-button:hover .ck-tooltip{visibility:visible;opacity:1}.ck.ck-button:focus:not(:hover) .ck-tooltip,a.ck.ck-button:focus:not(:hover) .ck-tooltip{display:none}.ck.ck-button,a.ck.ck-button{background:var(--ck-color-button-default-background)}.ck.ck-button:not(.ck-disabled):hover,a.ck.ck-button:not(.ck-disabled):hover{background:var(--ck-color-button-default-hover-background)}.ck.ck-button:not(.ck-disabled):active,a.ck.ck-button:not(.ck-disabled):active{background:var(--ck-color-button-default-active-background);box-shadow:inset 0 2px 2px var(--ck-color-button-default-active-shadow)}.ck.ck-button.ck-disabled,a.ck.ck-button.ck-disabled{background:var(--ck-color-button-default-disabled-background)}.ck.ck-button,a.ck.ck-button{border-radius:0}.ck-rounded-corners .ck.ck-button,.ck-rounded-corners a.ck.ck-button,.ck.ck-button.ck-rounded-corners,a.ck.ck-button.ck-rounded-corners{border-radius:var(--ck-border-radius)}.ck.ck-button,a.ck.ck-button{white-space:nowrap;cursor:default;vertical-align:middle;padding:var(--ck-spacing-tiny);text-align:center;min-width:var(--ck-ui-component-min-height);min-height:var(--ck-ui-component-min-height);line-height:1;font-size:inherit;border:1px solid transparent;transition:box-shadow .2s ease-in-out,border .2s ease-in-out;-webkit-appearance:none}.ck.ck-button:active,.ck.ck-button:focus,a.ck.ck-button:active,a.ck.ck-button:focus{outline:none;border:var(--ck-focus-ring);box-shadow:var(--ck-focus-outer-shadow),0 0}.ck.ck-button .ck-button__icon use,.ck.ck-button .ck-button__icon use *,a.ck.ck-button .ck-button__icon use,a.ck.ck-button .ck-button__icon use *{color:inherit}.ck.ck-button .ck-button__label,a.ck.ck-button .ck-button__label{font-size:inherit;font-weight:inherit;color:inherit;cursor:inherit;vertical-align:middle}[dir=ltr] .ck.ck-button .ck-button__label,[dir=ltr] a.ck.ck-button .ck-button__label{text-align:left}[dir=rtl] .ck.ck-button .ck-button__label,[dir=rtl] a.ck.ck-button .ck-button__label{text-align:right}.ck.ck-button .ck-button__keystroke,a.ck.ck-button .ck-button__keystroke{color:inherit}[dir=ltr] .ck.ck-button .ck-button__keystroke,[dir=ltr] a.ck.ck-button .ck-button__keystroke{margin-left:var(--ck-spacing-large)}[dir=rtl] .ck.ck-button .ck-button__keystroke,[dir=rtl] a.ck.ck-button .ck-button__keystroke{margin-right:var(--ck-spacing-large)}.ck.ck-button .ck-button__keystroke,a.ck.ck-button .ck-button__keystroke{font-weight:700;opacity:.7}.ck.ck-button.ck-disabled:active,.ck.ck-button.ck-disabled:focus,a.ck.ck-button.ck-disabled:active,a.ck.ck-button.ck-disabled:focus{box-shadow:var(--ck-focus-disabled-outer-shadow),0 0}.ck.ck-button.ck-disabled .ck-button__icon,a.ck.ck-button.ck-disabled .ck-button__icon{opacity:var(--ck-disabled-opacity)}.ck.ck-button.ck-disabled .ck-button__label,a.ck.ck-button.ck-disabled .ck-button__label{opacity:var(--ck-disabled-opacity)}.ck.ck-button.ck-disabled .ck-button__keystroke,a.ck.ck-button.ck-disabled .ck-button__keystroke{opacity:.3}.ck.ck-button.ck-button_with-text,a.ck.ck-button.ck-button_with-text{padding:var(--ck-spacing-tiny) var(--ck-spacing-standard)}[dir=ltr] .ck.ck-button.ck-button_with-text .ck-button__icon,[dir=ltr] a.ck.ck-button.ck-button_with-text .ck-button__icon{margin-left:calc(var(--ck-spacing-small)*-1);margin-right:var(--ck-spacing-small)}[dir=rtl] .ck.ck-button.ck-button_with-text .ck-button__icon,[dir=rtl] a.ck.ck-button.ck-button_with-text .ck-button__icon{margin-right:calc(var(--ck-spacing-small)*-1);margin-left:var(--ck-spacing-small)}.ck.ck-button.ck-button_with-keystroke .ck-button__label,a.ck.ck-button.ck-button_with-keystroke .ck-button__label{flex-grow:1}.ck.ck-button.ck-on,a.ck.ck-button.ck-on{background:var(--ck-color-button-on-background)}.ck.ck-button.ck-on:not(.ck-disabled):hover,a.ck.ck-button.ck-on:not(.ck-disabled):hover{background:var(--ck-color-button-on-hover-background)}.ck.ck-button.ck-on:not(.ck-disabled):active,a.ck.ck-button.ck-on:not(.ck-disabled):active{background:var(--ck-color-button-on-active-background);box-shadow:inset 0 2px 2px var(--ck-color-button-on-active-shadow)}.ck.ck-button.ck-on.ck-disabled,a.ck.ck-button.ck-on.ck-disabled{background:var(--ck-color-button-on-disabled-background)}.ck.ck-button.ck-button-save,a.ck.ck-button.ck-button-save{color:var(--ck-color-button-save)}.ck.ck-button.ck-button-cancel,a.ck.ck-button.ck-button-cancel{color:var(--ck-color-button-cancel)}.ck.ck-button-action,a.ck.ck-button-action{background:var(--ck-color-button-action-background)}.ck.ck-button-action:not(.ck-disabled):hover,a.ck.ck-button-action:not(.ck-disabled):hover{background:var(--ck-color-button-action-hover-background)}.ck.ck-button-action:not(.ck-disabled):active,a.ck.ck-button-action:not(.ck-disabled):active{background:var(--ck-color-button-action-active-background);box-shadow:inset 0 2px 2px var(--ck-color-button-action-active-shadow)}.ck.ck-button-action.ck-disabled,a.ck.ck-button-action.ck-disabled{background:var(--ck-color-button-action-disabled-background)}.ck.ck-button-action,a.ck.ck-button-action{color:var(--ck-color-button-action-text)}.ck.ck-button-bold,a.ck.ck-button-bold{font-weight:700}", ""]);
        var r = i;
      },
      "./node_modules/css-loader/dist/cjs.js!./node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].use[2]!./packages/ckeditor5-ui/theme/components/button/switchbutton.css": function _node_modules_cssLoader_dist_cjsJs_node_modules_postcssLoader_dist_cjsJsRuleSet1Rules1Use2_packages_ckeditor5Ui_theme_components_button_switchbuttonCss(e, t, s) {
        "use strict";

        s.d(t, {
          Z: function Z() {
            return r;
          }
        });
        var o = s("./node_modules/css-loader/dist/runtime/api.js"),
          i = s.n(o)()(function (e) {
            return e[1];
          });
        i.push([e.id, ".ck.ck-button.ck-switchbutton .ck-button__toggle,.ck.ck-button.ck-switchbutton .ck-button__toggle .ck-button__toggle__inner{display:block}:root{--ck-switch-button-toggle-width:2.6153846154em;--ck-switch-button-toggle-inner-size:1.0769230769em;--ck-switch-button-toggle-spacing:1px;--ck-switch-button-translation:calc(var(--ck-switch-button-toggle-width) - var(--ck-switch-button-toggle-inner-size) - var(--ck-switch-button-toggle-spacing)*2)}[dir=ltr] .ck.ck-button.ck-switchbutton .ck-button__label{margin-right:calc(var(--ck-spacing-large)*2)}[dir=rtl] .ck.ck-button.ck-switchbutton .ck-button__label{margin-left:calc(var(--ck-spacing-large)*2)}.ck.ck-button.ck-switchbutton .ck-button__toggle{border-radius:0}.ck-rounded-corners .ck.ck-button.ck-switchbutton .ck-button__toggle,.ck.ck-button.ck-switchbutton .ck-button__toggle.ck-rounded-corners{border-radius:var(--ck-border-radius)}[dir=ltr] .ck.ck-button.ck-switchbutton .ck-button__toggle{margin-left:auto}[dir=rtl] .ck.ck-button.ck-switchbutton .ck-button__toggle{margin-right:auto}.ck.ck-button.ck-switchbutton .ck-button__toggle{transition:background .4s ease;width:var(--ck-switch-button-toggle-width);background:var(--ck-color-switch-button-off-background)}.ck.ck-button.ck-switchbutton .ck-button__toggle .ck-button__toggle__inner{border-radius:0}.ck-rounded-corners .ck.ck-button.ck-switchbutton .ck-button__toggle .ck-button__toggle__inner,.ck.ck-button.ck-switchbutton .ck-button__toggle .ck-button__toggle__inner.ck-rounded-corners{border-radius:var(--ck-border-radius);border-radius:calc(var(--ck-border-radius)*0.5)}.ck.ck-button.ck-switchbutton .ck-button__toggle .ck-button__toggle__inner{margin:var(--ck-switch-button-toggle-spacing);width:var(--ck-switch-button-toggle-inner-size);height:var(--ck-switch-button-toggle-inner-size);background:var(--ck-color-switch-button-inner-background);transition:all .3s ease}.ck.ck-button.ck-switchbutton .ck-button__toggle:hover{background:var(--ck-color-switch-button-off-hover-background)}.ck.ck-button.ck-switchbutton .ck-button__toggle:hover .ck-button__toggle__inner{box-shadow:0 0 0 5px var(--ck-color-switch-button-inner-shadow)}.ck.ck-button.ck-switchbutton.ck-disabled .ck-button__toggle{opacity:var(--ck-disabled-opacity)}.ck.ck-button.ck-switchbutton.ck-on .ck-button__toggle{background:var(--ck-color-switch-button-on-background)}.ck.ck-button.ck-switchbutton.ck-on .ck-button__toggle:hover{background:var(--ck-color-switch-button-on-hover-background)}[dir=ltr] .ck.ck-button.ck-switchbutton.ck-on .ck-button__toggle .ck-button__toggle__inner{transform:translateX(var(--ck-switch-button-translation))}[dir=rtl] .ck.ck-button.ck-switchbutton.ck-on .ck-button__toggle .ck-button__toggle__inner{transform:translateX(calc(var(--ck-switch-button-translation)*-1))}", ""]);
        var r = i;
      },
      "./node_modules/css-loader/dist/cjs.js!./node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].use[2]!./packages/ckeditor5-ui/theme/components/colorgrid/colorgrid.css": function _node_modules_cssLoader_dist_cjsJs_node_modules_postcssLoader_dist_cjsJsRuleSet1Rules1Use2_packages_ckeditor5Ui_theme_components_colorgrid_colorgridCss(e, t, s) {
        "use strict";

        s.d(t, {
          Z: function Z() {
            return r;
          }
        });
        var o = s("./node_modules/css-loader/dist/runtime/api.js"),
          i = s.n(o)()(function (e) {
            return e[1];
          });
        i.push([e.id, ".ck.ck-color-grid{display:grid}:root{--ck-color-grid-tile-size:24px;--ck-color-color-grid-check-icon:#000}.ck.ck-color-grid{grid-gap:5px;padding:8px}.ck.ck-color-grid__tile{width:var(--ck-color-grid-tile-size);height:var(--ck-color-grid-tile-size);min-width:var(--ck-color-grid-tile-size);min-height:var(--ck-color-grid-tile-size);padding:0;transition:box-shadow .2s ease;border:0}.ck.ck-color-grid__tile.ck-disabled{cursor:unset;transition:unset}.ck.ck-color-grid__tile.ck-color-table__color-tile_bordered{box-shadow:0 0 0 1px var(--ck-color-base-border)}.ck.ck-color-grid__tile .ck.ck-icon{display:none;color:var(--ck-color-color-grid-check-icon)}.ck.ck-color-grid__tile.ck-on{box-shadow:inset 0 0 0 1px var(--ck-color-base-background),0 0 0 2px var(--ck-color-base-text)}.ck.ck-color-grid__tile.ck-on .ck.ck-icon{display:block}.ck.ck-color-grid__tile.ck-on,.ck.ck-color-grid__tile:focus:not(.ck-disabled),.ck.ck-color-grid__tile:hover:not(.ck-disabled){border:0}.ck.ck-color-grid__tile:focus:not(.ck-disabled),.ck.ck-color-grid__tile:hover:not(.ck-disabled){box-shadow:inset 0 0 0 1px var(--ck-color-base-background),0 0 0 2px var(--ck-color-focus-border)}.ck.ck-color-grid__label{padding:0 var(--ck-spacing-standard)}", ""]);
        var r = i;
      },
      "./node_modules/css-loader/dist/cjs.js!./node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].use[2]!./packages/ckeditor5-ui/theme/components/dropdown/dropdown.css": function _node_modules_cssLoader_dist_cjsJs_node_modules_postcssLoader_dist_cjsJsRuleSet1Rules1Use2_packages_ckeditor5Ui_theme_components_dropdown_dropdownCss(e, t, s) {
        "use strict";

        s.d(t, {
          Z: function Z() {
            return r;
          }
        });
        var o = s("./node_modules/css-loader/dist/runtime/api.js"),
          i = s.n(o)()(function (e) {
            return e[1];
          });
        i.push([e.id, ":root{--ck-dropdown-max-width:75vw}.ck.ck-dropdown{display:inline-block;position:relative}.ck.ck-dropdown .ck-dropdown__arrow{pointer-events:none;z-index:var(--ck-z-default)}.ck.ck-dropdown .ck-button.ck-dropdown__button{width:100%}.ck.ck-dropdown .ck-button.ck-dropdown__button.ck-on .ck-tooltip{display:none}.ck.ck-dropdown .ck-dropdown__panel{-webkit-backface-visibility:hidden;display:none;z-index:var(--ck-z-modal);max-width:var(--ck-dropdown-max-width);position:absolute}.ck.ck-dropdown .ck-dropdown__panel.ck-dropdown__panel-visible{display:inline-block}.ck.ck-dropdown .ck-dropdown__panel.ck-dropdown__panel_n,.ck.ck-dropdown .ck-dropdown__panel.ck-dropdown__panel_ne,.ck.ck-dropdown .ck-dropdown__panel.ck-dropdown__panel_nme,.ck.ck-dropdown .ck-dropdown__panel.ck-dropdown__panel_nmw,.ck.ck-dropdown .ck-dropdown__panel.ck-dropdown__panel_nw{bottom:100%}.ck.ck-dropdown .ck-dropdown__panel.ck-dropdown__panel_s,.ck.ck-dropdown .ck-dropdown__panel.ck-dropdown__panel_se,.ck.ck-dropdown .ck-dropdown__panel.ck-dropdown__panel_sme,.ck.ck-dropdown .ck-dropdown__panel.ck-dropdown__panel_smw,.ck.ck-dropdown .ck-dropdown__panel.ck-dropdown__panel_sw{top:100%;bottom:auto}.ck.ck-dropdown .ck-dropdown__panel.ck-dropdown__panel_ne,.ck.ck-dropdown .ck-dropdown__panel.ck-dropdown__panel_se{left:0}.ck.ck-dropdown .ck-dropdown__panel.ck-dropdown__panel_nw,.ck.ck-dropdown .ck-dropdown__panel.ck-dropdown__panel_sw{right:0}.ck.ck-dropdown .ck-dropdown__panel.ck-dropdown__panel_n,.ck.ck-dropdown .ck-dropdown__panel.ck-dropdown__panel_s{left:50%;transform:translateX(-50%)}.ck.ck-dropdown .ck-dropdown__panel.ck-dropdown__panel_nmw,.ck.ck-dropdown .ck-dropdown__panel.ck-dropdown__panel_smw{left:75%;transform:translateX(-75%)}.ck.ck-dropdown .ck-dropdown__panel.ck-dropdown__panel_nme,.ck.ck-dropdown .ck-dropdown__panel.ck-dropdown__panel_sme{left:25%;transform:translateX(-25%)}.ck.ck-toolbar .ck-dropdown__panel{z-index:calc(var(--ck-z-modal) + 1)}:root{--ck-dropdown-arrow-size:calc(var(--ck-icon-size)*0.5)}.ck.ck-dropdown{font-size:inherit}.ck.ck-dropdown .ck-dropdown__arrow{width:var(--ck-dropdown-arrow-size)}[dir=ltr] .ck.ck-dropdown .ck-dropdown__arrow{right:var(--ck-spacing-standard);margin-left:var(--ck-spacing-standard)}[dir=rtl] .ck.ck-dropdown .ck-dropdown__arrow{left:var(--ck-spacing-standard);margin-right:var(--ck-spacing-small)}.ck.ck-dropdown.ck-disabled .ck-dropdown__arrow{opacity:var(--ck-disabled-opacity)}[dir=ltr] .ck.ck-dropdown .ck-button.ck-dropdown__button:not(.ck-button_with-text){padding-left:var(--ck-spacing-small)}[dir=rtl] .ck.ck-dropdown .ck-button.ck-dropdown__button:not(.ck-button_with-text){padding-right:var(--ck-spacing-small)}.ck.ck-dropdown .ck-button.ck-dropdown__button .ck-button__label{width:7em;overflow:hidden;text-overflow:ellipsis}.ck.ck-dropdown .ck-button.ck-dropdown__button.ck-disabled .ck-button__label{opacity:var(--ck-disabled-opacity)}.ck.ck-dropdown .ck-button.ck-dropdown__button.ck-on{border-bottom-left-radius:0;border-bottom-right-radius:0}.ck.ck-dropdown .ck-button.ck-dropdown__button.ck-dropdown__button_label-width_auto .ck-button__label{width:auto}.ck.ck-dropdown .ck-button.ck-dropdown__button.ck-off:active,.ck.ck-dropdown .ck-button.ck-dropdown__button.ck-on:active{box-shadow:none}.ck.ck-dropdown .ck-button.ck-dropdown__button.ck-off:active:focus,.ck.ck-dropdown .ck-button.ck-dropdown__button.ck-on:active:focus{box-shadow:var(--ck-focus-outer-shadow),0 0}.ck.ck-dropdown__panel{border-radius:0}.ck-rounded-corners .ck.ck-dropdown__panel,.ck.ck-dropdown__panel.ck-rounded-corners{border-radius:var(--ck-border-radius)}.ck.ck-dropdown__panel{box-shadow:var(--ck-drop-shadow),0 0;background:var(--ck-color-dropdown-panel-background);border:1px solid var(--ck-color-dropdown-panel-border);bottom:0;min-width:100%}.ck.ck-dropdown__panel.ck-dropdown__panel_se{border-top-left-radius:0}.ck.ck-dropdown__panel.ck-dropdown__panel_sw{border-top-right-radius:0}.ck.ck-dropdown__panel.ck-dropdown__panel_ne{border-bottom-left-radius:0}.ck.ck-dropdown__panel.ck-dropdown__panel_nw{border-bottom-right-radius:0}", ""]);
        var r = i;
      },
      "./node_modules/css-loader/dist/cjs.js!./node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].use[2]!./packages/ckeditor5-ui/theme/components/dropdown/listdropdown.css": function _node_modules_cssLoader_dist_cjsJs_node_modules_postcssLoader_dist_cjsJsRuleSet1Rules1Use2_packages_ckeditor5Ui_theme_components_dropdown_listdropdownCss(e, t, s) {
        "use strict";

        s.d(t, {
          Z: function Z() {
            return r;
          }
        });
        var o = s("./node_modules/css-loader/dist/runtime/api.js"),
          i = s.n(o)()(function (e) {
            return e[1];
          });
        i.push([e.id, ".ck.ck-dropdown .ck-dropdown__panel .ck-list{border-radius:0}.ck-rounded-corners .ck.ck-dropdown .ck-dropdown__panel .ck-list,.ck.ck-dropdown .ck-dropdown__panel .ck-list.ck-rounded-corners{border-radius:var(--ck-border-radius);border-top-left-radius:0}.ck.ck-dropdown .ck-dropdown__panel .ck-list .ck-list__item:first-child .ck-button{border-radius:0}.ck-rounded-corners .ck.ck-dropdown .ck-dropdown__panel .ck-list .ck-list__item:first-child .ck-button,.ck.ck-dropdown .ck-dropdown__panel .ck-list .ck-list__item:first-child .ck-button.ck-rounded-corners{border-radius:var(--ck-border-radius);border-top-left-radius:0;border-bottom-left-radius:0;border-bottom-right-radius:0}.ck.ck-dropdown .ck-dropdown__panel .ck-list .ck-list__item:last-child .ck-button{border-radius:0}.ck-rounded-corners .ck.ck-dropdown .ck-dropdown__panel .ck-list .ck-list__item:last-child .ck-button,.ck.ck-dropdown .ck-dropdown__panel .ck-list .ck-list__item:last-child .ck-button.ck-rounded-corners{border-radius:var(--ck-border-radius);border-top-left-radius:0;border-top-right-radius:0}", ""]);
        var r = i;
      },
      "./node_modules/css-loader/dist/cjs.js!./node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].use[2]!./packages/ckeditor5-ui/theme/components/dropdown/splitbutton.css": function _node_modules_cssLoader_dist_cjsJs_node_modules_postcssLoader_dist_cjsJsRuleSet1Rules1Use2_packages_ckeditor5Ui_theme_components_dropdown_splitbuttonCss(e, t, s) {
        "use strict";

        s.d(t, {
          Z: function Z() {
            return r;
          }
        });
        var o = s("./node_modules/css-loader/dist/runtime/api.js"),
          i = s.n(o)()(function (e) {
            return e[1];
          });
        i.push([e.id, '.ck.ck-splitbutton{font-size:inherit}.ck.ck-splitbutton .ck-splitbutton__action:focus{z-index:calc(var(--ck-z-default) + 1)}.ck.ck-splitbutton.ck-splitbutton_open>.ck-button .ck-tooltip{display:none}:root{--ck-color-split-button-hover-background:#ebebeb;--ck-color-split-button-hover-border:#b3b3b3}[dir=ltr] .ck.ck-splitbutton.ck-splitbutton_open>.ck-splitbutton__action,[dir=ltr] .ck.ck-splitbutton:hover>.ck-splitbutton__action{border-top-right-radius:unset;border-bottom-right-radius:unset}[dir=rtl] .ck.ck-splitbutton.ck-splitbutton_open>.ck-splitbutton__action,[dir=rtl] .ck.ck-splitbutton:hover>.ck-splitbutton__action{border-top-left-radius:unset;border-bottom-left-radius:unset}.ck.ck-splitbutton>.ck-splitbutton__arrow{min-width:unset}[dir=ltr] .ck.ck-splitbutton>.ck-splitbutton__arrow{border-top-left-radius:unset;border-bottom-left-radius:unset}[dir=rtl] .ck.ck-splitbutton>.ck-splitbutton__arrow{border-top-right-radius:unset;border-bottom-right-radius:unset}.ck.ck-splitbutton>.ck-splitbutton__arrow svg{width:var(--ck-dropdown-arrow-size)}.ck.ck-splitbutton.ck-splitbutton_open>.ck-button:not(.ck-on):not(.ck-disabled):not(:hover),.ck.ck-splitbutton:hover>.ck-button:not(.ck-on):not(.ck-disabled):not(:hover){background:var(--ck-color-split-button-hover-background)}.ck.ck-splitbutton.ck-splitbutton_open>.ck-splitbutton__arrow:not(.ck-disabled):after,.ck.ck-splitbutton:hover>.ck-splitbutton__arrow:not(.ck-disabled):after{content:"";position:absolute;width:1px;height:100%;background-color:var(--ck-color-split-button-hover-border)}[dir=ltr] .ck.ck-splitbutton.ck-splitbutton_open>.ck-splitbutton__arrow:not(.ck-disabled):after,[dir=ltr] .ck.ck-splitbutton:hover>.ck-splitbutton__arrow:not(.ck-disabled):after{left:-1px}[dir=rtl] .ck.ck-splitbutton.ck-splitbutton_open>.ck-splitbutton__arrow:not(.ck-disabled):after,[dir=rtl] .ck.ck-splitbutton:hover>.ck-splitbutton__arrow:not(.ck-disabled):after{right:-1px}.ck.ck-splitbutton.ck-splitbutton_open{border-radius:0}.ck-rounded-corners .ck.ck-splitbutton.ck-splitbutton_open,.ck.ck-splitbutton.ck-splitbutton_open.ck-rounded-corners{border-radius:var(--ck-border-radius)}.ck-rounded-corners .ck.ck-splitbutton.ck-splitbutton_open>.ck-splitbutton__action,.ck.ck-splitbutton.ck-splitbutton_open.ck-rounded-corners>.ck-splitbutton__action{border-bottom-left-radius:0}.ck-rounded-corners .ck.ck-splitbutton.ck-splitbutton_open>.ck-splitbutton__arrow,.ck.ck-splitbutton.ck-splitbutton_open.ck-rounded-corners>.ck-splitbutton__arrow{border-bottom-right-radius:0}', ""]);
        var r = i;
      },
      "./node_modules/css-loader/dist/cjs.js!./node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].use[2]!./packages/ckeditor5-ui/theme/components/dropdown/toolbardropdown.css": function _node_modules_cssLoader_dist_cjsJs_node_modules_postcssLoader_dist_cjsJsRuleSet1Rules1Use2_packages_ckeditor5Ui_theme_components_dropdown_toolbardropdownCss(e, t, s) {
        "use strict";

        s.d(t, {
          Z: function Z() {
            return r;
          }
        });
        var o = s("./node_modules/css-loader/dist/runtime/api.js"),
          i = s.n(o)()(function (e) {
            return e[1];
          });
        i.push([e.id, ":root{--ck-toolbar-dropdown-max-width:60vw}.ck.ck-toolbar-dropdown>.ck-dropdown__panel{width:max-content;max-width:var(--ck-toolbar-dropdown-max-width)}.ck.ck-toolbar-dropdown>.ck-dropdown__panel .ck-button:focus{z-index:calc(var(--ck-z-default) + 1)}.ck.ck-toolbar-dropdown .ck-toolbar{border:0}", ""]);
        var r = i;
      },
      "./node_modules/css-loader/dist/cjs.js!./node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].use[2]!./packages/ckeditor5-ui/theme/components/editorui/editorui.css": function _node_modules_cssLoader_dist_cjsJs_node_modules_postcssLoader_dist_cjsJsRuleSet1Rules1Use2_packages_ckeditor5Ui_theme_components_editorui_editoruiCss(e, t, s) {
        "use strict";

        s.d(t, {
          Z: function Z() {
            return r;
          }
        });
        var o = s("./node_modules/css-loader/dist/runtime/api.js"),
          i = s.n(o)()(function (e) {
            return e[1];
          });
        i.push([e.id, ":root{--ck-color-editable-blur-selection:#d9d9d9}.ck.ck-editor__editable:not(.ck-editor__nested-editable){border-radius:0}.ck-rounded-corners .ck.ck-editor__editable:not(.ck-editor__nested-editable),.ck.ck-editor__editable:not(.ck-editor__nested-editable).ck-rounded-corners{border-radius:var(--ck-border-radius)}.ck.ck-editor__editable:not(.ck-editor__nested-editable).ck-focused{outline:none;border:var(--ck-focus-ring);box-shadow:var(--ck-inner-shadow),0 0}.ck.ck-editor__editable_inline{overflow:auto;padding:0 var(--ck-spacing-standard);border:1px solid transparent}.ck.ck-editor__editable_inline[dir=ltr]{text-align:left}.ck.ck-editor__editable_inline[dir=rtl]{text-align:right}.ck.ck-editor__editable_inline>:first-child{margin-top:var(--ck-spacing-large)}.ck.ck-editor__editable_inline>:last-child{margin-bottom:var(--ck-spacing-large)}.ck.ck-editor__editable_inline.ck-blurred ::selection{background:var(--ck-color-editable-blur-selection)}.ck.ck-balloon-panel.ck-toolbar-container[class*=arrow_n]:after{border-bottom-color:var(--ck-color-base-foreground)}.ck.ck-balloon-panel.ck-toolbar-container[class*=arrow_s]:after{border-top-color:var(--ck-color-base-foreground)}", ""]);
        var r = i;
      },
      "./node_modules/css-loader/dist/cjs.js!./node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].use[2]!./packages/ckeditor5-ui/theme/components/formheader/formheader.css": function _node_modules_cssLoader_dist_cjsJs_node_modules_postcssLoader_dist_cjsJsRuleSet1Rules1Use2_packages_ckeditor5Ui_theme_components_formheader_formheaderCss(e, t, s) {
        "use strict";

        s.d(t, {
          Z: function Z() {
            return r;
          }
        });
        var o = s("./node_modules/css-loader/dist/runtime/api.js"),
          i = s.n(o)()(function (e) {
            return e[1];
          });
        i.push([e.id, ".ck.ck-form__header{display:flex;flex-direction:row;flex-wrap:nowrap;align-items:center;justify-content:space-between}:root{--ck-form-header-height:38px}.ck.ck-form__header{padding:var(--ck-spacing-small) var(--ck-spacing-large);height:var(--ck-form-header-height);line-height:var(--ck-form-header-height);border-bottom:1px solid var(--ck-color-base-border)}.ck.ck-form__header .ck-form__header__label{font-weight:700}", ""]);
        var r = i;
      },
      "./node_modules/css-loader/dist/cjs.js!./node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].use[2]!./packages/ckeditor5-ui/theme/components/icon/icon.css": function _node_modules_cssLoader_dist_cjsJs_node_modules_postcssLoader_dist_cjsJsRuleSet1Rules1Use2_packages_ckeditor5Ui_theme_components_icon_iconCss(e, t, s) {
        "use strict";

        s.d(t, {
          Z: function Z() {
            return r;
          }
        });
        var o = s("./node_modules/css-loader/dist/runtime/api.js"),
          i = s.n(o)()(function (e) {
            return e[1];
          });
        i.push([e.id, ".ck.ck-icon{vertical-align:middle}:root{--ck-icon-size:calc(var(--ck-line-height-base)*var(--ck-font-size-normal))}.ck.ck-icon{width:var(--ck-icon-size);height:var(--ck-icon-size);font-size:.8333350694em;will-change:transform}.ck.ck-icon,.ck.ck-icon *{color:inherit;cursor:inherit}.ck.ck-icon :not([fill]){fill:currentColor}", ""]);
        var r = i;
      },
      "./node_modules/css-loader/dist/cjs.js!./node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].use[2]!./packages/ckeditor5-ui/theme/components/input/input.css": function _node_modules_cssLoader_dist_cjsJs_node_modules_postcssLoader_dist_cjsJsRuleSet1Rules1Use2_packages_ckeditor5Ui_theme_components_input_inputCss(e, t, s) {
        "use strict";

        s.d(t, {
          Z: function Z() {
            return r;
          }
        });
        var o = s("./node_modules/css-loader/dist/runtime/api.js"),
          i = s.n(o)()(function (e) {
            return e[1];
          });
        i.push([e.id, ":root{--ck-input-width:18em;--ck-input-text-width:var(--ck-input-width)}.ck.ck-input{border-radius:0}.ck-rounded-corners .ck.ck-input,.ck.ck-input.ck-rounded-corners{border-radius:var(--ck-border-radius)}.ck.ck-input{background:var(--ck-color-input-background);border:1px solid var(--ck-color-input-border);padding:var(--ck-spacing-extra-tiny) var(--ck-spacing-medium);min-width:var(--ck-input-width);min-height:var(--ck-ui-component-min-height);transition:box-shadow .1s ease-in-out,border .1s ease-in-out}.ck.ck-input:focus{outline:none;border:var(--ck-focus-ring);box-shadow:var(--ck-focus-outer-shadow),0 0}.ck.ck-input[readonly]{border:1px solid var(--ck-color-input-disabled-border);background:var(--ck-color-input-disabled-background);color:var(--ck-color-input-disabled-text)}.ck.ck-input[readonly]:focus{box-shadow:var(--ck-focus-disabled-outer-shadow),0 0}.ck.ck-input.ck-error{border-color:var(--ck-color-input-error-border);animation:ck-input-shake .3s ease both}.ck.ck-input.ck-error:focus{box-shadow:var(--ck-focus-error-outer-shadow),0 0}@keyframes ck-input-shake{20%{transform:translateX(-2px)}40%{transform:translateX(2px)}60%{transform:translateX(-1px)}80%{transform:translateX(1px)}}", ""]);
        var r = i;
      },
      "./node_modules/css-loader/dist/cjs.js!./node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].use[2]!./packages/ckeditor5-ui/theme/components/label/label.css": function _node_modules_cssLoader_dist_cjsJs_node_modules_postcssLoader_dist_cjsJsRuleSet1Rules1Use2_packages_ckeditor5Ui_theme_components_label_labelCss(e, t, s) {
        "use strict";

        s.d(t, {
          Z: function Z() {
            return r;
          }
        });
        var o = s("./node_modules/css-loader/dist/runtime/api.js"),
          i = s.n(o)()(function (e) {
            return e[1];
          });
        i.push([e.id, ".ck.ck-label{display:block}.ck.ck-voice-label{display:none}.ck.ck-label{font-weight:700}", ""]);
        var r = i;
      },
      "./node_modules/css-loader/dist/cjs.js!./node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].use[2]!./packages/ckeditor5-ui/theme/components/labeledfield/labeledfieldview.css": function _node_modules_cssLoader_dist_cjsJs_node_modules_postcssLoader_dist_cjsJsRuleSet1Rules1Use2_packages_ckeditor5Ui_theme_components_labeledfield_labeledfieldviewCss(e, t, s) {
        "use strict";

        s.d(t, {
          Z: function Z() {
            return r;
          }
        });
        var o = s("./node_modules/css-loader/dist/runtime/api.js"),
          i = s.n(o)()(function (e) {
            return e[1];
          });
        i.push([e.id, ".ck.ck-labeled-field-view>.ck.ck-labeled-field-view__input-wrapper{display:flex;position:relative}.ck.ck-labeled-field-view .ck.ck-label{display:block;position:absolute}:root{--ck-labeled-field-view-transition:.1s cubic-bezier(0,0,0.24,0.95);--ck-labeled-field-empty-unfocused-max-width:100% - 2 * var(--ck-spacing-medium);--ck-color-labeled-field-label-background:var(--ck-color-base-background)}.ck.ck-labeled-field-view{border-radius:0}.ck-rounded-corners .ck.ck-labeled-field-view,.ck.ck-labeled-field-view.ck-rounded-corners{border-radius:var(--ck-border-radius)}.ck.ck-labeled-field-view>.ck.ck-labeled-field-view__input-wrapper{width:100%}.ck.ck-labeled-field-view>.ck.ck-labeled-field-view__input-wrapper>.ck.ck-label{top:0}[dir=ltr] .ck.ck-labeled-field-view>.ck.ck-labeled-field-view__input-wrapper>.ck.ck-label{left:0}[dir=rtl] .ck.ck-labeled-field-view>.ck.ck-labeled-field-view__input-wrapper>.ck.ck-label{right:0}.ck.ck-labeled-field-view>.ck.ck-labeled-field-view__input-wrapper>.ck.ck-label{pointer-events:none;transform-origin:0 0;transform:translate(var(--ck-spacing-medium),-6px) scale(.75);background:var(--ck-color-labeled-field-label-background);padding:0 calc(var(--ck-font-size-tiny)*0.5);line-height:normal;font-weight:400;text-overflow:ellipsis;overflow:hidden;max-width:100%;transition:transform var(--ck-labeled-field-view-transition),padding var(--ck-labeled-field-view-transition),background var(--ck-labeled-field-view-transition)}.ck.ck-labeled-field-view.ck-error .ck-input:not([readonly])+.ck.ck-label,.ck.ck-labeled-field-view.ck-error>.ck.ck-labeled-field-view__input-wrapper>.ck.ck-label{color:var(--ck-color-base-error)}.ck.ck-labeled-field-view .ck-labeled-field-view__status{font-size:var(--ck-font-size-small);margin-top:var(--ck-spacing-small);white-space:normal}.ck.ck-labeled-field-view .ck-labeled-field-view__status.ck-labeled-field-view__status_error{color:var(--ck-color-base-error)}.ck.ck-labeled-field-view.ck-disabled>.ck.ck-labeled-field-view__input-wrapper>.ck.ck-label,.ck.ck-labeled-field-view.ck-labeled-field-view_empty:not(.ck-labeled-field-view_focused)>.ck.ck-labeled-field-view__input-wrapper>.ck.ck-label{color:var(--ck-color-input-disabled-text)}[dir=ltr] .ck.ck-labeled-field-view.ck-disabled.ck-labeled-field-view_empty>.ck.ck-labeled-field-view__input-wrapper>.ck.ck-label,[dir=ltr] .ck.ck-labeled-field-view.ck-labeled-field-view_empty:not(.ck-labeled-field-view_focused):not(.ck-labeled-field-view_placeholder)>.ck.ck-labeled-field-view__input-wrapper>.ck.ck-label{transform:translate(var(--ck-spacing-medium),calc(var(--ck-font-size-base)*0.6)) scale(1)}[dir=rtl] .ck.ck-labeled-field-view.ck-disabled.ck-labeled-field-view_empty>.ck.ck-labeled-field-view__input-wrapper>.ck.ck-label,[dir=rtl] .ck.ck-labeled-field-view.ck-labeled-field-view_empty:not(.ck-labeled-field-view_focused):not(.ck-labeled-field-view_placeholder)>.ck.ck-labeled-field-view__input-wrapper>.ck.ck-label{transform:translate(calc(var(--ck-spacing-medium)*-1),calc(var(--ck-font-size-base)*0.6)) scale(1)}.ck.ck-labeled-field-view.ck-disabled.ck-labeled-field-view_empty>.ck.ck-labeled-field-view__input-wrapper>.ck.ck-label,.ck.ck-labeled-field-view.ck-labeled-field-view_empty:not(.ck-labeled-field-view_focused):not(.ck-labeled-field-view_placeholder)>.ck.ck-labeled-field-view__input-wrapper>.ck.ck-label{max-width:calc(var(--ck-labeled-field-empty-unfocused-max-width));background:transparent;padding:0}.ck.ck-labeled-field-view>.ck.ck-labeled-field-view__input-wrapper>.ck-dropdown>.ck.ck-button{background:transparent}.ck.ck-labeled-field-view.ck-labeled-field-view_empty>.ck.ck-labeled-field-view__input-wrapper>.ck-dropdown>.ck-button>.ck-button__label{opacity:0}.ck.ck-labeled-field-view.ck-labeled-field-view_empty:not(.ck-labeled-field-view_focused):not(.ck-labeled-field-view_placeholder)>.ck.ck-labeled-field-view__input-wrapper>.ck-dropdown+.ck-label{max-width:calc(var(--ck-labeled-field-empty-unfocused-max-width) - var(--ck-dropdown-arrow-size) - var(--ck-spacing-standard))}", ""]);
        var r = i;
      },
      "./node_modules/css-loader/dist/cjs.js!./node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].use[2]!./packages/ckeditor5-ui/theme/components/list/list.css": function _node_modules_cssLoader_dist_cjsJs_node_modules_postcssLoader_dist_cjsJsRuleSet1Rules1Use2_packages_ckeditor5Ui_theme_components_list_listCss(e, t, s) {
        "use strict";

        s.d(t, {
          Z: function Z() {
            return r;
          }
        });
        var o = s("./node_modules/css-loader/dist/runtime/api.js"),
          i = s.n(o)()(function (e) {
            return e[1];
          });
        i.push([e.id, ".ck.ck-list{-moz-user-select:none;-webkit-user-select:none;-ms-user-select:none;user-select:none;display:flex;flex-direction:column}.ck.ck-list .ck-list__item,.ck.ck-list .ck-list__separator{display:block}.ck.ck-list .ck-list__item>:focus{position:relative;z-index:var(--ck-z-default)}.ck.ck-list{border-radius:0}.ck-rounded-corners .ck.ck-list,.ck.ck-list.ck-rounded-corners{border-radius:var(--ck-border-radius)}.ck.ck-list{list-style-type:none;background:var(--ck-color-list-background)}.ck.ck-list__item{cursor:default;min-width:12em}.ck.ck-list__item .ck-button{min-height:unset;width:100%;text-align:left;border-radius:0;padding:calc(var(--ck-line-height-base)*0.2*var(--ck-font-size-base)) calc(var(--ck-line-height-base)*0.4*var(--ck-font-size-base))}.ck.ck-list__item .ck-button .ck-button__label{line-height:calc(var(--ck-line-height-base)*1.2*var(--ck-font-size-base))}.ck.ck-list__item .ck-button:active{box-shadow:none}.ck.ck-list__item .ck-button.ck-on{background:var(--ck-color-list-button-on-background);color:var(--ck-color-list-button-on-text)}.ck.ck-list__item .ck-button.ck-on:active{box-shadow:none}.ck.ck-list__item .ck-button.ck-on:hover:not(.ck-disabled){background:var(--ck-color-list-button-on-background-focus)}.ck.ck-list__item .ck-button.ck-on:focus:not(.ck-disabled){border-color:var(--ck-color-base-background)}.ck.ck-list__item .ck-button:hover:not(.ck-disabled){background:var(--ck-color-list-button-hover-background)}.ck.ck-list__item .ck-switchbutton.ck-on{background:var(--ck-color-list-background);color:inherit}.ck.ck-list__item .ck-switchbutton.ck-on:hover:not(.ck-disabled){background:var(--ck-color-list-button-hover-background);color:inherit}.ck.ck-list__separator{height:1px;width:100%;background:var(--ck-color-base-border)}", ""]);
        var r = i;
      },
      "./node_modules/css-loader/dist/cjs.js!./node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].use[2]!./packages/ckeditor5-ui/theme/components/panel/balloonpanel.css": function _node_modules_cssLoader_dist_cjsJs_node_modules_postcssLoader_dist_cjsJsRuleSet1Rules1Use2_packages_ckeditor5Ui_theme_components_panel_balloonpanelCss(e, t, s) {
        "use strict";

        s.d(t, {
          Z: function Z() {
            return r;
          }
        });
        var o = s("./node_modules/css-loader/dist/runtime/api.js"),
          i = s.n(o)()(function (e) {
            return e[1];
          });
        i.push([e.id, ':root{--ck-balloon-panel-arrow-z-index:calc(var(--ck-z-default) - 3)}.ck.ck-balloon-panel{display:none;position:absolute;z-index:var(--ck-z-modal)}.ck.ck-balloon-panel.ck-balloon-panel_with-arrow:after,.ck.ck-balloon-panel.ck-balloon-panel_with-arrow:before{content:"";position:absolute}.ck.ck-balloon-panel.ck-balloon-panel_with-arrow:before{z-index:var(--ck-balloon-panel-arrow-z-index)}.ck.ck-balloon-panel.ck-balloon-panel_with-arrow:after{z-index:calc(var(--ck-balloon-panel-arrow-z-index) + 1)}.ck.ck-balloon-panel[class*=arrow_n]:before{z-index:var(--ck-balloon-panel-arrow-z-index)}.ck.ck-balloon-panel[class*=arrow_n]:after{z-index:calc(var(--ck-balloon-panel-arrow-z-index) + 1)}.ck.ck-balloon-panel[class*=arrow_s]:before{z-index:var(--ck-balloon-panel-arrow-z-index)}.ck.ck-balloon-panel[class*=arrow_s]:after{z-index:calc(var(--ck-balloon-panel-arrow-z-index) + 1)}.ck.ck-balloon-panel.ck-balloon-panel_visible{display:block}:root{--ck-balloon-arrow-offset:2px;--ck-balloon-arrow-height:10px;--ck-balloon-arrow-half-width:8px;--ck-balloon-arrow-drop-shadow:0 2px 2px var(--ck-color-shadow-drop)}.ck.ck-balloon-panel{border-radius:0}.ck-rounded-corners .ck.ck-balloon-panel,.ck.ck-balloon-panel.ck-rounded-corners{border-radius:var(--ck-border-radius)}.ck.ck-balloon-panel{box-shadow:var(--ck-drop-shadow),0 0;min-height:15px;background:var(--ck-color-panel-background);border:1px solid var(--ck-color-panel-border)}.ck.ck-balloon-panel.ck-balloon-panel_with-arrow:after,.ck.ck-balloon-panel.ck-balloon-panel_with-arrow:before{width:0;height:0;border-style:solid}.ck.ck-balloon-panel[class*=arrow_n]:after,.ck.ck-balloon-panel[class*=arrow_n]:before{border-left-width:var(--ck-balloon-arrow-half-width);border-bottom-width:var(--ck-balloon-arrow-height);border-right-width:var(--ck-balloon-arrow-half-width);border-top-width:0}.ck.ck-balloon-panel[class*=arrow_n]:before{border-bottom-color:var(--ck-color-panel-border)}.ck.ck-balloon-panel[class*=arrow_n]:after,.ck.ck-balloon-panel[class*=arrow_n]:before{border-left-color:transparent;border-right-color:transparent;border-top-color:transparent}.ck.ck-balloon-panel[class*=arrow_n]:after{border-bottom-color:var(--ck-color-panel-background);margin-top:var(--ck-balloon-arrow-offset)}.ck.ck-balloon-panel[class*=arrow_s]:after,.ck.ck-balloon-panel[class*=arrow_s]:before{border-left-width:var(--ck-balloon-arrow-half-width);border-bottom-width:0;border-right-width:var(--ck-balloon-arrow-half-width);border-top-width:var(--ck-balloon-arrow-height)}.ck.ck-balloon-panel[class*=arrow_s]:before{border-top-color:var(--ck-color-panel-border);filter:drop-shadow(var(--ck-balloon-arrow-drop-shadow))}.ck.ck-balloon-panel[class*=arrow_s]:after,.ck.ck-balloon-panel[class*=arrow_s]:before{border-left-color:transparent;border-bottom-color:transparent;border-right-color:transparent}.ck.ck-balloon-panel[class*=arrow_s]:after{border-top-color:var(--ck-color-panel-background);margin-bottom:var(--ck-balloon-arrow-offset)}.ck.ck-balloon-panel.ck-balloon-panel_arrow_n:after,.ck.ck-balloon-panel.ck-balloon-panel_arrow_n:before{left:50%;margin-left:calc(var(--ck-balloon-arrow-half-width)*-1);top:calc(var(--ck-balloon-arrow-height)*-1)}.ck.ck-balloon-panel.ck-balloon-panel_arrow_nw:after,.ck.ck-balloon-panel.ck-balloon-panel_arrow_nw:before{left:calc(var(--ck-balloon-arrow-half-width)*2);top:calc(var(--ck-balloon-arrow-height)*-1)}.ck.ck-balloon-panel.ck-balloon-panel_arrow_ne:after,.ck.ck-balloon-panel.ck-balloon-panel_arrow_ne:before{right:calc(var(--ck-balloon-arrow-half-width)*2);top:calc(var(--ck-balloon-arrow-height)*-1)}.ck.ck-balloon-panel.ck-balloon-panel_arrow_s:after,.ck.ck-balloon-panel.ck-balloon-panel_arrow_s:before{left:50%;margin-left:calc(var(--ck-balloon-arrow-half-width)*-1);bottom:calc(var(--ck-balloon-arrow-height)*-1)}.ck.ck-balloon-panel.ck-balloon-panel_arrow_sw:after,.ck.ck-balloon-panel.ck-balloon-panel_arrow_sw:before{left:calc(var(--ck-balloon-arrow-half-width)*2);bottom:calc(var(--ck-balloon-arrow-height)*-1)}.ck.ck-balloon-panel.ck-balloon-panel_arrow_se:after,.ck.ck-balloon-panel.ck-balloon-panel_arrow_se:before{right:calc(var(--ck-balloon-arrow-half-width)*2);bottom:calc(var(--ck-balloon-arrow-height)*-1)}.ck.ck-balloon-panel.ck-balloon-panel_arrow_sme:after,.ck.ck-balloon-panel.ck-balloon-panel_arrow_sme:before{right:25%;margin-right:calc(var(--ck-balloon-arrow-half-width)*2);bottom:calc(var(--ck-balloon-arrow-height)*-1)}.ck.ck-balloon-panel.ck-balloon-panel_arrow_smw:after,.ck.ck-balloon-panel.ck-balloon-panel_arrow_smw:before{left:25%;margin-left:calc(var(--ck-balloon-arrow-half-width)*2);bottom:calc(var(--ck-balloon-arrow-height)*-1)}.ck.ck-balloon-panel.ck-balloon-panel_arrow_nme:after,.ck.ck-balloon-panel.ck-balloon-panel_arrow_nme:before{right:25%;margin-right:calc(var(--ck-balloon-arrow-half-width)*2);top:calc(var(--ck-balloon-arrow-height)*-1)}.ck.ck-balloon-panel.ck-balloon-panel_arrow_nmw:after,.ck.ck-balloon-panel.ck-balloon-panel_arrow_nmw:before{left:25%;margin-left:calc(var(--ck-balloon-arrow-half-width)*2);top:calc(var(--ck-balloon-arrow-height)*-1)}', ""]);
        var r = i;
      },
      "./node_modules/css-loader/dist/cjs.js!./node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].use[2]!./packages/ckeditor5-ui/theme/components/panel/balloonrotator.css": function _node_modules_cssLoader_dist_cjsJs_node_modules_postcssLoader_dist_cjsJsRuleSet1Rules1Use2_packages_ckeditor5Ui_theme_components_panel_balloonrotatorCss(e, t, s) {
        "use strict";

        s.d(t, {
          Z: function Z() {
            return r;
          }
        });
        var o = s("./node_modules/css-loader/dist/runtime/api.js"),
          i = s.n(o)()(function (e) {
            return e[1];
          });
        i.push([e.id, ".ck .ck-balloon-rotator__navigation{display:flex;align-items:center;justify-content:center}.ck .ck-balloon-rotator__content .ck-toolbar{justify-content:center}.ck .ck-balloon-rotator__navigation{background:var(--ck-color-toolbar-background);border-bottom:1px solid var(--ck-color-toolbar-border);padding:0 var(--ck-spacing-small)}.ck .ck-balloon-rotator__navigation>*{margin-right:var(--ck-spacing-small);margin-top:var(--ck-spacing-small);margin-bottom:var(--ck-spacing-small)}.ck .ck-balloon-rotator__navigation .ck-balloon-rotator__counter{margin-right:var(--ck-spacing-standard);margin-left:var(--ck-spacing-small)}.ck .ck-balloon-rotator__content .ck.ck-annotation-wrapper{box-shadow:none}", ""]);
        var r = i;
      },
      "./node_modules/css-loader/dist/cjs.js!./node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].use[2]!./packages/ckeditor5-ui/theme/components/panel/fakepanel.css": function _node_modules_cssLoader_dist_cjsJs_node_modules_postcssLoader_dist_cjsJsRuleSet1Rules1Use2_packages_ckeditor5Ui_theme_components_panel_fakepanelCss(e, t, s) {
        "use strict";

        s.d(t, {
          Z: function Z() {
            return r;
          }
        });
        var o = s("./node_modules/css-loader/dist/runtime/api.js"),
          i = s.n(o)()(function (e) {
            return e[1];
          });
        i.push([e.id, ".ck .ck-fake-panel{position:absolute;z-index:calc(var(--ck-z-modal) - 1)}.ck .ck-fake-panel div{position:absolute}.ck .ck-fake-panel div:first-child{z-index:2}.ck .ck-fake-panel div:nth-child(2){z-index:1}:root{--ck-balloon-fake-panel-offset-horizontal:6px;--ck-balloon-fake-panel-offset-vertical:6px}.ck .ck-fake-panel div{box-shadow:var(--ck-drop-shadow),0 0;min-height:15px;background:var(--ck-color-panel-background);border:1px solid var(--ck-color-panel-border);border-radius:var(--ck-border-radius);width:100%;height:100%}.ck .ck-fake-panel div:first-child{margin-left:var(--ck-balloon-fake-panel-offset-horizontal);margin-top:var(--ck-balloon-fake-panel-offset-vertical)}.ck .ck-fake-panel div:nth-child(2){margin-left:calc(var(--ck-balloon-fake-panel-offset-horizontal)*2);margin-top:calc(var(--ck-balloon-fake-panel-offset-vertical)*2)}.ck .ck-fake-panel div:nth-child(3){margin-left:calc(var(--ck-balloon-fake-panel-offset-horizontal)*3);margin-top:calc(var(--ck-balloon-fake-panel-offset-vertical)*3)}.ck .ck-balloon-panel_arrow_s+.ck-fake-panel,.ck .ck-balloon-panel_arrow_se+.ck-fake-panel,.ck .ck-balloon-panel_arrow_sw+.ck-fake-panel{--ck-balloon-fake-panel-offset-vertical:-6px}", ""]);
        var r = i;
      },
      "./node_modules/css-loader/dist/cjs.js!./node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].use[2]!./packages/ckeditor5-ui/theme/components/panel/stickypanel.css": function _node_modules_cssLoader_dist_cjsJs_node_modules_postcssLoader_dist_cjsJsRuleSet1Rules1Use2_packages_ckeditor5Ui_theme_components_panel_stickypanelCss(e, t, s) {
        "use strict";

        s.d(t, {
          Z: function Z() {
            return r;
          }
        });
        var o = s("./node_modules/css-loader/dist/runtime/api.js"),
          i = s.n(o)()(function (e) {
            return e[1];
          });
        i.push([e.id, ".ck.ck-sticky-panel .ck-sticky-panel__content_sticky{z-index:var(--ck-z-modal);position:fixed;top:0}.ck.ck-sticky-panel .ck-sticky-panel__content_sticky_bottom-limit{top:auto;position:absolute}.ck.ck-sticky-panel .ck-sticky-panel__content_sticky{box-shadow:var(--ck-drop-shadow),0 0;border-width:0 1px 1px;border-top-left-radius:0;border-top-right-radius:0}", ""]);
        var r = i;
      },
      "./node_modules/css-loader/dist/cjs.js!./node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].use[2]!./packages/ckeditor5-ui/theme/components/toolbar/blocktoolbar.css": function _node_modules_cssLoader_dist_cjsJs_node_modules_postcssLoader_dist_cjsJsRuleSet1Rules1Use2_packages_ckeditor5Ui_theme_components_toolbar_blocktoolbarCss(e, t, s) {
        "use strict";

        s.d(t, {
          Z: function Z() {
            return r;
          }
        });
        var o = s("./node_modules/css-loader/dist/runtime/api.js"),
          i = s.n(o)()(function (e) {
            return e[1];
          });
        i.push([e.id, ".ck.ck-block-toolbar-button{position:absolute;z-index:var(--ck-z-default)}:root{--ck-color-block-toolbar-button:var(--ck-color-text);--ck-block-toolbar-button-size:var(--ck-font-size-normal)}.ck.ck-block-toolbar-button{color:var(--ck-color-block-toolbar-button);font-size:var(--ck-block-toolbar-size)}", ""]);
        var r = i;
      },
      "./node_modules/css-loader/dist/cjs.js!./node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].use[2]!./packages/ckeditor5-ui/theme/components/toolbar/toolbar.css": function _node_modules_cssLoader_dist_cjsJs_node_modules_postcssLoader_dist_cjsJsRuleSet1Rules1Use2_packages_ckeditor5Ui_theme_components_toolbar_toolbarCss(e, t, s) {
        "use strict";

        s.d(t, {
          Z: function Z() {
            return r;
          }
        });
        var o = s("./node_modules/css-loader/dist/runtime/api.js"),
          i = s.n(o)()(function (e) {
            return e[1];
          });
        i.push([e.id, ".ck.ck-toolbar{-moz-user-select:none;-webkit-user-select:none;-ms-user-select:none;user-select:none;display:flex;flex-flow:row nowrap;align-items:center}.ck.ck-toolbar>.ck-toolbar__items{display:flex;flex-flow:row wrap;align-items:center;flex-grow:1}.ck.ck-toolbar .ck.ck-toolbar__separator{display:inline-block}.ck.ck-toolbar .ck.ck-toolbar__separator:first-child,.ck.ck-toolbar .ck.ck-toolbar__separator:last-child{display:none}.ck.ck-toolbar .ck-toolbar__line-break{flex-basis:100%}.ck.ck-toolbar.ck-toolbar_grouping>.ck-toolbar__items{flex-wrap:nowrap}.ck.ck-toolbar.ck-toolbar_vertical>.ck-toolbar__items{flex-direction:column}.ck.ck-toolbar.ck-toolbar_floating>.ck-toolbar__items{flex-wrap:nowrap}.ck.ck-toolbar>.ck.ck-toolbar__grouped-dropdown>.ck-dropdown__button .ck-dropdown__arrow{display:none}.ck.ck-toolbar{border-radius:0}.ck-rounded-corners .ck.ck-toolbar,.ck.ck-toolbar.ck-rounded-corners{border-radius:var(--ck-border-radius)}.ck.ck-toolbar{background:var(--ck-color-toolbar-background);padding:0 var(--ck-spacing-small);border:1px solid var(--ck-color-toolbar-border)}.ck.ck-toolbar .ck.ck-toolbar__separator{align-self:stretch;width:1px;min-width:1px;background:var(--ck-color-toolbar-border);margin-top:var(--ck-spacing-small);margin-bottom:var(--ck-spacing-small)}.ck.ck-toolbar .ck-toolbar__line-break{height:0}.ck.ck-toolbar>.ck-toolbar__items>:not(.ck-toolbar__line-break){margin-right:var(--ck-spacing-small)}.ck.ck-toolbar>.ck-toolbar__items:empty+.ck.ck-toolbar__separator{display:none}.ck.ck-toolbar>.ck-toolbar__items>:not(.ck-toolbar__line-break),.ck.ck-toolbar>.ck.ck-toolbar__grouped-dropdown{margin-top:var(--ck-spacing-small);margin-bottom:var(--ck-spacing-small)}.ck.ck-toolbar.ck-toolbar_vertical{padding:0}.ck.ck-toolbar.ck-toolbar_vertical>.ck-toolbar__items>.ck{width:100%;margin:0;border-radius:0;border:0}.ck.ck-toolbar.ck-toolbar_compact{padding:0}.ck.ck-toolbar.ck-toolbar_compact>.ck-toolbar__items>*{margin:0}.ck.ck-toolbar.ck-toolbar_compact>.ck-toolbar__items>:not(:first-child):not(:last-child){border-radius:0}.ck.ck-toolbar>.ck.ck-toolbar__grouped-dropdown>.ck.ck-button.ck-dropdown__button{padding-left:var(--ck-spacing-tiny)}.ck-toolbar-container .ck.ck-toolbar{border:0}.ck.ck-toolbar[dir=rtl]>.ck-toolbar__items>.ck,[dir=rtl] .ck.ck-toolbar>.ck-toolbar__items>.ck{margin-right:0}.ck.ck-toolbar[dir=rtl]:not(.ck-toolbar_compact)>.ck-toolbar__items>.ck,[dir=rtl] .ck.ck-toolbar:not(.ck-toolbar_compact)>.ck-toolbar__items>.ck{margin-left:var(--ck-spacing-small)}.ck.ck-toolbar[dir=rtl]>.ck-toolbar__items>.ck:last-child,[dir=rtl] .ck.ck-toolbar>.ck-toolbar__items>.ck:last-child{margin-left:0}.ck.ck-toolbar[dir=rtl].ck-toolbar_compact>.ck-toolbar__items>.ck:first-child,[dir=rtl] .ck.ck-toolbar.ck-toolbar_compact>.ck-toolbar__items>.ck:first-child{border-top-left-radius:0;border-bottom-left-radius:0}.ck.ck-toolbar[dir=rtl].ck-toolbar_compact>.ck-toolbar__items>.ck:last-child,[dir=rtl] .ck.ck-toolbar.ck-toolbar_compact>.ck-toolbar__items>.ck:last-child{border-top-right-radius:0;border-bottom-right-radius:0}.ck.ck-toolbar[dir=rtl]>.ck.ck-toolbar__separator,[dir=rtl] .ck.ck-toolbar>.ck.ck-toolbar__separator{margin-left:var(--ck-spacing-small)}.ck.ck-toolbar[dir=rtl].ck-toolbar_grouping>.ck-toolbar__items:not(:empty):not(:only-child),[dir=rtl] .ck.ck-toolbar.ck-toolbar_grouping>.ck-toolbar__items:not(:empty):not(:only-child){margin-left:var(--ck-spacing-small)}.ck.ck-toolbar[dir=ltr]>.ck-toolbar__items>.ck:last-child,[dir=ltr] .ck.ck-toolbar>.ck-toolbar__items>.ck:last-child{margin-right:0}.ck.ck-toolbar[dir=ltr].ck-toolbar_compact>.ck-toolbar__items>.ck:first-child,[dir=ltr] .ck.ck-toolbar.ck-toolbar_compact>.ck-toolbar__items>.ck:first-child{border-top-right-radius:0;border-bottom-right-radius:0}.ck.ck-toolbar[dir=ltr].ck-toolbar_compact>.ck-toolbar__items>.ck:last-child,[dir=ltr] .ck.ck-toolbar.ck-toolbar_compact>.ck-toolbar__items>.ck:last-child{border-top-left-radius:0;border-bottom-left-radius:0}.ck.ck-toolbar[dir=ltr]>.ck.ck-toolbar__separator,[dir=ltr] .ck.ck-toolbar>.ck.ck-toolbar__separator{margin-right:var(--ck-spacing-small)}.ck.ck-toolbar[dir=ltr].ck-toolbar_grouping>.ck-toolbar__items:not(:empty):not(:only-child),[dir=ltr] .ck.ck-toolbar.ck-toolbar_grouping>.ck-toolbar__items:not(:empty):not(:only-child){margin-right:var(--ck-spacing-small)}", ""]);
        var r = i;
      },
      "./node_modules/css-loader/dist/cjs.js!./node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].use[2]!./packages/ckeditor5-ui/theme/components/tooltip/tooltip.css": function _node_modules_cssLoader_dist_cjsJs_node_modules_postcssLoader_dist_cjsJsRuleSet1Rules1Use2_packages_ckeditor5Ui_theme_components_tooltip_tooltipCss(e, t, s) {
        "use strict";

        s.d(t, {
          Z: function Z() {
            return r;
          }
        });
        var o = s("./node_modules/css-loader/dist/runtime/api.js"),
          i = s.n(o)()(function (e) {
            return e[1];
          });
        i.push([e.id, '.ck.ck-tooltip,.ck.ck-tooltip .ck-tooltip__text:after{position:absolute;pointer-events:none;-webkit-backface-visibility:hidden}.ck.ck-tooltip{visibility:hidden;opacity:0;display:none;z-index:var(--ck-z-modal)}.ck.ck-tooltip .ck-tooltip__text{display:inline-block}.ck.ck-tooltip .ck-tooltip__text:after{content:"";width:0;height:0}:root{--ck-tooltip-arrow-size:5px}.ck.ck-tooltip{left:50%;top:0;transition:opacity .2s ease-in-out .2s}.ck.ck-tooltip .ck-tooltip__text{border-radius:0}.ck-rounded-corners .ck.ck-tooltip .ck-tooltip__text,.ck.ck-tooltip .ck-tooltip__text.ck-rounded-corners{border-radius:var(--ck-border-radius)}.ck.ck-tooltip .ck-tooltip__text{font-size:.9em;line-height:1.5;color:var(--ck-color-tooltip-text);padding:var(--ck-spacing-small) var(--ck-spacing-medium);background:var(--ck-color-tooltip-background);position:relative;left:-50%}.ck.ck-tooltip .ck-tooltip__text:after{transition:opacity .2s ease-in-out .2s;border-style:solid;left:50%}.ck.ck-tooltip.ck-tooltip_s,.ck.ck-tooltip.ck-tooltip_se,.ck.ck-tooltip.ck-tooltip_sw{bottom:calc(var(--ck-tooltip-arrow-size)*-1);transform:translateY(100%)}.ck.ck-tooltip.ck-tooltip_s .ck-tooltip__text:after,.ck.ck-tooltip.ck-tooltip_se .ck-tooltip__text:after,.ck.ck-tooltip.ck-tooltip_sw .ck-tooltip__text:after{top:calc(var(--ck-tooltip-arrow-size)*-1 + 1px);transform:translateX(-50%);border-left-color:transparent;border-bottom-color:var(--ck-color-tooltip-background);border-right-color:transparent;border-top-color:transparent;border-left-width:var(--ck-tooltip-arrow-size);border-bottom-width:var(--ck-tooltip-arrow-size);border-right-width:var(--ck-tooltip-arrow-size);border-top-width:0}.ck.ck-tooltip.ck-tooltip_sw{right:50%;left:auto}.ck.ck-tooltip.ck-tooltip_sw .ck-tooltip__text{left:auto;right:calc(var(--ck-tooltip-arrow-size)*-2)}.ck.ck-tooltip.ck-tooltip_sw .ck-tooltip__text:after{left:auto;right:0}.ck.ck-tooltip.ck-tooltip_se{left:50%;right:auto}.ck.ck-tooltip.ck-tooltip_se .ck-tooltip__text{right:auto;left:calc(var(--ck-tooltip-arrow-size)*-2)}.ck.ck-tooltip.ck-tooltip_se .ck-tooltip__text:after{right:auto;left:0;transform:translateX(50%)}.ck.ck-tooltip.ck-tooltip_n{top:calc(var(--ck-tooltip-arrow-size)*-1);transform:translateY(-100%)}.ck.ck-tooltip.ck-tooltip_n .ck-tooltip__text:after{bottom:calc(var(--ck-tooltip-arrow-size)*-1);transform:translateX(-50%);border-left-color:transparent;border-bottom-color:transparent;border-right-color:transparent;border-top-color:var(--ck-color-tooltip-background);border-left-width:var(--ck-tooltip-arrow-size);border-bottom-width:0;border-right-width:var(--ck-tooltip-arrow-size);border-top-width:var(--ck-tooltip-arrow-size)}.ck.ck-tooltip.ck-tooltip_e{left:calc(100% + var(--ck-tooltip-arrow-size));top:50%}.ck.ck-tooltip.ck-tooltip_e .ck-tooltip__text{left:0;transform:translateY(-50%)}.ck.ck-tooltip.ck-tooltip_e .ck-tooltip__text:after{left:calc(var(--ck-tooltip-arrow-size)*-1);top:calc(50% - var(--ck-tooltip-arrow-size)*1);border-left-color:transparent;border-bottom-color:transparent;border-right-color:var(--ck-color-tooltip-background);border-top-color:transparent;border-left-width:0;border-bottom-width:var(--ck-tooltip-arrow-size);border-right-width:var(--ck-tooltip-arrow-size);border-top-width:var(--ck-tooltip-arrow-size)}.ck.ck-tooltip.ck-tooltip_w{right:calc(100% + var(--ck-tooltip-arrow-size));left:auto;top:50%}.ck.ck-tooltip.ck-tooltip_w .ck-tooltip__text{left:0;transform:translateY(-50%)}.ck.ck-tooltip.ck-tooltip_w .ck-tooltip__text:after{left:100%;top:calc(50% - var(--ck-tooltip-arrow-size)*1);border-left-color:var(--ck-color-tooltip-background);border-bottom-color:transparent;border-right-color:transparent;border-top-color:transparent;border-left-width:var(--ck-tooltip-arrow-size);border-bottom-width:var(--ck-tooltip-arrow-size);border-right-width:0;border-top-width:var(--ck-tooltip-arrow-size)}', ""]);
        var r = i;
      },
      "./node_modules/css-loader/dist/cjs.js!./node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].use[2]!./packages/ckeditor5-ui/theme/globals/globals.css": function _node_modules_cssLoader_dist_cjsJs_node_modules_postcssLoader_dist_cjsJsRuleSet1Rules1Use2_packages_ckeditor5Ui_theme_globals_globalsCss(e, t, s) {
        "use strict";

        s.d(t, {
          Z: function Z() {
            return r;
          }
        });
        var o = s("./node_modules/css-loader/dist/runtime/api.js"),
          i = s.n(o)()(function (e) {
            return e[1];
          });
        i.push([e.id, ".ck-hidden{display:none!important}.ck.ck-reset,.ck.ck-reset_all,.ck.ck-reset_all *{box-sizing:border-box;width:auto;height:auto;position:static}:root{--ck-z-default:1;--ck-z-modal:calc(var(--ck-z-default) + 999)}.ck-transitions-disabled,.ck-transitions-disabled *{transition:none!important}:root{--ck-color-base-foreground:#fafafa;--ck-color-base-background:#fff;--ck-color-base-border:#c4c4c4;--ck-color-base-action:#61b045;--ck-color-base-focus:#6cb5f9;--ck-color-base-text:#333;--ck-color-base-active:#198cf0;--ck-color-base-active-focus:#0e7fe1;--ck-color-base-error:#db3700;--ck-color-focus-border-coordinates:208,79%,51%;--ck-color-focus-border:hsl(var(--ck-color-focus-border-coordinates));--ck-color-focus-outer-shadow:#bcdefb;--ck-color-focus-disabled-shadow:rgba(119,186,248,0.3);--ck-color-focus-error-shadow:rgba(255,64,31,0.3);--ck-color-text:var(--ck-color-base-text);--ck-color-shadow-drop:rgba(0,0,0,0.15);--ck-color-shadow-drop-active:rgba(0,0,0,0.2);--ck-color-shadow-inner:rgba(0,0,0,0.1);--ck-color-button-default-background:transparent;--ck-color-button-default-hover-background:#e6e6e6;--ck-color-button-default-active-background:#d9d9d9;--ck-color-button-default-active-shadow:#bfbfbf;--ck-color-button-default-disabled-background:transparent;--ck-color-button-on-background:#dedede;--ck-color-button-on-hover-background:#c4c4c4;--ck-color-button-on-active-background:#bababa;--ck-color-button-on-active-shadow:#a1a1a1;--ck-color-button-on-disabled-background:#dedede;--ck-color-button-action-background:var(--ck-color-base-action);--ck-color-button-action-hover-background:#579e3d;--ck-color-button-action-active-background:#53973b;--ck-color-button-action-active-shadow:#498433;--ck-color-button-action-disabled-background:#7ec365;--ck-color-button-action-text:var(--ck-color-base-background);--ck-color-button-save:#008a00;--ck-color-button-cancel:#db3700;--ck-color-switch-button-off-background:#b0b0b0;--ck-color-switch-button-off-hover-background:#a3a3a3;--ck-color-switch-button-on-background:var(--ck-color-button-action-background);--ck-color-switch-button-on-hover-background:#579e3d;--ck-color-switch-button-inner-background:var(--ck-color-base-background);--ck-color-switch-button-inner-shadow:rgba(0,0,0,0.1);--ck-color-dropdown-panel-background:var(--ck-color-base-background);--ck-color-dropdown-panel-border:var(--ck-color-base-border);--ck-color-input-background:var(--ck-color-base-background);--ck-color-input-border:#c7c7c7;--ck-color-input-error-border:var(--ck-color-base-error);--ck-color-input-text:var(--ck-color-base-text);--ck-color-input-disabled-background:#f2f2f2;--ck-color-input-disabled-border:#c7c7c7;--ck-color-input-disabled-text:#757575;--ck-color-list-background:var(--ck-color-base-background);--ck-color-list-button-hover-background:var(--ck-color-button-default-hover-background);--ck-color-list-button-on-background:var(--ck-color-base-active);--ck-color-list-button-on-background-focus:var(--ck-color-base-active-focus);--ck-color-list-button-on-text:var(--ck-color-base-background);--ck-color-panel-background:var(--ck-color-base-background);--ck-color-panel-border:var(--ck-color-base-border);--ck-color-toolbar-background:var(--ck-color-base-foreground);--ck-color-toolbar-border:var(--ck-color-base-border);--ck-color-tooltip-background:var(--ck-color-base-text);--ck-color-tooltip-text:var(--ck-color-base-background);--ck-color-engine-placeholder-text:#707070;--ck-color-upload-bar-background:#6cb5f9;--ck-color-link-default:#0000f0;--ck-color-link-selected-background:rgba(31,177,255,0.1);--ck-color-link-fake-selection:rgba(31,177,255,0.3);--ck-disabled-opacity:.5;--ck-focus-outer-shadow-geometry:0 0 0 3px;--ck-focus-outer-shadow:var(--ck-focus-outer-shadow-geometry) var(--ck-color-focus-outer-shadow);--ck-focus-disabled-outer-shadow:var(--ck-focus-outer-shadow-geometry) var(--ck-color-focus-disabled-shadow);--ck-focus-error-outer-shadow:var(--ck-focus-outer-shadow-geometry) var(--ck-color-focus-error-shadow);--ck-focus-ring:1px solid var(--ck-color-focus-border);--ck-font-size-base:13px;--ck-line-height-base:1.84615;--ck-font-face:Helvetica,Arial,Tahoma,Verdana,Sans-Serif;--ck-font-size-tiny:0.7em;--ck-font-size-small:0.75em;--ck-font-size-normal:1em;--ck-font-size-big:1.4em;--ck-font-size-large:1.8em;--ck-ui-component-min-height:2.3em}.ck.ck-reset,.ck.ck-reset_all,.ck.ck-reset_all *{margin:0;padding:0;border:0;background:transparent;text-decoration:none;vertical-align:middle;transition:none;word-wrap:break-word}.ck.ck-reset_all,.ck.ck-reset_all *{border-collapse:collapse;font:normal normal normal var(--ck-font-size-base)/var(--ck-line-height-base) var(--ck-font-face);color:var(--ck-color-text);text-align:left;white-space:nowrap;cursor:auto;float:none}.ck.ck-reset_all .ck-rtl *{text-align:right}.ck.ck-reset_all iframe{vertical-align:inherit}.ck.ck-reset_all textarea{white-space:pre-wrap}.ck.ck-reset_all input[type=password],.ck.ck-reset_all input[type=text],.ck.ck-reset_all textarea{cursor:text}.ck.ck-reset_all input[type=password][disabled],.ck.ck-reset_all input[type=text][disabled],.ck.ck-reset_all textarea[disabled]{cursor:default}.ck.ck-reset_all fieldset{padding:10px;border:2px groove #dfdee3}.ck.ck-reset_all button::-moz-focus-inner{padding:0;border:0}.ck[dir=rtl],.ck[dir=rtl] .ck{text-align:right}:root{--ck-border-radius:2px;--ck-inner-shadow:2px 2px 3px var(--ck-color-shadow-inner) inset;--ck-drop-shadow:0 1px 2px 1px var(--ck-color-shadow-drop);--ck-drop-shadow-active:0 3px 6px 1px var(--ck-color-shadow-drop-active);--ck-spacing-unit:0.6em;--ck-spacing-large:calc(var(--ck-spacing-unit)*1.5);--ck-spacing-standard:var(--ck-spacing-unit);--ck-spacing-medium:calc(var(--ck-spacing-unit)*0.8);--ck-spacing-small:calc(var(--ck-spacing-unit)*0.5);--ck-spacing-tiny:calc(var(--ck-spacing-unit)*0.3);--ck-spacing-extra-tiny:calc(var(--ck-spacing-unit)*0.16)}", ""]);
        var r = i;
      },
      "./node_modules/css-loader/dist/cjs.js!./node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].use[2]!./packages/ckeditor5-widget/theme/widget.css": function _node_modules_cssLoader_dist_cjsJs_node_modules_postcssLoader_dist_cjsJsRuleSet1Rules1Use2_packages_ckeditor5Widget_theme_widgetCss(e, t, s) {
        "use strict";

        s.d(t, {
          Z: function Z() {
            return r;
          }
        });
        var o = s("./node_modules/css-loader/dist/runtime/api.js"),
          i = s.n(o)()(function (e) {
            return e[1];
          });
        i.push([e.id, ":root{--ck-color-resizer:var(--ck-color-focus-border);--ck-color-resizer-tooltip-background:#262626;--ck-color-resizer-tooltip-text:#f2f2f2;--ck-resizer-border-radius:var(--ck-border-radius);--ck-resizer-tooltip-offset:10px;--ck-resizer-tooltip-height:calc(var(--ck-spacing-small)*2 + 10px)}.ck .ck-widget,.ck .ck-widget.ck-widget_with-selection-handle{position:relative}.ck .ck-widget.ck-widget_with-selection-handle .ck-widget__selection-handle{position:absolute}.ck .ck-widget.ck-widget_with-selection-handle .ck-widget__selection-handle .ck-icon{display:block}.ck .ck-widget.ck-widget_with-selection-handle.ck-widget_selected>.ck-widget__selection-handle,.ck .ck-widget.ck-widget_with-selection-handle:hover>.ck-widget__selection-handle{visibility:visible}.ck .ck-size-view{background:var(--ck-color-resizer-tooltip-background);color:var(--ck-color-resizer-tooltip-text);border:1px solid var(--ck-color-resizer-tooltip-text);border-radius:var(--ck-resizer-border-radius);font-size:var(--ck-font-size-tiny);display:block;padding:0 var(--ck-spacing-small);height:var(--ck-resizer-tooltip-height);line-height:var(--ck-resizer-tooltip-height)}.ck .ck-size-view.ck-orientation-above-center,.ck .ck-size-view.ck-orientation-bottom-left,.ck .ck-size-view.ck-orientation-bottom-right,.ck .ck-size-view.ck-orientation-top-left,.ck .ck-size-view.ck-orientation-top-right{position:absolute}.ck .ck-size-view.ck-orientation-top-left{top:var(--ck-resizer-tooltip-offset);left:var(--ck-resizer-tooltip-offset)}.ck .ck-size-view.ck-orientation-top-right{top:var(--ck-resizer-tooltip-offset);right:var(--ck-resizer-tooltip-offset)}.ck .ck-size-view.ck-orientation-bottom-right{bottom:var(--ck-resizer-tooltip-offset);right:var(--ck-resizer-tooltip-offset)}.ck .ck-size-view.ck-orientation-bottom-left{bottom:var(--ck-resizer-tooltip-offset);left:var(--ck-resizer-tooltip-offset)}.ck .ck-size-view.ck-orientation-above-center{top:calc(var(--ck-resizer-tooltip-height)*-1);left:50%;transform:translate(-50%)}:root{--ck-widget-outline-thickness:3px;--ck-widget-handler-icon-size:16px;--ck-widget-handler-animation-duration:200ms;--ck-widget-handler-animation-curve:ease;--ck-color-widget-blurred-border:#dedede;--ck-color-widget-hover-border:#ffc83d;--ck-color-widget-editable-focus-background:var(--ck-color-base-background);--ck-color-widget-drag-handler-icon-color:var(--ck-color-base-background)}.ck .ck-widget{outline-width:var(--ck-widget-outline-thickness);outline-style:solid;outline-color:transparent;transition:outline-color var(--ck-widget-handler-animation-duration) var(--ck-widget-handler-animation-curve)}.ck .ck-widget.ck-widget_selected,.ck .ck-widget.ck-widget_selected:hover{outline:var(--ck-widget-outline-thickness) solid var(--ck-color-focus-border)}.ck .ck-widget:hover{outline-color:var(--ck-color-widget-hover-border)}.ck .ck-editor__nested-editable{border:1px solid transparent}.ck .ck-editor__nested-editable.ck-editor__nested-editable_focused,.ck .ck-editor__nested-editable:focus{outline:none;border:var(--ck-focus-ring);box-shadow:var(--ck-inner-shadow),0 0;background-color:var(--ck-color-widget-editable-focus-background)}.ck .ck-widget.ck-widget_with-selection-handle .ck-widget__selection-handle{padding:4px;box-sizing:border-box;background-color:transparent;opacity:0;transition:background-color var(--ck-widget-handler-animation-duration) var(--ck-widget-handler-animation-curve),visibility var(--ck-widget-handler-animation-duration) var(--ck-widget-handler-animation-curve),opacity var(--ck-widget-handler-animation-duration) var(--ck-widget-handler-animation-curve);border-radius:var(--ck-border-radius) var(--ck-border-radius) 0 0;transform:translateY(-100%);left:calc(0px - var(--ck-widget-outline-thickness));top:0}.ck .ck-widget.ck-widget_with-selection-handle .ck-widget__selection-handle .ck-icon{width:var(--ck-widget-handler-icon-size);height:var(--ck-widget-handler-icon-size);color:var(--ck-color-widget-drag-handler-icon-color)}.ck .ck-widget.ck-widget_with-selection-handle .ck-widget__selection-handle .ck-icon .ck-icon__selected-indicator{opacity:0;transition:opacity .3s var(--ck-widget-handler-animation-curve)}.ck .ck-widget.ck-widget_with-selection-handle .ck-widget__selection-handle:hover .ck-icon .ck-icon__selected-indicator{opacity:1}.ck .ck-widget.ck-widget_with-selection-handle:hover>.ck-widget__selection-handle{opacity:1;background-color:var(--ck-color-widget-hover-border)}.ck .ck-widget.ck-widget_with-selection-handle.ck-widget_selected:hover>.ck-widget__selection-handle,.ck .ck-widget.ck-widget_with-selection-handle.ck-widget_selected>.ck-widget__selection-handle{opacity:1;background-color:var(--ck-color-focus-border)}.ck .ck-widget.ck-widget_with-selection-handle.ck-widget_selected:hover>.ck-widget__selection-handle .ck-icon .ck-icon__selected-indicator,.ck .ck-widget.ck-widget_with-selection-handle.ck-widget_selected>.ck-widget__selection-handle .ck-icon .ck-icon__selected-indicator{opacity:1}.ck[dir=rtl] .ck-widget.ck-widget_with-selection-handle .ck-widget__selection-handle{left:auto;right:calc(0px - var(--ck-widget-outline-thickness))}.ck.ck-editor__editable.ck-read-only .ck-widget{transition:none}.ck.ck-editor__editable.ck-read-only .ck-widget:not(.ck-widget_selected){--ck-widget-outline-thickness:0px}.ck.ck-editor__editable.ck-read-only .ck-widget.ck-widget_with-selection-handle .ck-widget__selection-handle,.ck.ck-editor__editable.ck-read-only .ck-widget.ck-widget_with-selection-handle .ck-widget__selection-handle:hover{background:var(--ck-color-widget-blurred-border)}.ck.ck-editor__editable.ck-blurred .ck-widget.ck-widget_selected,.ck.ck-editor__editable.ck-blurred .ck-widget.ck-widget_selected:hover{outline-color:var(--ck-color-widget-blurred-border)}.ck.ck-editor__editable.ck-blurred .ck-widget.ck-widget_selected.ck-widget_with-selection-handle>.ck-widget__selection-handle,.ck.ck-editor__editable.ck-blurred .ck-widget.ck-widget_selected.ck-widget_with-selection-handle>.ck-widget__selection-handle:hover,.ck.ck-editor__editable.ck-blurred .ck-widget.ck-widget_selected:hover.ck-widget_with-selection-handle>.ck-widget__selection-handle,.ck.ck-editor__editable.ck-blurred .ck-widget.ck-widget_selected:hover.ck-widget_with-selection-handle>.ck-widget__selection-handle:hover{background:var(--ck-color-widget-blurred-border)}.ck.ck-editor__editable>.ck-widget.ck-widget_with-selection-handle:first-child,.ck.ck-editor__editable blockquote>.ck-widget.ck-widget_with-selection-handle:first-child{margin-top:calc(1em + var(--ck-widget-handler-icon-size))}", ""]);
        var r = i;
      },
      "./node_modules/css-loader/dist/cjs.js!./node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].use[2]!./packages/ckeditor5-widget/theme/widgetresize.css": function _node_modules_cssLoader_dist_cjsJs_node_modules_postcssLoader_dist_cjsJsRuleSet1Rules1Use2_packages_ckeditor5Widget_theme_widgetresizeCss(e, t, s) {
        "use strict";

        s.d(t, {
          Z: function Z() {
            return r;
          }
        });
        var o = s("./node_modules/css-loader/dist/runtime/api.js"),
          i = s.n(o)()(function (e) {
            return e[1];
          });
        i.push([e.id, ".ck .ck-widget_with-resizer{position:relative}.ck .ck-widget__resizer{display:none;position:absolute;pointer-events:none;left:0;top:0}.ck-focused .ck-widget_with-resizer.ck-widget_selected>.ck-widget__resizer{display:block}.ck .ck-widget__resizer__handle{position:absolute;pointer-events:all}.ck .ck-widget__resizer__handle.ck-widget__resizer__handle-bottom-right,.ck .ck-widget__resizer__handle.ck-widget__resizer__handle-top-left{cursor:nwse-resize}.ck .ck-widget__resizer__handle.ck-widget__resizer__handle-bottom-left,.ck .ck-widget__resizer__handle.ck-widget__resizer__handle-top-right{cursor:nesw-resize}:root{--ck-resizer-size:10px;--ck-resizer-offset:calc(var(--ck-resizer-size)/-2 - 2px);--ck-resizer-border-width:1px}.ck .ck-widget__resizer{outline:1px solid var(--ck-color-resizer)}.ck .ck-widget__resizer__handle{width:var(--ck-resizer-size);height:var(--ck-resizer-size);background:var(--ck-color-focus-border);border:var(--ck-resizer-border-width) solid #fff;border-radius:var(--ck-resizer-border-radius)}.ck .ck-widget__resizer__handle.ck-widget__resizer__handle-top-left{top:var(--ck-resizer-offset);left:var(--ck-resizer-offset)}.ck .ck-widget__resizer__handle.ck-widget__resizer__handle-top-right{top:var(--ck-resizer-offset);right:var(--ck-resizer-offset)}.ck .ck-widget__resizer__handle.ck-widget__resizer__handle-bottom-right{bottom:var(--ck-resizer-offset);right:var(--ck-resizer-offset)}.ck .ck-widget__resizer__handle.ck-widget__resizer__handle-bottom-left{bottom:var(--ck-resizer-offset);left:var(--ck-resizer-offset)}", ""]);
        var r = i;
      },
      "./node_modules/css-loader/dist/cjs.js!./node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].use[2]!./packages/ckeditor5-widget/theme/widgettypearound.css": function _node_modules_cssLoader_dist_cjsJs_node_modules_postcssLoader_dist_cjsJsRuleSet1Rules1Use2_packages_ckeditor5Widget_theme_widgettypearoundCss(e, t, s) {
        "use strict";

        s.d(t, {
          Z: function Z() {
            return r;
          }
        });
        var o = s("./node_modules/css-loader/dist/runtime/api.js"),
          i = s.n(o)()(function (e) {
            return e[1];
          });
        i.push([e.id, '.ck .ck-widget .ck-widget__type-around__button{display:block;position:absolute;overflow:hidden;z-index:var(--ck-z-default)}.ck .ck-widget .ck-widget__type-around__button svg{position:absolute;top:50%;left:50%;z-index:calc(var(--ck-z-default) + 2)}.ck .ck-widget .ck-widget__type-around__button.ck-widget__type-around__button_before{top:calc(var(--ck-widget-outline-thickness)*-0.5);left:min(10%,30px);transform:translateY(-50%)}.ck .ck-widget .ck-widget__type-around__button.ck-widget__type-around__button_after{bottom:calc(var(--ck-widget-outline-thickness)*-0.5);right:min(10%,30px);transform:translateY(50%)}.ck .ck-widget.ck-widget_selected>.ck-widget__type-around>.ck-widget__type-around__button:after,.ck .ck-widget>.ck-widget__type-around>.ck-widget__type-around__button:hover:after{content:"";display:block;position:absolute;top:1px;left:1px;z-index:calc(var(--ck-z-default) + 1)}.ck .ck-widget>.ck-widget__type-around>.ck-widget__type-around__fake-caret{display:none;position:absolute;left:0;right:0}.ck .ck-widget:hover>.ck-widget__type-around>.ck-widget__type-around__fake-caret{left:calc(var(--ck-widget-outline-thickness)*-1);right:calc(var(--ck-widget-outline-thickness)*-1)}.ck .ck-widget.ck-widget_type-around_show-fake-caret_before>.ck-widget__type-around>.ck-widget__type-around__fake-caret{top:calc(var(--ck-widget-outline-thickness)*-1 - 1px);display:block}.ck .ck-widget.ck-widget_type-around_show-fake-caret_after>.ck-widget__type-around>.ck-widget__type-around__fake-caret{bottom:calc(var(--ck-widget-outline-thickness)*-1 - 1px);display:block}.ck.ck-editor__editable.ck-read-only .ck-widget__type-around,.ck.ck-editor__editable.ck-restricted-editing_mode_restricted .ck-widget__type-around,.ck.ck-editor__editable.ck-widget__type-around_disabled .ck-widget__type-around{display:none}:root{--ck-widget-type-around-button-size:20px;--ck-color-widget-type-around-button-active:var(--ck-color-focus-border);--ck-color-widget-type-around-button-hover:var(--ck-color-widget-hover-border);--ck-color-widget-type-around-button-blurred-editable:var(--ck-color-widget-blurred-border);--ck-color-widget-type-around-button-radar-start-alpha:0;--ck-color-widget-type-around-button-radar-end-alpha:.3;--ck-color-widget-type-around-button-icon:var(--ck-color-base-background)}.ck .ck-widget .ck-widget__type-around__button{width:var(--ck-widget-type-around-button-size);height:var(--ck-widget-type-around-button-size);background:var(--ck-color-widget-type-around-button);border-radius:100px;transition:opacity var(--ck-widget-handler-animation-duration) var(--ck-widget-handler-animation-curve),background var(--ck-widget-handler-animation-duration) var(--ck-widget-handler-animation-curve);opacity:0;pointer-events:none}.ck .ck-widget .ck-widget__type-around__button svg{width:10px;height:8px;transform:translate(-50%,-50%);transition:transform .5s ease;margin-top:1px}.ck .ck-widget .ck-widget__type-around__button svg *{stroke-dasharray:10;stroke-dashoffset:0;fill:none;stroke:var(--ck-color-widget-type-around-button-icon);stroke-width:1.5px;stroke-linecap:round;stroke-linejoin:round}.ck .ck-widget .ck-widget__type-around__button svg line{stroke-dasharray:7}.ck .ck-widget .ck-widget__type-around__button:hover{animation:ck-widget-type-around-button-sonar 1s ease infinite}.ck .ck-widget .ck-widget__type-around__button:hover svg polyline{animation:ck-widget-type-around-arrow-dash 2s linear}.ck .ck-widget .ck-widget__type-around__button:hover svg line{animation:ck-widget-type-around-arrow-tip-dash 2s linear}.ck .ck-widget.ck-widget_selected>.ck-widget__type-around>.ck-widget__type-around__button,.ck .ck-widget:hover>.ck-widget__type-around>.ck-widget__type-around__button{opacity:1;pointer-events:auto}.ck .ck-widget:not(.ck-widget_selected)>.ck-widget__type-around>.ck-widget__type-around__button{background:var(--ck-color-widget-type-around-button-hover)}.ck .ck-widget.ck-widget_selected>.ck-widget__type-around>.ck-widget__type-around__button,.ck .ck-widget>.ck-widget__type-around>.ck-widget__type-around__button:hover{background:var(--ck-color-widget-type-around-button-active)}.ck .ck-widget.ck-widget_selected>.ck-widget__type-around>.ck-widget__type-around__button:after,.ck .ck-widget>.ck-widget__type-around>.ck-widget__type-around__button:hover:after{width:calc(var(--ck-widget-type-around-button-size) - 2px);height:calc(var(--ck-widget-type-around-button-size) - 2px);border-radius:100px;background:linear-gradient(135deg,hsla(0,0%,100%,0),hsla(0,0%,100%,.3))}.ck .ck-widget.ck-widget_with-selection-handle>.ck-widget__type-around>.ck-widget__type-around__button_before{margin-left:20px}.ck .ck-widget .ck-widget__type-around__fake-caret{pointer-events:none;height:1px;animation:ck-widget-type-around-fake-caret-pulse 1s linear infinite normal forwards;outline:1px solid hsla(0,0%,100%,.5);background:var(--ck-color-base-text)}.ck .ck-widget.ck-widget_selected.ck-widget_type-around_show-fake-caret_after,.ck .ck-widget.ck-widget_selected.ck-widget_type-around_show-fake-caret_before{outline-color:transparent}.ck .ck-widget.ck-widget_type-around_show-fake-caret_after.ck-widget_selected:hover,.ck .ck-widget.ck-widget_type-around_show-fake-caret_before.ck-widget_selected:hover{outline-color:var(--ck-color-widget-hover-border)}.ck .ck-widget.ck-widget_type-around_show-fake-caret_after>.ck-widget__type-around>.ck-widget__type-around__button,.ck .ck-widget.ck-widget_type-around_show-fake-caret_before>.ck-widget__type-around>.ck-widget__type-around__button{opacity:0;pointer-events:none}.ck .ck-widget.ck-widget_type-around_show-fake-caret_after.ck-widget_with-selection-handle.ck-widget_selected:hover>.ck-widget__selection-handle,.ck .ck-widget.ck-widget_type-around_show-fake-caret_after.ck-widget_with-selection-handle.ck-widget_selected>.ck-widget__selection-handle,.ck .ck-widget.ck-widget_type-around_show-fake-caret_before.ck-widget_with-selection-handle.ck-widget_selected:hover>.ck-widget__selection-handle,.ck .ck-widget.ck-widget_type-around_show-fake-caret_before.ck-widget_with-selection-handle.ck-widget_selected>.ck-widget__selection-handle{opacity:0}.ck .ck-widget.ck-widget_type-around_show-fake-caret_after.ck-widget_selected.ck-widget_with-resizer>.ck-widget__resizer,.ck .ck-widget.ck-widget_type-around_show-fake-caret_before.ck-widget_selected.ck-widget_with-resizer>.ck-widget__resizer{opacity:0}.ck[dir=rtl] .ck-widget.ck-widget_with-selection-handle .ck-widget__type-around>.ck-widget__type-around__button_before{margin-left:0;margin-right:20px}.ck-editor__nested-editable.ck-editor__editable_selected .ck-widget.ck-widget_selected>.ck-widget__type-around>.ck-widget__type-around__button,.ck-editor__nested-editable.ck-editor__editable_selected .ck-widget:hover>.ck-widget__type-around>.ck-widget__type-around__button{opacity:0;pointer-events:none}.ck-editor__editable.ck-blurred .ck-widget.ck-widget_selected>.ck-widget__type-around>.ck-widget__type-around__button:not(:hover){background:var(--ck-color-widget-type-around-button-blurred-editable)}.ck-editor__editable.ck-blurred .ck-widget.ck-widget_selected>.ck-widget__type-around>.ck-widget__type-around__button:not(:hover) svg *{stroke:#999}@keyframes ck-widget-type-around-arrow-dash{0%{stroke-dashoffset:10}20%,to{stroke-dashoffset:0}}@keyframes ck-widget-type-around-arrow-tip-dash{0%,20%{stroke-dashoffset:7}40%,to{stroke-dashoffset:0}}@keyframes ck-widget-type-around-button-sonar{0%{box-shadow:0 0 0 0 hsla(var(--ck-color-focus-border-coordinates),var(--ck-color-widget-type-around-button-radar-start-alpha))}50%{box-shadow:0 0 0 5px hsla(var(--ck-color-focus-border-coordinates),var(--ck-color-widget-type-around-button-radar-end-alpha))}to{box-shadow:0 0 0 5px hsla(var(--ck-color-focus-border-coordinates),var(--ck-color-widget-type-around-button-radar-start-alpha))}}@keyframes ck-widget-type-around-fake-caret-pulse{0%{opacity:1}49%{opacity:1}50%{opacity:0}99%{opacity:0}to{opacity:1}}', ""]);
        var r = i;
      },
      "./node_modules/css-loader/dist/runtime/api.js": function _node_modules_cssLoader_dist_runtime_apiJs(e) {
        "use strict";

        e.exports = function (e) {
          var t = [];
          return t.toString = function () {
            return this.map(function (t) {
              var s = e(t);
              return t[2] ? "@media ".concat(t[2], " {").concat(s, "}") : s;
            }).join("");
          }, t.i = function (e, s, o) {
            "string" == typeof e && (e = [[null, e, ""]]);
            var i = {};
            if (o) for (var r = 0; r < this.length; r++) {
              var n = this[r][0];
              null != n && (i[n] = !0);
            }
            for (var a = 0; a < e.length; a++) {
              var c = [].concat(e[a]);
              o && i[c[0]] || (s && (c[2] ? c[2] = "".concat(s, " and ").concat(c[2]) : c[2] = s), t.push(c));
            }
          }, t;
        };
      },
      "./packages/ckeditor5-core/theme/icons/pilcrow.svg": function _packages_ckeditor5Core_theme_icons_pilcrowSvg(e, t, s) {
        "use strict";

        s.d(t, {
          Z: function Z() {
            return o;
          }
        });
        var o = '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M6.999 2H15a1 1 0 0 1 0 2h-1.004v13a1 1 0 1 1-2 0V4H8.999v13a1 1 0 1 1-2 0v-7A4 4 0 0 1 3 6a4 4 0 0 1 3.999-4z"/></svg>';
      },
      "./packages/ckeditor5-core/theme/icons/three-vertical-dots.svg": function _packages_ckeditor5Core_theme_icons_threeVerticalDotsSvg(e, t, s) {
        "use strict";

        s.d(t, {
          Z: function Z() {
            return o;
          }
        });
        var o = '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><circle cx="9.5" cy="4.5" r="1.5"/><circle cx="9.5" cy="10.5" r="1.5"/><circle cx="9.5" cy="16.5" r="1.5"/></svg>';
      },
      "./packages/ckeditor5-ui/theme/icons/dropdown-arrow.svg": function _packages_ckeditor5Ui_theme_icons_dropdownArrowSvg(e, t, s) {
        "use strict";

        s.d(t, {
          Z: function Z() {
            return o;
          }
        });
        var o = '<svg viewBox="0 0 10 10" xmlns="http://www.w3.org/2000/svg"><path d="M.941 4.523a.75.75 0 1 1 1.06-1.06l3.006 3.005 3.005-3.005a.75.75 0 1 1 1.06 1.06l-3.549 3.55a.75.75 0 0 1-1.168-.136L.941 4.523z"/></svg>';
      },
      "./node_modules/style-loader/dist/runtime/injectStylesIntoStyleTag.js": function _node_modules_styleLoader_dist_runtime_injectStylesIntoStyleTagJs(e, t, s) {
        "use strict";

        var o,
          i = function i() {
            return void 0 === o && (o = Boolean(window && document && document.all && !window.atob)), o;
          },
          r = function () {
            var e = {};
            return function (t) {
              if (void 0 === e[t]) {
                var s = document.querySelector(t);
                if (window.HTMLIFrameElement && s instanceof window.HTMLIFrameElement) try {
                  s = s.contentDocument.head;
                } catch (e) {
                  s = null;
                }
                e[t] = s;
              }
              return e[t];
            };
          }(),
          n = [];
        function a(e) {
          for (var t = -1, s = 0; s < n.length; s++) if (n[s].identifier === e) {
            t = s;
            break;
          }
          return t;
        }
        function c(e, t) {
          for (var s = {}, o = [], i = 0; i < e.length; i++) {
            var r = e[i],
              c = t.base ? r[0] + t.base : r[0],
              l = s[c] || 0,
              d = "".concat(c, " ").concat(l);
            s[c] = l + 1;
            var h = a(d),
              u = {
                css: r[1],
                media: r[2],
                sourceMap: r[3]
              };
            -1 !== h ? (n[h].references++, n[h].updater(u)) : n.push({
              identifier: d,
              updater: m(u, t),
              references: 1
            }), o.push(d);
          }
          return o;
        }
        function l(e) {
          var t = document.createElement("style"),
            o = e.attributes || {};
          if (void 0 === o.nonce) {
            var i = s.nc;
            i && (o.nonce = i);
          }
          if (Object.keys(o).forEach(function (e) {
            t.setAttribute(e, o[e]);
          }), "function" == typeof e.insert) e.insert(t);else {
            var n = r(e.insert || "head");
            if (!n) throw new Error("Couldn't find a style target. This probably means that the value for the 'insert' parameter is invalid.");
            n.appendChild(t);
          }
          return t;
        }
        var d,
          h = (d = [], function (e, t) {
            return d[e] = t, d.filter(Boolean).join("\n");
          });
        function u(e, t, s, o) {
          var i = s ? "" : o.media ? "@media ".concat(o.media, " {").concat(o.css, "}") : o.css;
          if (e.styleSheet) e.styleSheet.cssText = h(t, i);else {
            var r = document.createTextNode(i),
              n = e.childNodes;
            n[t] && e.removeChild(n[t]), n.length ? e.insertBefore(r, n[t]) : e.appendChild(r);
          }
        }
        function g(e, t, s) {
          var o = s.css,
            i = s.media,
            r = s.sourceMap;
          if (i ? e.setAttribute("media", i) : e.removeAttribute("media"), r && "undefined" != typeof btoa && (o += "\n/*# sourceMappingURL=data:application/json;base64,".concat(btoa(unescape(encodeURIComponent(JSON.stringify(r)))), " */")), e.styleSheet) e.styleSheet.cssText = o;else {
            for (; e.firstChild;) e.removeChild(e.firstChild);
            e.appendChild(document.createTextNode(o));
          }
        }
        var p = null,
          f = 0;
        function m(e, t) {
          var s, o, i;
          if (t.singleton) {
            var r = f++;
            s = p || (p = l(t)), o = u.bind(null, s, r, !1), i = u.bind(null, s, r, !0);
          } else s = l(t), o = g.bind(null, s, t), i = function i() {
            !function (e) {
              if (null === e.parentNode) return !1;
              e.parentNode.removeChild(e);
            }(s);
          };
          return o(e), function (t) {
            if (t) {
              if (t.css === e.css && t.media === e.media && t.sourceMap === e.sourceMap) return;
              o(e = t);
            } else i();
          };
        }
        e.exports = function (e, t) {
          (t = t || {}).singleton || "boolean" == typeof t.singleton || (t.singleton = i());
          var s = c(e = e || [], t);
          return function (e) {
            if (e = e || [], "[object Array]" === Object.prototype.toString.call(e)) {
              for (var o = 0; o < s.length; o++) {
                var i = a(s[o]);
                n[i].references--;
              }
              for (var r = c(e, t), l = 0; l < s.length; l++) {
                var d = a(s[l]);
                0 === n[d].references && (n[d].updater(), n.splice(d, 1));
              }
              s = r;
            }
          };
        };
      },
      "./packages/ckeditor5-core/src/command.js": function _packages_ckeditor5Core_src_commandJs(e, t, s) {
        "use strict";

        s.d(t, {
          Z: function Z() {
            return r;
          }
        });
        var o = s("./packages/ckeditor5-utils/src/observablemixin.js"),
          i = s("./packages/ckeditor5-utils/src/mix.js");
        var r = /*#__PURE__*/function () {
          function r(e) {
            var _this = this;
            _classCallCheck(this, r);
            this.editor = e, this.set("value", void 0), this.set("isEnabled", !1), this.affectsData = !0, this._disableStack = new Set(), this.decorate("execute"), this.listenTo(this.editor.model.document, "change", function () {
              _this.refresh();
            }), this.on("execute", function (e) {
              _this.isEnabled || e.stop();
            }, {
              priority: "high"
            }), this.listenTo(e, "change:isReadOnly", function (e, t, s) {
              s && _this.affectsData ? _this.forceDisabled("readOnlyMode") : _this.clearForceDisabled("readOnlyMode");
            });
          }
          _createClass(r, [{
            key: "refresh",
            value: function refresh() {
              this.isEnabled = !0;
            }
          }, {
            key: "forceDisabled",
            value: function forceDisabled(e) {
              this._disableStack.add(e), 1 == this._disableStack.size && (this.on("set:isEnabled", n, {
                priority: "highest"
              }), this.isEnabled = !1);
            }
          }, {
            key: "clearForceDisabled",
            value: function clearForceDisabled(e) {
              this._disableStack.delete(e), 0 == this._disableStack.size && (this.off("set:isEnabled", n), this.refresh());
            }
          }, {
            key: "execute",
            value: function execute() {}
          }, {
            key: "destroy",
            value: function destroy() {
              this.stopListening();
            }
          }]);
          return r;
        }();
        function n(e) {
          e.return = !1, e.stop();
        }
        (0, i.Z)(r, o.Z);
      },
      "./packages/ckeditor5-core/src/contextplugin.js": function _packages_ckeditor5Core_src_contextpluginJs(e, t, s) {
        "use strict";

        s.d(t, {
          Z: function Z() {
            return r;
          }
        });
        var o = s("./packages/ckeditor5-utils/src/observablemixin.js"),
          i = s("./packages/ckeditor5-utils/src/mix.js");
        var r = /*#__PURE__*/function () {
          function r(e) {
            _classCallCheck(this, r);
            this.context = e;
          }
          _createClass(r, [{
            key: "destroy",
            value: function destroy() {
              this.stopListening();
            }
          }], [{
            key: "isContextPlugin",
            get: function get() {
              return !0;
            }
          }]);
          return r;
        }();
        (0, i.Z)(r, o.Z);
      },
      "./packages/ckeditor5-core/src/pendingactions.js": function _packages_ckeditor5Core_src_pendingactionsJs(e, t, s) {
        "use strict";

        s.d(t, {
          Z: function Z() {
            return a;
          }
        });
        var o = s("./packages/ckeditor5-core/src/contextplugin.js"),
          i = s("./packages/ckeditor5-utils/src/observablemixin.js"),
          r = s("./packages/ckeditor5-utils/src/collection.js"),
          n = s("./packages/ckeditor5-utils/src/ckeditorerror.js");
        var a = /*#__PURE__*/function (_o$Z) {
          _inherits(a, _o$Z);
          function a() {
            _classCallCheck(this, a);
            return _possibleConstructorReturn(this, _getPrototypeOf(a).apply(this, arguments));
          }
          _createClass(a, [{
            key: "init",
            value: function init() {
              this.set("hasAny", !1), this._actions = new r.Z({
                idProperty: "_id"
              }), this._actions.delegate("add", "remove").to(this);
            }
          }, {
            key: "add",
            value: function add(e) {
              if ("string" != typeof e) throw new n.ZP("pendingactions-add-invalid-message", this);
              var t = Object.create(i.Z);
              return t.set("message", e), this._actions.add(t), this.hasAny = !0, t;
            }
          }, {
            key: "remove",
            value: function remove(e) {
              this._actions.remove(e), this.hasAny = !!this._actions.length;
            }
          }, {
            key: Symbol.iterator,
            value: function value() {
              return this._actions[Symbol.iterator]();
            }
          }, {
            key: "first",
            get: function get() {
              return this._actions.get(0);
            }
          }], [{
            key: "pluginName",
            get: function get() {
              return "PendingActions";
            }
          }]);
          return a;
        }(o.Z);
      },
      "./packages/ckeditor5-core/src/plugin.js": function _packages_ckeditor5Core_src_pluginJs(e, t, s) {
        "use strict";

        s.d(t, {
          Z: function Z() {
            return r;
          }
        });
        var o = s("./packages/ckeditor5-utils/src/observablemixin.js"),
          i = s("./packages/ckeditor5-utils/src/mix.js");
        var r = /*#__PURE__*/function () {
          function r(e) {
            _classCallCheck(this, r);
            this.editor = e, this.set("isEnabled", !0), this._disableStack = new Set();
          }
          _createClass(r, [{
            key: "forceDisabled",
            value: function forceDisabled(e) {
              this._disableStack.add(e), 1 == this._disableStack.size && (this.on("set:isEnabled", n, {
                priority: "highest"
              }), this.isEnabled = !1);
            }
          }, {
            key: "clearForceDisabled",
            value: function clearForceDisabled(e) {
              this._disableStack.delete(e), 0 == this._disableStack.size && (this.off("set:isEnabled", n), this.isEnabled = !0);
            }
          }, {
            key: "destroy",
            value: function destroy() {
              this.stopListening();
            }
          }], [{
            key: "isContextPlugin",
            get: function get() {
              return !1;
            }
          }]);
          return r;
        }();
        function n(e) {
          e.return = !1, e.stop();
        }
        (0, i.Z)(r, o.Z);
      },
      "./packages/ckeditor5-engine/src/controller/datacontroller.js": function _packages_ckeditor5Engine_src_controller_datacontrollerJs(e, t, s) {
        "use strict";

        s.d(t, {
          Z: function Z() {
            return _Z;
          }
        });
        var o = s("./packages/ckeditor5-utils/src/mix.js"),
          i = s("./packages/ckeditor5-utils/src/observablemixin.js"),
          r = s("./packages/ckeditor5-utils/src/ckeditorerror.js"),
          n = s("./packages/ckeditor5-engine/src/conversion/mapper.js"),
          a = s("./packages/ckeditor5-engine/src/conversion/downcastdispatcher.js"),
          c = s("./packages/ckeditor5-engine/src/conversion/downcasthelpers.js"),
          l = s("./node_modules/lodash-es/isArray.js");
        var d = /*#__PURE__*/function () {
          function d() {
            _classCallCheck(this, d);
            this._consumables = new Map();
          }
          _createClass(d, [{
            key: "add",
            value: function add(e, t) {
              var s;
              e.is("$text") || e.is("documentFragment") ? this._consumables.set(e, !0) : (this._consumables.has(e) ? s = this._consumables.get(e) : (s = new h(e), this._consumables.set(e, s)), s.add(t));
            }
          }, {
            key: "test",
            value: function test(e, t) {
              var s = this._consumables.get(e);
              return void 0 === s ? null : e.is("$text") || e.is("documentFragment") ? s : s.test(t);
            }
          }, {
            key: "consume",
            value: function consume(e, t) {
              return !!this.test(e, t) && (e.is("$text") || e.is("documentFragment") ? this._consumables.set(e, !1) : this._consumables.get(e).consume(t), !0);
            }
          }, {
            key: "revert",
            value: function revert(e, t) {
              var s = this._consumables.get(e);
              void 0 !== s && (e.is("$text") || e.is("documentFragment") ? this._consumables.set(e, !0) : s.revert(t));
            }
          }], [{
            key: "consumablesFromElement",
            value: function consumablesFromElement(e) {
              var t = {
                  element: e,
                  name: !0,
                  attributes: [],
                  classes: [],
                  styles: []
                },
                s = e.getAttributeKeys();
              var _iterator = _createForOfIteratorHelper(s),
                _step;
              try {
                for (_iterator.s(); !(_step = _iterator.n()).done;) {
                  var _e2 = _step.value;
                  "style" != _e2 && "class" != _e2 && t.attributes.push(_e2);
                }
              } catch (err) {
                _iterator.e(err);
              } finally {
                _iterator.f();
              }
              var o = e.getClassNames();
              var _iterator2 = _createForOfIteratorHelper(o),
                _step2;
              try {
                for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
                  var _e3 = _step2.value;
                  t.classes.push(_e3);
                }
              } catch (err) {
                _iterator2.e(err);
              } finally {
                _iterator2.f();
              }
              var i = e.getStyleNames();
              var _iterator3 = _createForOfIteratorHelper(i),
                _step3;
              try {
                for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
                  var _e4 = _step3.value;
                  t.styles.push(_e4);
                }
              } catch (err) {
                _iterator3.e(err);
              } finally {
                _iterator3.f();
              }
              return t;
            }
          }, {
            key: "createFrom",
            value: function createFrom(e, t) {
              if (t || (t = new d(e)), e.is("$text")) return t.add(e), t;
              e.is("element") && t.add(e, d.consumablesFromElement(e)), e.is("documentFragment") && t.add(e);
              var _iterator4 = _createForOfIteratorHelper(e.getChildren()),
                _step4;
              try {
                for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
                  var _s = _step4.value;
                  t = d.createFrom(_s, t);
                }
              } catch (err) {
                _iterator4.e(err);
              } finally {
                _iterator4.f();
              }
              return t;
            }
          }]);
          return d;
        }();
        var h = /*#__PURE__*/function () {
          function h(e) {
            _classCallCheck(this, h);
            this.element = e, this._canConsumeName = null, this._consumables = {
              attributes: new Map(),
              styles: new Map(),
              classes: new Map()
            };
          }
          _createClass(h, [{
            key: "add",
            value: function add(e) {
              e.name && (this._canConsumeName = !0);
              for (var _t in this._consumables) _t in e && this._add(_t, e[_t]);
            }
          }, {
            key: "test",
            value: function test(e) {
              if (e.name && !this._canConsumeName) return this._canConsumeName;
              for (var _t2 in this._consumables) if (_t2 in e) {
                var _s2 = this._test(_t2, e[_t2]);
                if (!0 !== _s2) return _s2;
              }
              return !0;
            }
          }, {
            key: "consume",
            value: function consume(e) {
              e.name && (this._canConsumeName = !1);
              for (var _t3 in this._consumables) _t3 in e && this._consume(_t3, e[_t3]);
            }
          }, {
            key: "revert",
            value: function revert(e) {
              e.name && (this._canConsumeName = !0);
              for (var _t4 in this._consumables) _t4 in e && this._revert(_t4, e[_t4]);
            }
          }, {
            key: "_add",
            value: function _add(e, t) {
              var s = (0, l.Z)(t) ? t : [t],
                o = this._consumables[e];
              var _iterator5 = _createForOfIteratorHelper(s),
                _step5;
              try {
                for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
                  var _t5 = _step5.value;
                  if ("attributes" === e && ("class" === _t5 || "style" === _t5)) throw new r.ZP("viewconsumable-invalid-attribute", this);
                  if (o.set(_t5, !0), "styles" === e) {
                    var _iterator6 = _createForOfIteratorHelper(this.element.document.stylesProcessor.getRelatedStyles(_t5)),
                      _step6;
                    try {
                      for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
                        var _e5 = _step6.value;
                        o.set(_e5, !0);
                      }
                    } catch (err) {
                      _iterator6.e(err);
                    } finally {
                      _iterator6.f();
                    }
                  }
                }
              } catch (err) {
                _iterator5.e(err);
              } finally {
                _iterator5.f();
              }
            }
          }, {
            key: "_test",
            value: function _test(e, t) {
              var s = (0, l.Z)(t) ? t : [t],
                o = this._consumables[e];
              var _iterator7 = _createForOfIteratorHelper(s),
                _step7;
              try {
                for (_iterator7.s(); !(_step7 = _iterator7.n()).done;) {
                  var _t6 = _step7.value;
                  if ("attributes" !== e || "class" !== _t6 && "style" !== _t6) {
                    var _e6 = o.get(_t6);
                    if (void 0 === _e6) return null;
                    if (!_e6) return !1;
                  } else {
                    var _e7 = "class" == _t6 ? "classes" : "styles",
                      _s3 = this._test(_e7, _toConsumableArray(this._consumables[_e7].keys()));
                    if (!0 !== _s3) return _s3;
                  }
                }
              } catch (err) {
                _iterator7.e(err);
              } finally {
                _iterator7.f();
              }
              return !0;
            }
          }, {
            key: "_consume",
            value: function _consume(e, t) {
              var s = (0, l.Z)(t) ? t : [t],
                o = this._consumables[e];
              var _iterator8 = _createForOfIteratorHelper(s),
                _step8;
              try {
                for (_iterator8.s(); !(_step8 = _iterator8.n()).done;) {
                  var _t7 = _step8.value;
                  if ("attributes" !== e || "class" !== _t7 && "style" !== _t7) {
                    if (o.set(_t7, !1), "styles" == e) {
                      var _iterator9 = _createForOfIteratorHelper(this.element.document.stylesProcessor.getRelatedStyles(_t7)),
                        _step9;
                      try {
                        for (_iterator9.s(); !(_step9 = _iterator9.n()).done;) {
                          var _e8 = _step9.value;
                          o.set(_e8, !1);
                        }
                      } catch (err) {
                        _iterator9.e(err);
                      } finally {
                        _iterator9.f();
                      }
                    }
                  } else {
                    var _e9 = "class" == _t7 ? "classes" : "styles";
                    this._consume(_e9, _toConsumableArray(this._consumables[_e9].keys()));
                  }
                }
              } catch (err) {
                _iterator8.e(err);
              } finally {
                _iterator8.f();
              }
            }
          }, {
            key: "_revert",
            value: function _revert(e, t) {
              var s = (0, l.Z)(t) ? t : [t],
                o = this._consumables[e];
              var _iterator10 = _createForOfIteratorHelper(s),
                _step10;
              try {
                for (_iterator10.s(); !(_step10 = _iterator10.n()).done;) {
                  var _t8 = _step10.value;
                  if ("attributes" !== e || "class" !== _t8 && "style" !== _t8) {
                    !1 === o.get(_t8) && o.set(_t8, !0);
                  } else {
                    var _e10 = "class" == _t8 ? "classes" : "styles";
                    this._revert(_e10, _toConsumableArray(this._consumables[_e10].keys()));
                  }
                }
              } catch (err) {
                _iterator10.e(err);
              } finally {
                _iterator10.f();
              }
            }
          }]);
          return h;
        }();
        var u = s("./packages/ckeditor5-engine/src/model/range.js"),
          g = s("./packages/ckeditor5-engine/src/model/position.js"),
          p = s("./packages/ckeditor5-engine/src/model/schema.js"),
          f = s("./packages/ckeditor5-engine/src/model/utils/autoparagraphing.js"),
          m = s("./packages/ckeditor5-utils/src/emittermixin.js");
        var k = /*#__PURE__*/function () {
          function k() {
            var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
            _classCallCheck(this, k);
            this._splitParts = new Map(), this._cursorParents = new Map(), this._modelCursor = null, this.conversionApi = Object.assign({}, e), this.conversionApi.convertItem = this._convertItem.bind(this), this.conversionApi.convertChildren = this._convertChildren.bind(this), this.conversionApi.safeInsert = this._safeInsert.bind(this), this.conversionApi.updateConversionResult = this._updateConversionResult.bind(this), this.conversionApi.splitToAllowedParent = this._splitToAllowedParent.bind(this), this.conversionApi.getSplitParts = this._getSplitParts.bind(this);
          }
          _createClass(k, [{
            key: "convert",
            value: function convert(e, t) {
              var s = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : ["$root"];
              this.fire("viewCleanup", e), this._modelCursor = function (e, t) {
                var s;
                var _iterator11 = _createForOfIteratorHelper(new p.G(e)),
                  _step11;
                try {
                  for (_iterator11.s(); !(_step11 = _iterator11.n()).done;) {
                    var _o = _step11.value;
                    var _e11 = {};
                    var _iterator12 = _createForOfIteratorHelper(_o.getAttributeKeys()),
                      _step12;
                    try {
                      for (_iterator12.s(); !(_step12 = _iterator12.n()).done;) {
                        var _t9 = _step12.value;
                        _e11[_t9] = _o.getAttribute(_t9);
                      }
                    } catch (err) {
                      _iterator12.e(err);
                    } finally {
                      _iterator12.f();
                    }
                    var _i = t.createElement(_o.name, _e11);
                    s && t.append(_i, s), s = g.ZP._createAt(_i, 0);
                  }
                } catch (err) {
                  _iterator11.e(err);
                } finally {
                  _iterator11.f();
                }
                return s;
              }(s, t), this.conversionApi.writer = t, this.conversionApi.consumable = d.createFrom(e), this.conversionApi.store = {};
              var _this$_convertItem = this._convertItem(e, this._modelCursor),
                o = _this$_convertItem.modelRange,
                i = t.createDocumentFragment();
              if (o) {
                this._removeEmptyElements();
                for (var _i2 = 0, _Array$from = Array.from(this._modelCursor.parent.getChildren()); _i2 < _Array$from.length; _i2++) {
                  var _e12 = _Array$from[_i2];
                  t.append(_e12, i);
                }
                i.markers = function (e, t) {
                  var s = new Set(),
                    o = new Map(),
                    i = u.Z._createIn(e).getItems();
                  var _iterator13 = _createForOfIteratorHelper(i),
                    _step13;
                  try {
                    for (_iterator13.s(); !(_step13 = _iterator13.n()).done;) {
                      var _e13 = _step13.value;
                      "$marker" == _e13.name && s.add(_e13);
                    }
                  } catch (err) {
                    _iterator13.e(err);
                  } finally {
                    _iterator13.f();
                  }
                  var _iterator14 = _createForOfIteratorHelper(s),
                    _step14;
                  try {
                    for (_iterator14.s(); !(_step14 = _iterator14.n()).done;) {
                      var _e14 = _step14.value;
                      var _s4 = _e14.getAttribute("data-name"),
                        _i3 = t.createPositionBefore(_e14);
                      o.has(_s4) ? o.get(_s4).end = _i3.clone() : o.set(_s4, new u.Z(_i3.clone())), t.remove(_e14);
                    }
                  } catch (err) {
                    _iterator14.e(err);
                  } finally {
                    _iterator14.f();
                  }
                  return o;
                }(i, t);
              }
              return this._modelCursor = null, this._splitParts.clear(), this._cursorParents.clear(), this.conversionApi.writer = null, this.conversionApi.store = null, i;
            }
          }, {
            key: "_convertItem",
            value: function _convertItem(e, t) {
              var s = Object.assign({
                viewItem: e,
                modelCursor: t,
                modelRange: null
              });
              if (e.is("element") ? this.fire("element:" + e.name, s, this.conversionApi) : e.is("$text") ? this.fire("text", s, this.conversionApi) : this.fire("documentFragment", s, this.conversionApi), s.modelRange && !(s.modelRange instanceof u.Z)) throw new r.ZP("view-conversion-dispatcher-incorrect-result", this);
              return {
                modelRange: s.modelRange,
                modelCursor: s.modelCursor
              };
            }
          }, {
            key: "_convertChildren",
            value: function _convertChildren(e, t) {
              var s = t.is("position") ? t : g.ZP._createAt(t, 0);
              var o = new u.Z(s);
              for (var _i4 = 0, _Array$from2 = Array.from(e.getChildren()); _i4 < _Array$from2.length; _i4++) {
                var _t10 = _Array$from2[_i4];
                var _e15 = this._convertItem(_t10, s);
                _e15.modelRange instanceof u.Z && (o.end = _e15.modelRange.end, s = _e15.modelCursor);
              }
              return {
                modelRange: o,
                modelCursor: s
              };
            }
          }, {
            key: "_safeInsert",
            value: function _safeInsert(e, t) {
              var s = this._splitToAllowedParent(e, t);
              return !!s && (this.conversionApi.writer.insert(e, s.position), !0);
            }
          }, {
            key: "_updateConversionResult",
            value: function _updateConversionResult(e, t) {
              var s = this._getSplitParts(e),
                o = this.conversionApi.writer;
              t.modelRange || (t.modelRange = o.createRange(o.createPositionBefore(e), o.createPositionAfter(s[s.length - 1])));
              var i = this._cursorParents.get(e);
              t.modelCursor = i ? o.createPositionAt(i, 0) : t.modelRange.end;
            }
          }, {
            key: "_splitToAllowedParent",
            value: function _splitToAllowedParent(e, t) {
              var _this$conversionApi = this.conversionApi,
                s = _this$conversionApi.schema,
                o = _this$conversionApi.writer;
              var i = s.findAllowedParent(t, e);
              if (i) {
                if (i === t.parent) return {
                  position: t
                };
                this._modelCursor.parent.getAncestors().includes(i) && (i = null);
              }
              if (!i) return (0, f.gg)(t, e, s) ? {
                position: (0, f.zX)(t, o)
              } : null;
              var r = this.conversionApi.writer.split(t, i),
                n = [];
              var _iterator15 = _createForOfIteratorHelper(r.range.getWalker()),
                _step15;
              try {
                for (_iterator15.s(); !(_step15 = _iterator15.n()).done;) {
                  var _e16 = _step15.value;
                  if ("elementEnd" == _e16.type) n.push(_e16.item);else {
                    var _t11 = n.pop(),
                      _s5 = _e16.item;
                    this._registerSplitPair(_t11, _s5);
                  }
                }
              } catch (err) {
                _iterator15.e(err);
              } finally {
                _iterator15.f();
              }
              var a = r.range.end.parent;
              return this._cursorParents.set(e, a), {
                position: r.position,
                cursorParent: a
              };
            }
          }, {
            key: "_registerSplitPair",
            value: function _registerSplitPair(e, t) {
              this._splitParts.has(e) || this._splitParts.set(e, [e]);
              var s = this._splitParts.get(e);
              this._splitParts.set(t, s), s.push(t);
            }
          }, {
            key: "_getSplitParts",
            value: function _getSplitParts(e) {
              var t;
              return t = this._splitParts.has(e) ? this._splitParts.get(e) : [e], t;
            }
          }, {
            key: "_removeEmptyElements",
            value: function _removeEmptyElements() {
              var e = !1;
              var _iterator16 = _createForOfIteratorHelper(this._splitParts.keys()),
                _step16;
              try {
                for (_iterator16.s(); !(_step16 = _iterator16.n()).done;) {
                  var _t12 = _step16.value;
                  _t12.isEmpty && (this.conversionApi.writer.remove(_t12), this._splitParts.delete(_t12), e = !0);
                }
              } catch (err) {
                _iterator16.e(err);
              } finally {
                _iterator16.f();
              }
              e && this._removeEmptyElements();
            }
          }]);
          return k;
        }();
        (0, o.Z)(k, m.ZP);
        var _ = s("./packages/ckeditor5-engine/src/conversion/upcasthelpers.js"),
          b = s("./packages/ckeditor5-engine/src/view/documentfragment.js"),
          w = s("./packages/ckeditor5-engine/src/view/document.js"),
          v = s("./packages/ckeditor5-engine/src/view/downcastwriter.js"),
          y = s("./packages/ckeditor5-engine/src/dataprocessor/htmldataprocessor.js");
        var _Z = /*#__PURE__*/function () {
          function _Z(e, t) {
            var _this2 = this;
            _classCallCheck(this, _Z);
            this.model = e, this.mapper = new n.Z(), this.downcastDispatcher = new a.Z({
              mapper: this.mapper,
              schema: e.schema
            }), this.downcastDispatcher.on("insert:$text", (0, c.Om)(), {
              priority: "lowest"
            }), this.downcastDispatcher.on("insert", (0, c.o6)(), {
              priority: "lowest"
            }), this.upcastDispatcher = new k({
              schema: e.schema
            }), this.viewDocument = new w.Z(t), this.stylesProcessor = t, this.htmlProcessor = new y.Z(this.viewDocument), this.processor = this.htmlProcessor, this._viewWriter = new v.Z(this.viewDocument), this.upcastDispatcher.on("text", (0, _.s8)(), {
              priority: "lowest"
            }), this.upcastDispatcher.on("element", (0, _._p)(), {
              priority: "lowest"
            }), this.upcastDispatcher.on("documentFragment", (0, _._p)(), {
              priority: "lowest"
            }), this.decorate("init"), this.decorate("set"), this.decorate("get"), this.on("init", function () {
              _this2.fire("ready");
            }, {
              priority: "lowest"
            }), this.on("ready", function () {
              _this2.model.enqueueChange({
                isUndoable: !1
              }, f._m);
            }, {
              priority: "lowest"
            });
          }
          _createClass(_Z, [{
            key: "get",
            value: function get() {
              var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
              var _e$rootName = e.rootName,
                t = _e$rootName === void 0 ? "main" : _e$rootName,
                _e$trim = e.trim,
                s = _e$trim === void 0 ? "empty" : _e$trim;
              if (!this._checkIfRootsExists([t])) throw new r.ZP("datacontroller-get-non-existent-root", this);
              var o = this.model.document.getRoot(t);
              return "empty" !== s || this.model.hasContent(o, {
                ignoreWhitespaces: !0
              }) ? this.stringify(o, e) : "";
            }
          }, {
            key: "stringify",
            value: function stringify(e) {
              var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
              var s = this.toView(e, t);
              return this.processor.toData(s);
            }
          }, {
            key: "toView",
            value: function toView(e) {
              var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
              var s = this.viewDocument,
                o = this._viewWriter;
              this.mapper.clearBindings();
              var i = u.Z._createIn(e),
                r = new b.Z(s);
              this.mapper.bindElements(e, r);
              var n = e.is("documentFragment") ? e.markers : function (e) {
                var t = [],
                  s = e.root.document;
                if (!s) return new Map();
                var o = u.Z._createIn(e);
                var _iterator17 = _createForOfIteratorHelper(s.model.markers),
                  _step17;
                try {
                  for (_iterator17.s(); !(_step17 = _iterator17.n()).done;) {
                    var _e17 = _step17.value;
                    var _s6 = _e17.getRange(),
                      _i5 = _s6.isCollapsed,
                      _r = _s6.start.isEqual(o.start) || _s6.end.isEqual(o.end);
                    if (_i5 && _r) t.push([_e17.name, _s6]);else {
                      var _i6 = o.getIntersection(_s6);
                      _i6 && t.push([_e17.name, _i6]);
                    }
                  }
                } catch (err) {
                  _iterator17.e(err);
                } finally {
                  _iterator17.f();
                }
                return t.sort(function (_ref, _ref2) {
                  var _ref3 = _slicedToArray(_ref, 2),
                    e = _ref3[0],
                    t = _ref3[1];
                  var _ref4 = _slicedToArray(_ref2, 2),
                    s = _ref4[0],
                    o = _ref4[1];
                  if ("after" !== t.end.compareWith(o.start)) return 1;
                  if ("before" !== t.start.compareWith(o.end)) return -1;
                  switch (t.start.compareWith(o.start)) {
                    case "before":
                      return 1;
                    case "after":
                      return -1;
                    default:
                      switch (t.end.compareWith(o.end)) {
                        case "before":
                          return 1;
                        case "after":
                          return -1;
                        default:
                          return s.localeCompare(e);
                      }
                  }
                }), new Map(t);
              }(e);
              return this.downcastDispatcher.convert(i, n, o, t), r;
            }
          }, {
            key: "init",
            value: function init(e) {
              var _this3 = this;
              if (this.model.document.version) throw new r.ZP("datacontroller-init-document-not-empty", this);
              var t = {};
              if ("string" == typeof e ? t.main = e : t = e, !this._checkIfRootsExists(Object.keys(t))) throw new r.ZP("datacontroller-init-non-existent-root", this);
              return this.model.enqueueChange({
                isUndoable: !1
              }, function (e) {
                for (var _i7 = 0, _Object$keys = Object.keys(t); _i7 < _Object$keys.length; _i7++) {
                  var _s7 = _Object$keys[_i7];
                  var _o2 = _this3.model.document.getRoot(_s7);
                  e.insert(_this3.parse(t[_s7], _o2), _o2, 0);
                }
              }), Promise.resolve();
            }
          }, {
            key: "set",
            value: function set(e) {
              var _this4 = this;
              var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
              var s = {};
              if ("string" == typeof e ? s.main = e : s = e, !this._checkIfRootsExists(Object.keys(s))) throw new r.ZP("datacontroller-set-non-existent-root", this);
              this.model.enqueueChange(t.batchType || {}, function (e) {
                e.setSelection(null), e.removeSelectionAttribute(_this4.model.document.selection.getAttributeKeys());
                for (var _i8 = 0, _Object$keys2 = Object.keys(s); _i8 < _Object$keys2.length; _i8++) {
                  var _t13 = _Object$keys2[_i8];
                  var _o3 = _this4.model.document.getRoot(_t13);
                  e.remove(e.createRangeIn(_o3)), e.insert(_this4.parse(s[_t13], _o3), _o3, 0);
                }
              });
            }
          }, {
            key: "parse",
            value: function parse(e) {
              var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "$root";
              var s = this.processor.toView(e);
              return this.toModel(s, t);
            }
          }, {
            key: "toModel",
            value: function toModel(e) {
              var _this5 = this;
              var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "$root";
              return this.model.change(function (s) {
                return _this5.upcastDispatcher.convert(e, s, t);
              });
            }
          }, {
            key: "addStyleProcessorRules",
            value: function addStyleProcessorRules(e) {
              e(this.stylesProcessor);
            }
          }, {
            key: "registerRawContentMatcher",
            value: function registerRawContentMatcher(e) {
              this.processor && this.processor !== this.htmlProcessor && this.processor.registerRawContentMatcher(e), this.htmlProcessor.registerRawContentMatcher(e);
            }
          }, {
            key: "destroy",
            value: function destroy() {
              this.stopListening();
            }
          }, {
            key: "_checkIfRootsExists",
            value: function _checkIfRootsExists(e) {
              var _iterator18 = _createForOfIteratorHelper(e),
                _step18;
              try {
                for (_iterator18.s(); !(_step18 = _iterator18.n()).done;) {
                  var _t14 = _step18.value;
                  if (!this.model.document.getRootNames().includes(_t14)) return !1;
                }
              } catch (err) {
                _iterator18.e(err);
              } finally {
                _iterator18.f();
              }
              return !0;
            }
          }]);
          return _Z;
        }();
        (0, o.Z)(_Z, i.Z);
      },
      "./packages/ckeditor5-engine/src/controller/editingcontroller.js": function _packages_ckeditor5Engine_src_controller_editingcontrollerJs(e, t, s) {
        "use strict";

        s.d(t, {
          Z: function Z() {
            return Y;
          }
        });
        var o = s("./packages/ckeditor5-engine/src/view/editableelement.js");
        var i = Symbol("rootName");
        var r = /*#__PURE__*/function (_o$Z2) {
          _inherits(r, _o$Z2);
          function r(e, t) {
            var _this6;
            _classCallCheck(this, r);
            _this6 = _possibleConstructorReturn(this, _getPrototypeOf(r).call(this, e, t)), _this6.rootName = "main";
            return _this6;
          }
          _createClass(r, [{
            key: "is",
            value: function is(e) {
              var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
              return t ? t === this.name && ("rootElement" === e || "view:rootElement" === e || "editableElement" === e || "view:editableElement" === e || "containerElement" === e || "view:containerElement" === e || "element" === e || "view:element" === e) : "rootElement" === e || "view:rootElement" === e || "editableElement" === e || "view:editableElement" === e || "containerElement" === e || "view:containerElement" === e || "element" === e || "view:element" === e || "node" === e || "view:node" === e;
            }
          }, {
            key: "rootName",
            get: function get() {
              return this.getCustomProperty(i);
            },
            set: function set(e) {
              this._setCustomProperty(i, e);
            }
          }, {
            key: "_name",
            set: function set(e) {
              this.name = e;
            }
          }]);
          return r;
        }(o.Z);
        var n = s("./packages/ckeditor5-engine/src/view/document.js"),
          a = s("./packages/ckeditor5-engine/src/view/downcastwriter.js"),
          c = s("./packages/ckeditor5-engine/src/view/renderer.js"),
          l = s("./packages/ckeditor5-engine/src/view/domconverter.js"),
          d = s("./packages/ckeditor5-engine/src/view/position.js"),
          h = s("./packages/ckeditor5-engine/src/view/range.js"),
          u = s("./packages/ckeditor5-engine/src/view/selection.js"),
          g = s("./packages/ckeditor5-engine/src/view/observer/observer.js"),
          p = s("./packages/ckeditor5-engine/src/view/filler.js"),
          f = s("./node_modules/lodash-es/_baseIsEqual.js");
        var m = function m(e, t, s) {
          var o = (s = "function" == typeof s ? s : void 0) ? s(e, t) : void 0;
          return void 0 === o ? (0, f.Z)(e, t, void 0, s) : !!o;
        };
        var k = /*#__PURE__*/function (_g$Z) {
          _inherits(k, _g$Z);
          function k(e) {
            var _this7;
            _classCallCheck(this, k);
            _this7 = _possibleConstructorReturn(this, _getPrototypeOf(k).call(this, e)), _this7._config = {
              childList: !0,
              characterData: !0,
              characterDataOldValue: !0,
              subtree: !0
            }, _this7.domConverter = e.domConverter, _this7.renderer = e._renderer, _this7._domElements = [], _this7._mutationObserver = new window.MutationObserver(_this7._onMutations.bind(_assertThisInitialized(_assertThisInitialized(_this7))));
            return _this7;
          }
          _createClass(k, [{
            key: "flush",
            value: function flush() {
              this._onMutations(this._mutationObserver.takeRecords());
            }
          }, {
            key: "observe",
            value: function observe(e) {
              this._domElements.push(e), this.isEnabled && this._mutationObserver.observe(e, this._config);
            }
          }, {
            key: "enable",
            value: function enable() {
              _superPropGet(k, "enable", this, 3)([]);
              var _iterator19 = _createForOfIteratorHelper(this._domElements),
                _step19;
              try {
                for (_iterator19.s(); !(_step19 = _iterator19.n()).done;) {
                  var _e18 = _step19.value;
                  this._mutationObserver.observe(_e18, this._config);
                }
              } catch (err) {
                _iterator19.e(err);
              } finally {
                _iterator19.f();
              }
            }
          }, {
            key: "disable",
            value: function disable() {
              _superPropGet(k, "disable", this, 3)([]), this._mutationObserver.disconnect();
            }
          }, {
            key: "destroy",
            value: function destroy() {
              _superPropGet(k, "destroy", this, 3)([]), this._mutationObserver.disconnect();
            }
          }, {
            key: "_onMutations",
            value: function _onMutations(e) {
              if (0 === e.length) return;
              var t = this.domConverter,
                s = new Map(),
                o = new Set();
              var _iterator20 = _createForOfIteratorHelper(e),
                _step20;
              try {
                for (_iterator20.s(); !(_step20 = _iterator20.n()).done;) {
                  var _s9 = _step20.value;
                  if ("childList" === _s9.type) {
                    var _e20 = t.mapDomToView(_s9.target);
                    if (_e20 && (_e20.is("uiElement") || _e20.is("rawElement"))) continue;
                    _e20 && !this._isBogusBrMutation(_s9) && o.add(_e20);
                  }
                }
              } catch (err) {
                _iterator20.e(err);
              } finally {
                _iterator20.f();
              }
              var _iterator21 = _createForOfIteratorHelper(e),
                _step21;
              try {
                for (_iterator21.s(); !(_step21 = _iterator21.n()).done;) {
                  var _i9 = _step21.value;
                  var _e21 = t.mapDomToView(_i9.target);
                  if ((!_e21 || !_e21.is("uiElement") && !_e21.is("rawElement")) && "characterData" === _i9.type) {
                    var _e22 = t.findCorrespondingViewText(_i9.target);
                    _e22 && !o.has(_e22.parent) ? s.set(_e22, {
                      type: "text",
                      oldText: _e22.data,
                      newText: (0, p.th)(_i9.target),
                      node: _e22
                    }) : !_e22 && (0, p.Sw)(_i9.target) && o.add(t.mapDomToView(_i9.target.parentNode));
                  }
                }
              } catch (err) {
                _iterator21.e(err);
              } finally {
                _iterator21.f();
              }
              var i = [];
              var _iterator22 = _createForOfIteratorHelper(s.values()),
                _step22;
              try {
                for (_iterator22.s(); !(_step22 = _iterator22.n()).done;) {
                  var _e23 = _step22.value;
                  this.renderer.markToSync("text", _e23.node), i.push(_e23);
                }
              } catch (err) {
                _iterator22.e(err);
              } finally {
                _iterator22.f();
              }
              var _iterator23 = _createForOfIteratorHelper(o),
                _step23;
              try {
                for (_iterator23.s(); !(_step23 = _iterator23.n()).done;) {
                  var _e24 = _step23.value;
                  var _s10 = t.mapViewToDom(_e24),
                    _o4 = Array.from(_e24.getChildren()),
                    _r2 = Array.from(t.domChildrenToView(_s10, {
                      withChildren: !1
                    }));
                  m(_o4, _r2, a) || (this.renderer.markToSync("children", _e24), i.push({
                    type: "children",
                    oldChildren: _o4,
                    newChildren: _r2,
                    node: _e24
                  }));
                }
              } catch (err) {
                _iterator23.e(err);
              } finally {
                _iterator23.f();
              }
              var r = e[0].target.ownerDocument.getSelection();
              var n = null;
              if (r && r.anchorNode) {
                var _e19 = t.domPositionToView(r.anchorNode, r.anchorOffset),
                  _s8 = t.domPositionToView(r.focusNode, r.focusOffset);
                _e19 && _s8 && (n = new u.Z(_e19), n.setFocus(_s8));
              }
              function a(e, t) {
                if (!Array.isArray(e)) return e === t || !(!e.is("$text") || !t.is("$text")) && e.data === t.data;
              }
              i.length && (this.document.fire("mutations", i, n), this.view.forceRender());
            }
          }, {
            key: "_isBogusBrMutation",
            value: function _isBogusBrMutation(e) {
              var t = null;
              return null === e.nextSibling && 0 === e.removedNodes.length && 1 == e.addedNodes.length && (t = this.domConverter.domToView(e.addedNodes[0], {
                withChildren: !1
              })), t && t.is("element", "br");
            }
          }]);
          return k;
        }(g.Z);
        var _ = s("./packages/ckeditor5-engine/src/view/observer/domeventobserver.js"),
          b = s("./packages/ckeditor5-utils/src/keyboard.js");
        var w = /*#__PURE__*/function (_$Z) {
          _inherits(w, _$Z);
          function w(e) {
            var _this8;
            _classCallCheck(this, w);
            _this8 = _possibleConstructorReturn(this, _getPrototypeOf(w).call(this, e)), _this8.domEventType = ["keydown", "keyup"];
            return _this8;
          }
          _createClass(w, [{
            key: "onDomEvent",
            value: function onDomEvent(e) {
              this.fire(e.type, e, {
                keyCode: e.keyCode,
                altKey: e.altKey,
                ctrlKey: e.ctrlKey,
                shiftKey: e.shiftKey,
                metaKey: e.metaKey,
                get keystroke() {
                  return (0, b.Cq)(this);
                }
              });
            }
          }]);
          return w;
        }(_.Z);
        var v = s("./node_modules/lodash-es/debounce.js");
        var y = /*#__PURE__*/function (_g$Z2) {
          _inherits(y, _g$Z2);
          function y(e) {
            var _this9;
            _classCallCheck(this, y);
            _this9 = _possibleConstructorReturn(this, _getPrototypeOf(y).call(this, e)), _this9._fireSelectionChangeDoneDebounced = (0, v.Z)(function (e) {
              return _this9.document.fire("selectionChangeDone", e);
            }, 200);
            return _this9;
          }
          _createClass(y, [{
            key: "observe",
            value: function observe() {
              var _this10 = this;
              var e = this.document;
              e.on("arrowKey", function (t, s) {
                e.selection.isFake && _this10.isEnabled && s.preventDefault();
              }, {
                context: "$capture"
              }), e.on("arrowKey", function (t, s) {
                e.selection.isFake && _this10.isEnabled && _this10._handleSelectionMove(s.keyCode);
              }, {
                priority: "lowest"
              });
            }
          }, {
            key: "destroy",
            value: function destroy() {
              _superPropGet(y, "destroy", this, 3)([]), this._fireSelectionChangeDoneDebounced.cancel();
            }
          }, {
            key: "_handleSelectionMove",
            value: function _handleSelectionMove(e) {
              var t = this.document.selection,
                s = new u.Z(t.getRanges(), {
                  backward: t.isBackward,
                  fake: !1
                });
              e != b.Do.arrowleft && e != b.Do.arrowup || s.setTo(s.getFirstPosition()), e != b.Do.arrowright && e != b.Do.arrowdown || s.setTo(s.getLastPosition());
              var o = {
                oldSelection: t,
                newSelection: s,
                domSelection: null
              };
              this.document.fire("selectionChange", o), this._fireSelectionChangeDoneDebounced(o);
            }
          }]);
          return y;
        }(g.Z);
        var Z = /*#__PURE__*/function (_g$Z3) {
          _inherits(Z, _g$Z3);
          function Z(e) {
            var _this11;
            _classCallCheck(this, Z);
            _this11 = _possibleConstructorReturn(this, _getPrototypeOf(Z).call(this, e)), _this11.mutationObserver = e.getObserver(k), _this11.selection = _this11.document.selection, _this11.domConverter = e.domConverter, _this11._documents = new WeakSet(), _this11._fireSelectionChangeDoneDebounced = (0, v.Z)(function (e) {
              return _this11.document.fire("selectionChangeDone", e);
            }, 200), _this11._clearInfiniteLoopInterval = setInterval(function () {
              return _this11._clearInfiniteLoop();
            }, 1e3), _this11._documentIsSelectingInactivityTimeoutDebounced = (0, v.Z)(function () {
              return _this11.document.isSelecting = !1;
            }, 5e3), _this11._loopbackCounter = 0;
            return _this11;
          }
          _createClass(Z, [{
            key: "observe",
            value: function observe(e) {
              var _this12 = this;
              var t = e.ownerDocument,
                s = function s() {
                  _this12.document.isSelecting = !1, _this12._documentIsSelectingInactivityTimeoutDebounced.cancel();
                };
              this.listenTo(e, "selectstart", function () {
                _this12.document.isSelecting = !0, _this12._documentIsSelectingInactivityTimeoutDebounced();
              }, {
                priority: "highest"
              }), this.listenTo(e, "keydown", s, {
                priority: "highest"
              }), this.listenTo(e, "keyup", s, {
                priority: "highest"
              }), this._documents.has(t) || (this.listenTo(t, "mouseup", s, {
                priority: "highest"
              }), this.listenTo(t, "selectionchange", function (e, s) {
                _this12._handleSelectionChange(s, t), _this12._documentIsSelectingInactivityTimeoutDebounced();
              }), this._documents.add(t));
            }
          }, {
            key: "destroy",
            value: function destroy() {
              _superPropGet(Z, "destroy", this, 3)([]), clearInterval(this._clearInfiniteLoopInterval), this._fireSelectionChangeDoneDebounced.cancel(), this._documentIsSelectingInactivityTimeoutDebounced.cancel();
            }
          }, {
            key: "_handleSelectionChange",
            value: function _handleSelectionChange(e, t) {
              if (!this.isEnabled) return;
              var s = t.defaultView.getSelection();
              if (this.checkShouldIgnoreEventFromTarget(s.anchorNode)) return;
              this.mutationObserver.flush();
              var o = this.domConverter.domSelectionToView(s);
              if (0 != o.rangeCount) {
                if (this.view.hasDomSelection = !0, !(this.selection.isEqual(o) && this.domConverter.isDomSelectionCorrect(s) || ++this._loopbackCounter > 60)) if (this.selection.isSimilar(o)) this.view.forceRender();else {
                  var _e25 = {
                    oldSelection: this.selection,
                    newSelection: o,
                    domSelection: s
                  };
                  this.document.fire("selectionChange", _e25), this._fireSelectionChangeDoneDebounced(_e25);
                }
              } else this.view.hasDomSelection = !1;
            }
          }, {
            key: "_clearInfiniteLoop",
            value: function _clearInfiniteLoop() {
              this._loopbackCounter = 0;
            }
          }]);
          return Z;
        }(g.Z);
        var P = /*#__PURE__*/function (_$Z2) {
          _inherits(P, _$Z2);
          function P(e) {
            var _this13;
            _classCallCheck(this, P);
            _this13 = _possibleConstructorReturn(this, _getPrototypeOf(P).call(this, e)), _this13.domEventType = ["focus", "blur"], _this13.useCapture = !0;
            var t = _this13.document;
            t.on("focus", function () {
              t.isFocused = !0, _this13._renderTimeoutId = setTimeout(function () {
                return e.change(function () {});
              }, 50);
            }), t.on("blur", function (s, o) {
              var i = t.selection.editableElement;
              null !== i && i !== o.target || (t.isFocused = !1, e.change(function () {}));
            });
            return _this13;
          }
          _createClass(P, [{
            key: "onDomEvent",
            value: function onDomEvent(e) {
              this.fire(e.type, e);
            }
          }, {
            key: "destroy",
            value: function destroy() {
              this._renderTimeoutId && clearTimeout(this._renderTimeoutId), _superPropGet(P, "destroy", this, 3)([]);
            }
          }]);
          return P;
        }(_.Z);
        var j = /*#__PURE__*/function (_$Z3) {
          _inherits(j, _$Z3);
          function j(e) {
            var _this14;
            _classCallCheck(this, j);
            _this14 = _possibleConstructorReturn(this, _getPrototypeOf(j).call(this, e)), _this14.domEventType = ["compositionstart", "compositionupdate", "compositionend"];
            var t = _this14.document;
            t.on("compositionstart", function () {
              t.isComposing = !0;
            }), t.on("compositionend", function () {
              t.isComposing = !1;
            });
            return _this14;
          }
          _createClass(j, [{
            key: "onDomEvent",
            value: function onDomEvent(e) {
              this.fire(e.type, e);
            }
          }]);
          return j;
        }(_.Z);
        var x = /*#__PURE__*/function (_$Z4) {
          _inherits(x, _$Z4);
          function x(e) {
            var _this15;
            _classCallCheck(this, x);
            _this15 = _possibleConstructorReturn(this, _getPrototypeOf(x).call(this, e)), _this15.domEventType = ["beforeinput"];
            return _this15;
          }
          _createClass(x, [{
            key: "onDomEvent",
            value: function onDomEvent(e) {
              this.fire(e.type, e);
            }
          }]);
          return x;
        }(_.Z);
        var A = s("./packages/ckeditor5-engine/src/view/observer/bubblingeventinfo.js"),
          T = s("./packages/ckeditor5-utils/src/index.js");
        var C = /*#__PURE__*/function (_g$Z4) {
          _inherits(C, _g$Z4);
          function C(e) {
            var _this16;
            _classCallCheck(this, C);
            _this16 = _possibleConstructorReturn(this, _getPrototypeOf(C).call(this, e)), _this16.document.on("keydown", function (e, t) {
              if (_this16.isEnabled && (0, T.dj)(t.keyCode)) {
                var _s11 = new A.Z(_this16.document, "arrowKey", _this16.document.selection.getFirstRange());
                _this16.document.fire(_s11, t), _s11.stop.called && e.stop();
              }
            });
            return _this16;
          }
          _createClass(C, [{
            key: "observe",
            value: function observe() {}
          }]);
          return C;
        }(g.Z);
        var E = s("./packages/ckeditor5-utils/src/observablemixin.js"),
          S = s("./packages/ckeditor5-utils/src/mix.js"),
          R = s("./packages/ckeditor5-utils/src/dom/isrange.js"),
          O = s("./packages/ckeditor5-utils/src/dom/rect.js"),
          M = s("./packages/ckeditor5-utils/src/dom/istext.js");
        function N(_ref5) {
          var e = _ref5.target,
            _ref5$viewportOffset = _ref5.viewportOffset,
            t = _ref5$viewportOffset === void 0 ? 0 : _ref5$viewportOffset;
          var s = L(e);
          var o = s,
            i = null;
          for (; o;) {
            var _r3 = void 0;
            _r3 = W(o == s ? e : i), z(_r3, function () {
              return q(e, o);
            });
            var _n = q(e, o);
            if (I(o, _n, t), o.parent != o) {
              if (i = o.frameElement, o = o.parent, !i) return;
            } else o = null;
          }
        }
        function I(e, t, s) {
          var o = t.clone().moveBy(0, s),
            i = t.clone().moveBy(0, -s),
            r = new O.Z(e).excludeScrollbarsAndBorders();
          if (![i, o].every(function (e) {
            return r.contains(e);
          })) {
            var _n2 = e.scrollX,
              _a = e.scrollY;
            D(i, r) ? _a -= r.top - t.top + s : V(o, r) && (_a += t.bottom - r.bottom + s), B(t, r) ? _n2 -= r.left - t.left + s : F(t, r) && (_n2 += t.right - r.right + s), e.scrollTo(_n2, _a);
          }
        }
        function z(e, t) {
          var s = L(e);
          var o, i;
          for (; e != s.document.body;) i = t(), o = new O.Z(e).excludeScrollbarsAndBorders(), o.contains(i) || (D(i, o) ? e.scrollTop -= o.top - i.top : V(i, o) && (e.scrollTop += i.bottom - o.bottom), B(i, o) ? e.scrollLeft -= o.left - i.left : F(i, o) && (e.scrollLeft += i.right - o.right)), e = e.parentNode;
        }
        function V(e, t) {
          return e.bottom > t.bottom;
        }
        function D(e, t) {
          return e.top < t.top;
        }
        function B(e, t) {
          return e.left < t.left;
        }
        function F(e, t) {
          return e.right > t.right;
        }
        function L(e) {
          return (0, R.Z)(e) ? e.startContainer.ownerDocument.defaultView : e.ownerDocument.defaultView;
        }
        function W(e) {
          if ((0, R.Z)(e)) {
            var _t15 = e.commonAncestorContainer;
            return (0, M.Z)(_t15) && (_t15 = _t15.parentNode), _t15;
          }
          return e.parentNode;
        }
        function q(e, t) {
          var s = L(e),
            o = new O.Z(e);
          if (s === t) return o;
          {
            var _e26 = s;
            for (; _e26 != t;) {
              var _t16 = _e26.frameElement,
                _s12 = new O.Z(_t16).excludeScrollbarsAndBorders();
              o.moveBy(_s12.left, _s12.top), _e26 = _e26.parent;
            }
          }
          return o;
        }
        Object.assign({}, {
          scrollViewportToShowTarget: N,
          scrollAncestorsToShowTarget: function scrollAncestorsToShowTarget(e) {
            z(W(e), function () {
              return new O.Z(e);
            });
          }
        });
        var H = s("./packages/ckeditor5-engine/src/view/uielement.js"),
          $ = s("./packages/ckeditor5-utils/src/ckeditorerror.js"),
          U = s("./packages/ckeditor5-utils/src/env.js");
        var K = /*#__PURE__*/function () {
          function K(e) {
            var _this17 = this;
            _classCallCheck(this, K);
            this.document = new n.Z(e), this.domConverter = new l.Z(this.document), this.domRoots = new Map(), this.set("isRenderingInProgress", !1), this.set("hasDomSelection", !1), this._renderer = new c.Z(this.domConverter, this.document.selection), this._renderer.bind("isFocused", "isSelecting").to(this.document), this._initialDomRootAttributes = new WeakMap(), this._observers = new Map(), this._ongoingChange = !1, this._postFixersInProgress = !1, this._renderingDisabled = !1, this._hasChangedSinceTheLastRendering = !1, this._writer = new a.Z(this.document), this.addObserver(k), this.addObserver(Z), this.addObserver(P), this.addObserver(w), this.addObserver(y), this.addObserver(j), this.addObserver(C), U.ZP.isAndroid && this.addObserver(x), (0, p.mm)(this), (0, H.h)(this), this.on("render", function () {
              _this17._render(), _this17.document.fire("layoutChanged"), _this17._hasChangedSinceTheLastRendering = !1;
            }), this.listenTo(this.document.selection, "change", function () {
              _this17._hasChangedSinceTheLastRendering = !0;
            }), this.listenTo(this.document, "change:isFocused", function () {
              _this17._hasChangedSinceTheLastRendering = !0;
            });
          }
          _createClass(K, [{
            key: "attachDomRoot",
            value: function attachDomRoot(e) {
              var _this18 = this;
              var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "main";
              var s = this.document.getRoot(t);
              s._name = e.tagName.toLowerCase();
              var o = {};
              for (var _i10 = 0, _Array$from3 = Array.from(e.attributes); _i10 < _Array$from3.length; _i10++) {
                var _Array$from3$_i = _Array$from3[_i10],
                  _t17 = _Array$from3$_i.name,
                  _i11 = _Array$from3$_i.value;
                o[_t17] = _i11, "class" === _t17 ? this._writer.addClass(_i11.split(" "), s) : this._writer.setAttribute(_t17, _i11, s);
              }
              this._initialDomRootAttributes.set(e, o);
              var i = function i() {
                _this18._writer.setAttribute("contenteditable", !s.isReadOnly, s), s.isReadOnly ? _this18._writer.addClass("ck-read-only", s) : _this18._writer.removeClass("ck-read-only", s);
              };
              i(), this.domRoots.set(t, e), this.domConverter.bindElements(e, s), this._renderer.markToSync("children", s), this._renderer.markToSync("attributes", s), this._renderer.domDocuments.add(e.ownerDocument), s.on("change:children", function (e, t) {
                return _this18._renderer.markToSync("children", t);
              }), s.on("change:attributes", function (e, t) {
                return _this18._renderer.markToSync("attributes", t);
              }), s.on("change:text", function (e, t) {
                return _this18._renderer.markToSync("text", t);
              }), s.on("change:isReadOnly", function () {
                return _this18.change(i);
              }), s.on("change", function () {
                _this18._hasChangedSinceTheLastRendering = !0;
              });
              var _iterator24 = _createForOfIteratorHelper(this._observers.values()),
                _step24;
              try {
                for (_iterator24.s(); !(_step24 = _iterator24.n()).done;) {
                  var _s13 = _step24.value;
                  _s13.observe(e, t);
                }
              } catch (err) {
                _iterator24.e(err);
              } finally {
                _iterator24.f();
              }
            }
          }, {
            key: "detachDomRoot",
            value: function detachDomRoot(e) {
              var t = this.domRoots.get(e);
              Array.from(t.attributes).forEach(function (_ref6) {
                var e = _ref6.name;
                return t.removeAttribute(e);
              });
              var s = this._initialDomRootAttributes.get(t);
              for (var _e27 in s) t.setAttribute(_e27, s[_e27]);
              this.domRoots.delete(e), this.domConverter.unbindDomElement(t);
            }
          }, {
            key: "getDomRoot",
            value: function getDomRoot() {
              var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "main";
              return this.domRoots.get(e);
            }
          }, {
            key: "addObserver",
            value: function addObserver(e) {
              var t = this._observers.get(e);
              if (t) return t;
              t = new e(this), this._observers.set(e, t);
              var _iterator25 = _createForOfIteratorHelper(this.domRoots),
                _step25;
              try {
                for (_iterator25.s(); !(_step25 = _iterator25.n()).done;) {
                  var _step25$value = _slicedToArray(_step25.value, 2),
                    _e28 = _step25$value[0],
                    _s14 = _step25$value[1];
                  t.observe(_s14, _e28);
                }
              } catch (err) {
                _iterator25.e(err);
              } finally {
                _iterator25.f();
              }
              return t.enable(), t;
            }
          }, {
            key: "getObserver",
            value: function getObserver(e) {
              return this._observers.get(e);
            }
          }, {
            key: "disableObservers",
            value: function disableObservers() {
              var _iterator26 = _createForOfIteratorHelper(this._observers.values()),
                _step26;
              try {
                for (_iterator26.s(); !(_step26 = _iterator26.n()).done;) {
                  var _e29 = _step26.value;
                  _e29.disable();
                }
              } catch (err) {
                _iterator26.e(err);
              } finally {
                _iterator26.f();
              }
            }
          }, {
            key: "enableObservers",
            value: function enableObservers() {
              var _iterator27 = _createForOfIteratorHelper(this._observers.values()),
                _step27;
              try {
                for (_iterator27.s(); !(_step27 = _iterator27.n()).done;) {
                  var _e30 = _step27.value;
                  _e30.enable();
                }
              } catch (err) {
                _iterator27.e(err);
              } finally {
                _iterator27.f();
              }
            }
          }, {
            key: "scrollToTheSelection",
            value: function scrollToTheSelection() {
              var e = this.document.selection.getFirstRange();
              e && N({
                target: this.domConverter.viewRangeToDom(e),
                viewportOffset: 20
              });
            }
          }, {
            key: "focus",
            value: function focus() {
              if (!this.document.isFocused) {
                var _e31 = this.document.selection.editableElement;
                _e31 && (this.domConverter.focus(_e31), this.forceRender());
              }
            }
          }, {
            key: "change",
            value: function change(e) {
              if (this.isRenderingInProgress || this._postFixersInProgress) throw new $.ZP("cannot-change-view-tree", this);
              try {
                if (this._ongoingChange) return e(this._writer);
                this._ongoingChange = !0;
                var _t18 = e(this._writer);
                return this._ongoingChange = !1, !this._renderingDisabled && this._hasChangedSinceTheLastRendering && (this._postFixersInProgress = !0, this.document._callPostFixers(this._writer), this._postFixersInProgress = !1, this.fire("render")), _t18;
              } catch (e) {
                $.ZP.rethrowUnexpectedError(e, this);
              }
            }
          }, {
            key: "forceRender",
            value: function forceRender() {
              this._hasChangedSinceTheLastRendering = !0, this.change(function () {});
            }
          }, {
            key: "destroy",
            value: function destroy() {
              var _iterator28 = _createForOfIteratorHelper(this._observers.values()),
                _step28;
              try {
                for (_iterator28.s(); !(_step28 = _iterator28.n()).done;) {
                  var _e32 = _step28.value;
                  _e32.destroy();
                }
              } catch (err) {
                _iterator28.e(err);
              } finally {
                _iterator28.f();
              }
              this.document.destroy(), this.stopListening();
            }
          }, {
            key: "createPositionAt",
            value: function createPositionAt(e, t) {
              return d.Z._createAt(e, t);
            }
          }, {
            key: "createPositionAfter",
            value: function createPositionAfter(e) {
              return d.Z._createAfter(e);
            }
          }, {
            key: "createPositionBefore",
            value: function createPositionBefore(e) {
              return d.Z._createBefore(e);
            }
          }, {
            key: "createRange",
            value: function createRange(e, t) {
              return new h.Z(e, t);
            }
          }, {
            key: "createRangeOn",
            value: function createRangeOn(e) {
              return h.Z._createOn(e);
            }
          }, {
            key: "createRangeIn",
            value: function createRangeIn(e) {
              return h.Z._createIn(e);
            }
          }, {
            key: "createSelection",
            value: function createSelection(e, t, s) {
              return new u.Z(e, t, s);
            }
          }, {
            key: "_disableRendering",
            value: function _disableRendering(e) {
              this._renderingDisabled = e, 0 == e && this.change(function () {});
            }
          }, {
            key: "_render",
            value: function _render() {
              this.isRenderingInProgress = !0, this.disableObservers(), this._renderer.render(), this.enableObservers(), this.isRenderingInProgress = !1;
            }
          }]);
          return K;
        }();
        (0, S.Z)(K, E.Z);
        var G = s("./packages/ckeditor5-engine/src/conversion/mapper.js"),
          J = s("./packages/ckeditor5-engine/src/conversion/downcastdispatcher.js"),
          X = s("./packages/ckeditor5-engine/src/conversion/downcasthelpers.js"),
          Q = s("./packages/ckeditor5-engine/src/conversion/upcasthelpers.js");
        var Y = /*#__PURE__*/function () {
          function Y(e, t) {
            var _this19 = this;
            _classCallCheck(this, Y);
            this.model = e, this.view = new K(t), this.mapper = new G.Z(), this.downcastDispatcher = new J.Z({
              mapper: this.mapper,
              schema: e.schema
            });
            var s = this.model.document,
              o = s.selection,
              i = this.model.markers;
            this.listenTo(this.model, "_beforeChanges", function () {
              _this19.view._disableRendering(!0);
            }, {
              priority: "highest"
            }), this.listenTo(this.model, "_afterChanges", function () {
              _this19.view._disableRendering(!1);
            }, {
              priority: "lowest"
            }), this.listenTo(s, "change", function () {
              _this19.view.change(function (e) {
                _this19.downcastDispatcher.convertChanges(s.differ, i, e), _this19.downcastDispatcher.convertSelection(o, i, e);
              });
            }, {
              priority: "low"
            }), this.listenTo(this.view.document, "selectionChange", (0, Q.Fo)(this.model, this.mapper)), this.downcastDispatcher.on("insert:$text", (0, X.Om)(), {
              priority: "lowest"
            }), this.downcastDispatcher.on("insert", (0, X.o6)(), {
              priority: "lowest"
            }), this.downcastDispatcher.on("remove", (0, X.Od)(), {
              priority: "low"
            }), this.downcastDispatcher.on("selection", (0, X.iO)(), {
              priority: "high"
            }), this.downcastDispatcher.on("selection", (0, X.k3)(), {
              priority: "low"
            }), this.downcastDispatcher.on("selection", (0, X.GM)(), {
              priority: "low"
            }), this.view.document.roots.bindTo(this.model.document.roots).using(function (e) {
              if ("$graveyard" == e.rootName) return null;
              var t = new r(_this19.view.document, e.name);
              return t.rootName = e.rootName, _this19.mapper.bindElements(e, t), t;
            });
          }
          _createClass(Y, [{
            key: "destroy",
            value: function destroy() {
              this.view.destroy(), this.stopListening();
            }
          }, {
            key: "reconvertMarker",
            value: function reconvertMarker(e) {
              var _this20 = this;
              var t = "string" == typeof e ? e : e.name,
                s = this.model.markers.get(t);
              if (!s) throw new $.ZP("editingcontroller-reconvertmarker-marker-not-exist", this, {
                markerName: t
              });
              this.model.change(function () {
                _this20.model.markers._refresh(s);
              });
            }
          }, {
            key: "reconvertItem",
            value: function reconvertItem(e) {
              var _this21 = this;
              this.model.change(function () {
                _this21.model.document.differ._refreshItem(e);
              });
            }
          }]);
          return Y;
        }();
        (0, S.Z)(Y, E.Z);
      },
      "./packages/ckeditor5-engine/src/conversion/conversion.js": function _packages_ckeditor5Engine_src_conversion_conversionJs(e, t, s) {
        "use strict";

        var _marked = /*#__PURE__*/_regeneratorRuntime().mark(c),
          _marked2 = /*#__PURE__*/_regeneratorRuntime().mark(l);
        s.d(t, {
          Z: function Z() {
            return a;
          }
        });
        var o = s("./packages/ckeditor5-utils/src/ckeditorerror.js"),
          i = s("./packages/ckeditor5-engine/src/conversion/upcasthelpers.js"),
          r = s("./packages/ckeditor5-engine/src/conversion/downcasthelpers.js"),
          n = s("./packages/ckeditor5-utils/src/toarray.js");
        var a = /*#__PURE__*/function () {
          function a(e, t) {
            _classCallCheck(this, a);
            this._helpers = new Map(), this._downcast = (0, n.Z)(e), this._createConversionHelpers({
              name: "downcast",
              dispatchers: this._downcast,
              isDowncast: !0
            }), this._upcast = (0, n.Z)(t), this._createConversionHelpers({
              name: "upcast",
              dispatchers: this._upcast,
              isDowncast: !1
            });
          }
          _createClass(a, [{
            key: "addAlias",
            value: function addAlias(e, t) {
              var s = this._downcast.includes(t);
              if (!this._upcast.includes(t) && !s) throw new o.ZP("conversion-add-alias-dispatcher-not-registered", this);
              this._createConversionHelpers({
                name: e,
                dispatchers: [t],
                isDowncast: s
              });
            }
          }, {
            key: "for",
            value: function _for(e) {
              if (!this._helpers.has(e)) throw new o.ZP("conversion-for-unknown-group", this);
              return this._helpers.get(e);
            }
          }, {
            key: "elementToElement",
            value: function elementToElement(e) {
              this.for("downcast").elementToElement(e);
              var _iterator29 = _createForOfIteratorHelper(c(e)),
                _step29;
              try {
                for (_iterator29.s(); !(_step29 = _iterator29.n()).done;) {
                  var _step29$value = _step29.value,
                    _t19 = _step29$value.model,
                    _s15 = _step29$value.view;
                  this.for("upcast").elementToElement({
                    model: _t19,
                    view: _s15,
                    converterPriority: e.converterPriority
                  });
                }
              } catch (err) {
                _iterator29.e(err);
              } finally {
                _iterator29.f();
              }
            }
          }, {
            key: "attributeToElement",
            value: function attributeToElement(e) {
              this.for("downcast").attributeToElement(e);
              var _iterator30 = _createForOfIteratorHelper(c(e)),
                _step30;
              try {
                for (_iterator30.s(); !(_step30 = _iterator30.n()).done;) {
                  var _step30$value = _step30.value,
                    _t20 = _step30$value.model,
                    _s16 = _step30$value.view;
                  this.for("upcast").elementToAttribute({
                    view: _s16,
                    model: _t20,
                    converterPriority: e.converterPriority
                  });
                }
              } catch (err) {
                _iterator30.e(err);
              } finally {
                _iterator30.f();
              }
            }
          }, {
            key: "attributeToAttribute",
            value: function attributeToAttribute(e) {
              this.for("downcast").attributeToAttribute(e);
              var _iterator31 = _createForOfIteratorHelper(c(e)),
                _step31;
              try {
                for (_iterator31.s(); !(_step31 = _iterator31.n()).done;) {
                  var _step31$value = _step31.value,
                    _t21 = _step31$value.model,
                    _s17 = _step31$value.view;
                  this.for("upcast").attributeToAttribute({
                    view: _s17,
                    model: _t21
                  });
                }
              } catch (err) {
                _iterator31.e(err);
              } finally {
                _iterator31.f();
              }
            }
          }, {
            key: "_createConversionHelpers",
            value: function _createConversionHelpers(_ref7) {
              var e = _ref7.name,
                t = _ref7.dispatchers,
                s = _ref7.isDowncast;
              if (this._helpers.has(e)) throw new o.ZP("conversion-group-exists", this);
              var n = s ? new r.ZP(t) : new i.ZP(t);
              this._helpers.set(e, n);
            }
          }]);
          return a;
        }();
        function c(e) {
          var _iterator32, _step32, _t22, _s18, _o5, _i12;
          return _regeneratorRuntime().wrap(function c$(_context) {
            while (1) switch (_context.prev = _context.next) {
              case 0:
                if (!e.model.values) {
                  _context.next = 20;
                  break;
                }
                _iterator32 = _createForOfIteratorHelper(e.model.values);
                _context.prev = 2;
                _iterator32.s();
              case 4:
                if ((_step32 = _iterator32.n()).done) {
                  _context.next = 10;
                  break;
                }
                _t22 = _step32.value;
                _s18 = {
                  key: e.model.key,
                  value: _t22
                }, _o5 = e.view[_t22], _i12 = e.upcastAlso ? e.upcastAlso[_t22] : void 0;
                return _context.delegateYield(l(_s18, _o5, _i12), "t0", 8);
              case 8:
                _context.next = 4;
                break;
              case 10:
                _context.next = 15;
                break;
              case 12:
                _context.prev = 12;
                _context.t1 = _context["catch"](2);
                _iterator32.e(_context.t1);
              case 15:
                _context.prev = 15;
                _iterator32.f();
                return _context.finish(15);
              case 18:
                _context.next = 21;
                break;
              case 20:
                return _context.delegateYield(l(e.model, e.view, e.upcastAlso), "t2", 21);
              case 21:
              case "end":
                return _context.stop();
            }
          }, _marked, null, [[2, 12, 15, 18]]);
        }
        function l(e, t, s) {
          var _iterator33, _step33, _t23;
          return _regeneratorRuntime().wrap(function l$(_context2) {
            while (1) switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return {
                  model: e,
                  view: t
                };
              case 2:
                if (!s) {
                  _context2.next = 20;
                  break;
                }
                _iterator33 = _createForOfIteratorHelper((0, n.Z)(s));
                _context2.prev = 4;
                _iterator33.s();
              case 6:
                if ((_step33 = _iterator33.n()).done) {
                  _context2.next = 12;
                  break;
                }
                _t23 = _step33.value;
                _context2.next = 10;
                return {
                  model: e,
                  view: _t23
                };
              case 10:
                _context2.next = 6;
                break;
              case 12:
                _context2.next = 17;
                break;
              case 14:
                _context2.prev = 14;
                _context2.t0 = _context2["catch"](4);
                _iterator33.e(_context2.t0);
              case 17:
                _context2.prev = 17;
                _iterator33.f();
                return _context2.finish(17);
              case 20:
              case "end":
                return _context2.stop();
            }
          }, _marked2, null, [[4, 14, 17, 20]]);
        }
      },
      "./packages/ckeditor5-engine/src/conversion/conversionhelpers.js": function _packages_ckeditor5Engine_src_conversion_conversionhelpersJs(e, t, s) {
        "use strict";

        s.d(t, {
          Z: function Z() {
            return o;
          }
        });
        var o = /*#__PURE__*/function () {
          function o(e) {
            _classCallCheck(this, o);
            this._dispatchers = e;
          }
          _createClass(o, [{
            key: "add",
            value: function add(e) {
              var _iterator34 = _createForOfIteratorHelper(this._dispatchers),
                _step34;
              try {
                for (_iterator34.s(); !(_step34 = _iterator34.n()).done;) {
                  var _t24 = _step34.value;
                  e(_t24);
                }
              } catch (err) {
                _iterator34.e(err);
              } finally {
                _iterator34.f();
              }
              return this;
            }
          }]);
          return o;
        }();
      },
      "./packages/ckeditor5-engine/src/conversion/downcastdispatcher.js": function _packages_ckeditor5Engine_src_conversion_downcastdispatcherJs(e, t, s) {
        "use strict";

        s.d(t, {
          Z: function Z() {
            return d;
          }
        });
        var o = s("./packages/ckeditor5-engine/src/model/textproxy.js"),
          i = s("./packages/ckeditor5-utils/src/ckeditorerror.js");
        var r = /*#__PURE__*/function () {
          function r() {
            _classCallCheck(this, r);
            this._consumable = new Map(), this._textProxyRegistry = new Map();
          }
          _createClass(r, [{
            key: "add",
            value: function add(e, t) {
              t = n(t), e instanceof o.Z && (e = this._getSymbolForTextProxy(e)), this._consumable.has(e) || this._consumable.set(e, new Map()), this._consumable.get(e).set(t, !0);
            }
          }, {
            key: "consume",
            value: function consume(e, t) {
              return t = n(t), e instanceof o.Z && (e = this._getSymbolForTextProxy(e)), !!this.test(e, t) && (this._consumable.get(e).set(t, !1), !0);
            }
          }, {
            key: "test",
            value: function test(e, t) {
              t = n(t), e instanceof o.Z && (e = this._getSymbolForTextProxy(e));
              var s = this._consumable.get(e);
              if (void 0 === s) return null;
              var i = s.get(t);
              return void 0 === i ? null : i;
            }
          }, {
            key: "revert",
            value: function revert(e, t) {
              t = n(t), e instanceof o.Z && (e = this._getSymbolForTextProxy(e));
              var s = this.test(e, t);
              return !1 === s ? (this._consumable.get(e).set(t, !0), !0) : !0 !== s && null;
            }
          }, {
            key: "verifyAllConsumed",
            value: function verifyAllConsumed(e) {
              var t = [];
              var _iterator35 = _createForOfIteratorHelper(this._consumable),
                _step35;
              try {
                for (_iterator35.s(); !(_step35 = _iterator35.n()).done;) {
                  var _step35$value = _slicedToArray(_step35.value, 2),
                    _s19 = _step35$value[0],
                    _o6 = _step35$value[1];
                  var _iterator36 = _createForOfIteratorHelper(_o6),
                    _step36;
                  try {
                    for (_iterator36.s(); !(_step36 = _iterator36.n()).done;) {
                      var _step36$value = _slicedToArray(_step36.value, 2),
                        _i13 = _step36$value[0],
                        _r4 = _step36$value[1];
                      var _o7 = _i13.split(":")[0];
                      _r4 && e == _o7 && t.push({
                        event: _i13,
                        item: _s19.name || _s19.description
                      });
                    }
                  } catch (err) {
                    _iterator36.e(err);
                  } finally {
                    _iterator36.f();
                  }
                }
              } catch (err) {
                _iterator35.e(err);
              } finally {
                _iterator35.f();
              }
              if (t.length) throw new i.ZP("conversion-model-consumable-not-consumed", null, {
                items: t
              });
            }
          }, {
            key: "_getSymbolForTextProxy",
            value: function _getSymbolForTextProxy(e) {
              var t = null;
              var s = this._textProxyRegistry.get(e.startOffset);
              if (s) {
                var _o8 = s.get(e.endOffset);
                _o8 && (t = _o8.get(e.parent));
              }
              return t || (t = this._addSymbolForTextProxy(e)), t;
            }
          }, {
            key: "_addSymbolForTextProxy",
            value: function _addSymbolForTextProxy(e) {
              var t = e.startOffset,
                s = e.endOffset,
                o = e.parent,
                i = Symbol("$textProxy:" + e.data);
              var r, n;
              return r = this._textProxyRegistry.get(t), r || (r = new Map(), this._textProxyRegistry.set(t, r)), n = r.get(s), n || (n = new Map(), r.set(s, n)), n.set(o, i), i;
            }
          }]);
          return r;
        }();
        function n(e) {
          var t = e.split(":");
          return "insert" == t[0] ? t[0] : "addMarker" == t[0] || "removeMarker" == t[0] ? e : t.length > 1 ? t[0] + ":" + t[1] : t[0];
        }
        var a = s("./packages/ckeditor5-engine/src/model/range.js"),
          c = s("./packages/ckeditor5-utils/src/emittermixin.js"),
          l = s("./packages/ckeditor5-utils/src/mix.js");
        var d = /*#__PURE__*/function () {
          function d(e) {
            _classCallCheck(this, d);
            this._conversionApi = _objectSpread({
              dispatcher: this
            }, e), this._firedEventsMap = new WeakMap();
          }
          _createClass(d, [{
            key: "convertChanges",
            value: function convertChanges(e, t, s) {
              var o = this._createConversionApi(s, e.getRefreshedItems());
              var _iterator37 = _createForOfIteratorHelper(e.getMarkersToRemove()),
                _step37;
              try {
                for (_iterator37.s(); !(_step37 = _iterator37.n()).done;) {
                  var _t25 = _step37.value;
                  this._convertMarkerRemove(_t25.name, _t25.range, o);
                }
              } catch (err) {
                _iterator37.e(err);
              } finally {
                _iterator37.f();
              }
              var i = this._reduceChanges(e.getChanges());
              var _iterator38 = _createForOfIteratorHelper(i),
                _step38;
              try {
                for (_iterator38.s(); !(_step38 = _iterator38.n()).done;) {
                  var _e33 = _step38.value;
                  "insert" === _e33.type ? this._convertInsert(a.Z._createFromPositionAndShift(_e33.position, _e33.length), o) : "reinsert" === _e33.type ? this._convertReinsert(a.Z._createFromPositionAndShift(_e33.position, _e33.length), o) : "remove" === _e33.type ? this._convertRemove(_e33.position, _e33.length, _e33.name, o) : this._convertAttribute(_e33.range, _e33.attributeKey, _e33.attributeOldValue, _e33.attributeNewValue, o);
                }
              } catch (err) {
                _iterator38.e(err);
              } finally {
                _iterator38.f();
              }
              var _iterator39 = _createForOfIteratorHelper(o.mapper.flushUnboundMarkerNames()),
                _step39;
              try {
                for (_iterator39.s(); !(_step39 = _iterator39.n()).done;) {
                  var _e34 = _step39.value;
                  var _s20 = t.get(_e34).getRange();
                  this._convertMarkerRemove(_e34, _s20, o), this._convertMarkerAdd(_e34, _s20, o);
                }
              } catch (err) {
                _iterator39.e(err);
              } finally {
                _iterator39.f();
              }
              var _iterator40 = _createForOfIteratorHelper(e.getMarkersToAdd()),
                _step40;
              try {
                for (_iterator40.s(); !(_step40 = _iterator40.n()).done;) {
                  var _t26 = _step40.value;
                  this._convertMarkerAdd(_t26.name, _t26.range, o);
                }
              } catch (err) {
                _iterator40.e(err);
              } finally {
                _iterator40.f();
              }
              o.mapper.flushDeferredBindings(), o.consumable.verifyAllConsumed("insert");
            }
          }, {
            key: "convert",
            value: function convert(e, t, s) {
              var o = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
              var i = this._createConversionApi(s, void 0, o);
              this._convertInsert(e, i);
              var _iterator41 = _createForOfIteratorHelper(t),
                _step41;
              try {
                for (_iterator41.s(); !(_step41 = _iterator41.n()).done;) {
                  var _step41$value = _slicedToArray(_step41.value, 2),
                    _e35 = _step41$value[0],
                    _s21 = _step41$value[1];
                  this._convertMarkerAdd(_e35, _s21, i);
                }
              } catch (err) {
                _iterator41.e(err);
              } finally {
                _iterator41.f();
              }
              i.consumable.verifyAllConsumed("insert");
            }
          }, {
            key: "convertSelection",
            value: function convertSelection(e, t, s) {
              var o = Array.from(t.getMarkersAtPosition(e.getFirstPosition())),
                i = this._createConversionApi(s);
              if (this._addConsumablesForSelection(i.consumable, e, o), this.fire("selection", {
                selection: e
              }, i), e.isCollapsed) {
                var _iterator42 = _createForOfIteratorHelper(o),
                  _step42;
                try {
                  for (_iterator42.s(); !(_step42 = _iterator42.n()).done;) {
                    var _t27 = _step42.value;
                    var _s22 = _t27.getRange();
                    if (!h(e.getFirstPosition(), _t27, i.mapper)) continue;
                    var _o9 = {
                      item: e,
                      markerName: _t27.name,
                      markerRange: _s22
                    };
                    i.consumable.test(e, "addMarker:" + _t27.name) && this.fire("addMarker:" + _t27.name, _o9, i);
                  }
                } catch (err) {
                  _iterator42.e(err);
                } finally {
                  _iterator42.f();
                }
                var _iterator43 = _createForOfIteratorHelper(e.getAttributeKeys()),
                  _step43;
                try {
                  for (_iterator43.s(); !(_step43 = _iterator43.n()).done;) {
                    var _t28 = _step43.value;
                    var _s23 = {
                      item: e,
                      range: e.getFirstRange(),
                      attributeKey: _t28,
                      attributeOldValue: null,
                      attributeNewValue: e.getAttribute(_t28)
                    };
                    i.consumable.test(e, "attribute:" + _s23.attributeKey) && this.fire("attribute:" + _s23.attributeKey + ":$text", _s23, i);
                  }
                } catch (err) {
                  _iterator43.e(err);
                } finally {
                  _iterator43.f();
                }
              }
            }
          }, {
            key: "_convertInsert",
            value: function _convertInsert(e, t) {
              var s = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
              s.doNotAddConsumables || this._addConsumablesForInsert(t.consumable, Array.from(e));
              var _iterator44 = _createForOfIteratorHelper(Array.from(e.getWalker({
                  shallow: !0
                })).map(u)),
                _step44;
              try {
                for (_iterator44.s(); !(_step44 = _iterator44.n()).done;) {
                  var _s24 = _step44.value;
                  this._testAndFire("insert", _s24, t);
                }
              } catch (err) {
                _iterator44.e(err);
              } finally {
                _iterator44.f();
              }
            }
          }, {
            key: "_convertRemove",
            value: function _convertRemove(e, t, s, o) {
              this.fire("remove:" + s, {
                position: e,
                length: t
              }, o);
            }
          }, {
            key: "_convertAttribute",
            value: function _convertAttribute(e, t, s, o, i) {
              this._addConsumablesForRange(i.consumable, e, "attribute:".concat(t));
              var _iterator45 = _createForOfIteratorHelper(e),
                _step45;
              try {
                for (_iterator45.s(); !(_step45 = _iterator45.n()).done;) {
                  var _r5 = _step45.value;
                  var _e36 = {
                    item: _r5.item,
                    range: a.Z._createFromPositionAndShift(_r5.previousPosition, _r5.length),
                    attributeKey: t,
                    attributeOldValue: s,
                    attributeNewValue: o
                  };
                  this._testAndFire("attribute:".concat(t), _e36, i);
                }
              } catch (err) {
                _iterator45.e(err);
              } finally {
                _iterator45.f();
              }
            }
          }, {
            key: "_convertReinsert",
            value: function _convertReinsert(e, t) {
              var s = Array.from(e.getWalker({
                shallow: !0
              }));
              this._addConsumablesForInsert(t.consumable, s);
              var _iterator46 = _createForOfIteratorHelper(s.map(u)),
                _step46;
              try {
                for (_iterator46.s(); !(_step46 = _iterator46.n()).done;) {
                  var _e37 = _step46.value;
                  this._testAndFire("insert", _objectSpread({}, _e37, {
                    reconversion: !0
                  }), t);
                }
              } catch (err) {
                _iterator46.e(err);
              } finally {
                _iterator46.f();
              }
            }
          }, {
            key: "_convertMarkerAdd",
            value: function _convertMarkerAdd(e, t, s) {
              if ("$graveyard" == t.root.rootName) return;
              var o = "addMarker:" + e;
              if (s.consumable.add(t, o), this.fire(o, {
                markerName: e,
                markerRange: t
              }, s), s.consumable.consume(t, o)) {
                this._addConsumablesForRange(s.consumable, t, o);
                var _iterator47 = _createForOfIteratorHelper(t.getItems()),
                  _step47;
                try {
                  for (_iterator47.s(); !(_step47 = _iterator47.n()).done;) {
                    var _i14 = _step47.value;
                    if (!s.consumable.test(_i14, o)) continue;
                    var _r6 = {
                      item: _i14,
                      range: a.Z._createOn(_i14),
                      markerName: e,
                      markerRange: t
                    };
                    this.fire(o, _r6, s);
                  }
                } catch (err) {
                  _iterator47.e(err);
                } finally {
                  _iterator47.f();
                }
              }
            }
          }, {
            key: "_convertMarkerRemove",
            value: function _convertMarkerRemove(e, t, s) {
              "$graveyard" != t.root.rootName && this.fire("removeMarker:" + e, {
                markerName: e,
                markerRange: t
              }, s);
            }
          }, {
            key: "_reduceChanges",
            value: function _reduceChanges(e) {
              var t = {
                changes: e
              };
              return this.fire("reduceChanges", t), t.changes;
            }
          }, {
            key: "_addConsumablesForInsert",
            value: function _addConsumablesForInsert(e, t) {
              var _iterator48 = _createForOfIteratorHelper(t),
                _step48;
              try {
                for (_iterator48.s(); !(_step48 = _iterator48.n()).done;) {
                  var _s25 = _step48.value;
                  var _t29 = _s25.item;
                  if (null === e.test(_t29, "insert")) {
                    e.add(_t29, "insert");
                    var _iterator49 = _createForOfIteratorHelper(_t29.getAttributeKeys()),
                      _step49;
                    try {
                      for (_iterator49.s(); !(_step49 = _iterator49.n()).done;) {
                        var _s26 = _step49.value;
                        e.add(_t29, "attribute:" + _s26);
                      }
                    } catch (err) {
                      _iterator49.e(err);
                    } finally {
                      _iterator49.f();
                    }
                  }
                }
              } catch (err) {
                _iterator48.e(err);
              } finally {
                _iterator48.f();
              }
              return e;
            }
          }, {
            key: "_addConsumablesForRange",
            value: function _addConsumablesForRange(e, t, s) {
              var _iterator50 = _createForOfIteratorHelper(t.getItems()),
                _step50;
              try {
                for (_iterator50.s(); !(_step50 = _iterator50.n()).done;) {
                  var _o10 = _step50.value;
                  e.add(_o10, s);
                }
              } catch (err) {
                _iterator50.e(err);
              } finally {
                _iterator50.f();
              }
              return e;
            }
          }, {
            key: "_addConsumablesForSelection",
            value: function _addConsumablesForSelection(e, t, s) {
              e.add(t, "selection");
              var _iterator51 = _createForOfIteratorHelper(s),
                _step51;
              try {
                for (_iterator51.s(); !(_step51 = _iterator51.n()).done;) {
                  var _o11 = _step51.value;
                  e.add(t, "addMarker:" + _o11.name);
                }
              } catch (err) {
                _iterator51.e(err);
              } finally {
                _iterator51.f();
              }
              var _iterator52 = _createForOfIteratorHelper(t.getAttributeKeys()),
                _step52;
              try {
                for (_iterator52.s(); !(_step52 = _iterator52.n()).done;) {
                  var _s27 = _step52.value;
                  e.add(t, "attribute:" + _s27);
                }
              } catch (err) {
                _iterator52.e(err);
              } finally {
                _iterator52.f();
              }
              return e;
            }
          }, {
            key: "_testAndFire",
            value: function _testAndFire(e, t, s) {
              var o = function (e, t) {
                  var s = t.item.name || "$text";
                  return "".concat(e, ":").concat(s);
                }(e, t),
                i = t.item.is("$textProxy") ? s.consumable._getSymbolForTextProxy(t.item) : t.item,
                r = this._firedEventsMap.get(s),
                n = r.get(i);
              if (n) {
                if (n.has(o)) return;
                n.add(o);
              } else r.set(i, new Set([o]));
              this.fire(o, t, s);
            }
          }, {
            key: "_testAndFireAddAttributes",
            value: function _testAndFireAddAttributes(e, t) {
              var s = {
                item: e,
                range: a.Z._createOn(e)
              };
              var _iterator53 = _createForOfIteratorHelper(s.item.getAttributeKeys()),
                _step53;
              try {
                for (_iterator53.s(); !(_step53 = _iterator53.n()).done;) {
                  var _e38 = _step53.value;
                  s.attributeKey = _e38, s.attributeOldValue = null, s.attributeNewValue = s.item.getAttribute(_e38), this._testAndFire("attribute:".concat(_e38), s, t);
                }
              } catch (err) {
                _iterator53.e(err);
              } finally {
                _iterator53.f();
              }
            }
          }, {
            key: "_createConversionApi",
            value: function _createConversionApi(e) {
              var _this22 = this;
              var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new Set();
              var s = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
              var o = _objectSpread({}, this._conversionApi, {
                consumable: new r(),
                writer: e,
                options: s,
                convertItem: function convertItem(e) {
                  return _this22._convertInsert(a.Z._createOn(e), o);
                },
                convertChildren: function convertChildren(e) {
                  return _this22._convertInsert(a.Z._createIn(e), o, {
                    doNotAddConsumables: !0
                  });
                },
                convertAttributes: function convertAttributes(e) {
                  return _this22._testAndFireAddAttributes(e, o);
                },
                canReuseView: function canReuseView(e) {
                  return !t.has(o.mapper.toModelElement(e));
                }
              });
              return this._firedEventsMap.set(o, new Map()), o;
            }
          }]);
          return d;
        }();
        function h(e, t, s) {
          var o = t.getRange(),
            i = Array.from(e.getAncestors());
          i.shift(), i.reverse();
          return !i.some(function (e) {
            if (o.containsItem(e)) {
              return !!s.toViewElement(e).getCustomProperty("addHighlight");
            }
          });
        }
        function u(e) {
          return {
            item: e.item,
            range: a.Z._createFromPositionAndShift(e.previousPosition, e.length)
          };
        }
        (0, l.Z)(d, c.ZP);
      },
      "./packages/ckeditor5-engine/src/conversion/downcasthelpers.js": function _packages_ckeditor5Engine_src_conversion_downcasthelpersJs(e, t, s) {
        "use strict";

        s.d(t, {
          GM: function GM() {
            return b;
          },
          Od: function Od() {
            return m;
          },
          Om: function Om() {
            return p;
          },
          ZP: function ZP() {
            return g;
          },
          iO: function iO() {
            return w;
          },
          k3: function k3() {
            return _;
          },
          o6: function o6() {
            return f;
          }
        });
        var o = s("./packages/ckeditor5-engine/src/model/range.js"),
          i = s("./packages/ckeditor5-engine/src/model/selection.js"),
          r = s("./packages/ckeditor5-engine/src/model/element.js"),
          n = s("./packages/ckeditor5-engine/src/model/position.js"),
          a = s("./packages/ckeditor5-engine/src/view/attributeelement.js"),
          c = s("./packages/ckeditor5-engine/src/model/documentselection.js"),
          l = s("./packages/ckeditor5-engine/src/conversion/conversionhelpers.js"),
          d = s("./node_modules/lodash-es/cloneDeep.js"),
          h = s("./packages/ckeditor5-utils/src/ckeditorerror.js"),
          u = s("./packages/ckeditor5-utils/src/toarray.js");
        var g = /*#__PURE__*/function (_l$Z) {
          _inherits(g, _l$Z);
          function g() {
            _classCallCheck(this, g);
            return _possibleConstructorReturn(this, _getPrototypeOf(g).apply(this, arguments));
          }
          _createClass(g, [{
            key: "elementToElement",
            value: function elementToElement(e) {
              return this.add(function (e) {
                (e = (0, d.Z)(e)).model = y(e.model), e.view = Z(e.view, "container"), e.model.attributes.length && (e.model.children = !0);
                return function (t) {
                  t.on("insert:" + e.model.name, function (e) {
                    var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : S;
                    return function (s, o, i) {
                      if (!t(o.item, i.consumable, {
                        preflight: !0
                      })) return;
                      var r = e(o.item, i);
                      if (!r) return;
                      t(o.item, i.consumable);
                      var n = i.mapper.toViewPosition(o.range.start);
                      i.mapper.bindElements(o.item, r), i.writer.insert(n, r), i.convertAttributes(o.item), C(r, o.item.getChildren(), i, {
                        reconversion: o.reconversion
                      });
                    };
                  }(e.view, T(e.model)), {
                    priority: e.converterPriority || "normal"
                  }), (e.model.children || e.model.attributes.length) && t.on("reduceChanges", A(e.model), {
                    priority: "low"
                  });
                };
              }(e));
            }
          }, {
            key: "elementToStructure",
            value: function elementToStructure(e) {
              return this.add(function (e) {
                return (e = (0, d.Z)(e)).model = y(e.model), e.view = Z(e.view, "container"), e.model.children = !0, function (t) {
                  if (t._conversionApi.schema.checkChild(e.model.name, "$text")) throw new h.ZP("conversion-element-to-structure-disallowed-text", t, {
                    elementName: e.model.name
                  });
                  var s, o;
                  t.on("insert:" + e.model.name, (s = e.view, o = T(e.model), function (e, t, i) {
                    if (!o(t.item, i.consumable, {
                      preflight: !0
                    })) return;
                    var r = new Map();
                    i.writer._registerSlotFactory(function (e, t, s) {
                      return function (o) {
                        var i = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "children";
                        var r = o.createContainerElement("$slot");
                        var n = null;
                        if ("children" === i) n = Array.from(e.getChildren());else {
                          if ("function" != typeof i) throw new h.ZP("conversion-slot-mode-unknown", s.dispatcher, {
                            modeOrFilter: i
                          });
                          n = Array.from(e.getChildren()).filter(function (e) {
                            return i(e);
                          });
                        }
                        return t.set(r, n), r;
                      };
                    }(t.item, r, i));
                    var n = s(t.item, i);
                    if (i.writer._clearSlotFactory(), !n) return;
                    !function (e, t, s) {
                      var o = Array.from(t.values()).flat(),
                        i = new Set(o);
                      if (i.size != o.length) throw new h.ZP("conversion-slot-filter-overlap", s.dispatcher, {
                        element: e
                      });
                      if (i.size != e.childCount) throw new h.ZP("conversion-slot-filter-incomplete", s.dispatcher, {
                        element: e
                      });
                    }(t.item, r, i), o(t.item, i.consumable);
                    var a = i.mapper.toViewPosition(t.range.start);
                    i.mapper.bindElements(t.item, n), i.writer.insert(a, n), i.convertAttributes(t.item), function (e, t, s, o) {
                      s.mapper.on("modelToViewPosition", n, {
                        priority: "highest"
                      });
                      var i = null,
                        r = null;
                      var _iterator54 = _createForOfIteratorHelper(t),
                        _step54;
                      try {
                        for (_iterator54.s(); !(_step54 = _iterator54.n()).done;) {
                          var _step54$value = _slicedToArray(_step54.value, 2);
                          i = _step54$value[0];
                          r = _step54$value[1];
                          C(e, r, s, o), s.writer.move(s.writer.createRangeIn(i), s.writer.createPositionBefore(i)), s.writer.remove(i);
                        }
                      } catch (err) {
                        _iterator54.e(err);
                      } finally {
                        _iterator54.f();
                      }
                      function n(e, t) {
                        var s = t.modelPosition.nodeAfter,
                          o = r.indexOf(s);
                        o < 0 || (t.viewPosition = t.mapper.findPositionIn(i, o));
                      }
                      s.mapper.off("modelToViewPosition", n);
                    }(n, r, i, {
                      reconversion: t.reconversion
                    });
                  }), {
                    priority: e.converterPriority || "normal"
                  }), t.on("reduceChanges", A(e.model), {
                    priority: "low"
                  });
                };
              }(e));
            }
          }, {
            key: "attributeToElement",
            value: function attributeToElement(e) {
              return this.add(function (e) {
                e = (0, d.Z)(e);
                var t = "attribute:" + (e.model.key ? e.model.key : e.model);
                e.model.name && (t += ":" + e.model.name);
                if (e.model.values) {
                  var _iterator55 = _createForOfIteratorHelper(e.model.values),
                    _step55;
                  try {
                    for (_iterator55.s(); !(_step55 = _iterator55.n()).done;) {
                      var _t30 = _step55.value;
                      e.view[_t30] = Z(e.view[_t30], "attribute");
                    }
                  } catch (err) {
                    _iterator55.e(err);
                  } finally {
                    _iterator55.f();
                  }
                } else e.view = Z(e.view, "attribute");
                var s = P(e);
                return function (o) {
                  o.on(t, function (e) {
                    return function (t, s, o) {
                      if (!o.consumable.test(s.item, t.name)) return;
                      var r = e(s.attributeOldValue, o),
                        n = e(s.attributeNewValue, o);
                      if (!r && !n) return;
                      o.consumable.consume(s.item, t.name);
                      var a = o.writer,
                        l = a.document.selection;
                      if (s.item instanceof i.Z || s.item instanceof c.Z) a.wrap(l.getFirstRange(), n);else {
                        var _e39 = o.mapper.toViewRange(s.range);
                        null !== s.attributeOldValue && r && (_e39 = a.unwrap(_e39, r)), null !== s.attributeNewValue && n && a.wrap(_e39, n);
                      }
                    };
                  }(s), {
                    priority: e.converterPriority || "normal"
                  });
                };
              }(e));
            }
          }, {
            key: "attributeToAttribute",
            value: function attributeToAttribute(e) {
              return this.add(function (e) {
                e = (0, d.Z)(e);
                var t = "attribute:" + (e.model.key ? e.model.key : e.model);
                e.model.name && (t += ":" + e.model.name);
                if (e.model.values) {
                  var _iterator56 = _createForOfIteratorHelper(e.model.values),
                    _step56;
                  try {
                    for (_iterator56.s(); !(_step56 = _iterator56.n()).done;) {
                      var _t31 = _step56.value;
                      e.view[_t31] = j(e.view[_t31]);
                    }
                  } catch (err) {
                    _iterator56.e(err);
                  } finally {
                    _iterator56.f();
                  }
                } else e.view = j(e.view);
                var s = P(e);
                return function (o) {
                  var i;
                  o.on(t, (i = s, function (e, t, s) {
                    if (!s.consumable.test(t.item, e.name)) return;
                    var o = i(t.attributeOldValue, s),
                      r = i(t.attributeNewValue, s);
                    if (!o && !r) return;
                    s.consumable.consume(t.item, e.name);
                    var n = s.mapper.toViewElement(t.item),
                      a = s.writer;
                    if (!n) throw new h.ZP("conversion-attribute-to-attribute-on-text", s.dispatcher, t);
                    if (null !== t.attributeOldValue && o) if ("class" == o.key) {
                      var _e40 = (0, u.Z)(o.value);
                      var _iterator57 = _createForOfIteratorHelper(_e40),
                        _step57;
                      try {
                        for (_iterator57.s(); !(_step57 = _iterator57.n()).done;) {
                          var _t32 = _step57.value;
                          a.removeClass(_t32, n);
                        }
                      } catch (err) {
                        _iterator57.e(err);
                      } finally {
                        _iterator57.f();
                      }
                    } else if ("style" == o.key) {
                      var _e41 = Object.keys(o.value);
                      for (var _i15 = 0, _e42 = _e41; _i15 < _e42.length; _i15++) {
                        var _t33 = _e42[_i15];
                        a.removeStyle(_t33, n);
                      }
                    } else a.removeAttribute(o.key, n);
                    if (null !== t.attributeNewValue && r) if ("class" == r.key) {
                      var _e43 = (0, u.Z)(r.value);
                      var _iterator58 = _createForOfIteratorHelper(_e43),
                        _step58;
                      try {
                        for (_iterator58.s(); !(_step58 = _iterator58.n()).done;) {
                          var _t34 = _step58.value;
                          a.addClass(_t34, n);
                        }
                      } catch (err) {
                        _iterator58.e(err);
                      } finally {
                        _iterator58.f();
                      }
                    } else if ("style" == r.key) {
                      var _e44 = Object.keys(r.value);
                      for (var _i16 = 0, _e45 = _e44; _i16 < _e45.length; _i16++) {
                        var _t35 = _e45[_i16];
                        a.setStyle(_t35, r.value[_t35], n);
                      }
                    } else a.setAttribute(r.key, r.value, n);
                  }), {
                    priority: e.converterPriority || "normal"
                  });
                };
              }(e));
            }
          }, {
            key: "markerToElement",
            value: function markerToElement(e) {
              return this.add(function (e) {
                return (e = (0, d.Z)(e)).view = Z(e.view, "ui"), function (t) {
                  var s;
                  t.on("addMarker:" + e.model, (s = e.view, function (e, t, o) {
                    t.isOpening = !0;
                    var i = s(t, o);
                    t.isOpening = !1;
                    var r = s(t, o);
                    if (!i || !r) return;
                    var n = t.markerRange;
                    if (n.isCollapsed && !o.consumable.consume(n, e.name)) return;
                    var _iterator59 = _createForOfIteratorHelper(n),
                      _step59;
                    try {
                      for (_iterator59.s(); !(_step59 = _iterator59.n()).done;) {
                        var _t36 = _step59.value;
                        if (!o.consumable.consume(_t36.item, e.name)) return;
                      }
                    } catch (err) {
                      _iterator59.e(err);
                    } finally {
                      _iterator59.f();
                    }
                    var a = o.mapper,
                      c = o.writer;
                    c.insert(a.toViewPosition(n.start), i), o.mapper.bindElementToMarker(i, t.markerName), n.isCollapsed || (c.insert(a.toViewPosition(n.end), r), o.mapper.bindElementToMarker(r, t.markerName)), e.stop();
                  }), {
                    priority: e.converterPriority || "normal"
                  }), t.on("removeMarker:" + e.model, (e.view, function (e, t, s) {
                    var o = s.mapper.markerNameToElements(t.markerName);
                    if (o) {
                      var _iterator60 = _createForOfIteratorHelper(o),
                        _step60;
                      try {
                        for (_iterator60.s(); !(_step60 = _iterator60.n()).done;) {
                          var _e46 = _step60.value;
                          s.mapper.unbindElementFromMarkerName(_e46, t.markerName), s.writer.clear(s.writer.createRangeOn(_e46), _e46);
                        }
                      } catch (err) {
                        _iterator60.e(err);
                      } finally {
                        _iterator60.f();
                      }
                      s.writer.clearClonedElementsGroup(t.markerName), e.stop();
                    }
                  }), {
                    priority: e.converterPriority || "normal"
                  });
                };
              }(e));
            }
          }, {
            key: "markerToHighlight",
            value: function markerToHighlight(e) {
              return this.add(function (e) {
                return function (t) {
                  var s;
                  t.on("addMarker:" + e.model, (s = e.view, function (e, t, o) {
                    if (!t.item) return;
                    if (!(t.item instanceof i.Z || t.item instanceof c.Z || t.item.is("$textProxy"))) return;
                    var r = x(s, t, o);
                    if (!r) return;
                    if (!o.consumable.consume(t.item, e.name)) return;
                    var n = o.writer,
                      a = k(n, r),
                      l = n.document.selection;
                    if (t.item instanceof i.Z || t.item instanceof c.Z) n.wrap(l.getFirstRange(), a, l);else {
                      var _e47 = o.mapper.toViewRange(t.range),
                        _s28 = n.wrap(_e47, a);
                      var _iterator61 = _createForOfIteratorHelper(_s28.getItems()),
                        _step61;
                      try {
                        for (_iterator61.s(); !(_step61 = _iterator61.n()).done;) {
                          var _e48 = _step61.value;
                          if (_e48.is("attributeElement") && _e48.isSimilar(a)) {
                            o.mapper.bindElementToMarker(_e48, t.markerName);
                            break;
                          }
                        }
                      } catch (err) {
                        _iterator61.e(err);
                      } finally {
                        _iterator61.f();
                      }
                    }
                  }), {
                    priority: e.converterPriority || "normal"
                  }), t.on("addMarker:" + e.model, function (e) {
                    return function (t, s, i) {
                      if (!s.item) return;
                      if (!(s.item instanceof r.Z)) return;
                      var n = x(e, s, i);
                      if (!n) return;
                      if (!i.consumable.test(s.item, t.name)) return;
                      var a = i.mapper.toViewElement(s.item);
                      if (a && a.getCustomProperty("addHighlight")) {
                        i.consumable.consume(s.item, t.name);
                        var _iterator62 = _createForOfIteratorHelper(o.Z._createIn(s.item)),
                          _step62;
                        try {
                          for (_iterator62.s(); !(_step62 = _iterator62.n()).done;) {
                            var _e49 = _step62.value;
                            i.consumable.consume(_e49.item, t.name);
                          }
                        } catch (err) {
                          _iterator62.e(err);
                        } finally {
                          _iterator62.f();
                        }
                        a.getCustomProperty("addHighlight")(a, n, i.writer), i.mapper.bindElementToMarker(a, s.markerName);
                      }
                    };
                  }(e.view), {
                    priority: e.converterPriority || "normal"
                  }), t.on("removeMarker:" + e.model, function (e) {
                    return function (t, s, o) {
                      if (s.markerRange.isCollapsed) return;
                      var i = x(e, s, o);
                      if (!i) return;
                      var r = k(o.writer, i),
                        n = o.mapper.markerNameToElements(s.markerName);
                      if (n) {
                        var _iterator63 = _createForOfIteratorHelper(n),
                          _step63;
                        try {
                          for (_iterator63.s(); !(_step63 = _iterator63.n()).done;) {
                            var _e50 = _step63.value;
                            o.mapper.unbindElementFromMarkerName(_e50, s.markerName), _e50.is("attributeElement") ? o.writer.unwrap(o.writer.createRangeOn(_e50), r) : _e50.getCustomProperty("removeHighlight")(_e50, i.id, o.writer);
                          }
                        } catch (err) {
                          _iterator63.e(err);
                        } finally {
                          _iterator63.f();
                        }
                        o.writer.clearClonedElementsGroup(s.markerName), t.stop();
                      }
                    };
                  }(e.view), {
                    priority: e.converterPriority || "normal"
                  });
                };
              }(e));
            }
          }, {
            key: "markerToData",
            value: function markerToData(e) {
              return this.add(function (e) {
                var t = (e = (0, d.Z)(e)).model;
                e.view || (e.view = function (s) {
                  return {
                    group: t,
                    name: s.substr(e.model.length + 1)
                  };
                });
                return function (s) {
                  var o;
                  s.on("addMarker:" + t, (o = e.view, function (e, t, s) {
                    var i = o(t.markerName, s);
                    if (!i) return;
                    var r = t.markerRange;
                    s.consumable.consume(r, e.name) && (v(r, !1, s, t, i), v(r, !0, s, t, i), e.stop());
                  }), {
                    priority: e.converterPriority || "normal"
                  }), s.on("removeMarker:" + t, function (e) {
                    return function (t, s, o) {
                      var i = e(s.markerName, o);
                      if (!i) return;
                      var r = o.mapper.markerNameToElements(s.markerName);
                      if (r) {
                        var _iterator64 = _createForOfIteratorHelper(r),
                          _step64;
                        try {
                          for (_iterator64.s(); !(_step64 = _iterator64.n()).done;) {
                            var _e51 = _step64.value;
                            o.mapper.unbindElementFromMarkerName(_e51, s.markerName), _e51.is("containerElement") ? (n("data-".concat(i.group, "-start-before"), _e51), n("data-".concat(i.group, "-start-after"), _e51), n("data-".concat(i.group, "-end-before"), _e51), n("data-".concat(i.group, "-end-after"), _e51)) : o.writer.clear(o.writer.createRangeOn(_e51), _e51);
                          }
                        } catch (err) {
                          _iterator64.e(err);
                        } finally {
                          _iterator64.f();
                        }
                        o.writer.clearClonedElementsGroup(s.markerName), t.stop();
                      }
                      function n(e, t) {
                        if (t.hasAttribute(e)) {
                          var _s29 = new Set(t.getAttribute(e).split(","));
                          _s29.delete(i.name), 0 == _s29.size ? o.writer.removeAttribute(e, t) : o.writer.setAttribute(e, Array.from(_s29).join(","), t);
                        }
                      }
                    };
                  }(e.view), {
                    priority: e.converterPriority || "normal"
                  });
                };
              }(e));
            }
          }]);
          return g;
        }(l.Z);
        function p() {
          return function (e, t, s) {
            if (!s.consumable.consume(t.item, e.name)) return;
            var o = s.writer,
              i = s.mapper.toViewPosition(t.range.start),
              r = o.createText(t.item.data);
            o.insert(i, r);
          };
        }
        function f() {
          return function (e, t, s) {
            s.convertAttributes(t.item), t.reconversion || !t.item.is("element") || t.item.isEmpty || s.convertChildren(t.item);
          };
        }
        function m() {
          return function (e, t, s) {
            var o = s.mapper.toViewPosition(t.position),
              i = t.position.getShiftedBy(t.length),
              r = s.mapper.toViewPosition(i, {
                isPhantom: !0
              }),
              n = s.writer.createRange(o, r),
              a = s.writer.remove(n.getTrimmed());
            var _iterator65 = _createForOfIteratorHelper(s.writer.createRangeIn(a).getItems()),
              _step65;
            try {
              for (_iterator65.s(); !(_step65 = _iterator65.n()).done;) {
                var _e52 = _step65.value;
                s.mapper.unbindViewElement(_e52, {
                  defer: !0
                });
              }
            } catch (err) {
              _iterator65.e(err);
            } finally {
              _iterator65.f();
            }
          };
        }
        function k(e, t) {
          var s = e.createAttributeElement("span", t.attributes);
          return t.classes && s._addClass(t.classes), "number" == typeof t.priority && (s._priority = t.priority), s._id = t.id, s;
        }
        function _() {
          return function (e, t, s) {
            var o = t.selection;
            if (o.isCollapsed) return;
            if (!s.consumable.consume(o, "selection")) return;
            var i = [];
            var _iterator66 = _createForOfIteratorHelper(o.getRanges()),
              _step66;
            try {
              for (_iterator66.s(); !(_step66 = _iterator66.n()).done;) {
                var _e53 = _step66.value;
                var _t37 = s.mapper.toViewRange(_e53);
                i.push(_t37);
              }
            } catch (err) {
              _iterator66.e(err);
            } finally {
              _iterator66.f();
            }
            s.writer.setSelection(i, {
              backward: o.isBackward
            });
          };
        }
        function b() {
          return function (e, t, s) {
            var o = t.selection;
            if (!o.isCollapsed) return;
            if (!s.consumable.consume(o, "selection")) return;
            var i = s.writer,
              r = o.getFirstPosition(),
              n = s.mapper.toViewPosition(r),
              a = i.breakAttributes(n);
            i.setSelection(a);
          };
        }
        function w() {
          return function (e, t, s) {
            var o = s.writer,
              i = o.document.selection;
            var _iterator67 = _createForOfIteratorHelper(i.getRanges()),
              _step67;
            try {
              for (_iterator67.s(); !(_step67 = _iterator67.n()).done;) {
                var _e54 = _step67.value;
                _e54.isCollapsed && _e54.end.parent.isAttached() && s.writer.mergeAttributes(_e54.start);
              }
            } catch (err) {
              _iterator67.e(err);
            } finally {
              _iterator67.f();
            }
            o.setSelection(null);
          };
        }
        function v(e, t, s, o, i) {
          var r = t ? e.start : e.end,
            n = r.nodeAfter && r.nodeAfter.is("element") ? r.nodeAfter : null,
            a = r.nodeBefore && r.nodeBefore.is("element") ? r.nodeBefore : null;
          if (n || a) {
            var _e55, _r7;
            t && n || !t && !a ? (_e55 = n, _r7 = !0) : (_e55 = a, _r7 = !1);
            var _c = s.mapper.toViewElement(_e55);
            if (_c) return void function (e, t, s, o, i, r) {
              var n = "data-".concat(r.group, "-").concat(t ? "start" : "end", "-").concat(s ? "before" : "after"),
                a = e.hasAttribute(n) ? e.getAttribute(n).split(",") : [];
              a.unshift(r.name), o.writer.setAttribute(n, a.join(","), e), o.mapper.bindElementToMarker(e, i.markerName);
            }(_c, t, _r7, s, o, i);
          }
          !function (e, t, s, o, i) {
            var r = "".concat(i.group, "-").concat(t ? "start" : "end"),
              n = i.name ? {
                name: i.name
              } : null,
              a = s.writer.createUIElement(r, n);
            s.writer.insert(e, a), s.mapper.bindElementToMarker(a, o.markerName);
          }(s.mapper.toViewPosition(r), t, s, o, i);
        }
        function y(e) {
          return "string" == typeof e && (e = {
            name: e
          }), e.attributes ? Array.isArray(e.attributes) || (e.attributes = [e.attributes]) : e.attributes = [], e.children = !!e.children, e;
        }
        function Z(e, t) {
          return "function" == typeof e ? e : function (s, o) {
            return function (e, t, s) {
              "string" == typeof e && (e = {
                name: e
              });
              var o;
              var i = t.writer,
                r = Object.assign({}, e.attributes);
              if ("container" == s) o = i.createContainerElement(e.name, r);else if ("attribute" == s) {
                var _t38 = {
                  priority: e.priority || a.Z.DEFAULT_PRIORITY
                };
                o = i.createAttributeElement(e.name, r, _t38);
              } else o = i.createUIElement(e.name, r);
              if (e.styles) {
                var _t39 = Object.keys(e.styles);
                for (var _i17 = 0, _t40 = _t39; _i17 < _t40.length; _i17++) {
                  var _s30 = _t40[_i17];
                  i.setStyle(_s30, e.styles[_s30], o);
                }
              }
              if (e.classes) {
                var _t41 = e.classes;
                if ("string" == typeof _t41) i.addClass(_t41, o);else {
                  var _iterator68 = _createForOfIteratorHelper(_t41),
                    _step68;
                  try {
                    for (_iterator68.s(); !(_step68 = _iterator68.n()).done;) {
                      var _e56 = _step68.value;
                      i.addClass(_e56, o);
                    }
                  } catch (err) {
                    _iterator68.e(err);
                  } finally {
                    _iterator68.f();
                  }
                }
              }
              return o;
            }(e, o, t);
          };
        }
        function P(e) {
          return e.model.values ? function (t, s) {
            var o = e.view[t];
            return o ? o(t, s) : null;
          } : e.view;
        }
        function j(e) {
          return "string" == typeof e ? function (t) {
            return {
              key: e,
              value: t
            };
          } : "object" == typeof e ? e.value ? function () {
            return e;
          } : function (t) {
            return {
              key: e.key,
              value: t
            };
          } : e;
        }
        function x(e, t, s) {
          var o = "function" == typeof e ? e(t, s) : e;
          return o ? (o.priority || (o.priority = 10), o.id || (o.id = t.markerName), o) : null;
        }
        function A(e) {
          var t = function (e) {
            return function (t, s) {
              if (!t.is("element", e.name)) return !1;
              if ("attribute" == s.type) {
                if (e.attributes.includes(s.attributeKey)) return !0;
              } else if (e.children) return !0;
              return !1;
            };
          }(e);
          return function (e, s) {
            var o = [];
            s.reconvertedElements || (s.reconvertedElements = new Set());
            var _iterator69 = _createForOfIteratorHelper(s.changes),
              _step69;
            try {
              for (_iterator69.s(); !(_step69 = _iterator69.n()).done;) {
                var _e57 = _step69.value;
                var _i18 = _e57.position ? _e57.position.parent : _e57.range.start.nodeAfter;
                if (_i18 && t(_i18, _e57)) {
                  if (!s.reconvertedElements.has(_i18)) {
                    s.reconvertedElements.add(_i18);
                    var _e58 = n.ZP._createBefore(_i18);
                    o.push({
                      type: "remove",
                      name: _i18.name,
                      position: _e58,
                      length: 1
                    }, {
                      type: "reinsert",
                      name: _i18.name,
                      position: _e58,
                      length: 1
                    });
                  }
                } else o.push(_e57);
              }
            } catch (err) {
              _iterator69.e(err);
            } finally {
              _iterator69.f();
            }
            s.changes = o;
          };
        }
        function T(e) {
          return function (t, s) {
            var o = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
            var i = ["insert"];
            var _iterator70 = _createForOfIteratorHelper(e.attributes),
              _step70;
            try {
              for (_iterator70.s(); !(_step70 = _iterator70.n()).done;) {
                var _s31 = _step70.value;
                t.hasAttribute(_s31) && i.push("attribute:".concat(_s31));
              }
            } catch (err) {
              _iterator70.e(err);
            } finally {
              _iterator70.f();
            }
            return !!i.every(function (e) {
              return s.test(t, e);
            }) && (o.preflight || i.forEach(function (e) {
              return s.consume(t, e);
            }), !0);
          };
        }
        function C(e, t, s, o) {
          var _iterator71 = _createForOfIteratorHelper(t),
            _step71;
          try {
            for (_iterator71.s(); !(_step71 = _iterator71.n()).done;) {
              var _i19 = _step71.value;
              E(e.root, _i19, s, o) || s.convertItem(_i19);
            }
          } catch (err) {
            _iterator71.e(err);
          } finally {
            _iterator71.f();
          }
        }
        function E(e, t, s, o) {
          var i = s.writer,
            r = s.mapper;
          if (!o.reconversion) return !1;
          var a = r.toViewElement(t);
          return !(!a || a.root == e) && !!s.canReuseView(a) && (i.move(i.createRangeOn(a), r.toViewPosition(n.ZP._createBefore(t))), !0);
        }
        function S(e, t) {
          var _ref8 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
            s = _ref8.preflight;
          return s ? t.test(e, "insert") : t.consume(e, "insert");
        }
      },
      "./packages/ckeditor5-engine/src/conversion/mapper.js": function _packages_ckeditor5Engine_src_conversion_mapperJs(e, t, s) {
        "use strict";

        s.d(t, {
          Z: function Z() {
            return h;
          }
        });
        var o = s("./packages/ckeditor5-engine/src/model/position.js"),
          i = s("./packages/ckeditor5-engine/src/model/range.js"),
          r = s("./packages/ckeditor5-engine/src/view/position.js"),
          n = s("./packages/ckeditor5-engine/src/view/range.js"),
          a = s("./packages/ckeditor5-engine/src/view/text.js"),
          c = s("./packages/ckeditor5-utils/src/emittermixin.js"),
          l = s("./packages/ckeditor5-utils/src/ckeditorerror.js"),
          d = s("./packages/ckeditor5-utils/src/mix.js");
        var h = /*#__PURE__*/function () {
          function h() {
            var _this23 = this;
            _classCallCheck(this, h);
            this._modelToViewMapping = new WeakMap(), this._viewToModelMapping = new WeakMap(), this._viewToModelLengthCallbacks = new Map(), this._markerNameToElements = new Map(), this._elementToMarkerNames = new Map(), this._deferredBindingRemovals = new Map(), this._unboundMarkerNames = new Set(), this.on("modelToViewPosition", function (e, t) {
              if (t.viewPosition) return;
              var s = _this23._modelToViewMapping.get(t.modelPosition.parent);
              if (!s) throw new l.ZP("mapping-view-position-parent-not-found", _this23, {
                modelPosition: t.modelPosition
              });
              t.viewPosition = _this23.findPositionIn(s, t.modelPosition.offset);
            }, {
              priority: "low"
            }), this.on("viewToModelPosition", function (e, t) {
              if (t.modelPosition) return;
              var s = _this23.findMappedViewAncestor(t.viewPosition),
                i = _this23._viewToModelMapping.get(s),
                r = _this23._toModelOffset(t.viewPosition.parent, t.viewPosition.offset, s);
              t.modelPosition = o.ZP._createAt(i, r);
            }, {
              priority: "low"
            });
          }
          _createClass(h, [{
            key: "bindElements",
            value: function bindElements(e, t) {
              this._modelToViewMapping.set(e, t), this._viewToModelMapping.set(t, e);
            }
          }, {
            key: "unbindViewElement",
            value: function unbindViewElement(e) {
              var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
              var s = this.toModelElement(e);
              if (this._elementToMarkerNames.has(e)) {
                var _iterator72 = _createForOfIteratorHelper(this._elementToMarkerNames.get(e)),
                  _step72;
                try {
                  for (_iterator72.s(); !(_step72 = _iterator72.n()).done;) {
                    var _t42 = _step72.value;
                    this._unboundMarkerNames.add(_t42);
                  }
                } catch (err) {
                  _iterator72.e(err);
                } finally {
                  _iterator72.f();
                }
              }
              t.defer ? this._deferredBindingRemovals.set(e, e.root) : (this._viewToModelMapping.delete(e), this._modelToViewMapping.get(s) == e && this._modelToViewMapping.delete(s));
            }
          }, {
            key: "unbindModelElement",
            value: function unbindModelElement(e) {
              var t = this.toViewElement(e);
              this._modelToViewMapping.delete(e), this._viewToModelMapping.get(t) == e && this._viewToModelMapping.delete(t);
            }
          }, {
            key: "bindElementToMarker",
            value: function bindElementToMarker(e, t) {
              var s = this._markerNameToElements.get(t) || new Set();
              s.add(e);
              var o = this._elementToMarkerNames.get(e) || new Set();
              o.add(t), this._markerNameToElements.set(t, s), this._elementToMarkerNames.set(e, o);
            }
          }, {
            key: "unbindElementFromMarkerName",
            value: function unbindElementFromMarkerName(e, t) {
              var s = this._markerNameToElements.get(t);
              s && (s.delete(e), 0 == s.size && this._markerNameToElements.delete(t));
              var o = this._elementToMarkerNames.get(e);
              o && (o.delete(t), 0 == o.size && this._elementToMarkerNames.delete(e));
            }
          }, {
            key: "flushUnboundMarkerNames",
            value: function flushUnboundMarkerNames() {
              var e = Array.from(this._unboundMarkerNames);
              return this._unboundMarkerNames.clear(), e;
            }
          }, {
            key: "flushDeferredBindings",
            value: function flushDeferredBindings() {
              var _iterator73 = _createForOfIteratorHelper(this._deferredBindingRemovals),
                _step73;
              try {
                for (_iterator73.s(); !(_step73 = _iterator73.n()).done;) {
                  var _step73$value = _slicedToArray(_step73.value, 2),
                    _e59 = _step73$value[0],
                    _t43 = _step73$value[1];
                  _e59.root == _t43 && this.unbindViewElement(_e59);
                }
              } catch (err) {
                _iterator73.e(err);
              } finally {
                _iterator73.f();
              }
              this._deferredBindingRemovals = new Map();
            }
          }, {
            key: "clearBindings",
            value: function clearBindings() {
              this._modelToViewMapping = new WeakMap(), this._viewToModelMapping = new WeakMap(), this._markerNameToElements = new Map(), this._elementToMarkerNames = new Map(), this._unboundMarkerNames = new Set(), this._deferredBindingRemovals = new Map();
            }
          }, {
            key: "toModelElement",
            value: function toModelElement(e) {
              return this._viewToModelMapping.get(e);
            }
          }, {
            key: "toViewElement",
            value: function toViewElement(e) {
              return this._modelToViewMapping.get(e);
            }
          }, {
            key: "toModelRange",
            value: function toModelRange(e) {
              return new i.Z(this.toModelPosition(e.start), this.toModelPosition(e.end));
            }
          }, {
            key: "toViewRange",
            value: function toViewRange(e) {
              return new n.Z(this.toViewPosition(e.start), this.toViewPosition(e.end));
            }
          }, {
            key: "toModelPosition",
            value: function toModelPosition(e) {
              var t = {
                viewPosition: e,
                mapper: this
              };
              return this.fire("viewToModelPosition", t), t.modelPosition;
            }
          }, {
            key: "toViewPosition",
            value: function toViewPosition(e) {
              var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
                isPhantom: !1
              };
              var s = {
                modelPosition: e,
                mapper: this,
                isPhantom: t.isPhantom
              };
              return this.fire("modelToViewPosition", s), s.viewPosition;
            }
          }, {
            key: "markerNameToElements",
            value: function markerNameToElements(e) {
              var t = this._markerNameToElements.get(e);
              if (!t) return null;
              var s = new Set();
              var _iterator74 = _createForOfIteratorHelper(t),
                _step74;
              try {
                for (_iterator74.s(); !(_step74 = _iterator74.n()).done;) {
                  var _e60 = _step74.value;
                  if (_e60.is("attributeElement")) {
                    var _iterator75 = _createForOfIteratorHelper(_e60.getElementsWithSameId()),
                      _step75;
                    try {
                      for (_iterator75.s(); !(_step75 = _iterator75.n()).done;) {
                        var _t44 = _step75.value;
                        s.add(_t44);
                      }
                    } catch (err) {
                      _iterator75.e(err);
                    } finally {
                      _iterator75.f();
                    }
                  } else s.add(_e60);
                }
              } catch (err) {
                _iterator74.e(err);
              } finally {
                _iterator74.f();
              }
              return s;
            }
          }, {
            key: "registerViewToModelLength",
            value: function registerViewToModelLength(e, t) {
              this._viewToModelLengthCallbacks.set(e, t);
            }
          }, {
            key: "findMappedViewAncestor",
            value: function findMappedViewAncestor(e) {
              var t = e.parent;
              for (; !this._viewToModelMapping.has(t);) t = t.parent;
              return t;
            }
          }, {
            key: "_toModelOffset",
            value: function _toModelOffset(e, t, s) {
              if (s != e) {
                return this._toModelOffset(e.parent, e.index, s) + this._toModelOffset(e, t, e);
              }
              if (e.is("$text")) return t;
              var o = 0;
              for (var _s32 = 0; _s32 < t; _s32++) o += this.getModelLength(e.getChild(_s32));
              return o;
            }
          }, {
            key: "getModelLength",
            value: function getModelLength(e) {
              if (this._viewToModelLengthCallbacks.get(e.name)) {
                return this._viewToModelLengthCallbacks.get(e.name)(e);
              }
              if (this._viewToModelMapping.has(e)) return 1;
              if (e.is("$text")) return e.data.length;
              if (e.is("uiElement")) return 0;
              {
                var _t45 = 0;
                var _iterator76 = _createForOfIteratorHelper(e.getChildren()),
                  _step76;
                try {
                  for (_iterator76.s(); !(_step76 = _iterator76.n()).done;) {
                    var _s33 = _step76.value;
                    _t45 += this.getModelLength(_s33);
                  }
                } catch (err) {
                  _iterator76.e(err);
                } finally {
                  _iterator76.f();
                }
                return _t45;
              }
            }
          }, {
            key: "findPositionIn",
            value: function findPositionIn(e, t) {
              var s,
                o = 0,
                i = 0,
                n = 0;
              if (e.is("$text")) return new r.Z(e, t);
              for (; i < t;) s = e.getChild(n), o = this.getModelLength(s), i += o, n++;
              return i == t ? this._moveViewPositionToTextNode(new r.Z(e, n)) : this.findPositionIn(s, t - (i - o));
            }
          }, {
            key: "_moveViewPositionToTextNode",
            value: function _moveViewPositionToTextNode(e) {
              var t = e.nodeBefore,
                s = e.nodeAfter;
              return t instanceof a.Z ? new r.Z(t, t.data.length) : s instanceof a.Z ? new r.Z(s, 0) : e;
            }
          }]);
          return h;
        }();
        (0, d.Z)(h, c.ZP);
      },
      "./packages/ckeditor5-engine/src/conversion/upcasthelpers.js": function _packages_ckeditor5Engine_src_conversion_upcasthelpersJs(e, t, s) {
        "use strict";

        s.d(t, {
          Fo: function Fo() {
            return h;
          },
          ZP: function ZP() {
            return c;
          },
          _p: function _p() {
            return l;
          },
          s8: function s8() {
            return d;
          }
        });
        var o = s("./packages/ckeditor5-engine/src/view/matcher.js"),
          i = s("./packages/ckeditor5-engine/src/conversion/conversionhelpers.js"),
          r = s("./node_modules/lodash-es/cloneDeep.js"),
          n = s("./packages/ckeditor5-utils/src/priorities.js"),
          a = s("./packages/ckeditor5-engine/src/model/utils/autoparagraphing.js");
        var c = /*#__PURE__*/function (_i$Z) {
          _inherits(c, _i$Z);
          function c() {
            _classCallCheck(this, c);
            return _possibleConstructorReturn(this, _getPrototypeOf(c).apply(this, arguments));
          }
          _createClass(c, [{
            key: "elementToElement",
            value: function elementToElement(e) {
              return this.add(u(e));
            }
          }, {
            key: "elementToAttribute",
            value: function elementToAttribute(e) {
              return this.add(function (e) {
                f(e = (0, r.Z)(e));
                var t = m(e, !1),
                  s = g(e.view),
                  o = s ? "element:" + s : "element";
                return function (s) {
                  s.on(o, t, {
                    priority: e.converterPriority || "low"
                  });
                };
              }(e));
            }
          }, {
            key: "attributeToAttribute",
            value: function attributeToAttribute(e) {
              return this.add(function (e) {
                e = (0, r.Z)(e);
                var t = null;
                ("string" == typeof e.view || e.view.key) && (t = function (e) {
                  "string" == typeof e.view && (e.view = {
                    key: e.view
                  });
                  var t = e.view.key;
                  var s;
                  if ("class" == t || "style" == t) {
                    s = _defineProperty({}, "class" == t ? "classes" : "styles", e.view.value);
                  } else {
                    s = {
                      attributes: _defineProperty({}, t, void 0 === e.view.value ? /[\s\S]*/ : e.view.value)
                    };
                  }
                  e.view.name && (s.name = e.view.name);
                  return e.view = s, t;
                }(e));
                f(e, t);
                var s = m(e, !0);
                return function (t) {
                  t.on("element", s, {
                    priority: e.converterPriority || "low"
                  });
                };
              }(e));
            }
          }, {
            key: "elementToMarker",
            value: function elementToMarker(e) {
              return this.add(function (e) {
                return function (e) {
                  var t = e.model;
                  e.model = function (e, s) {
                    var o = "string" == typeof t ? t : t(e, s);
                    return s.writer.createElement("$marker", {
                      "data-name": o
                    });
                  };
                }(e = (0, r.Z)(e)), u(e);
              }(e));
            }
          }, {
            key: "dataToMarker",
            value: function dataToMarker(e) {
              return this.add(function (e) {
                (e = (0, r.Z)(e)).model || (e.model = function (t) {
                  return t ? e.view + ":" + t : e.view;
                });
                var t = p(k(e, "start")),
                  s = p(k(e, "end"));
                return function (o) {
                  o.on("element:" + e.view + "-start", t, {
                    priority: e.converterPriority || "normal"
                  }), o.on("element:" + e.view + "-end", s, {
                    priority: e.converterPriority || "normal"
                  });
                  var i = n.Z.get("low"),
                    r = n.Z.get("highest"),
                    a = n.Z.get(e.converterPriority) / r;
                  o.on("element", function (e) {
                    return function (t, s, o) {
                      var i = "data-".concat(e.view);
                      function r(t, i) {
                        var _iterator77 = _createForOfIteratorHelper(i),
                          _step77;
                        try {
                          for (_iterator77.s(); !(_step77 = _iterator77.n()).done;) {
                            var _r8 = _step77.value;
                            var _i20 = e.model(_r8, o),
                              _n3 = o.writer.createElement("$marker", {
                                "data-name": _i20
                              });
                            o.writer.insert(_n3, t), s.modelCursor.isEqual(t) ? s.modelCursor = s.modelCursor.getShiftedBy(1) : s.modelCursor = s.modelCursor._getTransformedByInsertion(t, 1), s.modelRange = s.modelRange._getTransformedByInsertion(t, 1)[0];
                          }
                        } catch (err) {
                          _iterator77.e(err);
                        } finally {
                          _iterator77.f();
                        }
                      }
                      (o.consumable.test(s.viewItem, {
                        attributes: i + "-end-after"
                      }) || o.consumable.test(s.viewItem, {
                        attributes: i + "-start-after"
                      }) || o.consumable.test(s.viewItem, {
                        attributes: i + "-end-before"
                      }) || o.consumable.test(s.viewItem, {
                        attributes: i + "-start-before"
                      })) && (s.modelRange || Object.assign(s, o.convertChildren(s.viewItem, s.modelCursor)), o.consumable.consume(s.viewItem, {
                        attributes: i + "-end-after"
                      }) && r(s.modelRange.end, s.viewItem.getAttribute(i + "-end-after").split(",")), o.consumable.consume(s.viewItem, {
                        attributes: i + "-start-after"
                      }) && r(s.modelRange.end, s.viewItem.getAttribute(i + "-start-after").split(",")), o.consumable.consume(s.viewItem, {
                        attributes: i + "-end-before"
                      }) && r(s.modelRange.start, s.viewItem.getAttribute(i + "-end-before").split(",")), o.consumable.consume(s.viewItem, {
                        attributes: i + "-start-before"
                      }) && r(s.modelRange.start, s.viewItem.getAttribute(i + "-start-before").split(",")));
                    };
                  }(e), {
                    priority: i + a
                  });
                };
              }(e));
            }
          }]);
          return c;
        }(i.Z);
        function l() {
          return function (e, t, s) {
            if (!t.modelRange && s.consumable.consume(t.viewItem, {
              name: !0
            })) {
              var _s$convertChildren = s.convertChildren(t.viewItem, t.modelCursor),
                _e61 = _s$convertChildren.modelRange,
                _o12 = _s$convertChildren.modelCursor;
              t.modelRange = _e61, t.modelCursor = _o12;
            }
          };
        }
        function d() {
          return function (e, t, _ref9) {
            var s = _ref9.schema,
              o = _ref9.consumable,
              i = _ref9.writer;
            var r = t.modelCursor;
            if (!o.test(t.viewItem)) return;
            if (!s.checkChild(r, "$text")) {
              if (!(0, a.gg)(r, "$text", s)) return;
              r = (0, a.zX)(r, i);
            }
            o.consume(t.viewItem);
            var n = i.createText(t.viewItem.data);
            i.insert(n, r), t.modelRange = i.createRange(r, r.getShiftedBy(n.offsetSize)), t.modelCursor = t.modelRange.end;
          };
        }
        function h(e, t) {
          return function (s, o) {
            var i = o.newSelection,
              r = [];
            var _iterator78 = _createForOfIteratorHelper(i.getRanges()),
              _step78;
            try {
              for (_iterator78.s(); !(_step78 = _iterator78.n()).done;) {
                var _e62 = _step78.value;
                r.push(t.toModelRange(_e62));
              }
            } catch (err) {
              _iterator78.e(err);
            } finally {
              _iterator78.f();
            }
            var n = e.createSelection(r, {
              backward: i.isBackward
            });
            n.isEqual(e.document.selection) || e.change(function (e) {
              e.setSelection(n);
            });
          };
        }
        function u(e) {
          var t = p(e = (0, r.Z)(e)),
            s = g(e.view),
            o = s ? "element:" + s : "element";
          return function (s) {
            s.on(o, t, {
              priority: e.converterPriority || "normal"
            });
          };
        }
        function g(e) {
          return "string" == typeof e ? e : "object" == typeof e && "string" == typeof e.name ? e.name : null;
        }
        function p(e) {
          var t = new o.Z(e.view);
          return function (s, o, i) {
            var r = t.match(o.viewItem);
            if (!r) return;
            var n = r.match;
            if (n.name = !0, !i.consumable.test(o.viewItem, n)) return;
            var a = function (e, t, s) {
              return e instanceof Function ? e(t, s) : s.writer.createElement(e);
            }(e.model, o.viewItem, i);
            a && i.safeInsert(a, o.modelCursor) && (i.consumable.consume(o.viewItem, n), i.convertChildren(o.viewItem, a), i.updateConversionResult(a, o));
          };
        }
        function f(e) {
          var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
          var s = null === t || function (e) {
              return e.getAttribute(t);
            },
            o = "object" != typeof e.model ? e.model : e.model.key,
            i = "object" != typeof e.model || void 0 === e.model.value ? s : e.model.value;
          e.model = {
            key: o,
            value: i
          };
        }
        function m(e, t) {
          var s = new o.Z(e.view);
          return function (o, i, r) {
            var n = s.match(i.viewItem);
            if (!n) return;
            if (!function (e, t) {
              var s = "function" == typeof e ? e(t) : e;
              if ("object" == typeof s && !g(s)) return !1;
              return !s.classes && !s.attributes && !s.styles;
            }(e.view, i.viewItem) ? delete n.match.name : n.match.name = !0, !r.consumable.test(i.viewItem, n.match)) return;
            var a = e.model.key,
              c = "function" == typeof e.model.value ? e.model.value(i.viewItem, r) : e.model.value;
            if (null === c) return;
            i.modelRange || Object.assign(i, r.convertChildren(i.viewItem, i.modelCursor));
            var l = function (e, t, s, o) {
              var i = !1;
              for (var _i21 = 0, _Array$from4 = Array.from(e.getItems({
                  shallow: s
                })); _i21 < _Array$from4.length; _i21++) {
                var _r9 = _Array$from4[_i21];
                o.schema.checkAttribute(_r9, t.key) && (i = !0, _r9.hasAttribute(t.key) || o.writer.setAttribute(t.key, t.value, _r9));
              }
              return i;
            }(i.modelRange, {
              key: a,
              value: c
            }, t, r);
            l && r.consumable.consume(i.viewItem, n.match);
          };
        }
        function k(e, t) {
          var s = {};
          return s.view = e.view + "-" + t, s.model = function (t, s) {
            var o = t.getAttribute("name"),
              i = e.model(o, s);
            return s.writer.createElement("$marker", {
              "data-name": i
            });
          }, s;
        }
      },
      "./packages/ckeditor5-engine/src/dataprocessor/htmldataprocessor.js": function _packages_ckeditor5Engine_src_dataprocessor_htmldataprocessorJs(e, t, s) {
        "use strict";

        s.d(t, {
          Z: function Z() {
            return r;
          }
        });
        var o = /*#__PURE__*/function () {
          function o() {
            _classCallCheck(this, o);
          }
          _createClass(o, [{
            key: "getHtml",
            value: function getHtml(e) {
              var t = document.implementation.createHTMLDocument("").createElement("div");
              return t.appendChild(e), t.innerHTML;
            }
          }]);
          return o;
        }();
        var i = s("./packages/ckeditor5-engine/src/view/domconverter.js");
        var r = /*#__PURE__*/function () {
          function r(e) {
            _classCallCheck(this, r);
            this.domParser = new DOMParser(), this.domConverter = new i.Z(e, {
              renderingMode: "data"
            }), this.htmlWriter = new o();
          }
          _createClass(r, [{
            key: "toData",
            value: function toData(e) {
              var t = this.domConverter.viewToDom(e, document);
              return this.htmlWriter.getHtml(t);
            }
          }, {
            key: "toView",
            value: function toView(e) {
              var t = this._toDom(e);
              return this.domConverter.domToView(t);
            }
          }, {
            key: "registerRawContentMatcher",
            value: function registerRawContentMatcher(e) {
              this.domConverter.registerRawContentMatcher(e);
            }
          }, {
            key: "useFillerType",
            value: function useFillerType(e) {
              this.domConverter.blockFillerMode = "marked" == e ? "markedNbsp" : "nbsp";
            }
          }, {
            key: "_toDom",
            value: function _toDom(e) {
              e.match(/<(?:html|body|head|meta)(?:\s[^>]*)?>/i) || (e = "<body>".concat(e, "</body>"));
              var t = this.domParser.parseFromString(e, "text/html"),
                s = t.createDocumentFragment(),
                o = t.body.childNodes;
              for (; o.length > 0;) s.appendChild(o[0]);
              return s;
            }
          }]);
          return r;
        }();
      },
      "./packages/ckeditor5-engine/src/model/documentfragment.js": function _packages_ckeditor5Engine_src_model_documentfragmentJs(e, t, s) {
        "use strict";

        s.d(t, {
          Z: function Z() {
            return c;
          }
        });
        var o = s("./packages/ckeditor5-engine/src/model/nodelist.js"),
          i = s("./packages/ckeditor5-engine/src/model/element.js"),
          r = s("./packages/ckeditor5-engine/src/model/text.js"),
          n = s("./packages/ckeditor5-engine/src/model/textproxy.js"),
          a = s("./packages/ckeditor5-utils/src/isiterable.js");
        var c = /*#__PURE__*/function () {
          function c(e) {
            _classCallCheck(this, c);
            this.markers = new Map(), this._children = new o.Z(), e && this._insertChild(0, e);
          }
          _createClass(c, [{
            key: Symbol.iterator,
            value: function value() {
              return this.getChildren();
            }
          }, {
            key: "is",
            value: function is(e) {
              return "documentFragment" === e || "model:documentFragment" === e;
            }
          }, {
            key: "getChild",
            value: function getChild(e) {
              return this._children.getNode(e);
            }
          }, {
            key: "getChildren",
            value: function getChildren() {
              return this._children[Symbol.iterator]();
            }
          }, {
            key: "getChildIndex",
            value: function getChildIndex(e) {
              return this._children.getNodeIndex(e);
            }
          }, {
            key: "getChildStartOffset",
            value: function getChildStartOffset(e) {
              return this._children.getNodeStartOffset(e);
            }
          }, {
            key: "getPath",
            value: function getPath() {
              return [];
            }
          }, {
            key: "getNodeByPath",
            value: function getNodeByPath(e) {
              var t = this;
              var _iterator79 = _createForOfIteratorHelper(e),
                _step79;
              try {
                for (_iterator79.s(); !(_step79 = _iterator79.n()).done;) {
                  var _s35 = _step79.value;
                  t = t.getChild(t.offsetToIndex(_s35));
                }
              } catch (err) {
                _iterator79.e(err);
              } finally {
                _iterator79.f();
              }
              return t;
            }
          }, {
            key: "offsetToIndex",
            value: function offsetToIndex(e) {
              return this._children.offsetToIndex(e);
            }
          }, {
            key: "toJSON",
            value: function toJSON() {
              var e = [];
              var _iterator80 = _createForOfIteratorHelper(this._children),
                _step80;
              try {
                for (_iterator80.s(); !(_step80 = _iterator80.n()).done;) {
                  var _t46 = _step80.value;
                  e.push(_t46.toJSON());
                }
              } catch (err) {
                _iterator80.e(err);
              } finally {
                _iterator80.f();
              }
              return e;
            }
          }, {
            key: "_appendChild",
            value: function _appendChild(e) {
              this._insertChild(this.childCount, e);
            }
          }, {
            key: "_insertChild",
            value: function _insertChild(e, t) {
              var s = function (e) {
                if ("string" == typeof e) return [new r.Z(e)];
                (0, a.Z)(e) || (e = [e]);
                return Array.from(e).map(function (e) {
                  return "string" == typeof e ? new r.Z(e) : e instanceof n.Z ? new r.Z(e.data, e.getAttributes()) : e;
                });
              }(t);
              var _iterator81 = _createForOfIteratorHelper(s),
                _step81;
              try {
                for (_iterator81.s(); !(_step81 = _iterator81.n()).done;) {
                  var _e63 = _step81.value;
                  null !== _e63.parent && _e63._remove(), _e63.parent = this;
                }
              } catch (err) {
                _iterator81.e(err);
              } finally {
                _iterator81.f();
              }
              this._children._insertNodes(e, s);
            }
          }, {
            key: "_removeChildren",
            value: function _removeChildren(e) {
              var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
              var s = this._children._removeNodes(e, t);
              var _iterator82 = _createForOfIteratorHelper(s),
                _step82;
              try {
                for (_iterator82.s(); !(_step82 = _iterator82.n()).done;) {
                  var _e64 = _step82.value;
                  _e64.parent = null;
                }
              } catch (err) {
                _iterator82.e(err);
              } finally {
                _iterator82.f();
              }
              return s;
            }
          }, {
            key: "childCount",
            get: function get() {
              return this._children.length;
            }
          }, {
            key: "maxOffset",
            get: function get() {
              return this._children.maxOffset;
            }
          }, {
            key: "isEmpty",
            get: function get() {
              return 0 === this.childCount;
            }
          }, {
            key: "root",
            get: function get() {
              return this;
            }
          }, {
            key: "parent",
            get: function get() {
              return null;
            }
          }], [{
            key: "fromJSON",
            value: function fromJSON(e) {
              var t = [];
              var _iterator83 = _createForOfIteratorHelper(e),
                _step83;
              try {
                for (_iterator83.s(); !(_step83 = _iterator83.n()).done;) {
                  var _s36 = _step83.value;
                  _s36.name ? t.push(i.Z.fromJSON(_s36)) : t.push(r.Z.fromJSON(_s36));
                }
              } catch (err) {
                _iterator83.e(err);
              } finally {
                _iterator83.f();
              }
              return new c(t);
            }
          }]);
          return c;
        }();
      },
      "./packages/ckeditor5-engine/src/model/documentselection.js": function _packages_ckeditor5Engine_src_model_documentselectionJs(e, t, s) {
        "use strict";

        s.d(t, {
          Z: function Z() {
            return p;
          }
        });
        var o = s("./packages/ckeditor5-utils/src/mix.js"),
          i = s("./packages/ckeditor5-utils/src/emittermixin.js"),
          r = s("./packages/ckeditor5-engine/src/model/selection.js"),
          n = s("./packages/ckeditor5-engine/src/model/liverange.js"),
          a = s("./packages/ckeditor5-engine/src/model/text.js"),
          c = s("./packages/ckeditor5-engine/src/model/textproxy.js"),
          l = s("./packages/ckeditor5-utils/src/tomap.js"),
          d = s("./packages/ckeditor5-utils/src/collection.js"),
          h = s("./packages/ckeditor5-utils/src/ckeditorerror.js"),
          u = s("./packages/ckeditor5-utils/src/uid.js");
        var g = "selection:";
        var p = /*#__PURE__*/function () {
          function p(e) {
            _classCallCheck(this, p);
            this._selection = new f(e), this._selection.delegate("change:range").to(this), this._selection.delegate("change:attribute").to(this), this._selection.delegate("change:marker").to(this);
          }
          _createClass(p, [{
            key: "getRanges",
            value: function getRanges() {
              return this._selection.getRanges();
            }
          }, {
            key: "getFirstPosition",
            value: function getFirstPosition() {
              return this._selection.getFirstPosition();
            }
          }, {
            key: "getLastPosition",
            value: function getLastPosition() {
              return this._selection.getLastPosition();
            }
          }, {
            key: "getFirstRange",
            value: function getFirstRange() {
              return this._selection.getFirstRange();
            }
          }, {
            key: "getLastRange",
            value: function getLastRange() {
              return this._selection.getLastRange();
            }
          }, {
            key: "getSelectedBlocks",
            value: function getSelectedBlocks() {
              return this._selection.getSelectedBlocks();
            }
          }, {
            key: "getSelectedElement",
            value: function getSelectedElement() {
              return this._selection.getSelectedElement();
            }
          }, {
            key: "containsEntireContent",
            value: function containsEntireContent(e) {
              return this._selection.containsEntireContent(e);
            }
          }, {
            key: "destroy",
            value: function destroy() {
              this._selection.destroy();
            }
          }, {
            key: "getAttributeKeys",
            value: function getAttributeKeys() {
              return this._selection.getAttributeKeys();
            }
          }, {
            key: "getAttributes",
            value: function getAttributes() {
              return this._selection.getAttributes();
            }
          }, {
            key: "getAttribute",
            value: function getAttribute(e) {
              return this._selection.getAttribute(e);
            }
          }, {
            key: "hasAttribute",
            value: function hasAttribute(e) {
              return this._selection.hasAttribute(e);
            }
          }, {
            key: "refresh",
            value: function refresh() {
              this._selection._updateMarkers(), this._selection._updateAttributes(!1);
            }
          }, {
            key: "observeMarkers",
            value: function observeMarkers(e) {
              this._selection.observeMarkers(e);
            }
          }, {
            key: "is",
            value: function is(e) {
              return "selection" === e || "model:selection" == e || "documentSelection" == e || "model:documentSelection" == e;
            }
          }, {
            key: "_setFocus",
            value: function _setFocus(e, t) {
              this._selection.setFocus(e, t);
            }
          }, {
            key: "_setTo",
            value: function _setTo(e, t, s) {
              this._selection.setTo(e, t, s);
            }
          }, {
            key: "_setAttribute",
            value: function _setAttribute(e, t) {
              this._selection.setAttribute(e, t);
            }
          }, {
            key: "_removeAttribute",
            value: function _removeAttribute(e) {
              this._selection.removeAttribute(e);
            }
          }, {
            key: "_getStoredAttributes",
            value: function _getStoredAttributes() {
              return this._selection._getStoredAttributes();
            }
          }, {
            key: "_overrideGravity",
            value: function _overrideGravity() {
              return this._selection.overrideGravity();
            }
          }, {
            key: "_restoreGravity",
            value: function _restoreGravity(e) {
              this._selection.restoreGravity(e);
            }
          }, {
            key: "isCollapsed",
            get: function get() {
              return this._selection.isCollapsed;
            }
          }, {
            key: "anchor",
            get: function get() {
              return this._selection.anchor;
            }
          }, {
            key: "focus",
            get: function get() {
              return this._selection.focus;
            }
          }, {
            key: "rangeCount",
            get: function get() {
              return this._selection.rangeCount;
            }
          }, {
            key: "hasOwnRange",
            get: function get() {
              return this._selection.hasOwnRange;
            }
          }, {
            key: "isBackward",
            get: function get() {
              return this._selection.isBackward;
            }
          }, {
            key: "isGravityOverridden",
            get: function get() {
              return this._selection.isGravityOverridden;
            }
          }, {
            key: "markers",
            get: function get() {
              return this._selection.markers;
            }
          }, {
            key: "_ranges",
            get: function get() {
              return this._selection._ranges;
            }
          }], [{
            key: "_getStoreAttributeKey",
            value: function _getStoreAttributeKey(e) {
              return g + e;
            }
          }, {
            key: "_isStoreAttributeKey",
            value: function _isStoreAttributeKey(e) {
              return e.startsWith(g);
            }
          }]);
          return p;
        }();
        (0, o.Z)(p, i.ZP);
        var f = /*#__PURE__*/function (_r$Z) {
          _inherits(f, _r$Z);
          function f(e) {
            var _this24;
            _classCallCheck(this, f);
            _this24 = _possibleConstructorReturn(this, _getPrototypeOf(f).call(this)), _this24.markers = new d.Z({
              idProperty: "name"
            }), _this24._model = e.model, _this24._document = e, _this24._attributePriority = new Map(), _this24._selectionRestorePosition = null, _this24._hasChangedRange = !1, _this24._overriddenGravityRegister = new Set(), _this24._observedMarkers = new Set(), _this24.listenTo(_this24._model, "applyOperation", function (e, t) {
              var s = t[0];
              s.isDocumentOperation && "marker" != s.type && "rename" != s.type && "noop" != s.type && (0 == _this24._ranges.length && _this24._selectionRestorePosition && _this24._fixGraveyardSelection(_this24._selectionRestorePosition), _this24._selectionRestorePosition = null, _this24._hasChangedRange && (_this24._hasChangedRange = !1, _this24.fire("change:range", {
                directChange: !1
              })));
            }, {
              priority: "lowest"
            }), _this24.on("change:range", function () {
              var _iterator84 = _createForOfIteratorHelper(_this24.getRanges()),
                _step84;
              try {
                for (_iterator84.s(); !(_step84 = _iterator84.n()).done;) {
                  var _e65 = _step84.value;
                  if (!_this24._document._validateSelectionRange(_e65)) throw new h.ZP("document-selection-wrong-position", _assertThisInitialized(_assertThisInitialized(_this24)), {
                    range: _e65
                  });
                }
              } catch (err) {
                _iterator84.e(err);
              } finally {
                _iterator84.f();
              }
            }), _this24.listenTo(_this24._model.markers, "update", function (e, t, s, o) {
              _this24._updateMarker(t, o);
            }), _this24.listenTo(_this24._document, "change", function (e, t) {
              !function (e, t) {
                var s = e.document.differ;
                var _iterator85 = _createForOfIteratorHelper(s.getChanges()),
                  _step85;
                try {
                  var _loop = function _loop() {
                    var o = _step85.value;
                    if ("insert" != o.type) return 1; // continue
                    var s = o.position.parent;
                    o.length === s.maxOffset && e.enqueueChange(t, function (e) {
                      var t = Array.from(s.getAttributeKeys()).filter(function (e) {
                        return e.startsWith(g);
                      });
                      var _iterator86 = _createForOfIteratorHelper(t),
                        _step86;
                      try {
                        for (_iterator86.s(); !(_step86 = _iterator86.n()).done;) {
                          var _o13 = _step86.value;
                          e.removeAttribute(_o13, s);
                        }
                      } catch (err) {
                        _iterator86.e(err);
                      } finally {
                        _iterator86.f();
                      }
                    });
                  };
                  for (_iterator85.s(); !(_step85 = _iterator85.n()).done;) {
                    if (_loop()) continue;
                  }
                } catch (err) {
                  _iterator85.e(err);
                } finally {
                  _iterator85.f();
                }
              }(_this24._model, t);
            });
            return _this24;
          }
          _createClass(f, [{
            key: "destroy",
            value: function destroy() {
              for (var _e66 = 0; _e66 < this._ranges.length; _e66++) this._ranges[_e66].detach();
              this.stopListening();
            }
          }, {
            key: "getRanges",
            value: /*#__PURE__*/_regeneratorRuntime().mark(function getRanges() {
              return _regeneratorRuntime().wrap(function getRanges$(_context3) {
                while (1) switch (_context3.prev = _context3.next) {
                  case 0:
                    if (!this._ranges.length) {
                      _context3.next = 4;
                      break;
                    }
                    return _context3.delegateYield(_superPropGet(f, "getRanges", this, 3)([]), "t0", 2);
                  case 2:
                    _context3.next = 6;
                    break;
                  case 4:
                    _context3.next = 6;
                    return this._document._getDefaultRange();
                  case 6:
                  case "end":
                    return _context3.stop();
                }
              }, getRanges, this);
            })
          }, {
            key: "getFirstRange",
            value: function getFirstRange() {
              return _superPropGet(f, "getFirstRange", this, 3)([]) || this._document._getDefaultRange();
            }
          }, {
            key: "getLastRange",
            value: function getLastRange() {
              return _superPropGet(f, "getLastRange", this, 3)([]) || this._document._getDefaultRange();
            }
          }, {
            key: "setTo",
            value: function setTo(e, t, s) {
              _superPropGet(f, "setTo", this, 3)([e, t, s]), this._updateAttributes(!0), this._updateMarkers();
            }
          }, {
            key: "setFocus",
            value: function setFocus(e, t) {
              _superPropGet(f, "setFocus", this, 3)([e, t]), this._updateAttributes(!0), this._updateMarkers();
            }
          }, {
            key: "setAttribute",
            value: function setAttribute(e, t) {
              if (this._setAttribute(e, t)) {
                var _t47 = [e];
                this.fire("change:attribute", {
                  attributeKeys: _t47,
                  directChange: !0
                });
              }
            }
          }, {
            key: "removeAttribute",
            value: function removeAttribute(e) {
              if (this._removeAttribute(e)) {
                var _t48 = [e];
                this.fire("change:attribute", {
                  attributeKeys: _t48,
                  directChange: !0
                });
              }
            }
          }, {
            key: "overrideGravity",
            value: function overrideGravity() {
              var e = (0, u.Z)();
              return this._overriddenGravityRegister.add(e), 1 === this._overriddenGravityRegister.size && this._updateAttributes(!0), e;
            }
          }, {
            key: "restoreGravity",
            value: function restoreGravity(e) {
              if (!this._overriddenGravityRegister.has(e)) throw new h.ZP("document-selection-gravity-wrong-restore", this, {
                uid: e
              });
              this._overriddenGravityRegister.delete(e), this.isGravityOverridden || this._updateAttributes(!0);
            }
          }, {
            key: "observeMarkers",
            value: function observeMarkers(e) {
              this._observedMarkers.add(e), this._updateMarkers();
            }
          }, {
            key: "_popRange",
            value: function _popRange() {
              this._ranges.pop().detach();
            }
          }, {
            key: "_pushRange",
            value: function _pushRange(e) {
              var t = this._prepareRange(e);
              t && this._ranges.push(t);
            }
          }, {
            key: "_prepareRange",
            value: function _prepareRange(e) {
              var _this25 = this;
              if (this._checkRange(e), e.root == this._document.graveyard) return;
              var t = n.Z.fromRange(e);
              return t.on("change:range", function (e, s, o) {
                if (_this25._hasChangedRange = !0, t.root == _this25._document.graveyard) {
                  _this25._selectionRestorePosition = o.deletionPosition;
                  var _e67 = _this25._ranges.indexOf(t);
                  _this25._ranges.splice(_e67, 1), t.detach();
                }
              }), t;
            }
          }, {
            key: "_updateMarkers",
            value: function _updateMarkers() {
              if (!this._observedMarkers.size) return;
              var e = [];
              var t = !1;
              var _iterator87 = _createForOfIteratorHelper(this._model.markers),
                _step87;
              try {
                for (_iterator87.s(); !(_step87 = _iterator87.n()).done;) {
                  var _t49 = _step87.value;
                  var _s39 = _t49.name.split(":", 1)[0];
                  if (!this._observedMarkers.has(_s39)) continue;
                  var _o14 = _t49.getRange();
                  var _iterator88 = _createForOfIteratorHelper(this.getRanges()),
                    _step88;
                  try {
                    for (_iterator88.s(); !(_step88 = _iterator88.n()).done;) {
                      var _s40 = _step88.value;
                      _o14.containsRange(_s40, !_s40.isCollapsed) && e.push(_t49);
                    }
                  } catch (err) {
                    _iterator88.e(err);
                  } finally {
                    _iterator88.f();
                  }
                }
              } catch (err) {
                _iterator87.e(err);
              } finally {
                _iterator87.f();
              }
              var s = Array.from(this.markers);
              for (var _i22 = 0, _e68 = e; _i22 < _e68.length; _i22++) {
                var _s37 = _e68[_i22];
                this.markers.has(_s37) || (this.markers.add(_s37), t = !0);
              }
              for (var _i23 = 0, _Array$from5 = Array.from(this.markers); _i23 < _Array$from5.length; _i23++) {
                var _s38 = _Array$from5[_i23];
                e.includes(_s38) || (this.markers.remove(_s38), t = !0);
              }
              t && this.fire("change:marker", {
                oldMarkers: s,
                directChange: !1
              });
            }
          }, {
            key: "_updateMarker",
            value: function _updateMarker(e, t) {
              var s = e.name.split(":", 1)[0];
              if (!this._observedMarkers.has(s)) return;
              var o = !1;
              var i = Array.from(this.markers),
                r = this.markers.has(e);
              if (t) {
                var _s41 = !1;
                var _iterator89 = _createForOfIteratorHelper(this.getRanges()),
                  _step89;
                try {
                  for (_iterator89.s(); !(_step89 = _iterator89.n()).done;) {
                    var _e69 = _step89.value;
                    if (t.containsRange(_e69, !_e69.isCollapsed)) {
                      _s41 = !0;
                      break;
                    }
                  }
                } catch (err) {
                  _iterator89.e(err);
                } finally {
                  _iterator89.f();
                }
                _s41 && !r ? (this.markers.add(e), o = !0) : !_s41 && r && (this.markers.remove(e), o = !0);
              } else r && (this.markers.remove(e), o = !0);
              o && this.fire("change:marker", {
                oldMarkers: i,
                directChange: !1
              });
            }
          }, {
            key: "_updateAttributes",
            value: function _updateAttributes(e) {
              var t = (0, l.Z)(this._getSurroundingAttributes()),
                s = (0, l.Z)(this.getAttributes());
              if (e) this._attributePriority = new Map(), this._attrs = new Map();else {
                var _iterator90 = _createForOfIteratorHelper(this._attributePriority),
                  _step90;
                try {
                  for (_iterator90.s(); !(_step90 = _iterator90.n()).done;) {
                    var _step90$value = _slicedToArray(_step90.value, 2),
                      _e70 = _step90$value[0],
                      _t50 = _step90$value[1];
                    "low" == _t50 && (this._attrs.delete(_e70), this._attributePriority.delete(_e70));
                  }
                } catch (err) {
                  _iterator90.e(err);
                } finally {
                  _iterator90.f();
                }
              }
              this._setAttributesTo(t);
              var o = [];
              var _iterator91 = _createForOfIteratorHelper(this.getAttributes()),
                _step91;
              try {
                for (_iterator91.s(); !(_step91 = _iterator91.n()).done;) {
                  var _step91$value = _slicedToArray(_step91.value, 2),
                    _e71 = _step91$value[0],
                    _t51 = _step91$value[1];
                  s.has(_e71) && s.get(_e71) === _t51 || o.push(_e71);
                }
              } catch (err) {
                _iterator91.e(err);
              } finally {
                _iterator91.f();
              }
              var _iterator92 = _createForOfIteratorHelper(s),
                _step92;
              try {
                for (_iterator92.s(); !(_step92 = _iterator92.n()).done;) {
                  var _step92$value = _slicedToArray(_step92.value, 1),
                    _e72 = _step92$value[0];
                  this.hasAttribute(_e72) || o.push(_e72);
                }
              } catch (err) {
                _iterator92.e(err);
              } finally {
                _iterator92.f();
              }
              o.length > 0 && this.fire("change:attribute", {
                attributeKeys: o,
                directChange: !1
              });
            }
          }, {
            key: "_setAttribute",
            value: function _setAttribute(e, t) {
              var s = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : !0;
              var o = s ? "normal" : "low";
              if ("low" == o && "normal" == this._attributePriority.get(e)) return !1;
              return _superPropGet(f, "getAttribute", this, 3)([e]) !== t && (this._attrs.set(e, t), this._attributePriority.set(e, o), !0);
            }
          }, {
            key: "_removeAttribute",
            value: function _removeAttribute(e) {
              var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !0;
              var s = t ? "normal" : "low";
              return ("low" != s || "normal" != this._attributePriority.get(e)) && (this._attributePriority.set(e, s), !!_superPropGet(f, "hasAttribute", this, 3)([e]) && (this._attrs.delete(e), !0));
            }
          }, {
            key: "_setAttributesTo",
            value: function _setAttributesTo(e) {
              var t = new Set();
              var _iterator93 = _createForOfIteratorHelper(this.getAttributes()),
                _step93;
              try {
                for (_iterator93.s(); !(_step93 = _iterator93.n()).done;) {
                  var _step93$value = _slicedToArray(_step93.value, 2),
                    _t52 = _step93$value[0],
                    _s42 = _step93$value[1];
                  e.get(_t52) !== _s42 && this._removeAttribute(_t52, !1);
                }
              } catch (err) {
                _iterator93.e(err);
              } finally {
                _iterator93.f();
              }
              var _iterator94 = _createForOfIteratorHelper(e),
                _step94;
              try {
                for (_iterator94.s(); !(_step94 = _iterator94.n()).done;) {
                  var _step94$value = _slicedToArray(_step94.value, 2),
                    _s43 = _step94$value[0],
                    _o15 = _step94$value[1];
                  this._setAttribute(_s43, _o15, !1) && t.add(_s43);
                }
              } catch (err) {
                _iterator94.e(err);
              } finally {
                _iterator94.f();
              }
              return t;
            }
          }, {
            key: "_getStoredAttributes",
            value: /*#__PURE__*/_regeneratorRuntime().mark(function _getStoredAttributes() {
              var e, _iterator95, _step95, _t53, _s44;
              return _regeneratorRuntime().wrap(function _getStoredAttributes$(_context4) {
                while (1) switch (_context4.prev = _context4.next) {
                  case 0:
                    e = this.getFirstPosition().parent;
                    if (!(this.isCollapsed && e.isEmpty)) {
                      _context4.next = 21;
                      break;
                    }
                    _iterator95 = _createForOfIteratorHelper(e.getAttributeKeys());
                    _context4.prev = 3;
                    _iterator95.s();
                  case 5:
                    if ((_step95 = _iterator95.n()).done) {
                      _context4.next = 13;
                      break;
                    }
                    _t53 = _step95.value;
                    if (!_t53.startsWith(g)) {
                      _context4.next = 11;
                      break;
                    }
                    _s44 = _t53.substr(g.length);
                    _context4.next = 11;
                    return [_s44, e.getAttribute(_t53)];
                  case 11:
                    _context4.next = 5;
                    break;
                  case 13:
                    _context4.next = 18;
                    break;
                  case 15:
                    _context4.prev = 15;
                    _context4.t0 = _context4["catch"](3);
                    _iterator95.e(_context4.t0);
                  case 18:
                    _context4.prev = 18;
                    _iterator95.f();
                    return _context4.finish(18);
                  case 21:
                  case "end":
                    return _context4.stop();
                }
              }, _getStoredAttributes, this, [[3, 15, 18, 21]]);
            })
          }, {
            key: "_getSurroundingAttributes",
            value: function _getSurroundingAttributes() {
              var e = this.getFirstPosition(),
                t = this._model.schema;
              var s = null;
              if (this.isCollapsed) {
                var _o16 = e.textNode ? e.textNode : e.nodeBefore,
                  _i24 = e.textNode ? e.textNode : e.nodeAfter;
                if (this.isGravityOverridden || (s = m(_o16)), s || (s = m(_i24)), !this.isGravityOverridden && !s) {
                  var _e73 = _o16;
                  for (; _e73 && !t.isInline(_e73) && !s;) _e73 = _e73.previousSibling, s = m(_e73);
                }
                if (!s) {
                  var _e74 = _i24;
                  for (; _e74 && !t.isInline(_e74) && !s;) _e74 = _e74.nextSibling, s = m(_e74);
                }
                s || (s = this._getStoredAttributes());
              } else {
                var _e75 = this.getFirstRange();
                var _iterator96 = _createForOfIteratorHelper(_e75),
                  _step96;
                try {
                  for (_iterator96.s(); !(_step96 = _iterator96.n()).done;) {
                    var _o17 = _step96.value;
                    if (_o17.item.is("element") && t.isObject(_o17.item)) break;
                    if ("text" == _o17.type) {
                      s = _o17.item.getAttributes();
                      break;
                    }
                  }
                } catch (err) {
                  _iterator96.e(err);
                } finally {
                  _iterator96.f();
                }
              }
              return s;
            }
          }, {
            key: "_fixGraveyardSelection",
            value: function _fixGraveyardSelection(e) {
              var t = this._model.schema.getNearestSelectionRange(e);
              t && this._pushRange(t);
            }
          }, {
            key: "isCollapsed",
            get: function get() {
              return 0 === this._ranges.length ? this._document._getDefaultRange().isCollapsed : _superPropGet(f, "isCollapsed", this, 1);
            }
          }, {
            key: "anchor",
            get: function get() {
              return _superPropGet(f, "anchor", this, 1) || this._document._getDefaultRange().start;
            }
          }, {
            key: "focus",
            get: function get() {
              return _superPropGet(f, "focus", this, 1) || this._document._getDefaultRange().end;
            }
          }, {
            key: "rangeCount",
            get: function get() {
              return this._ranges.length ? this._ranges.length : 1;
            }
          }, {
            key: "hasOwnRange",
            get: function get() {
              return this._ranges.length > 0;
            }
          }, {
            key: "isGravityOverridden",
            get: function get() {
              return !!this._overriddenGravityRegister.size;
            }
          }]);
          return f;
        }(r.Z);
        function m(e) {
          return e instanceof c.Z || e instanceof a.Z ? e.getAttributes() : null;
        }
      },
      "./packages/ckeditor5-engine/src/model/element.js": function _packages_ckeditor5Engine_src_model_elementJs(e, t, s) {
        "use strict";

        s.d(t, {
          Z: function Z() {
            return c;
          }
        });
        var o = s("./packages/ckeditor5-engine/src/model/node.js"),
          i = s("./packages/ckeditor5-engine/src/model/nodelist.js"),
          r = s("./packages/ckeditor5-engine/src/model/text.js"),
          n = s("./packages/ckeditor5-engine/src/model/textproxy.js"),
          a = s("./packages/ckeditor5-utils/src/isiterable.js");
        var c = /*#__PURE__*/function (_o$Z3) {
          _inherits(c, _o$Z3);
          function c(e, t, s) {
            var _this26;
            _classCallCheck(this, c);
            _this26 = _possibleConstructorReturn(this, _getPrototypeOf(c).call(this, t)), _this26.name = e, _this26._children = new i.Z(), s && _this26._insertChild(0, s);
            return _this26;
          }
          _createClass(c, [{
            key: "is",
            value: function is(e) {
              var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
              return t ? t === this.name && ("element" === e || "model:element" === e) : "element" === e || "model:element" === e || "node" === e || "model:node" === e;
            }
          }, {
            key: "getChild",
            value: function getChild(e) {
              return this._children.getNode(e);
            }
          }, {
            key: "getChildren",
            value: function getChildren() {
              return this._children[Symbol.iterator]();
            }
          }, {
            key: "getChildIndex",
            value: function getChildIndex(e) {
              return this._children.getNodeIndex(e);
            }
          }, {
            key: "getChildStartOffset",
            value: function getChildStartOffset(e) {
              return this._children.getNodeStartOffset(e);
            }
          }, {
            key: "offsetToIndex",
            value: function offsetToIndex(e) {
              return this._children.offsetToIndex(e);
            }
          }, {
            key: "getNodeByPath",
            value: function getNodeByPath(e) {
              var t = this;
              var _iterator97 = _createForOfIteratorHelper(e),
                _step97;
              try {
                for (_iterator97.s(); !(_step97 = _iterator97.n()).done;) {
                  var _s45 = _step97.value;
                  t = t.getChild(t.offsetToIndex(_s45));
                }
              } catch (err) {
                _iterator97.e(err);
              } finally {
                _iterator97.f();
              }
              return t;
            }
          }, {
            key: "findAncestor",
            value: function findAncestor(e) {
              var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
                includeSelf: !1
              };
              var s = t.includeSelf ? this : this.parent;
              for (; s;) {
                if (s.name === e) return s;
                s = s.parent;
              }
              return null;
            }
          }, {
            key: "toJSON",
            value: function toJSON() {
              var e = _superPropGet(c, "toJSON", this, 3)([]);
              if (e.name = this.name, this._children.length > 0) {
                e.children = [];
                var _iterator98 = _createForOfIteratorHelper(this._children),
                  _step98;
                try {
                  for (_iterator98.s(); !(_step98 = _iterator98.n()).done;) {
                    var _t54 = _step98.value;
                    e.children.push(_t54.toJSON());
                  }
                } catch (err) {
                  _iterator98.e(err);
                } finally {
                  _iterator98.f();
                }
              }
              return e;
            }
          }, {
            key: "_clone",
            value: function _clone() {
              var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !1;
              var t = e ? Array.from(this._children).map(function (e) {
                return e._clone(!0);
              }) : null;
              return new c(this.name, this.getAttributes(), t);
            }
          }, {
            key: "_appendChild",
            value: function _appendChild(e) {
              this._insertChild(this.childCount, e);
            }
          }, {
            key: "_insertChild",
            value: function _insertChild(e, t) {
              var s = function (e) {
                if ("string" == typeof e) return [new r.Z(e)];
                (0, a.Z)(e) || (e = [e]);
                return Array.from(e).map(function (e) {
                  return "string" == typeof e ? new r.Z(e) : e instanceof n.Z ? new r.Z(e.data, e.getAttributes()) : e;
                });
              }(t);
              var _iterator99 = _createForOfIteratorHelper(s),
                _step99;
              try {
                for (_iterator99.s(); !(_step99 = _iterator99.n()).done;) {
                  var _e76 = _step99.value;
                  null !== _e76.parent && _e76._remove(), _e76.parent = this;
                }
              } catch (err) {
                _iterator99.e(err);
              } finally {
                _iterator99.f();
              }
              this._children._insertNodes(e, s);
            }
          }, {
            key: "_removeChildren",
            value: function _removeChildren(e) {
              var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
              var s = this._children._removeNodes(e, t);
              var _iterator100 = _createForOfIteratorHelper(s),
                _step100;
              try {
                for (_iterator100.s(); !(_step100 = _iterator100.n()).done;) {
                  var _e77 = _step100.value;
                  _e77.parent = null;
                }
              } catch (err) {
                _iterator100.e(err);
              } finally {
                _iterator100.f();
              }
              return s;
            }
          }, {
            key: "childCount",
            get: function get() {
              return this._children.length;
            }
          }, {
            key: "maxOffset",
            get: function get() {
              return this._children.maxOffset;
            }
          }, {
            key: "isEmpty",
            get: function get() {
              return 0 === this.childCount;
            }
          }], [{
            key: "fromJSON",
            value: function fromJSON(e) {
              var t = null;
              if (e.children) {
                t = [];
                var _iterator101 = _createForOfIteratorHelper(e.children),
                  _step101;
                try {
                  for (_iterator101.s(); !(_step101 = _iterator101.n()).done;) {
                    var _s46 = _step101.value;
                    _s46.name ? t.push(c.fromJSON(_s46)) : t.push(r.Z.fromJSON(_s46));
                  }
                } catch (err) {
                  _iterator101.e(err);
                } finally {
                  _iterator101.f();
                }
              }
              return new c(e.name, e.attributes, t);
            }
          }]);
          return c;
        }(o.Z);
      },
      "./packages/ckeditor5-engine/src/model/history.js": function _packages_ckeditor5Engine_src_model_historyJs(e, t, s) {
        "use strict";

        s.d(t, {
          Z: function Z() {
            return o;
          }
        });
        var o = /*#__PURE__*/function () {
          function o() {
            _classCallCheck(this, o);
            this._operations = [], this._undoPairs = new Map(), this._undoneOperations = new Set();
          }
          _createClass(o, [{
            key: "addOperation",
            value: function addOperation(e) {
              this._operations.includes(e) || this._operations.push(e);
            }
          }, {
            key: "getOperations",
            value: function getOperations() {
              var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : Number.NEGATIVE_INFINITY;
              var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : Number.POSITIVE_INFINITY;
              var s = [];
              var _iterator102 = _createForOfIteratorHelper(this._operations),
                _step102;
              try {
                for (_iterator102.s(); !(_step102 = _iterator102.n()).done;) {
                  var _o18 = _step102.value;
                  _o18.baseVersion >= e && _o18.baseVersion < t && s.push(_o18);
                }
              } catch (err) {
                _iterator102.e(err);
              } finally {
                _iterator102.f();
              }
              return s;
            }
          }, {
            key: "getOperation",
            value: function getOperation(e) {
              var _iterator103 = _createForOfIteratorHelper(this._operations),
                _step103;
              try {
                for (_iterator103.s(); !(_step103 = _iterator103.n()).done;) {
                  var _t55 = _step103.value;
                  if (_t55.baseVersion == e) return _t55;
                }
              } catch (err) {
                _iterator103.e(err);
              } finally {
                _iterator103.f();
              }
            }
          }, {
            key: "setOperationAsUndone",
            value: function setOperationAsUndone(e, t) {
              this._undoPairs.set(t, e), this._undoneOperations.add(e);
            }
          }, {
            key: "isUndoingOperation",
            value: function isUndoingOperation(e) {
              return this._undoPairs.has(e);
            }
          }, {
            key: "isUndoneOperation",
            value: function isUndoneOperation(e) {
              return this._undoneOperations.has(e);
            }
          }, {
            key: "getUndoneOperation",
            value: function getUndoneOperation(e) {
              return this._undoPairs.get(e);
            }
          }]);
          return o;
        }();
      },
      "./packages/ckeditor5-engine/src/model/liveposition.js": function _packages_ckeditor5Engine_src_model_livepositionJs(e, t, s) {
        "use strict";

        s.d(t, {
          Z: function Z() {
            return a;
          }
        });
        var o = s("./packages/ckeditor5-engine/src/model/position.js"),
          i = s("./packages/ckeditor5-utils/src/emittermixin.js"),
          r = s("./packages/ckeditor5-utils/src/mix.js"),
          n = s("./packages/ckeditor5-utils/src/ckeditorerror.js");
        var a = /*#__PURE__*/function (_o$ZP) {
          _inherits(a, _o$ZP);
          function a(e, t) {
            var _this27;
            var s = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "toNone";
            _classCallCheck(this, a);
            if (_this27 = _possibleConstructorReturn(this, _getPrototypeOf(a).call(this, e, t, s)), !_this27.root.is("rootElement")) throw new n.ZP("model-liveposition-root-not-rootelement", e);
            c.call(_assertThisInitialized(_assertThisInitialized(_this27)));
            return _possibleConstructorReturn(_this27);
          }
          _createClass(a, [{
            key: "detach",
            value: function detach() {
              this.stopListening();
            }
          }, {
            key: "is",
            value: function is(e) {
              return "livePosition" === e || "model:livePosition" === e || "position" == e || "model:position" === e;
            }
          }, {
            key: "toPosition",
            value: function toPosition() {
              return new o.ZP(this.root, this.path.slice(), this.stickiness);
            }
          }], [{
            key: "fromPosition",
            value: function fromPosition(e, t) {
              return new this(e.root, e.path.slice(), t || e.stickiness);
            }
          }]);
          return a;
        }(o.ZP);
        function c() {
          var _this28 = this;
          this.listenTo(this.root.document.model, "applyOperation", function (e, t) {
            var s = t[0];
            s.isDocumentOperation && l.call(_this28, s);
          }, {
            priority: "low"
          });
        }
        function l(e) {
          var t = this.getTransformedByOperation(e);
          if (!this.isEqual(t)) {
            var _e78 = this.toPosition();
            this.path = t.path, this.root = t.root, this.fire("change", _e78);
          }
        }
        (0, r.Z)(a, i.ZP);
      },
      "./packages/ckeditor5-engine/src/model/liverange.js": function _packages_ckeditor5Engine_src_model_liverangeJs(e, t, s) {
        "use strict";

        s.d(t, {
          Z: function Z() {
            return n;
          }
        });
        var o = s("./packages/ckeditor5-engine/src/model/range.js"),
          i = s("./packages/ckeditor5-utils/src/emittermixin.js"),
          r = s("./packages/ckeditor5-utils/src/mix.js");
        var n = /*#__PURE__*/function (_o$Z4) {
          _inherits(n, _o$Z4);
          function n(e, t) {
            var _this29;
            _classCallCheck(this, n);
            _this29 = _possibleConstructorReturn(this, _getPrototypeOf(n).call(this, e, t)), a.call(_assertThisInitialized(_assertThisInitialized(_this29)));
            return _this29;
          }
          _createClass(n, [{
            key: "detach",
            value: function detach() {
              this.stopListening();
            }
          }, {
            key: "is",
            value: function is(e) {
              return "liveRange" === e || "model:liveRange" === e || "range" == e || "model:range" === e;
            }
          }, {
            key: "toRange",
            value: function toRange() {
              return new o.Z(this.start, this.end);
            }
          }], [{
            key: "fromRange",
            value: function fromRange(e) {
              return new n(e.start, e.end);
            }
          }]);
          return n;
        }(o.Z);
        function a() {
          var _this30 = this;
          this.listenTo(this.root.document.model, "applyOperation", function (e, t) {
            var s = t[0];
            s.isDocumentOperation && c.call(_this30, s);
          }, {
            priority: "low"
          });
        }
        function c(e) {
          var t = this.getTransformedByOperation(e),
            s = o.Z._createFromRanges(t),
            i = !s.isEqual(this),
            r = function (e, t) {
              switch (t.type) {
                case "insert":
                  return e.containsPosition(t.position);
                case "move":
                case "remove":
                case "reinsert":
                case "merge":
                  return e.containsPosition(t.sourcePosition) || e.start.isEqual(t.sourcePosition) || e.containsPosition(t.targetPosition);
                case "split":
                  return e.containsPosition(t.splitPosition) || e.containsPosition(t.insertionPosition);
              }
              return !1;
            }(this, e);
          var n = null;
          if (i) {
            "$graveyard" == s.root.rootName && (n = "remove" == e.type ? e.sourcePosition : e.deletionPosition);
            var _t56 = this.toRange();
            this.start = s.start, this.end = s.end, this.fire("change:range", _t56, {
              deletionPosition: n
            });
          } else r && this.fire("change:content", this.toRange(), {
            deletionPosition: n
          });
        }
        (0, r.Z)(n, i.ZP);
      },
      "./packages/ckeditor5-engine/src/model/model.js": function _packages_ckeditor5Engine_src_model_modelJs(e, t, s) {
        "use strict";

        s.d(t, {
          Z: function Z() {
            return be;
          }
        });
        var o = s("./packages/ckeditor5-utils/src/ckeditorerror.js");
        var i = /*#__PURE__*/function () {
          function i() {
            var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
            _classCallCheck(this, i);
            "string" == typeof e && (e = "transparent" === e ? {
              isUndoable: !1
            } : {}, (0, o.KE)("batch-constructor-deprecated-string-type"));
            var _e79 = e,
              _e79$isUndoable = _e79.isUndoable,
              t = _e79$isUndoable === void 0 ? !0 : _e79$isUndoable,
              _e79$isLocal = _e79.isLocal,
              s = _e79$isLocal === void 0 ? !0 : _e79$isLocal,
              _e79$isUndo = _e79.isUndo,
              _i25 = _e79$isUndo === void 0 ? !1 : _e79$isUndo,
              _e79$isTyping = _e79.isTyping,
              r = _e79$isTyping === void 0 ? !1 : _e79$isTyping;
            this.operations = [], this.isUndoable = t, this.isLocal = s, this.isUndo = _i25, this.isTyping = r;
          }
          _createClass(i, [{
            key: "addOperation",
            value: function addOperation(e) {
              return e.batch = this, this.operations.push(e), e;
            }
          }, {
            key: "type",
            get: function get() {
              return (0, o.KE)("batch-type-deprecated"), "default";
            }
          }, {
            key: "baseVersion",
            get: function get() {
              var _iterator104 = _createForOfIteratorHelper(this.operations),
                _step104;
              try {
                for (_iterator104.s(); !(_step104 = _iterator104.n()).done;) {
                  var _e80 = _step104.value;
                  if (null !== _e80.baseVersion) return _e80.baseVersion;
                }
              } catch (err) {
                _iterator104.e(err);
              } finally {
                _iterator104.f();
              }
              return null;
            }
          }]);
          return i;
        }();
        var r = s("./packages/ckeditor5-engine/src/model/operation/attributeoperation.js"),
          n = s("./packages/ckeditor5-engine/src/model/operation/operation.js"),
          a = s("./packages/ckeditor5-engine/src/model/range.js"),
          c = s("./packages/ckeditor5-engine/src/model/operation/utils.js");
        var l = /*#__PURE__*/function (_n$Z) {
          _inherits(l, _n$Z);
          function l(e, t) {
            var _this31;
            _classCallCheck(this, l);
            _this31 = _possibleConstructorReturn(this, _getPrototypeOf(l).call(this, null)), _this31.sourcePosition = e.clone(), _this31.howMany = t;
            return _this31;
          }
          _createClass(l, [{
            key: "toJSON",
            value: function toJSON() {
              var e = _superPropGet(l, "toJSON", this, 3)([]);
              return e.sourcePosition = this.sourcePosition.toJSON(), e;
            }
          }, {
            key: "_validate",
            value: function _validate() {
              if (this.sourcePosition.root.document) throw new o.ZP("detach-operation-on-document-node", this);
            }
          }, {
            key: "_execute",
            value: function _execute() {
              (0, c.X9)(a.Z._createFromPositionAndShift(this.sourcePosition, this.howMany));
            }
          }, {
            key: "type",
            get: function get() {
              return "detach";
            }
          }], [{
            key: "className",
            get: function get() {
              return "DetachOperation";
            }
          }]);
          return l;
        }(n.Z);
        var d = s("./packages/ckeditor5-engine/src/model/operation/insertoperation.js"),
          h = s("./packages/ckeditor5-engine/src/model/operation/markeroperation.js"),
          u = s("./packages/ckeditor5-engine/src/model/operation/moveoperation.js"),
          g = s("./packages/ckeditor5-engine/src/model/operation/renameoperation.js"),
          p = s("./packages/ckeditor5-engine/src/model/operation/rootattributeoperation.js"),
          f = s("./packages/ckeditor5-engine/src/model/operation/splitoperation.js"),
          m = s("./packages/ckeditor5-engine/src/model/operation/mergeoperation.js"),
          k = s("./packages/ckeditor5-engine/src/model/documentfragment.js"),
          _ = s("./packages/ckeditor5-engine/src/model/text.js"),
          b = s("./packages/ckeditor5-engine/src/model/element.js");
        var w = /*#__PURE__*/function (_b$Z) {
          _inherits(w, _b$Z);
          function w(e, t) {
            var _this32;
            var s = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "main";
            _classCallCheck(this, w);
            _this32 = _possibleConstructorReturn(this, _getPrototypeOf(w).call(this, t)), _this32._document = e, _this32.rootName = s;
            return _this32;
          }
          _createClass(w, [{
            key: "is",
            value: function is(e, t) {
              return t ? t === this.name && ("rootElement" === e || "model:rootElement" === e || "element" === e || "model:element" === e) : "rootElement" === e || "model:rootElement" === e || "element" === e || "model:element" === e || "node" === e || "model:node" === e;
            }
          }, {
            key: "toJSON",
            value: function toJSON() {
              return this.rootName;
            }
          }, {
            key: "document",
            get: function get() {
              return this._document;
            }
          }]);
          return w;
        }(b.Z);
        var v = s("./packages/ckeditor5-engine/src/model/position.js"),
          y = s("./packages/ckeditor5-engine/src/model/documentselection.js"),
          Z = s("./packages/ckeditor5-utils/src/tomap.js");
        var P = /*#__PURE__*/function () {
          function P(e, t) {
            _classCallCheck(this, P);
            this.model = e, this.batch = t;
          }
          _createClass(P, [{
            key: "createText",
            value: function createText(e, t) {
              return new _.Z(e, t);
            }
          }, {
            key: "createElement",
            value: function createElement(e, t) {
              return new b.Z(e, t);
            }
          }, {
            key: "createDocumentFragment",
            value: function createDocumentFragment() {
              return new k.Z();
            }
          }, {
            key: "cloneElement",
            value: function cloneElement(e) {
              var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !0;
              return e._clone(t);
            }
          }, {
            key: "insert",
            value: function insert(e, t) {
              var s = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
              if (this._assertWriterUsedCorrectly(), e instanceof _.Z && "" == e.data) return;
              var i = v.ZP._createAt(t, s);
              if (e.parent) {
                if (C(e.root, i.root)) return void this.move(a.Z._createOn(e), i);
                if (e.root.document) throw new o.ZP("model-writer-insert-forbidden-move", this);
                this.remove(e);
              }
              var r = i.root.document ? i.root.document.version : null,
                n = new d.Z(i, e, r);
              if (e instanceof _.Z && (n.shouldReceiveAttributes = !0), this.batch.addOperation(n), this.model.applyOperation(n), e instanceof k.Z) {
                var _iterator105 = _createForOfIteratorHelper(e.markers),
                  _step105;
                try {
                  for (_iterator105.s(); !(_step105 = _iterator105.n()).done;) {
                    var _step105$value = _slicedToArray(_step105.value, 2),
                      _t57 = _step105$value[0],
                      _s47 = _step105$value[1];
                    var _e81 = v.ZP._createAt(_s47.root, 0),
                      _o19 = {
                        range: new a.Z(_s47.start._getCombined(_e81, i), _s47.end._getCombined(_e81, i)),
                        usingOperation: !0,
                        affectsData: !0
                      };
                    this.model.markers.has(_t57) ? this.updateMarker(_t57, _o19) : this.addMarker(_t57, _o19);
                  }
                } catch (err) {
                  _iterator105.e(err);
                } finally {
                  _iterator105.f();
                }
              }
            }
          }, {
            key: "insertText",
            value: function insertText(e, t, s, o) {
              t instanceof k.Z || t instanceof b.Z || t instanceof v.ZP ? this.insert(this.createText(e), t, s) : this.insert(this.createText(e, t), s, o);
            }
          }, {
            key: "insertElement",
            value: function insertElement(e, t, s, o) {
              t instanceof k.Z || t instanceof b.Z || t instanceof v.ZP ? this.insert(this.createElement(e), t, s) : this.insert(this.createElement(e, t), s, o);
            }
          }, {
            key: "append",
            value: function append(e, t) {
              this.insert(e, t, "end");
            }
          }, {
            key: "appendText",
            value: function appendText(e, t, s) {
              t instanceof k.Z || t instanceof b.Z ? this.insert(this.createText(e), t, "end") : this.insert(this.createText(e, t), s, "end");
            }
          }, {
            key: "appendElement",
            value: function appendElement(e, t, s) {
              t instanceof k.Z || t instanceof b.Z ? this.insert(this.createElement(e), t, "end") : this.insert(this.createElement(e, t), s, "end");
            }
          }, {
            key: "setAttribute",
            value: function setAttribute(e, t, s) {
              if (this._assertWriterUsedCorrectly(), s instanceof a.Z) {
                var _o20 = s.getMinimalFlatRanges();
                var _iterator106 = _createForOfIteratorHelper(_o20),
                  _step106;
                try {
                  for (_iterator106.s(); !(_step106 = _iterator106.n()).done;) {
                    var _s48 = _step106.value;
                    j(this, e, t, _s48);
                  }
                } catch (err) {
                  _iterator106.e(err);
                } finally {
                  _iterator106.f();
                }
              } else x(this, e, t, s);
            }
          }, {
            key: "setAttributes",
            value: function setAttributes(e, t) {
              var _iterator107 = _createForOfIteratorHelper((0, Z.Z)(e)),
                _step107;
              try {
                for (_iterator107.s(); !(_step107 = _iterator107.n()).done;) {
                  var _step107$value = _slicedToArray(_step107.value, 2),
                    _s49 = _step107$value[0],
                    _o21 = _step107$value[1];
                  this.setAttribute(_s49, _o21, t);
                }
              } catch (err) {
                _iterator107.e(err);
              } finally {
                _iterator107.f();
              }
            }
          }, {
            key: "removeAttribute",
            value: function removeAttribute(e, t) {
              if (this._assertWriterUsedCorrectly(), t instanceof a.Z) {
                var _s50 = t.getMinimalFlatRanges();
                var _iterator108 = _createForOfIteratorHelper(_s50),
                  _step108;
                try {
                  for (_iterator108.s(); !(_step108 = _iterator108.n()).done;) {
                    var _t58 = _step108.value;
                    j(this, e, null, _t58);
                  }
                } catch (err) {
                  _iterator108.e(err);
                } finally {
                  _iterator108.f();
                }
              } else x(this, e, null, t);
            }
          }, {
            key: "clearAttributes",
            value: function clearAttributes(e) {
              var _this33 = this;
              this._assertWriterUsedCorrectly();
              var t = function t(e) {
                var _iterator109 = _createForOfIteratorHelper(e.getAttributeKeys()),
                  _step109;
                try {
                  for (_iterator109.s(); !(_step109 = _iterator109.n()).done;) {
                    var _t59 = _step109.value;
                    _this33.removeAttribute(_t59, e);
                  }
                } catch (err) {
                  _iterator109.e(err);
                } finally {
                  _iterator109.f();
                }
              };
              if (e instanceof a.Z) {
                var _iterator110 = _createForOfIteratorHelper(e.getItems()),
                  _step110;
                try {
                  for (_iterator110.s(); !(_step110 = _iterator110.n()).done;) {
                    var _s51 = _step110.value;
                    t(_s51);
                  }
                } catch (err) {
                  _iterator110.e(err);
                } finally {
                  _iterator110.f();
                }
              } else t(e);
            }
          }, {
            key: "move",
            value: function move(e, t, s) {
              if (this._assertWriterUsedCorrectly(), !(e instanceof a.Z)) throw new o.ZP("writer-move-invalid-range", this);
              if (!e.isFlat) throw new o.ZP("writer-move-range-not-flat", this);
              var i = v.ZP._createAt(t, s);
              if (i.isEqual(e.start)) return;
              if (this._addOperationForAffectedMarkers("move", e), !C(e.root, i.root)) throw new o.ZP("writer-move-different-document", this);
              var r = e.root.document ? e.root.document.version : null,
                n = new u.Z(e.start, e.end.offset - e.start.offset, i, r);
              this.batch.addOperation(n), this.model.applyOperation(n);
            }
          }, {
            key: "remove",
            value: function remove(e) {
              this._assertWriterUsedCorrectly();
              var t = (e instanceof a.Z ? e : a.Z._createOn(e)).getMinimalFlatRanges().reverse();
              var _iterator111 = _createForOfIteratorHelper(t),
                _step111;
              try {
                for (_iterator111.s(); !(_step111 = _iterator111.n()).done;) {
                  var _e82 = _step111.value;
                  this._addOperationForAffectedMarkers("move", _e82), T(_e82.start, _e82.end.offset - _e82.start.offset, this.batch, this.model);
                }
              } catch (err) {
                _iterator111.e(err);
              } finally {
                _iterator111.f();
              }
            }
          }, {
            key: "merge",
            value: function merge(e) {
              this._assertWriterUsedCorrectly();
              var t = e.nodeBefore,
                s = e.nodeAfter;
              if (this._addOperationForAffectedMarkers("merge", e), !(t instanceof b.Z)) throw new o.ZP("writer-merge-no-element-before", this);
              if (!(s instanceof b.Z)) throw new o.ZP("writer-merge-no-element-after", this);
              e.root.document ? this._merge(e) : this._mergeDetached(e);
            }
          }, {
            key: "createPositionFromPath",
            value: function createPositionFromPath(e, t, s) {
              return this.model.createPositionFromPath(e, t, s);
            }
          }, {
            key: "createPositionAt",
            value: function createPositionAt(e, t) {
              return this.model.createPositionAt(e, t);
            }
          }, {
            key: "createPositionAfter",
            value: function createPositionAfter(e) {
              return this.model.createPositionAfter(e);
            }
          }, {
            key: "createPositionBefore",
            value: function createPositionBefore(e) {
              return this.model.createPositionBefore(e);
            }
          }, {
            key: "createRange",
            value: function createRange(e, t) {
              return this.model.createRange(e, t);
            }
          }, {
            key: "createRangeIn",
            value: function createRangeIn(e) {
              return this.model.createRangeIn(e);
            }
          }, {
            key: "createRangeOn",
            value: function createRangeOn(e) {
              return this.model.createRangeOn(e);
            }
          }, {
            key: "createSelection",
            value: function createSelection(e, t, s) {
              return this.model.createSelection(e, t, s);
            }
          }, {
            key: "_mergeDetached",
            value: function _mergeDetached(e) {
              var t = e.nodeBefore,
                s = e.nodeAfter;
              this.move(a.Z._createIn(s), v.ZP._createAt(t, "end")), this.remove(s);
            }
          }, {
            key: "_merge",
            value: function _merge(e) {
              var t = v.ZP._createAt(e.nodeBefore, "end"),
                s = v.ZP._createAt(e.nodeAfter, 0),
                o = e.root.document.graveyard,
                i = new v.ZP(o, [0]),
                r = e.root.document.version,
                n = new m.Z(s, e.nodeAfter.maxOffset, t, i, r);
              this.batch.addOperation(n), this.model.applyOperation(n);
            }
          }, {
            key: "rename",
            value: function rename(e, t) {
              if (this._assertWriterUsedCorrectly(), !(e instanceof b.Z)) throw new o.ZP("writer-rename-not-element-instance", this);
              var s = e.root.document ? e.root.document.version : null,
                i = new g.Z(v.ZP._createBefore(e), e.name, t, s);
              this.batch.addOperation(i), this.model.applyOperation(i);
            }
          }, {
            key: "split",
            value: function split(e, t) {
              this._assertWriterUsedCorrectly();
              var s,
                i,
                r = e.parent;
              if (!r.parent) throw new o.ZP("writer-split-element-no-parent", this);
              if (t || (t = r.parent), !e.parent.getAncestors({
                includeSelf: !0
              }).includes(t)) throw new o.ZP("writer-split-invalid-limit-element", this);
              do {
                var _t60 = r.root.document ? r.root.document.version : null,
                  _o22 = r.maxOffset - e.offset,
                  _n4 = f.Z.getInsertionPosition(e),
                  _a2 = new f.Z(e, _o22, _n4, null, _t60);
                this.batch.addOperation(_a2), this.model.applyOperation(_a2), s || i || (s = r, i = e.parent.nextSibling), r = (e = this.createPositionAfter(e.parent)).parent;
              } while (r !== t);
              return {
                position: e,
                range: new a.Z(v.ZP._createAt(s, "end"), v.ZP._createAt(i, 0))
              };
            }
          }, {
            key: "wrap",
            value: function wrap(e, t) {
              if (this._assertWriterUsedCorrectly(), !e.isFlat) throw new o.ZP("writer-wrap-range-not-flat", this);
              var s = t instanceof b.Z ? t : new b.Z(t);
              if (s.childCount > 0) throw new o.ZP("writer-wrap-element-not-empty", this);
              if (null !== s.parent) throw new o.ZP("writer-wrap-element-attached", this);
              this.insert(s, e.start);
              var i = new a.Z(e.start.getShiftedBy(1), e.end.getShiftedBy(1));
              this.move(i, v.ZP._createAt(s, 0));
            }
          }, {
            key: "unwrap",
            value: function unwrap(e) {
              if (this._assertWriterUsedCorrectly(), null === e.parent) throw new o.ZP("writer-unwrap-element-no-parent", this);
              this.move(a.Z._createIn(e), this.createPositionAfter(e)), this.remove(e);
            }
          }, {
            key: "addMarker",
            value: function addMarker(e, t) {
              if (this._assertWriterUsedCorrectly(), !t || "boolean" != typeof t.usingOperation) throw new o.ZP("writer-addmarker-no-usingoperation", this);
              var s = t.usingOperation,
                i = t.range,
                r = void 0 !== t.affectsData && t.affectsData;
              if (this.model.markers.has(e)) throw new o.ZP("writer-addmarker-marker-exists", this);
              if (!i) throw new o.ZP("writer-addmarker-no-range", this);
              return s ? (A(this, e, null, i, r), this.model.markers.get(e)) : this.model.markers._set(e, i, s, r);
            }
          }, {
            key: "updateMarker",
            value: function updateMarker(e, t) {
              this._assertWriterUsedCorrectly();
              var s = "string" == typeof e ? e : e.name,
                i = this.model.markers.get(s);
              if (!i) throw new o.ZP("writer-updatemarker-marker-not-exists", this);
              if (!t) return (0, o.KE)("writer-updatemarker-reconvert-using-editingcontroller", {
                markerName: s
              }), void this.model.markers._refresh(i);
              var r = "boolean" == typeof t.usingOperation,
                n = "boolean" == typeof t.affectsData,
                a = n ? t.affectsData : i.affectsData;
              if (!r && !t.range && !n) throw new o.ZP("writer-updatemarker-wrong-options", this);
              var c = i.getRange(),
                l = t.range ? t.range : c;
              r && t.usingOperation !== i.managedUsingOperations ? t.usingOperation ? A(this, s, null, l, a) : (A(this, s, c, null, a), this.model.markers._set(s, l, void 0, a)) : i.managedUsingOperations ? A(this, s, c, l, a) : this.model.markers._set(s, l, void 0, a);
            }
          }, {
            key: "removeMarker",
            value: function removeMarker(e) {
              this._assertWriterUsedCorrectly();
              var t = "string" == typeof e ? e : e.name;
              if (!this.model.markers.has(t)) throw new o.ZP("writer-removemarker-no-marker", this);
              var s = this.model.markers.get(t);
              if (!s.managedUsingOperations) return void this.model.markers._remove(t);
              A(this, t, s.getRange(), null, s.affectsData);
            }
          }, {
            key: "setSelection",
            value: function setSelection(e, t, s) {
              this._assertWriterUsedCorrectly(), this.model.document.selection._setTo(e, t, s);
            }
          }, {
            key: "setSelectionFocus",
            value: function setSelectionFocus(e, t) {
              this._assertWriterUsedCorrectly(), this.model.document.selection._setFocus(e, t);
            }
          }, {
            key: "setSelectionAttribute",
            value: function setSelectionAttribute(e, t) {
              if (this._assertWriterUsedCorrectly(), "string" == typeof e) this._setSelectionAttribute(e, t);else {
                var _iterator112 = _createForOfIteratorHelper((0, Z.Z)(e)),
                  _step112;
                try {
                  for (_iterator112.s(); !(_step112 = _iterator112.n()).done;) {
                    var _step112$value = _slicedToArray(_step112.value, 2),
                      _t61 = _step112$value[0],
                      _s52 = _step112$value[1];
                    this._setSelectionAttribute(_t61, _s52);
                  }
                } catch (err) {
                  _iterator112.e(err);
                } finally {
                  _iterator112.f();
                }
              }
            }
          }, {
            key: "removeSelectionAttribute",
            value: function removeSelectionAttribute(e) {
              if (this._assertWriterUsedCorrectly(), "string" == typeof e) this._removeSelectionAttribute(e);else {
                var _iterator113 = _createForOfIteratorHelper(e),
                  _step113;
                try {
                  for (_iterator113.s(); !(_step113 = _iterator113.n()).done;) {
                    var _t62 = _step113.value;
                    this._removeSelectionAttribute(_t62);
                  }
                } catch (err) {
                  _iterator113.e(err);
                } finally {
                  _iterator113.f();
                }
              }
            }
          }, {
            key: "overrideSelectionGravity",
            value: function overrideSelectionGravity() {
              return this.model.document.selection._overrideGravity();
            }
          }, {
            key: "restoreSelectionGravity",
            value: function restoreSelectionGravity(e) {
              this.model.document.selection._restoreGravity(e);
            }
          }, {
            key: "_setSelectionAttribute",
            value: function _setSelectionAttribute(e, t) {
              var s = this.model.document.selection;
              if (s.isCollapsed && s.anchor.parent.isEmpty) {
                var _o23 = y.Z._getStoreAttributeKey(e);
                this.setAttribute(_o23, t, s.anchor.parent);
              }
              s._setAttribute(e, t);
            }
          }, {
            key: "_removeSelectionAttribute",
            value: function _removeSelectionAttribute(e) {
              var t = this.model.document.selection;
              if (t.isCollapsed && t.anchor.parent.isEmpty) {
                var _s53 = y.Z._getStoreAttributeKey(e);
                this.removeAttribute(_s53, t.anchor.parent);
              }
              t._removeAttribute(e);
            }
          }, {
            key: "_assertWriterUsedCorrectly",
            value: function _assertWriterUsedCorrectly() {
              if (this.model._currentWriter !== this) throw new o.ZP("writer-incorrect-use", this);
            }
          }, {
            key: "_addOperationForAffectedMarkers",
            value: function _addOperationForAffectedMarkers(e, t) {
              var _iterator114 = _createForOfIteratorHelper(this.model.markers),
                _step114;
              try {
                for (_iterator114.s(); !(_step114 = _iterator114.n()).done;) {
                  var _s54 = _step114.value;
                  if (!_s54.managedUsingOperations) continue;
                  var _o24 = _s54.getRange();
                  var _i26 = !1;
                  if ("move" === e) _i26 = t.containsPosition(_o24.start) || t.start.isEqual(_o24.start) || t.containsPosition(_o24.end) || t.end.isEqual(_o24.end);else {
                    var _e83 = t.nodeBefore,
                      _s55 = t.nodeAfter,
                      _r10 = _o24.start.parent == _e83 && _o24.start.isAtEnd,
                      _n5 = _o24.end.parent == _s55 && 0 == _o24.end.offset,
                      _a3 = _o24.end.nodeAfter == _s55,
                      _c2 = _o24.start.nodeAfter == _s55;
                    _i26 = _r10 || _n5 || _a3 || _c2;
                  }
                  _i26 && this.updateMarker(_s54.name, {
                    range: _o24
                  });
                }
              } catch (err) {
                _iterator114.e(err);
              } finally {
                _iterator114.f();
              }
            }
          }]);
          return P;
        }();
        function j(e, t, s, o) {
          var i = e.model,
            n = i.document;
          var c,
            l,
            d,
            h = o.start;
          var _iterator115 = _createForOfIteratorHelper(o.getWalker({
              shallow: !0
            })),
            _step115;
          try {
            for (_iterator115.s(); !(_step115 = _iterator115.n()).done;) {
              var _e84 = _step115.value;
              d = _e84.item.getAttribute(t), c && l != d && (l != s && u(), h = c), c = _e84.nextPosition, l = d;
            }
          } catch (err) {
            _iterator115.e(err);
          } finally {
            _iterator115.f();
          }
          function u() {
            var o = new a.Z(h, c),
              d = o.root.document ? n.version : null,
              u = new r.Z(o, t, l, s, d);
            e.batch.addOperation(u), i.applyOperation(u);
          }
          c instanceof v.ZP && c != h && l != s && u();
        }
        function x(e, t, s, o) {
          var i = e.model,
            n = i.document,
            c = o.getAttribute(t);
          var l, d;
          if (c != s) {
            if (o.root === o) {
              var _e85 = o.document ? n.version : null;
              d = new p.Z(o, t, c, s, _e85);
            } else {
              l = new a.Z(v.ZP._createBefore(o), e.createPositionAfter(o));
              var _i27 = l.root.document ? n.version : null;
              d = new r.Z(l, t, c, s, _i27);
            }
            e.batch.addOperation(d), i.applyOperation(d);
          }
        }
        function A(e, t, s, o, i) {
          var r = e.model,
            n = r.document,
            a = new h.Z(t, s, o, r.markers, i, n.version);
          e.batch.addOperation(a), r.applyOperation(a);
        }
        function T(e, t, s, o) {
          var i;
          if (e.root.document) {
            var _s56 = o.document,
              _r11 = new v.ZP(_s56.graveyard, [0]);
            i = new u.Z(e, t, _r11, _s56.version);
          } else i = new l(e, t);
          s.addOperation(i), o.applyOperation(i);
        }
        function C(e, t) {
          return e === t || e instanceof w && t instanceof w;
        }
        var E = s("./packages/ckeditor5-engine/src/model/schema.js");
        var S = /*#__PURE__*/function () {
          function S(e) {
            _classCallCheck(this, S);
            this._markerCollection = e, this._changesInElement = new Map(), this._elementSnapshots = new Map(), this._changedMarkers = new Map(), this._changeCount = 0, this._cachedChanges = null, this._cachedChangesWithGraveyard = null, this._refreshedItems = new Set();
          }
          _createClass(S, [{
            key: "bufferOperation",
            value: function bufferOperation(e) {
              switch (e.type) {
                case "insert":
                  if (this._isInInsertedElement(e.position.parent)) return;
                  this._markInsert(e.position.parent, e.position.offset, e.nodes.maxOffset);
                  break;
                case "addAttribute":
                case "removeAttribute":
                case "changeAttribute":
                  var _iterator116 = _createForOfIteratorHelper(e.range.getItems({
                      shallow: !0
                    })),
                    _step116;
                  try {
                    for (_iterator116.s(); !(_step116 = _iterator116.n()).done;) {
                      var _t63 = _step116.value;
                      this._isInInsertedElement(_t63.parent) || this._markAttribute(_t63);
                    }
                  } catch (err) {
                    _iterator116.e(err);
                  } finally {
                    _iterator116.f();
                  }
                  break;
                case "remove":
                case "move":
                case "reinsert":
                  {
                    if (e.sourcePosition.isEqual(e.targetPosition) || e.sourcePosition.getShiftedBy(e.howMany).isEqual(e.targetPosition)) return;
                    var _t64 = this._isInInsertedElement(e.sourcePosition.parent),
                      _s57 = this._isInInsertedElement(e.targetPosition.parent);
                    _t64 || this._markRemove(e.sourcePosition.parent, e.sourcePosition.offset, e.howMany), _s57 || this._markInsert(e.targetPosition.parent, e.getMovedRangeStart().offset, e.howMany);
                    break;
                  }
                case "rename":
                  {
                    if (this._isInInsertedElement(e.position.parent)) return;
                    this._markRemove(e.position.parent, e.position.offset, 1), this._markInsert(e.position.parent, e.position.offset, 1);
                    var _t65 = a.Z._createFromPositionAndShift(e.position, 1);
                    var _iterator117 = _createForOfIteratorHelper(this._markerCollection.getMarkersIntersectingRange(_t65)),
                      _step117;
                    try {
                      for (_iterator117.s(); !(_step117 = _iterator117.n()).done;) {
                        var _e86 = _step117.value;
                        var _t66 = _e86.getData();
                        this.bufferMarkerChange(_e86.name, _t66, _t66);
                      }
                    } catch (err) {
                      _iterator117.e(err);
                    } finally {
                      _iterator117.f();
                    }
                    break;
                  }
                case "split":
                  {
                    var _t67 = e.splitPosition.parent;
                    this._isInInsertedElement(_t67) || this._markRemove(_t67, e.splitPosition.offset, e.howMany), this._isInInsertedElement(e.insertionPosition.parent) || this._markInsert(e.insertionPosition.parent, e.insertionPosition.offset, 1), e.graveyardPosition && this._markRemove(e.graveyardPosition.parent, e.graveyardPosition.offset, 1);
                    break;
                  }
                case "merge":
                  {
                    var _t68 = e.sourcePosition.parent;
                    this._isInInsertedElement(_t68.parent) || this._markRemove(_t68.parent, _t68.startOffset, 1);
                    var _s58 = e.graveyardPosition.parent;
                    this._markInsert(_s58, e.graveyardPosition.offset, 1);
                    var _o25 = e.targetPosition.parent;
                    this._isInInsertedElement(_o25) || this._markInsert(_o25, e.targetPosition.offset, _t68.maxOffset);
                    break;
                  }
              }
              this._cachedChanges = null;
            }
          }, {
            key: "bufferMarkerChange",
            value: function bufferMarkerChange(e, t, s) {
              var o = this._changedMarkers.get(e);
              o ? (o.newMarkerData = s, null == o.oldMarkerData.range && null == s.range && this._changedMarkers.delete(e)) : this._changedMarkers.set(e, {
                newMarkerData: s,
                oldMarkerData: t
              });
            }
          }, {
            key: "getMarkersToRemove",
            value: function getMarkersToRemove() {
              var e = [];
              var _iterator118 = _createForOfIteratorHelper(this._changedMarkers),
                _step118;
              try {
                for (_iterator118.s(); !(_step118 = _iterator118.n()).done;) {
                  var _step118$value = _slicedToArray(_step118.value, 2),
                    _t69 = _step118$value[0],
                    _s59 = _step118$value[1];
                  null != _s59.oldMarkerData.range && e.push({
                    name: _t69,
                    range: _s59.oldMarkerData.range
                  });
                }
              } catch (err) {
                _iterator118.e(err);
              } finally {
                _iterator118.f();
              }
              return e;
            }
          }, {
            key: "getMarkersToAdd",
            value: function getMarkersToAdd() {
              var e = [];
              var _iterator119 = _createForOfIteratorHelper(this._changedMarkers),
                _step119;
              try {
                for (_iterator119.s(); !(_step119 = _iterator119.n()).done;) {
                  var _step119$value = _slicedToArray(_step119.value, 2),
                    _t70 = _step119$value[0],
                    _s60 = _step119$value[1];
                  null != _s60.newMarkerData.range && e.push({
                    name: _t70,
                    range: _s60.newMarkerData.range
                  });
                }
              } catch (err) {
                _iterator119.e(err);
              } finally {
                _iterator119.f();
              }
              return e;
            }
          }, {
            key: "getChangedMarkers",
            value: function getChangedMarkers() {
              return Array.from(this._changedMarkers).map(function (_ref10) {
                var _ref11 = _slicedToArray(_ref10, 2),
                  e = _ref11[0],
                  t = _ref11[1];
                return {
                  name: e,
                  data: {
                    oldRange: t.oldMarkerData.range,
                    newRange: t.newMarkerData.range
                  }
                };
              });
            }
          }, {
            key: "hasDataChanges",
            value: function hasDataChanges() {
              var _iterator120 = _createForOfIteratorHelper(this._changedMarkers.values()),
                _step120;
              try {
                for (_iterator120.s(); !(_step120 = _iterator120.n()).done;) {
                  var _step120$value = _step120.value,
                    _e87 = _step120$value.newMarkerData,
                    _t71 = _step120$value.oldMarkerData;
                  if (_e87.affectsData !== _t71.affectsData) return !0;
                  if (_e87.affectsData) return !(_e87.range && _t71.range && _e87.range.isEqual(_t71.range));
                }
              } catch (err) {
                _iterator120.e(err);
              } finally {
                _iterator120.f();
              }
              return this._changesInElement.size > 0;
            }
          }, {
            key: "getChanges",
            value: function getChanges() {
              var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
                includeChangesInGraveyard: !1
              };
              if (this._cachedChanges) return e.includeChangesInGraveyard ? this._cachedChangesWithGraveyard.slice() : this._cachedChanges.slice();
              var t = [];
              var _iterator121 = _createForOfIteratorHelper(this._changesInElement.keys()),
                _step121;
              try {
                for (_iterator121.s(); !(_step121 = _iterator121.n()).done;) {
                  var _e89 = _step121.value;
                  var _s62 = this._changesInElement.get(_e89).sort(function (e, t) {
                      return e.offset === t.offset ? e.type != t.type ? "remove" == e.type ? -1 : 1 : 0 : e.offset < t.offset ? -1 : 1;
                    }),
                    _o27 = this._elementSnapshots.get(_e89),
                    _i29 = R(_e89.getChildren()),
                    _r13 = O(_o27.length, _s62);
                  var _n7 = 0,
                    _c3 = 0;
                  var _iterator123 = _createForOfIteratorHelper(_r13),
                    _step123;
                  try {
                    for (_iterator123.s(); !(_step123 = _iterator123.n()).done;) {
                      var _s63 = _step123.value;
                      if ("i" === _s63) t.push(this._getInsertDiff(_e89, _n7, _i29[_n7].name)), _n7++;else if ("r" === _s63) t.push(this._getRemoveDiff(_e89, _n7, _o27[_c3].name)), _c3++;else if ("a" === _s63) {
                        var _t73;
                        var _s64 = _i29[_n7].attributes,
                          _r14 = _o27[_c3].attributes;
                        var _l = void 0;
                        if ("$text" == _i29[_n7].name) _l = new a.Z(v.ZP._createAt(_e89, _n7), v.ZP._createAt(_e89, _n7 + 1));else {
                          var _t72 = _e89.offsetToIndex(_n7);
                          _l = new a.Z(v.ZP._createAt(_e89, _n7), v.ZP._createAt(_e89.getChild(_t72), 0));
                        }
                        (_t73 = t).push.apply(_t73, _toConsumableArray(this._getAttributesDiff(_l, _r14, _s64))), _n7++, _c3++;
                      } else _n7++, _c3++;
                    }
                  } catch (err) {
                    _iterator123.e(err);
                  } finally {
                    _iterator123.f();
                  }
                }
              } catch (err) {
                _iterator121.e(err);
              } finally {
                _iterator121.f();
              }
              t.sort(function (e, t) {
                return e.position.root != t.position.root ? e.position.root.rootName < t.position.root.rootName ? -1 : 1 : e.position.isEqual(t.position) ? e.changeCount - t.changeCount : e.position.isBefore(t.position) ? -1 : 1;
              });
              for (var _e88 = 1, _s61 = 0; _e88 < t.length; _e88++) {
                var _o26 = t[_s61],
                  _i28 = t[_e88],
                  _r12 = "remove" == _o26.type && "remove" == _i28.type && "$text" == _o26.name && "$text" == _i28.name && _o26.position.isEqual(_i28.position),
                  _n6 = "insert" == _o26.type && "insert" == _i28.type && "$text" == _o26.name && "$text" == _i28.name && _o26.position.parent == _i28.position.parent && _o26.position.offset + _o26.length == _i28.position.offset,
                  _a4 = "attribute" == _o26.type && "attribute" == _i28.type && _o26.position.parent == _i28.position.parent && _o26.range.isFlat && _i28.range.isFlat && _o26.position.offset + _o26.length == _i28.position.offset && _o26.attributeKey == _i28.attributeKey && _o26.attributeOldValue == _i28.attributeOldValue && _o26.attributeNewValue == _i28.attributeNewValue;
                _r12 || _n6 || _a4 ? (_o26.length++, _a4 && (_o26.range.end = _o26.range.end.getShiftedBy(1)), t[_e88] = null) : _s61 = _e88;
              }
              t = t.filter(function (e) {
                return e;
              });
              var _iterator122 = _createForOfIteratorHelper(t),
                _step122;
              try {
                for (_iterator122.s(); !(_step122 = _iterator122.n()).done;) {
                  var _e90 = _step122.value;
                  delete _e90.changeCount, "attribute" == _e90.type && (delete _e90.position, delete _e90.length);
                }
              } catch (err) {
                _iterator122.e(err);
              } finally {
                _iterator122.f();
              }
              return this._changeCount = 0, this._cachedChangesWithGraveyard = t, this._cachedChanges = t.filter(M), e.includeChangesInGraveyard ? this._cachedChangesWithGraveyard.slice() : this._cachedChanges.slice();
            }
          }, {
            key: "getRefreshedItems",
            value: function getRefreshedItems() {
              return new Set(this._refreshedItems);
            }
          }, {
            key: "reset",
            value: function reset() {
              this._changesInElement.clear(), this._elementSnapshots.clear(), this._changedMarkers.clear(), this._refreshedItems = new Set(), this._cachedChanges = null;
            }
          }, {
            key: "_refreshItem",
            value: function _refreshItem(e) {
              if (this._isInInsertedElement(e.parent)) return;
              this._markRemove(e.parent, e.startOffset, e.offsetSize), this._markInsert(e.parent, e.startOffset, e.offsetSize), this._refreshedItems.add(e);
              var t = a.Z._createOn(e);
              var _iterator124 = _createForOfIteratorHelper(this._markerCollection.getMarkersIntersectingRange(t)),
                _step124;
              try {
                for (_iterator124.s(); !(_step124 = _iterator124.n()).done;) {
                  var _e91 = _step124.value;
                  var _t74 = _e91.getData();
                  this.bufferMarkerChange(_e91.name, _t74, _t74);
                }
              } catch (err) {
                _iterator124.e(err);
              } finally {
                _iterator124.f();
              }
              this._cachedChanges = null;
            }
          }, {
            key: "_markInsert",
            value: function _markInsert(e, t, s) {
              var o = {
                type: "insert",
                offset: t,
                howMany: s,
                count: this._changeCount++
              };
              this._markChange(e, o);
            }
          }, {
            key: "_markRemove",
            value: function _markRemove(e, t, s) {
              var o = {
                type: "remove",
                offset: t,
                howMany: s,
                count: this._changeCount++
              };
              this._markChange(e, o), this._removeAllNestedChanges(e, t, s);
            }
          }, {
            key: "_markAttribute",
            value: function _markAttribute(e) {
              var t = {
                type: "attribute",
                offset: e.startOffset,
                howMany: e.offsetSize,
                count: this._changeCount++
              };
              this._markChange(e.parent, t);
            }
          }, {
            key: "_markChange",
            value: function _markChange(e, t) {
              this._makeSnapshot(e);
              var s = this._getChangesForElement(e);
              this._handleChange(t, s), s.push(t);
              for (var _e92 = 0; _e92 < s.length; _e92++) s[_e92].howMany < 1 && (s.splice(_e92, 1), _e92--);
            }
          }, {
            key: "_getChangesForElement",
            value: function _getChangesForElement(e) {
              var t;
              return this._changesInElement.has(e) ? t = this._changesInElement.get(e) : (t = [], this._changesInElement.set(e, t)), t;
            }
          }, {
            key: "_makeSnapshot",
            value: function _makeSnapshot(e) {
              this._elementSnapshots.has(e) || this._elementSnapshots.set(e, R(e.getChildren()));
            }
          }, {
            key: "_handleChange",
            value: function _handleChange(e, t) {
              e.nodesToHandle = e.howMany;
              var _iterator125 = _createForOfIteratorHelper(t),
                _step125;
              try {
                for (_iterator125.s(); !(_step125 = _iterator125.n()).done;) {
                  var _s65 = _step125.value;
                  var _o28 = e.offset + e.howMany,
                    _i30 = _s65.offset + _s65.howMany;
                  if ("insert" == e.type && ("insert" == _s65.type && (e.offset <= _s65.offset ? _s65.offset += e.howMany : e.offset < _i30 && (_s65.howMany += e.nodesToHandle, e.nodesToHandle = 0)), "remove" == _s65.type && e.offset < _s65.offset && (_s65.offset += e.howMany), "attribute" == _s65.type)) if (e.offset <= _s65.offset) _s65.offset += e.howMany;else if (e.offset < _i30) {
                    var _i31 = _s65.howMany;
                    _s65.howMany = e.offset - _s65.offset, t.unshift({
                      type: "attribute",
                      offset: _o28,
                      howMany: _i31 - _s65.howMany,
                      count: this._changeCount++
                    });
                  }
                  if ("remove" == e.type) {
                    if ("insert" == _s65.type) if (_o28 <= _s65.offset) _s65.offset -= e.howMany;else if (_o28 <= _i30) {
                      if (e.offset < _s65.offset) {
                        var _t75 = _o28 - _s65.offset;
                        _s65.offset = e.offset, _s65.howMany -= _t75, e.nodesToHandle -= _t75;
                      } else _s65.howMany -= e.nodesToHandle, e.nodesToHandle = 0;
                    } else if (e.offset <= _s65.offset) e.nodesToHandle -= _s65.howMany, _s65.howMany = 0;else if (e.offset < _i30) {
                      var _t76 = _i30 - e.offset;
                      _s65.howMany -= _t76, e.nodesToHandle -= _t76;
                    }
                    if ("remove" == _s65.type && (_o28 <= _s65.offset ? _s65.offset -= e.howMany : e.offset < _s65.offset && (e.nodesToHandle += _s65.howMany, _s65.howMany = 0)), "attribute" == _s65.type) if (_o28 <= _s65.offset) _s65.offset -= e.howMany;else if (e.offset < _s65.offset) {
                      var _t77 = _o28 - _s65.offset;
                      _s65.offset = e.offset, _s65.howMany -= _t77;
                    } else if (e.offset < _i30) if (_o28 <= _i30) {
                      var _o29 = _s65.howMany;
                      _s65.howMany = e.offset - _s65.offset;
                      var _i32 = _o29 - _s65.howMany - e.nodesToHandle;
                      t.unshift({
                        type: "attribute",
                        offset: e.offset,
                        howMany: _i32,
                        count: this._changeCount++
                      });
                    } else _s65.howMany -= _i30 - e.offset;
                  }
                  if ("attribute" == e.type) {
                    if ("insert" == _s65.type) if (e.offset < _s65.offset && _o28 > _s65.offset) {
                      if (_o28 > _i30) {
                        var _e93 = {
                          type: "attribute",
                          offset: _i30,
                          howMany: _o28 - _i30,
                          count: this._changeCount++
                        };
                        this._handleChange(_e93, t), t.push(_e93);
                      }
                      e.nodesToHandle = _s65.offset - e.offset, e.howMany = e.nodesToHandle;
                    } else e.offset >= _s65.offset && e.offset < _i30 && (_o28 > _i30 ? (e.nodesToHandle = _o28 - _i30, e.offset = _i30) : e.nodesToHandle = 0);
                    if ("remove" == _s65.type && e.offset < _s65.offset && _o28 > _s65.offset) {
                      var _i33 = {
                        type: "attribute",
                        offset: _s65.offset,
                        howMany: _o28 - _s65.offset,
                        count: this._changeCount++
                      };
                      this._handleChange(_i33, t), t.push(_i33), e.nodesToHandle = _s65.offset - e.offset, e.howMany = e.nodesToHandle;
                    }
                    "attribute" == _s65.type && (e.offset >= _s65.offset && _o28 <= _i30 ? (e.nodesToHandle = 0, e.howMany = 0, e.offset = 0) : e.offset <= _s65.offset && _o28 >= _i30 && (_s65.howMany = 0));
                  }
                }
              } catch (err) {
                _iterator125.e(err);
              } finally {
                _iterator125.f();
              }
              e.howMany = e.nodesToHandle, delete e.nodesToHandle;
            }
          }, {
            key: "_getInsertDiff",
            value: function _getInsertDiff(e, t, s) {
              return {
                type: "insert",
                position: v.ZP._createAt(e, t),
                name: s,
                length: 1,
                changeCount: this._changeCount++
              };
            }
          }, {
            key: "_getRemoveDiff",
            value: function _getRemoveDiff(e, t, s) {
              return {
                type: "remove",
                position: v.ZP._createAt(e, t),
                name: s,
                length: 1,
                changeCount: this._changeCount++
              };
            }
          }, {
            key: "_getAttributesDiff",
            value: function _getAttributesDiff(e, t, s) {
              var o = [];
              s = new Map(s);
              var _iterator126 = _createForOfIteratorHelper(t),
                _step126;
              try {
                for (_iterator126.s(); !(_step126 = _iterator126.n()).done;) {
                  var _step126$value = _slicedToArray(_step126.value, 2),
                    _i34 = _step126$value[0],
                    _r15 = _step126$value[1];
                  var _t78 = s.has(_i34) ? s.get(_i34) : null;
                  _t78 !== _r15 && o.push({
                    type: "attribute",
                    position: e.start,
                    range: e.clone(),
                    length: 1,
                    attributeKey: _i34,
                    attributeOldValue: _r15,
                    attributeNewValue: _t78,
                    changeCount: this._changeCount++
                  }), s.delete(_i34);
                }
              } catch (err) {
                _iterator126.e(err);
              } finally {
                _iterator126.f();
              }
              var _iterator127 = _createForOfIteratorHelper(s),
                _step127;
              try {
                for (_iterator127.s(); !(_step127 = _iterator127.n()).done;) {
                  var _step127$value = _slicedToArray(_step127.value, 2),
                    _t79 = _step127$value[0],
                    _i35 = _step127$value[1];
                  o.push({
                    type: "attribute",
                    position: e.start,
                    range: e.clone(),
                    length: 1,
                    attributeKey: _t79,
                    attributeOldValue: null,
                    attributeNewValue: _i35,
                    changeCount: this._changeCount++
                  });
                }
              } catch (err) {
                _iterator127.e(err);
              } finally {
                _iterator127.f();
              }
              return o;
            }
          }, {
            key: "_isInInsertedElement",
            value: function _isInInsertedElement(e) {
              var t = e.parent;
              if (!t) return !1;
              var s = this._changesInElement.get(t),
                o = e.startOffset;
              if (s) {
                var _iterator128 = _createForOfIteratorHelper(s),
                  _step128;
                try {
                  for (_iterator128.s(); !(_step128 = _iterator128.n()).done;) {
                    var _e94 = _step128.value;
                    if ("insert" == _e94.type && o >= _e94.offset && o < _e94.offset + _e94.howMany) return !0;
                  }
                } catch (err) {
                  _iterator128.e(err);
                } finally {
                  _iterator128.f();
                }
              }
              return this._isInInsertedElement(t);
            }
          }, {
            key: "_removeAllNestedChanges",
            value: function _removeAllNestedChanges(e, t, s) {
              var o = new a.Z(v.ZP._createAt(e, t), v.ZP._createAt(e, t + s));
              var _iterator129 = _createForOfIteratorHelper(o.getItems({
                  shallow: !0
                })),
                _step129;
              try {
                for (_iterator129.s(); !(_step129 = _iterator129.n()).done;) {
                  var _e95 = _step129.value;
                  _e95.is("element") && (this._elementSnapshots.delete(_e95), this._changesInElement.delete(_e95), this._removeAllNestedChanges(_e95, 0, _e95.maxOffset));
                }
              } catch (err) {
                _iterator129.e(err);
              } finally {
                _iterator129.f();
              }
            }
          }, {
            key: "isEmpty",
            get: function get() {
              return 0 == this._changesInElement.size && 0 == this._changedMarkers.size;
            }
          }]);
          return S;
        }();
        function R(e) {
          var t = [];
          var _iterator130 = _createForOfIteratorHelper(e),
            _step130;
          try {
            for (_iterator130.s(); !(_step130 = _iterator130.n()).done;) {
              var _s66 = _step130.value;
              if (_s66.is("$text")) for (var _e96 = 0; _e96 < _s66.data.length; _e96++) t.push({
                name: "$text",
                attributes: new Map(_s66.getAttributes())
              });else t.push({
                name: _s66.name,
                attributes: new Map(_s66.getAttributes())
              });
            }
          } catch (err) {
            _iterator130.e(err);
          } finally {
            _iterator130.f();
          }
          return t;
        }
        function O(e, t) {
          var s = [];
          var o = 0,
            i = 0;
          var _iterator131 = _createForOfIteratorHelper(t),
            _step131;
          try {
            for (_iterator131.s(); !(_step131 = _iterator131.n()).done;) {
              var _e97 = _step131.value;
              if (_e97.offset > o) {
                for (var _t81 = 0; _t81 < _e97.offset - o; _t81++) s.push("e");
                i += _e97.offset - o;
              }
              if ("insert" == _e97.type) {
                for (var _t82 = 0; _t82 < _e97.howMany; _t82++) s.push("i");
                o = _e97.offset + _e97.howMany;
              } else if ("remove" == _e97.type) {
                for (var _t83 = 0; _t83 < _e97.howMany; _t83++) s.push("r");
                o = _e97.offset, i += _e97.howMany;
              } else s.push.apply(s, _toConsumableArray("a".repeat(_e97.howMany).split(""))), o = _e97.offset + _e97.howMany, i += _e97.howMany;
            }
          } catch (err) {
            _iterator131.e(err);
          } finally {
            _iterator131.f();
          }
          if (i < e) for (var _t80 = 0; _t80 < e - i - o; _t80++) s.push("e");
          return s;
        }
        function M(e) {
          var t = e.position && "$graveyard" == e.position.root.rootName,
            s = e.range && "$graveyard" == e.range.root.rootName;
          return !t && !s;
        }
        var N = s("./packages/ckeditor5-engine/src/model/history.js"),
          I = s("./packages/ckeditor5-utils/src/collection.js"),
          z = s("./packages/ckeditor5-utils/src/emittermixin.js"),
          V = s("./packages/ckeditor5-utils/src/mix.js");
        function D(e, t) {
          return !!(s = e.charAt(t - 1)) && 1 == s.length && /[\ud800-\udbff]/.test(s) && function (e) {
            return !!e && 1 == e.length && /[\udc00-\udfff]/.test(e);
          }(e.charAt(t));
          var s;
        }
        function B(e, t) {
          return !!(s = e.charAt(t)) && 1 == s.length && /[\u0300-\u036f\u1ab0-\u1aff\u1dc0-\u1dff\u20d0-\u20ff\ufe20-\ufe2f]/.test(s);
          var s;
        }
        var F = function () {
          var e = /(?:\uD83C[\uDDE6-\uDDFF]){2}/.source,
            t = "(?:" + [/(?:[#\*0-9\xA9\xAE\u203C\u2049\u2122\u2139\u2194-\u2199\u21A9\u21AA\u231A\u231B\u2328\u23CF\u23E9-\u23F3\u23F8-\u23FA\u24C2\u25AA\u25AB\u25B6\u25C0\u25FB-\u25FE\u2600-\u2604\u260E\u2611\u2614\u2615\u2618\u261D\u2620\u2622\u2623\u2626\u262A\u262E\u262F\u2638-\u263A\u2640\u2642\u2648-\u2653\u265F\u2660\u2663\u2665\u2666\u2668\u267B\u267E\u267F\u2692-\u2697\u2699\u269B\u269C\u26A0\u26A1\u26A7\u26AA\u26AB\u26B0\u26B1\u26BD\u26BE\u26C4\u26C5\u26C8\u26CE\u26CF\u26D1\u26D3\u26D4\u26E9\u26EA\u26F0-\u26F5\u26F7-\u26FA\u26FD\u2702\u2705\u2708-\u270D\u270F\u2712\u2714\u2716\u271D\u2721\u2728\u2733\u2734\u2744\u2747\u274C\u274E\u2753-\u2755\u2757\u2763\u2764\u2795-\u2797\u27A1\u27B0\u27BF\u2934\u2935\u2B05-\u2B07\u2B1B\u2B1C\u2B50\u2B55\u3030\u303D\u3297\u3299]|\uD83C[\uDC04\uDCCF\uDD70\uDD71\uDD7E\uDD7F\uDD8E\uDD91-\uDD9A\uDDE6-\uDDFF\uDE01\uDE02\uDE1A\uDE2F\uDE32-\uDE3A\uDE50\uDE51\uDF00-\uDF21\uDF24-\uDF93\uDF96\uDF97\uDF99-\uDF9B\uDF9E-\uDFF0\uDFF3-\uDFF5\uDFF7-\uDFFF]|\uD83D[\uDC00-\uDCFD\uDCFF-\uDD3D\uDD49-\uDD4E\uDD50-\uDD67\uDD6F\uDD70\uDD73-\uDD7A\uDD87\uDD8A-\uDD8D\uDD90\uDD95\uDD96\uDDA4\uDDA5\uDDA8\uDDB1\uDDB2\uDDBC\uDDC2-\uDDC4\uDDD1-\uDDD3\uDDDC-\uDDDE\uDDE1\uDDE3\uDDE8\uDDEF\uDDF3\uDDFA-\uDE4F\uDE80-\uDEC5\uDECB-\uDED2\uDED5-\uDED7\uDEDC-\uDEE5\uDEE9\uDEEB\uDEEC\uDEF0\uDEF3-\uDEFC\uDFE0-\uDFEB\uDFF0]|\uD83E[\uDD0C-\uDD3A\uDD3C-\uDD45\uDD47-\uDDFF\uDE70-\uDE7C\uDE80-\uDE89\uDE8F-\uDEC6\uDECE-\uDEDC\uDEDF-\uDEE9\uDEF0-\uDEF8])(?:\uDB40[\uDC20-\uDC7E])+(?:\uDB40\uDC7F)/, /(?:[#\*0-9\xA9\xAE\u203C\u2049\u2122\u2139\u2194-\u2199\u21A9\u21AA\u231A\u231B\u2328\u23CF\u23E9-\u23F3\u23F8-\u23FA\u24C2\u25AA\u25AB\u25B6\u25C0\u25FB-\u25FE\u2600-\u2604\u260E\u2611\u2614\u2615\u2618\u261D\u2620\u2622\u2623\u2626\u262A\u262E\u262F\u2638-\u263A\u2640\u2642\u2648-\u2653\u265F\u2660\u2663\u2665\u2666\u2668\u267B\u267E\u267F\u2692-\u2697\u2699\u269B\u269C\u26A0\u26A1\u26A7\u26AA\u26AB\u26B0\u26B1\u26BD\u26BE\u26C4\u26C5\u26C8\u26CE\u26CF\u26D1\u26D3\u26D4\u26E9\u26EA\u26F0-\u26F5\u26F7-\u26FA\u26FD\u2702\u2705\u2708-\u270D\u270F\u2712\u2714\u2716\u271D\u2721\u2728\u2733\u2734\u2744\u2747\u274C\u274E\u2753-\u2755\u2757\u2763\u2764\u2795-\u2797\u27A1\u27B0\u27BF\u2934\u2935\u2B05-\u2B07\u2B1B\u2B1C\u2B50\u2B55\u3030\u303D\u3297\u3299]|\uD83C[\uDC04\uDCCF\uDD70\uDD71\uDD7E\uDD7F\uDD8E\uDD91-\uDD9A\uDDE6-\uDDFF\uDE01\uDE02\uDE1A\uDE2F\uDE32-\uDE3A\uDE50\uDE51\uDF00-\uDF21\uDF24-\uDF93\uDF96\uDF97\uDF99-\uDF9B\uDF9E-\uDFF0\uDFF3-\uDFF5\uDFF7-\uDFFF]|\uD83D[\uDC00-\uDCFD\uDCFF-\uDD3D\uDD49-\uDD4E\uDD50-\uDD67\uDD6F\uDD70\uDD73-\uDD7A\uDD87\uDD8A-\uDD8D\uDD90\uDD95\uDD96\uDDA4\uDDA5\uDDA8\uDDB1\uDDB2\uDDBC\uDDC2-\uDDC4\uDDD1-\uDDD3\uDDDC-\uDDDE\uDDE1\uDDE3\uDDE8\uDDEF\uDDF3\uDDFA-\uDE4F\uDE80-\uDEC5\uDECB-\uDED2\uDED5-\uDED7\uDEDC-\uDEE5\uDEE9\uDEEB\uDEEC\uDEF0\uDEF3-\uDEFC\uDFE0-\uDFEB\uDFF0]|\uD83E[\uDD0C-\uDD3A\uDD3C-\uDD45\uDD47-\uDDFF\uDE70-\uDE7C\uDE80-\uDE89\uDE8F-\uDEC6\uDECE-\uDEDC\uDEDF-\uDEE9\uDEF0-\uDEF8])\uFE0F?\u20E3/, /(?:[#\*0-9\xA9\xAE\u203C\u2049\u2122\u2139\u2194-\u2199\u21A9\u21AA\u231A\u231B\u2328\u23CF\u23E9-\u23F3\u23F8-\u23FA\u24C2\u25AA\u25AB\u25B6\u25C0\u25FB-\u25FE\u2600-\u2604\u260E\u2611\u2614\u2615\u2618\u261D\u2620\u2622\u2623\u2626\u262A\u262E\u262F\u2638-\u263A\u2640\u2642\u2648-\u2653\u265F\u2660\u2663\u2665\u2666\u2668\u267B\u267E\u267F\u2692-\u2697\u2699\u269B\u269C\u26A0\u26A1\u26A7\u26AA\u26AB\u26B0\u26B1\u26BD\u26BE\u26C4\u26C5\u26C8\u26CE\u26CF\u26D1\u26D3\u26D4\u26E9\u26EA\u26F0-\u26F5\u26F7-\u26FA\u26FD\u2702\u2705\u2708-\u270D\u270F\u2712\u2714\u2716\u271D\u2721\u2728\u2733\u2734\u2744\u2747\u274C\u274E\u2753-\u2755\u2757\u2763\u2764\u2795-\u2797\u27A1\u27B0\u27BF\u2934\u2935\u2B05-\u2B07\u2B1B\u2B1C\u2B50\u2B55\u3030\u303D\u3297\u3299]|\uD83C[\uDC04\uDCCF\uDD70\uDD71\uDD7E\uDD7F\uDD8E\uDD91-\uDD9A\uDDE6-\uDDFF\uDE01\uDE02\uDE1A\uDE2F\uDE32-\uDE3A\uDE50\uDE51\uDF00-\uDF21\uDF24-\uDF93\uDF96\uDF97\uDF99-\uDF9B\uDF9E-\uDFF0\uDFF3-\uDFF5\uDFF7-\uDFFF]|\uD83D[\uDC00-\uDCFD\uDCFF-\uDD3D\uDD49-\uDD4E\uDD50-\uDD67\uDD6F\uDD70\uDD73-\uDD7A\uDD87\uDD8A-\uDD8D\uDD90\uDD95\uDD96\uDDA4\uDDA5\uDDA8\uDDB1\uDDB2\uDDBC\uDDC2-\uDDC4\uDDD1-\uDDD3\uDDDC-\uDDDE\uDDE1\uDDE3\uDDE8\uDDEF\uDDF3\uDDFA-\uDE4F\uDE80-\uDEC5\uDECB-\uDED2\uDED5-\uDED7\uDEDC-\uDEE5\uDEE9\uDEEB\uDEEC\uDEF0\uDEF3-\uDEFC\uDFE0-\uDFEB\uDFF0]|\uD83E[\uDD0C-\uDD3A\uDD3C-\uDD45\uDD47-\uDDFF\uDE70-\uDE7C\uDE80-\uDE89\uDE8F-\uDEC6\uDECE-\uDEDC\uDEDF-\uDEE9\uDEF0-\uDEF8])\uFE0F/, /(?=(?:[\xA6\xA9\xAE\xB0\u0482\u058D\u058E\u060E\u060F\u06DE\u06E9\u06FD\u06FE\u07F6\u09FA\u0B70\u0BF3-\u0BF8\u0BFA\u0C7F\u0D4F\u0D79\u0F01-\u0F03\u0F13\u0F15-\u0F17\u0F1A-\u0F1F\u0F34\u0F36\u0F38\u0FBE-\u0FC5\u0FC7-\u0FCC\u0FCE\u0FCF\u0FD5-\u0FD8\u109E\u109F\u1390-\u1399\u166D\u1940\u19DE-\u19FF\u1B61-\u1B6A\u1B74-\u1B7C\u2100\u2101\u2103-\u2106\u2108\u2109\u2114\u2116\u2117\u211E-\u2123\u2125\u2127\u2129\u212E\u213A\u213B\u214A\u214C\u214D\u214F\u218A\u218B\u2195-\u2199\u219C-\u219F\u21A1\u21A2\u21A4\u21A5\u21A7-\u21AD\u21AF-\u21CD\u21D0\u21D1\u21D3\u21D5-\u21F3\u2300-\u2307\u230C-\u231F\u2322-\u2328\u232B-\u237B\u237D-\u239A\u23B4-\u23DB\u23E2-\u2429\u2440-\u244A\u249C-\u24E9\u2500-\u25B6\u25B8-\u25C0\u25C2-\u25F7\u2600-\u266E\u2670-\u2767\u2794-\u27BF\u2800-\u28FF\u2B00-\u2B2F\u2B45\u2B46\u2B4D-\u2B73\u2B76-\u2B95\u2B97-\u2BFF\u2CE5-\u2CEA\u2E50\u2E51\u2E80-\u2E99\u2E9B-\u2EF3\u2F00-\u2FD5\u2FF0-\u2FFF\u3004\u3012\u3013\u3020\u3036\u3037\u303E\u303F\u3190\u3191\u3196-\u319F\u31C0-\u31E5\u31EF\u3200-\u321E\u322A-\u3247\u3250\u3260-\u327F\u328A-\u32B0\u32C0-\u33FF\u4DC0-\u4DFF\uA490-\uA4C6\uA828-\uA82B\uA836\uA837\uA839\uAA77-\uAA79\uFD40-\uFD4F\uFDCF\uFDFD-\uFDFF\uFFE4\uFFE8\uFFED\uFFEE\uFFFC\uFFFD]|\uD800[\uDD37-\uDD3F\uDD79-\uDD89\uDD8C-\uDD8E\uDD90-\uDD9C\uDDA0\uDDD0-\uDDFC]|\uD802[\uDC77\uDC78\uDEC8]|\uD805\uDF3F|\uD807[\uDFD5-\uDFDC\uDFE1-\uDFF1]|\uD81A[\uDF3C-\uDF3F\uDF45]|\uD82F\uDC9C|\uD833[\uDC00-\uDCEF\uDD00-\uDEB3\uDF50-\uDFC3]|\uD834[\uDC00-\uDCF5\uDD00-\uDD26\uDD29-\uDD64\uDD6A-\uDD6C\uDD83\uDD84\uDD8C-\uDDA9\uDDAE-\uDDEA\uDE00-\uDE41\uDE45\uDF00-\uDF56]|\uD836[\uDC00-\uDDFF\uDE37-\uDE3A\uDE6D-\uDE74\uDE76-\uDE83\uDE85\uDE86]|\uD838\uDD4F|\uD83B[\uDCAC\uDD2E]|\uD83C[\uDC00-\uDC2B\uDC30-\uDC93\uDCA0-\uDCAE\uDCB1-\uDCBF\uDCC1-\uDCCF\uDCD1-\uDCF5\uDD0D-\uDDAD\uDDE6-\uDE02\uDE10-\uDE3B\uDE40-\uDE48\uDE50\uDE51\uDE60-\uDE65\uDF00-\uDFFA]|\uD83D[\uDC00-\uDED7\uDEDC-\uDEEC\uDEF0-\uDEFC\uDF00-\uDF76\uDF7B-\uDFD9\uDFE0-\uDFEB\uDFF0]|\uD83E[\uDC00-\uDC0B\uDC10-\uDC47\uDC50-\uDC59\uDC60-\uDC87\uDC90-\uDCAD\uDCB0-\uDCBB\uDCC0\uDCC1\uDD00-\uDE53\uDE60-\uDE6D\uDE70-\uDE7C\uDE80-\uDE89\uDE8F-\uDEC6\uDECE-\uDEDC\uDEDF-\uDEE9\uDEF0-\uDEF8\uDF00-\uDF92\uDF94-\uDFEF]))(?:[#\*0-9\xA9\xAE\u203C\u2049\u2122\u2139\u2194-\u2199\u21A9\u21AA\u231A\u231B\u2328\u23CF\u23E9-\u23F3\u23F8-\u23FA\u24C2\u25AA\u25AB\u25B6\u25C0\u25FB-\u25FE\u2600-\u2604\u260E\u2611\u2614\u2615\u2618\u261D\u2620\u2622\u2623\u2626\u262A\u262E\u262F\u2638-\u263A\u2640\u2642\u2648-\u2653\u265F\u2660\u2663\u2665\u2666\u2668\u267B\u267E\u267F\u2692-\u2697\u2699\u269B\u269C\u26A0\u26A1\u26A7\u26AA\u26AB\u26B0\u26B1\u26BD\u26BE\u26C4\u26C5\u26C8\u26CE\u26CF\u26D1\u26D3\u26D4\u26E9\u26EA\u26F0-\u26F5\u26F7-\u26FA\u26FD\u2702\u2705\u2708-\u270D\u270F\u2712\u2714\u2716\u271D\u2721\u2728\u2733\u2734\u2744\u2747\u274C\u274E\u2753-\u2755\u2757\u2763\u2764\u2795-\u2797\u27A1\u27B0\u27BF\u2934\u2935\u2B05-\u2B07\u2B1B\u2B1C\u2B50\u2B55\u3030\u303D\u3297\u3299]|\uD83C[\uDC04\uDCCF\uDD70\uDD71\uDD7E\uDD7F\uDD8E\uDD91-\uDD9A\uDDE6-\uDDFF\uDE01\uDE02\uDE1A\uDE2F\uDE32-\uDE3A\uDE50\uDE51\uDF00-\uDF21\uDF24-\uDF93\uDF96\uDF97\uDF99-\uDF9B\uDF9E-\uDFF0\uDFF3-\uDFF5\uDFF7-\uDFFF]|\uD83D[\uDC00-\uDCFD\uDCFF-\uDD3D\uDD49-\uDD4E\uDD50-\uDD67\uDD6F\uDD70\uDD73-\uDD7A\uDD87\uDD8A-\uDD8D\uDD90\uDD95\uDD96\uDDA4\uDDA5\uDDA8\uDDB1\uDDB2\uDDBC\uDDC2-\uDDC4\uDDD1-\uDDD3\uDDDC-\uDDDE\uDDE1\uDDE3\uDDE8\uDDEF\uDDF3\uDDFA-\uDE4F\uDE80-\uDEC5\uDECB-\uDED2\uDED5-\uDED7\uDEDC-\uDEE5\uDEE9\uDEEB\uDEEC\uDEF0\uDEF3-\uDEFC\uDFE0-\uDFEB\uDFF0]|\uD83E[\uDD0C-\uDD3A\uDD3C-\uDD45\uDD47-\uDDFF\uDE70-\uDE7C\uDE80-\uDE89\uDE8F-\uDEC6\uDECE-\uDEDC\uDEDF-\uDEE9\uDEF0-\uDEF8])(?:\uD83C[\uDFFB-\uDFFF])*/].map(function (e) {
              return e.source;
            }).join("|") + ")";
          return new RegExp("".concat(e, "|").concat(t, "(?:\u200D").concat(t, ")*"), "ug");
        }();
        function L(e, t) {
          var s = String(e).matchAll(F);
          return Array.from(s).some(function (e) {
            return e.index < t && t < e.index + e[0].length;
          });
        }
        var W = s("./node_modules/lodash-es/clone.js");
        var q = "$graveyard";
        var H = /*#__PURE__*/function () {
          function H(e) {
            var _this34 = this;
            _classCallCheck(this, H);
            this.model = e, this.version = 0, this.history = new N.Z(this), this.selection = new y.Z(this), this.roots = new I.Z({
              idProperty: "rootName"
            }), this.differ = new S(e.markers), this._postFixers = new Set(), this._hasSelectionChangedFromTheLastChangeBlock = !1, this.createRoot("$root", q), this.listenTo(e, "applyOperation", function (e, t) {
              var s = t[0];
              if (s.isDocumentOperation && s.baseVersion !== _this34.version) throw new o.ZP("model-document-applyoperation-wrong-version", _this34, {
                operation: s
              });
            }, {
              priority: "highest"
            }), this.listenTo(e, "applyOperation", function (e, t) {
              var s = t[0];
              s.isDocumentOperation && _this34.differ.bufferOperation(s);
            }, {
              priority: "high"
            }), this.listenTo(e, "applyOperation", function (e, t) {
              var s = t[0];
              s.isDocumentOperation && (_this34.version++, _this34.history.addOperation(s));
            }, {
              priority: "low"
            }), this.listenTo(this.selection, "change", function () {
              _this34._hasSelectionChangedFromTheLastChangeBlock = !0;
            }), this.listenTo(e.markers, "update", function (e, t, s, o, i) {
              var r = _objectSpread({}, t.getData(), {
                range: o
              });
              _this34.differ.bufferMarkerChange(t.name, i, r), null === s && t.on("change", function (e, s) {
                var o = t.getData();
                _this34.differ.bufferMarkerChange(t.name, _objectSpread({}, o, {
                  range: s
                }), o);
              });
            });
          }
          _createClass(H, [{
            key: "createRoot",
            value: function createRoot() {
              var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "$root";
              var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "main";
              if (this.roots.get(t)) throw new o.ZP("model-document-createroot-name-exists", this, {
                name: t
              });
              var s = new w(this, e, t);
              return this.roots.add(s), s;
            }
          }, {
            key: "destroy",
            value: function destroy() {
              this.selection.destroy(), this.stopListening();
            }
          }, {
            key: "getRoot",
            value: function getRoot() {
              var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "main";
              return this.roots.get(e);
            }
          }, {
            key: "getRootNames",
            value: function getRootNames() {
              return Array.from(this.roots, function (e) {
                return e.rootName;
              }).filter(function (e) {
                return e != q;
              });
            }
          }, {
            key: "registerPostFixer",
            value: function registerPostFixer(e) {
              this._postFixers.add(e);
            }
          }, {
            key: "toJSON",
            value: function toJSON() {
              var e = (0, W.Z)(this);
              return e.selection = "[engine.model.DocumentSelection]", e.model = "[engine.model.Model]", e;
            }
          }, {
            key: "_handleChangeBlock",
            value: function _handleChangeBlock(e) {
              this._hasDocumentChangedFromTheLastChangeBlock() && (this._callPostFixers(e), this.selection.refresh(), this.differ.hasDataChanges() ? this.fire("change:data", e.batch) : this.fire("change", e.batch), this.selection.refresh(), this.differ.reset()), this._hasSelectionChangedFromTheLastChangeBlock = !1;
            }
          }, {
            key: "_hasDocumentChangedFromTheLastChangeBlock",
            value: function _hasDocumentChangedFromTheLastChangeBlock() {
              return !this.differ.isEmpty || this._hasSelectionChangedFromTheLastChangeBlock;
            }
          }, {
            key: "_getDefaultRoot",
            value: function _getDefaultRoot() {
              var _iterator132 = _createForOfIteratorHelper(this.roots),
                _step132;
              try {
                for (_iterator132.s(); !(_step132 = _iterator132.n()).done;) {
                  var _e98 = _step132.value;
                  if (_e98 !== this.graveyard) return _e98;
                }
              } catch (err) {
                _iterator132.e(err);
              } finally {
                _iterator132.f();
              }
              return this.graveyard;
            }
          }, {
            key: "_getDefaultRange",
            value: function _getDefaultRange() {
              var e = this._getDefaultRoot(),
                t = this.model,
                s = t.schema,
                o = t.createPositionFromPath(e, [0]);
              return s.getNearestSelectionRange(o) || t.createRange(o);
            }
          }, {
            key: "_validateSelectionRange",
            value: function _validateSelectionRange(e) {
              return $(e.start) && $(e.end);
            }
          }, {
            key: "_callPostFixers",
            value: function _callPostFixers(e) {
              var t = !1;
              do {
                var _iterator133 = _createForOfIteratorHelper(this._postFixers),
                  _step133;
                try {
                  for (_iterator133.s(); !(_step133 = _iterator133.n()).done;) {
                    var _s67 = _step133.value;
                    if (this.selection.refresh(), t = _s67(e), t) break;
                  }
                } catch (err) {
                  _iterator133.e(err);
                } finally {
                  _iterator133.f();
                }
              } while (t);
            }
          }, {
            key: "graveyard",
            get: function get() {
              return this.getRoot(q);
            }
          }]);
          return H;
        }();
        function $(e) {
          var t = e.textNode;
          if (t) {
            var _s68 = t.data,
              _o30 = e.offset - t.startOffset;
            return !D(_s68, _o30) && !B(_s68, _o30);
          }
          return !0;
        }
        (0, V.Z)(H, z.ZP);
        var U = s("./packages/ckeditor5-engine/src/model/liverange.js");
        var K = /*#__PURE__*/function () {
          function K() {
            _classCallCheck(this, K);
            this._markers = new Map();
          }
          _createClass(K, [{
            key: Symbol.iterator,
            value: function value() {
              return this._markers.values();
            }
          }, {
            key: "has",
            value: function has(e) {
              var t = e instanceof G ? e.name : e;
              return this._markers.has(t);
            }
          }, {
            key: "get",
            value: function get(e) {
              return this._markers.get(e) || null;
            }
          }, {
            key: "_set",
            value: function _set(e, t) {
              var s = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : !1;
              var i = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : !1;
              var r = e instanceof G ? e.name : e;
              if (r.includes(",")) throw new o.ZP("markercollection-incorrect-marker-name", this);
              var n = this._markers.get(r);
              if (n) {
                var _e99 = n.getData(),
                  _o31 = n.getRange();
                var _a5 = !1;
                return _o31.isEqual(t) || (n._attachLiveRange(U.Z.fromRange(t)), _a5 = !0), s != n.managedUsingOperations && (n._managedUsingOperations = s, _a5 = !0), "boolean" == typeof i && i != n.affectsData && (n._affectsData = i, _a5 = !0), _a5 && this.fire("update:" + r, n, _o31, t, _e99), n;
              }
              var a = U.Z.fromRange(t),
                c = new G(r, a, s, i);
              return this._markers.set(r, c), this.fire("update:" + r, c, null, t, _objectSpread({}, c.getData(), {
                range: null
              })), c;
            }
          }, {
            key: "_remove",
            value: function _remove(e) {
              var t = e instanceof G ? e.name : e,
                s = this._markers.get(t);
              return !!s && (this._markers.delete(t), this.fire("update:" + t, s, s.getRange(), null, s.getData()), this._destroyMarker(s), !0);
            }
          }, {
            key: "_refresh",
            value: function _refresh(e) {
              var t = e instanceof G ? e.name : e,
                s = this._markers.get(t);
              if (!s) throw new o.ZP("markercollection-refresh-marker-not-exists", this);
              var i = s.getRange();
              this.fire("update:" + t, s, i, i, s.getData());
            }
          }, {
            key: "getMarkersAtPosition",
            value: /*#__PURE__*/_regeneratorRuntime().mark(function getMarkersAtPosition(e) {
              var _iterator134, _step134, _t84;
              return _regeneratorRuntime().wrap(function getMarkersAtPosition$(_context5) {
                while (1) switch (_context5.prev = _context5.next) {
                  case 0:
                    _iterator134 = _createForOfIteratorHelper(this);
                    _context5.prev = 1;
                    _iterator134.s();
                  case 3:
                    if ((_step134 = _iterator134.n()).done) {
                      _context5.next = 11;
                      break;
                    }
                    _t84 = _step134.value;
                    _context5.t0 = _t84.getRange().containsPosition(e);
                    if (!_context5.t0) {
                      _context5.next = 9;
                      break;
                    }
                    _context5.next = 9;
                    return _t84;
                  case 9:
                    _context5.next = 3;
                    break;
                  case 11:
                    _context5.next = 16;
                    break;
                  case 13:
                    _context5.prev = 13;
                    _context5.t1 = _context5["catch"](1);
                    _iterator134.e(_context5.t1);
                  case 16:
                    _context5.prev = 16;
                    _iterator134.f();
                    return _context5.finish(16);
                  case 19:
                  case "end":
                    return _context5.stop();
                }
              }, getMarkersAtPosition, this, [[1, 13, 16, 19]]);
            })
          }, {
            key: "getMarkersIntersectingRange",
            value: /*#__PURE__*/_regeneratorRuntime().mark(function getMarkersIntersectingRange(e) {
              var _iterator135, _step135, _t85;
              return _regeneratorRuntime().wrap(function getMarkersIntersectingRange$(_context6) {
                while (1) switch (_context6.prev = _context6.next) {
                  case 0:
                    _iterator135 = _createForOfIteratorHelper(this);
                    _context6.prev = 1;
                    _iterator135.s();
                  case 3:
                    if ((_step135 = _iterator135.n()).done) {
                      _context6.next = 11;
                      break;
                    }
                    _t85 = _step135.value;
                    _context6.t0 = null !== _t85.getRange().getIntersection(e);
                    if (!_context6.t0) {
                      _context6.next = 9;
                      break;
                    }
                    _context6.next = 9;
                    return _t85;
                  case 9:
                    _context6.next = 3;
                    break;
                  case 11:
                    _context6.next = 16;
                    break;
                  case 13:
                    _context6.prev = 13;
                    _context6.t1 = _context6["catch"](1);
                    _iterator135.e(_context6.t1);
                  case 16:
                    _context6.prev = 16;
                    _iterator135.f();
                    return _context6.finish(16);
                  case 19:
                  case "end":
                    return _context6.stop();
                }
              }, getMarkersIntersectingRange, this, [[1, 13, 16, 19]]);
            })
          }, {
            key: "destroy",
            value: function destroy() {
              var _iterator136 = _createForOfIteratorHelper(this._markers.values()),
                _step136;
              try {
                for (_iterator136.s(); !(_step136 = _iterator136.n()).done;) {
                  var _e100 = _step136.value;
                  this._destroyMarker(_e100);
                }
              } catch (err) {
                _iterator136.e(err);
              } finally {
                _iterator136.f();
              }
              this._markers = null, this.stopListening();
            }
          }, {
            key: "getMarkersGroup",
            value: /*#__PURE__*/_regeneratorRuntime().mark(function getMarkersGroup(e) {
              var _iterator137, _step137, _t86;
              return _regeneratorRuntime().wrap(function getMarkersGroup$(_context7) {
                while (1) switch (_context7.prev = _context7.next) {
                  case 0:
                    _iterator137 = _createForOfIteratorHelper(this._markers.values());
                    _context7.prev = 1;
                    _iterator137.s();
                  case 3:
                    if ((_step137 = _iterator137.n()).done) {
                      _context7.next = 11;
                      break;
                    }
                    _t86 = _step137.value;
                    _context7.t0 = _t86.name.startsWith(e + ":");
                    if (!_context7.t0) {
                      _context7.next = 9;
                      break;
                    }
                    _context7.next = 9;
                    return _t86;
                  case 9:
                    _context7.next = 3;
                    break;
                  case 11:
                    _context7.next = 16;
                    break;
                  case 13:
                    _context7.prev = 13;
                    _context7.t1 = _context7["catch"](1);
                    _iterator137.e(_context7.t1);
                  case 16:
                    _context7.prev = 16;
                    _iterator137.f();
                    return _context7.finish(16);
                  case 19:
                  case "end":
                    return _context7.stop();
                }
              }, getMarkersGroup, this, [[1, 13, 16, 19]]);
            })
          }, {
            key: "_destroyMarker",
            value: function _destroyMarker(e) {
              e.stopListening(), e._detachLiveRange();
            }
          }]);
          return K;
        }();
        (0, V.Z)(K, z.ZP);
        var G = /*#__PURE__*/function () {
          function G(e, t, s, o) {
            _classCallCheck(this, G);
            this.name = e, this._liveRange = this._attachLiveRange(t), this._managedUsingOperations = s, this._affectsData = o;
          }
          _createClass(G, [{
            key: "getData",
            value: function getData() {
              return {
                range: this.getRange(),
                affectsData: this.affectsData,
                managedUsingOperations: this.managedUsingOperations
              };
            }
          }, {
            key: "getStart",
            value: function getStart() {
              if (!this._liveRange) throw new o.ZP("marker-destroyed", this);
              return this._liveRange.start.clone();
            }
          }, {
            key: "getEnd",
            value: function getEnd() {
              if (!this._liveRange) throw new o.ZP("marker-destroyed", this);
              return this._liveRange.end.clone();
            }
          }, {
            key: "getRange",
            value: function getRange() {
              if (!this._liveRange) throw new o.ZP("marker-destroyed", this);
              return this._liveRange.toRange();
            }
          }, {
            key: "is",
            value: function is(e) {
              return "marker" === e || "model:marker" === e;
            }
          }, {
            key: "_attachLiveRange",
            value: function _attachLiveRange(e) {
              return this._liveRange && this._detachLiveRange(), e.delegate("change:range").to(this), e.delegate("change:content").to(this), this._liveRange = e, e;
            }
          }, {
            key: "_detachLiveRange",
            value: function _detachLiveRange() {
              this._liveRange.stopDelegating("change:range", this), this._liveRange.stopDelegating("change:content", this), this._liveRange.detach(), this._liveRange = null;
            }
          }, {
            key: "managedUsingOperations",
            get: function get() {
              if (!this._liveRange) throw new o.ZP("marker-destroyed", this);
              return this._managedUsingOperations;
            }
          }, {
            key: "affectsData",
            get: function get() {
              if (!this._liveRange) throw new o.ZP("marker-destroyed", this);
              return this._affectsData;
            }
          }]);
          return G;
        }();
        (0, V.Z)(G, z.ZP);
        var J = s("./packages/ckeditor5-utils/src/observablemixin.js"),
          X = s("./packages/ckeditor5-engine/src/model/selection.js"),
          Q = s("./packages/ckeditor5-engine/src/model/operation/operationfactory.js"),
          Y = s("./packages/ckeditor5-engine/src/model/liveposition.js");
        var ee = /*#__PURE__*/function () {
          function ee(e, t, s) {
            _classCallCheck(this, ee);
            this.model = e, this.writer = t, this.position = s, this.canMergeWith = new Set([this.position.parent]), this.schema = e.schema, this._documentFragment = t.createDocumentFragment(), this._documentFragmentPosition = t.createPositionAt(this._documentFragment, 0), this._firstNode = null, this._lastNode = null, this._lastAutoParagraph = null, this._filterAttributesOf = [], this._affectedStart = null, this._affectedEnd = null;
          }
          _createClass(ee, [{
            key: "handleNodes",
            value: function handleNodes(e) {
              for (var _i36 = 0, _Array$from6 = Array.from(e); _i36 < _Array$from6.length; _i36++) {
                var _t87 = _Array$from6[_i36];
                this._handleNode(_t87);
              }
              this._insertPartialFragment(), this._lastAutoParagraph && this._updateLastNodeFromAutoParagraph(this._lastAutoParagraph), this._mergeOnRight(), this.schema.removeDisallowedAttributes(this._filterAttributesOf, this.writer), this._filterAttributesOf = [];
            }
          }, {
            key: "_updateLastNodeFromAutoParagraph",
            value: function _updateLastNodeFromAutoParagraph(e) {
              var t = this.writer.createPositionAfter(this._lastNode),
                s = this.writer.createPositionAfter(e);
              if (s.isAfter(t)) {
                if (this._lastNode = e, this.position.parent != e || !this.position.isAtEnd) throw new o.ZP("insertcontent-invalid-insertion-position", this);
                this.position = s, this._setAffectedBoundaries(this.position);
              }
            }
          }, {
            key: "getSelectionRange",
            value: function getSelectionRange() {
              return this.nodeToSelect ? a.Z._createOn(this.nodeToSelect) : this.model.schema.getNearestSelectionRange(this.position);
            }
          }, {
            key: "getAffectedRange",
            value: function getAffectedRange() {
              return this._affectedStart ? new a.Z(this._affectedStart, this._affectedEnd) : null;
            }
          }, {
            key: "destroy",
            value: function destroy() {
              this._affectedStart && this._affectedStart.detach(), this._affectedEnd && this._affectedEnd.detach();
            }
          }, {
            key: "_handleNode",
            value: function _handleNode(e) {
              if (this.schema.isObject(e)) return void this._handleObject(e);
              var t = this._checkAndAutoParagraphToAllowedPosition(e);
              t || (t = this._checkAndSplitToAllowedPosition(e), t) ? (this._appendToFragment(e), this._firstNode || (this._firstNode = e), this._lastNode = e) : this._handleDisallowedNode(e);
            }
          }, {
            key: "_insertPartialFragment",
            value: function _insertPartialFragment() {
              if (this._documentFragment.isEmpty) return;
              var e = Y.Z.fromPosition(this.position, "toNext");
              this._setAffectedBoundaries(this.position), this._documentFragment.getChild(0) == this._firstNode && (this.writer.insert(this._firstNode, this.position), this._mergeOnLeft(), this.position = e.toPosition()), this._documentFragment.isEmpty || this.writer.insert(this._documentFragment, this.position), this._documentFragmentPosition = this.writer.createPositionAt(this._documentFragment, 0), this.position = e.toPosition(), e.detach();
            }
          }, {
            key: "_handleObject",
            value: function _handleObject(e) {
              this._checkAndSplitToAllowedPosition(e) ? this._appendToFragment(e) : this._tryAutoparagraphing(e);
            }
          }, {
            key: "_handleDisallowedNode",
            value: function _handleDisallowedNode(e) {
              e.is("element") ? this.handleNodes(e.getChildren()) : this._tryAutoparagraphing(e);
            }
          }, {
            key: "_appendToFragment",
            value: function _appendToFragment(e) {
              if (!this.schema.checkChild(this.position, e)) throw new o.ZP("insertcontent-wrong-position", this, {
                node: e,
                position: this.position
              });
              this.writer.insert(e, this._documentFragmentPosition), this._documentFragmentPosition = this._documentFragmentPosition.getShiftedBy(e.offsetSize), this.schema.isObject(e) && !this.schema.checkChild(this.position, "$text") ? this.nodeToSelect = e : this.nodeToSelect = null, this._filterAttributesOf.push(e);
            }
          }, {
            key: "_setAffectedBoundaries",
            value: function _setAffectedBoundaries(e) {
              this._affectedStart || (this._affectedStart = Y.Z.fromPosition(e, "toPrevious")), this._affectedEnd && !this._affectedEnd.isBefore(e) || (this._affectedEnd && this._affectedEnd.detach(), this._affectedEnd = Y.Z.fromPosition(e, "toNext"));
            }
          }, {
            key: "_mergeOnLeft",
            value: function _mergeOnLeft() {
              var e = this._firstNode;
              if (!(e instanceof b.Z)) return;
              if (!this._canMergeLeft(e)) return;
              var t = Y.Z._createBefore(e);
              t.stickiness = "toNext";
              var s = Y.Z.fromPosition(this.position, "toNext");
              this._affectedStart.isEqual(t) && (this._affectedStart.detach(), this._affectedStart = Y.Z._createAt(t.nodeBefore, "end", "toPrevious")), this._firstNode === this._lastNode && (this._firstNode = t.nodeBefore, this._lastNode = t.nodeBefore), this.writer.merge(t), t.isEqual(this._affectedEnd) && this._firstNode === this._lastNode && (this._affectedEnd.detach(), this._affectedEnd = Y.Z._createAt(t.nodeBefore, "end", "toNext")), this.position = s.toPosition(), s.detach(), this._filterAttributesOf.push(this.position.parent), t.detach();
            }
          }, {
            key: "_mergeOnRight",
            value: function _mergeOnRight() {
              var e = this._lastNode;
              if (!(e instanceof b.Z)) return;
              if (!this._canMergeRight(e)) return;
              var t = Y.Z._createAfter(e);
              if (t.stickiness = "toNext", !this.position.isEqual(t)) throw new o.ZP("insertcontent-invalid-insertion-position", this);
              this.position = v.ZP._createAt(t.nodeBefore, "end");
              var s = Y.Z.fromPosition(this.position, "toPrevious");
              this._affectedEnd.isEqual(t) && (this._affectedEnd.detach(), this._affectedEnd = Y.Z._createAt(t.nodeBefore, "end", "toNext")), this._firstNode === this._lastNode && (this._firstNode = t.nodeBefore, this._lastNode = t.nodeBefore), this.writer.merge(t), t.getShiftedBy(-1).isEqual(this._affectedStart) && this._firstNode === this._lastNode && (this._affectedStart.detach(), this._affectedStart = Y.Z._createAt(t.nodeBefore, 0, "toPrevious")), this.position = s.toPosition(), s.detach(), this._filterAttributesOf.push(this.position.parent), t.detach();
            }
          }, {
            key: "_canMergeLeft",
            value: function _canMergeLeft(e) {
              var t = e.previousSibling;
              return t instanceof b.Z && this.canMergeWith.has(t) && this.model.schema.checkMerge(t, e);
            }
          }, {
            key: "_canMergeRight",
            value: function _canMergeRight(e) {
              var t = e.nextSibling;
              return t instanceof b.Z && this.canMergeWith.has(t) && this.model.schema.checkMerge(e, t);
            }
          }, {
            key: "_tryAutoparagraphing",
            value: function _tryAutoparagraphing(e) {
              var t = this.writer.createElement("paragraph");
              this._getAllowedIn(this.position.parent, t) && this.schema.checkChild(t, e) && (t._appendChild(e), this._handleNode(t));
            }
          }, {
            key: "_checkAndAutoParagraphToAllowedPosition",
            value: function _checkAndAutoParagraphToAllowedPosition(e) {
              if (this.schema.checkChild(this.position.parent, e)) return !0;
              if (!this.schema.checkChild(this.position.parent, "paragraph") || !this.schema.checkChild("paragraph", e)) return !1;
              this._insertPartialFragment();
              var t = this.writer.createElement("paragraph");
              return this.writer.insert(t, this.position), this._setAffectedBoundaries(this.position), this._lastAutoParagraph = t, this.position = this.writer.createPositionAt(t, 0), !0;
            }
          }, {
            key: "_checkAndSplitToAllowedPosition",
            value: function _checkAndSplitToAllowedPosition(e) {
              var t = this._getAllowedIn(this.position.parent, e);
              if (!t) return !1;
              for (t != this.position.parent && this._insertPartialFragment(); t != this.position.parent;) if (this.position.isAtStart) {
                var _e101 = this.position.parent;
                this.position = this.writer.createPositionBefore(_e101), _e101.isEmpty && _e101.parent === t && this.writer.remove(_e101);
              } else if (this.position.isAtEnd) this.position = this.writer.createPositionAfter(this.position.parent);else {
                var _e102 = this.writer.createPositionAfter(this.position.parent);
                this._setAffectedBoundaries(this.position), this.writer.split(this.position), this.position = _e102, this.canMergeWith.add(this.position.nodeAfter);
              }
              return !0;
            }
          }, {
            key: "_getAllowedIn",
            value: function _getAllowedIn(e, t) {
              return this.schema.checkChild(e, t) ? e : this.schema.isLimit(e) ? null : this._getAllowedIn(e.parent, t);
            }
          }]);
          return ee;
        }();
        function te(e, t) {
          var s = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
          if (t.isCollapsed) return;
          var o = t.getFirstRange();
          if ("$graveyard" == o.root.rootName) return;
          var i = e.schema;
          e.change(function (e) {
            if (!s.doNotResetEntireContent && function (e, t) {
              var s = e.getLimitElement(t);
              if (!t.containsEntireContent(s)) return !1;
              var o = t.getFirstRange();
              if (o.start.parent == o.end.parent) return !1;
              return e.checkChild(s, "paragraph");
            }(i, t)) return void function (e, t) {
              var s = e.model.schema.getLimitElement(t);
              e.remove(e.createRangeIn(s)), re(e, e.createPositionAt(s, 0), t);
            }(e, t);
            var _ref12 = function (e) {
                var t = e.root.document.model,
                  s = e.start;
                var o = e.end;
                if (t.hasContent(e, {
                  ignoreMarkers: !0
                })) {
                  var _s69 = function (e) {
                    var t = e.parent,
                      s = t.root.document.model.schema,
                      o = t.getAncestors({
                        parentFirst: !0,
                        includeSelf: !0
                      });
                    var _iterator138 = _createForOfIteratorHelper(o),
                      _step138;
                    try {
                      for (_iterator138.s(); !(_step138 = _iterator138.n()).done;) {
                        var _e103 = _step138.value;
                        if (s.isLimit(_e103)) return null;
                        if (s.isBlock(_e103)) return _e103;
                      }
                    } catch (err) {
                      _iterator138.e(err);
                    } finally {
                      _iterator138.f();
                    }
                  }(o);
                  if (_s69 && o.isTouching(t.createPositionAt(_s69, 0))) {
                    var _s70 = t.createSelection(e);
                    t.modifySelection(_s70, {
                      direction: "backward"
                    });
                    var _i37 = _s70.getLastPosition(),
                      _r16 = t.createRange(_i37, o);
                    t.hasContent(_r16, {
                      ignoreMarkers: !0
                    }) || (o = _i37);
                  }
                }
                return [Y.Z.fromPosition(s, "toPrevious"), Y.Z.fromPosition(o, "toNext")];
              }(o),
              _ref13 = _slicedToArray(_ref12, 2),
              r = _ref13[0],
              n = _ref13[1];
            r.isTouching(n) || e.remove(e.createRange(r, n)), s.leaveUnmerged || (!function (e, t, s) {
              var o = e.model;
              if (!ie(e.model.schema, t, s)) return;
              var _ref14 = function (e, t) {
                  var s = e.getAncestors(),
                    o = t.getAncestors();
                  var i = 0;
                  for (; s[i] && s[i] == o[i];) i++;
                  return [s[i], o[i]];
                }(t, s),
                _ref15 = _slicedToArray(_ref14, 2),
                i = _ref15[0],
                r = _ref15[1];
              if (!i || !r) return;
              !o.hasContent(i, {
                ignoreMarkers: !0
              }) && o.hasContent(r, {
                ignoreMarkers: !0
              }) ? oe(e, t, s, i.parent) : se(e, t, s, i.parent);
            }(e, r, n), i.removeDisallowedAttributes(r.parent.getChildren(), e)), ne(e, t, r), !s.doNotAutoparagraph && function (e, t) {
              var s = e.checkChild(t, "$text"),
                o = e.checkChild(t, "paragraph");
              return !s && o;
            }(i, r) && re(e, r, t), r.detach(), n.detach();
          });
        }
        function se(e, t, s, o) {
          var i = t.parent,
            r = s.parent;
          if (i != o && r != o) {
            for (t = e.createPositionAfter(i), (s = e.createPositionBefore(r)).isEqual(t) || e.insert(r, t), e.merge(t); s.parent.isEmpty;) {
              var _t88 = s.parent;
              s = e.createPositionBefore(_t88), e.remove(_t88);
            }
            ie(e.model.schema, t, s) && se(e, t, s, o);
          }
        }
        function oe(e, t, s, o) {
          var i = t.parent,
            r = s.parent;
          if (i != o && r != o) {
            for (t = e.createPositionAfter(i), (s = e.createPositionBefore(r)).isEqual(t) || e.insert(i, s); t.parent.isEmpty;) {
              var _s71 = t.parent;
              t = e.createPositionBefore(_s71), e.remove(_s71);
            }
            s = e.createPositionBefore(r), function (e, t) {
              var s = t.nodeBefore,
                o = t.nodeAfter;
              s.name != o.name && e.rename(s, o.name);
              e.clearAttributes(s), e.setAttributes(Object.fromEntries(o.getAttributes()), s), e.merge(t);
            }(e, s), ie(e.model.schema, t, s) && oe(e, t, s, o);
          }
        }
        function ie(e, t, s) {
          var o = t.parent,
            i = s.parent;
          return o != i && !e.isLimit(o) && !e.isLimit(i) && function (e, t, s) {
            var o = new a.Z(e, t);
            var _iterator139 = _createForOfIteratorHelper(o.getWalker()),
              _step139;
            try {
              for (_iterator139.s(); !(_step139 = _iterator139.n()).done;) {
                var _e104 = _step139.value;
                if (s.isLimit(_e104.item)) return !1;
              }
            } catch (err) {
              _iterator139.e(err);
            } finally {
              _iterator139.f();
            }
            return !0;
          }(t, s, e);
        }
        function re(e, t, s) {
          var o = e.createElement("paragraph");
          e.insert(o, t), ne(e, s, e.createPositionAt(o, 0));
        }
        function ne(e, t, s) {
          t instanceof y.Z ? e.setSelection(s) : t.setTo(s);
        }
        var ae = s("./packages/ckeditor5-engine/src/model/treewalker.js");
        var ce = ' ,.?!:;"-()';
        function le(e, t) {
          var s = e.isForward,
            o = e.walker,
            i = e.unit,
            r = e.schema,
            n = e.treatEmojiAsSingleUnit,
            a = t.type,
            c = t.item,
            l = t.nextPosition;
          if ("text" == a) return "word" === e.unit ? function (e, t) {
            var s = e.position.textNode;
            if (s) {
              var _o32 = e.position.offset - s.startOffset;
              for (; !he(s.data, _o32, t) && !ue(s, _o32, t);) {
                e.next();
                var _i38 = t ? e.position.nodeAfter : e.position.nodeBefore;
                if (_i38 && _i38.is("$text")) {
                  var _o33 = _i38.data.charAt(t ? 0 : _i38.data.length - 1);
                  ce.includes(_o33) || (e.next(), s = e.position.textNode);
                }
                _o32 = e.position.offset - s.startOffset;
              }
            }
            return e.position;
          }(o, s) : function (e, t, s) {
            var o = e.position.textNode;
            if (o) {
              var _i39 = o.data;
              var _r17 = e.position.offset - o.startOffset;
              for (; D(_i39, _r17) || "character" == t && B(_i39, _r17) || s && L(_i39, _r17);) e.next(), _r17 = e.position.offset - o.startOffset;
            }
            return e.position;
          }(o, i, n);
          if (a == (s ? "elementStart" : "elementEnd")) {
            if (r.isSelectable(c)) return v.ZP._createAt(c, s ? "after" : "before");
            if (r.checkChild(l, "$text")) return l;
          } else {
            if (r.isLimit(c)) return void o.skip(function () {
              return !0;
            });
            if (r.checkChild(l, "$text")) return l;
          }
        }
        function de(e, t) {
          var s = e.root,
            o = v.ZP._createAt(s, t ? "end" : 0);
          return t ? new a.Z(e, o) : new a.Z(o, e);
        }
        function he(e, t, s) {
          var o = t + (s ? 0 : -1);
          return ce.includes(e.charAt(o));
        }
        function ue(e, t, s) {
          return t === (s ? e.endOffset : 0);
        }
        function ge(e, t) {
          var s = [];
          Array.from(e.getItems({
            direction: "backward"
          })).map(function (e) {
            return t.createRangeOn(e);
          }).filter(function (t) {
            return (t.start.isAfter(e.start) || t.start.isEqual(e.start)) && (t.end.isBefore(e.end) || t.end.isEqual(e.end));
          }).forEach(function (e) {
            s.push(e.start.parent), t.remove(e);
          }), s.forEach(function (e) {
            var s = e;
            for (; s.parent && s.isEmpty;) {
              var _e105 = t.createRangeOn(s);
              s = s.parent, t.remove(_e105);
            }
          });
        }
        function pe(e) {
          e.document.registerPostFixer(function (t) {
            return function (e, t) {
              var s = t.document.selection,
                o = t.schema,
                i = [];
              var r = !1;
              var _iterator140 = _createForOfIteratorHelper(s.getRanges()),
                _step140;
              try {
                for (_iterator140.s(); !(_step140 = _iterator140.n()).done;) {
                  var _e107 = _step140.value;
                  var _t89 = fe(_e107, o);
                  _t89 && !_t89.isEqual(_e107) ? (i.push(_t89), r = !0) : i.push(_e107);
                }
              } catch (err) {
                _iterator140.e(err);
              } finally {
                _iterator140.f();
              }
              r && e.setSelection(function (e) {
                var t = _toConsumableArray(e),
                  s = new Set();
                var o = 1;
                for (; o < t.length;) {
                  var _e106 = t[o],
                    _i40 = t.slice(0, o);
                  var _iterator141 = _createForOfIteratorHelper(_i40.entries()),
                    _step141;
                  try {
                    for (_iterator141.s(); !(_step141 = _iterator141.n()).done;) {
                      var _step141$value = _slicedToArray(_step141.value, 2),
                        _r18 = _step141$value[0],
                        _n8 = _step141$value[1];
                      if (!s.has(_r18)) if (_e106.isEqual(_n8)) s.add(_r18);else if (_e106.isIntersecting(_n8)) {
                        s.add(_r18), s.add(o);
                        var _i41 = _e106.getJoined(_n8);
                        t.push(_i41);
                      }
                    }
                  } catch (err) {
                    _iterator141.e(err);
                  } finally {
                    _iterator141.f();
                  }
                  o++;
                }
                return t.filter(function (e, t) {
                  return !s.has(t);
                });
              }(i), {
                backward: s.isBackward
              });
            }(t, e);
          });
        }
        function fe(e, t) {
          return e.isCollapsed ? function (e, t) {
            var s = e.start,
              o = t.getNearestSelectionRange(s);
            if (!o) {
              var _e108 = s.getAncestors().reverse().find(function (e) {
                return t.isObject(e);
              });
              return _e108 ? a.Z._createOn(_e108) : null;
            }
            if (!o.isCollapsed) return o;
            var i = o.start;
            if (s.isEqual(i)) return null;
            return new a.Z(i);
          }(e, t) : function (e, t) {
            var s = e.start,
              o = e.end,
              i = t.checkChild(s, "$text"),
              r = t.checkChild(o, "$text"),
              n = t.getLimitElement(s),
              c = t.getLimitElement(o);
            if (n === c) {
              if (i && r) return null;
              if (function (e, t, s) {
                var o = e.nodeAfter && !s.isLimit(e.nodeAfter) || s.checkChild(e, "$text"),
                  i = t.nodeBefore && !s.isLimit(t.nodeBefore) || s.checkChild(t, "$text");
                return o || i;
              }(s, o, t)) {
                var _e109 = s.nodeAfter && t.isSelectable(s.nodeAfter) ? null : t.getNearestSelectionRange(s, "forward"),
                  _i42 = o.nodeBefore && t.isSelectable(o.nodeBefore) ? null : t.getNearestSelectionRange(o, "backward"),
                  _r19 = _e109 ? _e109.start : s,
                  _n9 = _i42 ? _i42.end : o;
                return new a.Z(_r19, _n9);
              }
            }
            var l = n && !n.is("rootElement"),
              d = c && !c.is("rootElement");
            if (l || d) {
              var _e110 = s.nodeAfter && o.nodeBefore && s.nodeAfter.parent === o.nodeBefore.parent,
                _i43 = l && (!_e110 || !ke(s.nodeAfter, t)),
                _r20 = d && (!_e110 || !ke(o.nodeBefore, t));
              var _h = s,
                _u = o;
              return _i43 && (_h = v.ZP._createBefore(me(n, t))), _r20 && (_u = v.ZP._createAfter(me(c, t))), new a.Z(_h, _u);
            }
            return null;
          }(e, t);
        }
        function me(e, t) {
          var s = e,
            o = s;
          for (; t.isLimit(o) && o.parent;) s = o, o = o.parent;
          return s;
        }
        function ke(e, t) {
          return e && t.isSelectable(e);
        }
        var _e = s("./packages/ckeditor5-engine/src/model/utils/autoparagraphing.js");
        var be = /*#__PURE__*/function () {
          function be() {
            var _this35 = this;
            _classCallCheck(this, be);
            this.markers = new K(), this.document = new H(this), this.schema = new E.Z(), this._pendingChanges = [], this._currentWriter = null, ["insertContent", "deleteContent", "modifySelection", "getSelectedContent", "applyOperation"].forEach(function (e) {
              return _this35.decorate(e);
            }), this.on("applyOperation", function (e, t) {
              t[0]._validate();
            }, {
              priority: "highest"
            }), this.schema.register("$root", {
              isLimit: !0
            }), this.schema.register("$block", {
              allowIn: "$root",
              isBlock: !0
            }), this.schema.register("$text", {
              allowIn: "$block",
              isInline: !0,
              isContent: !0
            }), this.schema.register("$clipboardHolder", {
              allowContentOf: "$root",
              allowChildren: "$text",
              isLimit: !0
            }), this.schema.register("$documentFragment", {
              allowContentOf: "$root",
              allowChildren: "$text",
              isLimit: !0
            }), this.schema.register("$marker"), this.schema.addChildCheck(function (e, t) {
              if ("$marker" === t.name) return !0;
            }), pe(this), this.document.registerPostFixer(_e._m);
          }
          _createClass(be, [{
            key: "change",
            value: function change(e) {
              try {
                return 0 === this._pendingChanges.length ? (this._pendingChanges.push({
                  batch: new i(),
                  callback: e
                }), this._runPendingChanges()[0]) : e(this._currentWriter);
              } catch (e) {
                o.ZP.rethrowUnexpectedError(e, this);
              }
            }
          }, {
            key: "enqueueChange",
            value: function enqueueChange(e, t) {
              try {
                e ? "function" == typeof e ? (t = e, e = new i()) : e instanceof i || (e = new i(e)) : e = new i(), this._pendingChanges.push({
                  batch: e,
                  callback: t
                }), 1 == this._pendingChanges.length && this._runPendingChanges();
              } catch (e) {
                o.ZP.rethrowUnexpectedError(e, this);
              }
            }
          }, {
            key: "applyOperation",
            value: function applyOperation(e) {
              e._execute();
            }
          }, {
            key: "insertContent",
            value: function insertContent(e, t, s) {
              return function (e, t, s, o) {
                return e.change(function (i) {
                  var r;
                  r = s ? s instanceof X.Z || s instanceof y.Z ? s : i.createSelection(s, o) : e.document.selection, r.isCollapsed || e.deleteContent(r, {
                    doNotAutoparagraph: !0
                  });
                  var n = new ee(e, i, r.anchor);
                  var a;
                  a = t.is("documentFragment") ? t.getChildren() : [t], n.handleNodes(a);
                  var c = n.getSelectionRange();
                  c && (r instanceof y.Z ? i.setSelection(c) : r.setTo(c));
                  var l = n.getAffectedRange() || e.createRange(r.anchor);
                  return n.destroy(), l;
                });
              }(this, e, t, s);
            }
          }, {
            key: "deleteContent",
            value: function deleteContent(e, t) {
              te(this, e, t);
            }
          }, {
            key: "modifySelection",
            value: function modifySelection(e, t) {
              !function (e, t) {
                var s = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                var o = e.schema,
                  i = "backward" != s.direction,
                  r = s.unit ? s.unit : "character",
                  n = !!s.treatEmojiAsSingleUnit,
                  a = t.focus,
                  c = new ae.Z({
                    boundaries: de(a, i),
                    singleCharacters: !0,
                    direction: i ? "forward" : "backward"
                  }),
                  l = {
                    walker: c,
                    schema: o,
                    isForward: i,
                    unit: r,
                    treatEmojiAsSingleUnit: n
                  };
                var d;
                var _loop2 = function _loop2() {
                    if (d.done) return {
                      v: void 0
                    };
                    var s = le(l, d.value);
                    if (s) return {
                      v: void (t instanceof y.Z ? e.change(function (e) {
                        e.setSelectionFocus(s);
                      }) : t.setFocus(s))
                    };
                  },
                  _ret;
                for (; d = c.next();) {
                  _ret = _loop2();
                  if (_ret) return _ret.v;
                }
              }(this, e, t);
            }
          }, {
            key: "getSelectedContent",
            value: function getSelectedContent(e) {
              return function (e, t) {
                return e.change(function (e) {
                  var s = e.createDocumentFragment(),
                    o = t.getFirstRange();
                  if (!o || o.isCollapsed) return s;
                  var i = o.start.root,
                    r = o.start.getCommonPath(o.end),
                    n = i.getNodeByPath(r);
                  var a;
                  a = o.start.parent == o.end.parent ? o : e.createRange(e.createPositionAt(n, o.start.path[r.length]), e.createPositionAt(n, o.end.path[r.length] + 1));
                  var c = a.end.offset - a.start.offset;
                  var _iterator142 = _createForOfIteratorHelper(a.getItems({
                      shallow: !0
                    })),
                    _step142;
                  try {
                    for (_iterator142.s(); !(_step142 = _iterator142.n()).done;) {
                      var _t91 = _step142.value;
                      _t91.is("$textProxy") ? e.appendText(_t91.data, _t91.getAttributes(), s) : e.append(e.cloneElement(_t91, !0), s);
                    }
                  } catch (err) {
                    _iterator142.e(err);
                  } finally {
                    _iterator142.f();
                  }
                  if (a != o) {
                    var _t90 = o._getTransformedByMove(a.start, e.createPositionAt(s, 0), c)[0],
                      _i44 = e.createRange(e.createPositionAt(s, 0), _t90.start);
                    ge(e.createRange(_t90.end, e.createPositionAt(s, "end")), e), ge(_i44, e);
                  }
                  return s;
                });
              }(this, e);
            }
          }, {
            key: "hasContent",
            value: function hasContent(e) {
              var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
              var s = e instanceof b.Z ? a.Z._createIn(e) : e;
              if (s.isCollapsed) return !1;
              var _t$ignoreWhitespaces = t.ignoreWhitespaces,
                o = _t$ignoreWhitespaces === void 0 ? !1 : _t$ignoreWhitespaces,
                _t$ignoreMarkers = t.ignoreMarkers,
                i = _t$ignoreMarkers === void 0 ? !1 : _t$ignoreMarkers;
              if (!i) {
                var _iterator143 = _createForOfIteratorHelper(this.markers.getMarkersIntersectingRange(s)),
                  _step143;
                try {
                  for (_iterator143.s(); !(_step143 = _iterator143.n()).done;) {
                    var _e111 = _step143.value;
                    if (_e111.affectsData) return !0;
                  }
                } catch (err) {
                  _iterator143.e(err);
                } finally {
                  _iterator143.f();
                }
              }
              var _iterator144 = _createForOfIteratorHelper(s.getItems()),
                _step144;
              try {
                for (_iterator144.s(); !(_step144 = _iterator144.n()).done;) {
                  var _e112 = _step144.value;
                  if (this.schema.isContent(_e112)) {
                    if (!_e112.is("$textProxy")) return !0;
                    if (!o) return !0;
                    if (-1 !== _e112.data.search(/\S/)) return !0;
                  }
                }
              } catch (err) {
                _iterator144.e(err);
              } finally {
                _iterator144.f();
              }
              return !1;
            }
          }, {
            key: "createPositionFromPath",
            value: function createPositionFromPath(e, t, s) {
              return new v.ZP(e, t, s);
            }
          }, {
            key: "createPositionAt",
            value: function createPositionAt(e, t) {
              return v.ZP._createAt(e, t);
            }
          }, {
            key: "createPositionAfter",
            value: function createPositionAfter(e) {
              return v.ZP._createAfter(e);
            }
          }, {
            key: "createPositionBefore",
            value: function createPositionBefore(e) {
              return v.ZP._createBefore(e);
            }
          }, {
            key: "createRange",
            value: function createRange(e, t) {
              return new a.Z(e, t);
            }
          }, {
            key: "createRangeIn",
            value: function createRangeIn(e) {
              return a.Z._createIn(e);
            }
          }, {
            key: "createRangeOn",
            value: function createRangeOn(e) {
              return a.Z._createOn(e);
            }
          }, {
            key: "createSelection",
            value: function createSelection(e, t, s) {
              return new X.Z(e, t, s);
            }
          }, {
            key: "createBatch",
            value: function createBatch(e) {
              return new i(e);
            }
          }, {
            key: "createOperationFromJSON",
            value: function createOperationFromJSON(e) {
              return Q.Z.fromJSON(e, this.document);
            }
          }, {
            key: "destroy",
            value: function destroy() {
              this.document.destroy(), this.stopListening();
            }
          }, {
            key: "_runPendingChanges",
            value: function _runPendingChanges() {
              var e = [];
              for (this.fire("_beforeChanges"); this._pendingChanges.length;) {
                var _t92 = this._pendingChanges[0].batch;
                this._currentWriter = new P(this, _t92);
                var _s72 = this._pendingChanges[0].callback(this._currentWriter);
                e.push(_s72), this.document._handleChangeBlock(this._currentWriter), this._pendingChanges.shift(), this._currentWriter = null;
              }
              return this.fire("_afterChanges"), e;
            }
          }]);
          return be;
        }();
        (0, V.Z)(be, J.Z);
      },
      "./packages/ckeditor5-engine/src/model/node.js": function _packages_ckeditor5Engine_src_model_nodeJs(e, t, s) {
        "use strict";

        s.d(t, {
          Z: function Z() {
            return n;
          }
        });
        var o = s("./packages/ckeditor5-utils/src/tomap.js"),
          i = s("./packages/ckeditor5-utils/src/ckeditorerror.js"),
          r = s("./packages/ckeditor5-utils/src/comparearrays.js");
        s("./packages/ckeditor5-utils/src/version.js");
        var n = /*#__PURE__*/function () {
          function n(e) {
            _classCallCheck(this, n);
            this.parent = null, this._attrs = (0, o.Z)(e);
          }
          _createClass(n, [{
            key: "isAttached",
            value: function isAttached() {
              return this.root.is("rootElement");
            }
          }, {
            key: "getPath",
            value: function getPath() {
              var e = [];
              var t = this;
              for (; t.parent;) e.unshift(t.startOffset), t = t.parent;
              return e;
            }
          }, {
            key: "getAncestors",
            value: function getAncestors() {
              var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
                includeSelf: !1,
                parentFirst: !1
              };
              var t = [];
              var s = e.includeSelf ? this : this.parent;
              for (; s;) t[e.parentFirst ? "push" : "unshift"](s), s = s.parent;
              return t;
            }
          }, {
            key: "getCommonAncestor",
            value: function getCommonAncestor(e) {
              var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
              var s = this.getAncestors(t),
                o = e.getAncestors(t);
              var i = 0;
              for (; s[i] == o[i] && s[i];) i++;
              return 0 === i ? null : s[i - 1];
            }
          }, {
            key: "isBefore",
            value: function isBefore(e) {
              if (this == e) return !1;
              if (this.root !== e.root) return !1;
              var t = this.getPath(),
                s = e.getPath(),
                o = (0, r.Z)(t, s);
              switch (o) {
                case "prefix":
                  return !0;
                case "extension":
                  return !1;
                default:
                  return t[o] < s[o];
              }
            }
          }, {
            key: "isAfter",
            value: function isAfter(e) {
              return this != e && this.root === e.root && !this.isBefore(e);
            }
          }, {
            key: "hasAttribute",
            value: function hasAttribute(e) {
              return this._attrs.has(e);
            }
          }, {
            key: "getAttribute",
            value: function getAttribute(e) {
              return this._attrs.get(e);
            }
          }, {
            key: "getAttributes",
            value: function getAttributes() {
              return this._attrs.entries();
            }
          }, {
            key: "getAttributeKeys",
            value: function getAttributeKeys() {
              return this._attrs.keys();
            }
          }, {
            key: "toJSON",
            value: function toJSON() {
              var e = {};
              return this._attrs.size && (e.attributes = Array.from(this._attrs).reduce(function (e, t) {
                return e[t[0]] = t[1], e;
              }, {})), e;
            }
          }, {
            key: "is",
            value: function is(e) {
              return "node" === e || "model:node" === e;
            }
          }, {
            key: "_clone",
            value: function _clone() {
              return new n(this._attrs);
            }
          }, {
            key: "_remove",
            value: function _remove() {
              this.parent._removeChildren(this.index);
            }
          }, {
            key: "_setAttribute",
            value: function _setAttribute(e, t) {
              this._attrs.set(e, t);
            }
          }, {
            key: "_setAttributesTo",
            value: function _setAttributesTo(e) {
              this._attrs = (0, o.Z)(e);
            }
          }, {
            key: "_removeAttribute",
            value: function _removeAttribute(e) {
              return this._attrs.delete(e);
            }
          }, {
            key: "_clearAttributes",
            value: function _clearAttributes() {
              this._attrs.clear();
            }
          }, {
            key: "index",
            get: function get() {
              var e;
              if (!this.parent) return null;
              if (null === (e = this.parent.getChildIndex(this))) throw new i.ZP("model-node-not-found-in-parent", this);
              return e;
            }
          }, {
            key: "startOffset",
            get: function get() {
              var e;
              if (!this.parent) return null;
              if (null === (e = this.parent.getChildStartOffset(this))) throw new i.ZP("model-node-not-found-in-parent", this);
              return e;
            }
          }, {
            key: "offsetSize",
            get: function get() {
              return 1;
            }
          }, {
            key: "endOffset",
            get: function get() {
              return this.parent ? this.startOffset + this.offsetSize : null;
            }
          }, {
            key: "nextSibling",
            get: function get() {
              var e = this.index;
              return null !== e && this.parent.getChild(e + 1) || null;
            }
          }, {
            key: "previousSibling",
            get: function get() {
              var e = this.index;
              return null !== e && this.parent.getChild(e - 1) || null;
            }
          }, {
            key: "root",
            get: function get() {
              var e = this;
              for (; e.parent;) e = e.parent;
              return e;
            }
          }]);
          return n;
        }();
      },
      "./packages/ckeditor5-engine/src/model/nodelist.js": function _packages_ckeditor5Engine_src_model_nodelistJs(e, t, s) {
        "use strict";

        s.d(t, {
          Z: function Z() {
            return r;
          }
        });
        var o = s("./packages/ckeditor5-engine/src/model/node.js"),
          i = s("./packages/ckeditor5-utils/src/ckeditorerror.js");
        var r = /*#__PURE__*/function () {
          function r(e) {
            _classCallCheck(this, r);
            this._nodes = [], e && this._insertNodes(0, e);
          }
          _createClass(r, [{
            key: Symbol.iterator,
            value: function value() {
              return this._nodes[Symbol.iterator]();
            }
          }, {
            key: "getNode",
            value: function getNode(e) {
              return this._nodes[e] || null;
            }
          }, {
            key: "getNodeIndex",
            value: function getNodeIndex(e) {
              var t = this._nodes.indexOf(e);
              return -1 == t ? null : t;
            }
          }, {
            key: "getNodeStartOffset",
            value: function getNodeStartOffset(e) {
              var t = this.getNodeIndex(e);
              return null === t ? null : this._nodes.slice(0, t).reduce(function (e, t) {
                return e + t.offsetSize;
              }, 0);
            }
          }, {
            key: "indexToOffset",
            value: function indexToOffset(e) {
              if (e == this._nodes.length) return this.maxOffset;
              var t = this._nodes[e];
              if (!t) throw new i.ZP("model-nodelist-index-out-of-bounds", this);
              return this.getNodeStartOffset(t);
            }
          }, {
            key: "offsetToIndex",
            value: function offsetToIndex(e) {
              var t = 0;
              var _iterator145 = _createForOfIteratorHelper(this._nodes),
                _step145;
              try {
                for (_iterator145.s(); !(_step145 = _iterator145.n()).done;) {
                  var _s73 = _step145.value;
                  if (e >= t && e < t + _s73.offsetSize) return this.getNodeIndex(_s73);
                  t += _s73.offsetSize;
                }
              } catch (err) {
                _iterator145.e(err);
              } finally {
                _iterator145.f();
              }
              if (t != e) throw new i.ZP("model-nodelist-offset-out-of-bounds", this, {
                offset: e,
                nodeList: this
              });
              return this.length;
            }
          }, {
            key: "_insertNodes",
            value: function _insertNodes(e, t) {
              var _this$_nodes;
              var _iterator146 = _createForOfIteratorHelper(t),
                _step146;
              try {
                for (_iterator146.s(); !(_step146 = _iterator146.n()).done;) {
                  var _e113 = _step146.value;
                  if (!(_e113 instanceof o.Z)) throw new i.ZP("model-nodelist-insertnodes-not-node", this);
                }
              } catch (err) {
                _iterator146.e(err);
              } finally {
                _iterator146.f();
              }
              (_this$_nodes = this._nodes).splice.apply(_this$_nodes, [e, 0].concat(_toConsumableArray(t)));
            }
          }, {
            key: "_removeNodes",
            value: function _removeNodes(e) {
              var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
              return this._nodes.splice(e, t);
            }
          }, {
            key: "toJSON",
            value: function toJSON() {
              return this._nodes.map(function (e) {
                return e.toJSON();
              });
            }
          }, {
            key: "length",
            get: function get() {
              return this._nodes.length;
            }
          }, {
            key: "maxOffset",
            get: function get() {
              return this._nodes.reduce(function (e, t) {
                return e + t.offsetSize;
              }, 0);
            }
          }]);
          return r;
        }();
      },
      "./packages/ckeditor5-engine/src/model/operation/attributeoperation.js": function _packages_ckeditor5Engine_src_model_operation_attributeoperationJs(e, t, s) {
        "use strict";

        s.d(t, {
          Z: function Z() {
            return l;
          }
        });
        var o = s("./packages/ckeditor5-engine/src/model/operation/operation.js"),
          i = s("./packages/ckeditor5-engine/src/model/range.js"),
          r = s("./packages/ckeditor5-utils/src/ckeditorerror.js"),
          n = s("./packages/ckeditor5-engine/src/model/operation/utils.js"),
          a = s("./node_modules/lodash-es/_baseIsEqual.js");
        var c = function c(e, t) {
          return (0, a.Z)(e, t);
        };
        var l = /*#__PURE__*/function (_o$Z5) {
          _inherits(l, _o$Z5);
          function l(e, t, s, o, i) {
            var _this36;
            _classCallCheck(this, l);
            _this36 = _possibleConstructorReturn(this, _getPrototypeOf(l).call(this, i)), _this36.range = e.clone(), _this36.key = t, _this36.oldValue = void 0 === s ? null : s, _this36.newValue = void 0 === o ? null : o;
            return _this36;
          }
          _createClass(l, [{
            key: "clone",
            value: function clone() {
              return new l(this.range, this.key, this.oldValue, this.newValue, this.baseVersion);
            }
          }, {
            key: "getReversed",
            value: function getReversed() {
              return new l(this.range, this.key, this.newValue, this.oldValue, this.baseVersion + 1);
            }
          }, {
            key: "toJSON",
            value: function toJSON() {
              var e = _superPropGet(l, "toJSON", this, 3)([]);
              return e.range = this.range.toJSON(), e;
            }
          }, {
            key: "_validate",
            value: function _validate() {
              if (!this.range.isFlat) throw new r.ZP("attribute-operation-range-not-flat", this);
              var _iterator147 = _createForOfIteratorHelper(this.range.getItems({
                  shallow: !0
                })),
                _step147;
              try {
                for (_iterator147.s(); !(_step147 = _iterator147.n()).done;) {
                  var _e114 = _step147.value;
                  if (null !== this.oldValue && !c(_e114.getAttribute(this.key), this.oldValue)) throw new r.ZP("attribute-operation-wrong-old-value", this, {
                    item: _e114,
                    key: this.key,
                    value: this.oldValue
                  });
                  if (null === this.oldValue && null !== this.newValue && _e114.hasAttribute(this.key)) throw new r.ZP("attribute-operation-attribute-exists", this, {
                    node: _e114,
                    key: this.key
                  });
                }
              } catch (err) {
                _iterator147.e(err);
              } finally {
                _iterator147.f();
              }
            }
          }, {
            key: "_execute",
            value: function _execute() {
              c(this.oldValue, this.newValue) || (0, n.pX)(this.range, this.key, this.newValue);
            }
          }, {
            key: "type",
            get: function get() {
              return null === this.oldValue ? "addAttribute" : null === this.newValue ? "removeAttribute" : "changeAttribute";
            }
          }], [{
            key: "fromJSON",
            value: function fromJSON(e, t) {
              return new l(i.Z.fromJSON(e.range, t), e.key, e.oldValue, e.newValue, e.baseVersion);
            }
          }, {
            key: "className",
            get: function get() {
              return "AttributeOperation";
            }
          }]);
          return l;
        }(o.Z);
      },
      "./packages/ckeditor5-engine/src/model/operation/insertoperation.js": function _packages_ckeditor5Engine_src_model_operation_insertoperationJs(e, t, s) {
        "use strict";

        s.d(t, {
          Z: function Z() {
            return h;
          }
        });
        var o = s("./packages/ckeditor5-engine/src/model/operation/operation.js"),
          i = s("./packages/ckeditor5-engine/src/model/position.js"),
          r = s("./packages/ckeditor5-engine/src/model/nodelist.js"),
          n = s("./packages/ckeditor5-engine/src/model/operation/moveoperation.js"),
          a = s("./packages/ckeditor5-engine/src/model/operation/utils.js"),
          c = s("./packages/ckeditor5-engine/src/model/text.js"),
          l = s("./packages/ckeditor5-engine/src/model/element.js"),
          d = s("./packages/ckeditor5-utils/src/ckeditorerror.js");
        var h = /*#__PURE__*/function (_o$Z6) {
          _inherits(h, _o$Z6);
          function h(e, t, s) {
            var _this37;
            _classCallCheck(this, h);
            _this37 = _possibleConstructorReturn(this, _getPrototypeOf(h).call(this, s)), _this37.position = e.clone(), _this37.position.stickiness = "toNone", _this37.nodes = new r.Z((0, a.So)(t)), _this37.shouldReceiveAttributes = !1;
            return _this37;
          }
          _createClass(h, [{
            key: "clone",
            value: function clone() {
              var e = new r.Z(_toConsumableArray(this.nodes).map(function (e) {
                  return e._clone(!0);
                })),
                t = new h(this.position, e, this.baseVersion);
              return t.shouldReceiveAttributes = this.shouldReceiveAttributes, t;
            }
          }, {
            key: "getReversed",
            value: function getReversed() {
              var e = this.position.root.document.graveyard,
                t = new i.ZP(e, [0]);
              return new n.Z(this.position, this.nodes.maxOffset, t, this.baseVersion + 1);
            }
          }, {
            key: "_validate",
            value: function _validate() {
              var e = this.position.parent;
              if (!e || e.maxOffset < this.position.offset) throw new d.ZP("insert-operation-position-invalid", this);
            }
          }, {
            key: "_execute",
            value: function _execute() {
              var e = this.nodes;
              this.nodes = new r.Z(_toConsumableArray(e).map(function (e) {
                return e._clone(!0);
              })), (0, a.fj)(this.position, e);
            }
          }, {
            key: "toJSON",
            value: function toJSON() {
              var e = _superPropGet(h, "toJSON", this, 3)([]);
              return e.position = this.position.toJSON(), e.nodes = this.nodes.toJSON(), e;
            }
          }, {
            key: "type",
            get: function get() {
              return "insert";
            }
          }, {
            key: "howMany",
            get: function get() {
              return this.nodes.maxOffset;
            }
          }], [{
            key: "fromJSON",
            value: function fromJSON(e, t) {
              var s = [];
              var _iterator148 = _createForOfIteratorHelper(e.nodes),
                _step148;
              try {
                for (_iterator148.s(); !(_step148 = _iterator148.n()).done;) {
                  var _t93 = _step148.value;
                  _t93.name ? s.push(l.Z.fromJSON(_t93)) : s.push(c.Z.fromJSON(_t93));
                }
              } catch (err) {
                _iterator148.e(err);
              } finally {
                _iterator148.f();
              }
              var o = new h(i.ZP.fromJSON(e.position, t), s, e.baseVersion);
              return o.shouldReceiveAttributes = e.shouldReceiveAttributes, o;
            }
          }, {
            key: "className",
            get: function get() {
              return "InsertOperation";
            }
          }]);
          return h;
        }(o.Z);
      },
      "./packages/ckeditor5-engine/src/model/operation/markeroperation.js": function _packages_ckeditor5Engine_src_model_operation_markeroperationJs(e, t, s) {
        "use strict";

        s.d(t, {
          Z: function Z() {
            return r;
          }
        });
        var o = s("./packages/ckeditor5-engine/src/model/operation/operation.js"),
          i = s("./packages/ckeditor5-engine/src/model/range.js");
        var r = /*#__PURE__*/function (_o$Z7) {
          _inherits(r, _o$Z7);
          function r(e, t, s, o, i, _r21) {
            var _this38;
            _classCallCheck(this, r);
            _this38 = _possibleConstructorReturn(this, _getPrototypeOf(r).call(this, _r21)), _this38.name = e, _this38.oldRange = t ? t.clone() : null, _this38.newRange = s ? s.clone() : null, _this38.affectsData = i, _this38._markers = o;
            return _this38;
          }
          _createClass(r, [{
            key: "clone",
            value: function clone() {
              return new r(this.name, this.oldRange, this.newRange, this._markers, this.affectsData, this.baseVersion);
            }
          }, {
            key: "getReversed",
            value: function getReversed() {
              return new r(this.name, this.newRange, this.oldRange, this._markers, this.affectsData, this.baseVersion + 1);
            }
          }, {
            key: "_execute",
            value: function _execute() {
              var e = this.newRange ? "_set" : "_remove";
              this._markers[e](this.name, this.newRange, !0, this.affectsData);
            }
          }, {
            key: "toJSON",
            value: function toJSON() {
              var e = _superPropGet(r, "toJSON", this, 3)([]);
              return this.oldRange && (e.oldRange = this.oldRange.toJSON()), this.newRange && (e.newRange = this.newRange.toJSON()), delete e._markers, e;
            }
          }, {
            key: "type",
            get: function get() {
              return "marker";
            }
          }], [{
            key: "fromJSON",
            value: function fromJSON(e, t) {
              return new r(e.name, e.oldRange ? i.Z.fromJSON(e.oldRange, t) : null, e.newRange ? i.Z.fromJSON(e.newRange, t) : null, t.model.markers, e.affectsData, e.baseVersion);
            }
          }, {
            key: "className",
            get: function get() {
              return "MarkerOperation";
            }
          }]);
          return r;
        }(o.Z);
      },
      "./packages/ckeditor5-engine/src/model/operation/mergeoperation.js": function _packages_ckeditor5Engine_src_model_operation_mergeoperationJs(e, t, s) {
        "use strict";

        s.d(t, {
          Z: function Z() {
            return l;
          }
        });
        var o = s("./packages/ckeditor5-engine/src/model/operation/operation.js"),
          i = s("./packages/ckeditor5-engine/src/model/operation/splitoperation.js"),
          r = s("./packages/ckeditor5-engine/src/model/position.js"),
          n = s("./packages/ckeditor5-engine/src/model/range.js"),
          a = s("./packages/ckeditor5-engine/src/model/operation/utils.js"),
          c = s("./packages/ckeditor5-utils/src/ckeditorerror.js");
        var l = /*#__PURE__*/function (_o$Z8) {
          _inherits(l, _o$Z8);
          function l(e, t, s, o, i) {
            var _this39;
            _classCallCheck(this, l);
            _this39 = _possibleConstructorReturn(this, _getPrototypeOf(l).call(this, i)), _this39.sourcePosition = e.clone(), _this39.sourcePosition.stickiness = "toPrevious", _this39.howMany = t, _this39.targetPosition = s.clone(), _this39.targetPosition.stickiness = "toNext", _this39.graveyardPosition = o.clone();
            return _this39;
          }
          _createClass(l, [{
            key: "clone",
            value: function clone() {
              return new this.constructor(this.sourcePosition, this.howMany, this.targetPosition, this.graveyardPosition, this.baseVersion);
            }
          }, {
            key: "getReversed",
            value: function getReversed() {
              var e = this.targetPosition._getTransformedByMergeOperation(this),
                t = this.sourcePosition.path.slice(0, -1),
                s = new r.ZP(this.sourcePosition.root, t)._getTransformedByMergeOperation(this);
              return new i.Z(e, this.howMany, s, this.graveyardPosition, this.baseVersion + 1);
            }
          }, {
            key: "_validate",
            value: function _validate() {
              var e = this.sourcePosition.parent,
                t = this.targetPosition.parent;
              if (!e.parent) throw new c.ZP("merge-operation-source-position-invalid", this);
              if (!t.parent) throw new c.ZP("merge-operation-target-position-invalid", this);
              if (this.howMany != e.maxOffset) throw new c.ZP("merge-operation-how-many-invalid", this);
            }
          }, {
            key: "_execute",
            value: function _execute() {
              var e = this.sourcePosition.parent,
                t = n.Z._createIn(e);
              (0, a.XF)(t, this.targetPosition), (0, a.XF)(n.Z._createOn(e), this.graveyardPosition);
            }
          }, {
            key: "toJSON",
            value: function toJSON() {
              var e = _superPropGet(l, "toJSON", this, 3)([]);
              return e.sourcePosition = e.sourcePosition.toJSON(), e.targetPosition = e.targetPosition.toJSON(), e.graveyardPosition = e.graveyardPosition.toJSON(), e;
            }
          }, {
            key: "type",
            get: function get() {
              return "merge";
            }
          }, {
            key: "deletionPosition",
            get: function get() {
              return new r.ZP(this.sourcePosition.root, this.sourcePosition.path.slice(0, -1));
            }
          }, {
            key: "movedRange",
            get: function get() {
              var e = this.sourcePosition.getShiftedBy(Number.POSITIVE_INFINITY);
              return new n.Z(this.sourcePosition, e);
            }
          }], [{
            key: "fromJSON",
            value: function fromJSON(e, t) {
              var s = r.ZP.fromJSON(e.sourcePosition, t),
                o = r.ZP.fromJSON(e.targetPosition, t),
                i = r.ZP.fromJSON(e.graveyardPosition, t);
              return new this(s, e.howMany, o, i, e.baseVersion);
            }
          }, {
            key: "className",
            get: function get() {
              return "MergeOperation";
            }
          }]);
          return l;
        }(o.Z);
      },
      "./packages/ckeditor5-engine/src/model/operation/moveoperation.js": function _packages_ckeditor5Engine_src_model_operation_moveoperationJs(e, t, s) {
        "use strict";

        s.d(t, {
          Z: function Z() {
            return l;
          }
        });
        var o = s("./packages/ckeditor5-engine/src/model/operation/operation.js"),
          i = s("./packages/ckeditor5-engine/src/model/position.js"),
          r = s("./packages/ckeditor5-engine/src/model/range.js"),
          n = s("./packages/ckeditor5-utils/src/ckeditorerror.js"),
          a = s("./packages/ckeditor5-utils/src/comparearrays.js"),
          c = s("./packages/ckeditor5-engine/src/model/operation/utils.js");
        var l = /*#__PURE__*/function (_o$Z9) {
          _inherits(l, _o$Z9);
          function l(e, t, s, o) {
            var _this40;
            _classCallCheck(this, l);
            _this40 = _possibleConstructorReturn(this, _getPrototypeOf(l).call(this, o)), _this40.sourcePosition = e.clone(), _this40.sourcePosition.stickiness = "toNext", _this40.howMany = t, _this40.targetPosition = s.clone(), _this40.targetPosition.stickiness = "toNone";
            return _this40;
          }
          _createClass(l, [{
            key: "clone",
            value: function clone() {
              return new this.constructor(this.sourcePosition, this.howMany, this.targetPosition, this.baseVersion);
            }
          }, {
            key: "getMovedRangeStart",
            value: function getMovedRangeStart() {
              return this.targetPosition._getTransformedByDeletion(this.sourcePosition, this.howMany);
            }
          }, {
            key: "getReversed",
            value: function getReversed() {
              var e = this.sourcePosition._getTransformedByInsertion(this.targetPosition, this.howMany);
              return new this.constructor(this.getMovedRangeStart(), this.howMany, e, this.baseVersion + 1);
            }
          }, {
            key: "_validate",
            value: function _validate() {
              var e = this.sourcePosition.parent,
                t = this.targetPosition.parent,
                s = this.sourcePosition.offset,
                o = this.targetPosition.offset;
              if (s + this.howMany > e.maxOffset) throw new n.ZP("move-operation-nodes-do-not-exist", this);
              if (e === t && s < o && o < s + this.howMany) throw new n.ZP("move-operation-range-into-itself", this);
              if (this.sourcePosition.root == this.targetPosition.root && "prefix" == (0, a.Z)(this.sourcePosition.getParentPath(), this.targetPosition.getParentPath())) {
                var _e115 = this.sourcePosition.path.length - 1;
                if (this.targetPosition.path[_e115] >= s && this.targetPosition.path[_e115] < s + this.howMany) throw new n.ZP("move-operation-node-into-itself", this);
              }
            }
          }, {
            key: "_execute",
            value: function _execute() {
              (0, c.XF)(r.Z._createFromPositionAndShift(this.sourcePosition, this.howMany), this.targetPosition);
            }
          }, {
            key: "toJSON",
            value: function toJSON() {
              var e = _superPropGet(l, "toJSON", this, 3)([]);
              return e.sourcePosition = this.sourcePosition.toJSON(), e.targetPosition = this.targetPosition.toJSON(), e;
            }
          }, {
            key: "type",
            get: function get() {
              return "$graveyard" == this.targetPosition.root.rootName ? "remove" : "$graveyard" == this.sourcePosition.root.rootName ? "reinsert" : "move";
            }
          }], [{
            key: "fromJSON",
            value: function fromJSON(e, t) {
              var s = i.ZP.fromJSON(e.sourcePosition, t),
                o = i.ZP.fromJSON(e.targetPosition, t);
              return new this(s, e.howMany, o, e.baseVersion);
            }
          }, {
            key: "className",
            get: function get() {
              return "MoveOperation";
            }
          }]);
          return l;
        }(o.Z);
      },
      "./packages/ckeditor5-engine/src/model/operation/nooperation.js": function _packages_ckeditor5Engine_src_model_operation_nooperationJs(e, t, s) {
        "use strict";

        s.d(t, {
          Z: function Z() {
            return i;
          }
        });
        var o = s("./packages/ckeditor5-engine/src/model/operation/operation.js");
        var i = /*#__PURE__*/function (_o$Z10) {
          _inherits(i, _o$Z10);
          function i() {
            _classCallCheck(this, i);
            return _possibleConstructorReturn(this, _getPrototypeOf(i).apply(this, arguments));
          }
          _createClass(i, [{
            key: "clone",
            value: function clone() {
              return new i(this.baseVersion);
            }
          }, {
            key: "getReversed",
            value: function getReversed() {
              return new i(this.baseVersion + 1);
            }
          }, {
            key: "_execute",
            value: function _execute() {}
          }, {
            key: "type",
            get: function get() {
              return "noop";
            }
          }], [{
            key: "className",
            get: function get() {
              return "NoOperation";
            }
          }]);
          return i;
        }(o.Z);
      },
      "./packages/ckeditor5-engine/src/model/operation/operation.js": function _packages_ckeditor5Engine_src_model_operation_operationJs(e, t, s) {
        "use strict";

        s.d(t, {
          Z: function Z() {
            return o;
          }
        });
        var o = /*#__PURE__*/function () {
          function o(e) {
            _classCallCheck(this, o);
            this.baseVersion = e, this.isDocumentOperation = null !== this.baseVersion, this.batch = null;
          }
          _createClass(o, [{
            key: "_validate",
            value: function _validate() {}
          }, {
            key: "toJSON",
            value: function toJSON() {
              var e = Object.assign({}, this);
              return e.__className = this.constructor.className, delete e.batch, delete e.isDocumentOperation, e;
            }
          }], [{
            key: "fromJSON",
            value: function fromJSON(e) {
              return new this(e.baseVersion);
            }
          }, {
            key: "className",
            get: function get() {
              return "Operation";
            }
          }]);
          return o;
        }();
      },
      "./packages/ckeditor5-engine/src/model/operation/operationfactory.js": function _packages_ckeditor5Engine_src_model_operation_operationfactoryJs(e, t, s) {
        "use strict";

        s.d(t, {
          Z: function Z() {
            return p;
          }
        });
        var o = s("./packages/ckeditor5-engine/src/model/operation/attributeoperation.js"),
          i = s("./packages/ckeditor5-engine/src/model/operation/insertoperation.js"),
          r = s("./packages/ckeditor5-engine/src/model/operation/markeroperation.js"),
          n = s("./packages/ckeditor5-engine/src/model/operation/moveoperation.js"),
          a = s("./packages/ckeditor5-engine/src/model/operation/nooperation.js"),
          c = s("./packages/ckeditor5-engine/src/model/operation/operation.js"),
          l = s("./packages/ckeditor5-engine/src/model/operation/renameoperation.js"),
          d = s("./packages/ckeditor5-engine/src/model/operation/rootattributeoperation.js"),
          h = s("./packages/ckeditor5-engine/src/model/operation/splitoperation.js"),
          u = s("./packages/ckeditor5-engine/src/model/operation/mergeoperation.js");
        var g = {};
        g[o.Z.className] = o.Z, g[i.Z.className] = i.Z, g[r.Z.className] = r.Z, g[n.Z.className] = n.Z, g[a.Z.className] = a.Z, g[c.Z.className] = c.Z, g[l.Z.className] = l.Z, g[d.Z.className] = d.Z, g[h.Z.className] = h.Z, g[u.Z.className] = u.Z;
        var p = /*#__PURE__*/function () {
          function p() {
            _classCallCheck(this, p);
          }
          _createClass(p, null, [{
            key: "fromJSON",
            value: function fromJSON(e, t) {
              return g[e.__className].fromJSON(e, t);
            }
          }]);
          return p;
        }();
      },
      "./packages/ckeditor5-engine/src/model/operation/renameoperation.js": function _packages_ckeditor5Engine_src_model_operation_renameoperationJs(e, t, s) {
        "use strict";

        s.d(t, {
          Z: function Z() {
            return a;
          }
        });
        var o = s("./packages/ckeditor5-engine/src/model/operation/operation.js"),
          i = s("./packages/ckeditor5-engine/src/model/element.js"),
          r = s("./packages/ckeditor5-utils/src/ckeditorerror.js"),
          n = s("./packages/ckeditor5-engine/src/model/position.js");
        var a = /*#__PURE__*/function (_o$Z11) {
          _inherits(a, _o$Z11);
          function a(e, t, s, o) {
            var _this41;
            _classCallCheck(this, a);
            _this41 = _possibleConstructorReturn(this, _getPrototypeOf(a).call(this, o)), _this41.position = e, _this41.position.stickiness = "toNext", _this41.oldName = t, _this41.newName = s;
            return _this41;
          }
          _createClass(a, [{
            key: "clone",
            value: function clone() {
              return new a(this.position.clone(), this.oldName, this.newName, this.baseVersion);
            }
          }, {
            key: "getReversed",
            value: function getReversed() {
              return new a(this.position.clone(), this.newName, this.oldName, this.baseVersion + 1);
            }
          }, {
            key: "_validate",
            value: function _validate() {
              var e = this.position.nodeAfter;
              if (!(e instanceof i.Z)) throw new r.ZP("rename-operation-wrong-position", this);
              if (e.name !== this.oldName) throw new r.ZP("rename-operation-wrong-name", this);
            }
          }, {
            key: "_execute",
            value: function _execute() {
              this.position.nodeAfter.name = this.newName;
            }
          }, {
            key: "toJSON",
            value: function toJSON() {
              var e = _superPropGet(a, "toJSON", this, 3)([]);
              return e.position = this.position.toJSON(), e;
            }
          }, {
            key: "type",
            get: function get() {
              return "rename";
            }
          }], [{
            key: "fromJSON",
            value: function fromJSON(e, t) {
              return new a(n.ZP.fromJSON(e.position, t), e.oldName, e.newName, e.baseVersion);
            }
          }, {
            key: "className",
            get: function get() {
              return "RenameOperation";
            }
          }]);
          return a;
        }(o.Z);
      },
      "./packages/ckeditor5-engine/src/model/operation/rootattributeoperation.js": function _packages_ckeditor5Engine_src_model_operation_rootattributeoperationJs(e, t, s) {
        "use strict";

        s.d(t, {
          Z: function Z() {
            return r;
          }
        });
        var o = s("./packages/ckeditor5-engine/src/model/operation/operation.js"),
          i = s("./packages/ckeditor5-utils/src/ckeditorerror.js");
        var r = /*#__PURE__*/function (_o$Z12) {
          _inherits(r, _o$Z12);
          function r(e, t, s, o, i) {
            var _this42;
            _classCallCheck(this, r);
            _this42 = _possibleConstructorReturn(this, _getPrototypeOf(r).call(this, i)), _this42.root = e, _this42.key = t, _this42.oldValue = s, _this42.newValue = o;
            return _this42;
          }
          _createClass(r, [{
            key: "clone",
            value: function clone() {
              return new r(this.root, this.key, this.oldValue, this.newValue, this.baseVersion);
            }
          }, {
            key: "getReversed",
            value: function getReversed() {
              return new r(this.root, this.key, this.newValue, this.oldValue, this.baseVersion + 1);
            }
          }, {
            key: "_validate",
            value: function _validate() {
              if (this.root != this.root.root || this.root.is("documentFragment")) throw new i.ZP("rootattribute-operation-not-a-root", this, {
                root: this.root,
                key: this.key
              });
              if (null !== this.oldValue && this.root.getAttribute(this.key) !== this.oldValue) throw new i.ZP("rootattribute-operation-wrong-old-value", this, {
                root: this.root,
                key: this.key
              });
              if (null === this.oldValue && null !== this.newValue && this.root.hasAttribute(this.key)) throw new i.ZP("rootattribute-operation-attribute-exists", this, {
                root: this.root,
                key: this.key
              });
            }
          }, {
            key: "_execute",
            value: function _execute() {
              null !== this.newValue ? this.root._setAttribute(this.key, this.newValue) : this.root._removeAttribute(this.key);
            }
          }, {
            key: "toJSON",
            value: function toJSON() {
              var e = _superPropGet(r, "toJSON", this, 3)([]);
              return e.root = this.root.toJSON(), e;
            }
          }, {
            key: "type",
            get: function get() {
              return null === this.oldValue ? "addRootAttribute" : null === this.newValue ? "removeRootAttribute" : "changeRootAttribute";
            }
          }], [{
            key: "fromJSON",
            value: function fromJSON(e, t) {
              if (!t.getRoot(e.root)) throw new i.ZP("rootattribute-operation-fromjson-no-root", this, {
                rootName: e.root
              });
              return new r(t.getRoot(e.root), e.key, e.oldValue, e.newValue, e.baseVersion);
            }
          }, {
            key: "className",
            get: function get() {
              return "RootAttributeOperation";
            }
          }]);
          return r;
        }(o.Z);
      },
      "./packages/ckeditor5-engine/src/model/operation/splitoperation.js": function _packages_ckeditor5Engine_src_model_operation_splitoperationJs(e, t, s) {
        "use strict";

        s.d(t, {
          Z: function Z() {
            return l;
          }
        });
        var o = s("./packages/ckeditor5-engine/src/model/operation/operation.js"),
          i = s("./packages/ckeditor5-engine/src/model/operation/mergeoperation.js"),
          r = s("./packages/ckeditor5-engine/src/model/position.js"),
          n = s("./packages/ckeditor5-engine/src/model/range.js"),
          a = s("./packages/ckeditor5-engine/src/model/operation/utils.js"),
          c = s("./packages/ckeditor5-utils/src/ckeditorerror.js");
        var l = /*#__PURE__*/function (_o$Z13) {
          _inherits(l, _o$Z13);
          function l(e, t, s, o, i) {
            var _this43;
            _classCallCheck(this, l);
            _this43 = _possibleConstructorReturn(this, _getPrototypeOf(l).call(this, i)), _this43.splitPosition = e.clone(), _this43.splitPosition.stickiness = "toNext", _this43.howMany = t, _this43.insertionPosition = s, _this43.graveyardPosition = o ? o.clone() : null, _this43.graveyardPosition && (_this43.graveyardPosition.stickiness = "toNext");
            return _this43;
          }
          _createClass(l, [{
            key: "clone",
            value: function clone() {
              return new this.constructor(this.splitPosition, this.howMany, this.insertionPosition, this.graveyardPosition, this.baseVersion);
            }
          }, {
            key: "getReversed",
            value: function getReversed() {
              var e = this.splitPosition.root.document.graveyard,
                t = new r.ZP(e, [0]);
              return new i.Z(this.moveTargetPosition, this.howMany, this.splitPosition, t, this.baseVersion + 1);
            }
          }, {
            key: "_validate",
            value: function _validate() {
              var e = this.splitPosition.parent,
                t = this.splitPosition.offset;
              if (!e || e.maxOffset < t) throw new c.ZP("split-operation-position-invalid", this);
              if (!e.parent) throw new c.ZP("split-operation-split-in-root", this);
              if (this.howMany != e.maxOffset - this.splitPosition.offset) throw new c.ZP("split-operation-how-many-invalid", this);
              if (this.graveyardPosition && !this.graveyardPosition.nodeAfter) throw new c.ZP("split-operation-graveyard-position-invalid", this);
            }
          }, {
            key: "_execute",
            value: function _execute() {
              var e = this.splitPosition.parent;
              if (this.graveyardPosition) (0, a.XF)(n.Z._createFromPositionAndShift(this.graveyardPosition, 1), this.insertionPosition);else {
                var _t94 = e._clone();
                (0, a.fj)(this.insertionPosition, _t94);
              }
              var t = new n.Z(r.ZP._createAt(e, this.splitPosition.offset), r.ZP._createAt(e, e.maxOffset));
              (0, a.XF)(t, this.moveTargetPosition);
            }
          }, {
            key: "toJSON",
            value: function toJSON() {
              var e = _superPropGet(l, "toJSON", this, 3)([]);
              return e.splitPosition = this.splitPosition.toJSON(), e.insertionPosition = this.insertionPosition.toJSON(), this.graveyardPosition && (e.graveyardPosition = this.graveyardPosition.toJSON()), e;
            }
          }, {
            key: "type",
            get: function get() {
              return "split";
            }
          }, {
            key: "moveTargetPosition",
            get: function get() {
              var e = this.insertionPosition.path.slice();
              return e.push(0), new r.ZP(this.insertionPosition.root, e);
            }
          }, {
            key: "movedRange",
            get: function get() {
              var e = this.splitPosition.getShiftedBy(Number.POSITIVE_INFINITY);
              return new n.Z(this.splitPosition, e);
            }
          }], [{
            key: "getInsertionPosition",
            value: function getInsertionPosition(e) {
              var t = e.path.slice(0, -1);
              return t[t.length - 1]++, new r.ZP(e.root, t, "toPrevious");
            }
          }, {
            key: "fromJSON",
            value: function fromJSON(e, t) {
              var s = r.ZP.fromJSON(e.splitPosition, t),
                o = r.ZP.fromJSON(e.insertionPosition, t),
                i = e.graveyardPosition ? r.ZP.fromJSON(e.graveyardPosition, t) : null;
              return new this(s, e.howMany, o, i, e.baseVersion);
            }
          }, {
            key: "className",
            get: function get() {
              return "SplitOperation";
            }
          }]);
          return l;
        }(o.Z);
      },
      "./packages/ckeditor5-engine/src/model/operation/transform.js": function _packages_ckeditor5Engine_src_model_operation_transformJs(e, t, s) {
        "use strict";

        s.d(t, {
          R: function R() {
            return b;
          }
        });
        var o = s("./packages/ckeditor5-engine/src/model/operation/insertoperation.js"),
          i = s("./packages/ckeditor5-engine/src/model/operation/attributeoperation.js"),
          r = s("./packages/ckeditor5-engine/src/model/operation/renameoperation.js"),
          n = s("./packages/ckeditor5-engine/src/model/operation/markeroperation.js"),
          a = s("./packages/ckeditor5-engine/src/model/operation/moveoperation.js"),
          c = s("./packages/ckeditor5-engine/src/model/operation/rootattributeoperation.js"),
          l = s("./packages/ckeditor5-engine/src/model/operation/mergeoperation.js"),
          d = s("./packages/ckeditor5-engine/src/model/operation/splitoperation.js"),
          h = s("./packages/ckeditor5-engine/src/model/operation/nooperation.js"),
          u = s("./packages/ckeditor5-engine/src/model/range.js"),
          g = s("./packages/ckeditor5-engine/src/model/position.js"),
          p = s("./packages/ckeditor5-utils/src/comparearrays.js");
        var f = new Map();
        function m(e, t, s) {
          var o = f.get(e);
          o || (o = new Map(), f.set(e, o)), o.set(t, s);
        }
        function k(e) {
          return [e];
        }
        function _(e, t) {
          var s = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
          var o = function (e, t) {
            var s = f.get(e);
            return s && s.has(t) ? s.get(t) : k;
          }(e.constructor, t.constructor);
          try {
            return o(e = e.clone(), t, s);
          } catch (e) {
            throw e;
          }
        }
        function b(e, t, s) {
          e = e.slice(), t = t.slice();
          var o = new w(s.document, s.useRelations, s.forceWeakRemove);
          o.setOriginalOperations(e), o.setOriginalOperations(t);
          var i = o.originalOperations;
          if (0 == e.length || 0 == t.length) return {
            operationsA: e,
            operationsB: t,
            originalOperations: i
          };
          var r = new WeakMap();
          var _iterator149 = _createForOfIteratorHelper(e),
            _step149;
          try {
            for (_iterator149.s(); !(_step149 = _iterator149.n()).done;) {
              var _t96 = _step149.value;
              r.set(_t96, 0);
            }
          } catch (err) {
            _iterator149.e(err);
          } finally {
            _iterator149.f();
          }
          var n = {
            nextBaseVersionA: e[e.length - 1].baseVersion + 1,
            nextBaseVersionB: t[t.length - 1].baseVersion + 1,
            originalOperationsACount: e.length,
            originalOperationsBCount: t.length
          };
          var a = 0;
          for (; a < e.length;) {
            var _e116, _t95;
            var _s74 = e[a],
              _i45 = r.get(_s74);
            if (_i45 == t.length) {
              a++;
              continue;
            }
            var _n10 = t[_i45],
              _c4 = _(_s74, _n10, o.getContext(_s74, _n10, !0)),
              _l2 = _(_n10, _s74, o.getContext(_n10, _s74, !1));
            o.updateRelation(_s74, _n10), o.setOriginalOperations(_c4, _s74), o.setOriginalOperations(_l2, _n10);
            var _iterator150 = _createForOfIteratorHelper(_c4),
              _step150;
            try {
              for (_iterator150.s(); !(_step150 = _iterator150.n()).done;) {
                var _e117 = _step150.value;
                r.set(_e117, _i45 + _l2.length);
              }
            } catch (err) {
              _iterator150.e(err);
            } finally {
              _iterator150.f();
            }
            (_e116 = e).splice.apply(_e116, [a, 1].concat(_toConsumableArray(_c4))), (_t95 = t).splice.apply(_t95, [_i45, 1].concat(_toConsumableArray(_l2)));
          }
          if (s.padWithNoOps) {
            var _s75 = e.length - n.originalOperationsACount,
              _o34 = t.length - n.originalOperationsBCount;
            y(e, _o34 - _s75), y(t, _s75 - _o34);
          }
          return v(e, n.nextBaseVersionB), v(t, n.nextBaseVersionA), {
            operationsA: e,
            operationsB: t,
            originalOperations: i
          };
        }
        var w = /*#__PURE__*/function () {
          function w(e, t) {
            var s = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : !1;
            _classCallCheck(this, w);
            this.originalOperations = new Map(), this._history = e.history, this._useRelations = t, this._forceWeakRemove = !!s, this._relations = new Map();
          }
          _createClass(w, [{
            key: "setOriginalOperations",
            value: function setOriginalOperations(e) {
              var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
              var s = t ? this.originalOperations.get(t) : null;
              var _iterator151 = _createForOfIteratorHelper(e),
                _step151;
              try {
                for (_iterator151.s(); !(_step151 = _iterator151.n()).done;) {
                  var _t97 = _step151.value;
                  this.originalOperations.set(_t97, s || _t97);
                }
              } catch (err) {
                _iterator151.e(err);
              } finally {
                _iterator151.f();
              }
            }
          }, {
            key: "updateRelation",
            value: function updateRelation(e, t) {
              switch (e.constructor) {
                case a.Z:
                  switch (t.constructor) {
                    case l.Z:
                      e.targetPosition.isEqual(t.sourcePosition) || t.movedRange.containsPosition(e.targetPosition) ? this._setRelation(e, t, "insertAtSource") : e.targetPosition.isEqual(t.deletionPosition) ? this._setRelation(e, t, "insertBetween") : e.targetPosition.isAfter(t.sourcePosition) && this._setRelation(e, t, "moveTargetAfter");
                      break;
                    case a.Z:
                      e.targetPosition.isEqual(t.sourcePosition) || e.targetPosition.isBefore(t.sourcePosition) ? this._setRelation(e, t, "insertBefore") : this._setRelation(e, t, "insertAfter");
                  }
                  break;
                case d.Z:
                  switch (t.constructor) {
                    case l.Z:
                      e.splitPosition.isBefore(t.sourcePosition) && this._setRelation(e, t, "splitBefore");
                      break;
                    case a.Z:
                      if (e.splitPosition.isEqual(t.sourcePosition) || e.splitPosition.isBefore(t.sourcePosition)) this._setRelation(e, t, "splitBefore");else {
                        var _s76 = u.Z._createFromPositionAndShift(t.sourcePosition, t.howMany);
                        if (e.splitPosition.hasSameParentAs(t.sourcePosition) && _s76.containsPosition(e.splitPosition)) {
                          var _o35 = _s76.end.offset - e.splitPosition.offset,
                            _i46 = e.splitPosition.offset - _s76.start.offset;
                          this._setRelation(e, t, {
                            howMany: _o35,
                            offset: _i46
                          });
                        }
                      }
                  }
                  break;
                case l.Z:
                  switch (t.constructor) {
                    case l.Z:
                      e.targetPosition.isEqual(t.sourcePosition) || this._setRelation(e, t, "mergeTargetNotMoved"), e.sourcePosition.isEqual(t.targetPosition) && this._setRelation(e, t, "mergeSourceNotMoved"), e.sourcePosition.isEqual(t.sourcePosition) && this._setRelation(e, t, "mergeSameElement");
                      break;
                    case d.Z:
                      e.sourcePosition.isEqual(t.splitPosition) && this._setRelation(e, t, "splitAtSource");
                  }
                  break;
                case n.Z:
                  {
                    var _s77 = e.newRange;
                    if (!_s77) return;
                    switch (t.constructor) {
                      case a.Z:
                        {
                          var _o36 = u.Z._createFromPositionAndShift(t.sourcePosition, t.howMany),
                            _i47 = _o36.containsPosition(_s77.start) || _o36.start.isEqual(_s77.start),
                            _r22 = _o36.containsPosition(_s77.end) || _o36.end.isEqual(_s77.end);
                          !_i47 && !_r22 || _o36.containsRange(_s77) || this._setRelation(e, t, {
                            side: _i47 ? "left" : "right",
                            path: _i47 ? _s77.start.path.slice() : _s77.end.path.slice()
                          });
                          break;
                        }
                      case l.Z:
                        {
                          var _o37 = _s77.start.isEqual(t.targetPosition),
                            _i48 = _s77.start.isEqual(t.deletionPosition),
                            _r23 = _s77.end.isEqual(t.deletionPosition),
                            _n11 = _s77.end.isEqual(t.sourcePosition);
                          (_o37 || _i48 || _r23 || _n11) && this._setRelation(e, t, {
                            wasInLeftElement: _o37,
                            wasStartBeforeMergedElement: _i48,
                            wasEndBeforeMergedElement: _r23,
                            wasInRightElement: _n11
                          });
                          break;
                        }
                    }
                    break;
                  }
              }
            }
          }, {
            key: "getContext",
            value: function getContext(e, t, s) {
              return {
                aIsStrong: s,
                aWasUndone: this._wasUndone(e),
                bWasUndone: this._wasUndone(t),
                abRelation: this._useRelations ? this._getRelation(e, t) : null,
                baRelation: this._useRelations ? this._getRelation(t, e) : null,
                forceWeakRemove: this._forceWeakRemove
              };
            }
          }, {
            key: "_wasUndone",
            value: function _wasUndone(e) {
              var t = this.originalOperations.get(e);
              return t.wasUndone || this._history.isUndoneOperation(t);
            }
          }, {
            key: "_getRelation",
            value: function _getRelation(e, t) {
              var s = this.originalOperations.get(t),
                o = this._history.getUndoneOperation(s);
              if (!o) return null;
              var i = this.originalOperations.get(e),
                r = this._relations.get(i);
              return r && r.get(o) || null;
            }
          }, {
            key: "_setRelation",
            value: function _setRelation(e, t, s) {
              var o = this.originalOperations.get(e),
                i = this.originalOperations.get(t);
              var r = this._relations.get(o);
              r || (r = new Map(), this._relations.set(o, r)), r.set(i, s);
            }
          }]);
          return w;
        }();
        function v(e, t) {
          var _iterator152 = _createForOfIteratorHelper(e),
            _step152;
          try {
            for (_iterator152.s(); !(_step152 = _iterator152.n()).done;) {
              var _s78 = _step152.value;
              _s78.baseVersion = t++;
            }
          } catch (err) {
            _iterator152.e(err);
          } finally {
            _iterator152.f();
          }
        }
        function y(e, t) {
          for (var _s79 = 0; _s79 < t; _s79++) e.push(new h.Z(0));
        }
        function Z(e, t, s) {
          var o = e.nodes.getNode(0).getAttribute(t);
          if (o == s) return null;
          var r = new u.Z(e.position, e.position.getShiftedBy(e.howMany));
          return new i.Z(r, t, o, s, 0);
        }
        function P(e, t) {
          return null === e.targetPosition._getTransformedByDeletion(t.sourcePosition, t.howMany);
        }
        function j(e, t) {
          var s = [];
          for (var _o38 = 0; _o38 < e.length; _o38++) {
            var _i49 = e[_o38],
              _r24 = new a.Z(_i49.start, _i49.end.offset - _i49.start.offset, t, 0);
            s.push(_r24);
            for (var _t98 = _o38 + 1; _t98 < e.length; _t98++) e[_t98] = e[_t98]._getTransformedByMove(_r24.sourcePosition, _r24.targetPosition, _r24.howMany)[0];
            t = t._getTransformedByMove(_r24.sourcePosition, _r24.targetPosition, _r24.howMany);
          }
          return s;
        }
        m(i.Z, i.Z, function (e, t, s) {
          if (e.key === t.key && e.range.start.hasSameParentAs(t.range.start)) {
            var _o39 = e.range.getDifference(t.range).map(function (t) {
                return new i.Z(t, e.key, e.oldValue, e.newValue, 0);
              }),
              _r25 = e.range.getIntersection(t.range);
            return _r25 && s.aIsStrong && _o39.push(new i.Z(_r25, t.key, t.newValue, e.newValue, 0)), 0 == _o39.length ? [new h.Z(0)] : _o39;
          }
          return [e];
        }), m(i.Z, o.Z, function (e, t) {
          if (e.range.start.hasSameParentAs(t.position) && e.range.containsPosition(t.position)) {
            var _s80 = e.range._getTransformedByInsertion(t.position, t.howMany, !t.shouldReceiveAttributes).map(function (t) {
              return new i.Z(t, e.key, e.oldValue, e.newValue, e.baseVersion);
            });
            if (t.shouldReceiveAttributes) {
              var _o40 = Z(t, e.key, e.oldValue);
              _o40 && _s80.unshift(_o40);
            }
            return _s80;
          }
          return e.range = e.range._getTransformedByInsertion(t.position, t.howMany, !1)[0], [e];
        }), m(i.Z, l.Z, function (e, t) {
          var s = [];
          e.range.start.hasSameParentAs(t.deletionPosition) && (e.range.containsPosition(t.deletionPosition) || e.range.start.isEqual(t.deletionPosition)) && s.push(u.Z._createFromPositionAndShift(t.graveyardPosition, 1));
          var o = e.range._getTransformedByMergeOperation(t);
          return o.isCollapsed || s.push(o), s.map(function (t) {
            return new i.Z(t, e.key, e.oldValue, e.newValue, e.baseVersion);
          });
        }), m(i.Z, a.Z, function (e, t) {
          return function (e, t) {
            var s = u.Z._createFromPositionAndShift(t.sourcePosition, t.howMany);
            var o = null,
              i = [];
            s.containsRange(e, !0) ? o = e : e.start.hasSameParentAs(s.start) ? (i = e.getDifference(s), o = e.getIntersection(s)) : i = [e];
            var r = [];
            var _iterator153 = _createForOfIteratorHelper(i),
              _step153;
            try {
              for (_iterator153.s(); !(_step153 = _iterator153.n()).done;) {
                var _e118 = _step153.value;
                _e118 = _e118._getTransformedByDeletion(t.sourcePosition, t.howMany);
                var _s81 = t.getMovedRangeStart(),
                  _o41 = _e118.start.hasSameParentAs(_s81);
                _e118 = _e118._getTransformedByInsertion(_s81, t.howMany, _o41), r.push.apply(r, _toConsumableArray(_e118));
              }
            } catch (err) {
              _iterator153.e(err);
            } finally {
              _iterator153.f();
            }
            o && r.push(o._getTransformedByMove(t.sourcePosition, t.targetPosition, t.howMany, !1)[0]);
            return r;
          }(e.range, t).map(function (t) {
            return new i.Z(t, e.key, e.oldValue, e.newValue, e.baseVersion);
          });
        }), m(i.Z, d.Z, function (e, t) {
          if (e.range.end.isEqual(t.insertionPosition)) return t.graveyardPosition || e.range.end.offset++, [e];
          if (e.range.start.hasSameParentAs(t.splitPosition) && e.range.containsPosition(t.splitPosition)) {
            var _s82 = e.clone();
            return _s82.range = new u.Z(t.moveTargetPosition.clone(), e.range.end._getCombined(t.splitPosition, t.moveTargetPosition)), e.range.end = t.splitPosition.clone(), e.range.end.stickiness = "toPrevious", [e, _s82];
          }
          return e.range = e.range._getTransformedBySplitOperation(t), [e];
        }), m(o.Z, i.Z, function (e, t) {
          var s = [e];
          if (e.shouldReceiveAttributes && e.position.hasSameParentAs(t.range.start) && t.range.containsPosition(e.position)) {
            var _o42 = Z(e, t.key, t.newValue);
            _o42 && s.push(_o42);
          }
          return s;
        }), m(o.Z, o.Z, function (e, t, s) {
          return e.position.isEqual(t.position) && s.aIsStrong || (e.position = e.position._getTransformedByInsertOperation(t)), [e];
        }), m(o.Z, a.Z, function (e, t) {
          return e.position = e.position._getTransformedByMoveOperation(t), [e];
        }), m(o.Z, d.Z, function (e, t) {
          return e.position = e.position._getTransformedBySplitOperation(t), [e];
        }), m(o.Z, l.Z, function (e, t) {
          return e.position = e.position._getTransformedByMergeOperation(t), [e];
        }), m(n.Z, o.Z, function (e, t) {
          return e.oldRange && (e.oldRange = e.oldRange._getTransformedByInsertOperation(t)[0]), e.newRange && (e.newRange = e.newRange._getTransformedByInsertOperation(t)[0]), [e];
        }), m(n.Z, n.Z, function (e, t, s) {
          if (e.name == t.name) {
            if (!s.aIsStrong) return [new h.Z(0)];
            e.oldRange = t.newRange ? t.newRange.clone() : null;
          }
          return [e];
        }), m(n.Z, l.Z, function (e, t) {
          return e.oldRange && (e.oldRange = e.oldRange._getTransformedByMergeOperation(t)), e.newRange && (e.newRange = e.newRange._getTransformedByMergeOperation(t)), [e];
        }), m(n.Z, a.Z, function (e, t, s) {
          if (e.oldRange && (e.oldRange = u.Z._createFromRanges(e.oldRange._getTransformedByMoveOperation(t))), e.newRange) {
            if (s.abRelation) {
              var _o43 = u.Z._createFromRanges(e.newRange._getTransformedByMoveOperation(t));
              if ("left" == s.abRelation.side && t.targetPosition.isEqual(e.newRange.start)) return e.newRange.start.path = s.abRelation.path, e.newRange.end = _o43.end, [e];
              if ("right" == s.abRelation.side && t.targetPosition.isEqual(e.newRange.end)) return e.newRange.start = _o43.start, e.newRange.end.path = s.abRelation.path, [e];
            }
            e.newRange = u.Z._createFromRanges(e.newRange._getTransformedByMoveOperation(t));
          }
          return [e];
        }), m(n.Z, d.Z, function (e, t, s) {
          if (e.oldRange && (e.oldRange = e.oldRange._getTransformedBySplitOperation(t)), e.newRange) {
            if (s.abRelation) {
              var _o44 = e.newRange._getTransformedBySplitOperation(t);
              return e.newRange.start.isEqual(t.splitPosition) && s.abRelation.wasStartBeforeMergedElement ? e.newRange.start = g.ZP._createAt(t.insertionPosition) : e.newRange.start.isEqual(t.splitPosition) && !s.abRelation.wasInLeftElement && (e.newRange.start = g.ZP._createAt(t.moveTargetPosition)), e.newRange.end.isEqual(t.splitPosition) && s.abRelation.wasInRightElement ? e.newRange.end = g.ZP._createAt(t.moveTargetPosition) : e.newRange.end.isEqual(t.splitPosition) && s.abRelation.wasEndBeforeMergedElement ? e.newRange.end = g.ZP._createAt(t.insertionPosition) : e.newRange.end = _o44.end, [e];
            }
            e.newRange = e.newRange._getTransformedBySplitOperation(t);
          }
          return [e];
        }), m(l.Z, o.Z, function (e, t) {
          return e.sourcePosition.hasSameParentAs(t.position) && (e.howMany += t.howMany), e.sourcePosition = e.sourcePosition._getTransformedByInsertOperation(t), e.targetPosition = e.targetPosition._getTransformedByInsertOperation(t), [e];
        }), m(l.Z, l.Z, function (e, t, s) {
          if (e.sourcePosition.isEqual(t.sourcePosition) && e.targetPosition.isEqual(t.targetPosition)) {
            if (s.bWasUndone) {
              var _s83 = t.graveyardPosition.path.slice();
              return _s83.push(0), e.sourcePosition = new g.ZP(t.graveyardPosition.root, _s83), e.howMany = 0, [e];
            }
            return [new h.Z(0)];
          }
          if (e.sourcePosition.isEqual(t.sourcePosition) && !e.targetPosition.isEqual(t.targetPosition) && !s.bWasUndone && "splitAtSource" != s.abRelation) {
            var _o45 = "$graveyard" == e.targetPosition.root.rootName,
              _i50 = "$graveyard" == t.targetPosition.root.rootName,
              _r26 = _o45 && !_i50;
            if (_i50 && !_o45 || !_r26 && s.aIsStrong) {
              var _s84 = t.targetPosition._getTransformedByMergeOperation(t),
                _o46 = e.targetPosition._getTransformedByMergeOperation(t);
              return [new a.Z(_s84, e.howMany, _o46, 0)];
            }
            return [new h.Z(0)];
          }
          return e.sourcePosition.hasSameParentAs(t.targetPosition) && (e.howMany += t.howMany), e.sourcePosition = e.sourcePosition._getTransformedByMergeOperation(t), e.targetPosition = e.targetPosition._getTransformedByMergeOperation(t), e.graveyardPosition.isEqual(t.graveyardPosition) && s.aIsStrong || (e.graveyardPosition = e.graveyardPosition._getTransformedByMergeOperation(t)), [e];
        }), m(l.Z, a.Z, function (e, t, s) {
          var o = u.Z._createFromPositionAndShift(t.sourcePosition, t.howMany);
          return "remove" == t.type && !s.bWasUndone && !s.forceWeakRemove && e.deletionPosition.hasSameParentAs(t.sourcePosition) && o.containsPosition(e.sourcePosition) ? [new h.Z(0)] : (e.sourcePosition.hasSameParentAs(t.targetPosition) && (e.howMany += t.howMany), e.sourcePosition.hasSameParentAs(t.sourcePosition) && (e.howMany -= t.howMany), e.sourcePosition = e.sourcePosition._getTransformedByMoveOperation(t), e.targetPosition = e.targetPosition._getTransformedByMoveOperation(t), e.graveyardPosition.isEqual(t.targetPosition) || (e.graveyardPosition = e.graveyardPosition._getTransformedByMoveOperation(t)), [e]);
        }), m(l.Z, d.Z, function (e, t, s) {
          if (t.graveyardPosition && (e.graveyardPosition = e.graveyardPosition._getTransformedByDeletion(t.graveyardPosition, 1), e.deletionPosition.isEqual(t.graveyardPosition) && (e.howMany = t.howMany)), e.targetPosition.isEqual(t.splitPosition)) {
            var _o47 = 0 != t.howMany,
              _i51 = t.graveyardPosition && e.deletionPosition.isEqual(t.graveyardPosition);
            if (_o47 || _i51 || "mergeTargetNotMoved" == s.abRelation) return e.sourcePosition = e.sourcePosition._getTransformedBySplitOperation(t), [e];
          }
          if (e.sourcePosition.isEqual(t.splitPosition)) {
            if ("mergeSourceNotMoved" == s.abRelation) return e.howMany = 0, e.targetPosition = e.targetPosition._getTransformedBySplitOperation(t), [e];
            if ("mergeSameElement" == s.abRelation || e.sourcePosition.offset > 0) return e.sourcePosition = t.moveTargetPosition.clone(), e.targetPosition = e.targetPosition._getTransformedBySplitOperation(t), [e];
          }
          return e.sourcePosition.hasSameParentAs(t.splitPosition) && (e.howMany = t.splitPosition.offset), e.sourcePosition = e.sourcePosition._getTransformedBySplitOperation(t), e.targetPosition = e.targetPosition._getTransformedBySplitOperation(t), [e];
        }), m(a.Z, o.Z, function (e, t) {
          var s = u.Z._createFromPositionAndShift(e.sourcePosition, e.howMany)._getTransformedByInsertOperation(t, !1)[0];
          return e.sourcePosition = s.start, e.howMany = s.end.offset - s.start.offset, e.targetPosition.isEqual(t.position) || (e.targetPosition = e.targetPosition._getTransformedByInsertOperation(t)), [e];
        }), m(a.Z, a.Z, function (e, t, s) {
          var o = u.Z._createFromPositionAndShift(e.sourcePosition, e.howMany),
            i = u.Z._createFromPositionAndShift(t.sourcePosition, t.howMany);
          var r,
            n = s.aIsStrong,
            a = !s.aIsStrong;
          if ("insertBefore" == s.abRelation || "insertAfter" == s.baRelation ? a = !0 : "insertAfter" != s.abRelation && "insertBefore" != s.baRelation || (a = !1), r = e.targetPosition.isEqual(t.targetPosition) && a ? e.targetPosition._getTransformedByDeletion(t.sourcePosition, t.howMany) : e.targetPosition._getTransformedByMove(t.sourcePosition, t.targetPosition, t.howMany), P(e, t) && P(t, e)) return [t.getReversed()];
          if (o.containsPosition(t.targetPosition) && o.containsRange(i, !0)) return o.start = o.start._getTransformedByMove(t.sourcePosition, t.targetPosition, t.howMany), o.end = o.end._getTransformedByMove(t.sourcePosition, t.targetPosition, t.howMany), j([o], r);
          if (i.containsPosition(e.targetPosition) && i.containsRange(o, !0)) return o.start = o.start._getCombined(t.sourcePosition, t.getMovedRangeStart()), o.end = o.end._getCombined(t.sourcePosition, t.getMovedRangeStart()), j([o], r);
          var c = (0, p.Z)(e.sourcePosition.getParentPath(), t.sourcePosition.getParentPath());
          if ("prefix" == c || "extension" == c) return o.start = o.start._getTransformedByMove(t.sourcePosition, t.targetPosition, t.howMany), o.end = o.end._getTransformedByMove(t.sourcePosition, t.targetPosition, t.howMany), j([o], r);
          "remove" != e.type || "remove" == t.type || s.aWasUndone || s.forceWeakRemove ? "remove" == e.type || "remove" != t.type || s.bWasUndone || s.forceWeakRemove || (n = !1) : n = !0;
          var l = [],
            d = o.getDifference(i);
          var _iterator154 = _createForOfIteratorHelper(d),
            _step154;
          try {
            for (_iterator154.s(); !(_step154 = _iterator154.n()).done;) {
              var _e119 = _step154.value;
              _e119.start = _e119.start._getTransformedByDeletion(t.sourcePosition, t.howMany), _e119.end = _e119.end._getTransformedByDeletion(t.sourcePosition, t.howMany);
              var _s85 = "same" == (0, p.Z)(_e119.start.getParentPath(), t.getMovedRangeStart().getParentPath()),
                _o48 = _e119._getTransformedByInsertion(t.getMovedRangeStart(), t.howMany, _s85);
              l.push.apply(l, _toConsumableArray(_o48));
            }
          } catch (err) {
            _iterator154.e(err);
          } finally {
            _iterator154.f();
          }
          var g = o.getIntersection(i);
          return null !== g && n && (g.start = g.start._getCombined(t.sourcePosition, t.getMovedRangeStart()), g.end = g.end._getCombined(t.sourcePosition, t.getMovedRangeStart()), 0 === l.length ? l.push(g) : 1 == l.length ? i.start.isBefore(o.start) || i.start.isEqual(o.start) ? l.unshift(g) : l.push(g) : l.splice(1, 0, g)), 0 === l.length ? [new h.Z(e.baseVersion)] : j(l, r);
        }), m(a.Z, d.Z, function (e, t, s) {
          var o = e.targetPosition.clone();
          e.targetPosition.isEqual(t.insertionPosition) && t.graveyardPosition && "moveTargetAfter" != s.abRelation || (o = e.targetPosition._getTransformedBySplitOperation(t));
          var i = u.Z._createFromPositionAndShift(e.sourcePosition, e.howMany);
          if (i.end.isEqual(t.insertionPosition)) return t.graveyardPosition || e.howMany++, e.targetPosition = o, [e];
          if (i.start.hasSameParentAs(t.splitPosition) && i.containsPosition(t.splitPosition)) {
            var _e120 = new u.Z(t.splitPosition, i.end);
            _e120 = _e120._getTransformedBySplitOperation(t);
            return j([new u.Z(i.start, t.splitPosition), _e120], o);
          }
          e.targetPosition.isEqual(t.splitPosition) && "insertAtSource" == s.abRelation && (o = t.moveTargetPosition), e.targetPosition.isEqual(t.insertionPosition) && "insertBetween" == s.abRelation && (o = e.targetPosition);
          var r = [i._getTransformedBySplitOperation(t)];
          if (t.graveyardPosition) {
            var _o49 = i.start.isEqual(t.graveyardPosition) || i.containsPosition(t.graveyardPosition);
            e.howMany > 1 && _o49 && !s.aWasUndone && r.push(u.Z._createFromPositionAndShift(t.insertionPosition, 1));
          }
          return j(r, o);
        }), m(a.Z, l.Z, function (e, t, s) {
          var o = u.Z._createFromPositionAndShift(e.sourcePosition, e.howMany);
          if (t.deletionPosition.hasSameParentAs(e.sourcePosition) && o.containsPosition(t.sourcePosition)) if ("remove" != e.type || s.forceWeakRemove) {
            if (1 == e.howMany) return s.bWasUndone ? (e.sourcePosition = t.graveyardPosition.clone(), e.targetPosition = e.targetPosition._getTransformedByMergeOperation(t), [e]) : [new h.Z(0)];
          } else if (!s.aWasUndone) {
            var _s86 = [];
            var _o50 = t.graveyardPosition.clone(),
              _i52 = t.targetPosition._getTransformedByMergeOperation(t);
            e.howMany > 1 && (_s86.push(new a.Z(e.sourcePosition, e.howMany - 1, e.targetPosition, 0)), _o50 = _o50._getTransformedByMove(e.sourcePosition, e.targetPosition, e.howMany - 1), _i52 = _i52._getTransformedByMove(e.sourcePosition, e.targetPosition, e.howMany - 1));
            var _r27 = t.deletionPosition._getCombined(e.sourcePosition, e.targetPosition),
              _n12 = new a.Z(_o50, 1, _r27, 0),
              _c5 = _n12.getMovedRangeStart().path.slice();
            _c5.push(0);
            var _l3 = new g.ZP(_n12.targetPosition.root, _c5);
            _i52 = _i52._getTransformedByMove(_o50, _r27, 1);
            var _d = new a.Z(_i52, t.howMany, _l3, 0);
            return _s86.push(_n12), _s86.push(_d), _s86;
          }
          var i = u.Z._createFromPositionAndShift(e.sourcePosition, e.howMany)._getTransformedByMergeOperation(t);
          return e.sourcePosition = i.start, e.howMany = i.end.offset - i.start.offset, e.targetPosition = e.targetPosition._getTransformedByMergeOperation(t), [e];
        }), m(r.Z, o.Z, function (e, t) {
          return e.position = e.position._getTransformedByInsertOperation(t), [e];
        }), m(r.Z, l.Z, function (e, t) {
          return e.position.isEqual(t.deletionPosition) ? (e.position = t.graveyardPosition.clone(), e.position.stickiness = "toNext", [e]) : (e.position = e.position._getTransformedByMergeOperation(t), [e]);
        }), m(r.Z, a.Z, function (e, t) {
          return e.position = e.position._getTransformedByMoveOperation(t), [e];
        }), m(r.Z, r.Z, function (e, t, s) {
          if (e.position.isEqual(t.position)) {
            if (!s.aIsStrong) return [new h.Z(0)];
            e.oldName = t.newName;
          }
          return [e];
        }), m(r.Z, d.Z, function (e, t) {
          var s = e.position.path,
            o = t.splitPosition.getParentPath();
          if ("same" == (0, p.Z)(s, o) && !t.graveyardPosition) {
            var _t99 = new r.Z(e.position.getShiftedBy(1), e.oldName, e.newName, 0);
            return [e, _t99];
          }
          return e.position = e.position._getTransformedBySplitOperation(t), [e];
        }), m(c.Z, c.Z, function (e, t, s) {
          if (e.root === t.root && e.key === t.key) {
            if (!s.aIsStrong || e.newValue === t.newValue) return [new h.Z(0)];
            e.oldValue = t.newValue;
          }
          return [e];
        }), m(d.Z, o.Z, function (e, t) {
          return e.splitPosition.hasSameParentAs(t.position) && e.splitPosition.offset < t.position.offset && (e.howMany += t.howMany), e.splitPosition = e.splitPosition._getTransformedByInsertOperation(t), e.insertionPosition = e.insertionPosition._getTransformedByInsertOperation(t), [e];
        }), m(d.Z, l.Z, function (e, t, s) {
          if (!e.graveyardPosition && !s.bWasUndone && e.splitPosition.hasSameParentAs(t.sourcePosition)) {
            var _s87 = t.graveyardPosition.path.slice();
            _s87.push(0);
            var _o51 = new g.ZP(t.graveyardPosition.root, _s87),
              _i53 = d.Z.getInsertionPosition(new g.ZP(t.graveyardPosition.root, _s87)),
              _r28 = new d.Z(_o51, 0, _i53, null, 0);
            return e.splitPosition = e.splitPosition._getTransformedByMergeOperation(t), e.insertionPosition = d.Z.getInsertionPosition(e.splitPosition), e.graveyardPosition = _r28.insertionPosition.clone(), e.graveyardPosition.stickiness = "toNext", [_r28, e];
          }
          return e.splitPosition.hasSameParentAs(t.deletionPosition) && !e.splitPosition.isAfter(t.deletionPosition) && e.howMany--, e.splitPosition.hasSameParentAs(t.targetPosition) && (e.howMany += t.howMany), e.splitPosition = e.splitPosition._getTransformedByMergeOperation(t), e.insertionPosition = d.Z.getInsertionPosition(e.splitPosition), e.graveyardPosition && (e.graveyardPosition = e.graveyardPosition._getTransformedByMergeOperation(t)), [e];
        }), m(d.Z, a.Z, function (e, t, s) {
          var o = u.Z._createFromPositionAndShift(t.sourcePosition, t.howMany);
          if (e.graveyardPosition) {
            var _i54 = o.start.isEqual(e.graveyardPosition) || o.containsPosition(e.graveyardPosition);
            if (!s.bWasUndone && _i54) {
              var _s88 = e.splitPosition._getTransformedByMoveOperation(t),
                _o52 = e.graveyardPosition._getTransformedByMoveOperation(t),
                _i55 = _o52.path.slice();
              _i55.push(0);
              var _r29 = new g.ZP(_o52.root, _i55);
              return [new a.Z(_s88, e.howMany, _r29, 0)];
            }
            e.graveyardPosition = e.graveyardPosition._getTransformedByMoveOperation(t);
          }
          var i = e.splitPosition.isEqual(t.targetPosition);
          if (i && ("insertAtSource" == s.baRelation || "splitBefore" == s.abRelation)) return e.howMany += t.howMany, e.splitPosition = e.splitPosition._getTransformedByDeletion(t.sourcePosition, t.howMany), e.insertionPosition = d.Z.getInsertionPosition(e.splitPosition), [e];
          if (i && s.abRelation && s.abRelation.howMany) {
            var _s$abRelation = s.abRelation,
              _t100 = _s$abRelation.howMany,
              _o53 = _s$abRelation.offset;
            return e.howMany += _t100, e.splitPosition = e.splitPosition.getShiftedBy(_o53), [e];
          }
          if (e.splitPosition.hasSameParentAs(t.sourcePosition) && o.containsPosition(e.splitPosition)) {
            var _s89 = t.howMany - (e.splitPosition.offset - t.sourcePosition.offset);
            return e.howMany -= _s89, e.splitPosition.hasSameParentAs(t.targetPosition) && e.splitPosition.offset < t.targetPosition.offset && (e.howMany += t.howMany), e.splitPosition = t.sourcePosition.clone(), e.insertionPosition = d.Z.getInsertionPosition(e.splitPosition), [e];
          }
          return t.sourcePosition.isEqual(t.targetPosition) || (e.splitPosition.hasSameParentAs(t.sourcePosition) && e.splitPosition.offset <= t.sourcePosition.offset && (e.howMany -= t.howMany), e.splitPosition.hasSameParentAs(t.targetPosition) && e.splitPosition.offset < t.targetPosition.offset && (e.howMany += t.howMany)), e.splitPosition.stickiness = "toNone", e.splitPosition = e.splitPosition._getTransformedByMoveOperation(t), e.splitPosition.stickiness = "toNext", e.graveyardPosition ? e.insertionPosition = e.insertionPosition._getTransformedByMoveOperation(t) : e.insertionPosition = d.Z.getInsertionPosition(e.splitPosition), [e];
        }), m(d.Z, d.Z, function (e, t, s) {
          if (e.splitPosition.isEqual(t.splitPosition)) {
            if (!e.graveyardPosition && !t.graveyardPosition) return [new h.Z(0)];
            if (e.graveyardPosition && t.graveyardPosition && e.graveyardPosition.isEqual(t.graveyardPosition)) return [new h.Z(0)];
            if ("splitBefore" == s.abRelation) return e.howMany = 0, e.graveyardPosition = e.graveyardPosition._getTransformedBySplitOperation(t), [e];
          }
          if (e.graveyardPosition && t.graveyardPosition && e.graveyardPosition.isEqual(t.graveyardPosition)) {
            var _o54 = "$graveyard" == e.splitPosition.root.rootName,
              _i56 = "$graveyard" == t.splitPosition.root.rootName,
              _r30 = _o54 && !_i56;
            if (_i56 && !_o54 || !_r30 && s.aIsStrong) {
              var _s90 = [];
              return t.howMany && _s90.push(new a.Z(t.moveTargetPosition, t.howMany, t.splitPosition, 0)), e.howMany && _s90.push(new a.Z(e.splitPosition, e.howMany, e.moveTargetPosition, 0)), _s90;
            }
            return [new h.Z(0)];
          }
          if (e.graveyardPosition && (e.graveyardPosition = e.graveyardPosition._getTransformedBySplitOperation(t)), e.splitPosition.isEqual(t.insertionPosition) && "splitBefore" == s.abRelation) return e.howMany++, [e];
          if (t.splitPosition.isEqual(e.insertionPosition) && "splitBefore" == s.baRelation) {
            var _s91 = t.insertionPosition.path.slice();
            _s91.push(0);
            var _o55 = new g.ZP(t.insertionPosition.root, _s91);
            return [e, new a.Z(e.insertionPosition, 1, _o55, 0)];
          }
          return e.splitPosition.hasSameParentAs(t.splitPosition) && e.splitPosition.offset < t.splitPosition.offset && (e.howMany -= t.howMany), e.splitPosition = e.splitPosition._getTransformedBySplitOperation(t), e.insertionPosition = d.Z.getInsertionPosition(e.splitPosition), [e];
        });
      },
      "./packages/ckeditor5-engine/src/model/operation/utils.js": function _packages_ckeditor5Engine_src_model_operation_utilsJs(e, t, s) {
        "use strict";

        s.d(t, {
          So: function So() {
            return p;
          },
          X9: function X9() {
            return h;
          },
          XF: function XF() {
            return u;
          },
          fj: function fj() {
            return d;
          },
          pX: function pX() {
            return g;
          }
        });
        var o = s("./packages/ckeditor5-engine/src/model/node.js"),
          i = s("./packages/ckeditor5-engine/src/model/text.js"),
          r = s("./packages/ckeditor5-engine/src/model/textproxy.js"),
          n = s("./packages/ckeditor5-engine/src/model/range.js"),
          a = s("./packages/ckeditor5-engine/src/model/documentfragment.js"),
          c = s("./packages/ckeditor5-engine/src/model/nodelist.js"),
          l = s("./packages/ckeditor5-utils/src/ckeditorerror.js");
        function d(e, t) {
          var s = (t = p(t)).reduce(function (e, t) {
              return e + t.offsetSize;
            }, 0),
            o = e.parent;
          m(e);
          var i = e.index;
          return o._insertChild(i, t), f(o, i + t.length), f(o, i), new n.Z(e, e.getShiftedBy(s));
        }
        function h(e) {
          if (!e.isFlat) throw new l.ZP("operation-utils-remove-range-not-flat", this);
          var t = e.start.parent;
          m(e.start), m(e.end);
          var s = t._removeChildren(e.start.index, e.end.index - e.start.index);
          return f(t, e.start.index), s;
        }
        function u(e, t) {
          if (!e.isFlat) throw new l.ZP("operation-utils-move-range-not-flat", this);
          var s = h(e);
          return d(t = t._getTransformedByDeletion(e.start, e.end.offset - e.start.offset), s);
        }
        function g(e, t, s) {
          m(e.start), m(e.end);
          var _iterator155 = _createForOfIteratorHelper(e.getItems({
              shallow: !0
            })),
            _step155;
          try {
            for (_iterator155.s(); !(_step155 = _iterator155.n()).done;) {
              var _o56 = _step155.value;
              var _e121 = _o56.is("$textProxy") ? _o56.textNode : _o56;
              null !== s ? _e121._setAttribute(t, s) : _e121._removeAttribute(t), f(_e121.parent, _e121.index);
            }
          } catch (err) {
            _iterator155.e(err);
          } finally {
            _iterator155.f();
          }
          f(e.end.parent, e.end.index);
        }
        function p(e) {
          var t = [];
          e instanceof Array || (e = [e]);
          for (var _s92 = 0; _s92 < e.length; _s92++) if ("string" == typeof e[_s92]) t.push(new i.Z(e[_s92]));else if (e[_s92] instanceof r.Z) t.push(new i.Z(e[_s92].data, e[_s92].getAttributes()));else if (e[_s92] instanceof a.Z || e[_s92] instanceof c.Z) {
            var _iterator156 = _createForOfIteratorHelper(e[_s92]),
              _step156;
            try {
              for (_iterator156.s(); !(_step156 = _iterator156.n()).done;) {
                var _o57 = _step156.value;
                t.push(_o57);
              }
            } catch (err) {
              _iterator156.e(err);
            } finally {
              _iterator156.f();
            }
          } else e[_s92] instanceof o.Z && t.push(e[_s92]);
          for (var _e122 = 1; _e122 < t.length; _e122++) {
            var _s93 = t[_e122],
              _o58 = t[_e122 - 1];
            _s93 instanceof i.Z && _o58 instanceof i.Z && k(_s93, _o58) && (t.splice(_e122 - 1, 2, new i.Z(_o58.data + _s93.data, _o58.getAttributes())), _e122--);
          }
          return t;
        }
        function f(e, t) {
          var s = e.getChild(t - 1),
            o = e.getChild(t);
          if (s && o && s.is("$text") && o.is("$text") && k(s, o)) {
            var _r31 = new i.Z(s.data + o.data, s.getAttributes());
            e._removeChildren(t - 1, 2), e._insertChild(t - 1, _r31);
          }
        }
        function m(e) {
          var t = e.textNode,
            s = e.parent;
          if (t) {
            var _o59 = e.offset - t.startOffset,
              _r32 = t.index;
            s._removeChildren(_r32, 1);
            var _n13 = new i.Z(t.data.substr(0, _o59), t.getAttributes()),
              _a6 = new i.Z(t.data.substr(_o59), t.getAttributes());
            s._insertChild(_r32, [_n13, _a6]);
          }
        }
        function k(e, t) {
          var s = e.getAttributes(),
            o = t.getAttributes();
          var _iterator157 = _createForOfIteratorHelper(s),
            _step157;
          try {
            for (_iterator157.s(); !(_step157 = _iterator157.n()).done;) {
              var _e123 = _step157.value;
              if (_e123[1] !== t.getAttribute(_e123[0])) return !1;
              o.next();
            }
          } catch (err) {
            _iterator157.e(err);
          } finally {
            _iterator157.f();
          }
          return o.next().done;
        }
      },
      "./packages/ckeditor5-engine/src/model/position.js": function _packages_ckeditor5Engine_src_model_positionJs(e, t, s) {
        "use strict";

        s.d(t, {
          Rt: function Rt() {
            return a;
          },
          Ux: function Ux() {
            return c;
          },
          YV: function YV() {
            return l;
          },
          ZP: function ZP() {
            return n;
          }
        });
        var o = s("./packages/ckeditor5-engine/src/model/treewalker.js"),
          i = s("./packages/ckeditor5-utils/src/comparearrays.js"),
          r = s("./packages/ckeditor5-utils/src/ckeditorerror.js");
        s("./packages/ckeditor5-utils/src/version.js");
        var n = /*#__PURE__*/function () {
          function n(e, t) {
            var s = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "toNone";
            _classCallCheck(this, n);
            if (!e.is("element") && !e.is("documentFragment")) throw new r.ZP("model-position-root-invalid", e);
            if (!(t instanceof Array) || 0 === t.length) throw new r.ZP("model-position-path-incorrect-format", e, {
              path: t
            });
            e.is("rootElement") ? t = t.slice() : (t = [].concat(_toConsumableArray(e.getPath()), _toConsumableArray(t)), e = e.root), this.root = e, this.path = t, this.stickiness = s;
          }
          _createClass(n, [{
            key: "compareWith",
            value: function compareWith(e) {
              if (this.root != e.root) return "different";
              var t = (0, i.Z)(this.path, e.path);
              switch (t) {
                case "same":
                  return "same";
                case "prefix":
                  return "before";
                case "extension":
                  return "after";
                default:
                  return this.path[t] < e.path[t] ? "before" : "after";
              }
            }
          }, {
            key: "getLastMatchingPosition",
            value: function getLastMatchingPosition(e) {
              var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
              t.startPosition = this;
              var s = new o.Z(t);
              return s.skip(e), s.position;
            }
          }, {
            key: "getParentPath",
            value: function getParentPath() {
              return this.path.slice(0, -1);
            }
          }, {
            key: "getAncestors",
            value: function getAncestors() {
              var e = this.parent;
              return e.is("documentFragment") ? [e] : e.getAncestors({
                includeSelf: !0
              });
            }
          }, {
            key: "findAncestor",
            value: function findAncestor(e) {
              var t = this.parent;
              return t.is("element") ? t.findAncestor(e, {
                includeSelf: !0
              }) : null;
            }
          }, {
            key: "getCommonPath",
            value: function getCommonPath(e) {
              if (this.root != e.root) return [];
              var t = (0, i.Z)(this.path, e.path),
                s = "string" == typeof t ? Math.min(this.path.length, e.path.length) : t;
              return this.path.slice(0, s);
            }
          }, {
            key: "getCommonAncestor",
            value: function getCommonAncestor(e) {
              var t = this.getAncestors(),
                s = e.getAncestors();
              var o = 0;
              for (; t[o] == s[o] && t[o];) o++;
              return 0 === o ? null : t[o - 1];
            }
          }, {
            key: "getShiftedBy",
            value: function getShiftedBy(e) {
              var t = this.clone(),
                s = t.offset + e;
              return t.offset = s < 0 ? 0 : s, t;
            }
          }, {
            key: "isAfter",
            value: function isAfter(e) {
              return "after" == this.compareWith(e);
            }
          }, {
            key: "isBefore",
            value: function isBefore(e) {
              return "before" == this.compareWith(e);
            }
          }, {
            key: "isEqual",
            value: function isEqual(e) {
              return "same" == this.compareWith(e);
            }
          }, {
            key: "isTouching",
            value: function isTouching(e) {
              var t = null,
                s = null;
              switch (this.compareWith(e)) {
                case "same":
                  return !0;
                case "before":
                  t = n._createAt(this), s = n._createAt(e);
                  break;
                case "after":
                  t = n._createAt(e), s = n._createAt(this);
                  break;
                default:
                  return !1;
              }
              var o = t.parent;
              for (; t.path.length + s.path.length;) {
                if (t.isEqual(s)) return !0;
                if (t.path.length > s.path.length) {
                  if (t.offset !== o.maxOffset) return !1;
                  t.path = t.path.slice(0, -1), o = o.parent, t.offset++;
                } else {
                  if (0 !== s.offset) return !1;
                  s.path = s.path.slice(0, -1);
                }
              }
            }
          }, {
            key: "is",
            value: function is(e) {
              return "position" === e || "model:position" === e;
            }
          }, {
            key: "hasSameParentAs",
            value: function hasSameParentAs(e) {
              if (this.root !== e.root) return !1;
              var t = this.getParentPath(),
                s = e.getParentPath();
              return "same" == (0, i.Z)(t, s);
            }
          }, {
            key: "getTransformedByOperation",
            value: function getTransformedByOperation(e) {
              var t;
              switch (e.type) {
                case "insert":
                  t = this._getTransformedByInsertOperation(e);
                  break;
                case "move":
                case "remove":
                case "reinsert":
                  t = this._getTransformedByMoveOperation(e);
                  break;
                case "split":
                  t = this._getTransformedBySplitOperation(e);
                  break;
                case "merge":
                  t = this._getTransformedByMergeOperation(e);
                  break;
                default:
                  t = n._createAt(this);
              }
              return t;
            }
          }, {
            key: "_getTransformedByInsertOperation",
            value: function _getTransformedByInsertOperation(e) {
              return this._getTransformedByInsertion(e.position, e.howMany);
            }
          }, {
            key: "_getTransformedByMoveOperation",
            value: function _getTransformedByMoveOperation(e) {
              return this._getTransformedByMove(e.sourcePosition, e.targetPosition, e.howMany);
            }
          }, {
            key: "_getTransformedBySplitOperation",
            value: function _getTransformedBySplitOperation(e) {
              var t = e.movedRange;
              return t.containsPosition(this) || t.start.isEqual(this) && "toNext" == this.stickiness ? this._getCombined(e.splitPosition, e.moveTargetPosition) : e.graveyardPosition ? this._getTransformedByMove(e.graveyardPosition, e.insertionPosition, 1) : this._getTransformedByInsertion(e.insertionPosition, 1);
            }
          }, {
            key: "_getTransformedByMergeOperation",
            value: function _getTransformedByMergeOperation(e) {
              var t = e.movedRange;
              var s;
              return t.containsPosition(this) || t.start.isEqual(this) ? (s = this._getCombined(e.sourcePosition, e.targetPosition), e.sourcePosition.isBefore(e.targetPosition) && (s = s._getTransformedByDeletion(e.deletionPosition, 1))) : s = this.isEqual(e.deletionPosition) ? n._createAt(e.deletionPosition) : this._getTransformedByMove(e.deletionPosition, e.graveyardPosition, 1), s;
            }
          }, {
            key: "_getTransformedByDeletion",
            value: function _getTransformedByDeletion(e, t) {
              var s = n._createAt(this);
              if (this.root != e.root) return s;
              if ("same" == (0, i.Z)(e.getParentPath(), this.getParentPath())) {
                if (e.offset < this.offset) {
                  if (e.offset + t > this.offset) return null;
                  s.offset -= t;
                }
              } else if ("prefix" == (0, i.Z)(e.getParentPath(), this.getParentPath())) {
                var _o60 = e.path.length - 1;
                if (e.offset <= this.path[_o60]) {
                  if (e.offset + t > this.path[_o60]) return null;
                  s.path[_o60] -= t;
                }
              }
              return s;
            }
          }, {
            key: "_getTransformedByInsertion",
            value: function _getTransformedByInsertion(e, t) {
              var s = n._createAt(this);
              if (this.root != e.root) return s;
              if ("same" == (0, i.Z)(e.getParentPath(), this.getParentPath())) (e.offset < this.offset || e.offset == this.offset && "toPrevious" != this.stickiness) && (s.offset += t);else if ("prefix" == (0, i.Z)(e.getParentPath(), this.getParentPath())) {
                var _o61 = e.path.length - 1;
                e.offset <= this.path[_o61] && (s.path[_o61] += t);
              }
              return s;
            }
          }, {
            key: "_getTransformedByMove",
            value: function _getTransformedByMove(e, t, s) {
              if (t = t._getTransformedByDeletion(e, s), e.isEqual(t)) return n._createAt(this);
              var o = this._getTransformedByDeletion(e, s);
              return null === o || e.isEqual(this) && "toNext" == this.stickiness || e.getShiftedBy(s).isEqual(this) && "toPrevious" == this.stickiness ? this._getCombined(e, t) : o._getTransformedByInsertion(t, s);
            }
          }, {
            key: "_getCombined",
            value: function _getCombined(e, t) {
              var s = e.path.length - 1,
                o = n._createAt(t);
              return o.stickiness = this.stickiness, o.offset = o.offset + this.path[s] - e.offset, o.path = [].concat(_toConsumableArray(o.path), _toConsumableArray(this.path.slice(s + 1))), o;
            }
          }, {
            key: "toJSON",
            value: function toJSON() {
              return {
                root: this.root.toJSON(),
                path: Array.from(this.path),
                stickiness: this.stickiness
              };
            }
          }, {
            key: "clone",
            value: function clone() {
              return new this.constructor(this.root, this.path, this.stickiness);
            }
          }, {
            key: "offset",
            get: function get() {
              return this.path[this.path.length - 1];
            },
            set: function set(e) {
              this.path[this.path.length - 1] = e;
            }
          }, {
            key: "parent",
            get: function get() {
              var e = this.root;
              for (var _t101 = 0; _t101 < this.path.length - 1; _t101++) if (e = e.getChild(e.offsetToIndex(this.path[_t101])), !e) throw new r.ZP("model-position-path-incorrect", this, {
                position: this
              });
              if (e.is("$text")) throw new r.ZP("model-position-path-incorrect", this, {
                position: this
              });
              return e;
            }
          }, {
            key: "index",
            get: function get() {
              return this.parent.offsetToIndex(this.offset);
            }
          }, {
            key: "textNode",
            get: function get() {
              return a(this, this.parent);
            }
          }, {
            key: "nodeAfter",
            get: function get() {
              var e = this.parent;
              return c(this, e, a(this, e));
            }
          }, {
            key: "nodeBefore",
            get: function get() {
              var e = this.parent;
              return l(this, e, a(this, e));
            }
          }, {
            key: "isAtStart",
            get: function get() {
              return 0 === this.offset;
            }
          }, {
            key: "isAtEnd",
            get: function get() {
              return this.offset == this.parent.maxOffset;
            }
          }], [{
            key: "_createAt",
            value: function _createAt(e, t) {
              var s = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "toNone";
              if (e instanceof n) return new n(e.root, e.path, e.stickiness);
              {
                var _o62 = e;
                if ("end" == t) t = _o62.maxOffset;else {
                  if ("before" == t) return this._createBefore(_o62, s);
                  if ("after" == t) return this._createAfter(_o62, s);
                  if (0 !== t && !t) throw new r.ZP("model-createpositionat-offset-required", [this, e]);
                }
                if (!_o62.is("element") && !_o62.is("documentFragment")) throw new r.ZP("model-position-parent-incorrect", [this, e]);
                var _i57 = _o62.getPath();
                return _i57.push(t), new this(_o62.root, _i57, s);
              }
            }
          }, {
            key: "_createAfter",
            value: function _createAfter(e, t) {
              if (!e.parent) throw new r.ZP("model-position-after-root", [this, e], {
                root: e
              });
              return this._createAt(e.parent, e.endOffset, t);
            }
          }, {
            key: "_createBefore",
            value: function _createBefore(e, t) {
              if (!e.parent) throw new r.ZP("model-position-before-root", e, {
                root: e
              });
              return this._createAt(e.parent, e.startOffset, t);
            }
          }, {
            key: "fromJSON",
            value: function fromJSON(e, t) {
              if ("$graveyard" === e.root) {
                var _s94 = new n(t.graveyard, e.path);
                return _s94.stickiness = e.stickiness, _s94;
              }
              if (!t.getRoot(e.root)) throw new r.ZP("model-position-fromjson-no-root", t, {
                rootName: e.root
              });
              return new n(t.getRoot(e.root), e.path, e.stickiness);
            }
          }]);
          return n;
        }();
        function a(e, t) {
          var s = t.getChild(t.offsetToIndex(e.offset));
          return s && s.is("$text") && s.startOffset < e.offset ? s : null;
        }
        function c(e, t, s) {
          return null !== s ? null : t.getChild(t.offsetToIndex(e.offset));
        }
        function l(e, t, s) {
          return null !== s ? null : t.getChild(t.offsetToIndex(e.offset) - 1);
        }
      },
      "./packages/ckeditor5-engine/src/model/range.js": function _packages_ckeditor5Engine_src_model_rangeJs(e, t, s) {
        "use strict";

        s.d(t, {
          Z: function Z() {
            return a;
          }
        });
        var o = s("./packages/ckeditor5-engine/src/model/position.js"),
          i = s("./packages/ckeditor5-engine/src/model/treewalker.js"),
          r = s("./packages/ckeditor5-utils/src/ckeditorerror.js"),
          n = s("./packages/ckeditor5-utils/src/comparearrays.js");
        var a = /*#__PURE__*/function () {
          function a(e) {
            var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
            _classCallCheck(this, a);
            this.start = o.ZP._createAt(e), this.end = t ? o.ZP._createAt(t) : o.ZP._createAt(e), this.start.stickiness = this.isCollapsed ? "toNone" : "toNext", this.end.stickiness = this.isCollapsed ? "toNone" : "toPrevious";
          }
          _createClass(a, [{
            key: Symbol.iterator,
            value: /*#__PURE__*/_regeneratorRuntime().mark(function value() {
              return _regeneratorRuntime().wrap(function value$(_context8) {
                while (1) switch (_context8.prev = _context8.next) {
                  case 0:
                    return _context8.delegateYield(new i.Z({
                      boundaries: this,
                      ignoreElementEnd: !0
                    }), "t0", 1);
                  case 1:
                  case "end":
                    return _context8.stop();
                }
              }, value, this);
            })
          }, {
            key: "containsPosition",
            value: function containsPosition(e) {
              return e.isAfter(this.start) && e.isBefore(this.end);
            }
          }, {
            key: "containsRange",
            value: function containsRange(e) {
              var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
              e.isCollapsed && (t = !1);
              var s = this.containsPosition(e.start) || t && this.start.isEqual(e.start),
                o = this.containsPosition(e.end) || t && this.end.isEqual(e.end);
              return s && o;
            }
          }, {
            key: "containsItem",
            value: function containsItem(e) {
              var t = o.ZP._createBefore(e);
              return this.containsPosition(t) || this.start.isEqual(t);
            }
          }, {
            key: "is",
            value: function is(e) {
              return "range" === e || "model:range" === e;
            }
          }, {
            key: "isEqual",
            value: function isEqual(e) {
              return this.start.isEqual(e.start) && this.end.isEqual(e.end);
            }
          }, {
            key: "isIntersecting",
            value: function isIntersecting(e) {
              return this.start.isBefore(e.end) && this.end.isAfter(e.start);
            }
          }, {
            key: "getDifference",
            value: function getDifference(e) {
              var t = [];
              return this.isIntersecting(e) ? (this.containsPosition(e.start) && t.push(new a(this.start, e.start)), this.containsPosition(e.end) && t.push(new a(e.end, this.end))) : t.push(new a(this.start, this.end)), t;
            }
          }, {
            key: "getIntersection",
            value: function getIntersection(e) {
              if (this.isIntersecting(e)) {
                var _t102 = this.start,
                  _s95 = this.end;
                return this.containsPosition(e.start) && (_t102 = e.start), this.containsPosition(e.end) && (_s95 = e.end), new a(_t102, _s95);
              }
              return null;
            }
          }, {
            key: "getJoined",
            value: function getJoined(e) {
              var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
              var s = this.isIntersecting(e);
              if (s || (s = this.start.isBefore(e.start) ? t ? this.end.isTouching(e.start) : this.end.isEqual(e.start) : t ? e.end.isTouching(this.start) : e.end.isEqual(this.start)), !s) return null;
              var o = this.start,
                i = this.end;
              return e.start.isBefore(o) && (o = e.start), e.end.isAfter(i) && (i = e.end), new a(o, i);
            }
          }, {
            key: "getMinimalFlatRanges",
            value: function getMinimalFlatRanges() {
              var e = [],
                t = this.start.getCommonPath(this.end).length,
                s = o.ZP._createAt(this.start);
              var i = s.parent;
              for (; s.path.length > t + 1;) {
                var _t103 = i.maxOffset - s.offset;
                0 !== _t103 && e.push(new a(s, s.getShiftedBy(_t103))), s.path = s.path.slice(0, -1), s.offset++, i = i.parent;
              }
              for (; s.path.length <= this.end.path.length;) {
                var _t104 = this.end.path[s.path.length - 1],
                  _o63 = _t104 - s.offset;
                0 !== _o63 && e.push(new a(s, s.getShiftedBy(_o63))), s.offset = _t104, s.path.push(0);
              }
              return e;
            }
          }, {
            key: "getWalker",
            value: function getWalker() {
              var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
              return e.boundaries = this, new i.Z(e);
            }
          }, {
            key: "getItems",
            value: function getItems() {
              var _this44 = this;
              var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
              return /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
                var t, _iterator158, _step158, _e124;
                return _regeneratorRuntime().wrap(function _callee$(_context9) {
                  while (1) switch (_context9.prev = _context9.next) {
                    case 0:
                      e.boundaries = _this44, e.ignoreElementEnd = !0;
                      t = new i.Z(e);
                      _iterator158 = _createForOfIteratorHelper(t);
                      _context9.prev = 3;
                      _iterator158.s();
                    case 5:
                      if ((_step158 = _iterator158.n()).done) {
                        _context9.next = 11;
                        break;
                      }
                      _e124 = _step158.value;
                      _context9.next = 9;
                      return _e124.item;
                    case 9:
                      _context9.next = 5;
                      break;
                    case 11:
                      _context9.next = 16;
                      break;
                    case 13:
                      _context9.prev = 13;
                      _context9.t0 = _context9["catch"](3);
                      _iterator158.e(_context9.t0);
                    case 16:
                      _context9.prev = 16;
                      _iterator158.f();
                      return _context9.finish(16);
                    case 19:
                    case "end":
                      return _context9.stop();
                  }
                }, _callee, null, [[3, 13, 16, 19]]);
              })();
            }
          }, {
            key: "getPositions",
            value: function getPositions() {
              var _this45 = this;
              var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
              return /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
                var t, _iterator159, _step159, _e125;
                return _regeneratorRuntime().wrap(function _callee2$(_context10) {
                  while (1) switch (_context10.prev = _context10.next) {
                    case 0:
                      e.boundaries = _this45;
                      t = new i.Z(e);
                      _context10.next = 4;
                      return t.position;
                    case 4:
                      _iterator159 = _createForOfIteratorHelper(t);
                      _context10.prev = 5;
                      _iterator159.s();
                    case 7:
                      if ((_step159 = _iterator159.n()).done) {
                        _context10.next = 13;
                        break;
                      }
                      _e125 = _step159.value;
                      _context10.next = 11;
                      return _e125.nextPosition;
                    case 11:
                      _context10.next = 7;
                      break;
                    case 13:
                      _context10.next = 18;
                      break;
                    case 15:
                      _context10.prev = 15;
                      _context10.t0 = _context10["catch"](5);
                      _iterator159.e(_context10.t0);
                    case 18:
                      _context10.prev = 18;
                      _iterator159.f();
                      return _context10.finish(18);
                    case 21:
                    case "end":
                      return _context10.stop();
                  }
                }, _callee2, null, [[5, 15, 18, 21]]);
              })();
            }
          }, {
            key: "getTransformedByOperation",
            value: function getTransformedByOperation(e) {
              switch (e.type) {
                case "insert":
                  return this._getTransformedByInsertOperation(e);
                case "move":
                case "remove":
                case "reinsert":
                  return this._getTransformedByMoveOperation(e);
                case "split":
                  return [this._getTransformedBySplitOperation(e)];
                case "merge":
                  return [this._getTransformedByMergeOperation(e)];
              }
              return [new a(this.start, this.end)];
            }
          }, {
            key: "getTransformedByOperations",
            value: function getTransformedByOperations(e) {
              var t = [new a(this.start, this.end)];
              var _iterator160 = _createForOfIteratorHelper(e),
                _step160;
              try {
                for (_iterator160.s(); !(_step160 = _iterator160.n()).done;) {
                  var _s97 = _step160.value;
                  for (var _e128 = 0; _e128 < t.length; _e128++) {
                    var _o65 = t[_e128].getTransformedByOperation(_s97);
                    t.splice.apply(t, [_e128, 1].concat(_toConsumableArray(_o65))), _e128 += _o65.length - 1;
                  }
                }
              } catch (err) {
                _iterator160.e(err);
              } finally {
                _iterator160.f();
              }
              for (var _e126 = 0; _e126 < t.length; _e126++) {
                var _s96 = t[_e126];
                for (var _o64 = _e126 + 1; _o64 < t.length; _o64++) {
                  var _e127 = t[_o64];
                  (_s96.containsRange(_e127) || _e127.containsRange(_s96) || _s96.isEqual(_e127)) && t.splice(_o64, 1);
                }
              }
              return t;
            }
          }, {
            key: "getCommonAncestor",
            value: function getCommonAncestor() {
              return this.start.getCommonAncestor(this.end);
            }
          }, {
            key: "getContainedElement",
            value: function getContainedElement() {
              if (this.isCollapsed) return null;
              var e = this.start.nodeAfter,
                t = this.end.nodeBefore;
              return e && e.is("element") && e === t ? e : null;
            }
          }, {
            key: "toJSON",
            value: function toJSON() {
              return {
                start: this.start.toJSON(),
                end: this.end.toJSON()
              };
            }
          }, {
            key: "clone",
            value: function clone() {
              return new this.constructor(this.start, this.end);
            }
          }, {
            key: "_getTransformedByInsertOperation",
            value: function _getTransformedByInsertOperation(e) {
              var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
              return this._getTransformedByInsertion(e.position, e.howMany, t);
            }
          }, {
            key: "_getTransformedByMoveOperation",
            value: function _getTransformedByMoveOperation(e) {
              var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
              var s = e.sourcePosition,
                o = e.howMany,
                i = e.targetPosition;
              return this._getTransformedByMove(s, i, o, t);
            }
          }, {
            key: "_getTransformedBySplitOperation",
            value: function _getTransformedBySplitOperation(e) {
              var t = this.start._getTransformedBySplitOperation(e);
              var s = this.end._getTransformedBySplitOperation(e);
              return this.end.isEqual(e.insertionPosition) && (s = this.end.getShiftedBy(1)), t.root != s.root && (s = this.end.getShiftedBy(-1)), new a(t, s);
            }
          }, {
            key: "_getTransformedByMergeOperation",
            value: function _getTransformedByMergeOperation(e) {
              if (this.start.isEqual(e.targetPosition) && this.end.isEqual(e.deletionPosition)) return new a(this.start);
              var t = this.start._getTransformedByMergeOperation(e),
                s = this.end._getTransformedByMergeOperation(e);
              return t.root != s.root && (s = this.end.getShiftedBy(-1)), t.isAfter(s) ? (e.sourcePosition.isBefore(e.targetPosition) ? (t = o.ZP._createAt(s), t.offset = 0) : (e.deletionPosition.isEqual(t) || (s = e.deletionPosition), t = e.targetPosition), new a(t, s)) : new a(t, s);
            }
          }, {
            key: "_getTransformedByInsertion",
            value: function _getTransformedByInsertion(e, t) {
              var s = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : !1;
              if (s && this.containsPosition(e)) return [new a(this.start, e), new a(e.getShiftedBy(t), this.end._getTransformedByInsertion(e, t))];
              {
                var _s98 = new a(this.start, this.end);
                return _s98.start = _s98.start._getTransformedByInsertion(e, t), _s98.end = _s98.end._getTransformedByInsertion(e, t), [_s98];
              }
            }
          }, {
            key: "_getTransformedByMove",
            value: function _getTransformedByMove(e, t, s) {
              var o = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : !1;
              if (this.isCollapsed) {
                var _o66 = this.start._getTransformedByMove(e, t, s);
                return [new a(_o66)];
              }
              var i = a._createFromPositionAndShift(e, s),
                r = t._getTransformedByDeletion(e, s);
              if (this.containsPosition(t) && !o && (i.containsPosition(this.start) || i.containsPosition(this.end))) {
                var _o67 = this.start._getTransformedByMove(e, t, s),
                  _i58 = this.end._getTransformedByMove(e, t, s);
                return [new a(_o67, _i58)];
              }
              var n;
              var c = this.getDifference(i);
              var l = null;
              var d = this.getIntersection(i);
              if (1 == c.length ? l = new a(c[0].start._getTransformedByDeletion(e, s), c[0].end._getTransformedByDeletion(e, s)) : 2 == c.length && (l = new a(this.start, this.end._getTransformedByDeletion(e, s))), n = l ? l._getTransformedByInsertion(r, s, null !== d || o) : [], d) {
                var _e129 = new a(d.start._getCombined(i.start, r), d.end._getCombined(i.start, r));
                2 == n.length ? n.splice(1, 0, _e129) : n.push(_e129);
              }
              return n;
            }
          }, {
            key: "_getTransformedByDeletion",
            value: function _getTransformedByDeletion(e, t) {
              var s = this.start._getTransformedByDeletion(e, t),
                o = this.end._getTransformedByDeletion(e, t);
              return null == s && null == o ? null : (null == s && (s = e), null == o && (o = e), new a(s, o));
            }
          }, {
            key: "isCollapsed",
            get: function get() {
              return this.start.isEqual(this.end);
            }
          }, {
            key: "isFlat",
            get: function get() {
              var e = this.start.getParentPath(),
                t = this.end.getParentPath();
              return "same" == (0, n.Z)(e, t);
            }
          }, {
            key: "root",
            get: function get() {
              return this.start.root;
            }
          }], [{
            key: "_createFromPositionAndShift",
            value: function _createFromPositionAndShift(e, t) {
              var s = e,
                o = e.getShiftedBy(t);
              return t > 0 ? new this(s, o) : new this(o, s);
            }
          }, {
            key: "_createIn",
            value: function _createIn(e) {
              return new this(o.ZP._createAt(e, 0), o.ZP._createAt(e, e.maxOffset));
            }
          }, {
            key: "_createOn",
            value: function _createOn(e) {
              return this._createFromPositionAndShift(o.ZP._createBefore(e), e.offsetSize);
            }
          }, {
            key: "_createFromRanges",
            value: function _createFromRanges(e) {
              if (0 === e.length) throw new r.ZP("range-create-from-ranges-empty-array", null);
              if (1 == e.length) return e[0].clone();
              var t = e[0];
              e.sort(function (e, t) {
                return e.start.isAfter(t.start) ? 1 : -1;
              });
              var s = e.indexOf(t),
                i = new this(t.start, t.end);
              if (s > 0) for (var _t105 = s - 1; e[_t105].end.isEqual(i.start); _t105++) i.start = o.ZP._createAt(e[_t105].start);
              for (var _t106 = s + 1; _t106 < e.length && e[_t106].start.isEqual(i.end); _t106++) i.end = o.ZP._createAt(e[_t106].end);
              return i;
            }
          }, {
            key: "fromJSON",
            value: function fromJSON(e, t) {
              return new this(o.ZP.fromJSON(e.start, t), o.ZP.fromJSON(e.end, t));
            }
          }]);
          return a;
        }();
      },
      "./packages/ckeditor5-engine/src/model/schema.js": function _packages_ckeditor5Engine_src_model_schemaJs(e, t, s) {
        "use strict";

        s.d(t, {
          G: function G() {
            return u;
          },
          Z: function Z() {
            return h;
          }
        });
        var o = s("./packages/ckeditor5-utils/src/ckeditorerror.js"),
          i = s("./packages/ckeditor5-utils/src/observablemixin.js"),
          r = s("./packages/ckeditor5-utils/src/mix.js"),
          n = s("./packages/ckeditor5-engine/src/model/range.js"),
          a = s("./packages/ckeditor5-engine/src/model/position.js"),
          c = s("./packages/ckeditor5-engine/src/model/element.js"),
          l = s("./packages/ckeditor5-engine/src/model/text.js"),
          d = s("./packages/ckeditor5-engine/src/model/treewalker.js");
        var h = /*#__PURE__*/function () {
          function h() {
            var _this46 = this;
            _classCallCheck(this, h);
            this._sourceDefinitions = {}, this._attributeProperties = {}, this.decorate("checkChild"), this.decorate("checkAttribute"), this.on("checkAttribute", function (e, t) {
              t[0] = new u(t[0]);
            }, {
              priority: "highest"
            }), this.on("checkChild", function (e, t) {
              t[0] = new u(t[0]), t[1] = _this46.getDefinition(t[1]);
            }, {
              priority: "highest"
            });
          }
          _createClass(h, [{
            key: "register",
            value: function register(e, t) {
              if (this._sourceDefinitions[e]) throw new o.ZP("schema-cannot-register-item-twice", this, {
                itemName: e
              });
              this._sourceDefinitions[e] = [Object.assign({}, t)], this._clearCache();
            }
          }, {
            key: "extend",
            value: function extend(e, t) {
              if (!this._sourceDefinitions[e]) throw new o.ZP("schema-cannot-extend-missing-item", this, {
                itemName: e
              });
              this._sourceDefinitions[e].push(Object.assign({}, t)), this._clearCache();
            }
          }, {
            key: "getDefinitions",
            value: function getDefinitions() {
              return this._compiledDefinitions || this._compile(), this._compiledDefinitions;
            }
          }, {
            key: "getDefinition",
            value: function getDefinition(e) {
              var t;
              return t = "string" == typeof e ? e : e.is && (e.is("$text") || e.is("$textProxy")) ? "$text" : e.name, this.getDefinitions()[t];
            }
          }, {
            key: "isRegistered",
            value: function isRegistered(e) {
              return !!this.getDefinition(e);
            }
          }, {
            key: "isBlock",
            value: function isBlock(e) {
              var t = this.getDefinition(e);
              return !(!t || !t.isBlock);
            }
          }, {
            key: "isLimit",
            value: function isLimit(e) {
              var t = this.getDefinition(e);
              return !!t && !(!t.isLimit && !t.isObject);
            }
          }, {
            key: "isObject",
            value: function isObject(e) {
              var t = this.getDefinition(e);
              return !!t && !!(t.isObject || t.isLimit && t.isSelectable && t.isContent);
            }
          }, {
            key: "isInline",
            value: function isInline(e) {
              var t = this.getDefinition(e);
              return !(!t || !t.isInline);
            }
          }, {
            key: "isSelectable",
            value: function isSelectable(e) {
              var t = this.getDefinition(e);
              return !!t && !(!t.isSelectable && !t.isObject);
            }
          }, {
            key: "isContent",
            value: function isContent(e) {
              var t = this.getDefinition(e);
              return !!t && !(!t.isContent && !t.isObject);
            }
          }, {
            key: "checkChild",
            value: function checkChild(e, t) {
              return !!t && this._checkContextMatch(t, e);
            }
          }, {
            key: "checkAttribute",
            value: function checkAttribute(e, t) {
              var s = this.getDefinition(e.last);
              return !!s && s.allowAttributes.includes(t);
            }
          }, {
            key: "checkMerge",
            value: function checkMerge(e) {
              var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
              if (e instanceof a.ZP) {
                var _t107 = e.nodeBefore,
                  _s99 = e.nodeAfter;
                if (!(_t107 instanceof c.Z)) throw new o.ZP("schema-check-merge-no-element-before", this);
                if (!(_s99 instanceof c.Z)) throw new o.ZP("schema-check-merge-no-element-after", this);
                return this.checkMerge(_t107, _s99);
              }
              var _iterator161 = _createForOfIteratorHelper(t.getChildren()),
                _step161;
              try {
                for (_iterator161.s(); !(_step161 = _iterator161.n()).done;) {
                  var _s100 = _step161.value;
                  if (!this.checkChild(e, _s100)) return !1;
                }
              } catch (err) {
                _iterator161.e(err);
              } finally {
                _iterator161.f();
              }
              return !0;
            }
          }, {
            key: "addChildCheck",
            value: function addChildCheck(e) {
              this.on("checkChild", function (t, _ref16) {
                var _ref17 = _slicedToArray(_ref16, 2),
                  s = _ref17[0],
                  o = _ref17[1];
                if (!o) return;
                var i = e(s, o);
                "boolean" == typeof i && (t.stop(), t.return = i);
              }, {
                priority: "high"
              });
            }
          }, {
            key: "addAttributeCheck",
            value: function addAttributeCheck(e) {
              this.on("checkAttribute", function (t, _ref18) {
                var _ref19 = _slicedToArray(_ref18, 2),
                  s = _ref19[0],
                  o = _ref19[1];
                var i = e(s, o);
                "boolean" == typeof i && (t.stop(), t.return = i);
              }, {
                priority: "high"
              });
            }
          }, {
            key: "setAttributeProperties",
            value: function setAttributeProperties(e, t) {
              this._attributeProperties[e] = Object.assign(this.getAttributeProperties(e), t);
            }
          }, {
            key: "getAttributeProperties",
            value: function getAttributeProperties(e) {
              return this._attributeProperties[e] || {};
            }
          }, {
            key: "getLimitElement",
            value: function getLimitElement(e) {
              var t;
              if (e instanceof a.ZP) t = e.parent;else {
                t = (e instanceof n.Z ? [e] : Array.from(e.getRanges())).reduce(function (e, t) {
                  var s = t.getCommonAncestor();
                  return e ? e.getCommonAncestor(s, {
                    includeSelf: !0
                  }) : s;
                }, null);
              }
              for (; !this.isLimit(t) && t.parent;) t = t.parent;
              return t;
            }
          }, {
            key: "checkAttributeInSelection",
            value: function checkAttributeInSelection(e, t) {
              if (e.isCollapsed) {
                var _s101 = [].concat(_toConsumableArray(e.getFirstPosition().getAncestors()), [new l.Z("", e.getAttributes())]);
                return this.checkAttribute(_s101, t);
              }
              {
                var _s102 = e.getRanges();
                var _iterator162 = _createForOfIteratorHelper(_s102),
                  _step162;
                try {
                  for (_iterator162.s(); !(_step162 = _iterator162.n()).done;) {
                    var _e130 = _step162.value;
                    var _iterator163 = _createForOfIteratorHelper(_e130),
                      _step163;
                    try {
                      for (_iterator163.s(); !(_step163 = _iterator163.n()).done;) {
                        var _s103 = _step163.value;
                        if (this.checkAttribute(_s103.item, t)) return !0;
                      }
                    } catch (err) {
                      _iterator163.e(err);
                    } finally {
                      _iterator163.f();
                    }
                  }
                } catch (err) {
                  _iterator162.e(err);
                } finally {
                  _iterator162.f();
                }
              }
              return !1;
            }
          }, {
            key: "getValidRanges",
            value: /*#__PURE__*/_regeneratorRuntime().mark(function getValidRanges(e, t) {
              var _iterator165, _step165, _s104;
              return _regeneratorRuntime().wrap(function getValidRanges$(_context12) {
                while (1) switch (_context12.prev = _context12.next) {
                  case 0:
                    e = /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(e) {
                      var _iterator164, _step164, _t108;
                      return _regeneratorRuntime().wrap(function _callee3$(_context11) {
                        while (1) switch (_context11.prev = _context11.next) {
                          case 0:
                            _iterator164 = _createForOfIteratorHelper(e);
                            _context11.prev = 1;
                            _iterator164.s();
                          case 3:
                            if ((_step164 = _iterator164.n()).done) {
                              _context11.next = 8;
                              break;
                            }
                            _t108 = _step164.value;
                            return _context11.delegateYield(_t108.getMinimalFlatRanges(), "t0", 6);
                          case 6:
                            _context11.next = 3;
                            break;
                          case 8:
                            _context11.next = 13;
                            break;
                          case 10:
                            _context11.prev = 10;
                            _context11.t1 = _context11["catch"](1);
                            _iterator164.e(_context11.t1);
                          case 13:
                            _context11.prev = 13;
                            _iterator164.f();
                            return _context11.finish(13);
                          case 16:
                          case "end":
                            return _context11.stop();
                        }
                      }, _callee3, null, [[1, 10, 13, 16]]);
                    })(e);
                    _iterator165 = _createForOfIteratorHelper(e);
                    _context12.prev = 2;
                    _iterator165.s();
                  case 4:
                    if ((_step165 = _iterator165.n()).done) {
                      _context12.next = 9;
                      break;
                    }
                    _s104 = _step165.value;
                    return _context12.delegateYield(this._getValidRangesForRange(_s104, t), "t0", 7);
                  case 7:
                    _context12.next = 4;
                    break;
                  case 9:
                    _context12.next = 14;
                    break;
                  case 11:
                    _context12.prev = 11;
                    _context12.t1 = _context12["catch"](2);
                    _iterator165.e(_context12.t1);
                  case 14:
                    _context12.prev = 14;
                    _iterator165.f();
                    return _context12.finish(14);
                  case 17:
                  case "end":
                    return _context12.stop();
                }
              }, getValidRanges, this, [[2, 11, 14, 17]]);
            })
          }, {
            key: "getNearestSelectionRange",
            value: function getNearestSelectionRange(e) {
              var _this47 = this;
              var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "both";
              if (this.checkChild(e, "$text")) return new n.Z(e);
              var s, o;
              var i = e.getAncestors().reverse().find(function (e) {
                return _this47.isLimit(e);
              }) || e.root;
              "both" != t && "backward" != t || (s = new d.Z({
                boundaries: n.Z._createIn(i),
                startPosition: e,
                direction: "backward"
              })), "both" != t && "forward" != t || (o = new d.Z({
                boundaries: n.Z._createIn(i),
                startPosition: e
              }));
              var _iterator166 = _createForOfIteratorHelper(/*#__PURE__*/_regeneratorRuntime().mark(function _callee4(e, t) {
                  var s, _t109, _e131;
                  return _regeneratorRuntime().wrap(function _callee4$(_context13) {
                    while (1) switch (_context13.prev = _context13.next) {
                      case 0:
                        s = !1;
                      case 1:
                        if (s) {
                          _context13.next = 18;
                          break;
                        }
                        if (!(s = !0, e)) {
                          _context13.next = 9;
                          break;
                        }
                        _t109 = e.next();
                        _context13.t0 = _t109.done;
                        if (_context13.t0) {
                          _context13.next = 9;
                          break;
                        }
                        s = !1;
                        _context13.next = 9;
                        return {
                          walker: e,
                          value: _t109.value
                        };
                      case 9:
                        if (!t) {
                          _context13.next = 16;
                          break;
                        }
                        _e131 = t.next();
                        _context13.t1 = _e131.done;
                        if (_context13.t1) {
                          _context13.next = 16;
                          break;
                        }
                        s = !1;
                        _context13.next = 16;
                        return {
                          walker: t,
                          value: _e131.value
                        };
                      case 16:
                        _context13.next = 1;
                        break;
                      case 18:
                      case "end":
                        return _context13.stop();
                    }
                  }, _callee4);
                })(s, o)),
                _step166;
              try {
                for (_iterator166.s(); !(_step166 = _iterator166.n()).done;) {
                  var _e132 = _step166.value;
                  var _t110 = _e132.walker == s ? "elementEnd" : "elementStart",
                    _o68 = _e132.value;
                  if (_o68.type == _t110 && this.isObject(_o68.item)) return n.Z._createOn(_o68.item);
                  if (this.checkChild(_o68.nextPosition, "$text")) return new n.Z(_o68.nextPosition);
                }
              } catch (err) {
                _iterator166.e(err);
              } finally {
                _iterator166.f();
              }
              return null;
            }
          }, {
            key: "findAllowedParent",
            value: function findAllowedParent(e, t) {
              var s = e.parent;
              for (; s;) {
                if (this.checkChild(s, t)) return s;
                if (this.isLimit(s)) return null;
                s = s.parent;
              }
              return null;
            }
          }, {
            key: "removeDisallowedAttributes",
            value: function removeDisallowedAttributes(e, t) {
              var _iterator167 = _createForOfIteratorHelper(e),
                _step167;
              try {
                for (_iterator167.s(); !(_step167 = _iterator167.n()).done;) {
                  var _s105 = _step167.value;
                  if (_s105.is("$text")) j(this, _s105, t);else {
                    var _e133 = n.Z._createIn(_s105).getPositions();
                    var _iterator168 = _createForOfIteratorHelper(_e133),
                      _step168;
                    try {
                      for (_iterator168.s(); !(_step168 = _iterator168.n()).done;) {
                        var _s106 = _step168.value;
                        j(this, _s106.nodeBefore || _s106.parent, t);
                      }
                    } catch (err) {
                      _iterator168.e(err);
                    } finally {
                      _iterator168.f();
                    }
                  }
                }
              } catch (err) {
                _iterator167.e(err);
              } finally {
                _iterator167.f();
              }
            }
          }, {
            key: "createContext",
            value: function createContext(e) {
              return new u(e);
            }
          }, {
            key: "_clearCache",
            value: function _clearCache() {
              this._compiledDefinitions = null;
            }
          }, {
            key: "_compile",
            value: function _compile() {
              var e = {},
                t = this._sourceDefinitions,
                s = Object.keys(t);
              for (var _i59 = 0, _s107 = s; _i59 < _s107.length; _i59++) {
                var _o69 = _s107[_i59];
                e[_o69] = g(t[_o69], _o69);
              }
              for (var _i60 = 0, _s108 = s; _i60 < _s108.length; _i60++) {
                var _t111 = _s108[_i60];
                p(e, _t111);
              }
              for (var _i61 = 0, _s109 = s; _i61 < _s109.length; _i61++) {
                var _t112 = _s109[_i61];
                f(e, _t112);
              }
              for (var _i62 = 0, _s110 = s; _i62 < _s110.length; _i62++) {
                var _t113 = _s110[_i62];
                m(e, _t113);
              }
              for (var _i63 = 0, _s111 = s; _i63 < _s111.length; _i63++) {
                var _t114 = _s111[_i63];
                k(e, _t114), _(e, _t114);
              }
              for (var _i64 = 0, _s112 = s; _i64 < _s112.length; _i64++) {
                var _t115 = _s112[_i64];
                b(e, _t115), w(e, _t115), v(e, _t115);
              }
              this._compiledDefinitions = e;
            }
          }, {
            key: "_checkContextMatch",
            value: function _checkContextMatch(e, t) {
              var s = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : t.length - 1;
              var o = t.getItem(s);
              if (e.allowIn.includes(o.name)) {
                if (0 == s) return !0;
                {
                  var _e134 = this.getDefinition(o);
                  return this._checkContextMatch(_e134, t, s - 1);
                }
              }
              return !1;
            }
          }, {
            key: "_getValidRangesForRange",
            value: /*#__PURE__*/_regeneratorRuntime().mark(function _getValidRangesForRange(e, t) {
              var s, o, _iterator169, _step169, _i65;
              return _regeneratorRuntime().wrap(function _getValidRangesForRange$(_context14) {
                while (1) switch (_context14.prev = _context14.next) {
                  case 0:
                    s = e.start, o = e.start;
                    _iterator169 = _createForOfIteratorHelper(e.getItems({
                      shallow: !0
                    }));
                    _context14.prev = 2;
                    _iterator169.s();
                  case 4:
                    if ((_step169 = _iterator169.n()).done) {
                      _context14.next = 19;
                      break;
                    }
                    _i65 = _step169.value;
                    _context14.t0 = _i65.is("element");
                    if (!_context14.t0) {
                      _context14.next = 9;
                      break;
                    }
                    return _context14.delegateYield(this._getValidRangesForRange(n.Z._createIn(_i65), t), "t1", 9);
                  case 9:
                    _context14.t2 = this.checkAttribute(_i65, t);
                    if (_context14.t2) {
                      _context14.next = 16;
                      break;
                    }
                    _context14.t3 = s.isEqual(o);
                    if (_context14.t3) {
                      _context14.next = 15;
                      break;
                    }
                    _context14.next = 15;
                    return new n.Z(s, o);
                  case 15:
                    s = a.ZP._createAfter(_i65);
                  case 16:
                    o = a.ZP._createAfter(_i65);
                  case 17:
                    _context14.next = 4;
                    break;
                  case 19:
                    _context14.next = 24;
                    break;
                  case 21:
                    _context14.prev = 21;
                    _context14.t4 = _context14["catch"](2);
                    _iterator169.e(_context14.t4);
                  case 24:
                    _context14.prev = 24;
                    _iterator169.f();
                    return _context14.finish(24);
                  case 27:
                    _context14.t5 = s.isEqual(o);
                    if (_context14.t5) {
                      _context14.next = 31;
                      break;
                    }
                    _context14.next = 31;
                    return new n.Z(s, o);
                  case 31:
                  case "end":
                    return _context14.stop();
                }
              }, _getValidRangesForRange, this, [[2, 21, 24, 27]]);
            })
          }]);
          return h;
        }();
        (0, r.Z)(h, i.Z);
        var u = /*#__PURE__*/function () {
          function u(e) {
            _classCallCheck(this, u);
            if (e instanceof u) return e;
            "string" == typeof e ? e = [e] : Array.isArray(e) || (e = e.getAncestors({
              includeSelf: !0
            })), this._items = e.map(P);
          }
          _createClass(u, [{
            key: Symbol.iterator,
            value: function value() {
              return this._items[Symbol.iterator]();
            }
          }, {
            key: "push",
            value: function push(e) {
              var t = new u([e]);
              return t._items = [].concat(_toConsumableArray(this._items), _toConsumableArray(t._items)), t;
            }
          }, {
            key: "getItem",
            value: function getItem(e) {
              return this._items[e];
            }
          }, {
            key: "getNames",
            value: /*#__PURE__*/_regeneratorRuntime().mark(function getNames() {
              return _regeneratorRuntime().wrap(function getNames$(_context15) {
                while (1) switch (_context15.prev = _context15.next) {
                  case 0:
                    return _context15.delegateYield(this._items.map(function (e) {
                      return e.name;
                    }), "t0", 1);
                  case 1:
                  case "end":
                    return _context15.stop();
                }
              }, getNames, this);
            })
          }, {
            key: "endsWith",
            value: function endsWith(e) {
              return Array.from(this.getNames()).join(" ").endsWith(e);
            }
          }, {
            key: "startsWith",
            value: function startsWith(e) {
              return Array.from(this.getNames()).join(" ").startsWith(e);
            }
          }, {
            key: "length",
            get: function get() {
              return this._items.length;
            }
          }, {
            key: "last",
            get: function get() {
              return this._items[this._items.length - 1];
            }
          }]);
          return u;
        }();
        function g(e, t) {
          var s = {
            name: t,
            allowIn: [],
            allowContentOf: [],
            allowWhere: [],
            allowAttributes: [],
            allowAttributesOf: [],
            allowChildren: [],
            inheritTypesFrom: []
          };
          return function (e, t) {
            var _iterator170 = _createForOfIteratorHelper(e),
              _step170;
            try {
              for (_iterator170.s(); !(_step170 = _iterator170.n()).done;) {
                var _s113 = _step170.value;
                var _e135 = Object.keys(_s113).filter(function (e) {
                  return e.startsWith("is");
                });
                var _iterator171 = _createForOfIteratorHelper(_e135),
                  _step171;
                try {
                  for (_iterator171.s(); !(_step171 = _iterator171.n()).done;) {
                    var _o70 = _step171.value;
                    t[_o70] = _s113[_o70];
                  }
                } catch (err) {
                  _iterator171.e(err);
                } finally {
                  _iterator171.f();
                }
              }
            } catch (err) {
              _iterator170.e(err);
            } finally {
              _iterator170.f();
            }
          }(e, s), y(e, s, "allowIn"), y(e, s, "allowContentOf"), y(e, s, "allowWhere"), y(e, s, "allowAttributes"), y(e, s, "allowAttributesOf"), y(e, s, "allowChildren"), y(e, s, "inheritTypesFrom"), function (e, t) {
            var _iterator172 = _createForOfIteratorHelper(e),
              _step172;
            try {
              for (_iterator172.s(); !(_step172 = _iterator172.n()).done;) {
                var _s114 = _step172.value;
                var _e136 = _s114.inheritAllFrom;
                _e136 && (t.allowContentOf.push(_e136), t.allowWhere.push(_e136), t.allowAttributesOf.push(_e136), t.inheritTypesFrom.push(_e136));
              }
            } catch (err) {
              _iterator172.e(err);
            } finally {
              _iterator172.f();
            }
          }(e, s), s;
        }
        function p(e, t) {
          var s = e[t];
          var _iterator173 = _createForOfIteratorHelper(s.allowChildren),
            _step173;
          try {
            for (_iterator173.s(); !(_step173 = _iterator173.n()).done;) {
              var _o71 = _step173.value;
              var _s115 = e[_o71];
              _s115 && _s115.allowIn.push(t);
            }
          } catch (err) {
            _iterator173.e(err);
          } finally {
            _iterator173.f();
          }
          s.allowChildren.length = 0;
        }
        function f(e, t) {
          var _iterator174 = _createForOfIteratorHelper(e[t].allowContentOf),
            _step174;
          try {
            for (_iterator174.s(); !(_step174 = _iterator174.n()).done;) {
              var _s116 = _step174.value;
              if (e[_s116]) {
                Z(e, _s116).forEach(function (e) {
                  e.allowIn.push(t);
                });
              }
            }
          } catch (err) {
            _iterator174.e(err);
          } finally {
            _iterator174.f();
          }
          delete e[t].allowContentOf;
        }
        function m(e, t) {
          var _iterator175 = _createForOfIteratorHelper(e[t].allowWhere),
            _step175;
          try {
            for (_iterator175.s(); !(_step175 = _iterator175.n()).done;) {
              var _s117 = _step175.value;
              var _o72 = e[_s117];
              if (_o72) {
                var _e$t$allowIn;
                var _s118 = _o72.allowIn;
                (_e$t$allowIn = e[t].allowIn).push.apply(_e$t$allowIn, _toConsumableArray(_s118));
              }
            }
          } catch (err) {
            _iterator175.e(err);
          } finally {
            _iterator175.f();
          }
          delete e[t].allowWhere;
        }
        function k(e, t) {
          var _iterator176 = _createForOfIteratorHelper(e[t].allowAttributesOf),
            _step176;
          try {
            for (_iterator176.s(); !(_step176 = _iterator176.n()).done;) {
              var _s119 = _step176.value;
              var _o73 = e[_s119];
              if (_o73) {
                var _e$t$allowAttributes;
                var _s120 = _o73.allowAttributes;
                (_e$t$allowAttributes = e[t].allowAttributes).push.apply(_e$t$allowAttributes, _toConsumableArray(_s120));
              }
            }
          } catch (err) {
            _iterator176.e(err);
          } finally {
            _iterator176.f();
          }
          delete e[t].allowAttributesOf;
        }
        function _(e, t) {
          var s = e[t];
          var _iterator177 = _createForOfIteratorHelper(s.inheritTypesFrom),
            _step177;
          try {
            for (_iterator177.s(); !(_step177 = _iterator177.n()).done;) {
              var _t116 = _step177.value;
              var _o74 = e[_t116];
              if (_o74) {
                var _e137 = Object.keys(_o74).filter(function (e) {
                  return e.startsWith("is");
                });
                var _iterator178 = _createForOfIteratorHelper(_e137),
                  _step178;
                try {
                  for (_iterator178.s(); !(_step178 = _iterator178.n()).done;) {
                    var _t117 = _step178.value;
                    _t117 in s || (s[_t117] = _o74[_t117]);
                  }
                } catch (err) {
                  _iterator178.e(err);
                } finally {
                  _iterator178.f();
                }
              }
            }
          } catch (err) {
            _iterator177.e(err);
          } finally {
            _iterator177.f();
          }
          delete s.inheritTypesFrom;
        }
        function b(e, t) {
          var s = e[t],
            o = s.allowIn.filter(function (t) {
              return e[t];
            });
          s.allowIn = Array.from(new Set(o));
        }
        function w(e, t) {
          var s = e[t];
          var _iterator179 = _createForOfIteratorHelper(s.allowIn),
            _step179;
          try {
            for (_iterator179.s(); !(_step179 = _iterator179.n()).done;) {
              var _o75 = _step179.value;
              e[_o75].allowChildren.push(t);
            }
          } catch (err) {
            _iterator179.e(err);
          } finally {
            _iterator179.f();
          }
        }
        function v(e, t) {
          var s = e[t];
          s.allowAttributes = Array.from(new Set(s.allowAttributes));
        }
        function y(e, t, s) {
          var _iterator180 = _createForOfIteratorHelper(e),
            _step180;
          try {
            for (_iterator180.s(); !(_step180 = _iterator180.n()).done;) {
              var _t$s;
              var _o76 = _step180.value;
              "string" == typeof _o76[s] ? t[s].push(_o76[s]) : Array.isArray(_o76[s]) && (_t$s = t[s]).push.apply(_t$s, _toConsumableArray(_o76[s]));
            }
          } catch (err) {
            _iterator180.e(err);
          } finally {
            _iterator180.f();
          }
        }
        function Z(e, t) {
          var s = e[t];
          return (o = e, Object.keys(o).map(function (e) {
            return o[e];
          })).filter(function (e) {
            return e.allowIn.includes(s.name);
          });
          var o;
        }
        function P(e) {
          return "string" == typeof e || e.is("documentFragment") ? {
            name: "string" == typeof e ? e : "$documentFragment",
            getAttributeKeys: /*#__PURE__*/_regeneratorRuntime().mark(function getAttributeKeys() {
              return _regeneratorRuntime().wrap(function getAttributeKeys$(_context16) {
                while (1) switch (_context16.prev = _context16.next) {
                  case 0:
                  case "end":
                    return _context16.stop();
                }
              }, getAttributeKeys);
            }),
            getAttribute: function getAttribute() {}
          } : {
            name: e.is("element") ? e.name : "$text",
            getAttributeKeys: /*#__PURE__*/_regeneratorRuntime().mark(function getAttributeKeys() {
              return _regeneratorRuntime().wrap(function getAttributeKeys$(_context17) {
                while (1) switch (_context17.prev = _context17.next) {
                  case 0:
                    return _context17.delegateYield(e.getAttributeKeys(), "t0", 1);
                  case 1:
                  case "end":
                    return _context17.stop();
                }
              }, getAttributeKeys);
            }),
            getAttribute: function getAttribute(t) {
              return e.getAttribute(t);
            }
          };
        }
        function j(e, t, s) {
          var _iterator181 = _createForOfIteratorHelper(t.getAttributeKeys()),
            _step181;
          try {
            for (_iterator181.s(); !(_step181 = _iterator181.n()).done;) {
              var _o77 = _step181.value;
              e.checkAttribute(t, _o77) || s.removeAttribute(_o77, t);
            }
          } catch (err) {
            _iterator181.e(err);
          } finally {
            _iterator181.f();
          }
        }
      },
      "./packages/ckeditor5-engine/src/model/selection.js": function _packages_ckeditor5Engine_src_model_selectionJs(e, t, s) {
        "use strict";

        s.d(t, {
          Z: function Z() {
            return d;
          }
        });
        var o = s("./packages/ckeditor5-engine/src/model/position.js"),
          i = s("./packages/ckeditor5-engine/src/model/node.js"),
          r = s("./packages/ckeditor5-engine/src/model/range.js"),
          n = s("./packages/ckeditor5-utils/src/emittermixin.js"),
          a = s("./packages/ckeditor5-utils/src/ckeditorerror.js"),
          c = s("./packages/ckeditor5-utils/src/mix.js"),
          l = s("./packages/ckeditor5-utils/src/isiterable.js");
        var d = /*#__PURE__*/function () {
          function d(e, t, s) {
            _classCallCheck(this, d);
            this._lastRangeBackward = !1, this._ranges = [], this._attrs = new Map(), e && this.setTo(e, t, s);
          }
          _createClass(d, [{
            key: "isEqual",
            value: function isEqual(e) {
              if (this.rangeCount != e.rangeCount) return !1;
              if (0 === this.rangeCount) return !0;
              if (!this.anchor.isEqual(e.anchor) || !this.focus.isEqual(e.focus)) return !1;
              var _iterator182 = _createForOfIteratorHelper(this._ranges),
                _step182;
              try {
                for (_iterator182.s(); !(_step182 = _iterator182.n()).done;) {
                  var _t118 = _step182.value;
                  var _s121 = !1;
                  var _iterator183 = _createForOfIteratorHelper(e._ranges),
                    _step183;
                  try {
                    for (_iterator183.s(); !(_step183 = _iterator183.n()).done;) {
                      var _o78 = _step183.value;
                      if (_t118.isEqual(_o78)) {
                        _s121 = !0;
                        break;
                      }
                    }
                  } catch (err) {
                    _iterator183.e(err);
                  } finally {
                    _iterator183.f();
                  }
                  if (!_s121) return !1;
                }
              } catch (err) {
                _iterator182.e(err);
              } finally {
                _iterator182.f();
              }
              return !0;
            }
          }, {
            key: "getRanges",
            value: /*#__PURE__*/_regeneratorRuntime().mark(function getRanges() {
              var _iterator184, _step184, _e138;
              return _regeneratorRuntime().wrap(function getRanges$(_context18) {
                while (1) switch (_context18.prev = _context18.next) {
                  case 0:
                    _iterator184 = _createForOfIteratorHelper(this._ranges);
                    _context18.prev = 1;
                    _iterator184.s();
                  case 3:
                    if ((_step184 = _iterator184.n()).done) {
                      _context18.next = 9;
                      break;
                    }
                    _e138 = _step184.value;
                    _context18.next = 7;
                    return new r.Z(_e138.start, _e138.end);
                  case 7:
                    _context18.next = 3;
                    break;
                  case 9:
                    _context18.next = 14;
                    break;
                  case 11:
                    _context18.prev = 11;
                    _context18.t0 = _context18["catch"](1);
                    _iterator184.e(_context18.t0);
                  case 14:
                    _context18.prev = 14;
                    _iterator184.f();
                    return _context18.finish(14);
                  case 17:
                  case "end":
                    return _context18.stop();
                }
              }, getRanges, this, [[1, 11, 14, 17]]);
            })
          }, {
            key: "getFirstRange",
            value: function getFirstRange() {
              var e = null;
              var _iterator185 = _createForOfIteratorHelper(this._ranges),
                _step185;
              try {
                for (_iterator185.s(); !(_step185 = _iterator185.n()).done;) {
                  var _t119 = _step185.value;
                  e && !_t119.start.isBefore(e.start) || (e = _t119);
                }
              } catch (err) {
                _iterator185.e(err);
              } finally {
                _iterator185.f();
              }
              return e ? new r.Z(e.start, e.end) : null;
            }
          }, {
            key: "getLastRange",
            value: function getLastRange() {
              var e = null;
              var _iterator186 = _createForOfIteratorHelper(this._ranges),
                _step186;
              try {
                for (_iterator186.s(); !(_step186 = _iterator186.n()).done;) {
                  var _t120 = _step186.value;
                  e && !_t120.end.isAfter(e.end) || (e = _t120);
                }
              } catch (err) {
                _iterator186.e(err);
              } finally {
                _iterator186.f();
              }
              return e ? new r.Z(e.start, e.end) : null;
            }
          }, {
            key: "getFirstPosition",
            value: function getFirstPosition() {
              var e = this.getFirstRange();
              return e ? e.start.clone() : null;
            }
          }, {
            key: "getLastPosition",
            value: function getLastPosition() {
              var e = this.getLastRange();
              return e ? e.end.clone() : null;
            }
          }, {
            key: "setTo",
            value: function setTo(e, t, s) {
              if (null === e) this._setRanges([]);else if (e instanceof d) this._setRanges(e.getRanges(), e.isBackward);else if (e && "function" == typeof e.getRanges) this._setRanges(e.getRanges(), e.isBackward);else if (e instanceof r.Z) this._setRanges([e], !!t && !!t.backward);else if (e instanceof o.ZP) this._setRanges([new r.Z(e)]);else if (e instanceof i.Z) {
                var _i66 = !!s && !!s.backward;
                var _n14;
                if ("in" == t) _n14 = r.Z._createIn(e);else if ("on" == t) _n14 = r.Z._createOn(e);else {
                  if (void 0 === t) throw new a.ZP("model-selection-setto-required-second-parameter", [this, e]);
                  _n14 = new r.Z(o.ZP._createAt(e, t));
                }
                this._setRanges([_n14], _i66);
              } else {
                if (!(0, l.Z)(e)) throw new a.ZP("model-selection-setto-not-selectable", [this, e]);
                this._setRanges(e, t && !!t.backward);
              }
            }
          }, {
            key: "_setRanges",
            value: function _setRanges(e) {
              var _this48 = this;
              var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
              var s = (e = Array.from(e)).some(function (t) {
                if (!(t instanceof r.Z)) throw new a.ZP("model-selection-set-ranges-not-range", [_this48, e]);
                return _this48._ranges.every(function (e) {
                  return !e.isEqual(t);
                });
              });
              if (e.length !== this._ranges.length || s) {
                this._removeAllRanges();
                var _iterator187 = _createForOfIteratorHelper(e),
                  _step187;
                try {
                  for (_iterator187.s(); !(_step187 = _iterator187.n()).done;) {
                    var _t121 = _step187.value;
                    this._pushRange(_t121);
                  }
                } catch (err) {
                  _iterator187.e(err);
                } finally {
                  _iterator187.f();
                }
                this._lastRangeBackward = !!t, this.fire("change:range", {
                  directChange: !0
                });
              }
            }
          }, {
            key: "setFocus",
            value: function setFocus(e, t) {
              if (null === this.anchor) throw new a.ZP("model-selection-setfocus-no-ranges", [this, e]);
              var s = o.ZP._createAt(e, t);
              if ("same" == s.compareWith(this.focus)) return;
              var i = this.anchor;
              this._ranges.length && this._popRange(), "before" == s.compareWith(i) ? (this._pushRange(new r.Z(s, i)), this._lastRangeBackward = !0) : (this._pushRange(new r.Z(i, s)), this._lastRangeBackward = !1), this.fire("change:range", {
                directChange: !0
              });
            }
          }, {
            key: "getAttribute",
            value: function getAttribute(e) {
              return this._attrs.get(e);
            }
          }, {
            key: "getAttributes",
            value: function getAttributes() {
              return this._attrs.entries();
            }
          }, {
            key: "getAttributeKeys",
            value: function getAttributeKeys() {
              return this._attrs.keys();
            }
          }, {
            key: "hasAttribute",
            value: function hasAttribute(e) {
              return this._attrs.has(e);
            }
          }, {
            key: "removeAttribute",
            value: function removeAttribute(e) {
              this.hasAttribute(e) && (this._attrs.delete(e), this.fire("change:attribute", {
                attributeKeys: [e],
                directChange: !0
              }));
            }
          }, {
            key: "setAttribute",
            value: function setAttribute(e, t) {
              this.getAttribute(e) !== t && (this._attrs.set(e, t), this.fire("change:attribute", {
                attributeKeys: [e],
                directChange: !0
              }));
            }
          }, {
            key: "getSelectedElement",
            value: function getSelectedElement() {
              return 1 !== this.rangeCount ? null : this.getFirstRange().getContainedElement();
            }
          }, {
            key: "is",
            value: function is(e) {
              return "selection" === e || "model:selection" === e;
            }
          }, {
            key: "getSelectedBlocks",
            value: /*#__PURE__*/_regeneratorRuntime().mark(function getSelectedBlocks() {
              var e, _iterator188, _step188, _t122, _s122, _iterator189, _step189, _s123, _o79, _i67;
              return _regeneratorRuntime().wrap(function getSelectedBlocks$(_context19) {
                while (1) switch (_context19.prev = _context19.next) {
                  case 0:
                    e = new WeakSet();
                    _iterator188 = _createForOfIteratorHelper(this.getRanges());
                    _context19.prev = 2;
                    _iterator188.s();
                  case 4:
                    if ((_step188 = _iterator188.n()).done) {
                      _context19.next = 38;
                      break;
                    }
                    _t122 = _step188.value;
                    _s122 = g(_t122.start, e);
                    _context19.t0 = _s122 && p(_s122, _t122);
                    if (!_context19.t0) {
                      _context19.next = 11;
                      break;
                    }
                    _context19.next = 11;
                    return _s122;
                  case 11:
                    _iterator189 = _createForOfIteratorHelper(_t122.getWalker());
                    _context19.prev = 12;
                    _iterator189.s();
                  case 14:
                    if ((_step189 = _iterator189.n()).done) {
                      _context19.next = 23;
                      break;
                    }
                    _s123 = _step189.value;
                    _o79 = _s123.item;
                    _context19.t1 = "elementEnd" == _s123.type && u(_o79, e, _t122);
                    if (!_context19.t1) {
                      _context19.next = 21;
                      break;
                    }
                    _context19.next = 21;
                    return _o79;
                  case 21:
                    _context19.next = 14;
                    break;
                  case 23:
                    _context19.next = 28;
                    break;
                  case 25:
                    _context19.prev = 25;
                    _context19.t2 = _context19["catch"](12);
                    _iterator189.e(_context19.t2);
                  case 28:
                    _context19.prev = 28;
                    _iterator189.f();
                    return _context19.finish(28);
                  case 31:
                    _i67 = g(_t122.end, e);
                    _context19.t3 = _i67 && !_t122.end.isTouching(o.ZP._createAt(_i67, 0)) && p(_i67, _t122);
                    if (!_context19.t3) {
                      _context19.next = 36;
                      break;
                    }
                    _context19.next = 36;
                    return _i67;
                  case 36:
                    _context19.next = 4;
                    break;
                  case 38:
                    _context19.next = 43;
                    break;
                  case 40:
                    _context19.prev = 40;
                    _context19.t4 = _context19["catch"](2);
                    _iterator188.e(_context19.t4);
                  case 43:
                    _context19.prev = 43;
                    _iterator188.f();
                    return _context19.finish(43);
                  case 46:
                  case "end":
                    return _context19.stop();
                }
              }, getSelectedBlocks, this, [[2, 40, 43, 46], [12, 25, 28, 31]]);
            })
          }, {
            key: "containsEntireContent",
            value: function containsEntireContent() {
              var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.anchor.root;
              var t = o.ZP._createAt(e, 0),
                s = o.ZP._createAt(e, "end");
              return t.isTouching(this.getFirstPosition()) && s.isTouching(this.getLastPosition());
            }
          }, {
            key: "_pushRange",
            value: function _pushRange(e) {
              this._checkRange(e), this._ranges.push(new r.Z(e.start, e.end));
            }
          }, {
            key: "_checkRange",
            value: function _checkRange(e) {
              for (var _t123 = 0; _t123 < this._ranges.length; _t123++) if (e.isIntersecting(this._ranges[_t123])) throw new a.ZP("model-selection-range-intersects", [this, e], {
                addedRange: e,
                intersectingRange: this._ranges[_t123]
              });
            }
          }, {
            key: "_removeAllRanges",
            value: function _removeAllRanges() {
              for (; this._ranges.length > 0;) this._popRange();
            }
          }, {
            key: "_popRange",
            value: function _popRange() {
              this._ranges.pop();
            }
          }, {
            key: "anchor",
            get: function get() {
              if (this._ranges.length > 0) {
                var _e139 = this._ranges[this._ranges.length - 1];
                return this._lastRangeBackward ? _e139.end : _e139.start;
              }
              return null;
            }
          }, {
            key: "focus",
            get: function get() {
              if (this._ranges.length > 0) {
                var _e140 = this._ranges[this._ranges.length - 1];
                return this._lastRangeBackward ? _e140.start : _e140.end;
              }
              return null;
            }
          }, {
            key: "isCollapsed",
            get: function get() {
              return 1 === this._ranges.length && this._ranges[0].isCollapsed;
            }
          }, {
            key: "rangeCount",
            get: function get() {
              return this._ranges.length;
            }
          }, {
            key: "isBackward",
            get: function get() {
              return !this.isCollapsed && this._lastRangeBackward;
            }
          }]);
          return d;
        }();
        function h(e, t) {
          return !t.has(e) && (t.add(e), e.root.document.model.schema.isBlock(e) && e.parent);
        }
        function u(e, t, s) {
          return h(e, t) && p(e, s);
        }
        function g(e, t) {
          var s = e.parent.root.document.model.schema,
            o = e.parent.getAncestors({
              parentFirst: !0,
              includeSelf: !0
            });
          var i = !1;
          var r = o.find(function (e) {
            return !i && (i = s.isLimit(e), !i && h(e, t));
          });
          return o.forEach(function (e) {
            return t.add(e);
          }), r;
        }
        function p(e, t) {
          var s = function (e) {
            var t = e.root.document.model.schema;
            var s = e.parent;
            for (; s;) {
              if (t.isBlock(s)) return s;
              s = s.parent;
            }
          }(e);
          if (!s) return !0;
          return !t.containsRange(r.Z._createOn(s), !0);
        }
        (0, c.Z)(d, n.ZP);
      },
      "./packages/ckeditor5-engine/src/model/text.js": function _packages_ckeditor5Engine_src_model_textJs(e, t, s) {
        "use strict";

        s.d(t, {
          Z: function Z() {
            return i;
          }
        });
        var o = s("./packages/ckeditor5-engine/src/model/node.js");
        var i = /*#__PURE__*/function (_o$Z14) {
          _inherits(i, _o$Z14);
          function i(e, t) {
            var _this49;
            _classCallCheck(this, i);
            _this49 = _possibleConstructorReturn(this, _getPrototypeOf(i).call(this, t)), _this49._data = e || "";
            return _this49;
          }
          _createClass(i, [{
            key: "is",
            value: function is(e) {
              return "$text" === e || "model:$text" === e || "text" === e || "model:text" === e || "node" === e || "model:node" === e;
            }
          }, {
            key: "toJSON",
            value: function toJSON() {
              var e = _superPropGet(i, "toJSON", this, 3)([]);
              return e.data = this.data, e;
            }
          }, {
            key: "_clone",
            value: function _clone() {
              return new i(this.data, this.getAttributes());
            }
          }, {
            key: "offsetSize",
            get: function get() {
              return this.data.length;
            }
          }, {
            key: "data",
            get: function get() {
              return this._data;
            }
          }], [{
            key: "fromJSON",
            value: function fromJSON(e) {
              return new i(e.data, e.attributes);
            }
          }]);
          return i;
        }(o.Z);
      },
      "./packages/ckeditor5-engine/src/model/textproxy.js": function _packages_ckeditor5Engine_src_model_textproxyJs(e, t, s) {
        "use strict";

        s.d(t, {
          Z: function Z() {
            return i;
          }
        });
        var o = s("./packages/ckeditor5-utils/src/ckeditorerror.js");
        var i = /*#__PURE__*/function () {
          function i(e, t, s) {
            _classCallCheck(this, i);
            if (this.textNode = e, t < 0 || t > e.offsetSize) throw new o.ZP("model-textproxy-wrong-offsetintext", this);
            if (s < 0 || t + s > e.offsetSize) throw new o.ZP("model-textproxy-wrong-length", this);
            this.data = e.data.substring(t, t + s), this.offsetInText = t;
          }
          _createClass(i, [{
            key: "is",
            value: function is(e) {
              return "$textProxy" === e || "model:$textProxy" === e || "textProxy" === e || "model:textProxy" === e;
            }
          }, {
            key: "getPath",
            value: function getPath() {
              var e = this.textNode.getPath();
              return e.length > 0 && (e[e.length - 1] += this.offsetInText), e;
            }
          }, {
            key: "getAncestors",
            value: function getAncestors() {
              var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
                includeSelf: !1,
                parentFirst: !1
              };
              var t = [];
              var s = e.includeSelf ? this : this.parent;
              for (; s;) t[e.parentFirst ? "push" : "unshift"](s), s = s.parent;
              return t;
            }
          }, {
            key: "hasAttribute",
            value: function hasAttribute(e) {
              return this.textNode.hasAttribute(e);
            }
          }, {
            key: "getAttribute",
            value: function getAttribute(e) {
              return this.textNode.getAttribute(e);
            }
          }, {
            key: "getAttributes",
            value: function getAttributes() {
              return this.textNode.getAttributes();
            }
          }, {
            key: "getAttributeKeys",
            value: function getAttributeKeys() {
              return this.textNode.getAttributeKeys();
            }
          }, {
            key: "startOffset",
            get: function get() {
              return null !== this.textNode.startOffset ? this.textNode.startOffset + this.offsetInText : null;
            }
          }, {
            key: "offsetSize",
            get: function get() {
              return this.data.length;
            }
          }, {
            key: "endOffset",
            get: function get() {
              return null !== this.startOffset ? this.startOffset + this.offsetSize : null;
            }
          }, {
            key: "isPartial",
            get: function get() {
              return this.offsetSize !== this.textNode.offsetSize;
            }
          }, {
            key: "parent",
            get: function get() {
              return this.textNode.parent;
            }
          }, {
            key: "root",
            get: function get() {
              return this.textNode.root;
            }
          }]);
          return i;
        }();
      },
      "./packages/ckeditor5-engine/src/model/treewalker.js": function _packages_ckeditor5Engine_src_model_treewalkerJs(e, t, s) {
        "use strict";

        s.d(t, {
          Z: function Z() {
            return c;
          }
        });
        var o = s("./packages/ckeditor5-engine/src/model/text.js"),
          i = s("./packages/ckeditor5-engine/src/model/textproxy.js"),
          r = s("./packages/ckeditor5-engine/src/model/element.js"),
          n = s("./packages/ckeditor5-engine/src/model/position.js"),
          a = s("./packages/ckeditor5-utils/src/ckeditorerror.js");
        var c = /*#__PURE__*/function () {
          function c() {
            var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
            _classCallCheck(this, c);
            if (!e.boundaries && !e.startPosition) throw new a.ZP("model-tree-walker-no-start-position", null);
            var t = e.direction || "forward";
            if ("forward" != t && "backward" != t) throw new a.ZP("model-tree-walker-unknown-direction", e, {
              direction: t
            });
            this.direction = t, this.boundaries = e.boundaries || null, e.startPosition ? this.position = e.startPosition.clone() : this.position = n.ZP._createAt(this.boundaries["backward" == this.direction ? "end" : "start"]), this.position.stickiness = "toNone", this.singleCharacters = !!e.singleCharacters, this.shallow = !!e.shallow, this.ignoreElementEnd = !!e.ignoreElementEnd, this._boundaryStartParent = this.boundaries ? this.boundaries.start.parent : null, this._boundaryEndParent = this.boundaries ? this.boundaries.end.parent : null, this._visitedParent = this.position.parent;
          }
          _createClass(c, [{
            key: Symbol.iterator,
            value: function value() {
              return this;
            }
          }, {
            key: "skip",
            value: function skip(e) {
              var t, s, o, i;
              do {
                var _this$next;
                o = this.position, i = this._visitedParent, _this$next = this.next(), t = _this$next.done, s = _this$next.value, _this$next;
              } while (!t && e(s));
              t || (this.position = o, this._visitedParent = i);
            }
          }, {
            key: "next",
            value: function next() {
              return "forward" == this.direction ? this._next() : this._previous();
            }
          }, {
            key: "_next",
            value: function _next() {
              var e = this.position,
                t = this.position.clone(),
                s = this._visitedParent;
              if (null === s.parent && t.offset === s.maxOffset) return {
                done: !0
              };
              if (s === this._boundaryEndParent && t.offset == this.boundaries.end.offset) return {
                done: !0
              };
              var a = t.parent,
                c = (0, n.Rt)(t, a),
                d = c || (0, n.Ux)(t, a, c);
              if (d instanceof r.Z) return this.shallow ? t.offset++ : (t.path.push(0), this._visitedParent = d), this.position = t, l("elementStart", d, e, t, 1);
              if (d instanceof o.Z) {
                var _o80;
                if (this.singleCharacters) _o80 = 1;else {
                  var _e141 = d.endOffset;
                  this._boundaryEndParent == s && this.boundaries.end.offset < _e141 && (_e141 = this.boundaries.end.offset), _o80 = _e141 - t.offset;
                }
                var _r33 = t.offset - d.startOffset,
                  _n15 = new i.Z(d, _r33, _o80);
                return t.offset += _o80, this.position = t, l("text", _n15, e, t, _o80);
              }
              return t.path.pop(), t.offset++, this.position = t, this._visitedParent = s.parent, this.ignoreElementEnd ? this._next() : l("elementEnd", s, e, t);
            }
          }, {
            key: "_previous",
            value: function _previous() {
              var e = this.position,
                t = this.position.clone(),
                s = this._visitedParent;
              if (null === s.parent && 0 === t.offset) return {
                done: !0
              };
              if (s == this._boundaryStartParent && t.offset == this.boundaries.start.offset) return {
                done: !0
              };
              var a = t.parent,
                c = (0, n.Rt)(t, a),
                d = c || (0, n.YV)(t, a, c);
              if (d instanceof r.Z) return t.offset--, this.shallow ? (this.position = t, l("elementStart", d, e, t, 1)) : (t.path.push(d.maxOffset), this.position = t, this._visitedParent = d, this.ignoreElementEnd ? this._previous() : l("elementEnd", d, e, t));
              if (d instanceof o.Z) {
                var _o81;
                if (this.singleCharacters) _o81 = 1;else {
                  var _e142 = d.startOffset;
                  this._boundaryStartParent == s && this.boundaries.start.offset > _e142 && (_e142 = this.boundaries.start.offset), _o81 = t.offset - _e142;
                }
                var _r34 = t.offset - d.startOffset,
                  _n16 = new i.Z(d, _r34 - _o81, _o81);
                return t.offset -= _o81, this.position = t, l("text", _n16, e, t, _o81);
              }
              return t.path.pop(), this.position = t, this._visitedParent = s.parent, l("elementStart", s, e, t, 1);
            }
          }]);
          return c;
        }();
        function l(e, t, s, o, i) {
          return {
            done: !1,
            value: {
              type: e,
              item: t,
              previousPosition: s,
              nextPosition: o,
              length: i
            }
          };
        }
      },
      "./packages/ckeditor5-engine/src/model/utils/autoparagraphing.js": function _packages_ckeditor5Engine_src_model_utils_autoparagraphingJs(e, t, s) {
        "use strict";

        function o(e) {
          var _e$model = e.model,
            t = _e$model.schema,
            s = _e$model.document;
          var _iterator190 = _createForOfIteratorHelper(s.getRootNames()),
            _step190;
          try {
            for (_iterator190.s(); !(_step190 = _iterator190.n()).done;) {
              var _o82 = _step190.value;
              var _i68 = s.getRoot(_o82);
              if (_i68.isEmpty && !t.checkChild(_i68, "$text") && t.checkChild(_i68, "paragraph")) return e.insertElement("paragraph", _i68), !0;
            }
          } catch (err) {
            _iterator190.e(err);
          } finally {
            _iterator190.f();
          }
          return !1;
        }
        function i(e, t, s) {
          var o = s.createContext(e);
          return !!s.checkChild(o, "paragraph") && !!s.checkChild(o.push("paragraph"), t);
        }
        function r(e, t) {
          var s = t.createElement("paragraph");
          return t.insert(s, e), t.createPositionAt(s, 0);
        }
        s.d(t, {
          _m: function _m() {
            return o;
          },
          gg: function gg() {
            return i;
          },
          zX: function zX() {
            return r;
          }
        });
      },
      "./packages/ckeditor5-engine/src/view/attributeelement.js": function _packages_ckeditor5Engine_src_view_attributeelementJs(e, t, s) {
        "use strict";

        s.d(t, {
          Z: function Z() {
            return r;
          }
        });
        var o = s("./packages/ckeditor5-engine/src/view/element.js"),
          i = s("./packages/ckeditor5-utils/src/ckeditorerror.js");
        var r = /*#__PURE__*/function (_o$Z15) {
          _inherits(r, _o$Z15);
          function r(e, t, s, o) {
            var _this50;
            _classCallCheck(this, r);
            _this50 = _possibleConstructorReturn(this, _getPrototypeOf(r).call(this, e, t, s, o)), _this50.getFillerOffset = n, _this50._priority = 10, _this50._id = null, _this50._clonesGroup = null;
            return _this50;
          }
          _createClass(r, [{
            key: "getElementsWithSameId",
            value: function getElementsWithSameId() {
              if (null === this.id) throw new i.ZP("attribute-element-get-elements-with-same-id-no-id", this);
              return new Set(this._clonesGroup);
            }
          }, {
            key: "is",
            value: function is(e) {
              var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
              return t ? t === this.name && ("attributeElement" === e || "view:attributeElement" === e || "element" === e || "view:element" === e) : "attributeElement" === e || "view:attributeElement" === e || "element" === e || "view:element" === e || "node" === e || "view:node" === e;
            }
          }, {
            key: "isSimilar",
            value: function isSimilar(e) {
              return null !== this.id || null !== e.id ? this.id === e.id : _superPropGet(r, "isSimilar", this, 3)([e]) && this.priority == e.priority;
            }
          }, {
            key: "_clone",
            value: function _clone(e) {
              var t = _superPropGet(r, "_clone", this, 3)([e]);
              return t._priority = this._priority, t._id = this._id, t;
            }
          }, {
            key: "priority",
            get: function get() {
              return this._priority;
            }
          }, {
            key: "id",
            get: function get() {
              return this._id;
            }
          }]);
          return r;
        }(o.Z);
        function n() {
          if (a(this)) return null;
          var e = this.parent;
          for (; e && e.is("attributeElement");) {
            if (a(e) > 1) return null;
            e = e.parent;
          }
          return !e || a(e) > 1 ? null : this.childCount;
        }
        function a(e) {
          return Array.from(e.getChildren()).filter(function (e) {
            return !e.is("uiElement");
          }).length;
        }
        r.DEFAULT_PRIORITY = 10;
      },
      "./packages/ckeditor5-engine/src/view/containerelement.js": function _packages_ckeditor5Engine_src_view_containerelementJs(e, t, s) {
        "use strict";

        s.d(t, {
          Y: function Y() {
            return r;
          },
          Z: function Z() {
            return i;
          }
        });
        var o = s("./packages/ckeditor5-engine/src/view/element.js");
        var i = /*#__PURE__*/function (_o$Z16) {
          _inherits(i, _o$Z16);
          function i(e, t, s, o) {
            var _this51;
            _classCallCheck(this, i);
            _this51 = _possibleConstructorReturn(this, _getPrototypeOf(i).call(this, e, t, s, o)), _this51.getFillerOffset = r;
            return _this51;
          }
          _createClass(i, [{
            key: "is",
            value: function is(e) {
              var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
              return t ? t === this.name && ("containerElement" === e || "view:containerElement" === e || "element" === e || "view:element" === e) : "containerElement" === e || "view:containerElement" === e || "element" === e || "view:element" === e || "node" === e || "view:node" === e;
            }
          }]);
          return i;
        }(o.Z);
        function r() {
          var e = _toConsumableArray(this.getChildren()),
            t = e[this.childCount - 1];
          if (t && t.is("element", "br")) return this.childCount;
          var _iterator191 = _createForOfIteratorHelper(e),
            _step191;
          try {
            for (_iterator191.s(); !(_step191 = _iterator191.n()).done;) {
              var _t124 = _step191.value;
              if (!_t124.is("uiElement")) return null;
            }
          } catch (err) {
            _iterator191.e(err);
          } finally {
            _iterator191.f();
          }
          return this.childCount;
        }
      },
      "./packages/ckeditor5-engine/src/view/document.js": function _packages_ckeditor5Engine_src_view_documentJs(e, t, s) {
        "use strict";

        s.d(t, {
          Z: function Z() {
            return _;
          }
        });
        var o = s("./packages/ckeditor5-engine/src/view/documentselection.js"),
          i = s("./packages/ckeditor5-utils/src/collection.js"),
          r = s("./packages/ckeditor5-utils/src/mix.js"),
          n = s("./packages/ckeditor5-utils/src/eventinfo.js"),
          a = s("./packages/ckeditor5-utils/src/ckeditorerror.js"),
          c = s("./packages/ckeditor5-utils/src/emittermixin.js"),
          l = s("./packages/ckeditor5-utils/src/toarray.js"),
          d = s("./packages/ckeditor5-engine/src/view/observer/bubblingeventinfo.js");
        var h = Symbol("bubbling contexts"),
          u = {
            fire: function fire(e) {
              try {
                var _s124 = e instanceof n.Z ? e : new n.Z(this, e),
                  _o83 = m(this);
                if (!_o83.size) return;
                for (var _len = arguments.length, t = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
                  t[_key - 1] = arguments[_key];
                }
                if (g(_s124, "capturing", this), p.apply(void 0, [_o83, "$capture", _s124].concat(t))) return _s124.return;
                var _i69 = _s124.startRange || this.selection.getFirstRange(),
                  _r35 = _i69 ? _i69.getContainedElement() : null,
                  _a7 = !!_r35 && Boolean(f(_o83, _r35));
                var _c6 = _r35 || function (e) {
                  if (!e) return null;
                  var t = e.start.parent,
                    s = e.end.parent,
                    o = t.getPath(),
                    i = s.getPath();
                  return o.length > i.length ? t : s;
                }(_i69);
                if (g(_s124, "atTarget", _c6), !_a7) {
                  if (p.apply(void 0, [_o83, "$text", _s124].concat(t))) return _s124.return;
                  g(_s124, "bubbling", _c6);
                }
                for (; _c6;) {
                  if (_c6.is("rootElement")) {
                    if (p.apply(void 0, [_o83, "$root", _s124].concat(t))) return _s124.return;
                  } else if (_c6.is("element") && p.apply(void 0, [_o83, _c6.name, _s124].concat(t))) return _s124.return;
                  if (p.apply(void 0, [_o83, _c6, _s124].concat(t))) return _s124.return;
                  _c6 = _c6.parent, g(_s124, "bubbling", _c6);
                }
                return g(_s124, "bubbling", this), p.apply(void 0, [_o83, "$document", _s124].concat(t)), _s124.return;
              } catch (e) {
                a.ZP.rethrowUnexpectedError(e, this);
              }
            },
            _addEventListener: function _addEventListener(e, t, s) {
              var o = (0, l.Z)(s.context || "$document"),
                i = m(this);
              var _iterator192 = _createForOfIteratorHelper(o),
                _step192;
              try {
                for (_iterator192.s(); !(_step192 = _iterator192.n()).done;) {
                  var _r36 = _step192.value;
                  var _o84 = i.get(_r36);
                  _o84 || (_o84 = Object.create(c.ZP), i.set(_r36, _o84)), this.listenTo(_o84, e, t, s);
                }
              } catch (err) {
                _iterator192.e(err);
              } finally {
                _iterator192.f();
              }
            },
            _removeEventListener: function _removeEventListener(e, t) {
              var s = m(this);
              var _iterator193 = _createForOfIteratorHelper(s.values()),
                _step193;
              try {
                for (_iterator193.s(); !(_step193 = _iterator193.n()).done;) {
                  var _o85 = _step193.value;
                  this.stopListening(_o85, e, t);
                }
              } catch (err) {
                _iterator193.e(err);
              } finally {
                _iterator193.f();
              }
            }
          };
        function g(e, t, s) {
          e instanceof d.Z && (e._eventPhase = t, e._currentTarget = s);
        }
        function p(e, t, s) {
          var i = "string" == typeof t ? e.get(t) : f(e, t);
          for (var _len2 = arguments.length, o = new Array(_len2 > 3 ? _len2 - 3 : 0), _key2 = 3; _key2 < _len2; _key2++) {
            o[_key2 - 3] = arguments[_key2];
          }
          return !!i && (i.fire.apply(i, [s].concat(o)), s.stop.called);
        }
        function f(e, t) {
          var _iterator194 = _createForOfIteratorHelper(e),
            _step194;
          try {
            for (_iterator194.s(); !(_step194 = _iterator194.n()).done;) {
              var _step194$value = _slicedToArray(_step194.value, 2),
                _s125 = _step194$value[0],
                _o86 = _step194$value[1];
              if ("function" == typeof _s125 && _s125(t)) return _o86;
            }
          } catch (err) {
            _iterator194.e(err);
          } finally {
            _iterator194.f();
          }
          return null;
        }
        function m(e) {
          return e[h] || (e[h] = new Map()), e[h];
        }
        var k = s("./packages/ckeditor5-utils/src/observablemixin.js");
        var _ = /*#__PURE__*/function () {
          function _(e) {
            _classCallCheck(this, _);
            this.selection = new o.Z(), this.roots = new i.Z({
              idProperty: "rootName"
            }), this.stylesProcessor = e, this.set("isReadOnly", !1), this.set("isFocused", !1), this.set("isSelecting", !1), this.set("isComposing", !1), this._postFixers = new Set();
          }
          _createClass(_, [{
            key: "getRoot",
            value: function getRoot() {
              var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "main";
              return this.roots.get(e);
            }
          }, {
            key: "registerPostFixer",
            value: function registerPostFixer(e) {
              this._postFixers.add(e);
            }
          }, {
            key: "destroy",
            value: function destroy() {
              this.roots.map(function (e) {
                return e.destroy();
              }), this.stopListening();
            }
          }, {
            key: "_callPostFixers",
            value: function _callPostFixers(e) {
              var t = !1;
              do {
                var _iterator195 = _createForOfIteratorHelper(this._postFixers),
                  _step195;
                try {
                  for (_iterator195.s(); !(_step195 = _iterator195.n()).done;) {
                    var _s126 = _step195.value;
                    if (t = _s126(e), t) break;
                  }
                } catch (err) {
                  _iterator195.e(err);
                } finally {
                  _iterator195.f();
                }
              } while (t);
            }
          }]);
          return _;
        }();
        (0, r.Z)(_, u), (0, r.Z)(_, k.Z);
      },
      "./packages/ckeditor5-engine/src/view/documentfragment.js": function _packages_ckeditor5Engine_src_view_documentfragmentJs(e, t, s) {
        "use strict";

        s.d(t, {
          Z: function Z() {
            return c;
          }
        });
        var o = s("./packages/ckeditor5-engine/src/view/text.js"),
          i = s("./packages/ckeditor5-engine/src/view/textproxy.js"),
          r = s("./packages/ckeditor5-utils/src/mix.js"),
          n = s("./packages/ckeditor5-utils/src/isiterable.js"),
          a = s("./packages/ckeditor5-utils/src/emittermixin.js");
        var c = /*#__PURE__*/function () {
          function c(e, t) {
            _classCallCheck(this, c);
            this.document = e, this._children = [], t && this._insertChild(0, t);
          }
          _createClass(c, [{
            key: Symbol.iterator,
            value: function value() {
              return this._children[Symbol.iterator]();
            }
          }, {
            key: "is",
            value: function is(e) {
              return "documentFragment" === e || "view:documentFragment" === e;
            }
          }, {
            key: "_appendChild",
            value: function _appendChild(e) {
              return this._insertChild(this.childCount, e);
            }
          }, {
            key: "getChild",
            value: function getChild(e) {
              return this._children[e];
            }
          }, {
            key: "getChildIndex",
            value: function getChildIndex(e) {
              return this._children.indexOf(e);
            }
          }, {
            key: "getChildren",
            value: function getChildren() {
              return this._children[Symbol.iterator]();
            }
          }, {
            key: "_insertChild",
            value: function _insertChild(e, t) {
              this._fireChange("children", this);
              var s = 0;
              var r = function (e, t) {
                if ("string" == typeof t) return [new o.Z(e, t)];
                (0, n.Z)(t) || (t = [t]);
                return Array.from(t).map(function (t) {
                  return "string" == typeof t ? new o.Z(e, t) : t instanceof i.Z ? new o.Z(e, t.data) : t;
                });
              }(this.document, t);
              var _iterator196 = _createForOfIteratorHelper(r),
                _step196;
              try {
                for (_iterator196.s(); !(_step196 = _iterator196.n()).done;) {
                  var _t125 = _step196.value;
                  null !== _t125.parent && _t125._remove(), _t125.parent = this, this._children.splice(e, 0, _t125), e++, s++;
                }
              } catch (err) {
                _iterator196.e(err);
              } finally {
                _iterator196.f();
              }
              return s;
            }
          }, {
            key: "_removeChildren",
            value: function _removeChildren(e) {
              var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
              this._fireChange("children", this);
              for (var _s127 = e; _s127 < e + t; _s127++) this._children[_s127].parent = null;
              return this._children.splice(e, t);
            }
          }, {
            key: "_fireChange",
            value: function _fireChange(e, t) {
              this.fire("change:" + e, t);
            }
          }, {
            key: "childCount",
            get: function get() {
              return this._children.length;
            }
          }, {
            key: "isEmpty",
            get: function get() {
              return 0 === this.childCount;
            }
          }, {
            key: "root",
            get: function get() {
              return this;
            }
          }, {
            key: "parent",
            get: function get() {
              return null;
            }
          }]);
          return c;
        }();
        (0, r.Z)(c, a.ZP);
      },
      "./packages/ckeditor5-engine/src/view/documentselection.js": function _packages_ckeditor5Engine_src_view_documentselectionJs(e, t, s) {
        "use strict";

        s.d(t, {
          Z: function Z() {
            return n;
          }
        });
        var o = s("./packages/ckeditor5-engine/src/view/selection.js"),
          i = s("./packages/ckeditor5-utils/src/mix.js"),
          r = s("./packages/ckeditor5-utils/src/emittermixin.js");
        var n = /*#__PURE__*/function () {
          function n() {
            var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
            var t = arguments.length > 1 ? arguments[1] : undefined;
            var s = arguments.length > 2 ? arguments[2] : undefined;
            _classCallCheck(this, n);
            this._selection = new o.Z(), this._selection.delegate("change").to(this), this._selection.setTo(e, t, s);
          }
          _createClass(n, [{
            key: "getRanges",
            value: /*#__PURE__*/_regeneratorRuntime().mark(function getRanges() {
              return _regeneratorRuntime().wrap(function getRanges$(_context20) {
                while (1) switch (_context20.prev = _context20.next) {
                  case 0:
                    return _context20.delegateYield(this._selection.getRanges(), "t0", 1);
                  case 1:
                  case "end":
                    return _context20.stop();
                }
              }, getRanges, this);
            })
          }, {
            key: "getFirstRange",
            value: function getFirstRange() {
              return this._selection.getFirstRange();
            }
          }, {
            key: "getLastRange",
            value: function getLastRange() {
              return this._selection.getLastRange();
            }
          }, {
            key: "getFirstPosition",
            value: function getFirstPosition() {
              return this._selection.getFirstPosition();
            }
          }, {
            key: "getLastPosition",
            value: function getLastPosition() {
              return this._selection.getLastPosition();
            }
          }, {
            key: "getSelectedElement",
            value: function getSelectedElement() {
              return this._selection.getSelectedElement();
            }
          }, {
            key: "isEqual",
            value: function isEqual(e) {
              return this._selection.isEqual(e);
            }
          }, {
            key: "isSimilar",
            value: function isSimilar(e) {
              return this._selection.isSimilar(e);
            }
          }, {
            key: "is",
            value: function is(e) {
              return "selection" === e || "documentSelection" == e || "view:selection" == e || "view:documentSelection" == e;
            }
          }, {
            key: "_setTo",
            value: function _setTo(e, t, s) {
              this._selection.setTo(e, t, s);
            }
          }, {
            key: "_setFocus",
            value: function _setFocus(e, t) {
              this._selection.setFocus(e, t);
            }
          }, {
            key: "isFake",
            get: function get() {
              return this._selection.isFake;
            }
          }, {
            key: "fakeSelectionLabel",
            get: function get() {
              return this._selection.fakeSelectionLabel;
            }
          }, {
            key: "anchor",
            get: function get() {
              return this._selection.anchor;
            }
          }, {
            key: "focus",
            get: function get() {
              return this._selection.focus;
            }
          }, {
            key: "isCollapsed",
            get: function get() {
              return this._selection.isCollapsed;
            }
          }, {
            key: "rangeCount",
            get: function get() {
              return this._selection.rangeCount;
            }
          }, {
            key: "isBackward",
            get: function get() {
              return this._selection.isBackward;
            }
          }, {
            key: "editableElement",
            get: function get() {
              return this._selection.editableElement;
            }
          }, {
            key: "_ranges",
            get: function get() {
              return this._selection._ranges;
            }
          }]);
          return n;
        }();
        (0, i.Z)(n, r.ZP);
      },
      "./packages/ckeditor5-engine/src/view/domconverter.js": function _packages_ckeditor5Engine_src_view_domconverterJs(e, t, s) {
        "use strict";

        s.d(t, {
          Z: function Z() {
            return j;
          }
        });
        var o = s("./packages/ckeditor5-engine/src/view/text.js"),
          i = s("./packages/ckeditor5-engine/src/view/element.js"),
          r = s("./packages/ckeditor5-engine/src/view/uielement.js"),
          n = s("./packages/ckeditor5-engine/src/view/position.js"),
          a = s("./packages/ckeditor5-engine/src/view/range.js"),
          c = s("./packages/ckeditor5-engine/src/view/selection.js"),
          l = s("./packages/ckeditor5-engine/src/view/documentfragment.js"),
          d = s("./packages/ckeditor5-engine/src/view/treewalker.js"),
          h = s("./packages/ckeditor5-engine/src/view/matcher.js"),
          u = s("./packages/ckeditor5-engine/src/view/filler.js"),
          g = s("./packages/ckeditor5-utils/src/dom/global.js"),
          p = s("./packages/ckeditor5-utils/src/ckeditorerror.js");
        function f(e) {
          var t = 0;
          for (; e.previousSibling;) e = e.previousSibling, t++;
          return t;
        }
        function m(e) {
          var t = [];
          for (; e && e.nodeType != Node.DOCUMENT_NODE;) t.unshift(e), e = e.parentNode;
          return t;
        }
        var k = s("./packages/ckeditor5-utils/src/dom/istext.js"),
          _ = s("./packages/ckeditor5-utils/src/dom/iscomment.js");
        var b = (0, u.yl)(document),
          w = (0, u.N3)(document),
          v = (0, u.PQ)(document),
          y = "data-ck-unsafe-attribute-",
          Z = "data-ck-unsafe-element",
          P = ["script", "style"];
        var j = /*#__PURE__*/function () {
          function j(e) {
            var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
            _classCallCheck(this, j);
            this.document = e, this.renderingMode = t.renderingMode || "editing", this.blockFillerMode = t.blockFillerMode || ("editing" === this.renderingMode ? "br" : "nbsp"), this.preElements = ["pre"], this.blockElements = ["address", "article", "aside", "blockquote", "caption", "center", "dd", "details", "dir", "div", "dl", "dt", "fieldset", "figcaption", "figure", "footer", "form", "h1", "h2", "h3", "h4", "h5", "h6", "header", "hgroup", "legend", "li", "main", "menu", "nav", "ol", "p", "pre", "section", "summary", "table", "tbody", "td", "tfoot", "th", "thead", "tr", "ul"], this.inlineObjectElements = ["object", "iframe", "input", "button", "textarea", "select", "option", "video", "embed", "audio", "img", "canvas"], this._domToViewMapping = new WeakMap(), this._viewToDomMapping = new WeakMap(), this._fakeSelectionMapping = new WeakMap(), this._rawContentElementMatcher = new h.Z(), this._encounteredRawContentDomNodes = new WeakSet();
          }
          _createClass(j, [{
            key: "bindFakeSelection",
            value: function bindFakeSelection(e, t) {
              this._fakeSelectionMapping.set(e, new c.Z(t));
            }
          }, {
            key: "fakeSelectionToView",
            value: function fakeSelectionToView(e) {
              return this._fakeSelectionMapping.get(e);
            }
          }, {
            key: "bindElements",
            value: function bindElements(e, t) {
              this._domToViewMapping.set(e, t), this._viewToDomMapping.set(t, e);
            }
          }, {
            key: "unbindDomElement",
            value: function unbindDomElement(e) {
              var t = this._domToViewMapping.get(e);
              if (t) {
                this._domToViewMapping.delete(e), this._viewToDomMapping.delete(t);
                var _iterator197 = _createForOfIteratorHelper(e.childNodes),
                  _step197;
                try {
                  for (_iterator197.s(); !(_step197 = _iterator197.n()).done;) {
                    var _t126 = _step197.value;
                    this.unbindDomElement(_t126);
                  }
                } catch (err) {
                  _iterator197.e(err);
                } finally {
                  _iterator197.f();
                }
              }
            }
          }, {
            key: "bindDocumentFragments",
            value: function bindDocumentFragments(e, t) {
              this._domToViewMapping.set(e, t), this._viewToDomMapping.set(t, e);
            }
          }, {
            key: "shouldRenderAttribute",
            value: function shouldRenderAttribute(e, t, s) {
              return "data" === this.renderingMode || !(e = e.toLowerCase()).startsWith("on") && ("srcdoc" !== e || !t.match(/\bon\S+\s*=|javascript:|<\s*\/*script/i)) && ("img" === s && ("src" === e || "srcset" === e) || "source" === s && "srcset" === e || !t.match(/^\s*(javascript:|data:(image\/svg|text\/x?html))/i));
            }
          }, {
            key: "setContentOf",
            value: function setContentOf(e, t) {
              if ("data" === this.renderingMode) return void (e.innerHTML = t);
              var s = new DOMParser().parseFromString(t, "text/html"),
                o = s.createDocumentFragment(),
                i = s.body.childNodes;
              for (; i.length > 0;) o.appendChild(i[0]);
              var r = s.createTreeWalker(o, NodeFilter.SHOW_ELEMENT),
                n = [];
              var a;
              for (; a = r.nextNode();) n.push(a);
              for (var _i70 = 0, _n17 = n; _i70 < _n17.length; _i70++) {
                var _e143 = _n17[_i70];
                var _iterator198 = _createForOfIteratorHelper(_e143.getAttributeNames()),
                  _step198;
                try {
                  for (_iterator198.s(); !(_step198 = _iterator198.n()).done;) {
                    var _t128 = _step198.value;
                    this.setDomElementAttribute(_e143, _t128, _e143.getAttribute(_t128));
                  }
                } catch (err) {
                  _iterator198.e(err);
                } finally {
                  _iterator198.f();
                }
                var _t127 = _e143.tagName.toLowerCase();
                this._shouldRenameElement(_t127) && (T(_t127), _e143.replaceWith(this._createReplacementDomElement(_t127, _e143)));
              }
              for (; e.firstChild;) e.firstChild.remove();
              e.append(o);
            }
          }, {
            key: "viewToDom",
            value: function viewToDom(e, t) {
              var s = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
              if (e.is("$text")) {
                var _s128 = this._processDataFromViewText(e);
                return t.createTextNode(_s128);
              }
              {
                if (this.mapViewToDom(e)) return this.mapViewToDom(e);
                var _o87;
                if (e.is("documentFragment")) _o87 = t.createDocumentFragment(), s.bind && this.bindDocumentFragments(_o87, e);else {
                  if (e.is("uiElement")) return _o87 = "$comment" === e.name ? t.createComment(e.getCustomProperty("$rawContent")) : e.render(t, this), s.bind && this.bindElements(_o87, e), _o87;
                  this._shouldRenameElement(e.name) ? (T(e.name), _o87 = this._createReplacementDomElement(e.name)) : _o87 = e.hasAttribute("xmlns") ? t.createElementNS(e.getAttribute("xmlns"), e.name) : t.createElement(e.name), e.is("rawElement") && e.render(_o87, this), s.bind && this.bindElements(_o87, e);
                  var _iterator199 = _createForOfIteratorHelper(e.getAttributeKeys()),
                    _step199;
                  try {
                    for (_iterator199.s(); !(_step199 = _iterator199.n()).done;) {
                      var _t129 = _step199.value;
                      this.setDomElementAttribute(_o87, _t129, e.getAttribute(_t129), e);
                    }
                  } catch (err) {
                    _iterator199.e(err);
                  } finally {
                    _iterator199.f();
                  }
                }
                if (!1 !== s.withChildren) {
                  var _iterator200 = _createForOfIteratorHelper(this.viewChildrenToDom(e, t, s)),
                    _step200;
                  try {
                    for (_iterator200.s(); !(_step200 = _iterator200.n()).done;) {
                      var _i71 = _step200.value;
                      _o87.appendChild(_i71);
                    }
                  } catch (err) {
                    _iterator200.e(err);
                  } finally {
                    _iterator200.f();
                  }
                }
                return _o87;
              }
            }
          }, {
            key: "setDomElementAttribute",
            value: function setDomElementAttribute(e, t, s) {
              var o = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
              var i = this.shouldRenderAttribute(t, s, e.tagName.toLowerCase()) || o && o.shouldRenderUnsafeAttribute(t);
              i || (0, p.KE)("domconverter-unsafe-attribute-detected", {
                domElement: e,
                key: t,
                value: s
              }), e.hasAttribute(t) && !i ? e.removeAttribute(t) : e.hasAttribute(y + t) && i && e.removeAttribute(y + t), e.setAttribute(i ? t : y + t, s);
            }
          }, {
            key: "removeDomElementAttribute",
            value: function removeDomElementAttribute(e, t) {
              t != Z && (e.removeAttribute(t), e.removeAttribute(y + t));
            }
          }, {
            key: "viewChildrenToDom",
            value: function viewChildrenToDom(e, t) {
              var _this52 = this;
              var s = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
              return /*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
                var o, i, _iterator201, _step201, _r37;
                return _regeneratorRuntime().wrap(function _callee5$(_context21) {
                  while (1) switch (_context21.prev = _context21.next) {
                    case 0:
                      o = e.getFillerOffset && e.getFillerOffset();
                      i = 0;
                      _iterator201 = _createForOfIteratorHelper(e.getChildren());
                      _context21.prev = 3;
                      _iterator201.s();
                    case 5:
                      if ((_step201 = _iterator201.n()).done) {
                        _context21.next = 16;
                        break;
                      }
                      _r37 = _step201.value;
                      _context21.t0 = o === i;
                      if (!_context21.t0) {
                        _context21.next = 11;
                        break;
                      }
                      _context21.next = 11;
                      return _this52._getBlockFiller(t);
                    case 11:
                      _context21.next = 13;
                      return _this52.viewToDom(_r37, t, s);
                    case 13:
                      i++;
                    case 14:
                      _context21.next = 5;
                      break;
                    case 16:
                      _context21.next = 21;
                      break;
                    case 18:
                      _context21.prev = 18;
                      _context21.t1 = _context21["catch"](3);
                      _iterator201.e(_context21.t1);
                    case 21:
                      _context21.prev = 21;
                      _iterator201.f();
                      return _context21.finish(21);
                    case 24:
                      _context21.t2 = o === i;
                      if (!_context21.t2) {
                        _context21.next = 28;
                        break;
                      }
                      _context21.next = 28;
                      return _this52._getBlockFiller(t);
                    case 28:
                    case "end":
                      return _context21.stop();
                  }
                }, _callee5, null, [[3, 18, 21, 24]]);
              })();
            }
          }, {
            key: "viewRangeToDom",
            value: function viewRangeToDom(e) {
              var t = this.viewPositionToDom(e.start),
                s = this.viewPositionToDom(e.end),
                o = document.createRange();
              return o.setStart(t.parent, t.offset), o.setEnd(s.parent, s.offset), o;
            }
          }, {
            key: "viewPositionToDom",
            value: function viewPositionToDom(e) {
              var t = e.parent;
              if (t.is("$text")) {
                var _s129 = this.findCorrespondingDomText(t);
                if (!_s129) return null;
                var _o88 = e.offset;
                return (0, u.Sw)(_s129) && (_o88 += u.b_), {
                  parent: _s129,
                  offset: _o88
                };
              }
              {
                var _s130, _o89, _i72;
                if (0 === e.offset) {
                  if (_s130 = this.mapViewToDom(t), !_s130) return null;
                  _i72 = _s130.childNodes[0];
                } else {
                  var _t130 = e.nodeBefore;
                  if (_o89 = _t130.is("$text") ? this.findCorrespondingDomText(_t130) : this.mapViewToDom(e.nodeBefore), !_o89) return null;
                  _s130 = _o89.parentNode, _i72 = _o89.nextSibling;
                }
                if ((0, k.Z)(_i72) && (0, u.Sw)(_i72)) return {
                  parent: _i72,
                  offset: u.b_
                };
                return {
                  parent: _s130,
                  offset: _o89 ? f(_o89) + 1 : 0
                };
              }
            }
          }, {
            key: "domToView",
            value: function domToView(e) {
              var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
              if (this.isBlockFiller(e)) return null;
              var s = this.getHostViewElement(e);
              if (s) return s;
              if ((0, _.Z)(e) && t.skipComments) return null;
              if ((0, k.Z)(e)) {
                if ((0, u.Qh)(e)) return null;
                {
                  var _t131 = this._processDataFromDomText(e);
                  return "" === _t131 ? null : new o.Z(this.document, _t131);
                }
              }
              {
                if (this.mapDomToView(e)) return this.mapDomToView(e);
                var _s131;
                if (this.isDocumentFragment(e)) _s131 = new l.Z(this.document), t.bind && this.bindDocumentFragments(e, _s131);else {
                  _s131 = this._createViewElement(e, t), t.bind && this.bindElements(e, _s131);
                  var _o90 = e.attributes;
                  if (_o90) for (var _e144 = _o90.length - 1; _e144 >= 0; _e144--) _s131._setAttribute(_o90[_e144].name, _o90[_e144].value);
                  if (this._isViewElementWithRawContent(_s131, t) || (0, _.Z)(e)) {
                    var _t132 = (0, _.Z)(e) ? e.data : e.innerHTML;
                    return _s131._setCustomProperty("$rawContent", _t132), this._encounteredRawContentDomNodes.add(e), _s131;
                  }
                }
                if (!1 !== t.withChildren) {
                  var _iterator202 = _createForOfIteratorHelper(this.domChildrenToView(e, t)),
                    _step202;
                  try {
                    for (_iterator202.s(); !(_step202 = _iterator202.n()).done;) {
                      var _o91 = _step202.value;
                      _s131._appendChild(_o91);
                    }
                  } catch (err) {
                    _iterator202.e(err);
                  } finally {
                    _iterator202.f();
                  }
                }
                return _s131;
              }
            }
          }, {
            key: "domChildrenToView",
            value: function domChildrenToView(e) {
              var _this53 = this;
              var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
              return /*#__PURE__*/_regeneratorRuntime().mark(function _callee6() {
                var _s132, _o92, _i73;
                return _regeneratorRuntime().wrap(function _callee6$(_context22) {
                  while (1) switch (_context22.prev = _context22.next) {
                    case 0:
                      _s132 = 0;
                    case 1:
                      if (!(_s132 < e.childNodes.length)) {
                        _context22.next = 10;
                        break;
                      }
                      _o92 = e.childNodes[_s132], _i73 = _this53.domToView(_o92, t);
                      _context22.t0 = null !== _i73;
                      if (!_context22.t0) {
                        _context22.next = 7;
                        break;
                      }
                      _context22.next = 7;
                      return _i73;
                    case 7:
                      _s132++;
                      _context22.next = 1;
                      break;
                    case 10:
                    case "end":
                      return _context22.stop();
                  }
                }, _callee6);
              })();
            }
          }, {
            key: "domSelectionToView",
            value: function domSelectionToView(e) {
              if (1 === e.rangeCount) {
                var _t133 = e.getRangeAt(0).startContainer;
                (0, k.Z)(_t133) && (_t133 = _t133.parentNode);
                var _s133 = this.fakeSelectionToView(_t133);
                if (_s133) return _s133;
              }
              var t = this.isDomSelectionBackward(e),
                s = [];
              for (var _t134 = 0; _t134 < e.rangeCount; _t134++) {
                var _o93 = e.getRangeAt(_t134),
                  _i74 = this.domRangeToView(_o93);
                _i74 && s.push(_i74);
              }
              return new c.Z(s, {
                backward: t
              });
            }
          }, {
            key: "domRangeToView",
            value: function domRangeToView(e) {
              var t = this.domPositionToView(e.startContainer, e.startOffset),
                s = this.domPositionToView(e.endContainer, e.endOffset);
              return t && s ? new a.Z(t, s) : null;
            }
          }, {
            key: "domPositionToView",
            value: function domPositionToView(e) {
              var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
              if (this.isBlockFiller(e)) return this.domPositionToView(e.parentNode, f(e));
              var s = this.mapDomToView(e);
              if (s && (s.is("uiElement") || s.is("rawElement"))) return n.Z._createBefore(s);
              if ((0, k.Z)(e)) {
                if ((0, u.Qh)(e)) return this.domPositionToView(e.parentNode, f(e));
                var _s134 = this.findCorrespondingViewText(e);
                var _o94 = t;
                return _s134 ? ((0, u.Sw)(e) && (_o94 -= u.b_, _o94 = _o94 < 0 ? 0 : _o94), new n.Z(_s134, _o94)) : null;
              }
              if (0 === t) {
                var _t135 = this.mapDomToView(e);
                if (_t135) return new n.Z(_t135, 0);
              } else {
                var _s135 = e.childNodes[t - 1],
                  _o95 = (0, k.Z)(_s135) ? this.findCorrespondingViewText(_s135) : this.mapDomToView(_s135);
                if (_o95 && _o95.parent) return new n.Z(_o95.parent, _o95.index + 1);
              }
              return null;
            }
          }, {
            key: "mapDomToView",
            value: function mapDomToView(e) {
              return this.getHostViewElement(e) || this._domToViewMapping.get(e);
            }
          }, {
            key: "findCorrespondingViewText",
            value: function findCorrespondingViewText(e) {
              if ((0, u.Qh)(e)) return null;
              var t = this.getHostViewElement(e);
              if (t) return t;
              var s = e.previousSibling;
              if (s) {
                if (!this.isElement(s)) return null;
                var _e145 = this.mapDomToView(s);
                if (_e145) {
                  return _e145.nextSibling instanceof o.Z ? _e145.nextSibling : null;
                }
              } else {
                var _t136 = this.mapDomToView(e.parentNode);
                if (_t136) {
                  var _e146 = _t136.getChild(0);
                  return _e146 instanceof o.Z ? _e146 : null;
                }
              }
              return null;
            }
          }, {
            key: "mapViewToDom",
            value: function mapViewToDom(e) {
              return this._viewToDomMapping.get(e);
            }
          }, {
            key: "findCorrespondingDomText",
            value: function findCorrespondingDomText(e) {
              var t = e.previousSibling;
              return t && this.mapViewToDom(t) ? this.mapViewToDom(t).nextSibling : !t && e.parent && this.mapViewToDom(e.parent) ? this.mapViewToDom(e.parent).childNodes[0] : null;
            }
          }, {
            key: "focus",
            value: function focus(e) {
              var t = this.mapViewToDom(e);
              if (t && t.ownerDocument.activeElement !== t) {
                var _g$Z$window = g.Z.window,
                  _e147 = _g$Z$window.scrollX,
                  _s136 = _g$Z$window.scrollY,
                  _o96 = [];
                x(t, function (e) {
                  var t = e.scrollLeft,
                    s = e.scrollTop;
                  _o96.push([t, s]);
                }), t.focus(), x(t, function (e) {
                  var _o96$shift = _o96.shift(),
                    _o96$shift2 = _slicedToArray(_o96$shift, 2),
                    t = _o96$shift2[0],
                    s = _o96$shift2[1];
                  e.scrollLeft = t, e.scrollTop = s;
                }), g.Z.window.scrollTo(_e147, _s136);
              }
            }
          }, {
            key: "isElement",
            value: function isElement(e) {
              return e && e.nodeType == Node.ELEMENT_NODE;
            }
          }, {
            key: "isDocumentFragment",
            value: function isDocumentFragment(e) {
              return e && e.nodeType == Node.DOCUMENT_FRAGMENT_NODE;
            }
          }, {
            key: "isBlockFiller",
            value: function isBlockFiller(e) {
              return "br" == this.blockFillerMode ? e.isEqualNode(b) : !("BR" !== e.tagName || !A(e, this.blockElements) || 1 !== e.parentNode.childNodes.length) || e.isEqualNode(v) || function (e, t) {
                return e.isEqualNode(w) && A(e, t) && 1 === e.parentNode.childNodes.length;
              }(e, this.blockElements);
            }
          }, {
            key: "isDomSelectionBackward",
            value: function isDomSelectionBackward(e) {
              if (e.isCollapsed) return !1;
              var t = document.createRange();
              t.setStart(e.anchorNode, e.anchorOffset), t.setEnd(e.focusNode, e.focusOffset);
              var s = t.collapsed;
              return t.detach(), s;
            }
          }, {
            key: "getHostViewElement",
            value: function getHostViewElement(e) {
              var t = m(e);
              for (t.pop(); t.length;) {
                var _e148 = t.pop(),
                  _s137 = this._domToViewMapping.get(_e148);
                if (_s137 && (_s137.is("uiElement") || _s137.is("rawElement"))) return _s137;
              }
              return null;
            }
          }, {
            key: "isDomSelectionCorrect",
            value: function isDomSelectionCorrect(e) {
              return this._isDomSelectionPositionCorrect(e.anchorNode, e.anchorOffset) && this._isDomSelectionPositionCorrect(e.focusNode, e.focusOffset);
            }
          }, {
            key: "registerRawContentMatcher",
            value: function registerRawContentMatcher(e) {
              this._rawContentElementMatcher.add(e);
            }
          }, {
            key: "_getBlockFiller",
            value: function _getBlockFiller(e) {
              switch (this.blockFillerMode) {
                case "nbsp":
                  return (0, u.N3)(e);
                case "markedNbsp":
                  return (0, u.PQ)(e);
                case "br":
                  return (0, u.yl)(e);
              }
            }
          }, {
            key: "_isDomSelectionPositionCorrect",
            value: function _isDomSelectionPositionCorrect(e, t) {
              if ((0, k.Z)(e) && (0, u.Sw)(e) && t < u.b_) return !1;
              if (this.isElement(e) && (0, u.Sw)(e.childNodes[t])) return !1;
              var s = this.mapDomToView(e);
              return !s || !s.is("uiElement") && !s.is("rawElement");
            }
          }, {
            key: "_processDataFromViewText",
            value: function _processDataFromViewText(e) {
              var _this54 = this;
              var t = e.data;
              if (e.getAncestors().some(function (e) {
                return _this54.preElements.includes(e.name);
              })) return t;
              if (" " == t.charAt(0)) {
                var _s138 = this._getTouchingInlineViewNode(e, !1);
                !(_s138 && _s138.is("$textProxy") && this._nodeEndsWithSpace(_s138)) && _s138 || (t = " " + t.substr(1));
              }
              if (" " == t.charAt(t.length - 1)) {
                var _s139 = this._getTouchingInlineViewNode(e, !0),
                  _o97 = _s139 && _s139.is("$textProxy") && " " == _s139.data.charAt(0);
                " " != t.charAt(t.length - 2) && _s139 && !_o97 || (t = t.substr(0, t.length - 1) + " ");
              }
              return t.replace(/ {2}/g, "  ");
            }
          }, {
            key: "_nodeEndsWithSpace",
            value: function _nodeEndsWithSpace(e) {
              var _this55 = this;
              if (e.getAncestors().some(function (e) {
                return _this55.preElements.includes(e.name);
              })) return !1;
              var t = this._processDataFromViewText(e);
              return " " == t.charAt(t.length - 1);
            }
          }, {
            key: "_processDataFromDomText",
            value: function _processDataFromDomText(e) {
              var t = e.data;
              if (function (e, t) {
                return m(e).some(function (e) {
                  return e.tagName && t.includes(e.tagName.toLowerCase());
                });
              }(e, this.preElements)) return (0, u.th)(e);
              t = t.replace(/[ \n\t\r]{1,}/g, " ");
              var s = this._getTouchingInlineDomNode(e, !1),
                o = this._getTouchingInlineDomNode(e, !0),
                i = this._checkShouldLeftTrimDomText(e, s),
                r = this._checkShouldRightTrimDomText(e, o);
              i && (t = t.replace(/^ /, "")), r && (t = t.replace(/ $/, "")), t = (0, u.th)(new Text(t)), t = t.replace(/ \u00A0/g, "  ");
              var n = o && this.isElement(o) && "BR" != o.tagName,
                a = o && (0, k.Z)(o) && " " == o.data.charAt(0);
              return (/( |\u00A0)\u00A0$/.test(t) || !o || n || a) && (t = t.replace(/\u00A0$/, " ")), (i || s && this.isElement(s) && "BR" != s.tagName) && (t = t.replace(/^\u00A0/, " ")), t;
            }
          }, {
            key: "_checkShouldLeftTrimDomText",
            value: function _checkShouldLeftTrimDomText(e, t) {
              return !t || (this.isElement(t) ? "BR" === t.tagName : !this._encounteredRawContentDomNodes.has(e.previousSibling) && /[^\S\u00A0]/.test(t.data.charAt(t.data.length - 1)));
            }
          }, {
            key: "_checkShouldRightTrimDomText",
            value: function _checkShouldRightTrimDomText(e, t) {
              return !t && !(0, u.Sw)(e);
            }
          }, {
            key: "_getTouchingInlineViewNode",
            value: function _getTouchingInlineViewNode(e, t) {
              var s = new d.Z({
                startPosition: t ? n.Z._createAfter(e) : n.Z._createBefore(e),
                direction: t ? "forward" : "backward"
              });
              var _iterator203 = _createForOfIteratorHelper(s),
                _step203;
              try {
                for (_iterator203.s(); !(_step203 = _iterator203.n()).done;) {
                  var _e149 = _step203.value;
                  if (_e149.item.is("element") && this.inlineObjectElements.includes(_e149.item.name)) return _e149.item;
                  if (_e149.item.is("containerElement")) return null;
                  if (_e149.item.is("element", "br")) return null;
                  if (_e149.item.is("$textProxy")) return _e149.item;
                }
              } catch (err) {
                _iterator203.e(err);
              } finally {
                _iterator203.f();
              }
              return null;
            }
          }, {
            key: "_getTouchingInlineDomNode",
            value: function _getTouchingInlineDomNode(e, t) {
              if (!e.parentNode) return null;
              var s = t ? "firstChild" : "lastChild",
                o = t ? "nextSibling" : "previousSibling";
              var i = !0;
              do {
                if (!i && e[s] ? e = e[s] : e[o] ? (e = e[o], i = !1) : (e = e.parentNode, i = !0), !e || this._isBlockElement(e)) return null;
              } while (!(0, k.Z)(e) && "BR" != e.tagName && !this._isInlineObjectElement(e));
              return e;
            }
          }, {
            key: "_isBlockElement",
            value: function _isBlockElement(e) {
              return this.isElement(e) && this.blockElements.includes(e.tagName.toLowerCase());
            }
          }, {
            key: "_isInlineObjectElement",
            value: function _isInlineObjectElement(e) {
              return this.isElement(e) && this.inlineObjectElements.includes(e.tagName.toLowerCase());
            }
          }, {
            key: "_createViewElement",
            value: function _createViewElement(e, t) {
              if ((0, _.Z)(e)) return new r.Z(this.document, "$comment");
              var s = t.keepOriginalCase ? e.tagName : e.tagName.toLowerCase();
              return new i.Z(this.document, s);
            }
          }, {
            key: "_isViewElementWithRawContent",
            value: function _isViewElementWithRawContent(e, t) {
              return !1 !== t.withChildren && this._rawContentElementMatcher.match(e);
            }
          }, {
            key: "_shouldRenameElement",
            value: function _shouldRenameElement(e) {
              var t = e.toLowerCase();
              return "editing" === this.renderingMode && P.includes(t);
            }
          }, {
            key: "_createReplacementDomElement",
            value: function _createReplacementDomElement(e) {
              var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
              var s = document.createElement("span");
              if (s.setAttribute(Z, e), t) {
                for (; t.firstChild;) s.appendChild(t.firstChild);
                var _iterator204 = _createForOfIteratorHelper(t.getAttributeNames()),
                  _step204;
                try {
                  for (_iterator204.s(); !(_step204 = _iterator204.n()).done;) {
                    var _e150 = _step204.value;
                    s.setAttribute(_e150, t.getAttribute(_e150));
                  }
                } catch (err) {
                  _iterator204.e(err);
                } finally {
                  _iterator204.f();
                }
              }
              return s;
            }
          }]);
          return j;
        }();
        function x(e, t) {
          for (; e && e != g.Z.document;) t(e), e = e.parentNode;
        }
        function A(e, t) {
          var s = e.parentNode;
          return s && s.tagName && t.includes(s.tagName.toLowerCase());
        }
        function T(e) {
          "script" === e && (0, p.KE)("domconverter-unsafe-script-element-detected"), "style" === e && (0, p.KE)("domconverter-unsafe-style-element-detected");
        }
      },
      "./packages/ckeditor5-engine/src/view/downcastwriter.js": function _packages_ckeditor5Engine_src_view_downcastwriterJs(e, t, s) {
        "use strict";

        s.d(t, {
          Z: function Z() {
            return v;
          }
        });
        var o = s("./packages/ckeditor5-engine/src/view/position.js"),
          i = s("./packages/ckeditor5-engine/src/view/range.js"),
          r = s("./packages/ckeditor5-engine/src/view/selection.js"),
          n = s("./packages/ckeditor5-engine/src/view/containerelement.js"),
          a = s("./packages/ckeditor5-engine/src/view/attributeelement.js"),
          c = s("./packages/ckeditor5-engine/src/view/element.js"),
          l = s("./packages/ckeditor5-utils/src/ckeditorerror.js"),
          d = s("./packages/ckeditor5-engine/src/view/node.js");
        var h = /*#__PURE__*/function (_c$Z) {
          _inherits(h, _c$Z);
          function h(e, t, s, o) {
            var _this56;
            _classCallCheck(this, h);
            _this56 = _possibleConstructorReturn(this, _getPrototypeOf(h).call(this, e, t, s, o)), _this56._isAllowedInsideAttributeElement = !0, _this56.getFillerOffset = u;
            return _this56;
          }
          _createClass(h, [{
            key: "is",
            value: function is(e) {
              var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
              return t ? t === this.name && ("emptyElement" === e || "view:emptyElement" === e || "element" === e || "view:element" === e) : "emptyElement" === e || "view:emptyElement" === e || "element" === e || "view:element" === e || "node" === e || "view:node" === e;
            }
          }, {
            key: "_insertChild",
            value: function _insertChild(e, t) {
              if (t && (t instanceof d.Z || Array.from(t).length > 0)) throw new l.ZP("view-emptyelement-cannot-add", [this, t]);
            }
          }]);
          return h;
        }(c.Z);
        function u() {
          return null;
        }
        var g = s("./packages/ckeditor5-engine/src/view/uielement.js");
        var p = /*#__PURE__*/function (_c$Z2) {
          _inherits(p, _c$Z2);
          function p(e, t, s, o) {
            var _this57;
            _classCallCheck(this, p);
            _this57 = _possibleConstructorReturn(this, _getPrototypeOf(p).call(this, e, t, s, o)), _this57._isAllowedInsideAttributeElement = !0, _this57.getFillerOffset = f;
            return _this57;
          }
          _createClass(p, [{
            key: "is",
            value: function is(e) {
              var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
              return t ? t === this.name && ("rawElement" === e || "view:rawElement" === e || "element" === e || "view:element" === e) : "rawElement" === e || "view:rawElement" === e || e === this.name || e === "view:" + this.name || "element" === e || "view:element" === e || "node" === e || "view:node" === e;
            }
          }, {
            key: "_insertChild",
            value: function _insertChild(e, t) {
              if (t && (t instanceof d.Z || Array.from(t).length > 0)) throw new l.ZP("view-rawelement-cannot-add", [this, t]);
            }
          }]);
          return p;
        }(c.Z);
        function f() {
          return null;
        }
        var m = s("./packages/ckeditor5-engine/src/view/documentfragment.js"),
          k = s("./packages/ckeditor5-utils/src/isiterable.js"),
          _ = s("./packages/ckeditor5-engine/src/view/text.js"),
          b = s("./packages/ckeditor5-engine/src/view/editableelement.js"),
          w = s("./node_modules/lodash-es/isPlainObject.js");
        var v = /*#__PURE__*/function () {
          function v(e) {
            _classCallCheck(this, v);
            this.document = e, this._cloneGroups = new Map(), this._slotFactory = null;
          }
          _createClass(v, [{
            key: "setSelection",
            value: function setSelection(e, t, s) {
              this.document.selection._setTo(e, t, s);
            }
          }, {
            key: "setSelectionFocus",
            value: function setSelectionFocus(e, t) {
              this.document.selection._setFocus(e, t);
            }
          }, {
            key: "createDocumentFragment",
            value: function createDocumentFragment(e) {
              return new m.Z(this.document, e);
            }
          }, {
            key: "createText",
            value: function createText(e) {
              return new _.Z(this.document, e);
            }
          }, {
            key: "createAttributeElement",
            value: function createAttributeElement(e, t) {
              var _o$_unsafeAttributesT;
              var s = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
              var o = new a.Z(this.document, e, t);
              return "number" == typeof s.priority && (o._priority = s.priority), s.id && (o._id = s.id), s.renderUnsafeAttributes && (_o$_unsafeAttributesT = o._unsafeAttributesToRender).push.apply(_o$_unsafeAttributesT, _toConsumableArray(s.renderUnsafeAttributes)), o;
            }
          }, {
            key: "createContainerElement",
            value: function createContainerElement(e, t) {
              var _r$_unsafeAttributesT;
              var s = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
              var o = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
              var i = null;
              (0, w.Z)(s) ? o = s : i = s;
              var r = new n.Z(this.document, e, t, i);
              return void 0 !== o.isAllowedInsideAttributeElement && (r._isAllowedInsideAttributeElement = o.isAllowedInsideAttributeElement), o.renderUnsafeAttributes && (_r$_unsafeAttributesT = r._unsafeAttributesToRender).push.apply(_r$_unsafeAttributesT, _toConsumableArray(o.renderUnsafeAttributes)), r;
            }
          }, {
            key: "createEditableElement",
            value: function createEditableElement(e, t) {
              var _o$_unsafeAttributesT2;
              var s = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
              var o = new b.Z(this.document, e, t);
              return o._document = this.document, s.renderUnsafeAttributes && (_o$_unsafeAttributesT2 = o._unsafeAttributesToRender).push.apply(_o$_unsafeAttributesT2, _toConsumableArray(s.renderUnsafeAttributes)), o;
            }
          }, {
            key: "createEmptyElement",
            value: function createEmptyElement(e, t) {
              var _o$_unsafeAttributesT3;
              var s = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
              var o = new h(this.document, e, t);
              return void 0 !== s.isAllowedInsideAttributeElement && (o._isAllowedInsideAttributeElement = s.isAllowedInsideAttributeElement), s.renderUnsafeAttributes && (_o$_unsafeAttributesT3 = o._unsafeAttributesToRender).push.apply(_o$_unsafeAttributesT3, _toConsumableArray(s.renderUnsafeAttributes)), o;
            }
          }, {
            key: "createUIElement",
            value: function createUIElement(e, t, s) {
              var o = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
              var i = new g.Z(this.document, e, t);
              return s && (i.render = s), void 0 !== o.isAllowedInsideAttributeElement && (i._isAllowedInsideAttributeElement = o.isAllowedInsideAttributeElement), i;
            }
          }, {
            key: "createRawElement",
            value: function createRawElement(e, t, s) {
              var _i$_unsafeAttributesT;
              var o = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
              var i = new p(this.document, e, t);
              return i.render = s || function () {}, void 0 !== o.isAllowedInsideAttributeElement && (i._isAllowedInsideAttributeElement = o.isAllowedInsideAttributeElement), o.renderUnsafeAttributes && (_i$_unsafeAttributesT = i._unsafeAttributesToRender).push.apply(_i$_unsafeAttributesT, _toConsumableArray(o.renderUnsafeAttributes)), i;
            }
          }, {
            key: "setAttribute",
            value: function setAttribute(e, t, s) {
              s._setAttribute(e, t);
            }
          }, {
            key: "removeAttribute",
            value: function removeAttribute(e, t) {
              t._removeAttribute(e);
            }
          }, {
            key: "addClass",
            value: function addClass(e, t) {
              t._addClass(e);
            }
          }, {
            key: "removeClass",
            value: function removeClass(e, t) {
              t._removeClass(e);
            }
          }, {
            key: "setStyle",
            value: function setStyle(e, t, s) {
              (0, w.Z)(e) && void 0 === s && (s = t), s._setStyle(e, t);
            }
          }, {
            key: "removeStyle",
            value: function removeStyle(e, t) {
              t._removeStyle(e);
            }
          }, {
            key: "setCustomProperty",
            value: function setCustomProperty(e, t, s) {
              s._setCustomProperty(e, t);
            }
          }, {
            key: "removeCustomProperty",
            value: function removeCustomProperty(e, t) {
              return t._removeCustomProperty(e);
            }
          }, {
            key: "breakAttributes",
            value: function breakAttributes(e) {
              return e instanceof o.Z ? this._breakAttributes(e) : this._breakAttributesRange(e);
            }
          }, {
            key: "breakContainer",
            value: function breakContainer(e) {
              var t = e.parent;
              if (!t.is("containerElement")) throw new l.ZP("view-writer-break-non-container-element", this.document);
              if (!t.parent) throw new l.ZP("view-writer-break-root", this.document);
              if (e.isAtStart) return o.Z._createBefore(t);
              if (!e.isAtEnd) {
                var _s140 = t._clone(!1);
                this.insert(o.Z._createAfter(t), _s140);
                var _r38 = new i.Z(e, o.Z._createAt(t, "end")),
                  _n18 = new o.Z(_s140, 0);
                this.move(_r38, _n18);
              }
              return o.Z._createAfter(t);
            }
          }, {
            key: "mergeAttributes",
            value: function mergeAttributes(e) {
              var t = e.offset,
                s = e.parent;
              if (s.is("$text")) return e;
              if (s.is("attributeElement") && 0 === s.childCount) {
                var _e151 = s.parent,
                  _t137 = s.index;
                return s._remove(), this._removeFromClonedElementsGroup(s), this.mergeAttributes(new o.Z(_e151, _t137));
              }
              var i = s.getChild(t - 1),
                r = s.getChild(t);
              if (!i || !r) return e;
              if (i.is("$text") && r.is("$text")) return x(i, r);
              if (i.is("attributeElement") && r.is("attributeElement") && i.isSimilar(r)) {
                var _e152 = i.childCount;
                return i._appendChild(r.getChildren()), r._remove(), this._removeFromClonedElementsGroup(r), this.mergeAttributes(new o.Z(i, _e152));
              }
              return e;
            }
          }, {
            key: "mergeContainers",
            value: function mergeContainers(e) {
              var t = e.nodeBefore,
                s = e.nodeAfter;
              if (!(t && s && t.is("containerElement") && s.is("containerElement"))) throw new l.ZP("view-writer-merge-containers-invalid-position", this.document);
              var r = t.getChild(t.childCount - 1),
                n = r instanceof _.Z ? o.Z._createAt(r, "end") : o.Z._createAt(t, "end");
              return this.move(i.Z._createIn(s), o.Z._createAt(t, "end")), this.remove(i.Z._createOn(s)), n;
            }
          }, {
            key: "insert",
            value: function insert(e, t) {
              A(t = (0, k.Z)(t) ? _toConsumableArray(t) : [t], this.document);
              var s = t.reduce(function (e, t) {
                var s = e[e.length - 1],
                  o = !(t.is("uiElement") && t.isAllowedInsideAttributeElement);
                return s && s.breakAttributes == o ? s.nodes.push(t) : e.push({
                  breakAttributes: o,
                  nodes: [t]
                }), e;
              }, []);
              var o = null,
                r = e;
              var _iterator205 = _createForOfIteratorHelper(s),
                _step205;
              try {
                for (_iterator205.s(); !(_step205 = _iterator205.n()).done;) {
                  var _step205$value = _step205.value,
                    _e153 = _step205$value.nodes,
                    _t138 = _step205$value.breakAttributes;
                  var _s141 = this._insertNodes(r, _e153, _t138);
                  o || (o = _s141.start), r = _s141.end;
                }
              } catch (err) {
                _iterator205.e(err);
              } finally {
                _iterator205.f();
              }
              return o ? new i.Z(o, r) : new i.Z(e);
            }
          }, {
            key: "remove",
            value: function remove(e) {
              var t = e instanceof i.Z ? e : i.Z._createOn(e);
              if (E(t, this.document), t.isCollapsed) return new m.Z(this.document);
              var _this$_breakAttribute = this._breakAttributesRange(t, !0),
                s = _this$_breakAttribute.start,
                o = _this$_breakAttribute.end,
                r = s.parent,
                n = o.offset - s.offset,
                a = r._removeChildren(s.offset, n);
              var _iterator206 = _createForOfIteratorHelper(a),
                _step206;
              try {
                for (_iterator206.s(); !(_step206 = _iterator206.n()).done;) {
                  var _e154 = _step206.value;
                  this._removeFromClonedElementsGroup(_e154);
                }
              } catch (err) {
                _iterator206.e(err);
              } finally {
                _iterator206.f();
              }
              var c = this.mergeAttributes(s);
              return t.start = c, t.end = c.clone(), new m.Z(this.document, a);
            }
          }, {
            key: "clear",
            value: function clear(e, t) {
              E(e, this.document);
              var s = e.getWalker({
                direction: "backward",
                ignoreElementEnd: !0
              });
              var _iterator207 = _createForOfIteratorHelper(s),
                _step207;
              try {
                for (_iterator207.s(); !(_step207 = _iterator207.n()).done;) {
                  var _o98 = _step207.value;
                  var _s142 = _o98.item;
                  var _r39 = void 0;
                  if (_s142.is("element") && t.isSimilar(_s142)) _r39 = i.Z._createOn(_s142);else if (!_o98.nextPosition.isAfter(e.start) && _s142.is("$textProxy")) {
                    var _e155 = _s142.getAncestors().find(function (e) {
                      return e.is("element") && t.isSimilar(e);
                    });
                    _e155 && (_r39 = i.Z._createIn(_e155));
                  }
                  _r39 && (_r39.end.isAfter(e.end) && (_r39.end = e.end), _r39.start.isBefore(e.start) && (_r39.start = e.start), this.remove(_r39));
                }
              } catch (err) {
                _iterator207.e(err);
              } finally {
                _iterator207.f();
              }
            }
          }, {
            key: "move",
            value: function move(e, t) {
              var s;
              if (t.isAfter(e.end)) {
                var _o99 = (t = this._breakAttributes(t, !0)).parent,
                  _i75 = _o99.childCount;
                e = this._breakAttributesRange(e, !0), s = this.remove(e), t.offset += _o99.childCount - _i75;
              } else s = this.remove(e);
              return this.insert(t, s);
            }
          }, {
            key: "wrap",
            value: function wrap(e, t) {
              if (!(t instanceof a.Z)) throw new l.ZP("view-writer-wrap-invalid-attribute", this.document);
              if (E(e, this.document), e.isCollapsed) {
                var _o100 = e.start;
                _o100.parent.is("element") && (s = _o100.parent, !Array.from(s.getChildren()).some(function (e) {
                  return !e.is("uiElement");
                })) && (_o100 = _o100.getLastMatchingPosition(function (e) {
                  return e.item.is("uiElement");
                })), _o100 = this._wrapPosition(_o100, t);
                var _r40 = this.document.selection;
                return _r40.isCollapsed && _r40.getFirstPosition().isEqual(e.start) && this.setSelection(_o100), new i.Z(_o100);
              }
              return this._wrapRange(e, t);
              var s;
            }
          }, {
            key: "unwrap",
            value: function unwrap(e, t) {
              if (!(t instanceof a.Z)) throw new l.ZP("view-writer-unwrap-invalid-attribute", this.document);
              if (E(e, this.document), e.isCollapsed) return e;
              var _this$_breakAttribute2 = this._breakAttributesRange(e, !0),
                s = _this$_breakAttribute2.start,
                o = _this$_breakAttribute2.end,
                r = s.parent,
                n = this._unwrapChildren(r, s.offset, o.offset, t),
                c = this.mergeAttributes(n.start);
              c.isEqual(n.start) || n.end.offset--;
              var d = this.mergeAttributes(n.end);
              return new i.Z(c, d);
            }
          }, {
            key: "rename",
            value: function rename(e, t) {
              var s = new n.Z(this.document, e, t.getAttributes());
              return this.insert(o.Z._createAfter(t), s), this.move(i.Z._createIn(t), o.Z._createAt(s, 0)), this.remove(i.Z._createOn(t)), s;
            }
          }, {
            key: "clearClonedElementsGroup",
            value: function clearClonedElementsGroup(e) {
              this._cloneGroups.delete(e);
            }
          }, {
            key: "createPositionAt",
            value: function createPositionAt(e, t) {
              return o.Z._createAt(e, t);
            }
          }, {
            key: "createPositionAfter",
            value: function createPositionAfter(e) {
              return o.Z._createAfter(e);
            }
          }, {
            key: "createPositionBefore",
            value: function createPositionBefore(e) {
              return o.Z._createBefore(e);
            }
          }, {
            key: "createRange",
            value: function createRange(e, t) {
              return new i.Z(e, t);
            }
          }, {
            key: "createRangeOn",
            value: function createRangeOn(e) {
              return i.Z._createOn(e);
            }
          }, {
            key: "createRangeIn",
            value: function createRangeIn(e) {
              return i.Z._createIn(e);
            }
          }, {
            key: "createSelection",
            value: function createSelection(e, t, s) {
              return new r.Z(e, t, s);
            }
          }, {
            key: "createSlot",
            value: function createSlot(e) {
              if (!this._slotFactory) throw new l.ZP("view-writer-invalid-create-slot-context", this.document);
              return this._slotFactory(this, e);
            }
          }, {
            key: "_registerSlotFactory",
            value: function _registerSlotFactory(e) {
              this._slotFactory = e;
            }
          }, {
            key: "_clearSlotFactory",
            value: function _clearSlotFactory() {
              this._slotFactory = null;
            }
          }, {
            key: "_insertNodes",
            value: function _insertNodes(e, t, s) {
              var o, r;
              if (o = s ? y(e) : e.parent.is("$text") ? e.parent.parent : e.parent, !o) throw new l.ZP("view-writer-invalid-position-container", this.document);
              r = s ? this._breakAttributes(e, !0) : e.parent.is("$text") ? j(e) : e;
              var n = o._insertChild(r.offset, t);
              var _iterator208 = _createForOfIteratorHelper(t),
                _step208;
              try {
                for (_iterator208.s(); !(_step208 = _iterator208.n()).done;) {
                  var _e156 = _step208.value;
                  this._addToClonedElementsGroup(_e156);
                }
              } catch (err) {
                _iterator208.e(err);
              } finally {
                _iterator208.f();
              }
              var a = r.getShiftedBy(n),
                c = this.mergeAttributes(r);
              c.isEqual(r) || a.offset--;
              var d = this.mergeAttributes(a);
              return new i.Z(c, d);
            }
          }, {
            key: "_wrapChildren",
            value: function _wrapChildren(e, t, s, r) {
              var n = t;
              var a = [];
              for (; n < s;) {
                var _t139 = e.getChild(n),
                  _s143 = _t139.is("$text"),
                  _i76 = _t139.is("attributeElement"),
                  _c7 = _t139.isAllowedInsideAttributeElement;
                if (_i76 && this._wrapAttributeElement(r, _t139)) a.push(new o.Z(e, n));else if (_s143 || _c7 || _i76 && Z(r, _t139)) {
                  var _s144 = r._clone();
                  _t139._remove(), _s144._appendChild(_t139), e._insertChild(n, _s144), this._addToClonedElementsGroup(_s144), a.push(new o.Z(e, n));
                } else _i76 && this._wrapChildren(_t139, 0, _t139.childCount, r);
                n++;
              }
              var c = 0;
              for (var _i77 = 0, _a8 = a; _i77 < _a8.length; _i77++) {
                var _e157 = _a8[_i77];
                if (_e157.offset -= c, _e157.offset == t) continue;
                this.mergeAttributes(_e157).isEqual(_e157) || (c++, s--);
              }
              return i.Z._createFromParentsAndOffsets(e, t, e, s);
            }
          }, {
            key: "_unwrapChildren",
            value: function _unwrapChildren(e, t, s, r) {
              var n = t;
              var a = [];
              for (; n < s;) {
                var _t140 = e.getChild(n);
                if (_t140.is("attributeElement")) {
                  if (_t140.isSimilar(r)) {
                    var _i78 = _t140.getChildren(),
                      _r41 = _t140.childCount;
                    _t140._remove(), e._insertChild(n, _i78), this._removeFromClonedElementsGroup(_t140), a.push(new o.Z(e, n), new o.Z(e, n + _r41)), n += _r41, s += _r41 - 1;
                  } else this._unwrapAttributeElement(r, _t140) ? (a.push(new o.Z(e, n), new o.Z(e, n + 1)), n++) : (this._unwrapChildren(_t140, 0, _t140.childCount, r), n++);
                } else n++;
              }
              var c = 0;
              for (var _i79 = 0, _a9 = a; _i79 < _a9.length; _i79++) {
                var _e158 = _a9[_i79];
                if (_e158.offset -= c, _e158.offset == t || _e158.offset == s) continue;
                this.mergeAttributes(_e158).isEqual(_e158) || (c++, s--);
              }
              return i.Z._createFromParentsAndOffsets(e, t, e, s);
            }
          }, {
            key: "_wrapRange",
            value: function _wrapRange(e, t) {
              var _this$_breakAttribute3 = this._breakAttributesRange(e, !0),
                s = _this$_breakAttribute3.start,
                o = _this$_breakAttribute3.end,
                r = s.parent,
                n = this._wrapChildren(r, s.offset, o.offset, t),
                a = this.mergeAttributes(n.start);
              a.isEqual(n.start) || n.end.offset--;
              var c = this.mergeAttributes(n.end);
              return new i.Z(a, c);
            }
          }, {
            key: "_wrapPosition",
            value: function _wrapPosition(e, t) {
              if (t.isSimilar(e.parent)) return P(e.clone());
              e.parent.is("$text") && (e = j(e));
              var s = this.createAttributeElement();
              s._priority = Number.POSITIVE_INFINITY, s.isSimilar = function () {
                return !1;
              }, e.parent._insertChild(e.offset, s);
              var r = new i.Z(e, e.getShiftedBy(1));
              this.wrap(r, t);
              var n = new o.Z(s.parent, s.index);
              s._remove();
              var a = n.nodeBefore,
                c = n.nodeAfter;
              return a instanceof _.Z && c instanceof _.Z ? x(a, c) : P(n);
            }
          }, {
            key: "_wrapAttributeElement",
            value: function _wrapAttributeElement(e, t) {
              if (!S(e, t)) return !1;
              if (e.name !== t.name || e.priority !== t.priority) return !1;
              var _iterator209 = _createForOfIteratorHelper(e.getAttributeKeys()),
                _step209;
              try {
                for (_iterator209.s(); !(_step209 = _iterator209.n()).done;) {
                  var _s145 = _step209.value;
                  if ("class" !== _s145 && "style" !== _s145 && t.hasAttribute(_s145) && t.getAttribute(_s145) !== e.getAttribute(_s145)) return !1;
                }
              } catch (err) {
                _iterator209.e(err);
              } finally {
                _iterator209.f();
              }
              var _iterator210 = _createForOfIteratorHelper(e.getStyleNames()),
                _step210;
              try {
                for (_iterator210.s(); !(_step210 = _iterator210.n()).done;) {
                  var _s146 = _step210.value;
                  if (t.hasStyle(_s146) && t.getStyle(_s146) !== e.getStyle(_s146)) return !1;
                }
              } catch (err) {
                _iterator210.e(err);
              } finally {
                _iterator210.f();
              }
              var _iterator211 = _createForOfIteratorHelper(e.getAttributeKeys()),
                _step211;
              try {
                for (_iterator211.s(); !(_step211 = _iterator211.n()).done;) {
                  var _s147 = _step211.value;
                  "class" !== _s147 && "style" !== _s147 && (t.hasAttribute(_s147) || this.setAttribute(_s147, e.getAttribute(_s147), t));
                }
              } catch (err) {
                _iterator211.e(err);
              } finally {
                _iterator211.f();
              }
              var _iterator212 = _createForOfIteratorHelper(e.getStyleNames()),
                _step212;
              try {
                for (_iterator212.s(); !(_step212 = _iterator212.n()).done;) {
                  var _s148 = _step212.value;
                  t.hasStyle(_s148) || this.setStyle(_s148, e.getStyle(_s148), t);
                }
              } catch (err) {
                _iterator212.e(err);
              } finally {
                _iterator212.f();
              }
              var _iterator213 = _createForOfIteratorHelper(e.getClassNames()),
                _step213;
              try {
                for (_iterator213.s(); !(_step213 = _iterator213.n()).done;) {
                  var _s149 = _step213.value;
                  t.hasClass(_s149) || this.addClass(_s149, t);
                }
              } catch (err) {
                _iterator213.e(err);
              } finally {
                _iterator213.f();
              }
              return !0;
            }
          }, {
            key: "_unwrapAttributeElement",
            value: function _unwrapAttributeElement(e, t) {
              if (!S(e, t)) return !1;
              if (e.name !== t.name || e.priority !== t.priority) return !1;
              var _iterator214 = _createForOfIteratorHelper(e.getAttributeKeys()),
                _step214;
              try {
                for (_iterator214.s(); !(_step214 = _iterator214.n()).done;) {
                  var _s150 = _step214.value;
                  if ("class" !== _s150 && "style" !== _s150 && (!t.hasAttribute(_s150) || t.getAttribute(_s150) !== e.getAttribute(_s150))) return !1;
                }
              } catch (err) {
                _iterator214.e(err);
              } finally {
                _iterator214.f();
              }
              if (!t.hasClass.apply(t, _toConsumableArray(e.getClassNames()))) return !1;
              var _iterator215 = _createForOfIteratorHelper(e.getStyleNames()),
                _step215;
              try {
                for (_iterator215.s(); !(_step215 = _iterator215.n()).done;) {
                  var _s151 = _step215.value;
                  if (!t.hasStyle(_s151) || t.getStyle(_s151) !== e.getStyle(_s151)) return !1;
                }
              } catch (err) {
                _iterator215.e(err);
              } finally {
                _iterator215.f();
              }
              var _iterator216 = _createForOfIteratorHelper(e.getAttributeKeys()),
                _step216;
              try {
                for (_iterator216.s(); !(_step216 = _iterator216.n()).done;) {
                  var _s152 = _step216.value;
                  "class" !== _s152 && "style" !== _s152 && this.removeAttribute(_s152, t);
                }
              } catch (err) {
                _iterator216.e(err);
              } finally {
                _iterator216.f();
              }
              return this.removeClass(Array.from(e.getClassNames()), t), this.removeStyle(Array.from(e.getStyleNames()), t), !0;
            }
          }, {
            key: "_breakAttributesRange",
            value: function _breakAttributesRange(e) {
              var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
              var s = e.start,
                o = e.end;
              if (E(e, this.document), e.isCollapsed) {
                var _s153 = this._breakAttributes(e.start, t);
                return new i.Z(_s153, _s153);
              }
              var r = this._breakAttributes(o, t),
                n = r.parent.childCount,
                a = this._breakAttributes(s, t);
              return r.offset += r.parent.childCount - n, new i.Z(a, r);
            }
          }, {
            key: "_breakAttributes",
            value: function _breakAttributes(e) {
              var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
              var s = e.offset,
                i = e.parent;
              if (e.parent.is("emptyElement")) throw new l.ZP("view-writer-cannot-break-empty-element", this.document);
              if (e.parent.is("uiElement")) throw new l.ZP("view-writer-cannot-break-ui-element", this.document);
              if (e.parent.is("rawElement")) throw new l.ZP("view-writer-cannot-break-raw-element", this.document);
              if (!t && i.is("$text") && C(i.parent)) return e.clone();
              if (C(i)) return e.clone();
              if (i.is("$text")) return this._breakAttributes(j(e), t);
              if (s == i.childCount) {
                var _e159 = new o.Z(i.parent, i.index + 1);
                return this._breakAttributes(_e159, t);
              }
              if (0 === s) {
                var _e160 = new o.Z(i.parent, i.index);
                return this._breakAttributes(_e160, t);
              }
              {
                var _e161 = i.index + 1,
                  _r42 = i._clone();
                i.parent._insertChild(_e161, _r42), this._addToClonedElementsGroup(_r42);
                var _n19 = i.childCount - s,
                  _a10 = i._removeChildren(s, _n19);
                _r42._appendChild(_a10);
                var _c8 = new o.Z(i.parent, _e161);
                return this._breakAttributes(_c8, t);
              }
            }
          }, {
            key: "_addToClonedElementsGroup",
            value: function _addToClonedElementsGroup(e) {
              if (!e.root.is("rootElement")) return;
              if (e.is("element")) {
                var _iterator217 = _createForOfIteratorHelper(e.getChildren()),
                  _step217;
                try {
                  for (_iterator217.s(); !(_step217 = _iterator217.n()).done;) {
                    var _t141 = _step217.value;
                    this._addToClonedElementsGroup(_t141);
                  }
                } catch (err) {
                  _iterator217.e(err);
                } finally {
                  _iterator217.f();
                }
              }
              var t = e.id;
              if (!t) return;
              var s = this._cloneGroups.get(t);
              s || (s = new Set(), this._cloneGroups.set(t, s)), s.add(e), e._clonesGroup = s;
            }
          }, {
            key: "_removeFromClonedElementsGroup",
            value: function _removeFromClonedElementsGroup(e) {
              if (e.is("element")) {
                var _iterator218 = _createForOfIteratorHelper(e.getChildren()),
                  _step218;
                try {
                  for (_iterator218.s(); !(_step218 = _iterator218.n()).done;) {
                    var _t142 = _step218.value;
                    this._removeFromClonedElementsGroup(_t142);
                  }
                } catch (err) {
                  _iterator218.e(err);
                } finally {
                  _iterator218.f();
                }
              }
              var t = e.id;
              if (!t) return;
              var s = this._cloneGroups.get(t);
              s && s.delete(e);
            }
          }]);
          return v;
        }();
        function y(e) {
          var t = e.parent;
          for (; !C(t);) {
            if (!t) return;
            t = t.parent;
          }
          return t;
        }
        function Z(e, t) {
          return e.priority < t.priority || !(e.priority > t.priority) && e.getIdentity() < t.getIdentity();
        }
        function P(e) {
          var t = e.nodeBefore;
          if (t && t.is("$text")) return new o.Z(t, t.data.length);
          var s = e.nodeAfter;
          return s && s.is("$text") ? new o.Z(s, 0) : e;
        }
        function j(e) {
          if (e.offset == e.parent.data.length) return new o.Z(e.parent.parent, e.parent.index + 1);
          if (0 === e.offset) return new o.Z(e.parent.parent, e.parent.index);
          var t = e.parent.data.slice(e.offset);
          return e.parent._data = e.parent.data.slice(0, e.offset), e.parent.parent._insertChild(e.parent.index + 1, new _.Z(e.root.document, t)), new o.Z(e.parent.parent, e.parent.index + 1);
        }
        function x(e, t) {
          var s = e.data.length;
          return e._data += t.data, t._remove(), new o.Z(e, s);
        }
        function A(e, t) {
          var _iterator219 = _createForOfIteratorHelper(e),
            _step219;
          try {
            var _loop3 = function _loop3() {
              var s = _step219.value;
              if (!T.some(function (e) {
                return s instanceof e;
              })) throw new l.ZP("view-writer-insert-invalid-node-type", t);
              s.is("$text") || A(s.getChildren(), t);
            };
            for (_iterator219.s(); !(_step219 = _iterator219.n()).done;) {
              _loop3();
            }
          } catch (err) {
            _iterator219.e(err);
          } finally {
            _iterator219.f();
          }
        }
        var T = [_.Z, a.Z, n.Z, h, p, g.Z];
        function C(e) {
          return e && (e.is("containerElement") || e.is("documentFragment"));
        }
        function E(e, t) {
          var s = y(e.start),
            o = y(e.end);
          if (!s || !o || s !== o) throw new l.ZP("view-writer-invalid-range-container", t);
        }
        function S(e, t) {
          return null === e.id && null === t.id;
        }
      },
      "./packages/ckeditor5-engine/src/view/editableelement.js": function _packages_ckeditor5Engine_src_view_editableelementJs(e, t, s) {
        "use strict";

        s.d(t, {
          Z: function Z() {
            return n;
          }
        });
        var o = s("./packages/ckeditor5-engine/src/view/containerelement.js"),
          i = s("./packages/ckeditor5-utils/src/mix.js"),
          r = s("./packages/ckeditor5-utils/src/observablemixin.js");
        var n = /*#__PURE__*/function (_o$Z17) {
          _inherits(n, _o$Z17);
          function n(e, t, s, o) {
            var _this58;
            _classCallCheck(this, n);
            _this58 = _possibleConstructorReturn(this, _getPrototypeOf(n).call(this, e, t, s, o)), _this58.set("isReadOnly", !1), _this58.set("isFocused", !1), _this58.bind("isReadOnly").to(e), _this58.bind("isFocused").to(e, "isFocused", function (t) {
              return t && e.selection.editableElement == _assertThisInitialized(_assertThisInitialized(_this58));
            }), _this58.listenTo(e.selection, "change", function () {
              _this58.isFocused = e.isFocused && e.selection.editableElement == _assertThisInitialized(_assertThisInitialized(_this58));
            });
            return _this58;
          }
          _createClass(n, [{
            key: "is",
            value: function is(e) {
              var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
              return t ? t === this.name && ("editableElement" === e || "view:editableElement" === e || "containerElement" === e || "view:containerElement" === e || "element" === e || "view:element" === e) : "editableElement" === e || "view:editableElement" === e || "containerElement" === e || "view:containerElement" === e || "element" === e || "view:element" === e || "node" === e || "view:node" === e;
            }
          }, {
            key: "destroy",
            value: function destroy() {
              this.stopListening();
            }
          }]);
          return n;
        }(o.Z);
        (0, i.Z)(n, r.Z);
      },
      "./packages/ckeditor5-engine/src/view/element.js": function _packages_ckeditor5Engine_src_view_elementJs(e, t, s) {
        "use strict";

        s.d(t, {
          Z: function Z() {
            return h;
          }
        });
        var o = s("./packages/ckeditor5-engine/src/view/node.js"),
          i = s("./packages/ckeditor5-engine/src/view/text.js"),
          r = s("./packages/ckeditor5-engine/src/view/textproxy.js"),
          n = s("./packages/ckeditor5-utils/src/tomap.js"),
          a = s("./packages/ckeditor5-utils/src/toarray.js"),
          c = s("./packages/ckeditor5-utils/src/isiterable.js"),
          l = s("./packages/ckeditor5-engine/src/view/matcher.js"),
          d = s("./packages/ckeditor5-engine/src/view/stylesmap.js");
        var h = /*#__PURE__*/function (_o$Z18) {
          _inherits(h, _o$Z18);
          function h(e, t, s, o) {
            var _this59;
            _classCallCheck(this, h);
            if (_this59 = _possibleConstructorReturn(this, _getPrototypeOf(h).call(this, e)), _this59.name = t, _this59._attrs = function (e) {
              e = (0, n.Z)(e);
              var _iterator220 = _createForOfIteratorHelper(e),
                _step220;
              try {
                for (_iterator220.s(); !(_step220 = _iterator220.n()).done;) {
                  var _step220$value = _slicedToArray(_step220.value, 2),
                    _t143 = _step220$value[0],
                    _s154 = _step220$value[1];
                  null === _s154 ? e.delete(_t143) : "string" != typeof _s154 && e.set(_t143, String(_s154));
                }
              } catch (err) {
                _iterator220.e(err);
              } finally {
                _iterator220.f();
              }
              return e;
            }(s), _this59._children = [], o && _this59._insertChild(0, o), _this59._classes = new Set(), _this59._attrs.has("class")) {
              var _e162 = _this59._attrs.get("class");
              u(_this59._classes, _e162), _this59._attrs.delete("class");
            }
            _this59._styles = new d.Z(_this59.document.stylesProcessor), _this59._attrs.has("style") && (_this59._styles.setTo(_this59._attrs.get("style")), _this59._attrs.delete("style")), _this59._customProperties = new Map(), _this59._isAllowedInsideAttributeElement = !1, _this59._unsafeAttributesToRender = [];
            return _possibleConstructorReturn(_this59);
          }
          _createClass(h, [{
            key: "is",
            value: function is(e) {
              var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
              return t ? t === this.name && ("element" === e || "view:element" === e) : "element" === e || "view:element" === e || "node" === e || "view:node" === e;
            }
          }, {
            key: "getChild",
            value: function getChild(e) {
              return this._children[e];
            }
          }, {
            key: "getChildIndex",
            value: function getChildIndex(e) {
              return this._children.indexOf(e);
            }
          }, {
            key: "getChildren",
            value: function getChildren() {
              return this._children[Symbol.iterator]();
            }
          }, {
            key: "getAttributeKeys",
            value: /*#__PURE__*/_regeneratorRuntime().mark(function getAttributeKeys() {
              return _regeneratorRuntime().wrap(function getAttributeKeys$(_context23) {
                while (1) switch (_context23.prev = _context23.next) {
                  case 0:
                    _context23.t0 = this._classes.size > 0;
                    if (!_context23.t0) {
                      _context23.next = 4;
                      break;
                    }
                    _context23.next = 4;
                    return "class";
                  case 4:
                    _context23.t1 = this._styles.isEmpty;
                    if (_context23.t1) {
                      _context23.next = 8;
                      break;
                    }
                    _context23.next = 8;
                    return "style";
                  case 8:
                    return _context23.delegateYield(this._attrs.keys(), "t2", 9);
                  case 9:
                  case "end":
                    return _context23.stop();
                }
              }, getAttributeKeys, this);
            })
          }, {
            key: "getAttributes",
            value: /*#__PURE__*/_regeneratorRuntime().mark(function getAttributes() {
              return _regeneratorRuntime().wrap(function getAttributes$(_context24) {
                while (1) switch (_context24.prev = _context24.next) {
                  case 0:
                    return _context24.delegateYield(this._attrs.entries(), "t0", 1);
                  case 1:
                    _context24.t1 = this._classes.size > 0;
                    if (!_context24.t1) {
                      _context24.next = 5;
                      break;
                    }
                    _context24.next = 5;
                    return ["class", this.getAttribute("class")];
                  case 5:
                    _context24.t2 = this._styles.isEmpty;
                    if (_context24.t2) {
                      _context24.next = 9;
                      break;
                    }
                    _context24.next = 9;
                    return ["style", this.getAttribute("style")];
                  case 9:
                  case "end":
                    return _context24.stop();
                }
              }, getAttributes, this);
            })
          }, {
            key: "getAttribute",
            value: function getAttribute(e) {
              if ("class" == e) return this._classes.size > 0 ? _toConsumableArray(this._classes).join(" ") : void 0;
              if ("style" == e) {
                var _e163 = this._styles.toString();
                return "" == _e163 ? void 0 : _e163;
              }
              return this._attrs.get(e);
            }
          }, {
            key: "hasAttribute",
            value: function hasAttribute(e) {
              return "class" == e ? this._classes.size > 0 : "style" == e ? !this._styles.isEmpty : this._attrs.has(e);
            }
          }, {
            key: "isSimilar",
            value: function isSimilar(e) {
              if (!(e instanceof h)) return !1;
              if (this === e) return !0;
              if (this.name != e.name) return !1;
              if (this.isAllowedInsideAttributeElement != e.isAllowedInsideAttributeElement) return !1;
              if (this._attrs.size !== e._attrs.size || this._classes.size !== e._classes.size || this._styles.size !== e._styles.size) return !1;
              var _iterator221 = _createForOfIteratorHelper(this._attrs),
                _step221;
              try {
                for (_iterator221.s(); !(_step221 = _iterator221.n()).done;) {
                  var _step221$value = _slicedToArray(_step221.value, 2),
                    _t144 = _step221$value[0],
                    _s155 = _step221$value[1];
                  if (!e._attrs.has(_t144) || e._attrs.get(_t144) !== _s155) return !1;
                }
              } catch (err) {
                _iterator221.e(err);
              } finally {
                _iterator221.f();
              }
              var _iterator222 = _createForOfIteratorHelper(this._classes),
                _step222;
              try {
                for (_iterator222.s(); !(_step222 = _iterator222.n()).done;) {
                  var _t145 = _step222.value;
                  if (!e._classes.has(_t145)) return !1;
                }
              } catch (err) {
                _iterator222.e(err);
              } finally {
                _iterator222.f();
              }
              var _iterator223 = _createForOfIteratorHelper(this._styles.getStyleNames()),
                _step223;
              try {
                for (_iterator223.s(); !(_step223 = _iterator223.n()).done;) {
                  var _t146 = _step223.value;
                  if (!e._styles.has(_t146) || e._styles.getAsString(_t146) !== this._styles.getAsString(_t146)) return !1;
                }
              } catch (err) {
                _iterator223.e(err);
              } finally {
                _iterator223.f();
              }
              return !0;
            }
          }, {
            key: "hasClass",
            value: function hasClass() {
              for (var _len3 = arguments.length, e = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
                e[_key3] = arguments[_key3];
              }
              for (var _i80 = 0, _e164 = e; _i80 < _e164.length; _i80++) {
                var _t147 = _e164[_i80];
                if (!this._classes.has(_t147)) return !1;
              }
              return !0;
            }
          }, {
            key: "getClassNames",
            value: function getClassNames() {
              return this._classes.keys();
            }
          }, {
            key: "getStyle",
            value: function getStyle(e) {
              return this._styles.getAsString(e);
            }
          }, {
            key: "getNormalizedStyle",
            value: function getNormalizedStyle(e) {
              return this._styles.getNormalized(e);
            }
          }, {
            key: "getStyleNames",
            value: function getStyleNames() {
              var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !1;
              return this._styles.getStyleNames(e);
            }
          }, {
            key: "hasStyle",
            value: function hasStyle() {
              for (var _len4 = arguments.length, e = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
                e[_key4] = arguments[_key4];
              }
              for (var _i81 = 0, _e165 = e; _i81 < _e165.length; _i81++) {
                var _t148 = _e165[_i81];
                if (!this._styles.has(_t148)) return !1;
              }
              return !0;
            }
          }, {
            key: "findAncestor",
            value: function findAncestor() {
              for (var _len5 = arguments.length, e = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
                e[_key5] = arguments[_key5];
              }
              var t = _construct(l.Z, e);
              var s = this.parent;
              for (; s;) {
                if (t.match(s)) return s;
                s = s.parent;
              }
              return null;
            }
          }, {
            key: "getCustomProperty",
            value: function getCustomProperty(e) {
              return this._customProperties.get(e);
            }
          }, {
            key: "getCustomProperties",
            value: /*#__PURE__*/_regeneratorRuntime().mark(function getCustomProperties() {
              return _regeneratorRuntime().wrap(function getCustomProperties$(_context25) {
                while (1) switch (_context25.prev = _context25.next) {
                  case 0:
                    return _context25.delegateYield(this._customProperties.entries(), "t0", 1);
                  case 1:
                  case "end":
                    return _context25.stop();
                }
              }, getCustomProperties, this);
            })
          }, {
            key: "getIdentity",
            value: function getIdentity() {
              var e = Array.from(this._classes).sort().join(","),
                t = this._styles.toString(),
                s = Array.from(this._attrs).map(function (e) {
                  return "".concat(e[0], "=\"").concat(e[1], "\"");
                }).sort().join(" ");
              return this.name + ("" == e ? "" : " class=\"".concat(e, "\"")) + (t ? " style=\"".concat(t, "\"") : "") + ("" == s ? "" : " ".concat(s));
            }
          }, {
            key: "shouldRenderUnsafeAttribute",
            value: function shouldRenderUnsafeAttribute(e) {
              return this._unsafeAttributesToRender.includes(e);
            }
          }, {
            key: "_clone",
            value: function _clone() {
              var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !1;
              var t = [];
              if (e) {
                var _iterator224 = _createForOfIteratorHelper(this.getChildren()),
                  _step224;
                try {
                  for (_iterator224.s(); !(_step224 = _iterator224.n()).done;) {
                    var _s156 = _step224.value;
                    t.push(_s156._clone(e));
                  }
                } catch (err) {
                  _iterator224.e(err);
                } finally {
                  _iterator224.f();
                }
              }
              var s = new this.constructor(this.document, this.name, this._attrs, t);
              return s._classes = new Set(this._classes), s._styles.set(this._styles.getNormalized()), s._customProperties = new Map(this._customProperties), s.getFillerOffset = this.getFillerOffset, s._isAllowedInsideAttributeElement = this.isAllowedInsideAttributeElement, s;
            }
          }, {
            key: "_appendChild",
            value: function _appendChild(e) {
              return this._insertChild(this.childCount, e);
            }
          }, {
            key: "_insertChild",
            value: function _insertChild(e, t) {
              this._fireChange("children", this);
              var s = 0;
              var o = function (e, t) {
                if ("string" == typeof t) return [new i.Z(e, t)];
                (0, c.Z)(t) || (t = [t]);
                return Array.from(t).map(function (t) {
                  return "string" == typeof t ? new i.Z(e, t) : t instanceof r.Z ? new i.Z(e, t.data) : t;
                });
              }(this.document, t);
              var _iterator225 = _createForOfIteratorHelper(o),
                _step225;
              try {
                for (_iterator225.s(); !(_step225 = _iterator225.n()).done;) {
                  var _t149 = _step225.value;
                  null !== _t149.parent && _t149._remove(), _t149.parent = this, _t149.document = this.document, this._children.splice(e, 0, _t149), e++, s++;
                }
              } catch (err) {
                _iterator225.e(err);
              } finally {
                _iterator225.f();
              }
              return s;
            }
          }, {
            key: "_removeChildren",
            value: function _removeChildren(e) {
              var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
              this._fireChange("children", this);
              for (var _s157 = e; _s157 < e + t; _s157++) this._children[_s157].parent = null;
              return this._children.splice(e, t);
            }
          }, {
            key: "_setAttribute",
            value: function _setAttribute(e, t) {
              t = String(t), this._fireChange("attributes", this), "class" == e ? u(this._classes, t) : "style" == e ? this._styles.setTo(t) : this._attrs.set(e, t);
            }
          }, {
            key: "_removeAttribute",
            value: function _removeAttribute(e) {
              return this._fireChange("attributes", this), "class" == e ? this._classes.size > 0 && (this._classes.clear(), !0) : "style" == e ? !this._styles.isEmpty && (this._styles.clear(), !0) : this._attrs.delete(e);
            }
          }, {
            key: "_addClass",
            value: function _addClass(e) {
              this._fireChange("attributes", this);
              var _iterator226 = _createForOfIteratorHelper((0, a.Z)(e)),
                _step226;
              try {
                for (_iterator226.s(); !(_step226 = _iterator226.n()).done;) {
                  var _t150 = _step226.value;
                  this._classes.add(_t150);
                }
              } catch (err) {
                _iterator226.e(err);
              } finally {
                _iterator226.f();
              }
            }
          }, {
            key: "_removeClass",
            value: function _removeClass(e) {
              this._fireChange("attributes", this);
              var _iterator227 = _createForOfIteratorHelper((0, a.Z)(e)),
                _step227;
              try {
                for (_iterator227.s(); !(_step227 = _iterator227.n()).done;) {
                  var _t151 = _step227.value;
                  this._classes.delete(_t151);
                }
              } catch (err) {
                _iterator227.e(err);
              } finally {
                _iterator227.f();
              }
            }
          }, {
            key: "_setStyle",
            value: function _setStyle(e, t) {
              this._fireChange("attributes", this), this._styles.set(e, t);
            }
          }, {
            key: "_removeStyle",
            value: function _removeStyle(e) {
              this._fireChange("attributes", this);
              var _iterator228 = _createForOfIteratorHelper((0, a.Z)(e)),
                _step228;
              try {
                for (_iterator228.s(); !(_step228 = _iterator228.n()).done;) {
                  var _t152 = _step228.value;
                  this._styles.remove(_t152);
                }
              } catch (err) {
                _iterator228.e(err);
              } finally {
                _iterator228.f();
              }
            }
          }, {
            key: "_setCustomProperty",
            value: function _setCustomProperty(e, t) {
              this._customProperties.set(e, t);
            }
          }, {
            key: "_removeCustomProperty",
            value: function _removeCustomProperty(e) {
              return this._customProperties.delete(e);
            }
          }, {
            key: "childCount",
            get: function get() {
              return this._children.length;
            }
          }, {
            key: "isEmpty",
            get: function get() {
              return 0 === this._children.length;
            }
          }, {
            key: "isAllowedInsideAttributeElement",
            get: function get() {
              return this._isAllowedInsideAttributeElement;
            }
          }]);
          return h;
        }(o.Z);
        function u(e, t) {
          var s = t.split(/\s+/);
          e.clear(), s.forEach(function (t) {
            return e.add(t);
          });
        }
      },
      "./packages/ckeditor5-engine/src/view/filler.js": function _packages_ckeditor5Engine_src_view_fillerJs(e, t, s) {
        "use strict";

        s.d(t, {
          N3: function N3() {
            return r;
          },
          PQ: function PQ() {
            return n;
          },
          Pj: function Pj() {
            return l;
          },
          Qh: function Qh() {
            return h;
          },
          Sw: function Sw() {
            return d;
          },
          b_: function b_() {
            return c;
          },
          mm: function mm() {
            return g;
          },
          th: function th() {
            return u;
          },
          yl: function yl() {
            return a;
          }
        });
        var o = s("./packages/ckeditor5-utils/src/keyboard.js"),
          i = s("./packages/ckeditor5-utils/src/dom/istext.js");
        var r = function r(e) {
            return e.createTextNode(" ");
          },
          n = function n(e) {
            var t = e.createElement("span");
            return t.dataset.ckeFiller = !0, t.innerHTML = " ", t;
          },
          a = function a(e) {
            var t = e.createElement("br");
            return t.dataset.ckeFiller = !0, t;
          },
          c = 7,
          l = "⁠".repeat(c);
        function d(e) {
          return (0, i.Z)(e) && e.data.substr(0, c) === l;
        }
        function h(e) {
          return e.data.length == c && d(e);
        }
        function u(e) {
          return d(e) ? e.data.slice(c) : e.data;
        }
        function g(e) {
          e.document.on("arrowKey", p, {
            priority: "low"
          });
        }
        function p(e, t) {
          if (t.keyCode == o.Do.arrowleft) {
            var _e166 = t.domTarget.ownerDocument.defaultView.getSelection();
            if (1 == _e166.rangeCount && _e166.getRangeAt(0).collapsed) {
              var _t153 = _e166.getRangeAt(0).startContainer,
                _s158 = _e166.getRangeAt(0).startOffset;
              d(_t153) && _s158 <= c && _e166.collapse(_t153, 0);
            }
          }
        }
      },
      "./packages/ckeditor5-engine/src/view/matcher.js": function _packages_ckeditor5Engine_src_view_matcherJs(e, t, s) {
        "use strict";

        s.d(t, {
          Z: function Z() {
            return r;
          }
        });
        var o = s("./node_modules/lodash-es/isPlainObject.js"),
          i = s("./packages/ckeditor5-utils/src/ckeditorerror.js");
        var r = /*#__PURE__*/function () {
          function r() {
            _classCallCheck(this, r);
            this._patterns = [], this.add.apply(this, arguments);
          }
          _createClass(r, [{
            key: "add",
            value: function add() {
              for (var _len6 = arguments.length, e = new Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
                e[_key6] = arguments[_key6];
              }
              for (var _i82 = 0, _e167 = e; _i82 < _e167.length; _i82++) {
                var _t154 = _e167[_i82];
                ("string" == typeof _t154 || _t154 instanceof RegExp) && (_t154 = {
                  name: _t154
                }), this._patterns.push(_t154);
              }
            }
          }, {
            key: "match",
            value: function match() {
              for (var _len7 = arguments.length, e = new Array(_len7), _key7 = 0; _key7 < _len7; _key7++) {
                e[_key7] = arguments[_key7];
              }
              for (var _i83 = 0, _e168 = e; _i83 < _e168.length; _i83++) {
                var _t155 = _e168[_i83];
                var _iterator229 = _createForOfIteratorHelper(this._patterns),
                  _step229;
                try {
                  for (_iterator229.s(); !(_step229 = _iterator229.n()).done;) {
                    var _e169 = _step229.value;
                    var _s159 = n(_t155, _e169);
                    if (_s159) return {
                      element: _t155,
                      pattern: _e169,
                      match: _s159
                    };
                  }
                } catch (err) {
                  _iterator229.e(err);
                } finally {
                  _iterator229.f();
                }
              }
              return null;
            }
          }, {
            key: "matchAll",
            value: function matchAll() {
              var t = [];
              for (var _len8 = arguments.length, e = new Array(_len8), _key8 = 0; _key8 < _len8; _key8++) {
                e[_key8] = arguments[_key8];
              }
              for (var _i84 = 0, _e170 = e; _i84 < _e170.length; _i84++) {
                var _s160 = _e170[_i84];
                var _iterator230 = _createForOfIteratorHelper(this._patterns),
                  _step230;
                try {
                  for (_iterator230.s(); !(_step230 = _iterator230.n()).done;) {
                    var _e171 = _step230.value;
                    var _o101 = n(_s160, _e171);
                    _o101 && t.push({
                      element: _s160,
                      pattern: _e171,
                      match: _o101
                    });
                  }
                } catch (err) {
                  _iterator230.e(err);
                } finally {
                  _iterator230.f();
                }
              }
              return t.length > 0 ? t : null;
            }
          }, {
            key: "getElementName",
            value: function getElementName() {
              if (1 !== this._patterns.length) return null;
              var e = this._patterns[0],
                t = e.name;
              return "function" == typeof e || !t || t instanceof RegExp ? null : t;
            }
          }]);
          return r;
        }();
        function n(e, t) {
          if ("function" == typeof t) return t(e);
          var s = {};
          return t.name && (s.name = function (e, t) {
            if (e instanceof RegExp) return !!t.match(e);
            return e === t;
          }(t.name, e.name), !s.name) || t.attributes && (s.attributes = function (e, t) {
            var s = new Set(t.getAttributeKeys());
            (0, o.Z)(e) ? (void 0 !== e.style && (0, i.KE)("matcher-pattern-deprecated-attributes-style-key", e), void 0 !== e.class && (0, i.KE)("matcher-pattern-deprecated-attributes-class-key", e)) : (s.delete("style"), s.delete("class"));
            return a(e, s, function (e) {
              return t.getAttribute(e);
            });
          }(t.attributes, e), !s.attributes) ? null : !(t.classes && (s.classes = function (e, t) {
            return a(e, t.getClassNames());
          }(t.classes, e), !s.classes)) && !(t.styles && (s.styles = function (e, t) {
            return a(e, t.getStyleNames(!0), function (e) {
              return t.getStyle(e);
            });
          }(t.styles, e), !s.styles)) && s;
        }
        function a(e, t, s) {
          var r = function (e) {
              if (Array.isArray(e)) return e.map(function (e) {
                return (0, o.Z)(e) ? (void 0 !== e.key && void 0 !== e.value || (0, i.KE)("matcher-pattern-missing-key-or-value", e), [e.key, e.value]) : [e, !0];
              });
              if ((0, o.Z)(e)) return Object.entries(e);
              return [[e, !0]];
            }(e),
            n = Array.from(t),
            a = [];
          return r.forEach(function (_ref20) {
            var _ref21 = _slicedToArray(_ref20, 2),
              e = _ref21[0],
              t = _ref21[1];
            n.forEach(function (o) {
              (function (e, t) {
                return !0 === e || e === t || e instanceof RegExp && t.match(e);
              })(e, o) && function (e, t, s) {
                if (!0 === e) return !0;
                var o = s(t);
                return e === o || e instanceof RegExp && !!String(o).match(e);
              }(t, o, s) && a.push(o);
            });
          }), !r.length || a.length < r.length ? null : a;
        }
      },
      "./packages/ckeditor5-engine/src/view/node.js": function _packages_ckeditor5Engine_src_view_nodeJs(e, t, s) {
        "use strict";

        s.d(t, {
          Z: function Z() {
            return c;
          }
        });
        var o = s("./packages/ckeditor5-utils/src/ckeditorerror.js"),
          i = s("./packages/ckeditor5-utils/src/emittermixin.js"),
          r = s("./packages/ckeditor5-utils/src/mix.js"),
          n = s("./packages/ckeditor5-utils/src/comparearrays.js"),
          a = s("./node_modules/lodash-es/clone.js");
        s("./packages/ckeditor5-utils/src/version.js");
        var c = /*#__PURE__*/function () {
          function c(e) {
            _classCallCheck(this, c);
            this.document = e, this.parent = null;
          }
          _createClass(c, [{
            key: "isAttached",
            value: function isAttached() {
              return this.root.is("rootElement");
            }
          }, {
            key: "getPath",
            value: function getPath() {
              var e = [];
              var t = this;
              for (; t.parent;) e.unshift(t.index), t = t.parent;
              return e;
            }
          }, {
            key: "getAncestors",
            value: function getAncestors() {
              var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
                includeSelf: !1,
                parentFirst: !1
              };
              var t = [];
              var s = e.includeSelf ? this : this.parent;
              for (; s;) t[e.parentFirst ? "push" : "unshift"](s), s = s.parent;
              return t;
            }
          }, {
            key: "getCommonAncestor",
            value: function getCommonAncestor(e) {
              var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
              var s = this.getAncestors(t),
                o = e.getAncestors(t);
              var i = 0;
              for (; s[i] == o[i] && s[i];) i++;
              return 0 === i ? null : s[i - 1];
            }
          }, {
            key: "isBefore",
            value: function isBefore(e) {
              if (this == e) return !1;
              if (this.root !== e.root) return !1;
              var t = this.getPath(),
                s = e.getPath(),
                o = (0, n.Z)(t, s);
              switch (o) {
                case "prefix":
                  return !0;
                case "extension":
                  return !1;
                default:
                  return t[o] < s[o];
              }
            }
          }, {
            key: "isAfter",
            value: function isAfter(e) {
              return this != e && this.root === e.root && !this.isBefore(e);
            }
          }, {
            key: "_remove",
            value: function _remove() {
              this.parent._removeChildren(this.index);
            }
          }, {
            key: "_fireChange",
            value: function _fireChange(e, t) {
              this.fire("change:" + e, t), this.parent && this.parent._fireChange(e, t);
            }
          }, {
            key: "toJSON",
            value: function toJSON() {
              var e = (0, a.Z)(this);
              return delete e.parent, e;
            }
          }, {
            key: "is",
            value: function is(e) {
              return "node" === e || "view:node" === e;
            }
          }, {
            key: "index",
            get: function get() {
              var e;
              if (!this.parent) return null;
              if (-1 == (e = this.parent.getChildIndex(this))) throw new o.ZP("view-node-not-found-in-parent", this);
              return e;
            }
          }, {
            key: "nextSibling",
            get: function get() {
              var e = this.index;
              return null !== e && this.parent.getChild(e + 1) || null;
            }
          }, {
            key: "previousSibling",
            get: function get() {
              var e = this.index;
              return null !== e && this.parent.getChild(e - 1) || null;
            }
          }, {
            key: "root",
            get: function get() {
              var e = this;
              for (; e.parent;) e = e.parent;
              return e;
            }
          }]);
          return c;
        }();
        (0, r.Z)(c, i.ZP);
      },
      "./packages/ckeditor5-engine/src/view/observer/bubblingeventinfo.js": function _packages_ckeditor5Engine_src_view_observer_bubblingeventinfoJs(e, t, s) {
        "use strict";

        s.d(t, {
          Z: function Z() {
            return i;
          }
        });
        var o = s("./packages/ckeditor5-utils/src/eventinfo.js");
        var i = /*#__PURE__*/function (_o$Z19) {
          _inherits(i, _o$Z19);
          function i(e, t, s) {
            var _this60;
            _classCallCheck(this, i);
            _this60 = _possibleConstructorReturn(this, _getPrototypeOf(i).call(this, e, t)), _this60.startRange = s, _this60._eventPhase = "none", _this60._currentTarget = null;
            return _this60;
          }
          _createClass(i, [{
            key: "eventPhase",
            get: function get() {
              return this._eventPhase;
            }
          }, {
            key: "currentTarget",
            get: function get() {
              return this._currentTarget;
            }
          }]);
          return i;
        }(o.Z);
      },
      "./packages/ckeditor5-engine/src/view/observer/domeventdata.js": function _packages_ckeditor5Engine_src_view_observer_domeventdataJs(e, t, s) {
        "use strict";

        s.d(t, {
          Z: function Z() {
            return i;
          }
        });
        var o = s("./node_modules/lodash-es/assignIn.js");
        var i = /*#__PURE__*/function () {
          function i(e, t, s) {
            _classCallCheck(this, i);
            this.view = e, this.document = e.document, this.domEvent = t, this.domTarget = t.target, (0, o.Z)(this, s);
          }
          _createClass(i, [{
            key: "preventDefault",
            value: function preventDefault() {
              this.domEvent.preventDefault();
            }
          }, {
            key: "stopPropagation",
            value: function stopPropagation() {
              this.domEvent.stopPropagation();
            }
          }, {
            key: "target",
            get: function get() {
              return this.view.domConverter.mapDomToView(this.domTarget);
            }
          }]);
          return i;
        }();
      },
      "./packages/ckeditor5-engine/src/view/observer/domeventobserver.js": function _packages_ckeditor5Engine_src_view_observer_domeventobserverJs(e, t, s) {
        "use strict";

        s.d(t, {
          Z: function Z() {
            return r;
          }
        });
        var o = s("./packages/ckeditor5-engine/src/view/observer/observer.js"),
          i = s("./packages/ckeditor5-engine/src/view/observer/domeventdata.js");
        var r = /*#__PURE__*/function (_o$Z20) {
          _inherits(r, _o$Z20);
          function r(e) {
            var _this61;
            _classCallCheck(this, r);
            _this61 = _possibleConstructorReturn(this, _getPrototypeOf(r).call(this, e)), _this61.useCapture = !1;
            return _this61;
          }
          _createClass(r, [{
            key: "observe",
            value: function observe(e) {
              var _this62 = this;
              ("string" == typeof this.domEventType ? [this.domEventType] : this.domEventType).forEach(function (t) {
                _this62.listenTo(e, t, function (e, t) {
                  _this62.isEnabled && !_this62.checkShouldIgnoreEventFromTarget(t.target) && _this62.onDomEvent(t);
                }, {
                  useCapture: _this62.useCapture
                });
              });
            }
          }, {
            key: "fire",
            value: function fire(e, t, s) {
              this.isEnabled && this.document.fire(e, new i.Z(this.view, t, s));
            }
          }]);
          return r;
        }(o.Z);
      },
      "./packages/ckeditor5-engine/src/view/observer/mouseobserver.js": function _packages_ckeditor5Engine_src_view_observer_mouseobserverJs(e, t, s) {
        "use strict";

        s.d(t, {
          Z: function Z() {
            return i;
          }
        });
        var o = s("./packages/ckeditor5-engine/src/view/observer/domeventobserver.js");
        var i = /*#__PURE__*/function (_o$Z21) {
          _inherits(i, _o$Z21);
          function i(e) {
            var _this63;
            _classCallCheck(this, i);
            _this63 = _possibleConstructorReturn(this, _getPrototypeOf(i).call(this, e)), _this63.domEventType = ["mousedown", "mouseup", "mouseover", "mouseout"];
            return _this63;
          }
          _createClass(i, [{
            key: "onDomEvent",
            value: function onDomEvent(e) {
              this.fire(e.type, e);
            }
          }]);
          return i;
        }(o.Z);
      },
      "./packages/ckeditor5-engine/src/view/observer/observer.js": function _packages_ckeditor5Engine_src_view_observer_observerJs(e, t, s) {
        "use strict";

        s.d(t, {
          Z: function Z() {
            return r;
          }
        });
        var o = s("./packages/ckeditor5-utils/src/dom/emittermixin.js"),
          i = s("./packages/ckeditor5-utils/src/mix.js");
        var r = /*#__PURE__*/function () {
          function r(e) {
            _classCallCheck(this, r);
            this.view = e, this.document = e.document, this.isEnabled = !1;
          }
          _createClass(r, [{
            key: "enable",
            value: function enable() {
              this.isEnabled = !0;
            }
          }, {
            key: "disable",
            value: function disable() {
              this.isEnabled = !1;
            }
          }, {
            key: "destroy",
            value: function destroy() {
              this.disable(), this.stopListening();
            }
          }, {
            key: "checkShouldIgnoreEventFromTarget",
            value: function checkShouldIgnoreEventFromTarget(e) {
              return e && 3 === e.nodeType && (e = e.parentNode), !(!e || 1 !== e.nodeType) && e.matches("[data-cke-ignore-events], [data-cke-ignore-events] *");
            }
          }]);
          return r;
        }();
        (0, i.Z)(r, o.Z);
      },
      "./packages/ckeditor5-engine/src/view/position.js": function _packages_ckeditor5Engine_src_view_positionJs(e, t, s) {
        "use strict";

        s.d(t, {
          Z: function Z() {
            return a;
          }
        });
        var o = s("./packages/ckeditor5-engine/src/view/treewalker.js"),
          i = s("./packages/ckeditor5-utils/src/comparearrays.js"),
          r = s("./packages/ckeditor5-utils/src/ckeditorerror.js"),
          n = s("./packages/ckeditor5-engine/src/view/editableelement.js");
        s("./packages/ckeditor5-utils/src/version.js");
        var a = /*#__PURE__*/function () {
          function a(e, t) {
            _classCallCheck(this, a);
            this.parent = e, this.offset = t;
          }
          _createClass(a, [{
            key: "getShiftedBy",
            value: function getShiftedBy(e) {
              var t = a._createAt(this),
                s = t.offset + e;
              return t.offset = s < 0 ? 0 : s, t;
            }
          }, {
            key: "getLastMatchingPosition",
            value: function getLastMatchingPosition(e) {
              var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
              t.startPosition = this;
              var s = new o.Z(t);
              return s.skip(e), s.position;
            }
          }, {
            key: "getAncestors",
            value: function getAncestors() {
              return this.parent.is("documentFragment") ? [this.parent] : this.parent.getAncestors({
                includeSelf: !0
              });
            }
          }, {
            key: "getCommonAncestor",
            value: function getCommonAncestor(e) {
              var t = this.getAncestors(),
                s = e.getAncestors();
              var o = 0;
              for (; t[o] == s[o] && t[o];) o++;
              return 0 === o ? null : t[o - 1];
            }
          }, {
            key: "is",
            value: function is(e) {
              return "position" === e || "view:position" === e;
            }
          }, {
            key: "isEqual",
            value: function isEqual(e) {
              return this.parent == e.parent && this.offset == e.offset;
            }
          }, {
            key: "isBefore",
            value: function isBefore(e) {
              return "before" == this.compareWith(e);
            }
          }, {
            key: "isAfter",
            value: function isAfter(e) {
              return "after" == this.compareWith(e);
            }
          }, {
            key: "compareWith",
            value: function compareWith(e) {
              if (this.root !== e.root) return "different";
              if (this.isEqual(e)) return "same";
              var t = this.parent.is("node") ? this.parent.getPath() : [],
                s = e.parent.is("node") ? e.parent.getPath() : [];
              t.push(this.offset), s.push(e.offset);
              var o = (0, i.Z)(t, s);
              switch (o) {
                case "prefix":
                  return "before";
                case "extension":
                  return "after";
                default:
                  return t[o] < s[o] ? "before" : "after";
              }
            }
          }, {
            key: "getWalker",
            value: function getWalker() {
              var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
              return e.startPosition = this, new o.Z(e);
            }
          }, {
            key: "clone",
            value: function clone() {
              return new a(this.parent, this.offset);
            }
          }, {
            key: "nodeAfter",
            get: function get() {
              return this.parent.is("$text") ? null : this.parent.getChild(this.offset) || null;
            }
          }, {
            key: "nodeBefore",
            get: function get() {
              return this.parent.is("$text") ? null : this.parent.getChild(this.offset - 1) || null;
            }
          }, {
            key: "isAtStart",
            get: function get() {
              return 0 === this.offset;
            }
          }, {
            key: "isAtEnd",
            get: function get() {
              var e = this.parent.is("$text") ? this.parent.data.length : this.parent.childCount;
              return this.offset === e;
            }
          }, {
            key: "root",
            get: function get() {
              return this.parent.root;
            }
          }, {
            key: "editableElement",
            get: function get() {
              var e = this.parent;
              for (; !(e instanceof n.Z);) {
                if (!e.parent) return null;
                e = e.parent;
              }
              return e;
            }
          }], [{
            key: "_createAt",
            value: function _createAt(e, t) {
              if (e instanceof a) return new this(e.parent, e.offset);
              {
                var _s161 = e;
                if ("end" == t) t = _s161.is("$text") ? _s161.data.length : _s161.childCount;else {
                  if ("before" == t) return this._createBefore(_s161);
                  if ("after" == t) return this._createAfter(_s161);
                  if (0 !== t && !t) throw new r.ZP("view-createpositionat-offset-required", _s161);
                }
                return new a(_s161, t);
              }
            }
          }, {
            key: "_createAfter",
            value: function _createAfter(e) {
              if (e.is("$textProxy")) return new a(e.textNode, e.offsetInText + e.data.length);
              if (!e.parent) throw new r.ZP("view-position-after-root", e, {
                root: e
              });
              return new a(e.parent, e.index + 1);
            }
          }, {
            key: "_createBefore",
            value: function _createBefore(e) {
              if (e.is("$textProxy")) return new a(e.textNode, e.offsetInText);
              if (!e.parent) throw new r.ZP("view-position-before-root", e, {
                root: e
              });
              return new a(e.parent, e.index);
            }
          }]);
          return a;
        }();
      },
      "./packages/ckeditor5-engine/src/view/range.js": function _packages_ckeditor5Engine_src_view_rangeJs(e, t, s) {
        "use strict";

        s.d(t, {
          Z: function Z() {
            return r;
          }
        });
        var o = s("./packages/ckeditor5-engine/src/view/position.js"),
          i = s("./packages/ckeditor5-engine/src/view/treewalker.js");
        var r = /*#__PURE__*/function () {
          function r(e) {
            var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
            _classCallCheck(this, r);
            this.start = e.clone(), this.end = t ? t.clone() : e.clone();
          }
          _createClass(r, [{
            key: Symbol.iterator,
            value: /*#__PURE__*/_regeneratorRuntime().mark(function value() {
              return _regeneratorRuntime().wrap(function value$(_context26) {
                while (1) switch (_context26.prev = _context26.next) {
                  case 0:
                    return _context26.delegateYield(new i.Z({
                      boundaries: this,
                      ignoreElementEnd: !0
                    }), "t0", 1);
                  case 1:
                  case "end":
                    return _context26.stop();
                }
              }, value, this);
            })
          }, {
            key: "getEnlarged",
            value: function getEnlarged() {
              var e = this.start.getLastMatchingPosition(n, {
                  direction: "backward"
                }),
                t = this.end.getLastMatchingPosition(n);
              return e.parent.is("$text") && e.isAtStart && (e = o.Z._createBefore(e.parent)), t.parent.is("$text") && t.isAtEnd && (t = o.Z._createAfter(t.parent)), new r(e, t);
            }
          }, {
            key: "getTrimmed",
            value: function getTrimmed() {
              var e = this.start.getLastMatchingPosition(n);
              if (e.isAfter(this.end) || e.isEqual(this.end)) return new r(e, e);
              var t = this.end.getLastMatchingPosition(n, {
                direction: "backward"
              });
              var s = e.nodeAfter,
                i = t.nodeBefore;
              return s && s.is("$text") && (e = new o.Z(s, 0)), i && i.is("$text") && (t = new o.Z(i, i.data.length)), new r(e, t);
            }
          }, {
            key: "isEqual",
            value: function isEqual(e) {
              return this == e || this.start.isEqual(e.start) && this.end.isEqual(e.end);
            }
          }, {
            key: "containsPosition",
            value: function containsPosition(e) {
              return e.isAfter(this.start) && e.isBefore(this.end);
            }
          }, {
            key: "containsRange",
            value: function containsRange(e) {
              var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
              e.isCollapsed && (t = !1);
              var s = this.containsPosition(e.start) || t && this.start.isEqual(e.start),
                o = this.containsPosition(e.end) || t && this.end.isEqual(e.end);
              return s && o;
            }
          }, {
            key: "getDifference",
            value: function getDifference(e) {
              var t = [];
              return this.isIntersecting(e) ? (this.containsPosition(e.start) && t.push(new r(this.start, e.start)), this.containsPosition(e.end) && t.push(new r(e.end, this.end))) : t.push(this.clone()), t;
            }
          }, {
            key: "getIntersection",
            value: function getIntersection(e) {
              if (this.isIntersecting(e)) {
                var _t156 = this.start,
                  _s162 = this.end;
                return this.containsPosition(e.start) && (_t156 = e.start), this.containsPosition(e.end) && (_s162 = e.end), new r(_t156, _s162);
              }
              return null;
            }
          }, {
            key: "getWalker",
            value: function getWalker() {
              var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
              return e.boundaries = this, new i.Z(e);
            }
          }, {
            key: "getCommonAncestor",
            value: function getCommonAncestor() {
              return this.start.getCommonAncestor(this.end);
            }
          }, {
            key: "getContainedElement",
            value: function getContainedElement() {
              if (this.isCollapsed) return null;
              var e = this.start.nodeAfter,
                t = this.end.nodeBefore;
              return this.start.parent.is("$text") && this.start.isAtEnd && this.start.parent.nextSibling && (e = this.start.parent.nextSibling), this.end.parent.is("$text") && this.end.isAtStart && this.end.parent.previousSibling && (t = this.end.parent.previousSibling), e && e.is("element") && e === t ? e : null;
            }
          }, {
            key: "clone",
            value: function clone() {
              return new r(this.start, this.end);
            }
          }, {
            key: "getItems",
            value: function getItems() {
              var _this64 = this;
              var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
              return /*#__PURE__*/_regeneratorRuntime().mark(function _callee7() {
                var t, _iterator231, _step231, _e172;
                return _regeneratorRuntime().wrap(function _callee7$(_context27) {
                  while (1) switch (_context27.prev = _context27.next) {
                    case 0:
                      e.boundaries = _this64, e.ignoreElementEnd = !0;
                      t = new i.Z(e);
                      _iterator231 = _createForOfIteratorHelper(t);
                      _context27.prev = 3;
                      _iterator231.s();
                    case 5:
                      if ((_step231 = _iterator231.n()).done) {
                        _context27.next = 11;
                        break;
                      }
                      _e172 = _step231.value;
                      _context27.next = 9;
                      return _e172.item;
                    case 9:
                      _context27.next = 5;
                      break;
                    case 11:
                      _context27.next = 16;
                      break;
                    case 13:
                      _context27.prev = 13;
                      _context27.t0 = _context27["catch"](3);
                      _iterator231.e(_context27.t0);
                    case 16:
                      _context27.prev = 16;
                      _iterator231.f();
                      return _context27.finish(16);
                    case 19:
                    case "end":
                      return _context27.stop();
                  }
                }, _callee7, null, [[3, 13, 16, 19]]);
              })();
            }
          }, {
            key: "getPositions",
            value: function getPositions() {
              var _this65 = this;
              var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
              return /*#__PURE__*/_regeneratorRuntime().mark(function _callee8() {
                var t, _iterator232, _step232, _e173;
                return _regeneratorRuntime().wrap(function _callee8$(_context28) {
                  while (1) switch (_context28.prev = _context28.next) {
                    case 0:
                      e.boundaries = _this65;
                      t = new i.Z(e);
                      _context28.next = 4;
                      return t.position;
                    case 4:
                      _iterator232 = _createForOfIteratorHelper(t);
                      _context28.prev = 5;
                      _iterator232.s();
                    case 7:
                      if ((_step232 = _iterator232.n()).done) {
                        _context28.next = 13;
                        break;
                      }
                      _e173 = _step232.value;
                      _context28.next = 11;
                      return _e173.nextPosition;
                    case 11:
                      _context28.next = 7;
                      break;
                    case 13:
                      _context28.next = 18;
                      break;
                    case 15:
                      _context28.prev = 15;
                      _context28.t0 = _context28["catch"](5);
                      _iterator232.e(_context28.t0);
                    case 18:
                      _context28.prev = 18;
                      _iterator232.f();
                      return _context28.finish(18);
                    case 21:
                    case "end":
                      return _context28.stop();
                  }
                }, _callee8, null, [[5, 15, 18, 21]]);
              })();
            }
          }, {
            key: "is",
            value: function is(e) {
              return "range" === e || "view:range" === e;
            }
          }, {
            key: "isIntersecting",
            value: function isIntersecting(e) {
              return this.start.isBefore(e.end) && this.end.isAfter(e.start);
            }
          }, {
            key: "isCollapsed",
            get: function get() {
              return this.start.isEqual(this.end);
            }
          }, {
            key: "isFlat",
            get: function get() {
              return this.start.parent === this.end.parent;
            }
          }, {
            key: "root",
            get: function get() {
              return this.start.root;
            }
          }], [{
            key: "_createFromParentsAndOffsets",
            value: function _createFromParentsAndOffsets(e, t, s, i) {
              return new this(new o.Z(e, t), new o.Z(s, i));
            }
          }, {
            key: "_createFromPositionAndShift",
            value: function _createFromPositionAndShift(e, t) {
              var s = e,
                o = e.getShiftedBy(t);
              return t > 0 ? new this(s, o) : new this(o, s);
            }
          }, {
            key: "_createIn",
            value: function _createIn(e) {
              return this._createFromParentsAndOffsets(e, 0, e, e.childCount);
            }
          }, {
            key: "_createOn",
            value: function _createOn(e) {
              var t = e.is("$textProxy") ? e.offsetSize : 1;
              return this._createFromPositionAndShift(o.Z._createBefore(e), t);
            }
          }]);
          return r;
        }();
        function n(e) {
          return !(!e.item.is("attributeElement") && !e.item.is("uiElement"));
        }
      },
      "./packages/ckeditor5-engine/src/view/renderer.js": function _packages_ckeditor5Engine_src_view_rendererJs(e, t, s) {
        "use strict";

        s.d(t, {
          Z: function Z() {
            return v;
          }
        });
        var o = s("./packages/ckeditor5-engine/src/view/text.js"),
          i = s("./packages/ckeditor5-engine/src/view/position.js"),
          r = s("./packages/ckeditor5-engine/src/view/filler.js"),
          n = s("./packages/ckeditor5-utils/src/mix.js"),
          a = s("./packages/ckeditor5-utils/src/diff.js");
        function c(e, t, s) {
          e.insertBefore(s, e.childNodes[t] || null);
        }
        function l(e) {
          var t = e.parentNode;
          t && t.removeChild(e);
        }
        var d = s("./packages/ckeditor5-utils/src/observablemixin.js"),
          h = s("./packages/ckeditor5-utils/src/ckeditorerror.js"),
          u = s("./packages/ckeditor5-utils/src/dom/istext.js"),
          g = s("./packages/ckeditor5-utils/src/dom/iscomment.js"),
          p = s("./packages/ckeditor5-utils/src/dom/isnode.js"),
          f = s("./packages/ckeditor5-utils/src/fastdiff.js"),
          m = s("./packages/ckeditor5-utils/src/env.js"),
          k = s("./node_modules/style-loader/dist/runtime/injectStylesIntoStyleTag.js"),
          _ = s.n(k),
          b = s("./node_modules/css-loader/dist/cjs.js!./node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].use[2]!./packages/ckeditor5-engine/theme/renderer.css"),
          w = {
            injectType: "singletonStyleTag",
            attributes: {
              "data-cke": !0
            },
            insert: "head",
            singleton: !0
          };
        _()(b.Z, w);
        b.Z.locals;
        var v = /*#__PURE__*/function () {
          function v(e, t) {
            var _this66 = this;
            _classCallCheck(this, v);
            this.domDocuments = new Set(), this.domConverter = e, this.markedAttributes = new Set(), this.markedChildren = new Set(), this.markedTexts = new Set(), this.selection = t, this.set("isFocused", !1), this.set("isSelecting", !1), m.ZP.isBlink && !m.ZP.isAndroid && this.on("change:isSelecting", function () {
              _this66.isSelecting || _this66.render();
            }), this._inlineFiller = null, this._fakeSelectionContainer = null;
          }
          _createClass(v, [{
            key: "markToSync",
            value: function markToSync(e, t) {
              if ("text" === e) this.domConverter.mapViewToDom(t.parent) && this.markedTexts.add(t);else {
                if (!this.domConverter.mapViewToDom(t)) return;
                if ("attributes" === e) this.markedAttributes.add(t);else {
                  if ("children" !== e) throw new h.ZP("view-renderer-unknown-type", this);
                  this.markedChildren.add(t);
                }
              }
            }
          }, {
            key: "render",
            value: function render() {
              var e;
              var t = !(m.ZP.isBlink && !m.ZP.isAndroid) || !this.isSelecting;
              var _iterator233 = _createForOfIteratorHelper(this.markedChildren),
                _step233;
              try {
                for (_iterator233.s(); !(_step233 = _iterator233.n()).done;) {
                  var _e174 = _step233.value;
                  this._updateChildrenMappings(_e174);
                }
              } catch (err) {
                _iterator233.e(err);
              } finally {
                _iterator233.f();
              }
              t ? (this._inlineFiller && !this._isSelectionInInlineFiller() && this._removeInlineFiller(), this._inlineFiller ? e = this._getInlineFillerPosition() : this._needsInlineFillerAtSelection() && (e = this.selection.getFirstPosition(), this.markedChildren.add(e.parent))) : this._inlineFiller && this._inlineFiller.parentNode && (e = this.domConverter.domPositionToView(this._inlineFiller));
              var _iterator234 = _createForOfIteratorHelper(this.markedAttributes),
                _step234;
              try {
                for (_iterator234.s(); !(_step234 = _iterator234.n()).done;) {
                  var _e175 = _step234.value;
                  this._updateAttrs(_e175);
                }
              } catch (err) {
                _iterator234.e(err);
              } finally {
                _iterator234.f();
              }
              var _iterator235 = _createForOfIteratorHelper(this.markedChildren),
                _step235;
              try {
                for (_iterator235.s(); !(_step235 = _iterator235.n()).done;) {
                  var _t158 = _step235.value;
                  this._updateChildren(_t158, {
                    inlineFillerPosition: e
                  });
                }
              } catch (err) {
                _iterator235.e(err);
              } finally {
                _iterator235.f();
              }
              var _iterator236 = _createForOfIteratorHelper(this.markedTexts),
                _step236;
              try {
                for (_iterator236.s(); !(_step236 = _iterator236.n()).done;) {
                  var _t159 = _step236.value;
                  !this.markedChildren.has(_t159.parent) && this.domConverter.mapViewToDom(_t159.parent) && this._updateText(_t159, {
                    inlineFillerPosition: e
                  });
                }
              } catch (err) {
                _iterator236.e(err);
              } finally {
                _iterator236.f();
              }
              if (t) if (e) {
                var _t157 = this.domConverter.viewPositionToDom(e),
                  _s163 = _t157.parent.ownerDocument;
                (0, r.Sw)(_t157.parent) ? this._inlineFiller = _t157.parent : this._inlineFiller = y(_s163, _t157.parent, _t157.offset);
              } else this._inlineFiller = null;
              this._updateFocus(), this._updateSelection(), this.markedTexts.clear(), this.markedAttributes.clear(), this.markedChildren.clear();
            }
          }, {
            key: "_updateChildrenMappings",
            value: function _updateChildrenMappings(e) {
              var t = this.domConverter.mapViewToDom(e);
              if (!t) return;
              var s = Array.from(this.domConverter.mapViewToDom(e).childNodes),
                o = Array.from(this.domConverter.viewChildrenToDom(e, t.ownerDocument, {
                  withChildren: !1
                })),
                i = this._diffNodeLists(s, o),
                r = this._findReplaceActions(i, s, o);
              if (-1 !== r.indexOf("replace")) {
                var _t160 = {
                  equal: 0,
                  insert: 0,
                  delete: 0
                };
                var _iterator237 = _createForOfIteratorHelper(r),
                  _step237;
                try {
                  for (_iterator237.s(); !(_step237 = _iterator237.n()).done;) {
                    var _i85 = _step237.value;
                    if ("replace" === _i85) {
                      var _i86 = _t160.equal + _t160.insert,
                        _r43 = _t160.equal + _t160.delete,
                        _n20 = e.getChild(_i86);
                      !_n20 || _n20.is("uiElement") || _n20.is("rawElement") || this._updateElementMappings(_n20, s[_r43]), l(o[_i86]), _t160.equal++;
                    } else _t160[_i85]++;
                  }
                } catch (err) {
                  _iterator237.e(err);
                } finally {
                  _iterator237.f();
                }
              }
            }
          }, {
            key: "_updateElementMappings",
            value: function _updateElementMappings(e, t) {
              this.domConverter.unbindDomElement(t), this.domConverter.bindElements(t, e), this.markedChildren.add(e), this.markedAttributes.add(e);
            }
          }, {
            key: "_getInlineFillerPosition",
            value: function _getInlineFillerPosition() {
              var e = this.selection.getFirstPosition();
              return e.parent.is("$text") ? i.Z._createBefore(this.selection.getFirstPosition().parent) : e;
            }
          }, {
            key: "_isSelectionInInlineFiller",
            value: function _isSelectionInInlineFiller() {
              if (1 != this.selection.rangeCount || !this.selection.isCollapsed) return !1;
              var e = this.selection.getFirstPosition(),
                t = this.domConverter.viewPositionToDom(e);
              return !!(t && (0, u.Z)(t.parent) && (0, r.Sw)(t.parent));
            }
          }, {
            key: "_removeInlineFiller",
            value: function _removeInlineFiller() {
              var e = this._inlineFiller;
              if (!(0, r.Sw)(e)) throw new h.ZP("view-renderer-filler-was-lost", this);
              (0, r.Qh)(e) ? e.remove() : e.data = e.data.substr(r.b_), this._inlineFiller = null;
            }
          }, {
            key: "_needsInlineFillerAtSelection",
            value: function _needsInlineFillerAtSelection() {
              if (1 != this.selection.rangeCount || !this.selection.isCollapsed) return !1;
              var e = this.selection.getFirstPosition(),
                t = e.parent,
                s = e.offset;
              if (!this.domConverter.mapViewToDom(t.root)) return !1;
              if (!t.is("element")) return !1;
              if (!function (e) {
                if ("false" == e.getAttribute("contenteditable")) return !1;
                var t = e.findAncestor(function (e) {
                  return e.hasAttribute("contenteditable");
                });
                return !t || "true" == t.getAttribute("contenteditable");
              }(t)) return !1;
              if (s === t.getFillerOffset()) return !1;
              var i = e.nodeBefore,
                r = e.nodeAfter;
              return !(i instanceof o.Z || r instanceof o.Z);
            }
          }, {
            key: "_updateText",
            value: function _updateText(e, t) {
              var s = this.domConverter.findCorrespondingDomText(e),
                o = this.domConverter.viewToDom(e, s.ownerDocument),
                i = s.data;
              var n = o.data;
              var a = t.inlineFillerPosition;
              if (a && a.parent == e.parent && a.offset == e.index && (n = r.Pj + n), i != n) {
                var _e176 = (0, f.Z)(i, n);
                var _iterator238 = _createForOfIteratorHelper(_e176),
                  _step238;
                try {
                  for (_iterator238.s(); !(_step238 = _iterator238.n()).done;) {
                    var _t161 = _step238.value;
                    "insert" === _t161.type ? s.insertData(_t161.index, _t161.values.join("")) : s.deleteData(_t161.index, _t161.howMany);
                  }
                } catch (err) {
                  _iterator238.e(err);
                } finally {
                  _iterator238.f();
                }
              }
            }
          }, {
            key: "_updateAttrs",
            value: function _updateAttrs(e) {
              var t = this.domConverter.mapViewToDom(e);
              if (!t) return;
              var s = Array.from(t.attributes).map(function (e) {
                  return e.name;
                }),
                o = e.getAttributeKeys();
              var _iterator239 = _createForOfIteratorHelper(o),
                _step239;
              try {
                for (_iterator239.s(); !(_step239 = _iterator239.n()).done;) {
                  var _s164 = _step239.value;
                  this.domConverter.setDomElementAttribute(t, _s164, e.getAttribute(_s164), e);
                }
              } catch (err) {
                _iterator239.e(err);
              } finally {
                _iterator239.f();
              }
              var _iterator240 = _createForOfIteratorHelper(s),
                _step240;
              try {
                for (_iterator240.s(); !(_step240 = _iterator240.n()).done;) {
                  var _o102 = _step240.value;
                  e.hasAttribute(_o102) || this.domConverter.removeDomElementAttribute(t, _o102);
                }
              } catch (err) {
                _iterator240.e(err);
              } finally {
                _iterator240.f();
              }
            }
          }, {
            key: "_updateChildren",
            value: function _updateChildren(e, t) {
              var s = this.domConverter.mapViewToDom(e);
              if (!s) return;
              var o = t.inlineFillerPosition,
                i = this.domConverter.mapViewToDom(e).childNodes,
                r = Array.from(this.domConverter.viewChildrenToDom(e, s.ownerDocument, {
                  bind: !0
                }));
              o && o.parent === e && y(s.ownerDocument, r, o.offset);
              var n = this._diffNodeLists(i, r);
              var a = 0;
              var d = new Set();
              var _iterator241 = _createForOfIteratorHelper(n),
                _step241;
              try {
                for (_iterator241.s(); !(_step241 = _iterator241.n()).done;) {
                  var _e177 = _step241.value;
                  "delete" === _e177 ? (d.add(i[a]), l(i[a])) : "equal" === _e177 && a++;
                }
              } catch (err) {
                _iterator241.e(err);
              } finally {
                _iterator241.f();
              }
              a = 0;
              var _iterator242 = _createForOfIteratorHelper(n),
                _step242;
              try {
                for (_iterator242.s(); !(_step242 = _iterator242.n()).done;) {
                  var _e178 = _step242.value;
                  "insert" === _e178 ? (c(s, a, r[a]), a++) : "equal" === _e178 && (this._markDescendantTextToSync(this.domConverter.domToView(r[a])), a++);
                }
              } catch (err) {
                _iterator242.e(err);
              } finally {
                _iterator242.f();
              }
              var _iterator243 = _createForOfIteratorHelper(d),
                _step243;
              try {
                for (_iterator243.s(); !(_step243 = _iterator243.n()).done;) {
                  var _e179 = _step243.value;
                  _e179.parentNode || this.domConverter.unbindDomElement(_e179);
                }
              } catch (err) {
                _iterator243.e(err);
              } finally {
                _iterator243.f();
              }
            }
          }, {
            key: "_diffNodeLists",
            value: function _diffNodeLists(e, t) {
              return e = function (e, t) {
                var s = Array.from(e);
                if (0 == s.length || !t) return s;
                s[s.length - 1] == t && s.pop();
                return s;
              }(e, this._fakeSelectionContainer), (0, a.Z)(e, t, P.bind(null, this.domConverter));
            }
          }, {
            key: "_findReplaceActions",
            value: function _findReplaceActions(e, t, s) {
              if (-1 === e.indexOf("insert") || -1 === e.indexOf("delete")) return e;
              var o = [],
                i = [],
                r = [];
              var n = {
                equal: 0,
                insert: 0,
                delete: 0
              };
              var _iterator244 = _createForOfIteratorHelper(e),
                _step244;
              try {
                for (_iterator244.s(); !(_step244 = _iterator244.n()).done;) {
                  var _c9 = _step244.value;
                  "insert" === _c9 ? r.push(s[n.equal + n.insert]) : "delete" === _c9 ? i.push(t[n.equal + n.delete]) : (o = o.concat((0, a.Z)(i, r, Z).map(function (e) {
                    return "equal" === e ? "replace" : e;
                  })), o.push("equal"), i = [], r = []), n[_c9]++;
                }
              } catch (err) {
                _iterator244.e(err);
              } finally {
                _iterator244.f();
              }
              return o.concat((0, a.Z)(i, r, Z).map(function (e) {
                return "equal" === e ? "replace" : e;
              }));
            }
          }, {
            key: "_markDescendantTextToSync",
            value: function _markDescendantTextToSync(e) {
              if (e) if (e.is("$text")) this.markedTexts.add(e);else if (e.is("element")) {
                var _iterator245 = _createForOfIteratorHelper(e.getChildren()),
                  _step245;
                try {
                  for (_iterator245.s(); !(_step245 = _iterator245.n()).done;) {
                    var _t162 = _step245.value;
                    this._markDescendantTextToSync(_t162);
                  }
                } catch (err) {
                  _iterator245.e(err);
                } finally {
                  _iterator245.f();
                }
              }
            }
          }, {
            key: "_updateSelection",
            value: function _updateSelection() {
              if (m.ZP.isBlink && !m.ZP.isAndroid && this.isSelecting && !this.markedChildren.size) return;
              if (0 === this.selection.rangeCount) return this._removeDomSelection(), void this._removeFakeSelection();
              var e = this.domConverter.mapViewToDom(this.selection.editableElement);
              this.isFocused && e && (this.selection.isFake ? this._updateFakeSelection(e) : (this._removeFakeSelection(), this._updateDomSelection(e)));
            }
          }, {
            key: "_updateFakeSelection",
            value: function _updateFakeSelection(e) {
              var t = e.ownerDocument;
              this._fakeSelectionContainer || (this._fakeSelectionContainer = function (e) {
                var t = e.createElement("div");
                return t.className = "ck-fake-selection-container", Object.assign(t.style, {
                  position: "fixed",
                  top: 0,
                  left: "-9999px",
                  width: "42px"
                }), t.textContent = " ", t;
              }(t));
              var s = this._fakeSelectionContainer;
              if (this.domConverter.bindFakeSelection(s, this.selection), !this._fakeSelectionNeedsUpdate(e)) return;
              s.parentElement && s.parentElement == e || e.appendChild(s), s.textContent = this.selection.fakeSelectionLabel || " ";
              var o = t.getSelection(),
                i = t.createRange();
              o.removeAllRanges(), i.selectNodeContents(s), o.addRange(i);
            }
          }, {
            key: "_updateDomSelection",
            value: function _updateDomSelection(e) {
              var t = e.ownerDocument.defaultView.getSelection();
              if (!this._domSelectionNeedsUpdate(t)) return;
              var s = this.domConverter.viewPositionToDom(this.selection.anchor),
                o = this.domConverter.viewPositionToDom(this.selection.focus);
              t.collapse(s.parent, s.offset), t.extend(o.parent, o.offset), m.ZP.isGecko && function (e, t) {
                var s = e.parent;
                if (s.nodeType != Node.ELEMENT_NODE || e.offset != s.childNodes.length - 1) return;
                var o = s.childNodes[e.offset];
                o && "BR" == o.tagName && t.addRange(t.getRangeAt(0));
              }(o, t);
            }
          }, {
            key: "_domSelectionNeedsUpdate",
            value: function _domSelectionNeedsUpdate(e) {
              if (!this.domConverter.isDomSelectionCorrect(e)) return !0;
              var t = e && this.domConverter.domSelectionToView(e);
              return (!t || !this.selection.isEqual(t)) && !(!this.selection.isCollapsed && this.selection.isSimilar(t));
            }
          }, {
            key: "_fakeSelectionNeedsUpdate",
            value: function _fakeSelectionNeedsUpdate(e) {
              var t = this._fakeSelectionContainer,
                s = e.ownerDocument.getSelection();
              return !t || t.parentElement !== e || s.anchorNode !== t && !t.contains(s.anchorNode) || t.textContent !== this.selection.fakeSelectionLabel;
            }
          }, {
            key: "_removeDomSelection",
            value: function _removeDomSelection() {
              var _iterator246 = _createForOfIteratorHelper(this.domDocuments),
                _step246;
              try {
                for (_iterator246.s(); !(_step246 = _iterator246.n()).done;) {
                  var _e180 = _step246.value;
                  if (_e180.getSelection().rangeCount) {
                    var _t163 = _e180.activeElement,
                      _s165 = this.domConverter.mapDomToView(_t163);
                    _t163 && _s165 && _e180.getSelection().removeAllRanges();
                  }
                }
              } catch (err) {
                _iterator246.e(err);
              } finally {
                _iterator246.f();
              }
            }
          }, {
            key: "_removeFakeSelection",
            value: function _removeFakeSelection() {
              var e = this._fakeSelectionContainer;
              e && e.remove();
            }
          }, {
            key: "_updateFocus",
            value: function _updateFocus() {
              if (this.isFocused) {
                var _e181 = this.selection.editableElement;
                _e181 && this.domConverter.focus(_e181);
              }
            }
          }]);
          return v;
        }();
        function y(e, t, s) {
          var o = t instanceof Array ? t : t.childNodes,
            i = o[s];
          if ((0, u.Z)(i)) return i.data = r.Pj + i.data, i;
          {
            var _i87 = e.createTextNode(r.Pj);
            return Array.isArray(t) ? o.splice(s, 0, _i87) : c(t, s, _i87), _i87;
          }
        }
        function Z(e, t) {
          return (0, p.Z)(e) && (0, p.Z)(t) && !(0, u.Z)(e) && !(0, u.Z)(t) && !(0, g.Z)(e) && !(0, g.Z)(t) && e.tagName.toLowerCase() === t.tagName.toLowerCase();
        }
        function P(e, t, s) {
          return t === s || ((0, u.Z)(t) && (0, u.Z)(s) ? t.data === s.data : !(!e.isBlockFiller(t) || !e.isBlockFiller(s)));
        }
        (0, n.Z)(v, d.Z);
      },
      "./packages/ckeditor5-engine/src/view/selection.js": function _packages_ckeditor5Engine_src_view_selectionJs(e, t, s) {
        "use strict";

        s.d(t, {
          Z: function Z() {
            return u;
          }
        });
        var o = s("./packages/ckeditor5-utils/src/ckeditorerror.js"),
          i = s("./packages/ckeditor5-engine/src/view/range.js"),
          r = s("./packages/ckeditor5-engine/src/view/position.js"),
          n = s("./packages/ckeditor5-utils/src/mix.js"),
          a = s("./packages/ckeditor5-utils/src/emittermixin.js"),
          c = s("./packages/ckeditor5-engine/src/view/node.js"),
          l = s("./packages/ckeditor5-utils/src/count.js"),
          d = s("./packages/ckeditor5-utils/src/isiterable.js"),
          h = s("./packages/ckeditor5-engine/src/view/documentselection.js");
        var u = /*#__PURE__*/function () {
          function u() {
            var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
            var t = arguments.length > 1 ? arguments[1] : undefined;
            var s = arguments.length > 2 ? arguments[2] : undefined;
            _classCallCheck(this, u);
            this._ranges = [], this._lastRangeBackward = !1, this._isFake = !1, this._fakeSelectionLabel = "", this.setTo(e, t, s);
          }
          _createClass(u, [{
            key: "getRanges",
            value: /*#__PURE__*/_regeneratorRuntime().mark(function getRanges() {
              var _iterator247, _step247, _e182;
              return _regeneratorRuntime().wrap(function getRanges$(_context29) {
                while (1) switch (_context29.prev = _context29.next) {
                  case 0:
                    _iterator247 = _createForOfIteratorHelper(this._ranges);
                    _context29.prev = 1;
                    _iterator247.s();
                  case 3:
                    if ((_step247 = _iterator247.n()).done) {
                      _context29.next = 9;
                      break;
                    }
                    _e182 = _step247.value;
                    _context29.next = 7;
                    return _e182.clone();
                  case 7:
                    _context29.next = 3;
                    break;
                  case 9:
                    _context29.next = 14;
                    break;
                  case 11:
                    _context29.prev = 11;
                    _context29.t0 = _context29["catch"](1);
                    _iterator247.e(_context29.t0);
                  case 14:
                    _context29.prev = 14;
                    _iterator247.f();
                    return _context29.finish(14);
                  case 17:
                  case "end":
                    return _context29.stop();
                }
              }, getRanges, this, [[1, 11, 14, 17]]);
            })
          }, {
            key: "getFirstRange",
            value: function getFirstRange() {
              var e = null;
              var _iterator248 = _createForOfIteratorHelper(this._ranges),
                _step248;
              try {
                for (_iterator248.s(); !(_step248 = _iterator248.n()).done;) {
                  var _t164 = _step248.value;
                  e && !_t164.start.isBefore(e.start) || (e = _t164);
                }
              } catch (err) {
                _iterator248.e(err);
              } finally {
                _iterator248.f();
              }
              return e ? e.clone() : null;
            }
          }, {
            key: "getLastRange",
            value: function getLastRange() {
              var e = null;
              var _iterator249 = _createForOfIteratorHelper(this._ranges),
                _step249;
              try {
                for (_iterator249.s(); !(_step249 = _iterator249.n()).done;) {
                  var _t165 = _step249.value;
                  e && !_t165.end.isAfter(e.end) || (e = _t165);
                }
              } catch (err) {
                _iterator249.e(err);
              } finally {
                _iterator249.f();
              }
              return e ? e.clone() : null;
            }
          }, {
            key: "getFirstPosition",
            value: function getFirstPosition() {
              var e = this.getFirstRange();
              return e ? e.start.clone() : null;
            }
          }, {
            key: "getLastPosition",
            value: function getLastPosition() {
              var e = this.getLastRange();
              return e ? e.end.clone() : null;
            }
          }, {
            key: "isEqual",
            value: function isEqual(e) {
              if (this.isFake != e.isFake) return !1;
              if (this.isFake && this.fakeSelectionLabel != e.fakeSelectionLabel) return !1;
              if (this.rangeCount != e.rangeCount) return !1;
              if (0 === this.rangeCount) return !0;
              if (!this.anchor.isEqual(e.anchor) || !this.focus.isEqual(e.focus)) return !1;
              var _iterator250 = _createForOfIteratorHelper(this._ranges),
                _step250;
              try {
                for (_iterator250.s(); !(_step250 = _iterator250.n()).done;) {
                  var _t166 = _step250.value;
                  var _s166 = !1;
                  var _iterator251 = _createForOfIteratorHelper(e._ranges),
                    _step251;
                  try {
                    for (_iterator251.s(); !(_step251 = _iterator251.n()).done;) {
                      var _o103 = _step251.value;
                      if (_t166.isEqual(_o103)) {
                        _s166 = !0;
                        break;
                      }
                    }
                  } catch (err) {
                    _iterator251.e(err);
                  } finally {
                    _iterator251.f();
                  }
                  if (!_s166) return !1;
                }
              } catch (err) {
                _iterator250.e(err);
              } finally {
                _iterator250.f();
              }
              return !0;
            }
          }, {
            key: "isSimilar",
            value: function isSimilar(e) {
              if (this.isBackward != e.isBackward) return !1;
              var t = (0, l.Z)(this.getRanges());
              if (t != (0, l.Z)(e.getRanges())) return !1;
              if (0 == t) return !0;
              var _iterator252 = _createForOfIteratorHelper(this.getRanges()),
                _step252;
              try {
                for (_iterator252.s(); !(_step252 = _iterator252.n()).done;) {
                  var _t167 = _step252.value;
                  _t167 = _t167.getTrimmed();
                  var _s167 = !1;
                  var _iterator253 = _createForOfIteratorHelper(e.getRanges()),
                    _step253;
                  try {
                    for (_iterator253.s(); !(_step253 = _iterator253.n()).done;) {
                      var _o104 = _step253.value;
                      if (_o104 = _o104.getTrimmed(), _t167.start.isEqual(_o104.start) && _t167.end.isEqual(_o104.end)) {
                        _s167 = !0;
                        break;
                      }
                    }
                  } catch (err) {
                    _iterator253.e(err);
                  } finally {
                    _iterator253.f();
                  }
                  if (!_s167) return !1;
                }
              } catch (err) {
                _iterator252.e(err);
              } finally {
                _iterator252.f();
              }
              return !0;
            }
          }, {
            key: "getSelectedElement",
            value: function getSelectedElement() {
              return 1 !== this.rangeCount ? null : this.getFirstRange().getContainedElement();
            }
          }, {
            key: "setTo",
            value: function setTo(e, t, s) {
              if (null === e) this._setRanges([]), this._setFakeOptions(t);else if (e instanceof u || e instanceof h.Z) this._setRanges(e.getRanges(), e.isBackward), this._setFakeOptions({
                fake: e.isFake,
                label: e.fakeSelectionLabel
              });else if (e instanceof i.Z) this._setRanges([e], t && t.backward), this._setFakeOptions(t);else if (e instanceof r.Z) this._setRanges([new i.Z(e)]), this._setFakeOptions(t);else if (e instanceof c.Z) {
                var _n21 = !!s && !!s.backward;
                var _a11;
                if (void 0 === t) throw new o.ZP("view-selection-setto-required-second-parameter", this);
                _a11 = "in" == t ? i.Z._createIn(e) : "on" == t ? i.Z._createOn(e) : new i.Z(r.Z._createAt(e, t)), this._setRanges([_a11], _n21), this._setFakeOptions(s);
              } else {
                if (!(0, d.Z)(e)) throw new o.ZP("view-selection-setto-not-selectable", this);
                this._setRanges(e, t && t.backward), this._setFakeOptions(t);
              }
              this.fire("change");
            }
          }, {
            key: "setFocus",
            value: function setFocus(e, t) {
              if (null === this.anchor) throw new o.ZP("view-selection-setfocus-no-ranges", this);
              var s = r.Z._createAt(e, t);
              if ("same" == s.compareWith(this.focus)) return;
              var n = this.anchor;
              this._ranges.pop(), "before" == s.compareWith(n) ? this._addRange(new i.Z(s, n), !0) : this._addRange(new i.Z(n, s)), this.fire("change");
            }
          }, {
            key: "is",
            value: function is(e) {
              return "selection" === e || "view:selection" === e;
            }
          }, {
            key: "_setRanges",
            value: function _setRanges(e) {
              var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
              e = Array.from(e), this._ranges = [];
              var _iterator254 = _createForOfIteratorHelper(e),
                _step254;
              try {
                for (_iterator254.s(); !(_step254 = _iterator254.n()).done;) {
                  var _t168 = _step254.value;
                  this._addRange(_t168);
                }
              } catch (err) {
                _iterator254.e(err);
              } finally {
                _iterator254.f();
              }
              this._lastRangeBackward = !!t;
            }
          }, {
            key: "_setFakeOptions",
            value: function _setFakeOptions() {
              var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
              this._isFake = !!e.fake, this._fakeSelectionLabel = e.fake && e.label || "";
            }
          }, {
            key: "_addRange",
            value: function _addRange(e) {
              var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
              if (!(e instanceof i.Z)) throw new o.ZP("view-selection-add-range-not-range", this);
              this._pushRange(e), this._lastRangeBackward = !!t;
            }
          }, {
            key: "_pushRange",
            value: function _pushRange(e) {
              var _iterator255 = _createForOfIteratorHelper(this._ranges),
                _step255;
              try {
                for (_iterator255.s(); !(_step255 = _iterator255.n()).done;) {
                  var _t169 = _step255.value;
                  if (e.isIntersecting(_t169)) throw new o.ZP("view-selection-range-intersects", this, {
                    addedRange: e,
                    intersectingRange: _t169
                  });
                }
              } catch (err) {
                _iterator255.e(err);
              } finally {
                _iterator255.f();
              }
              this._ranges.push(new i.Z(e.start, e.end));
            }
          }, {
            key: "isFake",
            get: function get() {
              return this._isFake;
            }
          }, {
            key: "fakeSelectionLabel",
            get: function get() {
              return this._fakeSelectionLabel;
            }
          }, {
            key: "anchor",
            get: function get() {
              if (!this._ranges.length) return null;
              var e = this._ranges[this._ranges.length - 1];
              return (this._lastRangeBackward ? e.end : e.start).clone();
            }
          }, {
            key: "focus",
            get: function get() {
              if (!this._ranges.length) return null;
              var e = this._ranges[this._ranges.length - 1];
              return (this._lastRangeBackward ? e.start : e.end).clone();
            }
          }, {
            key: "isCollapsed",
            get: function get() {
              return 1 === this.rangeCount && this._ranges[0].isCollapsed;
            }
          }, {
            key: "rangeCount",
            get: function get() {
              return this._ranges.length;
            }
          }, {
            key: "isBackward",
            get: function get() {
              return !this.isCollapsed && this._lastRangeBackward;
            }
          }, {
            key: "editableElement",
            get: function get() {
              return this.anchor ? this.anchor.editableElement : null;
            }
          }]);
          return u;
        }();
        (0, n.Z)(u, a.ZP);
      },
      "./packages/ckeditor5-engine/src/view/stylesmap.js": function _packages_ckeditor5Engine_src_view_stylesmapJs(e, t, s) {
        "use strict";

        s.d(t, {
          A: function A() {
            return ee;
          },
          Z: function Z() {
            return Y;
          }
        });
        var o = s("./node_modules/lodash-es/isArray.js"),
          i = s("./node_modules/lodash-es/isSymbol.js"),
          r = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
          n = /^\w*$/;
        var a = function a(e, t) {
          if ((0, o.Z)(e)) return !1;
          var s = typeof e;
          return !("number" != s && "symbol" != s && "boolean" != s && null != e && !(0, i.Z)(e)) || n.test(e) || !r.test(e) || null != t && e in Object(t);
        };
        var c = s("./node_modules/lodash-es/_MapCache.js");
        function l(e, t) {
          if ("function" != typeof e || null != t && "function" != typeof t) throw new TypeError("Expected a function");
          var _s168 = function s() {
            var o = arguments,
              i = t ? t.apply(this, o) : o[0],
              r = _s168.cache;
            if (r.has(i)) return r.get(i);
            var n = e.apply(this, o);
            return _s168.cache = r.set(i, n) || r, n;
          };
          return _s168.cache = new (l.Cache || c.Z)(), _s168;
        }
        l.Cache = c.Z;
        var d = l;
        var h = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g,
          u = /\\(\\)?/g;
        var g = function (e) {
          var t = d(e, function (e) {
              return 500 === s.size && s.clear(), e;
            }),
            s = t.cache;
          return t;
        }(function (e) {
          var t = [];
          return 46 === e.charCodeAt(0) && t.push(""), e.replace(h, function (e, s, o, i) {
            t.push(o ? i.replace(u, "$1") : s || e);
          }), t;
        });
        var p = s("./node_modules/lodash-es/toString.js");
        var f = function f(e, t) {
          return (0, o.Z)(e) ? e : a(e, t) ? [e] : g((0, p.Z)(e));
        };
        var m = function m(e) {
          var t = null == e ? 0 : e.length;
          return t ? e[t - 1] : void 0;
        };
        var k = function k(e) {
          if ("string" == typeof e || (0, i.Z)(e)) return e;
          var t = e + "";
          return "0" == t && 1 / e == -Infinity ? "-0" : t;
        };
        var _ = function _(e, t) {
          for (var s = 0, o = (t = f(t, e)).length; null != e && s < o;) e = e[k(t[s++])];
          return s && s == o ? e : void 0;
        };
        var b = function b(e, t, s) {
          var o = -1,
            i = e.length;
          t < 0 && (t = -t > i ? 0 : i + t), (s = s > i ? i : s) < 0 && (s += i), i = t > s ? 0 : s - t >>> 0, t >>>= 0;
          for (var r = Array(i); ++o < i;) r[o] = e[o + t];
          return r;
        };
        var w = function w(e, t) {
          return t.length < 2 ? e : _(e, b(t, 0, -1));
        };
        var v = function v(e, t) {
          return t = f(t, e), null == (e = w(e, t)) || delete e[k(m(t))];
        };
        var y = function y(e, t) {
          return null == e || v(e, t);
        };
        var Z = function Z(e, t, s) {
          var o = null == e ? void 0 : _(e, t);
          return void 0 === o ? s : o;
        };
        var P = s("./node_modules/lodash-es/_Stack.js"),
          j = s("./node_modules/lodash-es/_baseAssignValue.js"),
          x = s("./node_modules/lodash-es/eq.js");
        var A = function A(e, t, s) {
          (void 0 !== s && !(0, x.Z)(e[t], s) || void 0 === s && !(t in e)) && (0, j.Z)(e, t, s);
        };
        var T = function (e) {
          return function (t, s, o) {
            for (var i = -1, r = Object(t), n = o(t), a = n.length; a--;) {
              var c = n[e ? a : ++i];
              if (!1 === s(r[c], c, r)) break;
            }
            return t;
          };
        }();
        var C = s("./node_modules/lodash-es/_cloneBuffer.js"),
          E = s("./node_modules/lodash-es/_cloneTypedArray.js"),
          S = s("./node_modules/lodash-es/_copyArray.js"),
          R = s("./node_modules/lodash-es/_initCloneObject.js"),
          O = s("./node_modules/lodash-es/isArguments.js"),
          M = s("./node_modules/lodash-es/isArrayLike.js"),
          N = s("./node_modules/lodash-es/isObjectLike.js");
        var I = function I(e) {
          return (0, N.Z)(e) && (0, M.Z)(e);
        };
        var z = s("./node_modules/lodash-es/isBuffer.js"),
          V = s("./node_modules/lodash-es/isFunction.js"),
          D = s("./node_modules/lodash-es/isObject.js"),
          B = s("./node_modules/lodash-es/isPlainObject.js"),
          F = s("./node_modules/lodash-es/isTypedArray.js");
        var L = function L(e, t) {
          if (("constructor" !== t || "function" != typeof e[t]) && "__proto__" != t) return e[t];
        };
        var W = s("./node_modules/lodash-es/_copyObject.js"),
          q = s("./node_modules/lodash-es/keysIn.js");
        var H = function H(e) {
          return (0, W.Z)(e, (0, q.Z)(e));
        };
        var $ = function $(e, t, s, i, r, n, a) {
          var c = L(e, s),
            l = L(t, s),
            d = a.get(l);
          if (d) A(e, s, d);else {
            var h = n ? n(c, l, s + "", e, t, a) : void 0,
              u = void 0 === h;
            if (u) {
              var g = (0, o.Z)(l),
                p = !g && (0, z.Z)(l),
                f = !g && !p && (0, F.Z)(l);
              h = l, g || p || f ? (0, o.Z)(c) ? h = c : I(c) ? h = (0, S.Z)(c) : p ? (u = !1, h = (0, C.Z)(l, !0)) : f ? (u = !1, h = (0, E.Z)(l, !0)) : h = [] : (0, B.Z)(l) || (0, O.Z)(l) ? (h = c, (0, O.Z)(c) ? h = H(c) : (0, D.Z)(c) && !(0, V.Z)(c) || (h = (0, R.Z)(l))) : u = !1;
            }
            u && (a.set(l, h), r(h, l, i, n, a), a.delete(l)), A(e, s, h);
          }
        };
        var U = function e(t, s, o, i, r) {
          t !== s && T(s, function (n, a) {
            if (r || (r = new P.Z()), (0, D.Z)(n)) $(t, s, a, o, e, i, r);else {
              var c = i ? i(L(t, a), n, a + "", t, s, r) : void 0;
              void 0 === c && (c = n), A(t, a, c);
            }
          }, q.Z);
        };
        var K = (0, s("./node_modules/lodash-es/_createAssigner.js").Z)(function (e, t, s) {
          U(e, t, s);
        });
        var G = s("./node_modules/lodash-es/_assignValue.js"),
          J = s("./node_modules/lodash-es/_isIndex.js");
        var X = function X(e, t, s, o) {
          if (!(0, D.Z)(e)) return e;
          for (var i = -1, r = (t = f(t, e)).length, n = r - 1, a = e; null != a && ++i < r;) {
            var c = k(t[i]),
              l = s;
            if ("__proto__" === c || "constructor" === c || "prototype" === c) return e;
            if (i != n) {
              var d = a[c];
              void 0 === (l = o ? o(d, c, a) : void 0) && (l = (0, D.Z)(d) ? d : (0, J.Z)(t[i + 1]) ? [] : {});
            }
            (0, G.Z)(a, c, l), a = a[c];
          }
          return e;
        };
        var Q = function Q(e, t, s) {
          return null == e ? e : X(e, t, s);
        };
        var Y = /*#__PURE__*/function () {
          function Y(e) {
            _classCallCheck(this, Y);
            this._styles = {}, this._styleProcessor = e;
          }
          _createClass(Y, [{
            key: "setTo",
            value: function setTo(e) {
              this.clear();
              var t = Array.from(function (e) {
                var t = null,
                  s = 0,
                  o = 0,
                  i = null;
                var r = new Map();
                if ("" === e) return r;
                ";" != e.charAt(e.length - 1) && (e += ";");
                for (var _n22 = 0; _n22 < e.length; _n22++) {
                  var _a12 = e.charAt(_n22);
                  if (null === t) switch (_a12) {
                    case ":":
                      i || (i = e.substr(s, _n22 - s), o = _n22 + 1);
                      break;
                    case '"':
                    case "'":
                      t = _a12;
                      break;
                    case ";":
                      {
                        var _t170 = e.substr(o, _n22 - o);
                        i && r.set(i.trim(), _t170.trim()), i = null, s = _n22 + 1;
                        break;
                      }
                  } else _a12 === t && (t = null);
                }
                return r;
              }(e).entries());
              for (var _i88 = 0, _t171 = t; _i88 < _t171.length; _i88++) {
                var _t171$_i = _slicedToArray(_t171[_i88], 2),
                  _e183 = _t171$_i[0],
                  _s169 = _t171$_i[1];
                this._styleProcessor.toNormalizedForm(_e183, _s169, this._styles);
              }
            }
          }, {
            key: "has",
            value: function has(e) {
              if (this.isEmpty) return !1;
              var t = this._styleProcessor.getReducedForm(e, this._styles).find(function (_ref22) {
                var _ref23 = _slicedToArray(_ref22, 1),
                  t = _ref23[0];
                return t === e;
              });
              return Array.isArray(t);
            }
          }, {
            key: "set",
            value: function set(e, t) {
              if ((0, D.Z)(e)) for (var _i89 = 0, _Object$entries = Object.entries(e); _i89 < _Object$entries.length; _i89++) {
                var _Object$entries$_i = _slicedToArray(_Object$entries[_i89], 2),
                  _t172 = _Object$entries$_i[0],
                  _s170 = _Object$entries$_i[1];
                this._styleProcessor.toNormalizedForm(_t172, _s170, this._styles);
              } else this._styleProcessor.toNormalizedForm(e, t, this._styles);
            }
          }, {
            key: "remove",
            value: function remove(e) {
              var t = te(e);
              y(this._styles, t), delete this._styles[e], this._cleanEmptyObjectsOnPath(t);
            }
          }, {
            key: "getNormalized",
            value: function getNormalized(e) {
              return this._styleProcessor.getNormalized(e, this._styles);
            }
          }, {
            key: "toString",
            value: function toString() {
              return this.isEmpty ? "" : this._getStylesEntries().map(function (e) {
                return e.join(":");
              }).sort().join(";") + ";";
            }
          }, {
            key: "getAsString",
            value: function getAsString(e) {
              if (this.isEmpty) return;
              if (this._styles[e] && !(0, D.Z)(this._styles[e])) return this._styles[e];
              var t = this._styleProcessor.getReducedForm(e, this._styles).find(function (_ref24) {
                var _ref25 = _slicedToArray(_ref24, 1),
                  t = _ref25[0];
                return t === e;
              });
              return Array.isArray(t) ? t[1] : void 0;
            }
          }, {
            key: "getStyleNames",
            value: function getStyleNames() {
              var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !1;
              if (this.isEmpty) return [];
              if (e) return this._styleProcessor.getStyleNames(this._styles);
              return this._getStylesEntries().map(function (_ref26) {
                var _ref27 = _slicedToArray(_ref26, 1),
                  e = _ref27[0];
                return e;
              });
            }
          }, {
            key: "clear",
            value: function clear() {
              this._styles = {};
            }
          }, {
            key: "_getStylesEntries",
            value: function _getStylesEntries() {
              var e = [],
                t = Object.keys(this._styles);
              for (var _i90 = 0, _t173 = t; _i90 < _t173.length; _i90++) {
                var _s171 = _t173[_i90];
                e.push.apply(e, _toConsumableArray(this._styleProcessor.getReducedForm(_s171, this._styles)));
              }
              return e;
            }
          }, {
            key: "_cleanEmptyObjectsOnPath",
            value: function _cleanEmptyObjectsOnPath(e) {
              var t = e.split(".");
              if (!(t.length > 1)) return;
              var s = t.splice(0, t.length - 1).join("."),
                o = Z(this._styles, s);
              if (!o) return;
              !Array.from(Object.keys(o)).length && this.remove(s);
            }
          }, {
            key: "isEmpty",
            get: function get() {
              var e = Object.entries(this._styles);
              return !Array.from(e).length;
            }
          }, {
            key: "size",
            get: function get() {
              return this.isEmpty ? 0 : this.getStyleNames().length;
            }
          }]);
          return Y;
        }();
        var ee = /*#__PURE__*/function () {
          function ee() {
            _classCallCheck(this, ee);
            this._normalizers = new Map(), this._extractors = new Map(), this._reducers = new Map(), this._consumables = new Map();
          }
          _createClass(ee, [{
            key: "toNormalizedForm",
            value: function toNormalizedForm(e, t, s) {
              if ((0, D.Z)(t)) se(s, te(e), t);else if (this._normalizers.has(e)) {
                var _o106 = this._normalizers.get(e),
                  _o105 = _o106(t),
                  _i91 = _o105.path,
                  _r44 = _o105.value;
                se(s, _i91, _r44);
              } else se(s, e, t);
            }
          }, {
            key: "getNormalized",
            value: function getNormalized(e, t) {
              if (!e) return K({}, t);
              if (void 0 !== t[e]) return t[e];
              if (this._extractors.has(e)) {
                var _s172 = this._extractors.get(e);
                if ("string" == typeof _s172) return Z(t, _s172);
                var _o107 = _s172(e, t);
                if (_o107) return _o107;
              }
              return Z(t, te(e));
            }
          }, {
            key: "getReducedForm",
            value: function getReducedForm(e, t) {
              var s = this.getNormalized(e, t);
              if (void 0 === s) return [];
              if (this._reducers.has(e)) {
                return this._reducers.get(e)(s);
              }
              return [[e, s]];
            }
          }, {
            key: "getStyleNames",
            value: function getStyleNames(e) {
              var _this67 = this;
              var t = Array.from(this._consumables.keys()).filter(function (t) {
                  var s = _this67.getNormalized(t, e);
                  return s && "object" == typeof s ? Object.keys(s).length : s;
                }),
                s = new Set([].concat(_toConsumableArray(t), _toConsumableArray(Object.keys(e))));
              return Array.from(s.values());
            }
          }, {
            key: "getRelatedStyles",
            value: function getRelatedStyles(e) {
              return this._consumables.get(e) || [];
            }
          }, {
            key: "setNormalizer",
            value: function setNormalizer(e, t) {
              this._normalizers.set(e, t);
            }
          }, {
            key: "setExtractor",
            value: function setExtractor(e, t) {
              this._extractors.set(e, t);
            }
          }, {
            key: "setReducer",
            value: function setReducer(e, t) {
              this._reducers.set(e, t);
            }
          }, {
            key: "setStyleRelation",
            value: function setStyleRelation(e, t) {
              this._mapStyleNames(e, t);
              var _iterator256 = _createForOfIteratorHelper(t),
                _step256;
              try {
                for (_iterator256.s(); !(_step256 = _iterator256.n()).done;) {
                  var _s173 = _step256.value;
                  this._mapStyleNames(_s173, [e]);
                }
              } catch (err) {
                _iterator256.e(err);
              } finally {
                _iterator256.f();
              }
            }
          }, {
            key: "_mapStyleNames",
            value: function _mapStyleNames(e, t) {
              var _this$_consumables$ge;
              this._consumables.has(e) || this._consumables.set(e, []), (_this$_consumables$ge = this._consumables.get(e)).push.apply(_this$_consumables$ge, _toConsumableArray(t));
            }
          }]);
          return ee;
        }();
        function te(e) {
          return e.replace("-", ".");
        }
        function se(e, t, s) {
          var o = s;
          (0, D.Z)(s) && (o = K({}, Z(e, t), s)), Q(e, t, o);
        }
      },
      "./packages/ckeditor5-engine/src/view/text.js": function _packages_ckeditor5Engine_src_view_textJs(e, t, s) {
        "use strict";

        s.d(t, {
          Z: function Z() {
            return i;
          }
        });
        var o = s("./packages/ckeditor5-engine/src/view/node.js");
        var i = /*#__PURE__*/function (_o$Z22) {
          _inherits(i, _o$Z22);
          function i(e, t) {
            var _this68;
            _classCallCheck(this, i);
            _this68 = _possibleConstructorReturn(this, _getPrototypeOf(i).call(this, e)), _this68._textData = t;
            return _this68;
          }
          _createClass(i, [{
            key: "is",
            value: function is(e) {
              return "$text" === e || "view:$text" === e || "text" === e || "view:text" === e || "node" === e || "view:node" === e;
            }
          }, {
            key: "isSimilar",
            value: function isSimilar(e) {
              return e instanceof i && (this === e || this.data === e.data);
            }
          }, {
            key: "_clone",
            value: function _clone() {
              return new i(this.document, this.data);
            }
          }, {
            key: "data",
            get: function get() {
              return this._textData;
            }
          }, {
            key: "_data",
            get: function get() {
              return this.data;
            },
            set: function set(e) {
              this._fireChange("text", this), this._textData = e;
            }
          }]);
          return i;
        }(o.Z);
      },
      "./packages/ckeditor5-engine/src/view/textproxy.js": function _packages_ckeditor5Engine_src_view_textproxyJs(e, t, s) {
        "use strict";

        s.d(t, {
          Z: function Z() {
            return i;
          }
        });
        var o = s("./packages/ckeditor5-utils/src/ckeditorerror.js");
        var i = /*#__PURE__*/function () {
          function i(e, t, s) {
            _classCallCheck(this, i);
            if (this.textNode = e, t < 0 || t > e.data.length) throw new o.ZP("view-textproxy-wrong-offsetintext", this);
            if (s < 0 || t + s > e.data.length) throw new o.ZP("view-textproxy-wrong-length", this);
            this.data = e.data.substring(t, t + s), this.offsetInText = t;
          }
          _createClass(i, [{
            key: "is",
            value: function is(e) {
              return "$textProxy" === e || "view:$textProxy" === e || "textProxy" === e || "view:textProxy" === e;
            }
          }, {
            key: "getAncestors",
            value: function getAncestors() {
              var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
                includeSelf: !1,
                parentFirst: !1
              };
              var t = [];
              var s = e.includeSelf ? this.textNode : this.parent;
              for (; null !== s;) t[e.parentFirst ? "push" : "unshift"](s), s = s.parent;
              return t;
            }
          }, {
            key: "offsetSize",
            get: function get() {
              return this.data.length;
            }
          }, {
            key: "isPartial",
            get: function get() {
              return this.data.length !== this.textNode.data.length;
            }
          }, {
            key: "parent",
            get: function get() {
              return this.textNode.parent;
            }
          }, {
            key: "root",
            get: function get() {
              return this.textNode.root;
            }
          }, {
            key: "document",
            get: function get() {
              return this.textNode.document;
            }
          }]);
          return i;
        }();
      },
      "./packages/ckeditor5-engine/src/view/treewalker.js": function _packages_ckeditor5Engine_src_view_treewalkerJs(e, t, s) {
        "use strict";

        s.d(t, {
          Z: function Z() {
            return c;
          }
        });
        var o = s("./packages/ckeditor5-engine/src/view/element.js"),
          i = s("./packages/ckeditor5-engine/src/view/text.js"),
          r = s("./packages/ckeditor5-engine/src/view/textproxy.js"),
          n = s("./packages/ckeditor5-engine/src/view/position.js"),
          a = s("./packages/ckeditor5-utils/src/ckeditorerror.js");
        var c = /*#__PURE__*/function () {
          function c() {
            var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
            _classCallCheck(this, c);
            if (!e.boundaries && !e.startPosition) throw new a.ZP("view-tree-walker-no-start-position", null);
            if (e.direction && "forward" != e.direction && "backward" != e.direction) throw new a.ZP("view-tree-walker-unknown-direction", e.startPosition, {
              direction: e.direction
            });
            this.boundaries = e.boundaries || null, e.startPosition ? this.position = n.Z._createAt(e.startPosition) : this.position = n.Z._createAt(e.boundaries["backward" == e.direction ? "end" : "start"]), this.direction = e.direction || "forward", this.singleCharacters = !!e.singleCharacters, this.shallow = !!e.shallow, this.ignoreElementEnd = !!e.ignoreElementEnd, this._boundaryStartParent = this.boundaries ? this.boundaries.start.parent : null, this._boundaryEndParent = this.boundaries ? this.boundaries.end.parent : null;
          }
          _createClass(c, [{
            key: Symbol.iterator,
            value: function value() {
              return this;
            }
          }, {
            key: "skip",
            value: function skip(e) {
              var t, s, o;
              do {
                var _this$next2;
                o = this.position, _this$next2 = this.next(), t = _this$next2.done, s = _this$next2.value, _this$next2;
              } while (!t && e(s));
              t || (this.position = o);
            }
          }, {
            key: "next",
            value: function next() {
              return "forward" == this.direction ? this._next() : this._previous();
            }
          }, {
            key: "_next",
            value: function _next() {
              var e = this.position.clone();
              var t = this.position,
                s = e.parent;
              if (null === s.parent && e.offset === s.childCount) return {
                done: !0
              };
              if (s === this._boundaryEndParent && e.offset == this.boundaries.end.offset) return {
                done: !0
              };
              var a;
              if (s instanceof i.Z) {
                if (e.isAtEnd) return this.position = n.Z._createAfter(s), this._next();
                a = s.data[e.offset];
              } else a = s.getChild(e.offset);
              if (a instanceof o.Z) return this.shallow ? e.offset++ : e = new n.Z(a, 0), this.position = e, this._formatReturnValue("elementStart", a, t, e, 1);
              if (a instanceof i.Z) {
                if (this.singleCharacters) return e = new n.Z(a, 0), this.position = e, this._next();
                {
                  var _s174,
                    _o108 = a.data.length;
                  return a == this._boundaryEndParent ? (_o108 = this.boundaries.end.offset, _s174 = new r.Z(a, 0, _o108), e = n.Z._createAfter(_s174)) : (_s174 = new r.Z(a, 0, a.data.length), e.offset++), this.position = e, this._formatReturnValue("text", _s174, t, e, _o108);
                }
              }
              if ("string" == typeof a) {
                var _o109;
                if (this.singleCharacters) _o109 = 1;else {
                  _o109 = (s === this._boundaryEndParent ? this.boundaries.end.offset : s.data.length) - e.offset;
                }
                var _i92 = new r.Z(s, e.offset, _o109);
                return e.offset += _o109, this.position = e, this._formatReturnValue("text", _i92, t, e, _o109);
              }
              return e = n.Z._createAfter(s), this.position = e, this.ignoreElementEnd ? this._next() : this._formatReturnValue("elementEnd", s, t, e);
            }
          }, {
            key: "_previous",
            value: function _previous() {
              var e = this.position.clone();
              var t = this.position,
                s = e.parent;
              if (null === s.parent && 0 === e.offset) return {
                done: !0
              };
              if (s == this._boundaryStartParent && e.offset == this.boundaries.start.offset) return {
                done: !0
              };
              var a;
              if (s instanceof i.Z) {
                if (e.isAtStart) return this.position = n.Z._createBefore(s), this._previous();
                a = s.data[e.offset - 1];
              } else a = s.getChild(e.offset - 1);
              if (a instanceof o.Z) return this.shallow ? (e.offset--, this.position = e, this._formatReturnValue("elementStart", a, t, e, 1)) : (e = new n.Z(a, a.childCount), this.position = e, this.ignoreElementEnd ? this._previous() : this._formatReturnValue("elementEnd", a, t, e));
              if (a instanceof i.Z) {
                if (this.singleCharacters) return e = new n.Z(a, a.data.length), this.position = e, this._previous();
                {
                  var _s175,
                    _o110 = a.data.length;
                  if (a == this._boundaryStartParent) {
                    var _t174 = this.boundaries.start.offset;
                    _s175 = new r.Z(a, _t174, a.data.length - _t174), _o110 = _s175.data.length, e = n.Z._createBefore(_s175);
                  } else _s175 = new r.Z(a, 0, a.data.length), e.offset--;
                  return this.position = e, this._formatReturnValue("text", _s175, t, e, _o110);
                }
              }
              if ("string" == typeof a) {
                var _o111;
                if (this.singleCharacters) _o111 = 1;else {
                  var _t175 = s === this._boundaryStartParent ? this.boundaries.start.offset : 0;
                  _o111 = e.offset - _t175;
                }
                e.offset -= _o111;
                var _i93 = new r.Z(s, e.offset, _o111);
                return this.position = e, this._formatReturnValue("text", _i93, t, e, _o111);
              }
              return e = n.Z._createBefore(s), this.position = e, this._formatReturnValue("elementStart", s, t, e, 1);
            }
          }, {
            key: "_formatReturnValue",
            value: function _formatReturnValue(e, t, s, o, i) {
              return t instanceof r.Z && (t.offsetInText + t.data.length == t.textNode.data.length && ("forward" != this.direction || this.boundaries && this.boundaries.end.isEqual(this.position) ? s = n.Z._createAfter(t.textNode) : (o = n.Z._createAfter(t.textNode), this.position = o)), 0 === t.offsetInText && ("backward" != this.direction || this.boundaries && this.boundaries.start.isEqual(this.position) ? s = n.Z._createBefore(t.textNode) : (o = n.Z._createBefore(t.textNode), this.position = o))), {
                done: !1,
                value: {
                  type: e,
                  item: t,
                  previousPosition: s,
                  nextPosition: o,
                  length: i
                }
              };
            }
          }]);
          return c;
        }();
      },
      "./packages/ckeditor5-engine/src/view/uielement.js": function _packages_ckeditor5Engine_src_view_uielementJs(e, t, s) {
        "use strict";

        s.d(t, {
          Z: function Z() {
            return a;
          },
          h: function h() {
            return c;
          }
        });
        var o = s("./packages/ckeditor5-engine/src/view/element.js"),
          i = s("./packages/ckeditor5-utils/src/ckeditorerror.js"),
          r = s("./packages/ckeditor5-engine/src/view/node.js"),
          n = s("./packages/ckeditor5-utils/src/keyboard.js");
        var a = /*#__PURE__*/function (_o$Z23) {
          _inherits(a, _o$Z23);
          function a(e, t, s, o) {
            var _this69;
            _classCallCheck(this, a);
            _this69 = _possibleConstructorReturn(this, _getPrototypeOf(a).call(this, e, t, s, o)), _this69._isAllowedInsideAttributeElement = !0, _this69.getFillerOffset = l;
            return _this69;
          }
          _createClass(a, [{
            key: "is",
            value: function is(e) {
              var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
              return t ? t === this.name && ("uiElement" === e || "view:uiElement" === e || "element" === e || "view:element" === e) : "uiElement" === e || "view:uiElement" === e || "element" === e || "view:element" === e || "node" === e || "view:node" === e;
            }
          }, {
            key: "_insertChild",
            value: function _insertChild(e, t) {
              if (t && (t instanceof r.Z || Array.from(t).length > 0)) throw new i.ZP("view-uielement-cannot-add", this);
            }
          }, {
            key: "render",
            value: function render(e) {
              return this.toDomElement(e);
            }
          }, {
            key: "toDomElement",
            value: function toDomElement(e) {
              var t = e.createElement(this.name);
              var _iterator257 = _createForOfIteratorHelper(this.getAttributeKeys()),
                _step257;
              try {
                for (_iterator257.s(); !(_step257 = _iterator257.n()).done;) {
                  var _e184 = _step257.value;
                  t.setAttribute(_e184, this.getAttribute(_e184));
                }
              } catch (err) {
                _iterator257.e(err);
              } finally {
                _iterator257.f();
              }
              return t;
            }
          }]);
          return a;
        }(o.Z);
        function c(e) {
          e.document.on("arrowKey", function (t, s) {
            return function (e, t, s) {
              if (t.keyCode == n.Do.arrowright) {
                var _e185 = t.domTarget.ownerDocument.defaultView.getSelection(),
                  _o112 = 1 == _e185.rangeCount && _e185.getRangeAt(0).collapsed;
                if (_o112 || t.shiftKey) {
                  var _t176 = _e185.focusNode,
                    _i94 = _e185.focusOffset,
                    _r45 = s.domPositionToView(_t176, _i94);
                  if (null === _r45) return;
                  var _n23 = !1;
                  var _a13 = _r45.getLastMatchingPosition(function (e) {
                    return e.item.is("uiElement") && (_n23 = !0), !(!e.item.is("uiElement") && !e.item.is("attributeElement"));
                  });
                  if (_n23) {
                    var _t177 = s.viewPositionToDom(_a13);
                    _o112 ? _e185.collapse(_t177.parent, _t177.offset) : _e185.extend(_t177.parent, _t177.offset);
                  }
                }
              }
            }(0, s, e.domConverter);
          }, {
            priority: "low"
          });
        }
        function l() {
          return null;
        }
      },
      "./packages/ckeditor5-enter/src/enter.js": function _packages_ckeditor5Enter_src_enterJs(e, t, s) {
        "use strict";

        s.d(t, {
          Z: function Z() {
            return l;
          }
        });
        var o = s("./packages/ckeditor5-core/src/plugin.js"),
          i = s("./packages/ckeditor5-core/src/command.js"),
          r = s("./packages/ckeditor5-enter/src/utils.js");
        var n = /*#__PURE__*/function (_i$Z2) {
          _inherits(n, _i$Z2);
          function n() {
            _classCallCheck(this, n);
            return _possibleConstructorReturn(this, _getPrototypeOf(n).apply(this, arguments));
          }
          _createClass(n, [{
            key: "execute",
            value: function execute() {
              var _this70 = this;
              var e = this.editor.model,
                t = e.document;
              e.change(function (s) {
                !function (e, t, s, o) {
                  var i = s.isCollapsed,
                    n = s.getFirstRange(),
                    c = n.start.parent,
                    l = n.end.parent;
                  if (o.isLimit(c) || o.isLimit(l)) return void (i || c != l || e.deleteContent(s));
                  if (i) {
                    var _e186 = (0, r.G)(t.model.schema, s.getAttributes());
                    a(t, n.start), t.setSelectionAttribute(_e186);
                  } else {
                    var _o113 = !(n.start.isAtStart && n.end.isAtEnd),
                      _i95 = c == l;
                    e.deleteContent(s, {
                      leaveUnmerged: _o113
                    }), _o113 && (_i95 ? a(t, s.focus) : t.setSelection(l, 0));
                  }
                }(_this70.editor.model, s, t.selection, e.schema), _this70.fire("afterExecute", {
                  writer: s
                });
              });
            }
          }]);
          return n;
        }(i.Z);
        function a(e, t) {
          e.split(t), e.setSelection(t.parent.nextSibling, 0);
        }
        var c = s("./packages/ckeditor5-enter/src/enterobserver.js");
        var l = /*#__PURE__*/function (_o$Z24) {
          _inherits(l, _o$Z24);
          function l() {
            _classCallCheck(this, l);
            return _possibleConstructorReturn(this, _getPrototypeOf(l).apply(this, arguments));
          }
          _createClass(l, [{
            key: "init",
            value: function init() {
              var e = this.editor,
                t = e.editing.view,
                s = t.document;
              t.addObserver(c.Z), e.commands.add("enter", new n(e)), this.listenTo(s, "enter", function (s, o) {
                o.preventDefault(), o.isSoft || (e.execute("enter"), t.scrollToTheSelection());
              }, {
                priority: "low"
              });
            }
          }], [{
            key: "pluginName",
            get: function get() {
              return "Enter";
            }
          }]);
          return l;
        }(o.Z);
      },
      "./packages/ckeditor5-enter/src/enterobserver.js": function _packages_ckeditor5Enter_src_enterobserverJs(e, t, s) {
        "use strict";

        s.d(t, {
          Z: function Z() {
            return a;
          }
        });
        var o = s("./packages/ckeditor5-engine/src/view/observer/observer.js"),
          i = s("./packages/ckeditor5-engine/src/view/observer/domeventdata.js"),
          r = s("./packages/ckeditor5-engine/src/view/observer/bubblingeventinfo.js"),
          n = s("./packages/ckeditor5-utils/src/keyboard.js");
        var a = /*#__PURE__*/function (_o$Z25) {
          _inherits(a, _o$Z25);
          function a(e) {
            var _this71;
            _classCallCheck(this, a);
            _this71 = _possibleConstructorReturn(this, _getPrototypeOf(a).call(this, e));
            var t = _this71.document;
            t.on("keydown", function (e, s) {
              if (_this71.isEnabled && s.keyCode == n.Do.enter) {
                var _o114 = new r.Z(t, "enter", t.selection.getFirstRange());
                t.fire(_o114, new i.Z(t, s.domEvent, {
                  isSoft: s.shiftKey
                })), _o114.stop.called && e.stop();
              }
            });
            return _this71;
          }
          _createClass(a, [{
            key: "observe",
            value: function observe() {}
          }]);
          return a;
        }(o.Z);
      },
      "./packages/ckeditor5-enter/src/utils.js": function _packages_ckeditor5Enter_src_utilsJs(e, t, s) {
        "use strict";

        var _marked3 = /*#__PURE__*/_regeneratorRuntime().mark(o);
        function o(e, t) {
          var _iterator258, _step258, _s176;
          return _regeneratorRuntime().wrap(function o$(_context30) {
            while (1) switch (_context30.prev = _context30.next) {
              case 0:
                _iterator258 = _createForOfIteratorHelper(t);
                _context30.prev = 1;
                _iterator258.s();
              case 3:
                if ((_step258 = _iterator258.n()).done) {
                  _context30.next = 11;
                  break;
                }
                _s176 = _step258.value;
                _context30.t0 = _s176 && e.getAttributeProperties(_s176[0]).copyOnEnter;
                if (!_context30.t0) {
                  _context30.next = 9;
                  break;
                }
                _context30.next = 9;
                return _s176;
              case 9:
                _context30.next = 3;
                break;
              case 11:
                _context30.next = 16;
                break;
              case 13:
                _context30.prev = 13;
                _context30.t1 = _context30["catch"](1);
                _iterator258.e(_context30.t1);
              case 16:
                _context30.prev = 16;
                _iterator258.f();
                return _context30.finish(16);
              case 19:
              case "end":
                return _context30.stop();
            }
          }, _marked3, null, [[1, 13, 16, 19]]);
        }
        s.d(t, {
          G: function G() {
            return o;
          }
        });
      },
      "./packages/ckeditor5-typing/src/delete.js": function _packages_ckeditor5Typing_src_deleteJs(e, t, s) {
        "use strict";

        s.d(t, {
          Z: function Z() {
            return f;
          }
        });
        var o = s("./packages/ckeditor5-core/src/plugin.js"),
          i = s("./packages/ckeditor5-core/src/command.js"),
          r = s("./packages/ckeditor5-utils/src/count.js"),
          n = s("./packages/ckeditor5-typing/src/utils/changebuffer.js");
        var a = /*#__PURE__*/function (_i$Z3) {
          _inherits(a, _i$Z3);
          function a(e, t) {
            var _this72;
            _classCallCheck(this, a);
            _this72 = _possibleConstructorReturn(this, _getPrototypeOf(a).call(this, e)), _this72.direction = t, _this72._buffer = new n.Z(e.model, e.config.get("typing.undoStep"));
            return _this72;
          }
          _createClass(a, [{
            key: "execute",
            value: function execute() {
              var _this73 = this;
              var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
              var t = this.editor.model,
                s = t.document;
              t.enqueueChange(this._buffer.batch, function (o) {
                _this73._buffer.lock();
                var i = o.createSelection(e.selection || s.selection),
                  n = e.sequence || 1,
                  a = i.isCollapsed;
                if (i.isCollapsed && t.modifySelection(i, {
                  direction: _this73.direction,
                  unit: e.unit,
                  treatEmojiAsSingleUnit: !0
                }), _this73._shouldEntireContentBeReplacedWithParagraph(n)) return void _this73._replaceEntireContentWithParagraph(o);
                if (_this73._shouldReplaceFirstBlockWithParagraph(i, n)) return void _this73.editor.execute("paragraph", {
                  selection: i
                });
                if (i.isCollapsed) return;
                var c = 0;
                i.getFirstRange().getMinimalFlatRanges().forEach(function (e) {
                  c += (0, r.Z)(e.getWalker({
                    singleCharacters: !0,
                    ignoreElementEnd: !0,
                    shallow: !0
                  }));
                }), t.deleteContent(i, {
                  doNotResetEntireContent: a,
                  direction: _this73.direction
                }), _this73._buffer.input(c), o.setSelection(i), _this73._buffer.unlock();
              });
            }
          }, {
            key: "_shouldEntireContentBeReplacedWithParagraph",
            value: function _shouldEntireContentBeReplacedWithParagraph(e) {
              if (e > 1) return !1;
              var t = this.editor.model,
                s = t.document.selection,
                o = t.schema.getLimitElement(s);
              if (!(s.isCollapsed && s.containsEntireContent(o))) return !1;
              if (!t.schema.checkChild(o, "paragraph")) return !1;
              var i = o.getChild(0);
              return !i || "paragraph" !== i.name;
            }
          }, {
            key: "_replaceEntireContentWithParagraph",
            value: function _replaceEntireContentWithParagraph(e) {
              var t = this.editor.model,
                s = t.document.selection,
                o = t.schema.getLimitElement(s),
                i = e.createElement("paragraph");
              e.remove(e.createRangeIn(o)), e.insert(i, o), e.setSelection(i, 0);
            }
          }, {
            key: "_shouldReplaceFirstBlockWithParagraph",
            value: function _shouldReplaceFirstBlockWithParagraph(e, t) {
              var s = this.editor.model;
              if (t > 1 || "backward" != this.direction) return !1;
              if (!e.isCollapsed) return !1;
              var o = e.getFirstPosition(),
                i = s.schema.getLimitElement(o),
                r = i.getChild(0);
              return o.parent == r && !!e.containsEntireContent(r) && !!s.schema.checkChild(i, "paragraph") && "paragraph" != r.name;
            }
          }, {
            key: "buffer",
            get: function get() {
              return this._buffer;
            }
          }]);
          return a;
        }(i.Z);
        var c = s("./packages/ckeditor5-engine/src/view/observer/observer.js"),
          l = s("./packages/ckeditor5-engine/src/view/observer/domeventdata.js"),
          d = s("./packages/ckeditor5-engine/src/view/observer/bubblingeventinfo.js"),
          h = s("./packages/ckeditor5-utils/src/keyboard.js"),
          u = s("./packages/ckeditor5-utils/src/env.js"),
          g = s("./packages/ckeditor5-typing/src/utils/utils.js");
        var p = /*#__PURE__*/function (_c$Z3) {
          _inherits(p, _c$Z3);
          function p(e) {
            var _this74;
            _classCallCheck(this, p);
            _this74 = _possibleConstructorReturn(this, _getPrototypeOf(p).call(this, e));
            var t = e.document;
            var s = 0;
            function o(e, s, o) {
              var i = new d.Z(t, "delete", t.selection.getFirstRange());
              t.fire(i, new l.Z(t, s, o)), i.stop.called && e.stop();
            }
            t.on("keyup", function (e, t) {
              t.keyCode != h.Do.delete && t.keyCode != h.Do.backspace || (s = 0);
            }), t.on("keydown", function (e, i) {
              if (u.ZP.isWindows && (0, g.Uw)(i, t)) return;
              var r = {};
              if (i.keyCode == h.Do.delete) r.direction = "forward", r.unit = "character";else {
                if (i.keyCode != h.Do.backspace) return;
                r.direction = "backward", r.unit = "codePoint";
              }
              var n = u.ZP.isMac ? i.altKey : i.ctrlKey;
              r.unit = n ? "word" : r.unit, r.sequence = ++s, o(e, i.domEvent, r);
            }), u.ZP.isAndroid && t.on("beforeinput", function (t, s) {
              if ("deleteContentBackward" != s.domEvent.inputType) return;
              var i = {
                  unit: "codepoint",
                  direction: "backward",
                  sequence: 1
                },
                r = s.domTarget.ownerDocument.defaultView.getSelection();
              r.anchorNode == r.focusNode && r.anchorOffset + 1 != r.focusOffset && (i.selectionToRemove = e.domConverter.domSelectionToView(r)), o(t, s.domEvent, i);
            });
            return _this74;
          }
          _createClass(p, [{
            key: "observe",
            value: function observe() {}
          }]);
          return p;
        }(c.Z);
        var f = /*#__PURE__*/function (_o$Z26) {
          _inherits(f, _o$Z26);
          function f() {
            _classCallCheck(this, f);
            return _possibleConstructorReturn(this, _getPrototypeOf(f).apply(this, arguments));
          }
          _createClass(f, [{
            key: "init",
            value: function init() {
              var _this75 = this;
              var e = this.editor,
                t = e.editing.view,
                s = t.document,
                o = e.model.document;
              t.addObserver(p), this._undoOnBackspace = !1;
              var i = new a(e, "forward");
              if (e.commands.add("deleteForward", i), e.commands.add("forwardDelete", i), e.commands.add("delete", new a(e, "backward")), this.listenTo(s, "delete", function (s, o) {
                var i = {
                  unit: o.unit,
                  sequence: o.sequence
                };
                if (o.selectionToRemove) {
                  var _t178 = e.model.createSelection(),
                    _s177 = [];
                  var _iterator259 = _createForOfIteratorHelper(o.selectionToRemove.getRanges()),
                    _step259;
                  try {
                    for (_iterator259.s(); !(_step259 = _iterator259.n()).done;) {
                      var _t179 = _step259.value;
                      _s177.push(e.editing.mapper.toModelRange(_t179));
                    }
                  } catch (err) {
                    _iterator259.e(err);
                  } finally {
                    _iterator259.f();
                  }
                  _t178.setTo(_s177), i.selection = _t178;
                }
                e.execute("forward" == o.direction ? "deleteForward" : "delete", i), o.preventDefault(), t.scrollToTheSelection();
              }, {
                priority: "low"
              }), u.ZP.isAndroid) {
                var _e187 = null;
                this.listenTo(s, "delete", function (t, s) {
                  var o = s.domTarget.ownerDocument.defaultView.getSelection();
                  _e187 = {
                    anchorNode: o.anchorNode,
                    anchorOffset: o.anchorOffset,
                    focusNode: o.focusNode,
                    focusOffset: o.focusOffset
                  };
                }, {
                  priority: "lowest"
                }), this.listenTo(s, "keyup", function (t, s) {
                  if (_e187) {
                    var _t180 = s.domTarget.ownerDocument.defaultView.getSelection();
                    _t180.collapse(_e187.anchorNode, _e187.anchorOffset), _t180.extend(_e187.focusNode, _e187.focusOffset), _e187 = null;
                  }
                });
              }
              this.editor.plugins.has("UndoEditing") && (this.listenTo(s, "delete", function (t, s) {
                _this75._undoOnBackspace && "backward" == s.direction && 1 == s.sequence && "codePoint" == s.unit && (_this75._undoOnBackspace = !1, e.execute("undo"), s.preventDefault(), t.stop());
              }, {
                context: "$capture"
              }), this.listenTo(o, "change", function () {
                _this75._undoOnBackspace = !1;
              }));
            }
          }, {
            key: "requestUndoOnBackspace",
            value: function requestUndoOnBackspace() {
              this.editor.plugins.has("UndoEditing") && (this._undoOnBackspace = !0);
            }
          }], [{
            key: "pluginName",
            get: function get() {
              return "Delete";
            }
          }]);
          return f;
        }(o.Z);
      },
      "./packages/ckeditor5-typing/src/utils/changebuffer.js": function _packages_ckeditor5Typing_src_utils_changebufferJs(e, t, s) {
        "use strict";

        s.d(t, {
          Z: function Z() {
            return o;
          }
        });
        var o = /*#__PURE__*/function () {
          function o(e) {
            var _this76 = this;
            var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 20;
            _classCallCheck(this, o);
            this.model = e, this.size = 0, this.limit = t, this.isLocked = !1, this._changeCallback = function (e, t) {
              t.isLocal && t.isUndoable && t !== _this76._batch && _this76._reset(!0);
            }, this._selectionChangeCallback = function () {
              _this76._reset();
            }, this.model.document.on("change", this._changeCallback), this.model.document.selection.on("change:range", this._selectionChangeCallback), this.model.document.selection.on("change:attribute", this._selectionChangeCallback);
          }
          _createClass(o, [{
            key: "input",
            value: function input(e) {
              this.size += e, this.size >= this.limit && this._reset(!0);
            }
          }, {
            key: "lock",
            value: function lock() {
              this.isLocked = !0;
            }
          }, {
            key: "unlock",
            value: function unlock() {
              this.isLocked = !1;
            }
          }, {
            key: "destroy",
            value: function destroy() {
              this.model.document.off("change", this._changeCallback), this.model.document.selection.off("change:range", this._selectionChangeCallback), this.model.document.selection.off("change:attribute", this._selectionChangeCallback);
            }
          }, {
            key: "_reset",
            value: function _reset(e) {
              this.isLocked && !e || (this._batch = null, this.size = 0);
            }
          }, {
            key: "batch",
            get: function get() {
              return this._batch || (this._batch = this.model.createBatch({
                isTyping: !0
              })), this._batch;
            }
          }]);
          return o;
        }();
      },
      "./packages/ckeditor5-typing/src/utils/injectunsafekeystrokeshandling.js": function _packages_ckeditor5Typing_src_utils_injectunsafekeystrokeshandlingJs(e, t, s) {
        "use strict";

        s.d(t, {
          Z: function Z() {
            return n;
          },
          u: function u() {
            return c;
          }
        });
        var o = s("./packages/ckeditor5-utils/src/keyboard.js"),
          i = s("./packages/ckeditor5-utils/src/env.js"),
          r = s("./packages/ckeditor5-typing/src/utils/utils.js");
        function n(e) {
          var t = null;
          var s = e.model,
            o = e.editing.view,
            n = e.commands.get("input");
          function a(e) {
            if (i.ZP.isWindows && (0, r.Uw)(e, o.document)) return;
            var a = s.document,
              d = o.document.isComposing,
              h = t && t.isEqual(a.selection);
            t = null, n.isEnabled && (c(e) || a.selection.isCollapsed || d && 229 === e.keyCode || !d && 229 === e.keyCode && h || l());
          }
          function l() {
            var e = n.buffer;
            e.lock();
            var t = e.batch;
            s.enqueueChange(t, function () {
              s.deleteContent(s.document.selection);
            }), e.unlock();
          }
          i.ZP.isAndroid ? o.document.on("beforeinput", function (e, t) {
            return a(t);
          }, {
            priority: "lowest"
          }) : o.document.on("keydown", function (e, t) {
            return a(t);
          }, {
            priority: "lowest"
          }), o.document.on("compositionstart", function () {
            var e = s.document,
              t = 1 !== e.selection.rangeCount || e.selection.getFirstRange().isFlat;
            if (e.selection.isCollapsed || t) return;
            l();
          }, {
            priority: "lowest"
          }), o.document.on("compositionend", function () {
            t = s.createSelection(s.document.selection);
          }, {
            priority: "lowest"
          });
        }
        var a = [(0, o.Cq)("arrowUp"), (0, o.Cq)("arrowRight"), (0, o.Cq)("arrowDown"), (0, o.Cq)("arrowLeft"), 9, 16, 17, 18, 19, 20, 27, 33, 34, 35, 36, 45, 91, 93, 144, 145, 173, 174, 175, 176, 177, 178, 179, 255];
        for (var _e188 = 112; _e188 <= 135; _e188++) a.push(_e188);
        function c(e) {
          return !(!e.ctrlKey && !e.metaKey) || a.includes(e.keyCode);
        }
      },
      "./packages/ckeditor5-typing/src/utils/utils.js": function _packages_ckeditor5Typing_src_utils_utilsJs(e, t, s) {
        "use strict";

        s.d(t, {
          E9: function E9() {
            return r;
          },
          xG: function xG() {
            return n;
          },
          Uw: function Uw() {
            return c;
          }
        });
        var o = s("./packages/ckeditor5-utils/src/diff.js");
        var i = s("./packages/ckeditor5-utils/src/keyboard.js");
        function r(e) {
          if (0 == e.length) return !1;
          var _iterator260 = _createForOfIteratorHelper(e),
            _step260;
          try {
            for (_iterator260.s(); !(_step260 = _iterator260.n()).done;) {
              var _t181 = _step260.value;
              if ("children" === _t181.type && !n(_t181)) return !0;
            }
          } catch (err) {
            _iterator260.e(err);
          } finally {
            _iterator260.f();
          }
          return !1;
        }
        function n(e) {
          if (e.newChildren.length - e.oldChildren.length != 1) return;
          var t = function (e, t) {
            var s = [];
            var o,
              i = 0;
            return e.forEach(function (e) {
              "equal" == e ? (r(), i++) : "insert" == e ? (n("insert") ? o.values.push(t[i]) : (r(), o = {
                type: "insert",
                index: i,
                values: [t[i]]
              }), i++) : n("delete") ? o.howMany++ : (r(), o = {
                type: "delete",
                index: i,
                howMany: 1
              });
            }), r(), s;
            function r() {
              o && (s.push(o), o = null);
            }
            function n(e) {
              return o && o.type == e;
            }
          }((0, o.Z)(e.oldChildren, e.newChildren, a), e.newChildren);
          if (t.length > 1) return;
          var s = t[0];
          return s.values[0] && s.values[0].is("$text") ? s : void 0;
        }
        function a(e, t) {
          return e && e.is("$text") && t && t.is("$text") ? e.data === t.data : e === t;
        }
        function c(e, t) {
          var s = t.selection,
            o = e.shiftKey && e.keyCode === i.Do.delete,
            r = !s.isCollapsed;
          return o && r;
        }
      },
      "./packages/ckeditor5-ui/src/bindings/clickoutsidehandler.js": function _packages_ckeditor5Ui_src_bindings_clickoutsidehandlerJs(e, t, s) {
        "use strict";

        function o(_ref28) {
          var e = _ref28.emitter,
            t = _ref28.activator,
            s = _ref28.callback,
            o = _ref28.contextElements;
          e.listenTo(document, "mousedown", function (e, i) {
            if (!t()) return;
            var r = "function" == typeof i.composedPath ? i.composedPath() : [];
            var _iterator261 = _createForOfIteratorHelper(o),
              _step261;
            try {
              for (_iterator261.s(); !(_step261 = _iterator261.n()).done;) {
                var _e189 = _step261.value;
                if (_e189.contains(i.target) || r.includes(_e189)) return;
              }
            } catch (err) {
              _iterator261.e(err);
            } finally {
              _iterator261.f();
            }
            s();
          });
        }
        s.d(t, {
          Z: function Z() {
            return o;
          }
        });
      },
      "./packages/ckeditor5-ui/src/button/buttonview.js": function _packages_ckeditor5Ui_src_button_buttonviewJs(e, t, s) {
        "use strict";

        s.d(t, {
          Z: function Z() {
            return u;
          }
        });
        var o = s("./packages/ckeditor5-ui/src/view.js"),
          i = s("./packages/ckeditor5-ui/src/icon/iconview.js"),
          r = s("./packages/ckeditor5-ui/src/tooltip/tooltipview.js"),
          n = s("./packages/ckeditor5-utils/src/uid.js"),
          a = s("./packages/ckeditor5-utils/src/keyboard.js"),
          c = s("./node_modules/style-loader/dist/runtime/injectStylesIntoStyleTag.js"),
          l = s.n(c),
          d = s("./node_modules/css-loader/dist/cjs.js!./node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].use[2]!./packages/ckeditor5-ui/theme/components/button/button.css"),
          h = {
            injectType: "singletonStyleTag",
            attributes: {
              "data-cke": !0
            },
            insert: "head",
            singleton: !0
          };
        l()(d.Z, h);
        d.Z.locals;
        var u = /*#__PURE__*/function (_o$Z27) {
          _inherits(u, _o$Z27);
          function u(e) {
            var _this77;
            _classCallCheck(this, u);
            _this77 = _possibleConstructorReturn(this, _getPrototypeOf(u).call(this, e));
            var t = _this77.bindTemplate,
              s = (0, n.Z)();
            _this77.set("class"), _this77.set("labelStyle"), _this77.set("icon"), _this77.set("isEnabled", !0), _this77.set("isOn", !1), _this77.set("isVisible", !0), _this77.set("isToggleable", !1), _this77.set("keystroke"), _this77.set("label"), _this77.set("tabindex", -1), _this77.set("tooltip"), _this77.set("tooltipPosition", "s"), _this77.set("type", "button"), _this77.set("withText", !1), _this77.set("withKeystroke", !1), _this77.children = _this77.createCollection(), _this77.tooltipView = _this77._createTooltipView(), _this77.labelView = _this77._createLabelView(s), _this77.iconView = new i.Z(), _this77.iconView.extendTemplate({
              attributes: {
                class: "ck-button__icon"
              }
            }), _this77.keystrokeView = _this77._createKeystrokeView(), _this77.bind("_tooltipString").to(_assertThisInitialized(_assertThisInitialized(_this77)), "tooltip", _assertThisInitialized(_assertThisInitialized(_this77)), "label", _assertThisInitialized(_assertThisInitialized(_this77)), "keystroke", _this77._getTooltipString.bind(_assertThisInitialized(_assertThisInitialized(_this77)))), _this77.setTemplate({
              tag: "button",
              attributes: {
                class: ["ck", "ck-button", t.to("class"), t.if("isEnabled", "ck-disabled", function (e) {
                  return !e;
                }), t.if("isVisible", "ck-hidden", function (e) {
                  return !e;
                }), t.to("isOn", function (e) {
                  return e ? "ck-on" : "ck-off";
                }), t.if("withText", "ck-button_with-text"), t.if("withKeystroke", "ck-button_with-keystroke")],
                type: t.to("type", function (e) {
                  return e || "button";
                }),
                tabindex: t.to("tabindex"),
                "aria-labelledby": "ck-editor__aria-label_".concat(s),
                "aria-disabled": t.if("isEnabled", !0, function (e) {
                  return !e;
                }),
                "aria-pressed": t.to("isOn", function (e) {
                  return !!_this77.isToggleable && String(e);
                })
              },
              children: _this77.children,
              on: {
                mousedown: t.to(function (e) {
                  e.preventDefault();
                }),
                click: t.to(function (e) {
                  _this77.isEnabled ? _this77.fire("execute") : e.preventDefault();
                })
              }
            });
            return _this77;
          }
          _createClass(u, [{
            key: "render",
            value: function render() {
              _superPropGet(u, "render", this, 3)([]), this.icon && (this.iconView.bind("content").to(this, "icon"), this.children.add(this.iconView)), this.children.add(this.tooltipView), this.children.add(this.labelView), this.withKeystroke && this.keystroke && this.children.add(this.keystrokeView);
            }
          }, {
            key: "focus",
            value: function focus() {
              this.element.focus();
            }
          }, {
            key: "_createTooltipView",
            value: function _createTooltipView() {
              var e = new r.Z();
              return e.bind("text").to(this, "_tooltipString"), e.bind("position").to(this, "tooltipPosition"), e;
            }
          }, {
            key: "_createLabelView",
            value: function _createLabelView(e) {
              var t = new o.Z(),
                s = this.bindTemplate;
              return t.setTemplate({
                tag: "span",
                attributes: {
                  class: ["ck", "ck-button__label"],
                  style: s.to("labelStyle"),
                  id: "ck-editor__aria-label_".concat(e)
                },
                children: [{
                  text: this.bindTemplate.to("label")
                }]
              }), t;
            }
          }, {
            key: "_createKeystrokeView",
            value: function _createKeystrokeView() {
              var e = new o.Z();
              return e.setTemplate({
                tag: "span",
                attributes: {
                  class: ["ck", "ck-button__keystroke"]
                },
                children: [{
                  text: this.bindTemplate.to("keystroke", function (e) {
                    return (0, a.XU)(e);
                  })
                }]
              }), e;
            }
          }, {
            key: "_getTooltipString",
            value: function _getTooltipString(e, t, s) {
              return e ? "string" == typeof e ? e : (s && (s = (0, a.XU)(s)), e instanceof Function ? e(t, s) : "".concat(t).concat(s ? " (".concat(s, ")") : "")) : "";
            }
          }]);
          return u;
        }(o.Z);
      },
      "./packages/ckeditor5-ui/src/button/switchbuttonview.js": function _packages_ckeditor5Ui_src_button_switchbuttonviewJs(e, t, s) {
        "use strict";

        s.d(t, {
          Z: function Z() {
            return l;
          }
        });
        var o = s("./packages/ckeditor5-ui/src/view.js"),
          i = s("./packages/ckeditor5-ui/src/button/buttonview.js"),
          r = s("./node_modules/style-loader/dist/runtime/injectStylesIntoStyleTag.js"),
          n = s.n(r),
          a = s("./node_modules/css-loader/dist/cjs.js!./node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].use[2]!./packages/ckeditor5-ui/theme/components/button/switchbutton.css"),
          c = {
            injectType: "singletonStyleTag",
            attributes: {
              "data-cke": !0
            },
            insert: "head",
            singleton: !0
          };
        n()(a.Z, c);
        a.Z.locals;
        var l = /*#__PURE__*/function (_i$Z4) {
          _inherits(l, _i$Z4);
          function l(e) {
            var _this78;
            _classCallCheck(this, l);
            _this78 = _possibleConstructorReturn(this, _getPrototypeOf(l).call(this, e)), _this78.isToggleable = !0, _this78.toggleSwitchView = _this78._createToggleView(), _this78.extendTemplate({
              attributes: {
                class: "ck-switchbutton"
              }
            });
            return _this78;
          }
          _createClass(l, [{
            key: "render",
            value: function render() {
              _superPropGet(l, "render", this, 3)([]), this.children.add(this.toggleSwitchView);
            }
          }, {
            key: "_createToggleView",
            value: function _createToggleView() {
              var e = new o.Z();
              return e.setTemplate({
                tag: "span",
                attributes: {
                  class: ["ck", "ck-button__toggle"]
                },
                children: [{
                  tag: "span",
                  attributes: {
                    class: ["ck", "ck-button__toggle__inner"]
                  }
                }]
              }), e;
            }
          }]);
          return l;
        }(i.Z);
      },
      "./packages/ckeditor5-ui/src/dropdown/button/dropdownbuttonview.js": function _packages_ckeditor5Ui_src_dropdown_button_dropdownbuttonviewJs(e, t, s) {
        "use strict";

        s.d(t, {
          Z: function Z() {
            return n;
          }
        });
        var o = s("./packages/ckeditor5-ui/src/button/buttonview.js"),
          i = s("./packages/ckeditor5-ui/theme/icons/dropdown-arrow.svg"),
          r = s("./packages/ckeditor5-ui/src/icon/iconview.js");
        var n = /*#__PURE__*/function (_o$Z28) {
          _inherits(n, _o$Z28);
          function n(e) {
            var _this79;
            _classCallCheck(this, n);
            _this79 = _possibleConstructorReturn(this, _getPrototypeOf(n).call(this, e)), _this79.arrowView = _this79._createArrowView(), _this79.extendTemplate({
              attributes: {
                "aria-haspopup": !0
              }
            }), _this79.delegate("execute").to(_assertThisInitialized(_assertThisInitialized(_this79)), "open");
            return _this79;
          }
          _createClass(n, [{
            key: "render",
            value: function render() {
              _superPropGet(n, "render", this, 3)([]), this.children.add(this.arrowView);
            }
          }, {
            key: "_createArrowView",
            value: function _createArrowView() {
              var e = new r.Z();
              return e.content = i.Z, e.extendTemplate({
                attributes: {
                  class: "ck-dropdown__arrow"
                }
              }), e;
            }
          }]);
          return n;
        }(o.Z);
      },
      "./packages/ckeditor5-ui/src/dropdown/utils.js": function _packages_ckeditor5Ui_src_dropdown_utilsJs(e, t, s) {
        "use strict";

        s.d(t, {
          Pm: function Pm() {
            return x;
          },
          up: function up() {
            return j;
          },
          t9: function t9() {
            return P;
          }
        });
        var o = s("./packages/ckeditor5-ui/src/view.js");
        var i = /*#__PURE__*/function (_o$Z29) {
          _inherits(i, _o$Z29);
          function i(e) {
            var _this80;
            _classCallCheck(this, i);
            _this80 = _possibleConstructorReturn(this, _getPrototypeOf(i).call(this, e));
            var t = _this80.bindTemplate;
            _this80.set("isVisible", !1), _this80.set("position", "se"), _this80.children = _this80.createCollection(), _this80.setTemplate({
              tag: "div",
              attributes: {
                class: ["ck", "ck-reset", "ck-dropdown__panel", t.to("position", function (e) {
                  return "ck-dropdown__panel_".concat(e);
                }), t.if("isVisible", "ck-dropdown__panel-visible")]
              },
              children: _this80.children,
              on: {
                selectstart: t.to(function (e) {
                  return e.preventDefault();
                })
              }
            });
            return _this80;
          }
          _createClass(i, [{
            key: "focus",
            value: function focus() {
              this.children.length && this.children.first.focus();
            }
          }, {
            key: "focusLast",
            value: function focusLast() {
              if (this.children.length) {
                var _e190 = this.children.last;
                "function" == typeof _e190.focusLast ? _e190.focusLast() : _e190.focus();
              }
            }
          }]);
          return i;
        }(o.Z);
        var r = s("./packages/ckeditor5-utils/src/keystrokehandler.js"),
          n = s("./node_modules/style-loader/dist/runtime/injectStylesIntoStyleTag.js"),
          a = s.n(n),
          c = s("./node_modules/css-loader/dist/cjs.js!./node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].use[2]!./packages/ckeditor5-ui/theme/components/dropdown/dropdown.css"),
          l = {
            injectType: "singletonStyleTag",
            attributes: {
              "data-cke": !0
            },
            insert: "head",
            singleton: !0
          };
        a()(c.Z, l);
        c.Z.locals;
        var d = s("./packages/ckeditor5-utils/src/dom/position.js");
        var h = /*#__PURE__*/function (_o$Z30) {
          _inherits(h, _o$Z30);
          function h(e, t, s) {
            var _this81;
            _classCallCheck(this, h);
            _this81 = _possibleConstructorReturn(this, _getPrototypeOf(h).call(this, e));
            var o = _this81.bindTemplate;
            _this81.buttonView = t, _this81.panelView = s, _this81.set("isOpen", !1), _this81.set("isEnabled", !0), _this81.set("class"), _this81.set("id"), _this81.set("panelPosition", "auto"), _this81.keystrokes = new r.Z(), _this81.setTemplate({
              tag: "div",
              attributes: {
                class: ["ck", "ck-dropdown", o.to("class"), o.if("isEnabled", "ck-disabled", function (e) {
                  return !e;
                })],
                id: o.to("id"),
                "aria-describedby": o.to("ariaDescribedById")
              },
              children: [t, s]
            }), t.extendTemplate({
              attributes: {
                class: ["ck-dropdown__button"]
              }
            });
            return _this81;
          }
          _createClass(h, [{
            key: "render",
            value: function render() {
              var _this82 = this;
              _superPropGet(h, "render", this, 3)([]), this.listenTo(this.buttonView, "open", function () {
                _this82.isOpen = !_this82.isOpen;
              }), this.panelView.bind("isVisible").to(this, "isOpen"), this.on("change:isOpen", function () {
                _this82.isOpen && ("auto" === _this82.panelPosition ? _this82.panelView.position = h._getOptimalPosition({
                  element: _this82.panelView.element,
                  target: _this82.buttonView.element,
                  fitInViewport: !0,
                  positions: _this82._panelPositions
                }).name : _this82.panelView.position = _this82.panelPosition);
              }), this.keystrokes.listenTo(this.element);
              var e = function (_e191) {
                function e(_x, _x2) {
                  return _e191.apply(this, arguments);
                }
                e.toString = function () {
                  return _e191.toString();
                };
                return e;
              }(function (e, t) {
                _this82.isOpen && (_this82.buttonView.focus(), _this82.isOpen = !1, t());
              });
              this.keystrokes.set("arrowdown", function (e, t) {
                _this82.buttonView.isEnabled && !_this82.isOpen && (_this82.isOpen = !0, t());
              }), this.keystrokes.set("arrowright", function (e, t) {
                _this82.isOpen && t();
              }), this.keystrokes.set("arrowleft", e), this.keystrokes.set("esc", e);
            }
          }, {
            key: "focus",
            value: function focus() {
              this.buttonView.focus();
            }
          }, {
            key: "_panelPositions",
            get: function get() {
              var _h$defaultPanelPositi = h.defaultPanelPositions,
                e = _h$defaultPanelPositi.south,
                t = _h$defaultPanelPositi.north,
                s = _h$defaultPanelPositi.southEast,
                o = _h$defaultPanelPositi.southWest,
                i = _h$defaultPanelPositi.northEast,
                r = _h$defaultPanelPositi.northWest,
                n = _h$defaultPanelPositi.southMiddleEast,
                a = _h$defaultPanelPositi.southMiddleWest,
                c = _h$defaultPanelPositi.northMiddleEast,
                l = _h$defaultPanelPositi.northMiddleWest;
              return "rtl" !== this.locale.uiLanguageDirection ? [s, o, n, a, e, i, r, c, l, t] : [o, s, a, n, e, r, i, l, c, t];
            }
          }]);
          return h;
        }(o.Z);
        h.defaultPanelPositions = {
          south: function south(e, t) {
            return {
              top: e.bottom,
              left: e.left - (t.width - e.width) / 2,
              name: "s"
            };
          },
          southEast: function southEast(e) {
            return {
              top: e.bottom,
              left: e.left,
              name: "se"
            };
          },
          southWest: function southWest(e, t) {
            return {
              top: e.bottom,
              left: e.left - t.width + e.width,
              name: "sw"
            };
          },
          southMiddleEast: function southMiddleEast(e, t) {
            return {
              top: e.bottom,
              left: e.left - (t.width - e.width) / 4,
              name: "sme"
            };
          },
          southMiddleWest: function southMiddleWest(e, t) {
            return {
              top: e.bottom,
              left: e.left - 3 * (t.width - e.width) / 4,
              name: "smw"
            };
          },
          north: function north(e, t) {
            return {
              top: e.top - t.height,
              left: e.left - (t.width - e.width) / 2,
              name: "n"
            };
          },
          northEast: function northEast(e, t) {
            return {
              top: e.top - t.height,
              left: e.left,
              name: "ne"
            };
          },
          northWest: function northWest(e, t) {
            return {
              top: e.top - t.height,
              left: e.left - t.width + e.width,
              name: "nw"
            };
          },
          northMiddleEast: function northMiddleEast(e, t) {
            return {
              top: e.top - t.height,
              left: e.left - (t.width - e.width) / 4,
              name: "nme"
            };
          },
          northMiddleWest: function northMiddleWest(e, t) {
            return {
              top: e.top - t.height,
              left: e.left - 3 * (t.width - e.width) / 4,
              name: "nmw"
            };
          }
        }, h._getOptimalPosition = d.x;
        var u = s("./packages/ckeditor5-ui/src/dropdown/button/dropdownbuttonview.js"),
          g = s("./packages/ckeditor5-ui/src/toolbar/toolbarview.js"),
          p = s("./packages/ckeditor5-ui/src/list/listview.js"),
          f = s("./packages/ckeditor5-ui/src/list/listitemview.js");
        var m = /*#__PURE__*/function (_o$Z31) {
          _inherits(m, _o$Z31);
          function m(e) {
            var _this83;
            _classCallCheck(this, m);
            _this83 = _possibleConstructorReturn(this, _getPrototypeOf(m).call(this, e)), _this83.setTemplate({
              tag: "li",
              attributes: {
                class: ["ck", "ck-list__separator"]
              }
            });
            return _this83;
          }
          return m;
        }(o.Z);
        var k = s("./packages/ckeditor5-ui/src/button/buttonview.js"),
          _ = s("./packages/ckeditor5-ui/src/button/switchbuttonview.js"),
          b = s("./packages/ckeditor5-ui/src/bindings/clickoutsidehandler.js"),
          w = s("./node_modules/css-loader/dist/cjs.js!./node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].use[2]!./packages/ckeditor5-ui/theme/components/dropdown/toolbardropdown.css"),
          v = {
            injectType: "singletonStyleTag",
            attributes: {
              "data-cke": !0
            },
            insert: "head",
            singleton: !0
          };
        a()(w.Z, v);
        w.Z.locals;
        var y = s("./node_modules/css-loader/dist/cjs.js!./node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].use[2]!./packages/ckeditor5-ui/theme/components/dropdown/listdropdown.css"),
          Z = {
            injectType: "singletonStyleTag",
            attributes: {
              "data-cke": !0
            },
            insert: "head",
            singleton: !0
          };
        a()(y.Z, Z);
        y.Z.locals;
        function P(e) {
          var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : u.Z;
          var s = new t(e),
            o = new i(e),
            r = new h(e, s, o);
          return s.bind("isEnabled").to(r), s instanceof u.Z ? s.bind("isOn").to(r, "isOpen") : s.arrowView.bind("isOn").to(r, "isOpen"), function (e) {
            (function (e) {
              e.on("render", function () {
                (0, b.Z)({
                  emitter: e,
                  activator: function activator() {
                    return e.isOpen;
                  },
                  callback: function callback() {
                    e.isOpen = !1;
                  },
                  contextElements: [e.element]
                });
              });
            })(e), function (e) {
              e.on("execute", function (t) {
                t.source instanceof _.Z || (e.isOpen = !1);
              });
            }(e), function (e) {
              e.keystrokes.set("arrowdown", function (t, s) {
                e.isOpen && (e.panelView.focus(), s());
              }), e.keystrokes.set("arrowup", function (t, s) {
                e.isOpen && (e.panelView.focusLast(), s());
              });
            }(e);
          }(r), r;
        }
        function j(e, t) {
          var s = e.locale,
            o = s.t,
            i = e.toolbarView = new g.Z(s);
          i.set("ariaLabel", o("Dropdown toolbar")), e.extendTemplate({
            attributes: {
              class: ["ck-toolbar-dropdown"]
            }
          }), t.map(function (e) {
            return i.items.add(e);
          }), e.panelView.children.add(i), i.items.delegate("execute").to(e);
        }
        function x(e, t) {
          var s = e.locale,
            o = e.listView = new p.Z(s);
          o.items.bindTo(t).using(function (_ref29) {
            var e = _ref29.type,
              t = _ref29.model;
            if ("separator" === e) return new m(s);
            if ("button" === e || "switchbutton" === e) {
              var _i97;
              var _o115 = new f.Z(s);
              var _i96;
              return _i96 = "button" === e ? new k.Z(s) : new _.Z(s), (_i97 = _i96).bind.apply(_i97, _toConsumableArray(Object.keys(t))).to(t), _i96.delegate("execute").to(_o115), _o115.children.add(_i96), _o115;
            }
          }), e.panelView.children.add(o), o.items.delegate("execute").to(e);
        }
      },
      "./packages/ckeditor5-ui/src/focuscycler.js": function _packages_ckeditor5Ui_src_focuscyclerJs(e, t, s) {
        "use strict";

        s.d(t, {
          Z: function Z() {
            return i;
          }
        });
        var o = s("./packages/ckeditor5-utils/src/dom/isvisible.js");
        var i = /*#__PURE__*/function () {
          function i(e) {
            var _this84 = this;
            _classCallCheck(this, i);
            if (Object.assign(this, e), e.actions && e.keystrokeHandler) {
              var _loop4 = function _loop4(_t182) {
                var s = e.actions[_t182];
                "string" == typeof s && (s = [s]);
                var _iterator262 = _createForOfIteratorHelper(s),
                  _step262;
                try {
                  for (_iterator262.s(); !(_step262 = _iterator262.n()).done;) {
                    var _o116 = _step262.value;
                    e.keystrokeHandler.set(_o116, function (e, s) {
                      _this84[_t182](), s();
                    });
                  }
                } catch (err) {
                  _iterator262.e(err);
                } finally {
                  _iterator262.f();
                }
              };
              for (var _t182 in e.actions) {
                _loop4(_t182);
              }
            }
          }
          _createClass(i, [{
            key: "focusFirst",
            value: function focusFirst() {
              this._focus(this.first);
            }
          }, {
            key: "focusLast",
            value: function focusLast() {
              this._focus(this.last);
            }
          }, {
            key: "focusNext",
            value: function focusNext() {
              this._focus(this.next);
            }
          }, {
            key: "focusPrevious",
            value: function focusPrevious() {
              this._focus(this.previous);
            }
          }, {
            key: "_focus",
            value: function _focus(e) {
              e && e.focus();
            }
          }, {
            key: "_getFocusableItem",
            value: function _getFocusableItem(e) {
              var t = this.current,
                s = this.focusables.length;
              if (!s) return null;
              if (null === t) return this[1 === e ? "first" : "last"];
              var o = (t + s + e) % s;
              do {
                var _t183 = this.focusables.get(o);
                if (r(_t183)) return _t183;
                o = (o + s + e) % s;
              } while (o !== t);
              return null;
            }
          }, {
            key: "first",
            get: function get() {
              return this.focusables.find(r) || null;
            }
          }, {
            key: "last",
            get: function get() {
              return this.focusables.filter(r).slice(-1)[0] || null;
            }
          }, {
            key: "next",
            get: function get() {
              return this._getFocusableItem(1);
            }
          }, {
            key: "previous",
            get: function get() {
              return this._getFocusableItem(-1);
            }
          }, {
            key: "current",
            get: function get() {
              var _this85 = this;
              var e = null;
              return null === this.focusTracker.focusedElement ? null : (this.focusables.find(function (t, s) {
                var o = t.element === _this85.focusTracker.focusedElement;
                return o && (e = s), o;
              }), e);
            }
          }]);
          return i;
        }();
        function r(e) {
          return !(!e.focus || !(0, o.Z)(e.element));
        }
      },
      "./packages/ckeditor5-ui/src/icon/iconview.js": function _packages_ckeditor5Ui_src_icon_iconviewJs(e, t, s) {
        "use strict";

        s.d(t, {
          Z: function Z() {
            return c;
          }
        });
        var o = s("./packages/ckeditor5-ui/src/view.js"),
          i = s("./node_modules/style-loader/dist/runtime/injectStylesIntoStyleTag.js"),
          r = s.n(i),
          n = s("./node_modules/css-loader/dist/cjs.js!./node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].use[2]!./packages/ckeditor5-ui/theme/components/icon/icon.css"),
          a = {
            injectType: "singletonStyleTag",
            attributes: {
              "data-cke": !0
            },
            insert: "head",
            singleton: !0
          };
        r()(n.Z, a);
        n.Z.locals;
        var c = /*#__PURE__*/function (_o$Z32) {
          _inherits(c, _o$Z32);
          function c() {
            var _this86;
            _classCallCheck(this, c);
            _this86 = _possibleConstructorReturn(this, _getPrototypeOf(c).call(this));
            var e = _this86.bindTemplate;
            _this86.set("content", ""), _this86.set("viewBox", "0 0 20 20"), _this86.set("fillColor", ""), _this86.setTemplate({
              tag: "svg",
              ns: "http://www.w3.org/2000/svg",
              attributes: {
                class: ["ck", "ck-icon"],
                viewBox: e.to("viewBox")
              }
            });
            return _this86;
          }
          _createClass(c, [{
            key: "render",
            value: function render() {
              var _this87 = this;
              _superPropGet(c, "render", this, 3)([]), this._updateXMLContent(), this._colorFillPaths(), this.on("change:content", function () {
                _this87._updateXMLContent(), _this87._colorFillPaths();
              }), this.on("change:fillColor", function () {
                _this87._colorFillPaths();
              });
            }
          }, {
            key: "_updateXMLContent",
            value: function _updateXMLContent() {
              if (this.content) {
                var _e192 = new DOMParser().parseFromString(this.content.trim(), "image/svg+xml").querySelector("svg"),
                  _t184 = _e192.getAttribute("viewBox");
                for (_t184 && (this.viewBox = _t184), this.element.innerHTML = ""; _e192.childNodes.length > 0;) this.element.appendChild(_e192.childNodes[0]);
              }
            }
          }, {
            key: "_colorFillPaths",
            value: function _colorFillPaths() {
              var _this88 = this;
              this.fillColor && this.element.querySelectorAll(".ck-icon__fill").forEach(function (e) {
                e.style.fill = _this88.fillColor;
              });
            }
          }]);
          return c;
        }(o.Z);
      },
      "./packages/ckeditor5-ui/src/list/listitemview.js": function _packages_ckeditor5Ui_src_list_listitemviewJs(e, t, s) {
        "use strict";

        s.d(t, {
          Z: function Z() {
            return i;
          }
        });
        var o = s("./packages/ckeditor5-ui/src/view.js");
        var i = /*#__PURE__*/function (_o$Z33) {
          _inherits(i, _o$Z33);
          function i(e) {
            var _this89;
            _classCallCheck(this, i);
            _this89 = _possibleConstructorReturn(this, _getPrototypeOf(i).call(this, e)), _this89.children = _this89.createCollection(), _this89.setTemplate({
              tag: "li",
              attributes: {
                class: ["ck", "ck-list__item"]
              },
              children: _this89.children
            });
            return _this89;
          }
          _createClass(i, [{
            key: "focus",
            value: function focus() {
              this.children.first.focus();
            }
          }]);
          return i;
        }(o.Z);
      },
      "./packages/ckeditor5-ui/src/list/listview.js": function _packages_ckeditor5Ui_src_list_listviewJs(e, t, s) {
        "use strict";

        s.d(t, {
          Z: function Z() {
            return h;
          }
        });
        var o = s("./packages/ckeditor5-ui/src/view.js"),
          i = s("./packages/ckeditor5-utils/src/focustracker.js"),
          r = s("./packages/ckeditor5-ui/src/focuscycler.js"),
          n = s("./packages/ckeditor5-utils/src/keystrokehandler.js"),
          a = s("./node_modules/style-loader/dist/runtime/injectStylesIntoStyleTag.js"),
          c = s.n(a),
          l = s("./node_modules/css-loader/dist/cjs.js!./node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].use[2]!./packages/ckeditor5-ui/theme/components/list/list.css"),
          d = {
            injectType: "singletonStyleTag",
            attributes: {
              "data-cke": !0
            },
            insert: "head",
            singleton: !0
          };
        c()(l.Z, d);
        l.Z.locals;
        var h = /*#__PURE__*/function (_o$Z34) {
          _inherits(h, _o$Z34);
          function h() {
            var _this90;
            _classCallCheck(this, h);
            _this90 = _possibleConstructorReturn(this, _getPrototypeOf(h).call(this)), _this90.items = _this90.createCollection(), _this90.focusTracker = new i.Z(), _this90.keystrokes = new n.Z(), _this90._focusCycler = new r.Z({
              focusables: _this90.items,
              focusTracker: _this90.focusTracker,
              keystrokeHandler: _this90.keystrokes,
              actions: {
                focusPrevious: "arrowup",
                focusNext: "arrowdown"
              }
            }), _this90.setTemplate({
              tag: "ul",
              attributes: {
                class: ["ck", "ck-reset", "ck-list"]
              },
              children: _this90.items
            });
            return _this90;
          }
          _createClass(h, [{
            key: "render",
            value: function render() {
              var _this91 = this;
              _superPropGet(h, "render", this, 3)([]);
              var _iterator263 = _createForOfIteratorHelper(this.items),
                _step263;
              try {
                for (_iterator263.s(); !(_step263 = _iterator263.n()).done;) {
                  var _e193 = _step263.value;
                  this.focusTracker.add(_e193.element);
                }
              } catch (err) {
                _iterator263.e(err);
              } finally {
                _iterator263.f();
              }
              this.items.on("add", function (e, t) {
                _this91.focusTracker.add(t.element);
              }), this.items.on("remove", function (e, t) {
                _this91.focusTracker.remove(t.element);
              }), this.keystrokes.listenTo(this.element);
            }
          }, {
            key: "destroy",
            value: function destroy() {
              _superPropGet(h, "destroy", this, 3)([]), this.focusTracker.destroy(), this.keystrokes.destroy();
            }
          }, {
            key: "focus",
            value: function focus() {
              this._focusCycler.focusFirst();
            }
          }, {
            key: "focusLast",
            value: function focusLast() {
              this._focusCycler.focusLast();
            }
          }]);
          return h;
        }(o.Z);
      },
      "./packages/ckeditor5-ui/src/panel/balloon/balloonpanelview.js": function _packages_ckeditor5Ui_src_panel_balloon_balloonpanelviewJs(e, t, s) {
        "use strict";

        s.d(t, {
          Z: function Z() {
            return f;
          },
          M: function M() {
            return k;
          }
        });
        var o = s("./packages/ckeditor5-ui/src/view.js"),
          i = s("./packages/ckeditor5-utils/src/dom/position.js"),
          r = s("./packages/ckeditor5-utils/src/dom/isrange.js"),
          n = s("./packages/ckeditor5-utils/src/dom/tounit.js"),
          a = s("./packages/ckeditor5-utils/src/dom/global.js"),
          c = s("./node_modules/lodash-es/isElement.js"),
          l = s("./node_modules/style-loader/dist/runtime/injectStylesIntoStyleTag.js"),
          d = s.n(l),
          h = s("./node_modules/css-loader/dist/cjs.js!./node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].use[2]!./packages/ckeditor5-ui/theme/components/panel/balloonpanel.css"),
          u = {
            injectType: "singletonStyleTag",
            attributes: {
              "data-cke": !0
            },
            insert: "head",
            singleton: !0
          };
        d()(h.Z, u);
        h.Z.locals;
        var g = (0, n.Z)("px"),
          p = a.Z.document.body;
        var f = /*#__PURE__*/function (_o$Z35) {
          _inherits(f, _o$Z35);
          function f(e) {
            var _this92;
            _classCallCheck(this, f);
            _this92 = _possibleConstructorReturn(this, _getPrototypeOf(f).call(this, e));
            var t = _this92.bindTemplate;
            _this92.set("top", 0), _this92.set("left", 0), _this92.set("position", "arrow_nw"), _this92.set("isVisible", !1), _this92.set("withArrow", !0), _this92.set("class"), _this92.content = _this92.createCollection(), _this92.setTemplate({
              tag: "div",
              attributes: {
                class: ["ck", "ck-balloon-panel", t.to("position", function (e) {
                  return "ck-balloon-panel_".concat(e);
                }), t.if("isVisible", "ck-balloon-panel_visible"), t.if("withArrow", "ck-balloon-panel_with-arrow"), t.to("class")],
                style: {
                  top: t.to("top", g),
                  left: t.to("left", g)
                }
              },
              children: _this92.content
            });
            return _this92;
          }
          _createClass(f, [{
            key: "show",
            value: function show() {
              this.isVisible = !0;
            }
          }, {
            key: "hide",
            value: function hide() {
              this.isVisible = !1;
            }
          }, {
            key: "attachTo",
            value: function attachTo(e) {
              this.show();
              var t = f.defaultPositions,
                s = Object.assign({}, {
                  element: this.element,
                  positions: [t.southArrowNorth, t.southArrowNorthMiddleWest, t.southArrowNorthMiddleEast, t.southArrowNorthWest, t.southArrowNorthEast, t.northArrowSouth, t.northArrowSouthMiddleWest, t.northArrowSouthMiddleEast, t.northArrowSouthWest, t.northArrowSouthEast, t.viewportStickyNorth],
                  limiter: p,
                  fitInViewport: !0
                }, e),
                o = f._getOptimalPosition(s),
                i = parseInt(o.left),
                r = parseInt(o.top),
                n = o.name,
                _o$config = o.config,
                a = _o$config === void 0 ? {} : _o$config,
                _a$withArrow = a.withArrow,
                c = _a$withArrow === void 0 ? !0 : _a$withArrow;
              Object.assign(this, {
                top: r,
                left: i,
                position: n,
                withArrow: c
              });
            }
          }, {
            key: "pin",
            value: function pin(e) {
              var _this93 = this;
              this.unpin(), this._pinWhenIsVisibleCallback = function () {
                _this93.isVisible ? _this93._startPinning(e) : _this93._stopPinning();
              }, this._startPinning(e), this.listenTo(this, "change:isVisible", this._pinWhenIsVisibleCallback);
            }
          }, {
            key: "unpin",
            value: function unpin() {
              this._pinWhenIsVisibleCallback && (this._stopPinning(), this.stopListening(this, "change:isVisible", this._pinWhenIsVisibleCallback), this._pinWhenIsVisibleCallback = null, this.hide());
            }
          }, {
            key: "_startPinning",
            value: function _startPinning(e) {
              var _this94 = this;
              this.attachTo(e);
              var t = m(e.target),
                s = e.limiter ? m(e.limiter) : p;
              this.listenTo(a.Z.document, "scroll", function (o, i) {
                var r = i.target,
                  n = t && r.contains(t),
                  a = s && r.contains(s);
                !n && !a && t && s || _this94.attachTo(e);
              }, {
                useCapture: !0
              }), this.listenTo(a.Z.window, "resize", function () {
                _this94.attachTo(e);
              });
            }
          }, {
            key: "_stopPinning",
            value: function _stopPinning() {
              this.stopListening(a.Z.document, "scroll"), this.stopListening(a.Z.window, "resize");
            }
          }]);
          return f;
        }(o.Z);
        function m(e) {
          return (0, c.Z)(e) ? e : (0, r.Z)(e) ? e.commonAncestorContainer : "function" == typeof e ? m(e()) : null;
        }
        function k() {
          var _ref30 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
            _ref30$horizontalOffs = _ref30.horizontalOffset,
            e = _ref30$horizontalOffs === void 0 ? f.arrowHorizontalOffset : _ref30$horizontalOffs,
            _ref30$verticalOffset = _ref30.verticalOffset,
            t = _ref30$verticalOffset === void 0 ? f.arrowVerticalOffset : _ref30$verticalOffset,
            _ref30$stickyVertical = _ref30.stickyVerticalOffset,
            s = _ref30$stickyVertical === void 0 ? f.stickyVerticalOffset : _ref30$stickyVertical,
            o = _ref30.config;
          return {
            northWestArrowSouthWest: function northWestArrowSouthWest(t, s) {
              return _objectSpread({
                top: i(t, s),
                left: t.left - e,
                name: "arrow_sw"
              }, o && {
                config: o
              });
            },
            northWestArrowSouthMiddleWest: function northWestArrowSouthMiddleWest(t, s) {
              return _objectSpread({
                top: i(t, s),
                left: t.left - .25 * s.width - e,
                name: "arrow_smw"
              }, o && {
                config: o
              });
            },
            northWestArrowSouth: function northWestArrowSouth(e, t) {
              return _objectSpread({
                top: i(e, t),
                left: e.left - t.width / 2,
                name: "arrow_s"
              }, o && {
                config: o
              });
            },
            northWestArrowSouthMiddleEast: function northWestArrowSouthMiddleEast(t, s) {
              return _objectSpread({
                top: i(t, s),
                left: t.left - .75 * s.width + e,
                name: "arrow_sme"
              }, o && {
                config: o
              });
            },
            northWestArrowSouthEast: function northWestArrowSouthEast(t, s) {
              return _objectSpread({
                top: i(t, s),
                left: t.left - s.width + e,
                name: "arrow_se"
              }, o && {
                config: o
              });
            },
            northArrowSouthWest: function northArrowSouthWest(t, s) {
              return _objectSpread({
                top: i(t, s),
                left: t.left + t.width / 2 - e,
                name: "arrow_sw"
              }, o && {
                config: o
              });
            },
            northArrowSouthMiddleWest: function northArrowSouthMiddleWest(t, s) {
              return _objectSpread({
                top: i(t, s),
                left: t.left + t.width / 2 - .25 * s.width - e,
                name: "arrow_smw"
              }, o && {
                config: o
              });
            },
            northArrowSouth: function northArrowSouth(e, t) {
              return _objectSpread({
                top: i(e, t),
                left: e.left + e.width / 2 - t.width / 2,
                name: "arrow_s"
              }, o && {
                config: o
              });
            },
            northArrowSouthMiddleEast: function northArrowSouthMiddleEast(t, s) {
              return _objectSpread({
                top: i(t, s),
                left: t.left + t.width / 2 - .75 * s.width + e,
                name: "arrow_sme"
              }, o && {
                config: o
              });
            },
            northArrowSouthEast: function northArrowSouthEast(t, s) {
              return _objectSpread({
                top: i(t, s),
                left: t.left + t.width / 2 - s.width + e,
                name: "arrow_se"
              }, o && {
                config: o
              });
            },
            northEastArrowSouthWest: function northEastArrowSouthWest(t, s) {
              return _objectSpread({
                top: i(t, s),
                left: t.right - e,
                name: "arrow_sw"
              }, o && {
                config: o
              });
            },
            northEastArrowSouthMiddleWest: function northEastArrowSouthMiddleWest(t, s) {
              return _objectSpread({
                top: i(t, s),
                left: t.right - .25 * s.width - e,
                name: "arrow_smw"
              }, o && {
                config: o
              });
            },
            northEastArrowSouth: function northEastArrowSouth(e, t) {
              return _objectSpread({
                top: i(e, t),
                left: e.right - t.width / 2,
                name: "arrow_s"
              }, o && {
                config: o
              });
            },
            northEastArrowSouthMiddleEast: function northEastArrowSouthMiddleEast(t, s) {
              return _objectSpread({
                top: i(t, s),
                left: t.right - .75 * s.width + e,
                name: "arrow_sme"
              }, o && {
                config: o
              });
            },
            northEastArrowSouthEast: function northEastArrowSouthEast(t, s) {
              return _objectSpread({
                top: i(t, s),
                left: t.right - s.width + e,
                name: "arrow_se"
              }, o && {
                config: o
              });
            },
            southWestArrowNorthWest: function southWestArrowNorthWest(t, s) {
              return _objectSpread({
                top: r(t),
                left: t.left - e,
                name: "arrow_nw"
              }, o && {
                config: o
              });
            },
            southWestArrowNorthMiddleWest: function southWestArrowNorthMiddleWest(t, s) {
              return _objectSpread({
                top: r(t),
                left: t.left - .25 * s.width - e,
                name: "arrow_nmw"
              }, o && {
                config: o
              });
            },
            southWestArrowNorth: function southWestArrowNorth(e, t) {
              return _objectSpread({
                top: r(e),
                left: e.left - t.width / 2,
                name: "arrow_n"
              }, o && {
                config: o
              });
            },
            southWestArrowNorthMiddleEast: function southWestArrowNorthMiddleEast(t, s) {
              return _objectSpread({
                top: r(t),
                left: t.left - .75 * s.width + e,
                name: "arrow_nme"
              }, o && {
                config: o
              });
            },
            southWestArrowNorthEast: function southWestArrowNorthEast(t, s) {
              return _objectSpread({
                top: r(t),
                left: t.left - s.width + e,
                name: "arrow_ne"
              }, o && {
                config: o
              });
            },
            southArrowNorthWest: function southArrowNorthWest(t, s) {
              return _objectSpread({
                top: r(t),
                left: t.left + t.width / 2 - e,
                name: "arrow_nw"
              }, o && {
                config: o
              });
            },
            southArrowNorthMiddleWest: function southArrowNorthMiddleWest(t, s) {
              return _objectSpread({
                top: r(t),
                left: t.left + t.width / 2 - .25 * s.width - e,
                name: "arrow_nmw"
              }, o && {
                config: o
              });
            },
            southArrowNorth: function southArrowNorth(e, t) {
              return _objectSpread({
                top: r(e),
                left: e.left + e.width / 2 - t.width / 2,
                name: "arrow_n"
              }, o && {
                config: o
              });
            },
            southArrowNorthMiddleEast: function southArrowNorthMiddleEast(t, s) {
              return _objectSpread({
                top: r(t),
                left: t.left + t.width / 2 - .75 * s.width + e,
                name: "arrow_nme"
              }, o && {
                config: o
              });
            },
            southArrowNorthEast: function southArrowNorthEast(t, s) {
              return _objectSpread({
                top: r(t),
                left: t.left + t.width / 2 - s.width + e,
                name: "arrow_ne"
              }, o && {
                config: o
              });
            },
            southEastArrowNorthWest: function southEastArrowNorthWest(t, s) {
              return _objectSpread({
                top: r(t),
                left: t.right - e,
                name: "arrow_nw"
              }, o && {
                config: o
              });
            },
            southEastArrowNorthMiddleWest: function southEastArrowNorthMiddleWest(t, s) {
              return _objectSpread({
                top: r(t),
                left: t.right - .25 * s.width - e,
                name: "arrow_nmw"
              }, o && {
                config: o
              });
            },
            southEastArrowNorth: function southEastArrowNorth(e, t) {
              return _objectSpread({
                top: r(e),
                left: e.right - t.width / 2,
                name: "arrow_n"
              }, o && {
                config: o
              });
            },
            southEastArrowNorthMiddleEast: function southEastArrowNorthMiddleEast(t, s) {
              return _objectSpread({
                top: r(t),
                left: t.right - .75 * s.width + e,
                name: "arrow_nme"
              }, o && {
                config: o
              });
            },
            southEastArrowNorthEast: function southEastArrowNorthEast(t, s) {
              return _objectSpread({
                top: r(t),
                left: t.right - s.width + e,
                name: "arrow_ne"
              }, o && {
                config: o
              });
            },
            viewportStickyNorth: function viewportStickyNorth(e, t, i) {
              return e.getIntersection(i) ? {
                top: i.top + s,
                left: e.left + e.width / 2 - t.width / 2,
                name: "arrowless",
                config: _objectSpread({
                  withArrow: !1
                }, o)
              } : null;
            }
          };
          function i(e, s) {
            return e.top - s.height - t;
          }
          function r(e) {
            return e.bottom + t;
          }
        }
        f.arrowHorizontalOffset = 25, f.arrowVerticalOffset = 10, f.stickyVerticalOffset = 20, f._getOptimalPosition = i.x, f.defaultPositions = k();
      },
      "./packages/ckeditor5-ui/src/panel/balloon/contextualballoon.js": function _packages_ckeditor5Ui_src_panel_balloon_contextualballoonJs(e, t, s) {
        "use strict";

        s.d(t, {
          Z: function Z() {
            return _;
          }
        });
        var o = s("./packages/ckeditor5-core/src/plugin.js"),
          i = s("./packages/ckeditor5-ui/src/panel/balloon/balloonpanelview.js"),
          r = s("./packages/ckeditor5-ui/src/view.js"),
          n = s("./packages/ckeditor5-ui/src/button/buttonview.js"),
          a = s("./packages/ckeditor5-utils/src/ckeditorerror.js"),
          c = s("./packages/ckeditor5-utils/src/focustracker.js"),
          l = s("./packages/ckeditor5-utils/src/dom/tounit.js"),
          d = s("./packages/ckeditor5-utils/src/dom/rect.js");
        var h = s("./node_modules/style-loader/dist/runtime/injectStylesIntoStyleTag.js"),
          u = s.n(h),
          g = s("./node_modules/css-loader/dist/cjs.js!./node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].use[2]!./packages/ckeditor5-ui/theme/components/panel/balloonrotator.css"),
          p = {
            injectType: "singletonStyleTag",
            attributes: {
              "data-cke": !0
            },
            insert: "head",
            singleton: !0
          };
        u()(g.Z, p);
        g.Z.locals;
        var f = s("./node_modules/css-loader/dist/cjs.js!./node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].use[2]!./packages/ckeditor5-ui/theme/components/panel/fakepanel.css"),
          m = {
            injectType: "singletonStyleTag",
            attributes: {
              "data-cke": !0
            },
            insert: "head",
            singleton: !0
          };
        u()(f.Z, m);
        f.Z.locals;
        var k = (0, l.Z)("px");
        var _ = /*#__PURE__*/function (_o$Z36) {
          _inherits(_, _o$Z36);
          _createClass(_, null, [{
            key: "pluginName",
            get: function get() {
              return "ContextualBalloon";
            }
          }]);
          function _(e) {
            var _this95;
            _classCallCheck(this, _);
            _this95 = _possibleConstructorReturn(this, _getPrototypeOf(_).call(this, e)), _this95.positionLimiter = function () {
              var e = _this95.editor.editing.view,
                t = e.document.selection.editableElement;
              return t ? e.domConverter.mapViewToDom(t.root) : null;
            }, _this95.set("visibleView", null), _this95.view = new i.Z(e.locale), e.ui.view.body.add(_this95.view), e.ui.focusTracker.add(_this95.view.element), _this95._viewToStack = new Map(), _this95._idToStack = new Map(), _this95.set("_numberOfStacks", 0), _this95.set("_singleViewMode", !1), _this95._rotatorView = _this95._createRotatorView(), _this95._fakePanelsView = _this95._createFakePanelsView();
            return _this95;
          }
          _createClass(_, [{
            key: "destroy",
            value: function destroy() {
              _superPropGet(_, "destroy", this, 3)([]), this.view.destroy(), this._rotatorView.destroy(), this._fakePanelsView.destroy();
            }
          }, {
            key: "hasView",
            value: function hasView(e) {
              return Array.from(this._viewToStack.keys()).includes(e);
            }
          }, {
            key: "add",
            value: function add(e) {
              if (this.hasView(e.view)) throw new a.ZP("contextualballoon-add-view-exist", [this, e]);
              var t = e.stackId || "main";
              if (!this._idToStack.has(t)) return this._idToStack.set(t, new Map([[e.view, e]])), this._viewToStack.set(e.view, this._idToStack.get(t)), this._numberOfStacks = this._idToStack.size, void (this._visibleStack && !e.singleViewMode || this.showStack(t));
              var s = this._idToStack.get(t);
              e.singleViewMode && this.showStack(t), s.set(e.view, e), this._viewToStack.set(e.view, s), s === this._visibleStack && this._showView(e);
            }
          }, {
            key: "remove",
            value: function remove(e) {
              if (!this.hasView(e)) throw new a.ZP("contextualballoon-remove-view-not-exist", [this, e]);
              var t = this._viewToStack.get(e);
              this._singleViewMode && this.visibleView === e && (this._singleViewMode = !1), this.visibleView === e && (1 === t.size ? this._idToStack.size > 1 ? this._showNextStack() : (this.view.hide(), this.visibleView = null, this._rotatorView.hideView()) : this._showView(Array.from(t.values())[t.size - 2])), 1 === t.size ? (this._idToStack.delete(this._getStackId(t)), this._numberOfStacks = this._idToStack.size) : t.delete(e), this._viewToStack.delete(e);
            }
          }, {
            key: "updatePosition",
            value: function updatePosition(e) {
              e && (this._visibleStack.get(this.visibleView).position = e), this.view.pin(this._getBalloonPosition()), this._fakePanelsView.updatePosition();
            }
          }, {
            key: "showStack",
            value: function showStack(e) {
              this.visibleStack = e;
              var t = this._idToStack.get(e);
              if (!t) throw new a.ZP("contextualballoon-showstack-stack-not-exist", this);
              this._visibleStack !== t && this._showView(Array.from(t.values()).pop());
            }
          }, {
            key: "_getStackId",
            value: function _getStackId(e) {
              return Array.from(this._idToStack.entries()).find(function (t) {
                return t[1] === e;
              })[0];
            }
          }, {
            key: "_showNextStack",
            value: function _showNextStack() {
              var e = Array.from(this._idToStack.values());
              var t = e.indexOf(this._visibleStack) + 1;
              e[t] || (t = 0), this.showStack(this._getStackId(e[t]));
            }
          }, {
            key: "_showPrevStack",
            value: function _showPrevStack() {
              var e = Array.from(this._idToStack.values());
              var t = e.indexOf(this._visibleStack) - 1;
              e[t] || (t = e.length - 1), this.showStack(this._getStackId(e[t]));
            }
          }, {
            key: "_createRotatorView",
            value: function _createRotatorView() {
              var _this96 = this;
              var e = new b(this.editor.locale),
                t = this.editor.locale.t;
              return this.view.content.add(e), e.bind("isNavigationVisible").to(this, "_numberOfStacks", this, "_singleViewMode", function (e, t) {
                return !t && e > 1;
              }), e.on("change:isNavigationVisible", function () {
                return _this96.updatePosition();
              }, {
                priority: "low"
              }), e.bind("counter").to(this, "visibleView", this, "_numberOfStacks", function (e, s) {
                if (s < 2) return "";
                var o = Array.from(_this96._idToStack.values()).indexOf(_this96._visibleStack) + 1;
                return t("%0 of %1", [o, s]);
              }), e.buttonNextView.on("execute", function () {
                e.focusTracker.isFocused && _this96.editor.editing.view.focus(), _this96._showNextStack();
              }), e.buttonPrevView.on("execute", function () {
                e.focusTracker.isFocused && _this96.editor.editing.view.focus(), _this96._showPrevStack();
              }), e;
            }
          }, {
            key: "_createFakePanelsView",
            value: function _createFakePanelsView() {
              var e = new w(this.editor.locale, this.view);
              return e.bind("numberOfPanels").to(this, "_numberOfStacks", this, "_singleViewMode", function (e, t) {
                return !t && e >= 2 ? Math.min(e - 1, 2) : 0;
              }), e.listenTo(this.view, "change:top", function () {
                return e.updatePosition();
              }), e.listenTo(this.view, "change:left", function () {
                return e.updatePosition();
              }), this.editor.ui.view.body.add(e), e;
            }
          }, {
            key: "_showView",
            value: function _showView(_ref31) {
              var e = _ref31.view,
                _ref31$balloonClassNa = _ref31.balloonClassName,
                t = _ref31$balloonClassNa === void 0 ? "" : _ref31$balloonClassNa,
                _ref31$withArrow = _ref31.withArrow,
                s = _ref31$withArrow === void 0 ? !0 : _ref31$withArrow,
                _ref31$singleViewMode = _ref31.singleViewMode,
                o = _ref31$singleViewMode === void 0 ? !1 : _ref31$singleViewMode;
              this.view.class = t, this.view.withArrow = s, this._rotatorView.showView(e), this.visibleView = e, this.view.pin(this._getBalloonPosition()), this._fakePanelsView.updatePosition(), o && (this._singleViewMode = !0);
            }
          }, {
            key: "_getBalloonPosition",
            value: function _getBalloonPosition() {
              var e = Array.from(this._visibleStack.values()).pop().position;
              return e && (e.limiter || (e = Object.assign({}, e, {
                limiter: this.positionLimiter
              })), e = Object.assign({}, e, {
                viewportOffsetConfig: this.editor.ui.viewportOffset
              })), e;
            }
          }, {
            key: "_visibleStack",
            get: function get() {
              return this._viewToStack.get(this.visibleView);
            }
          }]);
          return _;
        }(o.Z);
        var b = /*#__PURE__*/function (_r$Z2) {
          _inherits(b, _r$Z2);
          function b(e) {
            var _this97;
            _classCallCheck(this, b);
            _this97 = _possibleConstructorReturn(this, _getPrototypeOf(b).call(this, e));
            var t = e.t,
              s = _this97.bindTemplate;
            _this97.set("isNavigationVisible", !0), _this97.focusTracker = new c.Z(), _this97.buttonPrevView = _this97._createButtonView(t("Previous"), '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M11.463 5.187a.888.888 0 1 1 1.254 1.255L9.16 10l3.557 3.557a.888.888 0 1 1-1.254 1.255L7.26 10.61a.888.888 0 0 1 .16-1.382l4.043-4.042z"/></svg>'), _this97.buttonNextView = _this97._createButtonView(t("Next"), '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M8.537 14.813a.888.888 0 1 1-1.254-1.255L10.84 10 7.283 6.442a.888.888 0 1 1 1.254-1.255L12.74 9.39a.888.888 0 0 1-.16 1.382l-4.043 4.042z"/></svg>'), _this97.content = _this97.createCollection(), _this97.setTemplate({
              tag: "div",
              attributes: {
                class: ["ck", "ck-balloon-rotator"],
                "z-index": "-1"
              },
              children: [{
                tag: "div",
                attributes: {
                  class: ["ck-balloon-rotator__navigation", s.to("isNavigationVisible", function (e) {
                    return e ? "" : "ck-hidden";
                  })]
                },
                children: [_this97.buttonPrevView, {
                  tag: "span",
                  attributes: {
                    class: ["ck-balloon-rotator__counter"]
                  },
                  children: [{
                    text: s.to("counter")
                  }]
                }, _this97.buttonNextView]
              }, {
                tag: "div",
                attributes: {
                  class: "ck-balloon-rotator__content"
                },
                children: _this97.content
              }]
            });
            return _this97;
          }
          _createClass(b, [{
            key: "render",
            value: function render() {
              _superPropGet(b, "render", this, 3)([]), this.focusTracker.add(this.element);
            }
          }, {
            key: "destroy",
            value: function destroy() {
              _superPropGet(b, "destroy", this, 3)([]), this.focusTracker.destroy();
            }
          }, {
            key: "showView",
            value: function showView(e) {
              this.hideView(), this.content.add(e);
            }
          }, {
            key: "hideView",
            value: function hideView() {
              this.content.clear();
            }
          }, {
            key: "_createButtonView",
            value: function _createButtonView(e, t) {
              var s = new n.Z(this.locale);
              return s.set({
                label: e,
                icon: t,
                tooltip: !0
              }), s;
            }
          }]);
          return b;
        }(r.Z);
        var w = /*#__PURE__*/function (_r$Z3) {
          _inherits(w, _r$Z3);
          function w(e, t) {
            var _this98;
            _classCallCheck(this, w);
            _this98 = _possibleConstructorReturn(this, _getPrototypeOf(w).call(this, e));
            var s = _this98.bindTemplate;
            _this98.set("top", 0), _this98.set("left", 0), _this98.set("height", 0), _this98.set("width", 0), _this98.set("numberOfPanels", 0), _this98.content = _this98.createCollection(), _this98._balloonPanelView = t, _this98.setTemplate({
              tag: "div",
              attributes: {
                class: ["ck-fake-panel", s.to("numberOfPanels", function (e) {
                  return e ? "" : "ck-hidden";
                })],
                style: {
                  top: s.to("top", k),
                  left: s.to("left", k),
                  width: s.to("width", k),
                  height: s.to("height", k)
                }
              },
              children: _this98.content
            }), _this98.on("change:numberOfPanels", function (e, t, s, o) {
              s > o ? _this98._addPanels(s - o) : _this98._removePanels(o - s), _this98.updatePosition();
            });
            return _this98;
          }
          _createClass(w, [{
            key: "_addPanels",
            value: function _addPanels(e) {
              for (; e--;) {
                var _e194 = new r.Z();
                _e194.setTemplate({
                  tag: "div"
                }), this.content.add(_e194), this.registerChild(_e194);
              }
            }
          }, {
            key: "_removePanels",
            value: function _removePanels(e) {
              for (; e--;) {
                var _e195 = this.content.last;
                this.content.remove(_e195), this.deregisterChild(_e195), _e195.destroy();
              }
            }
          }, {
            key: "updatePosition",
            value: function updatePosition() {
              if (this.numberOfPanels) {
                var _this$_balloonPanelVi = this._balloonPanelView,
                  _e196 = _this$_balloonPanelVi.top,
                  _t185 = _this$_balloonPanelVi.left,
                  _d$Z = new d.Z(this._balloonPanelView.element),
                  _s178 = _d$Z.width,
                  _o117 = _d$Z.height;
                Object.assign(this, {
                  top: _e196,
                  left: _t185,
                  width: _s178,
                  height: _o117
                });
              }
            }
          }]);
          return w;
        }(r.Z);
      },
      "./packages/ckeditor5-ui/src/template.js": function _packages_ckeditor5Ui_src_templateJs(e, t, s) {
        "use strict";

        s.d(t, {
          ZP: function ZP() {
            return u;
          }
        });
        var o = s("./packages/ckeditor5-utils/src/ckeditorerror.js"),
          i = s("./packages/ckeditor5-utils/src/mix.js"),
          r = s("./packages/ckeditor5-utils/src/emittermixin.js"),
          n = s("./packages/ckeditor5-ui/src/view.js"),
          a = s("./packages/ckeditor5-ui/src/viewcollection.js"),
          c = s("./packages/ckeditor5-utils/src/dom/isnode.js"),
          l = s("./node_modules/lodash-es/isObject.js"),
          d = s("./node_modules/lodash-es/cloneDeepWith.js"),
          h = s("./packages/ckeditor5-utils/src/toarray.js");
        var u = /*#__PURE__*/function () {
          function u(e) {
            _classCallCheck(this, u);
            Object.assign(this, y(v(e))), this._isRendered = !1, this._revertData = null;
          }
          _createClass(u, [{
            key: "render",
            value: function render() {
              var e = this._renderNode({
                intoFragment: !0
              });
              return this._isRendered = !0, e;
            }
          }, {
            key: "apply",
            value: function apply(e) {
              return this._revertData = {
                children: [],
                bindings: [],
                attributes: {}
              }, this._renderNode({
                node: e,
                isApplying: !0,
                revertData: this._revertData
              }), e;
            }
          }, {
            key: "revert",
            value: function revert(e) {
              if (!this._revertData) throw new o.ZP("ui-template-revert-not-applied", [this, e]);
              this._revertTemplateFromNode(e, this._revertData);
            }
          }, {
            key: "getViews",
            value: /*#__PURE__*/_regeneratorRuntime().mark(function getViews() {
              return _regeneratorRuntime().wrap(function getViews$(_context32) {
                while (1) switch (_context32.prev = _context32.next) {
                  case 0:
                    return _context32.delegateYield(/*#__PURE__*/_regeneratorRuntime().mark(function e(t) {
                      var _iterator264, _step264, _s179;
                      return _regeneratorRuntime().wrap(function e$(_context31) {
                        while (1) switch (_context31.prev = _context31.next) {
                          case 0:
                            if (!t.children) {
                              _context31.next = 24;
                              break;
                            }
                            _iterator264 = _createForOfIteratorHelper(t.children);
                            _context31.prev = 2;
                            _iterator264.s();
                          case 4:
                            if ((_step264 = _iterator264.n()).done) {
                              _context31.next = 16;
                              break;
                            }
                            _s179 = _step264.value;
                            if (!T(_s179)) {
                              _context31.next = 11;
                              break;
                            }
                            _context31.next = 9;
                            return _s179;
                          case 9:
                            _context31.next = 14;
                            break;
                          case 11:
                            _context31.t0 = C(_s179);
                            if (!_context31.t0) {
                              _context31.next = 14;
                              break;
                            }
                            return _context31.delegateYield(e(_s179), "t1", 14);
                          case 14:
                            _context31.next = 4;
                            break;
                          case 16:
                            _context31.next = 21;
                            break;
                          case 18:
                            _context31.prev = 18;
                            _context31.t2 = _context31["catch"](2);
                            _iterator264.e(_context31.t2);
                          case 21:
                            _context31.prev = 21;
                            _iterator264.f();
                            return _context31.finish(21);
                          case 24:
                          case "end":
                            return _context31.stop();
                        }
                      }, e, null, [[2, 18, 21, 24]]);
                    })(this), "t0", 1);
                  case 1:
                  case "end":
                    return _context32.stop();
                }
              }, getViews, this);
            })
          }, {
            key: "_renderNode",
            value: function _renderNode(e) {
              var t;
              if (t = e.node ? this.tag && this.text : this.tag ? this.text : !this.text, t) throw new o.ZP("ui-template-wrong-syntax", this);
              return this.text ? this._renderText(e) : this._renderElement(e);
            }
          }, {
            key: "_renderElement",
            value: function _renderElement(e) {
              var t = e.node;
              return t || (t = e.node = document.createElementNS(this.ns || "http://www.w3.org/1999/xhtml", this.tag)), this._renderAttributes(e), this._renderElementChildren(e), this._setUpListeners(e), t;
            }
          }, {
            key: "_renderText",
            value: function _renderText(e) {
              var t = e.node;
              return t ? e.revertData.text = t.textContent : t = e.node = document.createTextNode(""), m(this.text) ? this._bindToObservable({
                schema: this.text,
                updater: _(t),
                data: e
              }) : t.textContent = this.text.join(""), t;
            }
          }, {
            key: "_renderAttributes",
            value: function _renderAttributes(e) {
              var t, s, o, i;
              if (!this.attributes) return;
              var r = e.node,
                n = e.revertData;
              for (t in this.attributes) if (o = r.getAttribute(t), s = this.attributes[t], n && (n.attributes[t] = o), i = (0, l.Z)(s[0]) && s[0].ns ? s[0].ns : null, m(s)) {
                var _a14 = i ? s[0].value : s;
                n && S(t) && _a14.unshift(o), this._bindToObservable({
                  schema: _a14,
                  updater: b(r, t, i),
                  data: e
                });
              } else "style" == t && "string" != typeof s[0] ? this._renderStyleAttribute(s[0], e) : (n && o && S(t) && s.unshift(o), s = s.map(function (e) {
                return e && e.value || e;
              }).reduce(function (e, t) {
                return e.concat(t);
              }, []).reduce(P, ""), A(s) || r.setAttributeNS(i, t, s));
            }
          }, {
            key: "_renderStyleAttribute",
            value: function _renderStyleAttribute(e, t) {
              var s = t.node;
              for (var _o118 in e) {
                var _i98 = e[_o118];
                m(_i98) ? this._bindToObservable({
                  schema: [_i98],
                  updater: w(s, _o118),
                  data: t
                }) : s.style[_o118] = _i98;
              }
            }
          }, {
            key: "_renderElementChildren",
            value: function _renderElementChildren(e) {
              var t = e.node,
                s = e.intoFragment ? document.createDocumentFragment() : t,
                o = e.isApplying;
              var i = 0;
              var _iterator265 = _createForOfIteratorHelper(this.children),
                _step265;
              try {
                for (_iterator265.s(); !(_step265 = _iterator265.n()).done;) {
                  var _r46 = _step265.value;
                  if (E(_r46)) {
                    if (!o) {
                      _r46.setParent(t);
                      var _iterator266 = _createForOfIteratorHelper(_r46),
                        _step266;
                      try {
                        for (_iterator266.s(); !(_step266 = _iterator266.n()).done;) {
                          var _e197 = _step266.value;
                          s.appendChild(_e197.element);
                        }
                      } catch (err) {
                        _iterator266.e(err);
                      } finally {
                        _iterator266.f();
                      }
                    }
                  } else if (T(_r46)) o || (_r46.isRendered || _r46.render(), s.appendChild(_r46.element));else if ((0, c.Z)(_r46)) s.appendChild(_r46);else if (o) {
                    var _t186 = {
                      children: [],
                      bindings: [],
                      attributes: {}
                    };
                    e.revertData.children.push(_t186), _r46._renderNode({
                      node: s.childNodes[i++],
                      isApplying: !0,
                      revertData: _t186
                    });
                  } else s.appendChild(_r46.render());
                }
              } catch (err) {
                _iterator265.e(err);
              } finally {
                _iterator265.f();
              }
              e.intoFragment && t.appendChild(s);
            }
          }, {
            key: "_setUpListeners",
            value: function _setUpListeners(e) {
              var _this99 = this;
              if (this.eventListeners) {
                var _loop5 = function _loop5(_t187) {
                  var s = _this99.eventListeners[_t187].map(function (s) {
                    var _t187$split = _t187.split("@"),
                      _t187$split2 = _slicedToArray(_t187$split, 2),
                      o = _t187$split2[0],
                      i = _t187$split2[1];
                    return s.activateDomEventListener(o, i, e);
                  });
                  e.revertData && e.revertData.bindings.push(s);
                };
                for (var _t187 in this.eventListeners) {
                  _loop5(_t187);
                }
              }
            }
          }, {
            key: "_bindToObservable",
            value: function _bindToObservable(_ref32) {
              var e = _ref32.schema,
                t = _ref32.updater,
                s = _ref32.data;
              var o = s.revertData;
              k(e, t, s);
              var i = e.filter(function (e) {
                return !A(e);
              }).filter(function (e) {
                return e.observable;
              }).map(function (o) {
                return o.activateAttributeListener(e, t, s);
              });
              o && o.bindings.push(i);
            }
          }, {
            key: "_revertTemplateFromNode",
            value: function _revertTemplateFromNode(e, t) {
              var _iterator267 = _createForOfIteratorHelper(t.bindings),
                _step267;
              try {
                for (_iterator267.s(); !(_step267 = _iterator267.n()).done;) {
                  var _e198 = _step267.value;
                  var _iterator268 = _createForOfIteratorHelper(_e198),
                    _step268;
                  try {
                    for (_iterator268.s(); !(_step268 = _iterator268.n()).done;) {
                      var _t188 = _step268.value;
                      _t188();
                    }
                  } catch (err) {
                    _iterator268.e(err);
                  } finally {
                    _iterator268.f();
                  }
                }
              } catch (err) {
                _iterator267.e(err);
              } finally {
                _iterator267.f();
              }
              if (t.text) e.textContent = t.text;else {
                for (var _s180 in t.attributes) {
                  var _o119 = t.attributes[_s180];
                  null === _o119 ? e.removeAttribute(_s180) : e.setAttribute(_s180, _o119);
                }
                for (var _s181 = 0; _s181 < t.children.length; ++_s181) this._revertTemplateFromNode(e.childNodes[_s181], t.children[_s181]);
              }
            }
          }], [{
            key: "bind",
            value: function bind(e, t) {
              return {
                to: function to(s, o) {
                  return new p({
                    eventNameOrFunction: s,
                    attribute: s,
                    observable: e,
                    emitter: t,
                    callback: o
                  });
                },
                if: function _if(s, o, i) {
                  return new f({
                    observable: e,
                    emitter: t,
                    attribute: s,
                    valueIfTrue: o,
                    callback: i
                  });
                }
              };
            }
          }, {
            key: "extend",
            value: function extend(e, t) {
              if (e._isRendered) throw new o.ZP("template-extend-render", [this, e]);
              x(e, y(v(t)));
            }
          }]);
          return u;
        }();
        (0, i.Z)(u, r.ZP);
        var g = /*#__PURE__*/function () {
          function g(e) {
            _classCallCheck(this, g);
            Object.assign(this, e);
          }
          _createClass(g, [{
            key: "getValue",
            value: function getValue(e) {
              var t = this.observable[this.attribute];
              return this.callback ? this.callback(t, e) : t;
            }
          }, {
            key: "activateAttributeListener",
            value: function activateAttributeListener(e, t, s) {
              var _this100 = this;
              var o = function o() {
                return k(e, t, s);
              };
              return this.emitter.listenTo(this.observable, "change:" + this.attribute, o), function () {
                _this100.emitter.stopListening(_this100.observable, "change:" + _this100.attribute, o);
              };
            }
          }]);
          return g;
        }();
        var p = /*#__PURE__*/function (_g) {
          _inherits(p, _g);
          function p() {
            _classCallCheck(this, p);
            return _possibleConstructorReturn(this, _getPrototypeOf(p).apply(this, arguments));
          }
          _createClass(p, [{
            key: "activateDomEventListener",
            value: function activateDomEventListener(e, t, s) {
              var _this101 = this;
              var o = function o(e, s) {
                t && !s.target.matches(t) || ("function" == typeof _this101.eventNameOrFunction ? _this101.eventNameOrFunction(s) : _this101.observable.fire(_this101.eventNameOrFunction, s));
              };
              return this.emitter.listenTo(s.node, e, o), function () {
                _this101.emitter.stopListening(s.node, e, o);
              };
            }
          }]);
          return p;
        }(g);
        var f = /*#__PURE__*/function (_g2) {
          _inherits(f, _g2);
          function f() {
            _classCallCheck(this, f);
            return _possibleConstructorReturn(this, _getPrototypeOf(f).apply(this, arguments));
          }
          _createClass(f, [{
            key: "getValue",
            value: function getValue(e) {
              return !A(_superPropGet(f, "getValue", this, 3)([e])) && (this.valueIfTrue || !0);
            }
          }]);
          return f;
        }(g);
        function m(e) {
          return !!e && (e.value && (e = e.value), Array.isArray(e) ? e.some(m) : e instanceof g);
        }
        function k(e, t, _ref33) {
          var s = _ref33.node;
          var o = function (e, t) {
            return e.map(function (e) {
              return e instanceof g ? e.getValue(t) : e;
            });
          }(e, s);
          o = 1 == e.length && e[0] instanceof f ? o[0] : o.reduce(P, ""), A(o) ? t.remove() : t.set(o);
        }
        function _(e) {
          return {
            set: function set(t) {
              e.textContent = t;
            },
            remove: function remove() {
              e.textContent = "";
            }
          };
        }
        function b(e, t, s) {
          return {
            set: function set(o) {
              e.setAttributeNS(s, t, o);
            },
            remove: function remove() {
              e.removeAttributeNS(s, t);
            }
          };
        }
        function w(e, t) {
          return {
            set: function set(s) {
              e.style[t] = s;
            },
            remove: function remove() {
              e.style[t] = null;
            }
          };
        }
        function v(e) {
          return (0, d.Z)(e, function (e) {
            if (e && (e instanceof g || C(e) || T(e) || E(e))) return e;
          });
        }
        function y(e) {
          if ("string" == typeof e ? e = function (e) {
            return {
              text: [e]
            };
          }(e) : e.text && function (e) {
            e.text = (0, h.Z)(e.text);
          }(e), e.on && (e.eventListeners = function (e) {
            for (var _t189 in e) Z(e, _t189);
            return e;
          }(e.on), delete e.on), !e.text) {
            e.attributes && function (e) {
              for (var _t190 in e) e[_t190].value && (e[_t190].value = (0, h.Z)(e[_t190].value)), Z(e, _t190);
            }(e.attributes);
            var _t191 = [];
            if (e.children) if (E(e.children)) _t191.push(e.children);else {
              var _iterator269 = _createForOfIteratorHelper(e.children),
                _step269;
              try {
                for (_iterator269.s(); !(_step269 = _iterator269.n()).done;) {
                  var _s182 = _step269.value;
                  C(_s182) || T(_s182) || (0, c.Z)(_s182) ? _t191.push(_s182) : _t191.push(new u(_s182));
                }
              } catch (err) {
                _iterator269.e(err);
              } finally {
                _iterator269.f();
              }
            }
            e.children = _t191;
          }
          return e;
        }
        function Z(e, t) {
          e[t] = (0, h.Z)(e[t]);
        }
        function P(e, t) {
          return A(t) ? e : A(e) ? t : "".concat(e, " ").concat(t);
        }
        function j(e, t) {
          for (var _s183 in t) {
            var _e$_s;
            e[_s183] ? (_e$_s = e[_s183]).push.apply(_e$_s, _toConsumableArray(t[_s183])) : e[_s183] = t[_s183];
          }
        }
        function x(e, t) {
          var _e$text;
          if (t.attributes && (e.attributes || (e.attributes = {}), j(e.attributes, t.attributes)), t.eventListeners && (e.eventListeners || (e.eventListeners = {}), j(e.eventListeners, t.eventListeners)), t.text && (_e$text = e.text).push.apply(_e$text, _toConsumableArray(t.text)), t.children && t.children.length) {
            if (e.children.length != t.children.length) throw new o.ZP("ui-template-extend-children-mismatch", e);
            var _s184 = 0;
            var _iterator270 = _createForOfIteratorHelper(t.children),
              _step270;
            try {
              for (_iterator270.s(); !(_step270 = _iterator270.n()).done;) {
                var _o120 = _step270.value;
                x(e.children[_s184++], _o120);
              }
            } catch (err) {
              _iterator270.e(err);
            } finally {
              _iterator270.f();
            }
          }
        }
        function A(e) {
          return !e && 0 !== e;
        }
        function T(e) {
          return e instanceof n.Z;
        }
        function C(e) {
          return e instanceof u;
        }
        function E(e) {
          return e instanceof a.Z;
        }
        function S(e) {
          return "class" == e || "style" == e;
        }
      },
      "./packages/ckeditor5-ui/src/toolbar/normalizetoolbarconfig.js": function _packages_ckeditor5Ui_src_toolbar_normalizetoolbarconfigJs(e, t, s) {
        "use strict";

        function o(e) {
          return Array.isArray(e) ? {
            items: e,
            removeItems: []
          } : e ? Object.assign({
            items: [],
            removeItems: []
          }, e) : {
            items: [],
            removeItems: []
          };
        }
        s.d(t, {
          Z: function Z() {
            return o;
          }
        });
      },
      "./packages/ckeditor5-ui/src/toolbar/toolbarseparatorview.js": function _packages_ckeditor5Ui_src_toolbar_toolbarseparatorviewJs(e, t, s) {
        "use strict";

        s.d(t, {
          Z: function Z() {
            return i;
          }
        });
        var o = s("./packages/ckeditor5-ui/src/view.js");
        var i = /*#__PURE__*/function (_o$Z37) {
          _inherits(i, _o$Z37);
          function i(e) {
            var _this102;
            _classCallCheck(this, i);
            _this102 = _possibleConstructorReturn(this, _getPrototypeOf(i).call(this, e)), _this102.setTemplate({
              tag: "span",
              attributes: {
                class: ["ck", "ck-toolbar__separator"]
              }
            });
            return _this102;
          }
          return i;
        }(o.Z);
      },
      "./packages/ckeditor5-ui/src/toolbar/toolbarview.js": function _packages_ckeditor5Ui_src_toolbar_toolbarviewJs(e, t, s) {
        "use strict";

        s.d(t, {
          Z: function Z() {
            return y;
          }
        });
        var o = s("./packages/ckeditor5-ui/src/view.js"),
          i = s("./packages/ckeditor5-utils/src/focustracker.js"),
          r = s("./packages/ckeditor5-ui/src/focuscycler.js"),
          n = s("./packages/ckeditor5-utils/src/keystrokehandler.js"),
          a = s("./packages/ckeditor5-ui/src/toolbar/toolbarseparatorview.js");
        var c = /*#__PURE__*/function (_o$Z38) {
          _inherits(c, _o$Z38);
          function c(e) {
            var _this103;
            _classCallCheck(this, c);
            _this103 = _possibleConstructorReturn(this, _getPrototypeOf(c).call(this, e)), _this103.setTemplate({
              tag: "span",
              attributes: {
                class: ["ck", "ck-toolbar__line-break"]
              }
            });
            return _this103;
          }
          return c;
        }(o.Z);
        var l = s("./packages/ckeditor5-utils/src/dom/resizeobserver.js");
        function d(e) {
          return e.bindTemplate.to(function (t) {
            t.target === e.element && t.preventDefault();
          });
        }
        var h = s("./packages/ckeditor5-utils/src/dom/rect.js"),
          u = s("./packages/ckeditor5-utils/src/dom/isvisible.js"),
          g = s("./packages/ckeditor5-utils/src/dom/global.js"),
          p = s("./packages/ckeditor5-ui/src/dropdown/utils.js"),
          f = s("./packages/ckeditor5-utils/src/ckeditorerror.js"),
          m = s("./packages/ckeditor5-ui/src/toolbar/normalizetoolbarconfig.js"),
          k = s("./packages/ckeditor5-core/theme/icons/three-vertical-dots.svg"),
          _ = s("./node_modules/style-loader/dist/runtime/injectStylesIntoStyleTag.js"),
          b = s.n(_),
          w = s("./node_modules/css-loader/dist/cjs.js!./node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].use[2]!./packages/ckeditor5-ui/theme/components/toolbar/toolbar.css"),
          v = {
            injectType: "singletonStyleTag",
            attributes: {
              "data-cke": !0
            },
            insert: "head",
            singleton: !0
          };
        b()(w.Z, v);
        w.Z.locals;
        var y = /*#__PURE__*/function (_o$Z39) {
          _inherits(y, _o$Z39);
          function y(e, t) {
            var _this104;
            _classCallCheck(this, y);
            _this104 = _possibleConstructorReturn(this, _getPrototypeOf(y).call(this, e));
            var s = _this104.bindTemplate,
              o = _this104.t;
            _this104.options = t || {}, _this104.set("ariaLabel", o("Editor toolbar")), _this104.set("maxWidth", "auto"), _this104.items = _this104.createCollection(), _this104.focusTracker = new i.Z(), _this104.keystrokes = new n.Z(), _this104.set("class"), _this104.set("isCompact", !1), _this104.itemsView = new Z(e), _this104.children = _this104.createCollection(), _this104.children.add(_this104.itemsView), _this104.focusables = _this104.createCollection();
            var a = "rtl" === e.uiLanguageDirection;
            _this104._focusCycler = new r.Z({
              focusables: _this104.focusables,
              focusTracker: _this104.focusTracker,
              keystrokeHandler: _this104.keystrokes,
              actions: {
                focusPrevious: [a ? "arrowright" : "arrowleft", "arrowup"],
                focusNext: [a ? "arrowleft" : "arrowright", "arrowdown"]
              }
            });
            var c = ["ck", "ck-toolbar", s.to("class"), s.if("isCompact", "ck-toolbar_compact")];
            _this104.options.shouldGroupWhenFull && _this104.options.isFloating && c.push("ck-toolbar_floating"), _this104.setTemplate({
              tag: "div",
              attributes: {
                class: c,
                role: "toolbar",
                "aria-label": s.to("ariaLabel"),
                style: {
                  maxWidth: s.to("maxWidth")
                }
              },
              children: _this104.children,
              on: {
                mousedown: d(_assertThisInitialized(_assertThisInitialized(_this104)))
              }
            }), _this104._behavior = _this104.options.shouldGroupWhenFull ? new j(_assertThisInitialized(_assertThisInitialized(_this104))) : new P(_assertThisInitialized(_assertThisInitialized(_this104)));
            return _this104;
          }
          _createClass(y, [{
            key: "render",
            value: function render() {
              var _this105 = this;
              _superPropGet(y, "render", this, 3)([]);
              var _iterator271 = _createForOfIteratorHelper(this.items),
                _step271;
              try {
                for (_iterator271.s(); !(_step271 = _iterator271.n()).done;) {
                  var _e199 = _step271.value;
                  this.focusTracker.add(_e199.element);
                }
              } catch (err) {
                _iterator271.e(err);
              } finally {
                _iterator271.f();
              }
              this.items.on("add", function (e, t) {
                _this105.focusTracker.add(t.element);
              }), this.items.on("remove", function (e, t) {
                _this105.focusTracker.remove(t.element);
              }), this.keystrokes.listenTo(this.element), this._behavior.render(this);
            }
          }, {
            key: "destroy",
            value: function destroy() {
              return this._behavior.destroy(), this.focusTracker.destroy(), this.keystrokes.destroy(), _superPropGet(y, "destroy", this, 3)([]);
            }
          }, {
            key: "focus",
            value: function focus() {
              this._focusCycler.focusFirst();
            }
          }, {
            key: "focusLast",
            value: function focusLast() {
              this._focusCycler.focusLast();
            }
          }, {
            key: "fillFromConfig",
            value: function fillFromConfig(e, t) {
              var _this106 = this;
              var s = (0, m.Z)(e),
                o = s.items.filter(function (e, o, i) {
                  return "|" === e || -1 === s.removeItems.indexOf(e) && ("-" === e ? !_this106.options.shouldGroupWhenFull || ((0, f.KE)("toolbarview-line-break-ignored-when-grouping-items", i), !1) : !!t.has(e) || ((0, f.KE)("toolbarview-item-unavailable", {
                    name: e
                  }), !1));
                }),
                i = this._cleanSeparators(o).map(function (e) {
                  return "|" === e ? new a.Z() : "-" === e ? new c() : t.create(e);
                });
              this.items.addMany(i);
            }
          }, {
            key: "_cleanSeparators",
            value: function _cleanSeparators(e) {
              var t = function t(e) {
                  return "-" !== e && "|" !== e;
                },
                s = e.length,
                o = e.findIndex(t),
                i = s - e.slice().reverse().findIndex(t);
              return e.slice(o, i).filter(function (e, s, o) {
                if (t(e)) return !0;
                return !(s > 0 && o[s - 1] === e);
              });
            }
          }]);
          return y;
        }(o.Z);
        var Z = /*#__PURE__*/function (_o$Z40) {
          _inherits(Z, _o$Z40);
          function Z(e) {
            var _this107;
            _classCallCheck(this, Z);
            _this107 = _possibleConstructorReturn(this, _getPrototypeOf(Z).call(this, e)), _this107.children = _this107.createCollection(), _this107.setTemplate({
              tag: "div",
              attributes: {
                class: ["ck", "ck-toolbar__items"]
              },
              children: _this107.children
            });
            return _this107;
          }
          return Z;
        }(o.Z);
        var P = /*#__PURE__*/function () {
          function P(e) {
            _classCallCheck(this, P);
            var t = e.bindTemplate;
            e.set("isVertical", !1), e.itemsView.children.bindTo(e.items).using(function (e) {
              return e;
            }), e.focusables.bindTo(e.items).using(function (e) {
              return e;
            }), e.extendTemplate({
              attributes: {
                class: [t.if("isVertical", "ck-toolbar_vertical")]
              }
            });
          }
          _createClass(P, [{
            key: "render",
            value: function render() {}
          }, {
            key: "destroy",
            value: function destroy() {}
          }]);
          return P;
        }();
        var j = /*#__PURE__*/function () {
          function j(e) {
            var _this108 = this;
            _classCallCheck(this, j);
            this.view = e, this.viewChildren = e.children, this.viewFocusables = e.focusables, this.viewItemsView = e.itemsView, this.viewFocusTracker = e.focusTracker, this.viewLocale = e.locale, this.ungroupedItems = e.createCollection(), this.groupedItems = e.createCollection(), this.groupedItemsDropdown = this._createGroupedItemsDropdown(), this.resizeObserver = null, this.cachedPadding = null, this.shouldUpdateGroupingOnNextResize = !1, e.itemsView.children.bindTo(this.ungroupedItems).using(function (e) {
              return e;
            }), this.ungroupedItems.on("add", this._updateFocusCycleableItems.bind(this)), this.ungroupedItems.on("remove", this._updateFocusCycleableItems.bind(this)), e.children.on("add", this._updateFocusCycleableItems.bind(this)), e.children.on("remove", this._updateFocusCycleableItems.bind(this)), e.items.on("change", function (e, t) {
              var s = t.index;
              var _iterator272 = _createForOfIteratorHelper(t.removed),
                _step272;
              try {
                for (_iterator272.s(); !(_step272 = _iterator272.n()).done;) {
                  var _e201 = _step272.value;
                  s >= _this108.ungroupedItems.length ? _this108.groupedItems.remove(_e201) : _this108.ungroupedItems.remove(_e201);
                }
              } catch (err) {
                _iterator272.e(err);
              } finally {
                _iterator272.f();
              }
              for (var _e200 = s; _e200 < s + t.added.length; _e200++) {
                var _o121 = t.added[_e200 - s];
                _e200 > _this108.ungroupedItems.length ? _this108.groupedItems.add(_o121, _e200 - _this108.ungroupedItems.length) : _this108.ungroupedItems.add(_o121, _e200);
              }
              _this108._updateGrouping();
            }), e.extendTemplate({
              attributes: {
                class: ["ck-toolbar_grouping"]
              }
            });
          }
          _createClass(j, [{
            key: "render",
            value: function render(e) {
              this.viewElement = e.element, this._enableGroupingOnResize(), this._enableGroupingOnMaxWidthChange(e);
            }
          }, {
            key: "destroy",
            value: function destroy() {
              this.groupedItemsDropdown.destroy(), this.resizeObserver.destroy();
            }
          }, {
            key: "_updateGrouping",
            value: function _updateGrouping() {
              if (!this.viewElement.ownerDocument.body.contains(this.viewElement)) return;
              if (!(0, u.Z)(this.viewElement)) return void (this.shouldUpdateGroupingOnNextResize = !0);
              var e = this.groupedItems.length;
              var t;
              for (; this._areItemsOverflowing;) this._groupLastItem(), t = !0;
              if (!t && this.groupedItems.length) {
                for (; this.groupedItems.length && !this._areItemsOverflowing;) this._ungroupFirstItem();
                this._areItemsOverflowing && this._groupLastItem();
              }
              this.groupedItems.length !== e && this.view.fire("groupedItemsUpdate");
            }
          }, {
            key: "_enableGroupingOnResize",
            value: function _enableGroupingOnResize() {
              var _this109 = this;
              var e;
              this.resizeObserver = new l.Z(this.viewElement, function (t) {
                e && e === t.contentRect.width && !_this109.shouldUpdateGroupingOnNextResize || (_this109.shouldUpdateGroupingOnNextResize = !1, _this109._updateGrouping(), e = t.contentRect.width);
              }), this._updateGrouping();
            }
          }, {
            key: "_enableGroupingOnMaxWidthChange",
            value: function _enableGroupingOnMaxWidthChange(e) {
              var _this110 = this;
              e.on("change:maxWidth", function () {
                _this110._updateGrouping();
              });
            }
          }, {
            key: "_groupLastItem",
            value: function _groupLastItem() {
              this.groupedItems.length || (this.viewChildren.add(new a.Z()), this.viewChildren.add(this.groupedItemsDropdown), this.viewFocusTracker.add(this.groupedItemsDropdown.element)), this.groupedItems.add(this.ungroupedItems.remove(this.ungroupedItems.last), 0);
            }
          }, {
            key: "_ungroupFirstItem",
            value: function _ungroupFirstItem() {
              this.ungroupedItems.add(this.groupedItems.remove(this.groupedItems.first)), this.groupedItems.length || (this.viewChildren.remove(this.groupedItemsDropdown), this.viewChildren.remove(this.viewChildren.last), this.viewFocusTracker.remove(this.groupedItemsDropdown.element));
            }
          }, {
            key: "_createGroupedItemsDropdown",
            value: function _createGroupedItemsDropdown() {
              var e = this.viewLocale,
                t = e.t,
                s = (0, p.t9)(e);
              return s.class = "ck-toolbar__grouped-dropdown", s.panelPosition = "ltr" === e.uiLanguageDirection ? "sw" : "se", (0, p.up)(s, []), s.buttonView.set({
                label: t("Show more items"),
                tooltip: !0,
                tooltipPosition: "rtl" === e.uiLanguageDirection ? "se" : "sw",
                icon: k.Z
              }), s.toolbarView.items.bindTo(this.groupedItems).using(function (e) {
                return e;
              }), s;
            }
          }, {
            key: "_updateFocusCycleableItems",
            value: function _updateFocusCycleableItems() {
              var _this111 = this;
              this.viewFocusables.clear(), this.ungroupedItems.map(function (e) {
                _this111.viewFocusables.add(e);
              }), this.groupedItems.length && this.viewFocusables.add(this.groupedItemsDropdown);
            }
          }, {
            key: "_areItemsOverflowing",
            get: function get() {
              if (!this.ungroupedItems.length) return !1;
              var e = this.viewElement,
                t = this.viewLocale.uiLanguageDirection,
                s = new h.Z(e.lastChild),
                o = new h.Z(e);
              if (!this.cachedPadding) {
                var _s185 = g.Z.window.getComputedStyle(e),
                  _o122 = "ltr" === t ? "paddingRight" : "paddingLeft";
                this.cachedPadding = Number.parseInt(_s185[_o122]);
              }
              return "ltr" === t ? s.right > o.right - this.cachedPadding : s.left < o.left + this.cachedPadding;
            }
          }]);
          return j;
        }();
      },
      "./packages/ckeditor5-ui/src/tooltip/tooltipview.js": function _packages_ckeditor5Ui_src_tooltip_tooltipviewJs(e, t, s) {
        "use strict";

        s.d(t, {
          Z: function Z() {
            return c;
          }
        });
        var o = s("./packages/ckeditor5-ui/src/view.js"),
          i = s("./node_modules/style-loader/dist/runtime/injectStylesIntoStyleTag.js"),
          r = s.n(i),
          n = s("./node_modules/css-loader/dist/cjs.js!./node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].use[2]!./packages/ckeditor5-ui/theme/components/tooltip/tooltip.css"),
          a = {
            injectType: "singletonStyleTag",
            attributes: {
              "data-cke": !0
            },
            insert: "head",
            singleton: !0
          };
        r()(n.Z, a);
        n.Z.locals;
        var c = /*#__PURE__*/function (_o$Z41) {
          _inherits(c, _o$Z41);
          function c(e) {
            var _this112;
            _classCallCheck(this, c);
            _this112 = _possibleConstructorReturn(this, _getPrototypeOf(c).call(this, e)), _this112.set("text", ""), _this112.set("position", "s");
            var t = _this112.bindTemplate;
            _this112.setTemplate({
              tag: "span",
              attributes: {
                class: ["ck", "ck-tooltip", t.to("position", function (e) {
                  return "ck-tooltip_" + e;
                }), t.if("text", "ck-hidden", function (e) {
                  return !e.trim();
                })]
              },
              children: [{
                tag: "span",
                attributes: {
                  class: ["ck", "ck-tooltip__text"]
                },
                children: [{
                  text: t.to("text")
                }]
              }]
            });
            return _this112;
          }
          return c;
        }(o.Z);
      },
      "./packages/ckeditor5-ui/src/view.js": function _packages_ckeditor5Ui_src_viewJs(e, t, s) {
        "use strict";

        s.d(t, {
          Z: function Z() {
            return f;
          }
        });
        var o = s("./packages/ckeditor5-utils/src/ckeditorerror.js"),
          i = s("./packages/ckeditor5-ui/src/viewcollection.js"),
          r = s("./packages/ckeditor5-ui/src/template.js"),
          n = s("./packages/ckeditor5-utils/src/dom/emittermixin.js"),
          a = s("./packages/ckeditor5-utils/src/observablemixin.js"),
          c = s("./packages/ckeditor5-utils/src/collection.js"),
          l = s("./packages/ckeditor5-utils/src/mix.js"),
          d = s("./packages/ckeditor5-utils/src/isiterable.js"),
          h = s("./node_modules/style-loader/dist/runtime/injectStylesIntoStyleTag.js"),
          u = s.n(h),
          g = s("./node_modules/css-loader/dist/cjs.js!./node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].use[2]!./packages/ckeditor5-ui/theme/globals/globals.css"),
          p = {
            injectType: "singletonStyleTag",
            attributes: {
              "data-cke": !0
            },
            insert: "head",
            singleton: !0
          };
        u()(g.Z, p);
        g.Z.locals;
        var f = /*#__PURE__*/function () {
          function f(e) {
            _classCallCheck(this, f);
            this.element = null, this.isRendered = !1, this.locale = e, this.t = e && e.t, this._viewCollections = new c.Z(), this._unboundChildren = this.createCollection(), this._viewCollections.on("add", function (t, s) {
              s.locale = e;
            }), this.decorate("render");
          }
          _createClass(f, [{
            key: "createCollection",
            value: function createCollection(e) {
              var t = new i.Z(e);
              return this._viewCollections.add(t), t;
            }
          }, {
            key: "registerChild",
            value: function registerChild(e) {
              (0, d.Z)(e) || (e = [e]);
              var _iterator273 = _createForOfIteratorHelper(e),
                _step273;
              try {
                for (_iterator273.s(); !(_step273 = _iterator273.n()).done;) {
                  var _t192 = _step273.value;
                  this._unboundChildren.add(_t192);
                }
              } catch (err) {
                _iterator273.e(err);
              } finally {
                _iterator273.f();
              }
            }
          }, {
            key: "deregisterChild",
            value: function deregisterChild(e) {
              (0, d.Z)(e) || (e = [e]);
              var _iterator274 = _createForOfIteratorHelper(e),
                _step274;
              try {
                for (_iterator274.s(); !(_step274 = _iterator274.n()).done;) {
                  var _t193 = _step274.value;
                  this._unboundChildren.remove(_t193);
                }
              } catch (err) {
                _iterator274.e(err);
              } finally {
                _iterator274.f();
              }
            }
          }, {
            key: "setTemplate",
            value: function setTemplate(e) {
              this.template = new r.ZP(e);
            }
          }, {
            key: "extendTemplate",
            value: function extendTemplate(e) {
              r.ZP.extend(this.template, e);
            }
          }, {
            key: "render",
            value: function render() {
              if (this.isRendered) throw new o.ZP("ui-view-render-already-rendered", this);
              this.template && (this.element = this.template.render(), this.registerChild(this.template.getViews())), this.isRendered = !0;
            }
          }, {
            key: "destroy",
            value: function destroy() {
              this.stopListening(), this._viewCollections.map(function (e) {
                return e.destroy();
              }), this.template && this.template._revertData && this.template.revert(this.element);
            }
          }, {
            key: "bindTemplate",
            get: function get() {
              return this._bindTemplate ? this._bindTemplate : this._bindTemplate = r.ZP.bind(this, this);
            }
          }]);
          return f;
        }();
        (0, l.Z)(f, n.Z), (0, l.Z)(f, a.Z);
      },
      "./packages/ckeditor5-ui/src/viewcollection.js": function _packages_ckeditor5Ui_src_viewcollectionJs(e, t, s) {
        "use strict";

        s.d(t, {
          Z: function Z() {
            return r;
          }
        });
        var o = s("./packages/ckeditor5-utils/src/ckeditorerror.js"),
          i = s("./packages/ckeditor5-utils/src/collection.js");
        var r = /*#__PURE__*/function (_i$Z5) {
          _inherits(r, _i$Z5);
          function r() {
            var _this113;
            var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
            _classCallCheck(this, r);
            _this113 = _possibleConstructorReturn(this, _getPrototypeOf(r).call(this, e, {
              idProperty: "viewUid"
            })), _this113.on("add", function (e, t, s) {
              _this113._renderViewIntoCollectionParent(t, s);
            }), _this113.on("remove", function (e, t) {
              t.element && _this113._parentElement && t.element.remove();
            }), _this113._parentElement = null;
            return _this113;
          }
          _createClass(r, [{
            key: "destroy",
            value: function destroy() {
              this.map(function (e) {
                return e.destroy();
              });
            }
          }, {
            key: "setParent",
            value: function setParent(e) {
              this._parentElement = e;
              var _iterator275 = _createForOfIteratorHelper(this),
                _step275;
              try {
                for (_iterator275.s(); !(_step275 = _iterator275.n()).done;) {
                  var _e202 = _step275.value;
                  this._renderViewIntoCollectionParent(_e202);
                }
              } catch (err) {
                _iterator275.e(err);
              } finally {
                _iterator275.f();
              }
            }
          }, {
            key: "delegate",
            value: function delegate() {
              var _this114 = this;
              for (var _len9 = arguments.length, e = new Array(_len9), _key9 = 0; _key9 < _len9; _key9++) {
                e[_key9] = arguments[_key9];
              }
              if (!e.length || !e.every(function (e) {
                return "string" == typeof e;
              })) throw new o.ZP("ui-viewcollection-delegate-wrong-events", this);
              return {
                to: function to(t) {
                  var _iterator276 = _createForOfIteratorHelper(_this114),
                    _step276;
                  try {
                    for (_iterator276.s(); !(_step276 = _iterator276.n()).done;) {
                      var _s188 = _step276.value;
                      for (var _i101 = 0, _e205 = e; _i101 < _e205.length; _i101++) {
                        var _o123 = _e205[_i101];
                        _s188.delegate(_o123).to(t);
                      }
                    }
                  } catch (err) {
                    _iterator276.e(err);
                  } finally {
                    _iterator276.f();
                  }
                  _this114.on("add", function (s, o) {
                    for (var _i99 = 0, _e203 = e; _i99 < _e203.length; _i99++) {
                      var _s186 = _e203[_i99];
                      o.delegate(_s186).to(t);
                    }
                  }), _this114.on("remove", function (s, o) {
                    for (var _i100 = 0, _e204 = e; _i100 < _e204.length; _i100++) {
                      var _s187 = _e204[_i100];
                      o.stopDelegating(_s187, t);
                    }
                  });
                }
              };
            }
          }, {
            key: "_renderViewIntoCollectionParent",
            value: function _renderViewIntoCollectionParent(e, t) {
              e.isRendered || e.render(), e.element && this._parentElement && this._parentElement.insertBefore(e.element, this._parentElement.children[t]);
            }
          }]);
          return r;
        }(i.Z);
      },
      "./packages/ckeditor5-utils/src/ckeditorerror.js": function _packages_ckeditor5Utils_src_ckeditorerrorJs(e, t, s) {
        "use strict";

        s.d(t, {
          H: function H() {
            return r;
          },
          KE: function KE() {
            return i;
          },
          ZP: function ZP() {
            return o;
          }
        });
        var o = /*#__PURE__*/function (_Error) {
          _inherits(o, _Error);
          function o(e, t, s) {
            var _this115;
            _classCallCheck(this, o);
            _this115 = _possibleConstructorReturn(this, _getPrototypeOf(o).call(this, function (e, t) {
              var s = new WeakSet(),
                o = function o(e, t) {
                  if ("object" == typeof t && null !== t) {
                    if (s.has(t)) return "[object ".concat(t.constructor.name, "]");
                    s.add(t);
                  }
                  return t;
                },
                i = t ? " ".concat(JSON.stringify(t, o)) : "",
                r = n(e);
              return e + i + r;
            }(e, s))), _this115.name = "CKEditorError", _this115.context = t, _this115.data = s;
            return _this115;
          }
          _createClass(o, [{
            key: "is",
            value: function is(e) {
              return "CKEditorError" === e;
            }
          }], [{
            key: "rethrowUnexpectedError",
            value: function rethrowUnexpectedError(e, t) {
              if (e.is && e.is("CKEditorError")) throw e;
              var s = new o(e.message, t);
              throw s.stack = e.stack, s;
            }
          }]);
          return o;
        }(_wrapNativeSuper(Error));
        function i(e, t) {
          var _console;
          (_console = console).warn.apply(_console, _toConsumableArray(a(e, t)));
        }
        function r(e, t) {
          var _console2;
          (_console2 = console).error.apply(_console2, _toConsumableArray(a(e, t)));
        }
        function n(e) {
          return "\nRead more: https://ckeditor.com/docs/ckeditor5/latest/framework/guides/support/error-codes.html#error-".concat(e);
        }
        function a(e, t) {
          var s = n(e);
          return t ? [e, t, s] : [e, s];
        }
      },
      "./packages/ckeditor5-utils/src/collection.js": function _packages_ckeditor5Utils_src_collectionJs(e, t, s) {
        "use strict";

        s.d(t, {
          Z: function Z() {
            return c;
          }
        });
        var o = s("./packages/ckeditor5-utils/src/emittermixin.js"),
          i = s("./packages/ckeditor5-utils/src/ckeditorerror.js"),
          r = s("./packages/ckeditor5-utils/src/uid.js"),
          n = s("./packages/ckeditor5-utils/src/isiterable.js"),
          a = s("./packages/ckeditor5-utils/src/mix.js");
        var c = /*#__PURE__*/function () {
          function c() {
            var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
            var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
            _classCallCheck(this, c);
            var s = (0, n.Z)(e);
            if (s || (t = e), this._items = [], this._itemMap = new Map(), this._idProperty = t.idProperty || "id", this._bindToExternalToInternalMap = new WeakMap(), this._bindToInternalToExternalMap = new WeakMap(), this._skippedIndexesFromExternal = [], s) {
              var _iterator277 = _createForOfIteratorHelper(e),
                _step277;
              try {
                for (_iterator277.s(); !(_step277 = _iterator277.n()).done;) {
                  var _t194 = _step277.value;
                  this._items.push(_t194), this._itemMap.set(this._getItemIdBeforeAdding(_t194), _t194);
                }
              } catch (err) {
                _iterator277.e(err);
              } finally {
                _iterator277.f();
              }
            }
          }
          _createClass(c, [{
            key: "add",
            value: function add(e, t) {
              return this.addMany([e], t);
            }
          }, {
            key: "addMany",
            value: function addMany(e, t) {
              if (void 0 === t) t = this._items.length;else if (t > this._items.length || t < 0) throw new i.ZP("collection-add-item-invalid-index", this);
              for (var _s189 = 0; _s189 < e.length; _s189++) {
                var _o124 = e[_s189],
                  _i102 = this._getItemIdBeforeAdding(_o124),
                  _r47 = t + _s189;
                this._items.splice(_r47, 0, _o124), this._itemMap.set(_i102, _o124), this.fire("add", _o124, _r47);
              }
              return this.fire("change", {
                added: e,
                removed: [],
                index: t
              }), this;
            }
          }, {
            key: "get",
            value: function get(e) {
              var t;
              if ("string" == typeof e) t = this._itemMap.get(e);else {
                if ("number" != typeof e) throw new i.ZP("collection-get-invalid-arg", this);
                t = this._items[e];
              }
              return t || null;
            }
          }, {
            key: "has",
            value: function has(e) {
              if ("string" == typeof e) return this._itemMap.has(e);
              {
                var _t195 = e[this._idProperty];
                return this._itemMap.has(_t195);
              }
            }
          }, {
            key: "getIndex",
            value: function getIndex(e) {
              var t;
              return t = "string" == typeof e ? this._itemMap.get(e) : e, this._items.indexOf(t);
            }
          }, {
            key: "remove",
            value: function remove(e) {
              var _this$_remove = this._remove(e),
                _this$_remove2 = _slicedToArray(_this$_remove, 2),
                t = _this$_remove2[0],
                s = _this$_remove2[1];
              return this.fire("change", {
                added: [],
                removed: [t],
                index: s
              }), t;
            }
          }, {
            key: "map",
            value: function map(e, t) {
              return this._items.map(e, t);
            }
          }, {
            key: "find",
            value: function find(e, t) {
              return this._items.find(e, t);
            }
          }, {
            key: "filter",
            value: function filter(e, t) {
              return this._items.filter(e, t);
            }
          }, {
            key: "clear",
            value: function clear() {
              this._bindToCollection && (this.stopListening(this._bindToCollection), this._bindToCollection = null);
              var e = Array.from(this._items);
              for (; this.length;) this._remove(0);
              this.fire("change", {
                added: [],
                removed: e,
                index: 0
              });
            }
          }, {
            key: "bindTo",
            value: function bindTo(e) {
              var _this116 = this;
              if (this._bindToCollection) throw new i.ZP("collection-bind-to-rebind", this);
              return this._bindToCollection = e, {
                as: function as(e) {
                  _this116._setUpBindToBinding(function (t) {
                    return new e(t);
                  });
                },
                using: function using(e) {
                  "function" == typeof e ? _this116._setUpBindToBinding(function (t) {
                    return e(t);
                  }) : _this116._setUpBindToBinding(function (t) {
                    return t[e];
                  });
                }
              };
            }
          }, {
            key: "_setUpBindToBinding",
            value: function _setUpBindToBinding(e) {
              var _this117 = this;
              var t = this._bindToCollection,
                s = function s(_s191, o, i) {
                  var r = t._bindToCollection == _this117,
                    n = t._bindToInternalToExternalMap.get(o);
                  if (r && n) _this117._bindToExternalToInternalMap.set(o, n), _this117._bindToInternalToExternalMap.set(n, o);else {
                    var _s190 = e(o);
                    if (!_s190) return void _this117._skippedIndexesFromExternal.push(i);
                    var _r48 = i;
                    var _iterator278 = _createForOfIteratorHelper(_this117._skippedIndexesFromExternal),
                      _step278;
                    try {
                      for (_iterator278.s(); !(_step278 = _iterator278.n()).done;) {
                        var _e207 = _step278.value;
                        i > _e207 && _r48--;
                      }
                    } catch (err) {
                      _iterator278.e(err);
                    } finally {
                      _iterator278.f();
                    }
                    var _iterator279 = _createForOfIteratorHelper(t._skippedIndexesFromExternal),
                      _step279;
                    try {
                      for (_iterator279.s(); !(_step279 = _iterator279.n()).done;) {
                        var _e208 = _step279.value;
                        _r48 >= _e208 && _r48++;
                      }
                    } catch (err) {
                      _iterator279.e(err);
                    } finally {
                      _iterator279.f();
                    }
                    _this117._bindToExternalToInternalMap.set(o, _s190), _this117._bindToInternalToExternalMap.set(_s190, o), _this117.add(_s190, _r48);
                    for (var _e206 = 0; _e206 < t._skippedIndexesFromExternal.length; _e206++) _r48 <= t._skippedIndexesFromExternal[_e206] && t._skippedIndexesFromExternal[_e206]++;
                  }
                };
              var _iterator280 = _createForOfIteratorHelper(t),
                _step280;
              try {
                for (_iterator280.s(); !(_step280 = _iterator280.n()).done;) {
                  var _e209 = _step280.value;
                  s(0, _e209, t.getIndex(_e209));
                }
              } catch (err) {
                _iterator280.e(err);
              } finally {
                _iterator280.f();
              }
              this.listenTo(t, "add", s), this.listenTo(t, "remove", function (e, t, s) {
                var o = _this117._bindToExternalToInternalMap.get(t);
                o && _this117.remove(o), _this117._skippedIndexesFromExternal = _this117._skippedIndexesFromExternal.reduce(function (e, t) {
                  return s < t && e.push(t - 1), s > t && e.push(t), e;
                }, []);
              });
            }
          }, {
            key: "_getItemIdBeforeAdding",
            value: function _getItemIdBeforeAdding(e) {
              var t = this._idProperty;
              var s;
              if (t in e) {
                if (s = e[t], "string" != typeof s) throw new i.ZP("collection-add-invalid-id", this);
                if (this.get(s)) throw new i.ZP("collection-add-item-already-exists", this);
              } else e[t] = s = (0, r.Z)();
              return s;
            }
          }, {
            key: "_remove",
            value: function _remove(e) {
              var t,
                s,
                o,
                r = !1;
              var n = this._idProperty;
              if ("string" == typeof e ? (s = e, o = this._itemMap.get(s), r = !o, o && (t = this._items.indexOf(o))) : "number" == typeof e ? (t = e, o = this._items[t], r = !o, o && (s = o[n])) : (o = e, s = o[n], t = this._items.indexOf(o), r = -1 == t || !this._itemMap.get(s)), r) throw new i.ZP("collection-remove-404", this);
              this._items.splice(t, 1), this._itemMap.delete(s);
              var a = this._bindToInternalToExternalMap.get(o);
              return this._bindToInternalToExternalMap.delete(o), this._bindToExternalToInternalMap.delete(a), this.fire("remove", o, t), [o, t];
            }
          }, {
            key: Symbol.iterator,
            value: function value() {
              return this._items[Symbol.iterator]();
            }
          }, {
            key: "length",
            get: function get() {
              return this._items.length;
            }
          }, {
            key: "first",
            get: function get() {
              return this._items[0] || null;
            }
          }, {
            key: "last",
            get: function get() {
              return this._items[this.length - 1] || null;
            }
          }]);
          return c;
        }();
        (0, a.Z)(c, o.ZP);
      },
      "./packages/ckeditor5-utils/src/comparearrays.js": function _packages_ckeditor5Utils_src_comparearraysJs(e, t, s) {
        "use strict";

        function o(e, t) {
          var s = Math.min(e.length, t.length);
          for (var _o125 = 0; _o125 < s; _o125++) if (e[_o125] != t[_o125]) return _o125;
          return e.length == t.length ? "same" : e.length < t.length ? "prefix" : "extension";
        }
        s.d(t, {
          Z: function Z() {
            return o;
          }
        });
      },
      "./packages/ckeditor5-utils/src/count.js": function _packages_ckeditor5Utils_src_countJs(e, t, s) {
        "use strict";

        function o(e) {
          var t = 0;
          var _iterator281 = _createForOfIteratorHelper(e),
            _step281;
          try {
            for (_iterator281.s(); !(_step281 = _iterator281.n()).done;) {
              var _s192 = _step281.value;
              t++;
            }
          } catch (err) {
            _iterator281.e(err);
          } finally {
            _iterator281.f();
          }
          return t;
        }
        s.d(t, {
          Z: function Z() {
            return o;
          }
        });
      },
      "./packages/ckeditor5-utils/src/diff.js": function _packages_ckeditor5Utils_src_diffJs(e, t, s) {
        "use strict";

        s.d(t, {
          Z: function Z() {
            return i;
          }
        });
        var o = s("./packages/ckeditor5-utils/src/fastdiff.js");
        function i(e, t, s) {
          s = s || function (e, t) {
            return e === t;
          };
          var o = e.length,
            r = t.length;
          if (o > 200 || r > 200 || o + r > 300) return i.fastDiff(e, t, s, !0);
          var n, a;
          if (r < o) {
            var _s193 = e;
            e = t, t = _s193, n = "delete", a = "insert";
          } else n = "insert", a = "delete";
          var c = e.length,
            l = t.length,
            d = l - c,
            h = {},
            u = {};
          function g(o) {
            var i = (void 0 !== u[o - 1] ? u[o - 1] : -1) + 1,
              r = void 0 !== u[o + 1] ? u[o + 1] : -1,
              d = i > r ? -1 : 1;
            h[o + d] && (h[o] = h[o + d].slice(0)), h[o] || (h[o] = []), h[o].push(i > r ? n : a);
            var g = Math.max(i, r),
              p = g - o;
            for (; p < c && g < l && s(e[p], t[g]);) p++, g++, h[o].push("equal");
            return g;
          }
          var p,
            f = 0;
          do {
            for (p = -f; p < d; p++) u[p] = g(p);
            for (p = d + f; p > d; p--) u[p] = g(p);
            u[d] = g(d), f++;
          } while (u[d] !== l);
          return h[d].slice(1);
        }
        i.fastDiff = o.Z;
      },
      "./packages/ckeditor5-utils/src/dom/createelement.js": function _packages_ckeditor5Utils_src_dom_createelementJs(e, t, s) {
        "use strict";

        s.d(t, {
          Z: function Z() {
            return c;
          }
        });
        var o = s("./packages/ckeditor5-utils/src/isiterable.js"),
          i = s("./node_modules/lodash-es/_baseGetTag.js"),
          r = s("./node_modules/lodash-es/isArray.js"),
          n = s("./node_modules/lodash-es/isObjectLike.js");
        var a = function a(e) {
          return "string" == typeof e || !(0, r.Z)(e) && (0, n.Z)(e) && "[object String]" == (0, i.Z)(e);
        };
        function c(e, t) {
          var s = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
          var i = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : [];
          var r = s && s.xmlns,
            n = r ? e.createElementNS(r, t) : e.createElement(t);
          for (var _e210 in s) n.setAttribute(_e210, s[_e210]);
          !a(i) && (0, o.Z)(i) || (i = [i]);
          var _iterator282 = _createForOfIteratorHelper(i),
            _step282;
          try {
            for (_iterator282.s(); !(_step282 = _iterator282.n()).done;) {
              var _t196 = _step282.value;
              a(_t196) && (_t196 = e.createTextNode(_t196)), n.appendChild(_t196);
            }
          } catch (err) {
            _iterator282.e(err);
          } finally {
            _iterator282.f();
          }
          return n;
        }
      },
      "./packages/ckeditor5-utils/src/dom/emittermixin.js": function _packages_ckeditor5Utils_src_dom_emittermixinJs(e, t, s) {
        "use strict";

        s.d(t, {
          Z: function Z() {
            return c;
          }
        });
        var o = s("./packages/ckeditor5-utils/src/emittermixin.js"),
          i = s("./packages/ckeditor5-utils/src/uid.js"),
          r = s("./packages/ckeditor5-utils/src/dom/isnode.js"),
          n = s("./packages/ckeditor5-utils/src/dom/iswindow.js"),
          a = s("./node_modules/lodash-es/assignIn.js");
        var c = (0, a.Z)({}, o.ZP, {
          listenTo: function listenTo(e, t, s) {
            var i = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
            if ((0, r.Z)(e) || (0, n.Z)(e)) {
              var _o126 = {
                  capture: !!i.useCapture,
                  passive: !!i.usePassive
                },
                _r49 = this._getProxyEmitter(e, _o126) || new l(e, _o126);
              this.listenTo(_r49, t, s, i);
            } else o.ZP.listenTo.call(this, e, t, s, i);
          },
          stopListening: function stopListening(e, t, s) {
            if ((0, r.Z)(e) || (0, n.Z)(e)) {
              var _o127 = this._getAllProxyEmitters(e);
              var _iterator283 = _createForOfIteratorHelper(_o127),
                _step283;
              try {
                for (_iterator283.s(); !(_step283 = _iterator283.n()).done;) {
                  var _e211 = _step283.value;
                  this.stopListening(_e211, t, s);
                }
              } catch (err) {
                _iterator283.e(err);
              } finally {
                _iterator283.f();
              }
            } else o.ZP.stopListening.call(this, e, t, s);
          },
          _getProxyEmitter: function _getProxyEmitter(e, t) {
            return (0, o.Rl)(this, d(e, t));
          },
          _getAllProxyEmitters: function _getAllProxyEmitters(e) {
            var _this118 = this;
            return [{
              capture: !1,
              passive: !1
            }, {
              capture: !1,
              passive: !0
            }, {
              capture: !0,
              passive: !1
            }, {
              capture: !0,
              passive: !0
            }].map(function (t) {
              return _this118._getProxyEmitter(e, t);
            }).filter(function (e) {
              return !!e;
            });
          }
        });
        var l = function l(e, t) {
          _classCallCheck(this, l);
          (0, o.Hv)(this, d(e, t)), this._domNode = e, this._options = t;
        };
        function d(e, t) {
          var s = function (e) {
            return e["data-ck-expando"] || (e["data-ck-expando"] = (0, i.Z)());
          }(e);
          var _iterator284 = _createForOfIteratorHelper(Object.keys(t).sort()),
            _step284;
          try {
            for (_iterator284.s(); !(_step284 = _iterator284.n()).done;) {
              var _e212 = _step284.value;
              t[_e212] && (s += "-" + _e212);
            }
          } catch (err) {
            _iterator284.e(err);
          } finally {
            _iterator284.f();
          }
          return s;
        }
        (0, a.Z)(l.prototype, o.ZP, {
          attach: function attach(e) {
            if (this._domListeners && this._domListeners[e]) return;
            var t = this._createDomListener(e);
            this._domNode.addEventListener(e, t, this._options), this._domListeners || (this._domListeners = {}), this._domListeners[e] = t;
          },
          detach: function detach(e) {
            var t;
            !this._domListeners[e] || (t = this._events[e]) && t.callbacks.length || this._domListeners[e].removeListener();
          },
          _addEventListener: function _addEventListener(e, t, s) {
            this.attach(e), o.ZP._addEventListener.call(this, e, t, s);
          },
          _removeEventListener: function _removeEventListener(e, t) {
            o.ZP._removeEventListener.call(this, e, t), this.detach(e);
          },
          _createDomListener: function _createDomListener(e) {
            var _this119 = this;
            var t = function t(_t197) {
              _this119.fire(e, _t197);
            };
            return t.removeListener = function () {
              _this119._domNode.removeEventListener(e, t, _this119._options), delete _this119._domListeners[e];
            }, t;
          }
        });
      },
      "./packages/ckeditor5-utils/src/dom/getborderwidths.js": function _packages_ckeditor5Utils_src_dom_getborderwidthsJs(e, t, s) {
        "use strict";

        function o(e) {
          var t = e.ownerDocument.defaultView.getComputedStyle(e);
          return {
            top: parseInt(t.borderTopWidth, 10),
            right: parseInt(t.borderRightWidth, 10),
            bottom: parseInt(t.borderBottomWidth, 10),
            left: parseInt(t.borderLeftWidth, 10)
          };
        }
        s.d(t, {
          Z: function Z() {
            return o;
          }
        });
      },
      "./packages/ckeditor5-utils/src/dom/global.js": function _packages_ckeditor5Utils_src_dom_globalJs(e, t, s) {
        "use strict";

        s.d(t, {
          Z: function Z() {
            return o;
          }
        });
        var o = {
          window: window,
          document: document
        };
      },
      "./packages/ckeditor5-utils/src/dom/iscomment.js": function _packages_ckeditor5Utils_src_dom_iscommentJs(e, t, s) {
        "use strict";

        function o(e) {
          return e && e.nodeType === Node.COMMENT_NODE;
        }
        s.d(t, {
          Z: function Z() {
            return o;
          }
        });
      },
      "./packages/ckeditor5-utils/src/dom/isnode.js": function _packages_ckeditor5Utils_src_dom_isnodeJs(e, t, s) {
        "use strict";

        function o(e) {
          if (e) {
            if (e.defaultView) return e instanceof e.defaultView.Document;
            if (e.ownerDocument && e.ownerDocument.defaultView) return e instanceof e.ownerDocument.defaultView.Node;
          }
          return !1;
        }
        s.d(t, {
          Z: function Z() {
            return o;
          }
        });
      },
      "./packages/ckeditor5-utils/src/dom/isrange.js": function _packages_ckeditor5Utils_src_dom_israngeJs(e, t, s) {
        "use strict";

        function o(e) {
          return "[object Range]" == Object.prototype.toString.apply(e);
        }
        s.d(t, {
          Z: function Z() {
            return o;
          }
        });
      },
      "./packages/ckeditor5-utils/src/dom/istext.js": function _packages_ckeditor5Utils_src_dom_istextJs(e, t, s) {
        "use strict";

        function o(e) {
          return "[object Text]" == Object.prototype.toString.call(e);
        }
        s.d(t, {
          Z: function Z() {
            return o;
          }
        });
      },
      "./packages/ckeditor5-utils/src/dom/isvisible.js": function _packages_ckeditor5Utils_src_dom_isvisibleJs(e, t, s) {
        "use strict";

        function o(e) {
          return !!(e && e.getClientRects && e.getClientRects().length);
        }
        s.d(t, {
          Z: function Z() {
            return o;
          }
        });
      },
      "./packages/ckeditor5-utils/src/dom/iswindow.js": function _packages_ckeditor5Utils_src_dom_iswindowJs(e, t, s) {
        "use strict";

        function o(e) {
          var t = Object.prototype.toString.apply(e);
          return "[object Window]" == t || "[object global]" == t;
        }
        s.d(t, {
          Z: function Z() {
            return o;
          }
        });
      },
      "./packages/ckeditor5-utils/src/dom/position.js": function _packages_ckeditor5Utils_src_dom_positionJs(e, t, s) {
        "use strict";

        s.d(t, {
          x: function x() {
            return a;
          }
        });
        var o = s("./packages/ckeditor5-utils/src/dom/global.js"),
          i = s("./packages/ckeditor5-utils/src/dom/rect.js");
        var r = s("./packages/ckeditor5-utils/src/dom/getborderwidths.js"),
          n = s("./node_modules/lodash-es/isFunction.js");
        function a(_ref34) {
          var e = _ref34.element,
            t = _ref34.target,
            s = _ref34.positions,
            r = _ref34.limiter,
            a = _ref34.fitInViewport,
            c = _ref34.viewportOffsetConfig;
          (0, n.Z)(t) && (t = t()), (0, n.Z)(r) && (r = r());
          var d = function (e) {
              return e && e.parentNode ? e.offsetParent === o.Z.document.body ? null : e.offsetParent : null;
            }(e),
            h = new i.Z(e);
          var u;
          var g = {
            targetRect: new i.Z(t),
            elementRect: h,
            positionedElementAncestor: d
          };
          if (r || a) {
            var _e213 = r && new i.Z(r).getVisible(),
              _t198 = a && function (e) {
                e = Object.assign({
                  top: 0,
                  bottom: 0,
                  left: 0,
                  right: 0
                }, e);
                var t = new i.Z(o.Z.window);
                return t.top += e.top, t.height -= e.top, t.bottom -= e.bottom, t.height -= e.bottom, t;
              }(c);
            Object.assign(g, {
              limiterRect: _e213,
              viewportRect: _t198
            }), u = function (e, t) {
              var s = t.elementRect,
                o = s.getArea(),
                i = e.map(function (e) {
                  return new l(e, t);
                }).filter(function (e) {
                  return !!e.name;
                });
              var r = 0,
                n = null;
              var _iterator285 = _createForOfIteratorHelper(i),
                _step285;
              try {
                for (_iterator285.s(); !(_step285 = _iterator285.n()).done;) {
                  var _e214 = _step285.value;
                  var _t199 = _e214._limiterIntersectionArea,
                    _s194 = _e214._viewportIntersectionArea;
                  if (_t199 === o) return _e214;
                  var _i103 = Math.pow(_s194, 2) + Math.pow(_t199, 2);
                  _i103 > r && (r = _i103, n = _e214);
                }
              } catch (err) {
                _iterator285.e(err);
              } finally {
                _iterator285.f();
              }
              return n;
            }(s, g) || new l(s[0], g);
          } else u = new l(s[0], g);
          return u;
        }
        function c(e) {
          var _o$Z$window = o.Z.window,
            t = _o$Z$window.scrollX,
            s = _o$Z$window.scrollY;
          return e.clone().moveBy(t, s);
        }
        var l = /*#__PURE__*/function () {
          function l(e, t) {
            _classCallCheck(this, l);
            var s = e(t.targetRect, t.elementRect, t.viewportRect);
            if (!s) return;
            var o = s.left,
              i = s.top,
              r = s.name,
              n = s.config;
            Object.assign(this, {
              name: r,
              config: n
            }), this._positioningFunctionCorrdinates = {
              left: o,
              top: i
            }, this._options = t;
          }
          _createClass(l, [{
            key: "left",
            get: function get() {
              return this._absoluteRect.left;
            }
          }, {
            key: "top",
            get: function get() {
              return this._absoluteRect.top;
            }
          }, {
            key: "_limiterIntersectionArea",
            get: function get() {
              var e = this._options.limiterRect;
              if (e) {
                var _t200 = this._options.viewportRect;
                if (!_t200) return e.getIntersectionArea(this._rect);
                {
                  var _s195 = e.getIntersection(_t200);
                  if (_s195) return _s195.getIntersectionArea(this._rect);
                }
              }
              return 0;
            }
          }, {
            key: "_viewportIntersectionArea",
            get: function get() {
              var e = this._options.viewportRect;
              return e ? e.getIntersectionArea(this._rect) : 0;
            }
          }, {
            key: "_rect",
            get: function get() {
              return this._cachedRect || (this._cachedRect = this._options.elementRect.clone().moveTo(this._positioningFunctionCorrdinates.left, this._positioningFunctionCorrdinates.top)), this._cachedRect;
            }
          }, {
            key: "_absoluteRect",
            get: function get() {
              return this._cachedAbsoluteRect || (this._cachedAbsoluteRect = c(this._rect), this._options.positionedElementAncestor && function (e, t) {
                var s = c(new i.Z(t)),
                  o = (0, r.Z)(t);
                var n = 0,
                  a = 0;
                n -= s.left, a -= s.top, n += t.scrollLeft, a += t.scrollTop, n -= o.left, a -= o.top, e.moveBy(n, a);
              }(this._cachedAbsoluteRect, this._options.positionedElementAncestor)), this._cachedAbsoluteRect;
            }
          }]);
          return l;
        }();
      },
      "./packages/ckeditor5-utils/src/dom/rect.js": function _packages_ckeditor5Utils_src_dom_rectJs(e, t, s) {
        "use strict";

        s.d(t, {
          Z: function Z() {
            return l;
          }
        });
        var o = s("./packages/ckeditor5-utils/src/dom/isrange.js"),
          i = s("./packages/ckeditor5-utils/src/dom/iswindow.js"),
          r = s("./packages/ckeditor5-utils/src/dom/getborderwidths.js"),
          n = s("./packages/ckeditor5-utils/src/dom/istext.js"),
          a = s("./node_modules/lodash-es/isElement.js");
        var c = ["top", "right", "bottom", "left", "width", "height"];
        var l = /*#__PURE__*/function () {
          function l(e) {
            _classCallCheck(this, l);
            var t = (0, o.Z)(e);
            if (Object.defineProperty(this, "_source", {
              value: e._source || e,
              writable: !0,
              enumerable: !1
            }), (0, a.Z)(e) || t) {
              if (t) {
                var _t201 = l.getDomRangeRects(e);
                d(this, l.getBoundingRect(_t201));
              } else d(this, e.getBoundingClientRect());
            } else if ((0, i.Z)(e)) {
              var _t202 = e.innerWidth,
                _s196 = e.innerHeight;
              d(this, {
                top: 0,
                right: _t202,
                bottom: _s196,
                left: 0,
                width: _t202,
                height: _s196
              });
            } else d(this, e);
          }
          _createClass(l, [{
            key: "clone",
            value: function clone() {
              return new l(this);
            }
          }, {
            key: "moveTo",
            value: function moveTo(e, t) {
              return this.top = t, this.right = e + this.width, this.bottom = t + this.height, this.left = e, this;
            }
          }, {
            key: "moveBy",
            value: function moveBy(e, t) {
              return this.top += t, this.right += e, this.left += e, this.bottom += t, this;
            }
          }, {
            key: "getIntersection",
            value: function getIntersection(e) {
              var t = {
                top: Math.max(this.top, e.top),
                right: Math.min(this.right, e.right),
                bottom: Math.min(this.bottom, e.bottom),
                left: Math.max(this.left, e.left)
              };
              return t.width = t.right - t.left, t.height = t.bottom - t.top, t.width < 0 || t.height < 0 ? null : new l(t);
            }
          }, {
            key: "getIntersectionArea",
            value: function getIntersectionArea(e) {
              var t = this.getIntersection(e);
              return t ? t.getArea() : 0;
            }
          }, {
            key: "getArea",
            value: function getArea() {
              return this.width * this.height;
            }
          }, {
            key: "getVisible",
            value: function getVisible() {
              var e = this._source;
              var t = this.clone();
              if (!h(e)) {
                var _s197 = e.parentNode || e.commonAncestorContainer;
                for (; _s197 && !h(_s197);) {
                  var _e215 = new l(_s197),
                    _o128 = t.getIntersection(_e215);
                  if (!_o128) return null;
                  _o128.getArea() < t.getArea() && (t = _o128), _s197 = _s197.parentNode;
                }
              }
              return t;
            }
          }, {
            key: "isEqual",
            value: function isEqual(e) {
              for (var _i104 = 0, _c10 = c; _i104 < _c10.length; _i104++) {
                var _t203 = _c10[_i104];
                if (this[_t203] !== e[_t203]) return !1;
              }
              return !0;
            }
          }, {
            key: "contains",
            value: function contains(e) {
              var t = this.getIntersection(e);
              return !(!t || !t.isEqual(e));
            }
          }, {
            key: "excludeScrollbarsAndBorders",
            value: function excludeScrollbarsAndBorders() {
              var e = this._source;
              var t, s, o;
              if ((0, i.Z)(e)) t = e.innerWidth - e.document.documentElement.clientWidth, s = e.innerHeight - e.document.documentElement.clientHeight, o = e.getComputedStyle(e.document.documentElement).direction;else {
                var _i105 = (0, r.Z)(this._source);
                t = e.offsetWidth - e.clientWidth - _i105.left - _i105.right, s = e.offsetHeight - e.clientHeight - _i105.top - _i105.bottom, o = e.ownerDocument.defaultView.getComputedStyle(e).direction, this.left += _i105.left, this.top += _i105.top, this.right -= _i105.right, this.bottom -= _i105.bottom, this.width = this.right - this.left, this.height = this.bottom - this.top;
              }
              return this.width -= t, "ltr" === o ? this.right -= t : this.left += t, this.height -= s, this.bottom -= s, this;
            }
          }], [{
            key: "getDomRangeRects",
            value: function getDomRangeRects(e) {
              var t = [],
                s = Array.from(e.getClientRects());
              if (s.length) {
                var _iterator286 = _createForOfIteratorHelper(s),
                  _step286;
                try {
                  for (_iterator286.s(); !(_step286 = _iterator286.n()).done;) {
                    var _e216 = _step286.value;
                    t.push(new l(_e216));
                  }
                } catch (err) {
                  _iterator286.e(err);
                } finally {
                  _iterator286.f();
                }
              } else {
                var _s198 = e.startContainer;
                (0, n.Z)(_s198) && (_s198 = _s198.parentNode);
                var _o129 = new l(_s198.getBoundingClientRect());
                _o129.right = _o129.left, _o129.width = 0, t.push(_o129);
              }
              return t;
            }
          }, {
            key: "getBoundingRect",
            value: function getBoundingRect(e) {
              var t = {
                left: Number.POSITIVE_INFINITY,
                top: Number.POSITIVE_INFINITY,
                right: Number.NEGATIVE_INFINITY,
                bottom: Number.NEGATIVE_INFINITY
              };
              var s = 0;
              var _iterator287 = _createForOfIteratorHelper(e),
                _step287;
              try {
                for (_iterator287.s(); !(_step287 = _iterator287.n()).done;) {
                  var _o130 = _step287.value;
                  s++, t.left = Math.min(t.left, _o130.left), t.top = Math.min(t.top, _o130.top), t.right = Math.max(t.right, _o130.right), t.bottom = Math.max(t.bottom, _o130.bottom);
                }
              } catch (err) {
                _iterator287.e(err);
              } finally {
                _iterator287.f();
              }
              return 0 == s ? null : (t.width = t.right - t.left, t.height = t.bottom - t.top, new l(t));
            }
          }]);
          return l;
        }();
        function d(e, t) {
          var _iterator288 = _createForOfIteratorHelper(c),
            _step288;
          try {
            for (_iterator288.s(); !(_step288 = _iterator288.n()).done;) {
              var _s199 = _step288.value;
              e[_s199] = t[_s199];
            }
          } catch (err) {
            _iterator288.e(err);
          } finally {
            _iterator288.f();
          }
        }
        function h(e) {
          return !!(0, a.Z)(e) && e === e.ownerDocument.body;
        }
      },
      "./packages/ckeditor5-utils/src/dom/resizeobserver.js": function _packages_ckeditor5Utils_src_dom_resizeobserverJs(e, t, s) {
        "use strict";

        s.d(t, {
          Z: function Z() {
            return a;
          }
        });
        var o = s("./packages/ckeditor5-utils/src/mix.js"),
          i = s("./packages/ckeditor5-utils/src/dom/global.js"),
          r = s("./packages/ckeditor5-utils/src/dom/rect.js"),
          n = s("./packages/ckeditor5-utils/src/dom/emittermixin.js");
        var a = /*#__PURE__*/function () {
          function a(e, t) {
            _classCallCheck(this, a);
            a._observerInstance || a._createObserver(), this._element = e, this._callback = t, a._addElementCallback(e, t), a._observerInstance.observe(e);
          }
          _createClass(a, [{
            key: "destroy",
            value: function destroy() {
              a._deleteElementCallback(this._element, this._callback);
            }
          }], [{
            key: "_addElementCallback",
            value: function _addElementCallback(e, t) {
              a._elementCallbacks || (a._elementCallbacks = new Map());
              var s = a._elementCallbacks.get(e);
              s || (s = new Set(), a._elementCallbacks.set(e, s)), s.add(t);
            }
          }, {
            key: "_deleteElementCallback",
            value: function _deleteElementCallback(e, t) {
              var s = a._getElementCallbacks(e);
              s && (s.delete(t), s.size || (a._elementCallbacks.delete(e), a._observerInstance.unobserve(e))), a._elementCallbacks && !a._elementCallbacks.size && (a._observerInstance = null, a._elementCallbacks = null);
            }
          }, {
            key: "_getElementCallbacks",
            value: function _getElementCallbacks(e) {
              return a._elementCallbacks ? a._elementCallbacks.get(e) : null;
            }
          }, {
            key: "_createObserver",
            value: function _createObserver() {
              var e;
              e = "function" == typeof i.Z.window.ResizeObserver ? i.Z.window.ResizeObserver : c, a._observerInstance = new e(function (e) {
                var _iterator289 = _createForOfIteratorHelper(e),
                  _step289;
                try {
                  for (_iterator289.s(); !(_step289 = _iterator289.n()).done;) {
                    var _t204 = _step289.value;
                    var _e217 = a._getElementCallbacks(_t204.target);
                    if (_e217) {
                      var _iterator290 = _createForOfIteratorHelper(_e217),
                        _step290;
                      try {
                        for (_iterator290.s(); !(_step290 = _iterator290.n()).done;) {
                          var _s200 = _step290.value;
                          _s200(_t204);
                        }
                      } catch (err) {
                        _iterator290.e(err);
                      } finally {
                        _iterator290.f();
                      }
                    }
                  }
                } catch (err) {
                  _iterator289.e(err);
                } finally {
                  _iterator289.f();
                }
              });
            }
          }]);
          return a;
        }();
        a._observerInstance = null, a._elementCallbacks = null;
        var c = /*#__PURE__*/function () {
          function c(e) {
            _classCallCheck(this, c);
            this._callback = e, this._elements = new Set(), this._previousRects = new Map(), this._periodicCheckTimeout = null;
          }
          _createClass(c, [{
            key: "observe",
            value: function observe(e) {
              this._elements.add(e), this._checkElementRectsAndExecuteCallback(), 1 === this._elements.size && this._startPeriodicCheck();
            }
          }, {
            key: "unobserve",
            value: function unobserve(e) {
              this._elements.delete(e), this._previousRects.delete(e), this._elements.size || this._stopPeriodicCheck();
            }
          }, {
            key: "_startPeriodicCheck",
            value: function _startPeriodicCheck() {
              var _this120 = this;
              var e = function (_e218) {
                function e() {
                  return _e218.apply(this, arguments);
                }
                e.toString = function () {
                  return _e218.toString();
                };
                return e;
              }(function () {
                _this120._checkElementRectsAndExecuteCallback(), _this120._periodicCheckTimeout = setTimeout(e, 100);
              });
              this.listenTo(i.Z.window, "resize", function () {
                _this120._checkElementRectsAndExecuteCallback();
              }), this._periodicCheckTimeout = setTimeout(e, 100);
            }
          }, {
            key: "_stopPeriodicCheck",
            value: function _stopPeriodicCheck() {
              clearTimeout(this._periodicCheckTimeout), this.stopListening(), this._previousRects.clear();
            }
          }, {
            key: "_checkElementRectsAndExecuteCallback",
            value: function _checkElementRectsAndExecuteCallback() {
              var e = [];
              var _iterator291 = _createForOfIteratorHelper(this._elements),
                _step291;
              try {
                for (_iterator291.s(); !(_step291 = _iterator291.n()).done;) {
                  var _t205 = _step291.value;
                  this._hasRectChanged(_t205) && e.push({
                    target: _t205,
                    contentRect: this._previousRects.get(_t205)
                  });
                }
              } catch (err) {
                _iterator291.e(err);
              } finally {
                _iterator291.f();
              }
              e.length && this._callback(e);
            }
          }, {
            key: "_hasRectChanged",
            value: function _hasRectChanged(e) {
              if (!e.ownerDocument.body.contains(e)) return !1;
              var t = new r.Z(e),
                s = this._previousRects.get(e),
                o = !s || !s.isEqual(t);
              return this._previousRects.set(e, t), o;
            }
          }]);
          return c;
        }();
        (0, o.Z)(c, n.Z);
      },
      "./packages/ckeditor5-utils/src/dom/setdatainelement.js": function _packages_ckeditor5Utils_src_dom_setdatainelementJs(e, t, s) {
        "use strict";

        function o(e, t) {
          e instanceof HTMLTextAreaElement && (e.value = t), e.innerHTML = t;
        }
        s.d(t, {
          Z: function Z() {
            return o;
          }
        });
      },
      "./packages/ckeditor5-utils/src/dom/tounit.js": function _packages_ckeditor5Utils_src_dom_tounitJs(e, t, s) {
        "use strict";

        function o(e) {
          return function (t) {
            return t + e;
          };
        }
        s.d(t, {
          Z: function Z() {
            return o;
          }
        });
      },
      "./packages/ckeditor5-utils/src/emittermixin.js": function _packages_ckeditor5Utils_src_emittermixinJs(e, t, s) {
        "use strict";

        s.d(t, {
          Hv: function Hv() {
            return h;
          },
          Rl: function Rl() {
            return d;
          },
          ZP: function ZP() {
            return l;
          }
        });
        var o = s("./packages/ckeditor5-utils/src/eventinfo.js"),
          i = s("./packages/ckeditor5-utils/src/uid.js"),
          r = s("./packages/ckeditor5-utils/src/priorities.js"),
          n = (s("./packages/ckeditor5-utils/src/version.js"), s("./packages/ckeditor5-utils/src/ckeditorerror.js"));
        var a = Symbol("listeningTo"),
          c = Symbol("emitterId"),
          l = {
            on: function on(e, t) {
              var s = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
              this.listenTo(this, e, t, s);
            },
            once: function once(e, t, s) {
              var o = !1;
              this.listenTo(this, e, function (e) {
                for (var _len10 = arguments.length, s = new Array(_len10 > 1 ? _len10 - 1 : 0), _key10 = 1; _key10 < _len10; _key10++) {
                  s[_key10 - 1] = arguments[_key10];
                }
                o || (o = !0, e.off(), t.call.apply(t, [this, e].concat(s)));
              }, s);
            },
            off: function off(e, t) {
              this.stopListening(this, e, t);
            },
            listenTo: function listenTo(e, t, s) {
              var o = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
              var i, r;
              this[a] || (this[a] = {});
              var n = this[a];
              u(e) || h(e);
              var c = u(e);
              (i = n[c]) || (i = n[c] = {
                emitter: e,
                callbacks: {}
              }), (r = i.callbacks[t]) || (r = i.callbacks[t] = []), r.push(s), function (e, t, s, o, i) {
                t._addEventListener ? t._addEventListener(s, o, i) : e._addEventListener.call(t, s, o, i);
              }(this, e, t, s, o);
            },
            stopListening: function stopListening(e, t, s) {
              var o = this[a];
              var i = e && u(e);
              var r = o && i && o[i],
                n = r && t && r.callbacks[t];
              if (!(!o || e && !r || t && !n)) if (s) {
                k(this, e, t, s);
                -1 !== n.indexOf(s) && (1 === n.length ? delete r.callbacks[t] : k(this, e, t, s));
              } else if (n) {
                for (; s = n.pop();) k(this, e, t, s);
                delete r.callbacks[t];
              } else if (r) {
                for (t in r.callbacks) this.stopListening(e, t);
                delete o[i];
              } else {
                for (i in o) this.stopListening(o[i].emitter);
                delete this[a];
              }
            },
            fire: function fire(e) {
              try {
                var _s201 = e instanceof o.Z ? e : new o.Z(this, e),
                  _i106 = _s201.name;
                var _r50 = f(this, _i106);
                for (var _len11 = arguments.length, t = new Array(_len11 > 1 ? _len11 - 1 : 0), _key11 = 1; _key11 < _len11; _key11++) {
                  t[_key11 - 1] = arguments[_key11];
                }
                if (_s201.path.push(this), _r50) {
                  var _e219 = [_s201].concat(t);
                  _r50 = Array.from(_r50);
                  for (var _t206 = 0; _t206 < _r50.length && (_r50[_t206].callback.apply(this, _e219), _s201.off.called && (delete _s201.off.called, this._removeEventListener(_i106, _r50[_t206].callback)), !_s201.stop.called); _t206++);
                }
                if (this._delegations) {
                  var _e220 = this._delegations.get(_i106),
                    _o131 = this._delegations.get("*");
                  _e220 && m(_e220, _s201, t), _o131 && m(_o131, _s201, t);
                }
                return _s201.return;
              } catch (e) {
                n.ZP.rethrowUnexpectedError(e, this);
              }
            },
            delegate: function delegate() {
              var _this121 = this;
              for (var _len12 = arguments.length, e = new Array(_len12), _key12 = 0; _key12 < _len12; _key12++) {
                e[_key12] = arguments[_key12];
              }
              return {
                to: function to(t, s) {
                  _this121._delegations || (_this121._delegations = new Map()), e.forEach(function (e) {
                    var o = _this121._delegations.get(e);
                    o ? o.set(t, s) : _this121._delegations.set(e, new Map([[t, s]]));
                  });
                }
              };
            },
            stopDelegating: function stopDelegating(e, t) {
              if (this._delegations) if (e) {
                if (t) {
                  var _s202 = this._delegations.get(e);
                  _s202 && _s202.delete(t);
                } else this._delegations.delete(e);
              } else this._delegations.clear();
            },
            _addEventListener: function _addEventListener(e, t, s) {
              !function (e, t) {
                var s = g(e);
                if (s[t]) return;
                var o = t,
                  i = null;
                var r = [];
                for (; "" !== o && !s[o];) s[o] = {
                  callbacks: [],
                  childEvents: []
                }, r.push(s[o]), i && s[o].childEvents.push(i), i = o, o = o.substr(0, o.lastIndexOf(":"));
                if ("" !== o) {
                  var _iterator292 = _createForOfIteratorHelper(r),
                    _step292;
                  try {
                    for (_iterator292.s(); !(_step292 = _iterator292.n()).done;) {
                      var _e221 = _step292.value;
                      _e221.callbacks = s[o].callbacks.slice();
                    }
                  } catch (err) {
                    _iterator292.e(err);
                  } finally {
                    _iterator292.f();
                  }
                  s[o].childEvents.push(i);
                }
              }(this, e);
              var o = p(this, e),
                i = r.Z.get(s.priority),
                n = {
                  callback: t,
                  priority: i
                };
              var _iterator293 = _createForOfIteratorHelper(o),
                _step293;
              try {
                for (_iterator293.s(); !(_step293 = _iterator293.n()).done;) {
                  var _e222 = _step293.value;
                  var _t207 = !1;
                  for (var _s203 = 0; _s203 < _e222.length; _s203++) if (_e222[_s203].priority < i) {
                    _e222.splice(_s203, 0, n), _t207 = !0;
                    break;
                  }
                  _t207 || _e222.push(n);
                }
              } catch (err) {
                _iterator293.e(err);
              } finally {
                _iterator293.f();
              }
            },
            _removeEventListener: function _removeEventListener(e, t) {
              var s = p(this, e);
              var _iterator294 = _createForOfIteratorHelper(s),
                _step294;
              try {
                for (_iterator294.s(); !(_step294 = _iterator294.n()).done;) {
                  var _e223 = _step294.value;
                  for (var _s204 = 0; _s204 < _e223.length; _s204++) _e223[_s204].callback == t && (_e223.splice(_s204, 1), _s204--);
                }
              } catch (err) {
                _iterator294.e(err);
              } finally {
                _iterator294.f();
              }
            }
          };
        function d(e, t) {
          return e[a] && e[a][t] ? e[a][t].emitter : null;
        }
        function h(e, t) {
          e[c] || (e[c] = t || (0, i.Z)());
        }
        function u(e) {
          return e[c];
        }
        function g(e) {
          return e._events || Object.defineProperty(e, "_events", {
            value: {}
          }), e._events;
        }
        function p(e, t) {
          var s = g(e)[t];
          if (!s) return [];
          var o = [s.callbacks];
          for (var _t208 = 0; _t208 < s.childEvents.length; _t208++) {
            var _i107 = p(e, s.childEvents[_t208]);
            o = o.concat(_i107);
          }
          return o;
        }
        function f(e, t) {
          var s;
          return e._events && (s = e._events[t]) && s.callbacks.length ? s.callbacks : t.indexOf(":") > -1 ? f(e, t.substr(0, t.lastIndexOf(":"))) : null;
        }
        function m(e, t, s) {
          var _iterator295 = _createForOfIteratorHelper(e),
            _step295;
          try {
            for (_iterator295.s(); !(_step295 = _iterator295.n()).done;) {
              var _step295$value = _slicedToArray(_step295.value, 2),
                _i108 = _step295$value[0],
                _r51 = _step295$value[1];
              _r51 ? "function" == typeof _r51 && (_r51 = _r51(t.name)) : _r51 = t.name;
              var _e224 = new o.Z(t.source, _r51);
              _e224.path = _toConsumableArray(t.path), _i108.fire.apply(_i108, [_e224].concat(_toConsumableArray(s)));
            }
          } catch (err) {
            _iterator295.e(err);
          } finally {
            _iterator295.f();
          }
        }
        function k(e, t, s, o) {
          t._removeEventListener ? t._removeEventListener(s, o) : e._removeEventListener.call(t, s, o);
        }
      },
      "./packages/ckeditor5-utils/src/env.js": function _packages_ckeditor5Utils_src_envJs(e, t, s) {
        "use strict";

        s.d(t, {
          ZP: function ZP() {
            return r;
          }
        });
        var o = navigator.userAgent.toLowerCase(),
          i = {
            isMac: n(o),
            isWindows: function (e) {
              return e.indexOf("windows") > -1;
            }(o),
            isGecko: function (e) {
              return !!e.match(/gecko\/\d+/);
            }(o),
            isSafari: function (e) {
              return e.indexOf(" applewebkit/") > -1 && -1 === e.indexOf("chrome");
            }(o),
            isiOS: function (e) {
              return !!e.match(/iphone|ipad/i) || n(e) && navigator.maxTouchPoints > 0;
            }(o),
            isAndroid: function (e) {
              return e.indexOf("android") > -1;
            }(o),
            isBlink: function (e) {
              return e.indexOf("chrome/") > -1 && e.indexOf("edge/") < 0;
            }(o),
            features: {
              isRegExpUnicodePropertySupported: function () {
                var e = !1;
                try {
                  e = 0 === "ć".search(new RegExp("[\\p{L}]", "u"));
                } catch (e) {}
                return e;
              }()
            }
          },
          r = i;
        function n(e) {
          return e.indexOf("macintosh") > -1;
        }
      },
      "./packages/ckeditor5-utils/src/eventinfo.js": function _packages_ckeditor5Utils_src_eventinfoJs(e, t, s) {
        "use strict";

        s.d(t, {
          Z: function Z() {
            return i;
          }
        });
        var o = function o() {
          return function e() {
            e.called = !0;
          };
        };
        var i = function i(e, t) {
          _classCallCheck(this, i);
          this.source = e, this.name = t, this.path = [], this.stop = o(), this.off = o();
        };
      },
      "./packages/ckeditor5-utils/src/fastdiff.js": function _packages_ckeditor5Utils_src_fastdiffJs(e, t, s) {
        "use strict";

        function o(e, t, s) {
          var o = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : !1;
          s = s || function (e, t) {
            return e === t;
          }, Array.isArray(e) || (e = Array.prototype.slice.call(e)), Array.isArray(t) || (t = Array.prototype.slice.call(t));
          var n = function (e, t, s) {
            var o = i(e, t, s);
            if (-1 === o) return {
              firstIndex: -1,
              lastIndexOld: -1,
              lastIndexNew: -1
            };
            var n = r(e, o),
              a = r(t, o),
              c = i(n, a, s),
              l = e.length - c,
              d = t.length - c;
            return {
              firstIndex: o,
              lastIndexOld: l,
              lastIndexNew: d
            };
          }(e, t, s);
          return o ? function (e, t) {
            var s = e.firstIndex,
              o = e.lastIndexOld,
              i = e.lastIndexNew;
            if (-1 === s) return Array(t).fill("equal");
            var r = [];
            s > 0 && (r = r.concat(Array(s).fill("equal")));
            i - s > 0 && (r = r.concat(Array(i - s).fill("insert")));
            o - s > 0 && (r = r.concat(Array(o - s).fill("delete")));
            i < t && (r = r.concat(Array(t - i).fill("equal")));
            return r;
          }(n, t.length) : function (e, t) {
            var s = [],
              o = t.firstIndex,
              i = t.lastIndexOld,
              r = t.lastIndexNew;
            r - o > 0 && s.push({
              index: o,
              type: "insert",
              values: e.slice(o, r)
            });
            i - o > 0 && s.push({
              index: o + (r - o),
              type: "delete",
              howMany: i - o
            });
            return s;
          }(t, n);
        }
        function i(e, t, s) {
          for (var _o132 = 0; _o132 < Math.max(e.length, t.length); _o132++) if (void 0 === e[_o132] || void 0 === t[_o132] || !s(e[_o132], t[_o132])) return _o132;
          return -1;
        }
        function r(e, t) {
          return e.slice(t).reverse();
        }
        s.d(t, {
          Z: function Z() {
            return o;
          }
        });
      },
      "./packages/ckeditor5-utils/src/first.js": function _packages_ckeditor5Utils_src_firstJs(e, t, s) {
        "use strict";

        function o(e) {
          var t = e.next();
          return t.done ? null : t.value;
        }
        s.d(t, {
          Z: function Z() {
            return o;
          }
        });
      },
      "./packages/ckeditor5-utils/src/focustracker.js": function _packages_ckeditor5Utils_src_focustrackerJs(e, t, s) {
        "use strict";

        s.d(t, {
          Z: function Z() {
            return a;
          }
        });
        var o = s("./packages/ckeditor5-utils/src/dom/emittermixin.js"),
          i = s("./packages/ckeditor5-utils/src/observablemixin.js"),
          r = s("./packages/ckeditor5-utils/src/ckeditorerror.js"),
          n = s("./packages/ckeditor5-utils/src/mix.js");
        var a = /*#__PURE__*/function () {
          function a() {
            _classCallCheck(this, a);
            this.set("isFocused", !1), this.set("focusedElement", null), this._elements = new Set(), this._nextEventLoopTimeout = null;
          }
          _createClass(a, [{
            key: "add",
            value: function add(e) {
              var _this122 = this;
              if (this._elements.has(e)) throw new r.ZP("focustracker-add-element-already-exist", this);
              this.listenTo(e, "focus", function () {
                return _this122._focus(e);
              }, {
                useCapture: !0
              }), this.listenTo(e, "blur", function () {
                return _this122._blur();
              }, {
                useCapture: !0
              }), this._elements.add(e);
            }
          }, {
            key: "remove",
            value: function remove(e) {
              e === this.focusedElement && this._blur(e), this._elements.has(e) && (this.stopListening(e), this._elements.delete(e));
            }
          }, {
            key: "destroy",
            value: function destroy() {
              this.stopListening();
            }
          }, {
            key: "_focus",
            value: function _focus(e) {
              clearTimeout(this._nextEventLoopTimeout), this.focusedElement = e, this.isFocused = !0;
            }
          }, {
            key: "_blur",
            value: function _blur() {
              var _this123 = this;
              clearTimeout(this._nextEventLoopTimeout), this._nextEventLoopTimeout = setTimeout(function () {
                _this123.focusedElement = null, _this123.isFocused = !1;
              }, 0);
            }
          }]);
          return a;
        }();
        (0, n.Z)(a, o.Z), (0, n.Z)(a, i.Z);
      },
      "./packages/ckeditor5-utils/src/index.js": function _packages_ckeditor5Utils_src_indexJs(e, t, s) {
        "use strict";

        s.d(t, {
          Bb: function Bb() {
            return c.ZP;
          },
          FE: function FE() {
            return y.Z;
          },
          Xu: function Xu() {
            return h.Z;
          },
          a6: function a6() {
            return l;
          },
          ln: function ln() {
            return n.ZP;
          },
          Rh: function Rh() {
            return P.Z;
          },
          VD: function VD() {
            return j.Z;
          },
          go: function go() {
            return v.Z;
          },
          Re: function Re() {
            return a.Z;
          },
          UL: function UL() {
            return p.Z;
          },
          do: function _do() {
            return f.Z;
          },
          az: function az() {
            return d.Z;
          },
          Hg: function Hg() {
            return i.Z;
          },
          OB: function OB() {
            return o.ZP;
          },
          Ps: function Ps() {
            return Z.Z;
          },
          Cq: function Cq() {
            return b.Cq;
          },
          yy: function yy() {
            return g;
          },
          XU: function XU() {
            return b.XU;
          },
          j9: function j9() {
            return w.j;
          },
          mA: function mA() {
            return b.mA;
          },
          CO: function CO() {
            return u.Z;
          },
          dj: function dj() {
            return b.dj;
          },
          Zt: function Zt() {
            return b.Zt;
          },
          pn: function pn() {
            return _.Z;
          },
          Do: function Do() {
            return b.Do;
          },
          H: function H() {
            return c.H;
          },
          KE: function KE() {
            return c.KE;
          },
          CD: function CD() {
            return r.Z;
          },
          Zz: function Zz() {
            return b.Zz;
          },
          tA: function tA() {
            return T.Z;
          },
          jS: function jS() {
            return m.Z;
          },
          qo: function qo() {
            return x.Z;
          },
          qL: function qL() {
            return A.Z;
          },
          nn: function nn() {
            return k.Z;
          },
          hQ: function hQ() {
            return C.Z;
          },
          i8: function i8() {
            return E.Z;
          }
        });
        var o = s("./packages/ckeditor5-utils/src/env.js"),
          i = s("./packages/ckeditor5-utils/src/diff.js"),
          r = s("./packages/ckeditor5-utils/src/mix.js"),
          n = s("./packages/ckeditor5-utils/src/emittermixin.js"),
          a = s("./packages/ckeditor5-utils/src/observablemixin.js"),
          c = s("./packages/ckeditor5-utils/src/ckeditorerror.js");
        var l = /*#__PURE__*/function () {
          function l() {
            _classCallCheck(this, l);
            this._replacedElements = [];
          }
          _createClass(l, [{
            key: "replace",
            value: function replace(e, t) {
              this._replacedElements.push({
                element: e,
                newElement: t
              }), e.style.display = "none", t && e.parentNode.insertBefore(t, e.nextSibling);
            }
          }, {
            key: "restore",
            value: function restore() {
              this._replacedElements.forEach(function (_ref35) {
                var e = _ref35.element,
                  t = _ref35.newElement;
                e.style.display = "", t && t.remove();
              }), this._replacedElements = [];
            }
          }]);
          return l;
        }();
        var d = s("./packages/ckeditor5-utils/src/dom/createelement.js"),
          h = s("./packages/ckeditor5-utils/src/dom/emittermixin.js"),
          u = s("./packages/ckeditor5-utils/src/dom/global.js");
        function g(e) {
          return e instanceof HTMLTextAreaElement ? e.value : e.innerHTML;
        }
        var p = s("./packages/ckeditor5-utils/src/dom/rect.js"),
          f = s("./packages/ckeditor5-utils/src/dom/resizeobserver.js"),
          m = s("./packages/ckeditor5-utils/src/dom/setdatainelement.js"),
          k = s("./packages/ckeditor5-utils/src/dom/tounit.js"),
          _ = s("./packages/ckeditor5-utils/src/dom/isvisible.js"),
          b = s("./packages/ckeditor5-utils/src/keyboard.js"),
          w = s("./packages/ckeditor5-utils/src/language.js"),
          v = s("./packages/ckeditor5-utils/src/locale.js"),
          y = s("./packages/ckeditor5-utils/src/collection.js"),
          Z = s("./packages/ckeditor5-utils/src/first.js"),
          P = s("./packages/ckeditor5-utils/src/focustracker.js"),
          j = s("./packages/ckeditor5-utils/src/keystrokehandler.js"),
          x = s("./packages/ckeditor5-utils/src/toarray.js"),
          A = s("./packages/ckeditor5-utils/src/tomap.js"),
          T = s("./packages/ckeditor5-utils/src/priorities.js"),
          C = s("./packages/ckeditor5-utils/src/uid.js"),
          E = s("./packages/ckeditor5-utils/src/version.js");
      },
      "./packages/ckeditor5-utils/src/isiterable.js": function _packages_ckeditor5Utils_src_isiterableJs(e, t, s) {
        "use strict";

        function o(e) {
          return !(!e || !e[Symbol.iterator]);
        }
        s.d(t, {
          Z: function Z() {
            return o;
          }
        });
      },
      "./packages/ckeditor5-utils/src/keyboard.js": function _packages_ckeditor5Utils_src_keyboardJs(e, t, s) {
        "use strict";

        s.d(t, {
          Cq: function Cq() {
            return l;
          },
          Do: function Do() {
            return a;
          },
          XU: function XU() {
            return h;
          },
          Zt: function Zt() {
            return p;
          },
          Zz: function Zz() {
            return d;
          },
          dj: function dj() {
            return u;
          },
          mA: function mA() {
            return g;
          }
        });
        var o = s("./packages/ckeditor5-utils/src/ckeditorerror.js"),
          i = s("./packages/ckeditor5-utils/src/env.js");
        var r = {
            ctrl: "⌃",
            cmd: "⌘",
            alt: "⌥",
            shift: "⇧"
          },
          n = {
            ctrl: "Ctrl+",
            alt: "Alt+",
            shift: "Shift+"
          },
          a = function () {
            var e = {
              arrowleft: 37,
              arrowup: 38,
              arrowright: 39,
              arrowdown: 40,
              backspace: 8,
              delete: 46,
              enter: 13,
              space: 32,
              esc: 27,
              tab: 9,
              ctrl: 1114112,
              shift: 2228224,
              alt: 4456448,
              cmd: 8912896
            };
            for (var _t209 = 65; _t209 <= 90; _t209++) {
              var _s205 = String.fromCharCode(_t209);
              e[_s205.toLowerCase()] = _t209;
            }
            for (var _t210 = 48; _t210 <= 57; _t210++) e[_t210 - 48] = _t210;
            for (var _t211 = 112; _t211 <= 123; _t211++) e["f" + (_t211 - 111)] = _t211;
            var _iterator296 = _createForOfIteratorHelper("`-=[];',./\\"),
              _step296;
            try {
              for (_iterator296.s(); !(_step296 = _iterator296.n()).done;) {
                var _t212 = _step296.value;
                e[_t212] = _t212.charCodeAt(0);
              }
            } catch (err) {
              _iterator296.e(err);
            } finally {
              _iterator296.f();
            }
            return e;
          }(),
          c = Object.fromEntries(Object.entries(a).map(function (_ref36) {
            var _ref37 = _slicedToArray(_ref36, 2),
              e = _ref37[0],
              t = _ref37[1];
            return [t, e.charAt(0).toUpperCase() + e.slice(1)];
          }));
        function l(e) {
          var t;
          if ("string" == typeof e) {
            if (t = a[e.toLowerCase()], !t) throw new o.ZP("keyboard-unknown-key", null, {
              key: e
            });
          } else t = e.keyCode + (e.altKey ? a.alt : 0) + (e.ctrlKey ? a.ctrl : 0) + (e.shiftKey ? a.shift : 0) + (e.metaKey ? a.cmd : 0);
          return t;
        }
        function d(e) {
          return "string" == typeof e && (e = function (e) {
            return e.split("+").map(function (e) {
              return e.trim();
            });
          }(e)), e.map(function (e) {
            return "string" == typeof e ? function (e) {
              if (e.endsWith("!")) return l(e.slice(0, -1));
              var t = l(e);
              return i.ZP.isMac && t == a.ctrl ? a.cmd : t;
            }(e) : e;
          }).reduce(function (e, t) {
            return t + e;
          }, 0);
        }
        function h(e) {
          var t = d(e);
          return Object.entries(i.ZP.isMac ? r : n).reduce(function (e, _ref38) {
            var _ref39 = _slicedToArray(_ref38, 2),
              s = _ref39[0],
              o = _ref39[1];
            return 0 != (t & a[s]) && (t &= ~a[s], e += o), e;
          }, "") + (t ? c[t] : "");
        }
        function u(e) {
          return e == a.arrowright || e == a.arrowleft || e == a.arrowup || e == a.arrowdown;
        }
        function g(e, t) {
          var s = "ltr" === t;
          switch (e) {
            case a.arrowleft:
              return s ? "left" : "right";
            case a.arrowright:
              return s ? "right" : "left";
            case a.arrowup:
              return "up";
            case a.arrowdown:
              return "down";
          }
        }
        function p(e, t) {
          var s = g(e, t);
          return "down" === s || "right" === s;
        }
      },
      "./packages/ckeditor5-utils/src/keystrokehandler.js": function _packages_ckeditor5Utils_src_keystrokehandlerJs(e, t, s) {
        "use strict";

        s.d(t, {
          Z: function Z() {
            return r;
          }
        });
        var o = s("./packages/ckeditor5-utils/src/dom/emittermixin.js"),
          i = s("./packages/ckeditor5-utils/src/keyboard.js");
        var r = /*#__PURE__*/function () {
          function r() {
            _classCallCheck(this, r);
            this._listener = Object.create(o.Z);
          }
          _createClass(r, [{
            key: "listenTo",
            value: function listenTo(e) {
              var _this124 = this;
              this._listener.listenTo(e, "keydown", function (e, t) {
                _this124._listener.fire("_keydown:" + (0, i.Cq)(t), t);
              });
            }
          }, {
            key: "set",
            value: function set(e, t) {
              var s = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
              var o = (0, i.Zz)(e),
                r = s.priority;
              this._listener.listenTo(this._listener, "_keydown:" + o, function (e, s) {
                t(s, function () {
                  s.preventDefault(), s.stopPropagation(), e.stop();
                }), e.return = !0;
              }, {
                priority: r
              });
            }
          }, {
            key: "press",
            value: function press(e) {
              return !!this._listener.fire("_keydown:" + (0, i.Cq)(e), e);
            }
          }, {
            key: "destroy",
            value: function destroy() {
              this._listener.stopListening();
            }
          }]);
          return r;
        }();
      },
      "./packages/ckeditor5-utils/src/language.js": function _packages_ckeditor5Utils_src_languageJs(e, t, s) {
        "use strict";

        s.d(t, {
          j: function j() {
            return i;
          }
        });
        var o = ["ar", "ara", "fa", "per", "fas", "he", "heb", "ku", "kur", "ug", "uig"];
        function i(e) {
          return o.includes(e) ? "rtl" : "ltr";
        }
      },
      "./packages/ckeditor5-utils/src/locale.js": function _packages_ckeditor5Utils_src_localeJs(e, t, s) {
        "use strict";

        s.d(t, {
          Z: function Z() {
            return a;
          }
        });
        var o = s("./packages/ckeditor5-utils/src/toarray.js"),
          i = s("./packages/ckeditor5-utils/src/ckeditorerror.js");
        function r(e, t) {
          var s = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
          if ("number" != typeof s) throw new i.ZP("translation-service-quantity-not-a-number", null, {
            quantity: s
          });
          var o = Object.keys(window.CKEDITOR_TRANSLATIONS).length;
          1 === o && (e = Object.keys(window.CKEDITOR_TRANSLATIONS)[0]);
          var r = t.id || t.string;
          if (0 === o || !function (e, t) {
            return !!window.CKEDITOR_TRANSLATIONS[e] && !!window.CKEDITOR_TRANSLATIONS[e].dictionary[t];
          }(e, r)) return 1 !== s ? t.plural : t.string;
          var n = window.CKEDITOR_TRANSLATIONS[e].dictionary,
            a = window.CKEDITOR_TRANSLATIONS[e].getPluralForm || function (e) {
              return 1 === e ? 0 : 1;
            };
          if ("string" == typeof n[r]) return n[r];
          var c = Number(a(s));
          return n[r][c];
        }
        window.CKEDITOR_TRANSLATIONS || (window.CKEDITOR_TRANSLATIONS = {});
        var n = s("./packages/ckeditor5-utils/src/language.js");
        var a = /*#__PURE__*/function () {
          function a() {
            var _this125 = this;
            var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
            _classCallCheck(this, a);
            this.uiLanguage = e.uiLanguage || "en", this.contentLanguage = e.contentLanguage || this.uiLanguage, this.uiLanguageDirection = (0, n.j)(this.uiLanguage), this.contentLanguageDirection = (0, n.j)(this.contentLanguage), this.t = function (e, t) {
              return _this125._t(e, t);
            };
          }
          _createClass(a, [{
            key: "_t",
            value: function _t(e) {
              var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
              t = (0, o.Z)(t), "string" == typeof e && (e = {
                string: e
              });
              var s = !!e.plural ? t[0] : 1;
              return function (e, t) {
                return e.replace(/%(\d+)/g, function (e, s) {
                  return s < t.length ? t[s] : e;
                });
              }(r(this.uiLanguage, e, s), t);
            }
          }, {
            key: "language",
            get: function get() {
              return console.warn("locale-deprecated-language-property: The Locale#language property has been deprecated and will be removed in the near future. Please use #uiLanguage and #contentLanguage properties instead."), this.uiLanguage;
            }
          }]);
          return a;
        }();
      },
      "./packages/ckeditor5-utils/src/mix.js": function _packages_ckeditor5Utils_src_mixJs(e, t, s) {
        "use strict";

        function o(e) {
          for (var _len13 = arguments.length, t = new Array(_len13 > 1 ? _len13 - 1 : 0), _key13 = 1; _key13 < _len13; _key13++) {
            t[_key13 - 1] = arguments[_key13];
          }
          t.forEach(function (t) {
            Object.getOwnPropertyNames(t).concat(Object.getOwnPropertySymbols(t)).forEach(function (s) {
              if (s in e.prototype) return;
              var o = Object.getOwnPropertyDescriptor(t, s);
              o.enumerable = !1, Object.defineProperty(e.prototype, s, o);
            });
          });
        }
        s.d(t, {
          Z: function Z() {
            return o;
          }
        });
      },
      "./packages/ckeditor5-utils/src/observablemixin.js": function _packages_ckeditor5Utils_src_observablemixinJs(e, t, s) {
        "use strict";

        s.d(t, {
          Z: function Z() {
            return g;
          }
        });
        var o = s("./packages/ckeditor5-utils/src/emittermixin.js"),
          i = s("./packages/ckeditor5-utils/src/ckeditorerror.js"),
          r = s("./node_modules/lodash-es/isObject.js"),
          n = s("./node_modules/lodash-es/assignIn.js");
        var a = Symbol("observableProperties"),
          c = Symbol("boundObservables"),
          l = Symbol("boundProperties"),
          d = Symbol("decoratedMethods"),
          h = Symbol("decoratedOriginal"),
          u = {
            set: function set(e, t) {
              var _this126 = this;
              if ((0, r.Z)(e)) return void Object.keys(e).forEach(function (t) {
                _this126.set(t, e[t]);
              }, this);
              p(this);
              var s = this[a];
              if (e in this && !s.has(e)) throw new i.ZP("observable-set-cannot-override", this);
              Object.defineProperty(this, e, {
                enumerable: !0,
                configurable: !0,
                get: function get() {
                  return s.get(e);
                },
                set: function set(t) {
                  var o = s.get(e);
                  var i = this.fire("set:" + e, e, t, o);
                  void 0 === i && (i = t), o === i && s.has(e) || (s.set(e, i), this.fire("change:" + e, e, i, o));
                }
              }), this[e] = t;
            },
            bind: function bind() {
              var _this127 = this;
              for (var _len14 = arguments.length, e = new Array(_len14), _key14 = 0; _key14 < _len14; _key14++) {
                e[_key14] = arguments[_key14];
              }
              if (!e.length || !k(e)) throw new i.ZP("observable-bind-wrong-properties", this);
              if (new Set(e).size !== e.length) throw new i.ZP("observable-bind-duplicate-properties", this);
              p(this);
              var t = this[l];
              e.forEach(function (e) {
                if (t.has(e)) throw new i.ZP("observable-bind-rebind", _this127);
              });
              var s = new Map();
              return e.forEach(function (e) {
                var o = {
                  property: e,
                  to: []
                };
                t.set(e, o), s.set(e, o);
              }), {
                to: f,
                toMany: m,
                _observable: this,
                _bindProperties: e,
                _to: [],
                _bindings: s
              };
            },
            unbind: function unbind() {
              var _this128 = this;
              if (!this[a]) return;
              var t = this[l],
                s = this[c];
              for (var _len15 = arguments.length, e = new Array(_len15), _key15 = 0; _key15 < _len15; _key15++) {
                e[_key15] = arguments[_key15];
              }
              if (e.length) {
                if (!k(e)) throw new i.ZP("observable-unbind-wrong-properties", this);
                e.forEach(function (e) {
                  var o = t.get(e);
                  if (!o) return;
                  var i, r, n, a;
                  o.to.forEach(function (e) {
                    i = e[0], r = e[1], n = s.get(i), a = n[r], a.delete(o), a.size || delete n[r], Object.keys(n).length || (s.delete(i), _this128.stopListening(i, "change"));
                  }), t.delete(e);
                });
              } else s.forEach(function (e, t) {
                _this128.stopListening(t, "change");
              }), s.clear(), t.clear();
            },
            decorate: function decorate(e) {
              var _this129 = this;
              var t = this[e];
              if (!t) throw new i.ZP("observablemixin-cannot-decorate-undefined", this, {
                object: this,
                methodName: e
              });
              this.on(e, function (e, s) {
                e.return = t.apply(_this129, s);
              }), this[e] = function () {
                for (var _len16 = arguments.length, t = new Array(_len16), _key16 = 0; _key16 < _len16; _key16++) {
                  t[_key16] = arguments[_key16];
                }
                return this.fire(e, t);
              }, this[e][h] = t, this[d] || (this[d] = []), this[d].push(e);
            }
          };
        (0, n.Z)(u, o.ZP), u.stopListening = function (e, t, s) {
          if (!e && this[d]) {
            var _iterator297 = _createForOfIteratorHelper(this[d]),
              _step297;
            try {
              for (_iterator297.s(); !(_step297 = _iterator297.n()).done;) {
                var _e225 = _step297.value;
                this[_e225] = this[_e225][h];
              }
            } catch (err) {
              _iterator297.e(err);
            } finally {
              _iterator297.f();
            }
            delete this[d];
          }
          o.ZP.stopListening.call(this, e, t, s);
        };
        var g = u;
        function p(e) {
          e[a] || (Object.defineProperty(e, a, {
            value: new Map()
          }), Object.defineProperty(e, c, {
            value: new Map()
          }), Object.defineProperty(e, l, {
            value: new Map()
          }));
        }
        function f() {
          var _this130 = this;
          var t = function () {
              for (var _len17 = arguments.length, e = new Array(_len17), _key17 = 0; _key17 < _len17; _key17++) {
                e[_key17] = arguments[_key17];
              }
              if (!e.length) throw new i.ZP("observable-bind-to-parse-error", null);
              var t = {
                to: []
              };
              var s;
              "function" == typeof e[e.length - 1] && (t.callback = e.pop());
              return e.forEach(function (e) {
                if ("string" == typeof e) s.properties.push(e);else {
                  if ("object" != typeof e) throw new i.ZP("observable-bind-to-parse-error", null);
                  s = {
                    observable: e,
                    properties: []
                  }, t.to.push(s);
                }
              }), t;
            }.apply(void 0, arguments),
            s = Array.from(this._bindings.keys()),
            o = s.length;
          if (!t.callback && t.to.length > 1) throw new i.ZP("observable-bind-to-no-callback", this);
          if (o > 1 && t.callback) throw new i.ZP("observable-bind-to-extra-callback", this);
          var r;
          t.to.forEach(function (e) {
            if (e.properties.length && e.properties.length !== o) throw new i.ZP("observable-bind-to-properties-length", _this130);
            e.properties.length || (e.properties = _this130._bindProperties);
          }), this._to = t.to, t.callback && (this._bindings.get(s[0]).callback = t.callback), r = this._observable, this._to.forEach(function (e) {
            var t = r[c];
            var s;
            t.get(e.observable) || r.listenTo(e.observable, "change", function (o, i) {
              s = t.get(e.observable)[i], s && s.forEach(function (e) {
                _(r, e.property);
              });
            });
          }), function (e) {
            var t;
            e._bindings.forEach(function (s, o) {
              e._to.forEach(function (i) {
                t = i.properties[s.callback ? 0 : e._bindProperties.indexOf(o)], s.to.push([i.observable, t]), function (e, t, s, o) {
                  var i = e[c],
                    r = i.get(s),
                    n = r || {};
                  n[o] || (n[o] = new Set());
                  n[o].add(t), r || i.set(s, n);
                }(e._observable, s, i.observable, t);
              });
            });
          }(this), this._bindProperties.forEach(function (e) {
            _(_this130._observable, e);
          });
        }
        function m(e, t, s) {
          if (this._bindings.size > 1) throw new i.ZP("observable-bind-to-many-not-one-binding", this);
          this.to.apply(this, _toConsumableArray(function (e, t) {
            var s = e.map(function (e) {
              return [e, t];
            });
            return Array.prototype.concat.apply([], s);
          }(e, t)).concat([s]));
        }
        function k(e) {
          return e.every(function (e) {
            return "string" == typeof e;
          });
        }
        function _(e, t) {
          var s = e[l].get(t);
          var o;
          s.callback ? o = s.callback.apply(e, s.to.map(function (e) {
            return e[0][e[1]];
          })) : (o = s.to[0], o = o[0][o[1]]), Object.prototype.hasOwnProperty.call(e, t) ? e[t] = o : e.set(t, o);
        }
      },
      "./packages/ckeditor5-utils/src/priorities.js": function _packages_ckeditor5Utils_src_prioritiesJs(e, t, s) {
        "use strict";

        s.d(t, {
          Z: function Z() {
            return o;
          }
        });
        var o = {
          get: function get(e) {
            return "number" != typeof e ? this[e] || this.normal : e;
          },
          highest: 1e5,
          high: 1e3,
          normal: 0,
          low: -1e3,
          lowest: -1e5
        };
      },
      "./packages/ckeditor5-utils/src/toarray.js": function _packages_ckeditor5Utils_src_toarrayJs(e, t, s) {
        "use strict";

        function o(e) {
          return Array.isArray(e) ? e : [e];
        }
        s.d(t, {
          Z: function Z() {
            return o;
          }
        });
      },
      "./packages/ckeditor5-utils/src/tomap.js": function _packages_ckeditor5Utils_src_tomapJs(e, t, s) {
        "use strict";

        s.d(t, {
          Z: function Z() {
            return i;
          }
        });
        var o = s("./packages/ckeditor5-utils/src/isiterable.js");
        function i(e) {
          return (0, o.Z)(e) ? new Map(e) : function (e) {
            var t = new Map();
            for (var _s206 in e) t.set(_s206, e[_s206]);
            return t;
          }(e);
        }
      },
      "./packages/ckeditor5-utils/src/uid.js": function _packages_ckeditor5Utils_src_uidJs(e, t, s) {
        "use strict";

        s.d(t, {
          Z: function Z() {
            return i;
          }
        });
        var o = new Array(256).fill().map(function (e, t) {
          return ("0" + t.toString(16)).slice(-2);
        });
        function i() {
          var e = 4294967296 * Math.random() >>> 0,
            t = 4294967296 * Math.random() >>> 0,
            s = 4294967296 * Math.random() >>> 0,
            i = 4294967296 * Math.random() >>> 0;
          return "e" + o[e >> 0 & 255] + o[e >> 8 & 255] + o[e >> 16 & 255] + o[e >> 24 & 255] + o[t >> 0 & 255] + o[t >> 8 & 255] + o[t >> 16 & 255] + o[t >> 24 & 255] + o[s >> 0 & 255] + o[s >> 8 & 255] + o[s >> 16 & 255] + o[s >> 24 & 255] + o[i >> 0 & 255] + o[i >> 8 & 255] + o[i >> 16 & 255] + o[i >> 24 & 255];
        }
      },
      "./packages/ckeditor5-utils/src/version.js": function _packages_ckeditor5Utils_src_versionJs(e, t, s) {
        "use strict";

        s.d(t, {
          Z: function Z() {
            return r;
          }
        });
        var o = s("./packages/ckeditor5-utils/src/ckeditorerror.js");
        var i = "33.0.0",
          r = i,
          n = "object" == typeof window ? window : s.g;
        if (n.CKEDITOR_VERSION) throw new o.ZP("ckeditor-duplicated-modules", null);
        n.CKEDITOR_VERSION = i;
      },
      "./packages/ckeditor5-widget/src/utils.js": function _packages_ckeditor5Widget_src_utilsJs(e, t, s) {
        "use strict";

        s.d(t, {
          s4: function s4() {
            return p;
          },
          Uo: function Uo() {
            return f;
          },
          KT: function KT() {
            return P;
          },
          id: function id() {
            return y;
          },
          Qd: function Qd() {
            return m;
          },
          em: function em() {
            return w;
          },
          l6: function l6() {
            return v;
          },
          XC: function XC() {
            return k;
          },
          sC: function sC() {
            return Z;
          },
          $n: function $n() {
            return j;
          }
        });
        var o = s("./packages/ckeditor5-utils/src/ckeditorerror.js"),
          i = s("./packages/ckeditor5-utils/src/toarray.js"),
          r = s("./packages/ckeditor5-utils/src/emittermixin.js"),
          n = s("./packages/ckeditor5-utils/src/mix.js");
        var a = /*#__PURE__*/function () {
          function a() {
            _classCallCheck(this, a);
            this._stack = [];
          }
          _createClass(a, [{
            key: "add",
            value: function add(e, t) {
              var s = this._stack,
                o = s[0];
              this._insertDescriptor(e);
              var i = s[0];
              o === i || c(o, i) || this.fire("change:top", {
                oldDescriptor: o,
                newDescriptor: i,
                writer: t
              });
            }
          }, {
            key: "remove",
            value: function remove(e, t) {
              var s = this._stack,
                o = s[0];
              this._removeDescriptor(e);
              var i = s[0];
              o === i || c(o, i) || this.fire("change:top", {
                oldDescriptor: o,
                newDescriptor: i,
                writer: t
              });
            }
          }, {
            key: "_insertDescriptor",
            value: function _insertDescriptor(e) {
              var t = this._stack,
                s = t.findIndex(function (t) {
                  return t.id === e.id;
                });
              if (c(e, t[s])) return;
              s > -1 && t.splice(s, 1);
              var o = 0;
              for (; t[o] && l(t[o], e);) o++;
              t.splice(o, 0, e);
            }
          }, {
            key: "_removeDescriptor",
            value: function _removeDescriptor(e) {
              var t = this._stack,
                s = t.findIndex(function (t) {
                  return t.id === e;
                });
              s > -1 && t.splice(s, 1);
            }
          }]);
          return a;
        }();
        function c(e, t) {
          return e && t && e.priority == t.priority && d(e.classes) == d(t.classes);
        }
        function l(e, t) {
          return e.priority > t.priority || !(e.priority < t.priority) && d(e.classes) > d(t.classes);
        }
        function d(e) {
          return Array.isArray(e) ? e.sort().join(",") : e;
        }
        (0, n.Z)(a, r.ZP);
        var h = s("./packages/ckeditor5-widget/src/widgettypearound/utils.js"),
          u = s("./packages/ckeditor5-ui/src/icon/iconview.js");
        var g = '<svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg"><path d="M4 0v1H1v3H0V.5A.5.5 0 0 1 .5 0H4zm8 0h3.5a.5.5 0 0 1 .5.5V4h-1V1h-3V0zM4 16H.5a.5.5 0 0 1-.5-.5V12h1v3h3v1zm8 0v-1h3v-3h1v3.5a.5.5 0 0 1-.5.5H12z"/><path fill-opacity=".256" d="M1 1h14v14H1z"/><g class="ck-icon__selected-indicator"><path d="M7 0h2v1H7V0zM0 7h1v2H0V7zm15 0h1v2h-1V7zm-8 8h2v1H7v-1z"/><path fill-opacity=".254" d="M1 1h14v14H1z"/></g></svg>',
          p = "ck-widget",
          f = "ck-widget_selected";
        function m(e) {
          return !!e.is("element") && !!e.getCustomProperty("widget");
        }
        function k(e, t) {
          var s = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
          if (!e.is("containerElement")) throw new o.ZP("widget-to-widget-wrong-element-type", null, {
            element: e
          });
          return t.setAttribute("contenteditable", "false", e), t.addClass(p, e), t.setCustomProperty("widget", !0, e), e.getFillerOffset = x, s.label && v(e, s.label, t), s.hasSelectionHandle && function (e, t) {
            var s = t.createUIElement("div", {
              class: "ck ck-widget__selection-handle"
            }, function (e) {
              var t = this.toDomElement(e),
                s = new u.Z();
              return s.set("content", g), s.render(), t.appendChild(s.element), t;
            });
            t.insert(t.createPositionAt(e, 0), s), t.addClass(["ck-widget_with-selection-handle"], e);
          }(e, t), w(e, t), e;
        }
        function _(e, t, s) {
          if (t.classes && s.addClass((0, i.Z)(t.classes), e), t.attributes) for (var _o133 in t.attributes) s.setAttribute(_o133, t.attributes[_o133], e);
        }
        function b(e, t, s) {
          if (t.classes && s.removeClass((0, i.Z)(t.classes), e), t.attributes) for (var _o134 in t.attributes) s.removeAttribute(_o134, e);
        }
        function w(e, t) {
          var s = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _;
          var o = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : b;
          var i = new a();
          i.on("change:top", function (t, i) {
            i.oldDescriptor && o(e, i.oldDescriptor, i.writer), i.newDescriptor && s(e, i.newDescriptor, i.writer);
          }), t.setCustomProperty("addHighlight", function (e, t, s) {
            return i.add(t, s);
          }, e), t.setCustomProperty("removeHighlight", function (e, t, s) {
            return i.remove(t, s);
          }, e);
        }
        function v(e, t, s) {
          s.setCustomProperty("widgetLabel", t, e);
        }
        function y(e) {
          var t = e.getCustomProperty("widgetLabel");
          return t ? "function" == typeof t ? t() : t : "";
        }
        function Z(e, t) {
          return t.addClass(["ck-editor__editable", "ck-editor__nested-editable"], e), t.setAttribute("contenteditable", e.isReadOnly ? "false" : "true", e), e.on("change:isReadOnly", function (s, o, i) {
            t.setAttribute("contenteditable", i ? "false" : "true", e);
          }), e.on("change:isFocused", function (s, o, i) {
            i ? t.addClass("ck-editor__nested-editable_focused", e) : t.removeClass("ck-editor__nested-editable_focused", e);
          }), w(e, t), e;
        }
        function P(e, t) {
          var s = e.getSelectedElement();
          if (s) {
            var _o135 = (0, h.tB)(e);
            if (_o135) return t.createRange(t.createPositionAt(s, _o135));
            if (t.schema.isObject(s) && !t.schema.isInline(s)) return t.createRangeOn(s);
          }
          var o = e.getSelectedBlocks().next().value;
          if (o) {
            if (o.isEmpty) return t.createRange(t.createPositionAt(o, 0));
            var _s207 = t.createPositionAfter(o);
            return e.focus.isTouching(_s207) ? t.createRange(_s207) : t.createRange(t.createPositionBefore(o));
          }
          return t.createRange(e.focus);
        }
        function j(e, t) {
          return function (s, o) {
            var i = o.mapper,
              r = o.viewPosition,
              n = i.findMappedViewAncestor(r);
            if (!t(n)) return;
            var a = i.toModelElement(n);
            o.modelPosition = e.createPositionAt(a, r.isAtStart ? "before" : "after");
          };
        }
        function x() {
          return null;
        }
      },
      "./packages/ckeditor5-widget/src/widget.js": function _packages_ckeditor5Widget_src_widgetJs(e, t, s) {
        "use strict";

        s.d(t, {
          Z: function Z() {
            return _;
          }
        });
        var o = s("./packages/ckeditor5-core/src/plugin.js"),
          i = s("./packages/ckeditor5-engine/src/view/observer/mouseobserver.js"),
          r = s("./packages/ckeditor5-widget/src/widgettypearound/widgettypearound.js"),
          n = s("./packages/ckeditor5-typing/src/delete.js"),
          a = s("./packages/ckeditor5-utils/src/env.js"),
          c = s("./packages/ckeditor5-utils/src/keyboard.js"),
          l = s("./packages/ckeditor5-utils/src/dom/rect.js");
        function d(e) {
          var t = e.model;
          return function (s, o) {
            var i = o.keyCode == c.Do.arrowup,
              r = o.keyCode == c.Do.arrowdown,
              n = o.shiftKey,
              a = t.document.selection;
            if (!i && !r) return;
            var d = r;
            if (n && function (e, t) {
              return !e.isCollapsed && e.isBackward == t;
            }(a, d)) return;
            var g = function (e, t, s) {
              var o = e.model;
              if (s) {
                var _e226 = t.isCollapsed ? t.focus : t.getLastPosition(),
                  _s208 = h(o, _e226, "forward");
                if (!_s208) return null;
                var _i109 = o.createRange(_e226, _s208),
                  _r52 = u(o.schema, _i109, "backward");
                return _r52 ? o.createRange(_e226, _r52) : null;
              }
              {
                var _e227 = t.isCollapsed ? t.focus : t.getFirstPosition(),
                  _s209 = h(o, _e227, "backward");
                if (!_s209) return null;
                var _i110 = o.createRange(_s209, _e227),
                  _r53 = u(o.schema, _i110, "forward");
                return _r53 ? o.createRange(_r53, _e227) : null;
              }
            }(e, a, d);
            if (g) {
              if (g.isCollapsed) {
                if (a.isCollapsed) return;
                if (n) return;
              }
              (g.isCollapsed || function (e, t, s) {
                var o = e.model,
                  i = e.view.domConverter;
                if (s) {
                  var _e228 = o.createSelection(t.start);
                  o.modifySelection(_e228), _e228.focus.isAtEnd || t.start.isEqual(_e228.focus) || (t = o.createRange(_e228.focus, t.end));
                }
                var r = e.mapper.toViewRange(t),
                  n = i.viewRangeToDom(r),
                  a = l.Z.getDomRangeRects(n);
                var c;
                var _iterator298 = _createForOfIteratorHelper(a),
                  _step298;
                try {
                  for (_iterator298.s(); !(_step298 = _iterator298.n()).done;) {
                    var _e229 = _step298.value;
                    if (void 0 !== c) {
                      if (Math.round(_e229.top) >= c) return !1;
                      c = Math.max(c, Math.round(_e229.bottom));
                    } else c = Math.round(_e229.bottom);
                  }
                } catch (err) {
                  _iterator298.e(err);
                } finally {
                  _iterator298.f();
                }
                return !0;
              }(e, g, d)) && (t.change(function (e) {
                var s = d ? g.end : g.start;
                if (n) {
                  var _o136 = t.createSelection(a.anchor);
                  _o136.setFocus(s), e.setSelection(_o136);
                } else e.setSelection(s);
              }), s.stop(), o.preventDefault(), o.stopPropagation());
            }
          };
        }
        function h(e, t, s) {
          var o = e.schema,
            i = e.createRangeIn(t.root),
            r = "forward" == s ? "elementStart" : "elementEnd";
          var _iterator299 = _createForOfIteratorHelper(i.getWalker({
              startPosition: t,
              direction: s
            })),
            _step299;
          try {
            for (_iterator299.s(); !(_step299 = _iterator299.n()).done;) {
              var _step299$value = _step299.value,
                _e230 = _step299$value.previousPosition,
                _n24 = _step299$value.item,
                _a15 = _step299$value.type;
              if (o.isLimit(_n24) && !o.isInline(_n24)) return _e230;
              if (_a15 == r && o.isBlock(_n24)) return null;
            }
          } catch (err) {
            _iterator299.e(err);
          } finally {
            _iterator299.f();
          }
          return null;
        }
        function u(e, t, s) {
          var o = "backward" == s ? t.end : t.start;
          if (e.checkChild(o, "$text")) return o;
          var _iterator300 = _createForOfIteratorHelper(t.getWalker({
              direction: s
            })),
            _step300;
          try {
            for (_iterator300.s(); !(_step300 = _iterator300.n()).done;) {
              var _o137 = _step300.value.nextPosition;
              if (e.checkChild(_o137, "$text")) return _o137;
            }
          } catch (err) {
            _iterator300.e(err);
          } finally {
            _iterator300.f();
          }
          return null;
        }
        var g = s("./packages/ckeditor5-widget/src/utils.js"),
          p = s("./node_modules/style-loader/dist/runtime/injectStylesIntoStyleTag.js"),
          f = s.n(p),
          m = s("./node_modules/css-loader/dist/cjs.js!./node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].use[2]!./packages/ckeditor5-widget/theme/widget.css"),
          k = {
            injectType: "singletonStyleTag",
            attributes: {
              "data-cke": !0
            },
            insert: "head",
            singleton: !0
          };
        f()(m.Z, k);
        m.Z.locals;
        var _ = /*#__PURE__*/function (_o$Z42) {
          _inherits(_, _o$Z42);
          function _() {
            _classCallCheck(this, _);
            return _possibleConstructorReturn(this, _getPrototypeOf(_).apply(this, arguments));
          }
          _createClass(_, [{
            key: "init",
            value: function init() {
              var _this131 = this;
              var e = this.editor,
                t = e.editing.view,
                s = t.document;
              this._previouslySelected = new Set(), this.editor.editing.downcastDispatcher.on("selection", function (t, s, o) {
                var i = o.writer,
                  r = s.selection;
                if (r.isCollapsed) return;
                var n = r.getSelectedElement();
                if (!n) return;
                var a = e.editing.mapper.toViewElement(n);
                (0, g.Qd)(a) && o.consumable.consume(r, "selection") && i.setSelection(i.createRangeOn(a), {
                  fake: !0,
                  label: (0, g.id)(a)
                });
              }), this.editor.editing.downcastDispatcher.on("selection", function (e, t, s) {
                _this131._clearPreviouslySelectedWidgets(s.writer);
                var o = s.writer,
                  i = o.document.selection;
                var r = null;
                var _iterator301 = _createForOfIteratorHelper(i.getRanges()),
                  _step301;
                try {
                  for (_iterator301.s(); !(_step301 = _iterator301.n()).done;) {
                    var _e231 = _step301.value;
                    var _iterator302 = _createForOfIteratorHelper(_e231),
                      _step302;
                    try {
                      for (_iterator302.s(); !(_step302 = _iterator302.n()).done;) {
                        var _t213 = _step302.value;
                        var _e232 = _t213.item;
                        (0, g.Qd)(_e232) && !b(_e232, r) && (o.addClass(g.Uo, _e232), _this131._previouslySelected.add(_e232), r = _e232);
                      }
                    } catch (err) {
                      _iterator302.e(err);
                    } finally {
                      _iterator302.f();
                    }
                  }
                } catch (err) {
                  _iterator301.e(err);
                } finally {
                  _iterator301.f();
                }
              }, {
                priority: "low"
              }), t.addObserver(i.Z), this.listenTo(s, "mousedown", function () {
                return _this131._onMousedown.apply(_this131, arguments);
              }), this.listenTo(s, "arrowKey", function () {
                _this131._handleSelectionChangeOnArrowKeyPress.apply(_this131, arguments);
              }, {
                context: [g.Qd, "$text"]
              }), this.listenTo(s, "arrowKey", function () {
                _this131._preventDefaultOnArrowKeyPress.apply(_this131, arguments);
              }, {
                context: "$root"
              }), this.listenTo(s, "arrowKey", d(this.editor.editing), {
                context: "$text"
              }), this.listenTo(s, "delete", function (e, t) {
                _this131._handleDelete("forward" == t.direction) && (t.preventDefault(), e.stop());
              }, {
                context: "$root"
              });
            }
          }, {
            key: "_onMousedown",
            value: function _onMousedown(e, t) {
              var s = this.editor,
                o = s.editing.view,
                i = o.document;
              var r = t.target;
              if (function (e) {
                for (; e;) {
                  if (e.is("editableElement") && !e.is("rootElement")) return !0;
                  if ((0, g.Qd)(e)) return !1;
                  e = e.parent;
                }
                return !1;
              }(r)) {
                if ((a.ZP.isSafari || a.ZP.isGecko) && t.domEvent.detail >= 3) {
                  var _e233 = s.editing.mapper,
                    _o138 = r.is("attributeElement") ? r.findAncestor(function (e) {
                      return !e.is("attributeElement");
                    }) : r,
                    _i111 = _e233.toModelElement(_o138);
                  t.preventDefault(), this.editor.model.change(function (e) {
                    e.setSelection(_i111, "in");
                  });
                }
                return;
              }
              if (!(0, g.Qd)(r) && (r = r.findAncestor(g.Qd), !r)) return;
              a.ZP.isAndroid && t.preventDefault(), i.isFocused || o.focus();
              var n = s.editing.mapper.toModelElement(r);
              this._setSelectionOverElement(n);
            }
          }, {
            key: "_handleSelectionChangeOnArrowKeyPress",
            value: function _handleSelectionChangeOnArrowKeyPress(e, t) {
              var s = t.keyCode,
                o = this.editor.model,
                i = o.schema,
                r = o.document.selection,
                n = r.getSelectedElement(),
                a = (0, c.mA)(s, this.editor.locale.contentLanguageDirection),
                l = "down" == a || "right" == a,
                d = "up" == a || "down" == a;
              if (n && i.isObject(n)) {
                var _s210 = l ? r.getLastPosition() : r.getFirstPosition(),
                  _n25 = i.getNearestSelectionRange(_s210, l ? "forward" : "backward");
                return void (_n25 && (o.change(function (e) {
                  e.setSelection(_n25);
                }), t.preventDefault(), e.stop()));
              }
              if (!r.isCollapsed && !t.shiftKey) {
                var _s211 = r.getFirstPosition(),
                  _n26 = r.getLastPosition(),
                  _a16 = _s211.nodeAfter,
                  _c11 = _n26.nodeBefore;
                return void ((_a16 && i.isObject(_a16) || _c11 && i.isObject(_c11)) && (o.change(function (e) {
                  e.setSelection(l ? _n26 : _s211);
                }), t.preventDefault(), e.stop()));
              }
              if (!r.isCollapsed) return;
              var h = this._getObjectElementNextToSelection(l);
              if (h && i.isObject(h)) {
                if (i.isInline(h) && d) return;
                this._setSelectionOverElement(h), t.preventDefault(), e.stop();
              }
            }
          }, {
            key: "_preventDefaultOnArrowKeyPress",
            value: function _preventDefaultOnArrowKeyPress(e, t) {
              var s = this.editor.model,
                o = s.schema,
                i = s.document.selection.getSelectedElement();
              i && o.isObject(i) && (t.preventDefault(), e.stop());
            }
          }, {
            key: "_handleDelete",
            value: function _handleDelete(e) {
              var _this132 = this;
              if (this.editor.isReadOnly) return;
              var t = this.editor.model.document.selection;
              if (!t.isCollapsed) return;
              var s = this._getObjectElementNextToSelection(e);
              return s ? (this.editor.model.change(function (e) {
                var o = t.anchor.parent;
                for (; o.isEmpty;) {
                  var _t214 = o;
                  o = _t214.parent, e.remove(_t214);
                }
                _this132._setSelectionOverElement(s);
              }), !0) : void 0;
            }
          }, {
            key: "_setSelectionOverElement",
            value: function _setSelectionOverElement(e) {
              this.editor.model.change(function (t) {
                t.setSelection(t.createRangeOn(e));
              });
            }
          }, {
            key: "_getObjectElementNextToSelection",
            value: function _getObjectElementNextToSelection(e) {
              var t = this.editor.model,
                s = t.schema,
                o = t.document.selection,
                i = t.createSelection(o);
              if (t.modifySelection(i, {
                direction: e ? "forward" : "backward"
              }), i.isEqual(o)) return null;
              var r = e ? i.focus.nodeBefore : i.focus.nodeAfter;
              return r && s.isObject(r) ? r : null;
            }
          }, {
            key: "_clearPreviouslySelectedWidgets",
            value: function _clearPreviouslySelectedWidgets(e) {
              var _iterator303 = _createForOfIteratorHelper(this._previouslySelected),
                _step303;
              try {
                for (_iterator303.s(); !(_step303 = _iterator303.n()).done;) {
                  var _t215 = _step303.value;
                  e.removeClass(g.Uo, _t215);
                }
              } catch (err) {
                _iterator303.e(err);
              } finally {
                _iterator303.f();
              }
              this._previouslySelected.clear();
            }
          }], [{
            key: "pluginName",
            get: function get() {
              return "Widget";
            }
          }, {
            key: "requires",
            get: function get() {
              return [r.Z, n.Z];
            }
          }]);
          return _;
        }(o.Z);
        function b(e, t) {
          return !!t && Array.from(e.getAncestors()).includes(t);
        }
      },
      "./packages/ckeditor5-widget/src/widgettypearound/utils.js": function _packages_ckeditor5Widget_src_widgettypearound_utilsJs(e, t, s) {
        "use strict";

        s.d(t, {
          Xr: function Xr() {
            return n;
          },
          _m: function _m() {
            return r;
          },
          aU: function aU() {
            return a;
          },
          bi: function bi() {
            return i;
          },
          t: function t() {
            return c;
          },
          tB: function tB() {
            return l;
          }
        });
        var o = s("./packages/ckeditor5-widget/src/utils.js");
        var i = "widget-type-around";
        function r(e, t, s) {
          return e && (0, o.Qd)(e) && !s.isInline(t);
        }
        function n(e) {
          return e.closest(".ck-widget__type-around__button");
        }
        function a(e) {
          return e.classList.contains("ck-widget__type-around__button_before") ? "before" : "after";
        }
        function c(e, t) {
          var s = e.closest(".ck-widget");
          return t.mapDomToView(s);
        }
        function l(e) {
          return e.getAttribute(i);
        }
      },
      "./packages/ckeditor5-widget/src/widgettypearound/widgettypearound.js": function _packages_ckeditor5Widget_src_widgettypearound_widgettypearoundJs(e, t, s) {
        "use strict";

        s.d(t, {
          Z: function Z() {
            return _;
          }
        });
        var o = s("./packages/ckeditor5-core/src/plugin.js"),
          i = s("./packages/ckeditor5-ui/src/template.js"),
          r = s("./packages/ckeditor5-enter/src/enter.js"),
          n = s("./packages/ckeditor5-typing/src/delete.js"),
          a = s("./packages/ckeditor5-utils/src/keyboard.js"),
          c = s("./packages/ckeditor5-widget/src/widgettypearound/utils.js"),
          l = s("./packages/ckeditor5-typing/src/utils/injectunsafekeystrokeshandling.js"),
          d = s("./packages/ckeditor5-widget/src/utils.js");
        var h = s("./node_modules/style-loader/dist/runtime/injectStylesIntoStyleTag.js"),
          u = s.n(h),
          g = s("./node_modules/css-loader/dist/cjs.js!./node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].use[2]!./packages/ckeditor5-widget/theme/widgettypearound.css"),
          p = {
            injectType: "singletonStyleTag",
            attributes: {
              "data-cke": !0
            },
            insert: "head",
            singleton: !0
          };
        u()(g.Z, p);
        g.Z.locals;
        var f = ["before", "after"],
          m = new DOMParser().parseFromString('<svg viewBox="0 0 10 8" xmlns="http://www.w3.org/2000/svg"><path d="M9.055.263v3.972h-6.77M1 4.216l2-2.038m-2 2 2 2.038"/></svg>', "image/svg+xml").firstChild,
          k = "ck-widget__type-around_disabled";
        var _ = /*#__PURE__*/function (_o$Z43) {
          _inherits(_, _o$Z43);
          _createClass(_, null, [{
            key: "pluginName",
            get: function get() {
              return "WidgetTypeAround";
            }
          }, {
            key: "requires",
            get: function get() {
              return [r.Z, n.Z];
            }
          }]);
          function _(e) {
            var _this133;
            _classCallCheck(this, _);
            _this133 = _possibleConstructorReturn(this, _getPrototypeOf(_).call(this, e)), _this133._currentFakeCaretModelElement = null;
            return _this133;
          }
          _createClass(_, [{
            key: "init",
            value: function init() {
              var e = this.editor,
                t = e.editing.view;
              this.on("change:isEnabled", function (s, o, i) {
                t.change(function (e) {
                  var _iterator304 = _createForOfIteratorHelper(t.document.roots),
                    _step304;
                  try {
                    for (_iterator304.s(); !(_step304 = _iterator304.n()).done;) {
                      var _s212 = _step304.value;
                      i ? e.removeClass(k, _s212) : e.addClass(k, _s212);
                    }
                  } catch (err) {
                    _iterator304.e(err);
                  } finally {
                    _iterator304.f();
                  }
                }), i || e.model.change(function (e) {
                  e.removeSelectionAttribute(c.bi);
                });
              }), this._enableTypeAroundUIInjection(), this._enableInsertingParagraphsOnButtonClick(), this._enableInsertingParagraphsOnEnterKeypress(), this._enableInsertingParagraphsOnTypingKeystroke(), this._enableTypeAroundFakeCaretActivationUsingKeyboardArrows(), this._enableDeleteIntegration(), this._enableInsertContentIntegration(), this._enableDeleteContentIntegration();
            }
          }, {
            key: "destroy",
            value: function destroy() {
              this._currentFakeCaretModelElement = null;
            }
          }, {
            key: "_insertParagraph",
            value: function _insertParagraph(e, t) {
              var s = this.editor,
                o = s.editing.view;
              s.execute("insertParagraph", {
                position: s.model.createPositionAt(e, t)
              }), o.focus(), o.scrollToTheSelection();
            }
          }, {
            key: "_listenToIfEnabled",
            value: function _listenToIfEnabled(e, t, s, o) {
              var _this134 = this;
              this.listenTo(e, t, function () {
                _this134.isEnabled && s.apply(void 0, arguments);
              }, o);
            }
          }, {
            key: "_insertParagraphAccordingToFakeCaretPosition",
            value: function _insertParagraphAccordingToFakeCaretPosition() {
              var e = this.editor.model.document.selection,
                t = (0, c.tB)(e);
              if (!t) return !1;
              var s = e.getSelectedElement();
              return this._insertParagraph(s, t), !0;
            }
          }, {
            key: "_enableTypeAroundUIInjection",
            value: function _enableTypeAroundUIInjection() {
              var e = this.editor,
                t = e.model.schema,
                s = e.locale.t,
                o = {
                  before: s("Insert paragraph before block"),
                  after: s("Insert paragraph after block")
                };
              e.editing.downcastDispatcher.on("insert", function (e, s, r) {
                var n = r.mapper.toViewElement(s.item);
                (0, c._m)(n, s.item, t) && function (e, t, s) {
                  var o = e.createUIElement("div", {
                    class: "ck ck-reset_all ck-widget__type-around"
                  }, function (e) {
                    var s = this.toDomElement(e);
                    return function (e, t) {
                      for (var _i112 = 0, _f = f; _i112 < _f.length; _i112++) {
                        var _s213 = _f[_i112];
                        var _o139 = new i.ZP({
                          tag: "div",
                          attributes: {
                            class: ["ck", "ck-widget__type-around__button", "ck-widget__type-around__button_".concat(_s213)],
                            title: t[_s213]
                          },
                          children: [e.ownerDocument.importNode(m, !0)]
                        });
                        e.appendChild(_o139.render());
                      }
                    }(s, t), function (e) {
                      var t = new i.ZP({
                        tag: "div",
                        attributes: {
                          class: ["ck", "ck-widget__type-around__fake-caret"]
                        }
                      });
                      e.appendChild(t.render());
                    }(s), s;
                  });
                  e.insert(e.createPositionAt(s, "end"), o);
                }(r.writer, o, n);
              }, {
                priority: "low"
              });
            }
          }, {
            key: "_enableTypeAroundFakeCaretActivationUsingKeyboardArrows",
            value: function _enableTypeAroundFakeCaretActivationUsingKeyboardArrows() {
              var _this135 = this;
              var e = this.editor,
                t = e.model,
                s = t.document.selection,
                o = t.schema,
                i = e.editing.view;
              function r(e) {
                return "ck-widget_type-around_show-fake-caret_".concat(e);
              }
              this._listenToIfEnabled(i.document, "arrowKey", function (e, t) {
                _this135._handleArrowKeyPress(e, t);
              }, {
                context: [d.Qd, "$text"],
                priority: "high"
              }), this._listenToIfEnabled(s, "change:range", function (t, s) {
                s.directChange && e.model.change(function (e) {
                  e.removeSelectionAttribute(c.bi);
                });
              }), this._listenToIfEnabled(t.document, "change:data", function () {
                var t = s.getSelectedElement();
                if (t) {
                  var _s214 = e.editing.mapper.toViewElement(t);
                  if ((0, c._m)(_s214, t, o)) return;
                }
                e.model.change(function (e) {
                  e.removeSelectionAttribute(c.bi);
                });
              }), this._listenToIfEnabled(e.editing.downcastDispatcher, "selection", function (e, t, s) {
                var i = s.writer;
                if (_this135._currentFakeCaretModelElement) {
                  var _e234 = s.mapper.toViewElement(_this135._currentFakeCaretModelElement);
                  _e234 && (i.removeClass(f.map(r), _e234), _this135._currentFakeCaretModelElement = null);
                }
                var n = t.selection.getSelectedElement();
                if (!n) return;
                var a = s.mapper.toViewElement(n);
                if (!(0, c._m)(a, n, o)) return;
                var l = (0, c.tB)(t.selection);
                l && (i.addClass(r(l), a), _this135._currentFakeCaretModelElement = n);
              }), this._listenToIfEnabled(e.ui.focusTracker, "change:isFocused", function (t, s, o) {
                o || e.model.change(function (e) {
                  e.removeSelectionAttribute(c.bi);
                });
              });
            }
          }, {
            key: "_handleArrowKeyPress",
            value: function _handleArrowKeyPress(e, t) {
              var s = this.editor,
                o = s.model,
                i = o.document.selection,
                r = o.schema,
                n = s.editing.view,
                l = t.keyCode,
                d = (0, a.Zt)(l, s.locale.contentLanguageDirection),
                h = n.document.selection.getSelectedElement(),
                u = s.editing.mapper.toModelElement(h);
              var g;
              (0, c._m)(h, u, r) ? g = this._handleArrowKeyPressOnSelectedWidget(d) : i.isCollapsed ? g = this._handleArrowKeyPressWhenSelectionNextToAWidget(d) : t.shiftKey || (g = this._handleArrowKeyPressWhenNonCollapsedSelection(d)), g && (t.preventDefault(), e.stop());
            }
          }, {
            key: "_handleArrowKeyPressOnSelectedWidget",
            value: function _handleArrowKeyPressOnSelectedWidget(e) {
              var t = this.editor.model,
                s = t.document.selection,
                o = (0, c.tB)(s);
              return t.change(function (t) {
                if (!o) return t.setSelectionAttribute(c.bi, e ? "after" : "before"), !0;
                if (!(o === (e ? "after" : "before"))) return t.removeSelectionAttribute(c.bi), !0;
                return !1;
              });
            }
          }, {
            key: "_handleArrowKeyPressWhenSelectionNextToAWidget",
            value: function _handleArrowKeyPressWhenSelectionNextToAWidget(e) {
              var t = this.editor,
                s = t.model,
                o = s.schema,
                i = t.plugins.get("Widget"),
                r = i._getObjectElementNextToSelection(e),
                n = t.editing.mapper.toViewElement(r);
              return !!(0, c._m)(n, r, o) && (s.change(function (t) {
                i._setSelectionOverElement(r), t.setSelectionAttribute(c.bi, e ? "before" : "after");
              }), !0);
            }
          }, {
            key: "_handleArrowKeyPressWhenNonCollapsedSelection",
            value: function _handleArrowKeyPressWhenNonCollapsedSelection(e) {
              var t = this.editor,
                s = t.model,
                o = s.schema,
                i = t.editing.mapper,
                r = s.document.selection,
                n = e ? r.getLastPosition().nodeBefore : r.getFirstPosition().nodeAfter,
                a = i.toViewElement(n);
              return !!(0, c._m)(a, n, o) && (s.change(function (t) {
                t.setSelection(n, "on"), t.setSelectionAttribute(c.bi, e ? "after" : "before");
              }), !0);
            }
          }, {
            key: "_enableInsertingParagraphsOnButtonClick",
            value: function _enableInsertingParagraphsOnButtonClick() {
              var _this136 = this;
              var e = this.editor,
                t = e.editing.view;
              this._listenToIfEnabled(t.document, "mousedown", function (s, o) {
                var i = (0, c.Xr)(o.domTarget);
                if (!i) return;
                var r = (0, c.aU)(i),
                  n = (0, c.t)(i, t.domConverter),
                  a = e.editing.mapper.toModelElement(n);
                _this136._insertParagraph(a, r), o.preventDefault(), s.stop();
              });
            }
          }, {
            key: "_enableInsertingParagraphsOnEnterKeypress",
            value: function _enableInsertingParagraphsOnEnterKeypress() {
              var _this137 = this;
              var e = this.editor,
                t = e.model.document.selection,
                s = e.editing.view;
              this._listenToIfEnabled(s.document, "enter", function (s, o) {
                if ("atTarget" != s.eventPhase) return;
                var i = t.getSelectedElement(),
                  r = e.editing.mapper.toViewElement(i),
                  n = e.model.schema;
                var a;
                _this137._insertParagraphAccordingToFakeCaretPosition() ? a = !0 : (0, c._m)(r, i, n) && (_this137._insertParagraph(i, o.isSoft ? "before" : "after"), a = !0), a && (o.preventDefault(), s.stop());
              }, {
                context: d.Qd
              });
            }
          }, {
            key: "_enableInsertingParagraphsOnTypingKeystroke",
            value: function _enableInsertingParagraphsOnTypingKeystroke() {
              var _this138 = this;
              var e = this.editor.editing.view,
                t = [a.Do.enter, a.Do.delete, a.Do.backspace];
              this._listenToIfEnabled(e.document, "keydown", function (e, s) {
                t.includes(s.keyCode) || (0, l.u)(s) || _this138._insertParagraphAccordingToFakeCaretPosition();
              }, {
                priority: "high"
              });
            }
          }, {
            key: "_enableDeleteIntegration",
            value: function _enableDeleteIntegration() {
              var e = this.editor,
                t = e.editing.view,
                s = e.model,
                o = s.schema;
              this._listenToIfEnabled(t.document, "delete", function (t, i) {
                if ("atTarget" != t.eventPhase) return;
                var r = (0, c.tB)(s.document.selection);
                if (!r) return;
                var n = i.direction,
                  a = s.document.selection.getSelectedElement(),
                  l = "forward" == n;
                if ("before" === r === l) e.execute("delete", {
                  selection: s.createSelection(a, "on")
                });else {
                  var _t216 = o.getNearestSelectionRange(s.createPositionAt(a, r), n);
                  if (_t216) if (_t216.isCollapsed) {
                    var _i113 = s.createSelection(_t216.start);
                    if (s.modifySelection(_i113, {
                      direction: n
                    }), _i113.focus.isEqual(_t216.start)) {
                      var _e235 = function (e, t) {
                        var s = t;
                        var _iterator305 = _createForOfIteratorHelper(t.getAncestors({
                            parentFirst: !0
                          })),
                          _step305;
                        try {
                          for (_iterator305.s(); !(_step305 = _iterator305.n()).done;) {
                            var _o140 = _step305.value;
                            if (_o140.childCount > 1 || e.isLimit(_o140)) break;
                            s = _o140;
                          }
                        } catch (err) {
                          _iterator305.e(err);
                        } finally {
                          _iterator305.f();
                        }
                        return s;
                      }(o, _t216.start.parent);
                      s.deleteContent(s.createSelection(_e235, "on"), {
                        doNotAutoparagraph: !0
                      });
                    } else s.change(function (s) {
                      s.setSelection(_t216), e.execute(l ? "deleteForward" : "delete");
                    });
                  } else s.change(function (s) {
                    s.setSelection(_t216), e.execute(l ? "deleteForward" : "delete");
                  });
                }
                i.preventDefault(), t.stop();
              }, {
                context: d.Qd
              });
            }
          }, {
            key: "_enableInsertContentIntegration",
            value: function _enableInsertContentIntegration() {
              var e = this.editor,
                t = this.editor.model,
                s = t.document.selection;
              this._listenToIfEnabled(e.model, "insertContent", function (e, _ref40) {
                var _ref41 = _slicedToArray(_ref40, 2),
                  o = _ref41[0],
                  i = _ref41[1];
                if (i && !i.is("documentSelection")) return;
                var r = (0, c.tB)(s);
                return r ? (e.stop(), t.change(function (e) {
                  var i = s.getSelectedElement(),
                    n = t.createPositionAt(i, r),
                    a = e.createSelection(n),
                    c = t.insertContent(o, a);
                  return e.setSelection(a), c;
                })) : void 0;
              }, {
                priority: "high"
              });
            }
          }, {
            key: "_enableDeleteContentIntegration",
            value: function _enableDeleteContentIntegration() {
              var e = this.editor,
                t = this.editor.model.document.selection;
              this._listenToIfEnabled(e.model, "deleteContent", function (e, _ref42) {
                var _ref43 = _slicedToArray(_ref42, 1),
                  s = _ref43[0];
                if (s && !s.is("documentSelection")) return;
                (0, c.tB)(t) && e.stop();
              }, {
                priority: "high"
              });
            }
          }]);
          return _;
        }(o.Z);
      },
      "./src/clipboard.js": function _src_clipboardJs(e, t, s) {
        "use strict";

        s.r(t), s.d(t, {
          Clipboard: function Clipboard() {
            return T;
          },
          ClipboardPipeline: function ClipboardPipeline() {
            return d;
          },
          DragDrop: function DragDrop() {
            return y;
          },
          PastePlainText: function PastePlainText() {
            return A;
          }
        });
        var o = s("./packages/ckeditor5-core/src/plugin.js"),
          i = s("./packages/ckeditor5-utils/src/eventinfo.js"),
          r = s("./packages/ckeditor5-engine/src/view/observer/domeventobserver.js");
        var n = /*#__PURE__*/function () {
          function n(e) {
            _classCallCheck(this, n);
            this.files = function (e) {
              var t = Array.from(e.files || []),
                s = Array.from(e.items || []);
              if (t.length) return t;
              return s.filter(function (e) {
                return "file" === e.kind;
              }).map(function (e) {
                return e.getAsFile();
              });
            }(e), this._native = e;
          }
          _createClass(n, [{
            key: "getData",
            value: function getData(e) {
              return this._native.getData(e);
            }
          }, {
            key: "setData",
            value: function setData(e, t) {
              this._native.setData(e, t);
            }
          }, {
            key: "types",
            get: function get() {
              return this._native.types;
            }
          }, {
            key: "effectAllowed",
            set: function set(e) {
              this._native.effectAllowed = e;
            },
            get: function get() {
              return this._native.effectAllowed;
            }
          }, {
            key: "dropEffect",
            set: function set(e) {
              this._native.dropEffect = e;
            },
            get: function get() {
              return this._native.dropEffect;
            }
          }, {
            key: "isCanceled",
            get: function get() {
              return "none" == this._native.dropEffect || !!this._native.mozUserCancelled;
            }
          }]);
          return n;
        }();
        var a = /*#__PURE__*/function (_r$Z4) {
          _inherits(a, _r$Z4);
          function a(e) {
            var _this139;
            _classCallCheck(this, a);
            _this139 = _possibleConstructorReturn(this, _getPrototypeOf(a).call(this, e));
            var t = _this139.document;
            function s(e) {
              return function (s, o) {
                o.preventDefault();
                var r = o.dropRange ? [o.dropRange] : null,
                  n = new i.Z(t, e);
                t.fire(n, {
                  dataTransfer: o.dataTransfer,
                  method: s.name,
                  targetRanges: r,
                  target: o.target
                }), n.stop.called && o.stopPropagation();
              };
            }
            _this139.domEventType = ["paste", "copy", "cut", "drop", "dragover", "dragstart", "dragend", "dragenter", "dragleave"], _this139.listenTo(t, "paste", s("clipboardInput"), {
              priority: "low"
            }), _this139.listenTo(t, "drop", s("clipboardInput"), {
              priority: "low"
            }), _this139.listenTo(t, "dragover", s("dragging"), {
              priority: "low"
            });
            return _this139;
          }
          _createClass(a, [{
            key: "onDomEvent",
            value: function onDomEvent(e) {
              var t = {
                dataTransfer: new n(e.clipboardData ? e.clipboardData : e.dataTransfer)
              };
              "drop" != e.type && "dragover" != e.type || (t.dropRange = function (e, t) {
                var s = t.target.ownerDocument,
                  o = t.clientX,
                  i = t.clientY;
                var r;
                s.caretRangeFromPoint && s.caretRangeFromPoint(o, i) ? r = s.caretRangeFromPoint(o, i) : t.rangeParent && (r = s.createRange(), r.setStart(t.rangeParent, t.rangeOffset), r.collapse(!0));
                if (r) return e.domConverter.domRangeToView(r);
                return null;
              }(this.view, e)), this.fire(e.type, e, t);
            }
          }]);
          return a;
        }(r.Z);
        var c = ["figcaption", "li"];
        function l(e) {
          var t = "";
          if (e.is("$text") || e.is("$textProxy")) t = e.data;else if (e.is("element", "img") && e.hasAttribute("alt")) t = e.getAttribute("alt");else if (e.is("element", "br")) t = "\n";else {
            var _s215 = null;
            var _iterator306 = _createForOfIteratorHelper(e.getChildren()),
              _step306;
            try {
              for (_iterator306.s(); !(_step306 = _iterator306.n()).done;) {
                var _o141 = _step306.value;
                var _e236 = l(_o141);
                _s215 && (_s215.is("containerElement") || _o141.is("containerElement")) && (c.includes(_s215.name) || c.includes(_o141.name) ? t += "\n" : t += "\n\n"), t += _e236, _s215 = _o141;
              }
            } catch (err) {
              _iterator306.e(err);
            } finally {
              _iterator306.f();
            }
          }
          return t;
        }
        var d = /*#__PURE__*/function (_o$Z44) {
          _inherits(d, _o$Z44);
          function d() {
            _classCallCheck(this, d);
            return _possibleConstructorReturn(this, _getPrototypeOf(d).apply(this, arguments));
          }
          _createClass(d, [{
            key: "init",
            value: function init() {
              this.editor.editing.view.addObserver(a), this._setupPasteDrop(), this._setupCopyCut();
            }
          }, {
            key: "_setupPasteDrop",
            value: function _setupPasteDrop() {
              var _this140 = this;
              var e = this.editor,
                t = e.model,
                s = e.editing.view,
                o = s.document;
              this.listenTo(o, "clipboardInput", function (t) {
                e.isReadOnly && t.stop();
              }, {
                priority: "highest"
              }), this.listenTo(o, "clipboardInput", function (e, t) {
                var o = t.dataTransfer;
                var r = t.content || "";
                var n;
                r || (o.getData("text/html") ? r = function (e) {
                  return e.replace(/<span(?: class="Apple-converted-space"|)>(\s+)<\/span>/g, function (e, t) {
                    return 1 == t.length ? " " : t;
                  }).replace(/<!--[\s\S]*?-->/g, "");
                }(o.getData("text/html")) : o.getData("text/plain") && (((n = (n = o.getData("text/plain")).replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/\r?\n\r?\n/g, "</p><p>").replace(/\r?\n/g, "<br>").replace(/^\s/, "&nbsp;").replace(/\s$/, "&nbsp;").replace(/\s\s/g, " &nbsp;")).includes("</p><p>") || n.includes("<br>")) && (n = "<p>".concat(n, "</p>")), r = n), r = _this140.editor.data.htmlProcessor.toView(r));
                var a = new i.Z(_this140, "inputTransformation");
                _this140.fire(a, {
                  content: r,
                  dataTransfer: o,
                  targetRanges: t.targetRanges,
                  method: t.method
                }), a.stop.called && e.stop(), s.scrollToTheSelection();
              }, {
                priority: "low"
              }), this.listenTo(this, "inputTransformation", function (e, s) {
                if (s.content.isEmpty) return;
                var o = _this140.editor.data.toModel(s.content, "$clipboardHolder");
                0 != o.childCount && (e.stop(), t.change(function () {
                  _this140.fire("contentInsertion", {
                    content: o,
                    method: s.method,
                    dataTransfer: s.dataTransfer,
                    targetRanges: s.targetRanges
                  });
                }));
              }, {
                priority: "low"
              }), this.listenTo(this, "contentInsertion", function (e, s) {
                s.resultRange = t.insertContent(s.content);
              }, {
                priority: "low"
              });
            }
          }, {
            key: "_setupCopyCut",
            value: function _setupCopyCut() {
              var _this141 = this;
              var e = this.editor,
                t = e.model.document,
                s = e.editing.view.document;
              function o(o, i) {
                var r = i.dataTransfer;
                i.preventDefault();
                var n = e.data.toView(e.model.getSelectedContent(t.selection));
                s.fire("clipboardOutput", {
                  dataTransfer: r,
                  content: n,
                  method: o.name
                });
              }
              this.listenTo(s, "copy", o, {
                priority: "low"
              }), this.listenTo(s, "cut", function (t, s) {
                e.isReadOnly ? s.preventDefault() : o(t, s);
              }, {
                priority: "low"
              }), this.listenTo(s, "clipboardOutput", function (s, o) {
                o.content.isEmpty || (o.dataTransfer.setData("text/html", _this141.editor.data.htmlProcessor.toData(o.content)), o.dataTransfer.setData("text/plain", l(o.content))), "cut" == o.method && e.model.deleteContent(t.selection);
              }, {
                priority: "low"
              });
            }
          }], [{
            key: "pluginName",
            get: function get() {
              return "ClipboardPipeline";
            }
          }]);
          return d;
        }(o.Z);
        var h = s("./packages/ckeditor5-engine/src/model/liverange.js"),
          u = s("./packages/ckeditor5-engine/src/view/observer/mouseobserver.js"),
          g = s("./packages/ckeditor5-widget/src/widget.js"),
          p = s("./packages/ckeditor5-utils/src/uid.js"),
          f = s("./packages/ckeditor5-utils/src/env.js"),
          m = s("./packages/ckeditor5-widget/src/utils.js"),
          k = s("./node_modules/lodash-es/throttle.js"),
          _ = s("./node_modules/style-loader/dist/runtime/injectStylesIntoStyleTag.js"),
          b = s.n(_),
          w = s("./node_modules/css-loader/dist/cjs.js!./node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].use[2]!./packages/ckeditor5-clipboard/theme/clipboard.css"),
          v = {
            injectType: "singletonStyleTag",
            attributes: {
              "data-cke": !0
            },
            insert: "head",
            singleton: !0
          };
        b()(w.Z, v);
        w.Z.locals;
        var y = /*#__PURE__*/function (_o$Z45) {
          _inherits(y, _o$Z45);
          function y() {
            _classCallCheck(this, y);
            return _possibleConstructorReturn(this, _getPrototypeOf(y).apply(this, arguments));
          }
          _createClass(y, [{
            key: "init",
            value: function init() {
              var _this142 = this;
              var e = this.editor,
                t = e.editing.view;
              this._draggedRange = null, this._draggingUid = "", this._draggableElement = null, this._updateDropMarkerThrottled = (0, k.Z)(function (e) {
                return _this142._updateDropMarker(e);
              }, 40), this._removeDropMarkerDelayed = j(function () {
                return _this142._removeDropMarker();
              }, 40), this._clearDraggableAttributesDelayed = j(function () {
                return _this142._clearDraggableAttributes();
              }, 40), t.addObserver(a), t.addObserver(u.Z), this._setupDragging(), this._setupContentInsertionIntegration(), this._setupClipboardInputIntegration(), this._setupDropMarker(), this._setupDraggableAttributeHandling(), this.listenTo(e, "change:isReadOnly", function (e, t, s) {
                s ? _this142.forceDisabled("readOnlyMode") : _this142.clearForceDisabled("readOnlyMode");
              }), this.on("change:isEnabled", function (e, t, s) {
                s || _this142._finalizeDragging(!1);
              }), f.ZP.isAndroid && this.forceDisabled("noAndroidSupport");
            }
          }, {
            key: "destroy",
            value: function destroy() {
              return this._draggedRange && (this._draggedRange.detach(), this._draggedRange = null), this._updateDropMarkerThrottled.cancel(), this._removeDropMarkerDelayed.cancel(), this._clearDraggableAttributesDelayed.cancel(), _superPropGet(y, "destroy", this, 3)([]);
            }
          }, {
            key: "_setupDragging",
            value: function _setupDragging() {
              var _this143 = this;
              var e = this.editor,
                t = e.model,
                s = t.document,
                o = e.editing.view,
                i = o.document;
              this.listenTo(i, "dragstart", function (o, r) {
                var n = s.selection;
                if (r.target && r.target.is("editableElement")) return void r.preventDefault();
                var a = r.target ? x(r.target) : null;
                if (a) {
                  var _s216 = e.editing.mapper.toModelElement(a);
                  _this143._draggedRange = h.Z.fromRange(t.createRangeOn(_s216)), e.plugins.has("WidgetToolbarRepository") && e.plugins.get("WidgetToolbarRepository").forceDisabled("dragDrop");
                } else if (!i.selection.isCollapsed) {
                  var _e237 = i.selection.getSelectedElement();
                  _e237 && (0, m.Qd)(_e237) || (_this143._draggedRange = h.Z.fromRange(n.getFirstRange()));
                }
                if (!_this143._draggedRange) return void r.preventDefault();
                _this143._draggingUid = (0, p.Z)(), r.dataTransfer.effectAllowed = _this143.isEnabled ? "copyMove" : "copy", r.dataTransfer.setData("application/ckeditor5-dragging-uid", _this143._draggingUid);
                var c = t.createSelection(_this143._draggedRange.toRange()),
                  l = e.data.toView(t.getSelectedContent(c));
                i.fire("clipboardOutput", {
                  dataTransfer: r.dataTransfer,
                  content: l,
                  method: o.name
                }), _this143.isEnabled || (_this143._draggedRange.detach(), _this143._draggedRange = null, _this143._draggingUid = "");
              }, {
                priority: "low"
              }), this.listenTo(i, "dragend", function (e, t) {
                _this143._finalizeDragging(!t.dataTransfer.isCanceled && "move" == t.dataTransfer.dropEffect);
              }, {
                priority: "low"
              }), this.listenTo(i, "dragenter", function () {
                _this143.isEnabled && o.focus();
              }), this.listenTo(i, "dragleave", function () {
                _this143._removeDropMarkerDelayed();
              }), this.listenTo(i, "dragging", function (t, s) {
                if (!_this143.isEnabled) return void (s.dataTransfer.dropEffect = "none");
                _this143._removeDropMarkerDelayed.cancel();
                var o = Z(e, s.targetRanges, s.target);
                _this143._draggedRange || (s.dataTransfer.dropEffect = "copy"), f.ZP.isGecko || ("copy" == s.dataTransfer.effectAllowed ? s.dataTransfer.dropEffect = "copy" : ["all", "copyMove"].includes(s.dataTransfer.effectAllowed) && (s.dataTransfer.dropEffect = "move")), o && _this143._updateDropMarkerThrottled(o);
              }, {
                priority: "low"
              });
            }
          }, {
            key: "_setupClipboardInputIntegration",
            value: function _setupClipboardInputIntegration() {
              var _this144 = this;
              var e = this.editor,
                t = e.editing.view.document;
              this.listenTo(t, "clipboardInput", function (t, s) {
                if ("drop" != s.method) return;
                var o = Z(e, s.targetRanges, s.target);
                if (_this144._removeDropMarker(), !o) return _this144._finalizeDragging(!1), void t.stop();
                _this144._draggedRange && _this144._draggingUid != s.dataTransfer.getData("application/ckeditor5-dragging-uid") && (_this144._draggedRange.detach(), _this144._draggedRange = null, _this144._draggingUid = "");
                if ("move" == P(s.dataTransfer) && _this144._draggedRange && _this144._draggedRange.containsRange(o, !0)) return _this144._finalizeDragging(!1), void t.stop();
                s.targetRanges = [e.editing.mapper.toViewRange(o)];
              }, {
                priority: "high"
              });
            }
          }, {
            key: "_setupContentInsertionIntegration",
            value: function _setupContentInsertionIntegration() {
              var _this145 = this;
              var e = this.editor.plugins.get(d);
              e.on("contentInsertion", function (e, t) {
                if (!_this145.isEnabled || "drop" !== t.method) return;
                var s = t.targetRanges.map(function (e) {
                  return _this145.editor.editing.mapper.toModelRange(e);
                });
                _this145.editor.model.change(function (e) {
                  return e.setSelection(s);
                });
              }, {
                priority: "high"
              }), e.on("contentInsertion", function (e, t) {
                if (!_this145.isEnabled || "drop" !== t.method) return;
                var s = "move" == P(t.dataTransfer),
                  o = !t.resultRange || !t.resultRange.isCollapsed;
                _this145._finalizeDragging(o && s);
              }, {
                priority: "lowest"
              });
            }
          }, {
            key: "_setupDraggableAttributeHandling",
            value: function _setupDraggableAttributeHandling() {
              var _this146 = this;
              var e = this.editor,
                t = e.editing.view,
                s = t.document;
              this.listenTo(s, "mousedown", function (o, i) {
                if (f.ZP.isAndroid || !i) return;
                _this146._clearDraggableAttributesDelayed.cancel();
                var r = x(i.target);
                if (f.ZP.isBlink && !e.isReadOnly && !r && !s.selection.isCollapsed) {
                  var _e238 = s.selection.getSelectedElement();
                  _e238 && (0, m.Qd)(_e238) || (r = s.selection.editableElement);
                }
                r && (t.change(function (e) {
                  e.setAttribute("draggable", "true", r);
                }), _this146._draggableElement = e.editing.mapper.toModelElement(r));
              }), this.listenTo(s, "mouseup", function () {
                f.ZP.isAndroid || _this146._clearDraggableAttributesDelayed();
              });
            }
          }, {
            key: "_clearDraggableAttributes",
            value: function _clearDraggableAttributes() {
              var _this147 = this;
              var e = this.editor.editing;
              e.view.change(function (t) {
                _this147._draggableElement && "$graveyard" != _this147._draggableElement.root.rootName && t.removeAttribute("draggable", e.mapper.toViewElement(_this147._draggableElement)), _this147._draggableElement = null;
              });
            }
          }, {
            key: "_setupDropMarker",
            value: function _setupDropMarker() {
              var e = this.editor;
              e.conversion.for("editingDowncast").markerToHighlight({
                model: "drop-target",
                view: {
                  classes: ["ck-clipboard-drop-target-range"]
                }
              }), e.conversion.for("editingDowncast").markerToElement({
                model: "drop-target",
                view: function view(t, _ref44) {
                  var s = _ref44.writer;
                  if (e.model.schema.checkChild(t.markerRange.start, "$text")) return s.createUIElement("span", {
                    class: "ck ck-clipboard-drop-target-position"
                  }, function (e) {
                    var t = this.toDomElement(e);
                    return t.innerHTML = "&NoBreak;<span></span>&NoBreak;", t;
                  });
                }
              });
            }
          }, {
            key: "_updateDropMarker",
            value: function _updateDropMarker(e) {
              var t = this.editor,
                s = t.model.markers;
              t.model.change(function (t) {
                s.has("drop-target") ? s.get("drop-target").getRange().isEqual(e) || t.updateMarker("drop-target", {
                  range: e
                }) : t.addMarker("drop-target", {
                  range: e,
                  usingOperation: !1,
                  affectsData: !1
                });
              });
            }
          }, {
            key: "_removeDropMarker",
            value: function _removeDropMarker() {
              var e = this.editor.model;
              this._removeDropMarkerDelayed.cancel(), this._updateDropMarkerThrottled.cancel(), e.markers.has("drop-target") && e.change(function (e) {
                e.removeMarker("drop-target");
              });
            }
          }, {
            key: "_finalizeDragging",
            value: function _finalizeDragging(e) {
              var t = this.editor,
                s = t.model;
              this._removeDropMarker(), this._clearDraggableAttributes(), t.plugins.has("WidgetToolbarRepository") && t.plugins.get("WidgetToolbarRepository").clearForceDisabled("dragDrop"), this._draggingUid = "", this._draggedRange && (e && this.isEnabled && s.deleteContent(s.createSelection(this._draggedRange), {
                doNotAutoparagraph: !0
              }), this._draggedRange.detach(), this._draggedRange = null);
            }
          }], [{
            key: "pluginName",
            get: function get() {
              return "DragDrop";
            }
          }, {
            key: "requires",
            get: function get() {
              return [d, g.Z];
            }
          }]);
          return y;
        }(o.Z);
        function Z(e, t, s) {
          var o = e.model,
            i = e.editing.mapper;
          var r = null;
          var n = t ? t[0].start : null;
          if (s.is("uiElement") && (s = s.parent), r = function (e, t) {
            var s = e.model,
              o = e.editing.mapper;
            if ((0, m.Qd)(t)) return s.createRangeOn(o.toModelElement(t));
            if (!t.is("editableElement")) {
              var _e239 = t.findAncestor(function (e) {
                return (0, m.Qd)(e) || e.is("editableElement");
              });
              if ((0, m.Qd)(_e239)) return s.createRangeOn(o.toModelElement(_e239));
            }
            return null;
          }(e, s), r) return r;
          var a = function (e, t) {
              var s = e.editing.mapper,
                o = e.editing.view,
                i = s.toModelElement(t);
              if (i) return i;
              var r = o.createPositionBefore(t),
                n = s.findMappedViewAncestor(r);
              return s.toModelElement(n);
            }(e, s),
            c = n ? i.toModelPosition(n) : null;
          return c ? (r = function (e, t, s) {
            var o = e.model;
            if (!o.schema.checkChild(s, "$block")) return null;
            var i = o.createPositionAt(s, 0),
              r = t.path.slice(0, i.path.length),
              n = o.createPositionFromPath(t.root, r).nodeAfter;
            if (n && o.schema.isObject(n)) return o.createRangeOn(n);
            return null;
          }(e, c, a), r || (r = o.schema.getNearestSelectionRange(c, f.ZP.isGecko ? "forward" : "backward"), r || function (e, t) {
            var s = e.model;
            for (; t;) {
              if (s.schema.isObject(t)) return s.createRangeOn(t);
              t = t.parent;
            }
          }(e, c.parent))) : function (e, t) {
            var s = e.model,
              o = s.schema,
              i = s.createPositionAt(t, 0);
            return o.getNearestSelectionRange(i, "forward");
          }(e, a);
        }
        function P(e) {
          return f.ZP.isGecko ? e.dropEffect : ["all", "copyMove"].includes(e.effectAllowed) ? "move" : "copy";
        }
        function j(e, t) {
          var s;
          function o() {
            for (var _len18 = arguments.length, i = new Array(_len18), _key18 = 0; _key18 < _len18; _key18++) {
              i[_key18] = arguments[_key18];
            }
            o.cancel(), s = setTimeout(function () {
              return e.apply(void 0, i);
            }, t);
          }
          return o.cancel = function () {
            clearTimeout(s);
          }, o;
        }
        function x(e) {
          if (e.is("editableElement")) return null;
          if (e.hasClass("ck-widget__selection-handle")) return e.findAncestor(m.Qd);
          if ((0, m.Qd)(e)) return e;
          var t = e.findAncestor(function (e) {
            return (0, m.Qd)(e) || e.is("editableElement");
          });
          return (0, m.Qd)(t) ? t : null;
        }
        var A = /*#__PURE__*/function (_o$Z46) {
          _inherits(A, _o$Z46);
          function A() {
            _classCallCheck(this, A);
            return _possibleConstructorReturn(this, _getPrototypeOf(A).apply(this, arguments));
          }
          _createClass(A, [{
            key: "init",
            value: function init() {
              var e = this.editor,
                t = e.model,
                s = e.editing.view,
                o = s.document,
                i = t.document.selection;
              var r = !1;
              s.addObserver(a), this.listenTo(o, "keydown", function (e, t) {
                r = t.shiftKey;
              }), e.plugins.get(d).on("contentInsertion", function (e, s) {
                (r || function (e, t) {
                  if (e.childCount > 1) return !1;
                  var s = e.getChild(0);
                  if (t.isObject(s)) return !1;
                  return 0 == _toConsumableArray(s.getAttributeKeys()).length;
                }(s.content, t.schema)) && t.change(function (e) {
                  var o = Array.from(i.getAttributes()).filter(function (_ref45) {
                    var _ref46 = _slicedToArray(_ref45, 1),
                      e = _ref46[0];
                    return t.schema.getAttributeProperties(e).isFormatting;
                  });
                  i.isCollapsed || t.deleteContent(i, {
                    doNotAutoparagraph: !0
                  }), o.push.apply(o, _toConsumableArray(i.getAttributes()));
                  var r = e.createRangeIn(s.content);
                  var _iterator307 = _createForOfIteratorHelper(r.getItems()),
                    _step307;
                  try {
                    for (_iterator307.s(); !(_step307 = _iterator307.n()).done;) {
                      var _t217 = _step307.value;
                      _t217.is("$textProxy") && e.setAttributes(o, _t217);
                    }
                  } catch (err) {
                    _iterator307.e(err);
                  } finally {
                    _iterator307.f();
                  }
                });
              });
            }
          }], [{
            key: "pluginName",
            get: function get() {
              return "PastePlainText";
            }
          }, {
            key: "requires",
            get: function get() {
              return [d];
            }
          }]);
          return A;
        }(o.Z);
        var T = /*#__PURE__*/function (_o$Z47) {
          _inherits(T, _o$Z47);
          function T() {
            _classCallCheck(this, T);
            return _possibleConstructorReturn(this, _getPrototypeOf(T).apply(this, arguments));
          }
          _createClass(T, null, [{
            key: "pluginName",
            get: function get() {
              return "Clipboard";
            }
          }, {
            key: "requires",
            get: function get() {
              return [d, y, A];
            }
          }]);
          return T;
        }(o.Z);
      },
      "./src/core.js": function _src_coreJs(e, t, s) {
        "use strict";

        s.r(t), s.d(t, {
          Command: function Command() {
            return i.Z;
          },
          Context: function Context() {
            return _;
          },
          ContextPlugin: function ContextPlugin() {
            return b.Z;
          },
          DataApiMixin: function DataApiMixin() {
            return I;
          },
          Editor: function Editor() {
            return C;
          },
          EditorUI: function EditorUI() {
            return O;
          },
          ElementApiMixin: function ElementApiMixin() {
            return V;
          },
          MultiCommand: function MultiCommand() {
            return r;
          },
          PendingActions: function PendingActions() {
            return B.Z;
          },
          Plugin: function Plugin() {
            return o.Z;
          },
          attachToForm: function attachToForm() {
            return N;
          },
          icons: function icons() {
            return W;
          },
          secureSourceElement: function secureSourceElement() {
            return D;
          }
        });
        var o = s("./packages/ckeditor5-core/src/plugin.js"),
          i = s("./packages/ckeditor5-core/src/command.js");
        var r = /*#__PURE__*/function (_i$Z6) {
          _inherits(r, _i$Z6);
          function r(e) {
            var _this148;
            _classCallCheck(this, r);
            _this148 = _possibleConstructorReturn(this, _getPrototypeOf(r).call(this, e)), _this148._childCommands = [];
            return _this148;
          }
          _createClass(r, [{
            key: "refresh",
            value: function refresh() {}
          }, {
            key: "execute",
            value: function execute() {
              var t = this._getFirstEnabledCommand();
              for (var _len19 = arguments.length, e = new Array(_len19), _key19 = 0; _key19 < _len19; _key19++) {
                e[_key19] = arguments[_key19];
              }
              return null != t && t.execute(e);
            }
          }, {
            key: "registerChildCommand",
            value: function registerChildCommand(e) {
              var _this149 = this;
              this._childCommands.push(e), e.on("change:isEnabled", function () {
                return _this149._checkEnabled();
              }), this._checkEnabled();
            }
          }, {
            key: "_checkEnabled",
            value: function _checkEnabled() {
              this.isEnabled = !!this._getFirstEnabledCommand();
            }
          }, {
            key: "_getFirstEnabledCommand",
            value: function _getFirstEnabledCommand() {
              return this._childCommands.find(function (e) {
                return e.isEnabled;
              });
            }
          }]);
          return r;
        }(i.Z);
        var n = s("./node_modules/lodash-es/isPlainObject.js"),
          a = s("./node_modules/lodash-es/cloneDeepWith.js"),
          c = s("./node_modules/lodash-es/isElement.js");
        var l = /*#__PURE__*/function () {
          function l(e, t) {
            _classCallCheck(this, l);
            this._config = {}, t && this.define(d(t)), e && this._setObjectToTarget(this._config, e);
          }
          _createClass(l, [{
            key: "set",
            value: function set(e, t) {
              this._setToTarget(this._config, e, t);
            }
          }, {
            key: "define",
            value: function define(e, t) {
              this._setToTarget(this._config, e, t, !0);
            }
          }, {
            key: "get",
            value: function get(e) {
              return this._getFromSource(this._config, e);
            }
          }, {
            key: "names",
            value: /*#__PURE__*/_regeneratorRuntime().mark(function names() {
              var _i114, _Object$keys3, _e240;
              return _regeneratorRuntime().wrap(function names$(_context33) {
                while (1) switch (_context33.prev = _context33.next) {
                  case 0:
                    _i114 = 0, _Object$keys3 = Object.keys(this._config);
                  case 1:
                    if (!(_i114 < _Object$keys3.length)) {
                      _context33.next = 8;
                      break;
                    }
                    _e240 = _Object$keys3[_i114];
                    _context33.next = 5;
                    return _e240;
                  case 5:
                    _i114++;
                    _context33.next = 1;
                    break;
                  case 8:
                  case "end":
                    return _context33.stop();
                }
              }, names, this);
            })
          }, {
            key: "_setToTarget",
            value: function _setToTarget(e, t, s) {
              var o = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : !1;
              if ((0, n.Z)(t)) return void this._setObjectToTarget(e, t, o);
              var i = t.split(".");
              t = i.pop();
              var _iterator308 = _createForOfIteratorHelper(i),
                _step308;
              try {
                for (_iterator308.s(); !(_step308 = _iterator308.n()).done;) {
                  var _t218 = _step308.value;
                  (0, n.Z)(e[_t218]) || (e[_t218] = {}), e = e[_t218];
                }
              } catch (err) {
                _iterator308.e(err);
              } finally {
                _iterator308.f();
              }
              if ((0, n.Z)(s)) return (0, n.Z)(e[t]) || (e[t] = {}), e = e[t], void this._setObjectToTarget(e, s, o);
              o && void 0 !== e[t] || (e[t] = s);
            }
          }, {
            key: "_getFromSource",
            value: function _getFromSource(e, t) {
              var s = t.split(".");
              t = s.pop();
              var _iterator309 = _createForOfIteratorHelper(s),
                _step309;
              try {
                for (_iterator309.s(); !(_step309 = _iterator309.n()).done;) {
                  var _t219 = _step309.value;
                  if (!(0, n.Z)(e[_t219])) {
                    e = null;
                    break;
                  }
                  e = e[_t219];
                }
              } catch (err) {
                _iterator309.e(err);
              } finally {
                _iterator309.f();
              }
              return e ? d(e[t]) : void 0;
            }
          }, {
            key: "_setObjectToTarget",
            value: function _setObjectToTarget(e, t, s) {
              var _this150 = this;
              Object.keys(t).forEach(function (o) {
                _this150._setToTarget(e, o, t[o], s);
              });
            }
          }]);
          return l;
        }();
        function d(e) {
          return (0, a.Z)(e, h);
        }
        function h(e) {
          return (0, c.Z)(e) ? e : void 0;
        }
        var u = s("./packages/ckeditor5-utils/src/collection.js"),
          g = s("./packages/ckeditor5-utils/src/ckeditorerror.js"),
          p = s("./packages/ckeditor5-utils/src/emittermixin.js"),
          f = s("./packages/ckeditor5-utils/src/mix.js");
        var m = /*#__PURE__*/function () {
          function m(e) {
            var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
            var s = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
            _classCallCheck(this, m);
            this._context = e, this._plugins = new Map(), this._availablePlugins = new Map();
            var _iterator310 = _createForOfIteratorHelper(t),
              _step310;
            try {
              for (_iterator310.s(); !(_step310 = _iterator310.n()).done;) {
                var _e241 = _step310.value;
                _e241.pluginName && this._availablePlugins.set(_e241.pluginName, _e241);
              }
            } catch (err) {
              _iterator310.e(err);
            } finally {
              _iterator310.f();
            }
            this._contextPlugins = new Map();
            var _iterator311 = _createForOfIteratorHelper(s),
              _step311;
            try {
              for (_iterator311.s(); !(_step311 = _iterator311.n()).done;) {
                var _step311$value = _slicedToArray(_step311.value, 2),
                  _e242 = _step311$value[0],
                  _t220 = _step311$value[1];
                this._contextPlugins.set(_e242, _t220), this._contextPlugins.set(_t220, _e242), _e242.pluginName && this._availablePlugins.set(_e242.pluginName, _e242);
              }
            } catch (err) {
              _iterator311.e(err);
            } finally {
              _iterator311.f();
            }
          }
          _createClass(m, [{
            key: Symbol.iterator,
            value: /*#__PURE__*/_regeneratorRuntime().mark(function value() {
              var _iterator312, _step312, _e243;
              return _regeneratorRuntime().wrap(function value$(_context34) {
                while (1) switch (_context34.prev = _context34.next) {
                  case 0:
                    _iterator312 = _createForOfIteratorHelper(this._plugins);
                    _context34.prev = 1;
                    _iterator312.s();
                  case 3:
                    if ((_step312 = _iterator312.n()).done) {
                      _context34.next = 11;
                      break;
                    }
                    _e243 = _step312.value;
                    _context34.t0 = "function" == typeof _e243[0];
                    if (!_context34.t0) {
                      _context34.next = 9;
                      break;
                    }
                    _context34.next = 9;
                    return _e243;
                  case 9:
                    _context34.next = 3;
                    break;
                  case 11:
                    _context34.next = 16;
                    break;
                  case 13:
                    _context34.prev = 13;
                    _context34.t1 = _context34["catch"](1);
                    _iterator312.e(_context34.t1);
                  case 16:
                    _context34.prev = 16;
                    _iterator312.f();
                    return _context34.finish(16);
                  case 19:
                  case "end":
                    return _context34.stop();
                }
              }, value, this, [[1, 13, 16, 19]]);
            })
          }, {
            key: "get",
            value: function get(e) {
              var t = this._plugins.get(e);
              if (!t) {
                var _t221 = e;
                throw "function" == typeof e && (_t221 = e.pluginName || e.name), new g.ZP("plugincollection-plugin-not-loaded", this._context, {
                  plugin: _t221
                });
              }
              return t;
            }
          }, {
            key: "has",
            value: function has(e) {
              return this._plugins.has(e);
            }
          }, {
            key: "init",
            value: function init(e) {
              var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
              var s = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
              var o = this,
                i = this._context;
              !function e(t) {
                var s = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new Set();
                t.forEach(function (t) {
                  a(t) && (s.has(t) || (s.add(t), t.pluginName && !o._availablePlugins.has(t.pluginName) && o._availablePlugins.set(t.pluginName, t), t.requires && e(t.requires, s)));
                });
              }(e), h(e);
              var r = _toConsumableArray(function e(t) {
                var s = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new Set();
                return t.map(function (e) {
                  return a(e) ? e : o._availablePlugins.get(e);
                }).reduce(function (t, o) {
                  return s.has(o) ? t : (s.add(o), o.requires && (h(o.requires, o), e(o.requires, s).forEach(function (e) {
                    return t.add(e);
                  })), t.add(o));
                }, new Set());
              }(e.filter(function (e) {
                return !l(e, t);
              })));
              !function (e, t) {
                var _iterator313 = _createForOfIteratorHelper(t),
                  _step313;
                try {
                  for (_iterator313.s(); !(_step313 = _iterator313.n()).done;) {
                    var _s217 = _step313.value;
                    if ("function" != typeof _s217) throw new g.ZP("plugincollection-replace-plugin-invalid-type", null, {
                      pluginItem: _s217
                    });
                    var _t222 = _s217.pluginName;
                    if (!_t222) throw new g.ZP("plugincollection-replace-plugin-missing-name", null, {
                      pluginItem: _s217
                    });
                    if (_s217.requires && _s217.requires.length) throw new g.ZP("plugincollection-plugin-for-replacing-cannot-have-dependencies", null, {
                      pluginName: _t222
                    });
                    var _i115 = o._availablePlugins.get(_t222);
                    if (!_i115) throw new g.ZP("plugincollection-plugin-for-replacing-not-exist", null, {
                      pluginName: _t222
                    });
                    var _r54 = e.indexOf(_i115);
                    if (-1 === _r54) {
                      if (o._contextPlugins.has(_i115)) return;
                      throw new g.ZP("plugincollection-plugin-for-replacing-not-loaded", null, {
                        pluginName: _t222
                      });
                    }
                    if (_i115.requires && _i115.requires.length) throw new g.ZP("plugincollection-replaced-plugin-cannot-have-dependencies", null, {
                      pluginName: _t222
                    });
                    e.splice(_r54, 1, _s217), o._availablePlugins.set(_t222, _s217);
                  }
                } catch (err) {
                  _iterator313.e(err);
                } finally {
                  _iterator313.f();
                }
              }(r, s);
              var n = function (e) {
                return e.map(function (e) {
                  var t = o._contextPlugins.get(e) || new e(i);
                  return o._add(e, t), t;
                });
              }(r);
              return u(n, "init").then(function () {
                return u(n, "afterInit");
              }).then(function () {
                return n;
              });
              function a(e) {
                return "function" == typeof e;
              }
              function c(e) {
                return a(e) && e.isContextPlugin;
              }
              function l(e, t) {
                return t.some(function (t) {
                  return t === e || d(e) === t || d(t) === e;
                });
              }
              function d(e) {
                return a(e) ? e.pluginName || e.name : e;
              }
              function h(e) {
                var s = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
                e.map(function (e) {
                  return a(e) ? e : o._availablePlugins.get(e) || e;
                }).forEach(function (e) {
                  !function (e, t) {
                    if (a(e)) return;
                    if (t) throw new g.ZP("plugincollection-soft-required", i, {
                      missingPlugin: e,
                      requiredBy: d(t)
                    });
                    throw new g.ZP("plugincollection-plugin-not-found", i, {
                      plugin: e
                    });
                  }(e, s), function (e, t) {
                    if (!c(t)) return;
                    if (c(e)) return;
                    throw new g.ZP("plugincollection-context-required", i, {
                      plugin: d(e),
                      requiredBy: d(t)
                    });
                  }(e, s), function (e, s) {
                    if (!s) return;
                    if (!l(e, t)) return;
                    throw new g.ZP("plugincollection-required", i, {
                      plugin: d(e),
                      requiredBy: d(s)
                    });
                  }(e, s);
                });
              }
              function u(e, t) {
                return e.reduce(function (e, s) {
                  return s[t] ? o._contextPlugins.has(s) ? e : e.then(s[t].bind(s)) : e;
                }, Promise.resolve());
              }
            }
          }, {
            key: "destroy",
            value: function destroy() {
              var e = [];
              var _iterator314 = _createForOfIteratorHelper(this),
                _step314;
              try {
                for (_iterator314.s(); !(_step314 = _iterator314.n()).done;) {
                  var _step314$value = _slicedToArray(_step314.value, 2),
                    _t223 = _step314$value[1];
                  "function" != typeof _t223.destroy || this._contextPlugins.has(_t223) || e.push(_t223.destroy());
                }
              } catch (err) {
                _iterator314.e(err);
              } finally {
                _iterator314.f();
              }
              return Promise.all(e);
            }
          }, {
            key: "_add",
            value: function _add(e, t) {
              this._plugins.set(e, t);
              var s = e.pluginName;
              if (s) {
                if (this._plugins.has(s)) throw new g.ZP("plugincollection-plugin-name-conflict", null, {
                  pluginName: s,
                  plugin1: this._plugins.get(s).constructor,
                  plugin2: e
                });
                this._plugins.set(s, t);
              }
            }
          }]);
          return m;
        }();
        (0, f.Z)(m, p.ZP);
        var k = s("./packages/ckeditor5-utils/src/locale.js");
        var _ = /*#__PURE__*/function () {
          function _(e) {
            _classCallCheck(this, _);
            this.config = new l(e, this.constructor.defaultConfig);
            var t = this.constructor.builtinPlugins;
            this.config.define("plugins", t), this.plugins = new m(this, t);
            var s = this.config.get("language") || {};
            this.locale = new k.Z({
              uiLanguage: "string" == typeof s ? s : s.ui,
              contentLanguage: this.config.get("language.content")
            }), this.t = this.locale.t, this.editors = new u.Z(), this._contextOwner = null;
          }
          _createClass(_, [{
            key: "initPlugins",
            value: function initPlugins() {
              var e = this.config.get("plugins") || [],
                t = this.config.get("substitutePlugins") || [];
              var _iterator315 = _createForOfIteratorHelper(e.concat(t)),
                _step315;
              try {
                for (_iterator315.s(); !(_step315 = _iterator315.n()).done;) {
                  var _s218 = _step315.value;
                  if ("function" != typeof _s218) throw new g.ZP("context-initplugins-constructor-only", null, {
                    Plugin: _s218
                  });
                  if (!0 !== _s218.isContextPlugin) throw new g.ZP("context-initplugins-invalid-plugin", null, {
                    Plugin: _s218
                  });
                }
              } catch (err) {
                _iterator315.e(err);
              } finally {
                _iterator315.f();
              }
              return this.plugins.init(e, [], t);
            }
          }, {
            key: "destroy",
            value: function destroy() {
              var _this151 = this;
              return Promise.all(Array.from(this.editors, function (e) {
                return e.destroy();
              })).then(function () {
                return _this151.plugins.destroy();
              });
            }
          }, {
            key: "_addEditor",
            value: function _addEditor(e, t) {
              if (this._contextOwner) throw new g.ZP("context-addeditor-private-context");
              this.editors.add(e), t && (this._contextOwner = e);
            }
          }, {
            key: "_removeEditor",
            value: function _removeEditor(e) {
              return this.editors.has(e) && this.editors.remove(e), this._contextOwner === e ? this.destroy() : Promise.resolve();
            }
          }, {
            key: "_getEditorConfig",
            value: function _getEditorConfig() {
              var e = {};
              var _iterator316 = _createForOfIteratorHelper(this.config.names()),
                _step316;
              try {
                for (_iterator316.s(); !(_step316 = _iterator316.n()).done;) {
                  var _t224 = _step316.value;
                  ["plugins", "removePlugins", "extraPlugins"].includes(_t224) || (e[_t224] = this.config.get(_t224));
                }
              } catch (err) {
                _iterator316.e(err);
              } finally {
                _iterator316.f();
              }
              return e;
            }
          }], [{
            key: "create",
            value: function create(e) {
              var _this152 = this;
              return new Promise(function (t) {
                var s = new _this152(e);
                t(s.initPlugins().then(function () {
                  return s;
                }));
              });
            }
          }]);
          return _;
        }();
        var b = s("./packages/ckeditor5-core/src/contextplugin.js"),
          w = s("./packages/ckeditor5-engine/src/controller/editingcontroller.js");
        var v = /*#__PURE__*/function () {
          function v() {
            _classCallCheck(this, v);
            this._commands = new Map();
          }
          _createClass(v, [{
            key: "add",
            value: function add(e, t) {
              this._commands.set(e, t);
            }
          }, {
            key: "get",
            value: function get(e) {
              return this._commands.get(e);
            }
          }, {
            key: "execute",
            value: function execute(e) {
              var s = this.get(e);
              if (!s) throw new g.ZP("commandcollection-command-not-found", this, {
                commandName: e
              });
              for (var _len20 = arguments.length, t = new Array(_len20 > 1 ? _len20 - 1 : 0), _key20 = 1; _key20 < _len20; _key20++) {
                t[_key20 - 1] = arguments[_key20];
              }
              return s.execute.apply(s, t);
            }
          }, {
            key: "names",
            value: /*#__PURE__*/_regeneratorRuntime().mark(function names() {
              return _regeneratorRuntime().wrap(function names$(_context35) {
                while (1) switch (_context35.prev = _context35.next) {
                  case 0:
                    return _context35.delegateYield(this._commands.keys(), "t0", 1);
                  case 1:
                  case "end":
                    return _context35.stop();
                }
              }, names, this);
            })
          }, {
            key: "commands",
            value: /*#__PURE__*/_regeneratorRuntime().mark(function commands() {
              return _regeneratorRuntime().wrap(function commands$(_context36) {
                while (1) switch (_context36.prev = _context36.next) {
                  case 0:
                    return _context36.delegateYield(this._commands.values(), "t0", 1);
                  case 1:
                  case "end":
                    return _context36.stop();
                }
              }, commands, this);
            })
          }, {
            key: Symbol.iterator,
            value: function value() {
              return this._commands[Symbol.iterator]();
            }
          }, {
            key: "destroy",
            value: function destroy() {
              var _iterator317 = _createForOfIteratorHelper(this.commands()),
                _step317;
              try {
                for (_iterator317.s(); !(_step317 = _iterator317.n()).done;) {
                  var _e244 = _step317.value;
                  _e244.destroy();
                }
              } catch (err) {
                _iterator317.e(err);
              } finally {
                _iterator317.f();
              }
            }
          }]);
          return v;
        }();
        var y = s("./packages/ckeditor5-engine/src/controller/datacontroller.js"),
          Z = s("./packages/ckeditor5-engine/src/conversion/conversion.js"),
          P = s("./packages/ckeditor5-engine/src/model/model.js"),
          j = s("./packages/ckeditor5-utils/src/keystrokehandler.js");
        var x = /*#__PURE__*/function (_j$Z) {
          _inherits(x, _j$Z);
          function x(e) {
            var _this153;
            _classCallCheck(this, x);
            _this153 = _possibleConstructorReturn(this, _getPrototypeOf(x).call(this)), _this153.editor = e;
            return _this153;
          }
          _createClass(x, [{
            key: "set",
            value: function set(e, t) {
              var _this154 = this;
              var s = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
              if ("string" == typeof t) {
                var _e245 = t;
                t = function t(_t225, s) {
                  _this154.editor.execute(_e245), s();
                };
              }
              _superPropGet(x, "set", this, 3)([e, t, s]);
            }
          }]);
          return x;
        }(j.Z);
        var A = s("./packages/ckeditor5-utils/src/observablemixin.js"),
          T = s("./packages/ckeditor5-engine/src/view/stylesmap.js");
        var C = /*#__PURE__*/function () {
          function C() {
            var _this155 = this;
            var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
            _classCallCheck(this, C);
            var t = e.language || this.constructor.defaultConfig && this.constructor.defaultConfig.language;
            this._context = e.context || new _({
              language: t
            }), this._context._addEditor(this, !e.context);
            var s = Array.from(this.constructor.builtinPlugins || []);
            this.config = new l(e, this.constructor.defaultConfig), this.config.define("plugins", s), this.config.define(this._context._getEditorConfig()), this.plugins = new m(this, s, this._context.plugins), this.locale = this._context.locale, this.t = this.locale.t, this.commands = new v(), this.set("state", "initializing"), this.once("ready", function () {
              return _this155.state = "ready";
            }, {
              priority: "high"
            }), this.once("destroy", function () {
              return _this155.state = "destroyed";
            }, {
              priority: "high"
            }), this.set("isReadOnly", !1), this.model = new P.Z();
            var o = new T.A();
            this.data = new y.Z(this.model, o), this.editing = new w.Z(this.model, o), this.editing.view.document.bind("isReadOnly").to(this), this.conversion = new Z.Z([this.editing.downcastDispatcher, this.data.downcastDispatcher], this.data.upcastDispatcher), this.conversion.addAlias("dataDowncast", this.data.downcastDispatcher), this.conversion.addAlias("editingDowncast", this.editing.downcastDispatcher), this.keystrokes = new x(this), this.keystrokes.listenTo(this.editing.view.document);
          }
          _createClass(C, [{
            key: "initPlugins",
            value: function initPlugins() {
              var e = this.config,
                t = e.get("plugins"),
                s = e.get("removePlugins") || [],
                o = e.get("extraPlugins") || [],
                i = e.get("substitutePlugins") || [];
              return this.plugins.init(t.concat(o), s, i);
            }
          }, {
            key: "destroy",
            value: function destroy() {
              var _this156 = this;
              var e = Promise.resolve();
              return "initializing" == this.state && (e = new Promise(function (e) {
                return _this156.once("ready", e);
              })), e.then(function () {
                _this156.fire("destroy"), _this156.stopListening(), _this156.commands.destroy();
              }).then(function () {
                return _this156.plugins.destroy();
              }).then(function () {
                _this156.model.destroy(), _this156.data.destroy(), _this156.editing.destroy(), _this156.keystrokes.destroy();
              }).then(function () {
                return _this156._context._removeEditor(_this156);
              });
            }
          }, {
            key: "execute",
            value: function execute() {
              try {
                var _this$commands;
                return (_this$commands = this.commands).execute.apply(_this$commands, arguments);
              } catch (e) {
                g.ZP.rethrowUnexpectedError(e, this);
              }
            }
          }, {
            key: "focus",
            value: function focus() {
              this.editing.view.focus();
            }
          }]);
          return C;
        }();
        (0, f.Z)(C, A.Z);
        var E = /*#__PURE__*/function () {
          function E(e) {
            _classCallCheck(this, E);
            this.editor = e, this._components = new Map();
          }
          _createClass(E, [{
            key: "names",
            value: /*#__PURE__*/_regeneratorRuntime().mark(function names() {
              var _iterator318, _step318, _e246;
              return _regeneratorRuntime().wrap(function names$(_context37) {
                while (1) switch (_context37.prev = _context37.next) {
                  case 0:
                    _iterator318 = _createForOfIteratorHelper(this._components.values());
                    _context37.prev = 1;
                    _iterator318.s();
                  case 3:
                    if ((_step318 = _iterator318.n()).done) {
                      _context37.next = 9;
                      break;
                    }
                    _e246 = _step318.value;
                    _context37.next = 7;
                    return _e246.originalName;
                  case 7:
                    _context37.next = 3;
                    break;
                  case 9:
                    _context37.next = 14;
                    break;
                  case 11:
                    _context37.prev = 11;
                    _context37.t0 = _context37["catch"](1);
                    _iterator318.e(_context37.t0);
                  case 14:
                    _context37.prev = 14;
                    _iterator318.f();
                    return _context37.finish(14);
                  case 17:
                  case "end":
                    return _context37.stop();
                }
              }, names, this, [[1, 11, 14, 17]]);
            })
          }, {
            key: "add",
            value: function add(e, t) {
              this._components.set(S(e), {
                callback: t,
                originalName: e
              });
            }
          }, {
            key: "create",
            value: function create(e) {
              if (!this.has(e)) throw new g.ZP("componentfactory-item-missing", this, {
                name: e
              });
              return this._components.get(S(e)).callback(this.editor.locale);
            }
          }, {
            key: "has",
            value: function has(e) {
              return this._components.has(S(e));
            }
          }]);
          return E;
        }();
        function S(e) {
          return String(e).toLowerCase();
        }
        var R = s("./packages/ckeditor5-utils/src/focustracker.js");
        var O = /*#__PURE__*/function () {
          function O(e) {
            var _this157 = this;
            _classCallCheck(this, O);
            this.editor = e, this.componentFactory = new E(e), this.focusTracker = new R.Z(), this.set("viewportOffset", this._readViewportOffsetFromConfig()), this._editableElementsMap = new Map(), this.listenTo(e.editing.view.document, "layoutChanged", function () {
              return _this157.update();
            });
          }
          _createClass(O, [{
            key: "update",
            value: function update() {
              this.fire("update");
            }
          }, {
            key: "destroy",
            value: function destroy() {
              this.stopListening(), this.focusTracker.destroy();
              var _iterator319 = _createForOfIteratorHelper(this._editableElementsMap.values()),
                _step319;
              try {
                for (_iterator319.s(); !(_step319 = _iterator319.n()).done;) {
                  var _e247 = _step319.value;
                  _e247.ckeditorInstance = null;
                }
              } catch (err) {
                _iterator319.e(err);
              } finally {
                _iterator319.f();
              }
              this._editableElementsMap = new Map();
            }
          }, {
            key: "setEditableElement",
            value: function setEditableElement(e, t) {
              this._editableElementsMap.set(e, t), t.ckeditorInstance || (t.ckeditorInstance = this.editor);
            }
          }, {
            key: "getEditableElement",
            value: function getEditableElement() {
              var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "main";
              return this._editableElementsMap.get(e);
            }
          }, {
            key: "getEditableElementsNames",
            value: function getEditableElementsNames() {
              return this._editableElementsMap.keys();
            }
          }, {
            key: "_readViewportOffsetFromConfig",
            value: function _readViewportOffsetFromConfig() {
              var e = this.editor,
                t = e.config.get("ui.viewportOffset");
              if (t) return t;
              var s = e.config.get("toolbar.viewportTopOffset");
              return s ? (console.warn("editor-ui-deprecated-viewport-offset-config: The `toolbar.vieportTopOffset` configuration option is deprecated. It will be removed from future CKEditor versions. Use `ui.viewportOffset.top` instead."), {
                top: s
              }) : {
                top: 0
              };
            }
          }, {
            key: "element",
            get: function get() {
              return null;
            }
          }, {
            key: "_editableElements",
            get: function get() {
              return console.warn("editor-ui-deprecated-editable-elements: The EditorUI#_editableElements property has been deprecated and will be removed in the near future.", {
                editorUI: this
              }), this._editableElementsMap;
            }
          }]);
          return O;
        }();
        (0, f.Z)(O, A.Z);
        var M = s("./node_modules/lodash-es/isFunction.js");
        function N(e) {
          if (!(0, M.Z)(e.updateSourceElement)) throw new g.ZP("attachtoform-missing-elementapi-interface", e);
          var t = e.sourceElement;
          if (t && "textarea" === t.tagName.toLowerCase() && t.form) {
            var _s219;
            var _o142 = t.form,
              _i116 = function _i116() {
                return e.updateSourceElement();
              };
            (0, M.Z)(_o142.submit) && (_s219 = _o142.submit, _o142.submit = function () {
              _i116(), _s219.apply(_o142);
            }), _o142.addEventListener("submit", _i116), e.on("destroy", function () {
              _o142.removeEventListener("submit", _i116), _s219 && (_o142.submit = _s219);
            });
          }
        }
        var I = {
          setData: function setData(e) {
            this.data.set(e);
          },
          getData: function getData(e) {
            return this.data.get(e);
          }
        };
        var z = s("./packages/ckeditor5-utils/src/dom/setdatainelement.js");
        var V = {
          updateSourceElement: function updateSourceElement() {
            if (!this.sourceElement) throw new g.ZP("editor-missing-sourceelement", this);
            (0, z.Z)(this.sourceElement, this.data.get());
          }
        };
        function D(e) {
          var t = e.sourceElement;
          if (t) {
            if (t.ckeditorInstance) throw new g.ZP("editor-source-element-already-used", e);
            t.ckeditorInstance = e, e.once("destroy", function () {
              delete t.ckeditorInstance;
            });
          }
        }
        var B = s("./packages/ckeditor5-core/src/pendingactions.js");
        var F = s("./packages/ckeditor5-core/theme/icons/pilcrow.svg");
        var L = s("./packages/ckeditor5-core/theme/icons/three-vertical-dots.svg");
        var W = {
          cancel: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="m11.591 10.177 4.243 4.242a1 1 0 0 1-1.415 1.415l-4.242-4.243-4.243 4.243a1 1 0 0 1-1.414-1.415l4.243-4.242L4.52 5.934A1 1 0 0 1 5.934 4.52l4.243 4.243 4.242-4.243a1 1 0 1 1 1.415 1.414l-4.243 4.243z"/></svg>',
          caption: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M2 16h9a1 1 0 0 1 0 2H2a1 1 0 0 1 0-2z"/><path d="M17 1a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h14zm0 1.5H3a.5.5 0 0 0-.492.41L2.5 3v9a.5.5 0 0 0 .41.492L3 12.5h14a.5.5 0 0 0 .492-.41L17.5 12V3a.5.5 0 0 0-.41-.492L17 2.5z" fill-opacity=".6"/></svg>',
          check: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M6.972 16.615a.997.997 0 0 1-.744-.292l-4.596-4.596a1 1 0 1 1 1.414-1.414l3.926 3.926 9.937-9.937a1 1 0 0 1 1.414 1.415L7.717 16.323a.997.997 0 0 1-.745.292z"/></svg>',
          cog: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="m11.333 2 .19 2.263a5.899 5.899 0 0 1 1.458.604L14.714 3.4 16.6 5.286l-1.467 1.733c.263.452.468.942.605 1.46L18 8.666v2.666l-2.263.19a5.899 5.899 0 0 1-.604 1.458l1.467 1.733-1.886 1.886-1.733-1.467a5.899 5.899 0 0 1-1.46.605L11.334 18H8.667l-.19-2.263a5.899 5.899 0 0 1-1.458-.604L5.286 16.6 3.4 14.714l1.467-1.733a5.899 5.899 0 0 1-.604-1.458L2 11.333V8.667l2.262-.189a5.899 5.899 0 0 1 .605-1.459L3.4 5.286 5.286 3.4l1.733 1.467a5.899 5.899 0 0 1 1.46-.605L8.666 2h2.666zM10 6.267a3.733 3.733 0 1 0 0 7.466 3.733 3.733 0 0 0 0-7.466z"/></svg>',
          eraser: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="m8.636 9.531-2.758 3.94a.5.5 0 0 0 .122.696l3.224 2.284h1.314l2.636-3.736L8.636 9.53zm.288 8.451L5.14 15.396a2 2 0 0 1-.491-2.786l6.673-9.53a2 2 0 0 1 2.785-.49l3.742 2.62a2 2 0 0 1 .491 2.785l-7.269 10.053-2.147-.066z"/><path d="M4 18h5.523v-1H4zm-2 0h1v-1H2z"/></svg>',
          lowVision: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M5.085 6.22 2.943 4.078a.75.75 0 1 1 1.06-1.06l2.592 2.59A11.094 11.094 0 0 1 10 5.068c4.738 0 8.578 3.101 8.578 5.083 0 1.197-1.401 2.803-3.555 3.887l1.714 1.713a.75.75 0 0 1-.09 1.138.488.488 0 0 1-.15.084.75.75 0 0 1-.821-.16L6.17 7.304c-.258.11-.51.233-.757.365l6.239 6.24-.006.005.78.78c-.388.094-.78.166-1.174.215l-1.11-1.11h.011L4.55 8.197a7.2 7.2 0 0 0-.665.514l-.112.098 4.897 4.897-.005.006 1.276 1.276a10.164 10.164 0 0 1-1.477-.117l-.479-.479-.009.009-4.863-4.863-.022.031a2.563 2.563 0 0 0-.124.2c-.043.077-.08.158-.108.241a.534.534 0 0 0-.028.133.29.29 0 0 0 .008.072.927.927 0 0 0 .082.226c.067.133.145.26.234.379l3.242 3.365.025.01.59.623c-3.265-.918-5.59-3.155-5.59-4.668 0-1.194 1.448-2.838 3.663-3.93zm7.07.531a4.632 4.632 0 0 1 1.108 5.992l.345.344.046-.018a9.313 9.313 0 0 0 2-1.112c.256-.187.5-.392.727-.613.137-.134.27-.277.392-.431.072-.091.141-.185.203-.286.057-.093.107-.19.148-.292a.72.72 0 0 0 .036-.12.29.29 0 0 0 .008-.072.492.492 0 0 0-.028-.133.999.999 0 0 0-.036-.096 2.165 2.165 0 0 0-.071-.145 2.917 2.917 0 0 0-.125-.2 3.592 3.592 0 0 0-.263-.335 5.444 5.444 0 0 0-.53-.523 7.955 7.955 0 0 0-1.054-.768 9.766 9.766 0 0 0-1.879-.891c-.337-.118-.68-.219-1.027-.301zm-2.85.21-.069.002a.508.508 0 0 0-.254.097.496.496 0 0 0-.104.679.498.498 0 0 0 .326.199l.045.005c.091.003.181.003.272.012a2.45 2.45 0 0 1 2.017 1.513c.024.061.043.125.069.185a.494.494 0 0 0 .45.287h.008a.496.496 0 0 0 .35-.158.482.482 0 0 0 .13-.335.638.638 0 0 0-.048-.219 3.379 3.379 0 0 0-.36-.723 3.438 3.438 0 0 0-2.791-1.543l-.028-.001h-.013z"/></svg>',
          image: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M6.91 10.54c.26-.23.64-.21.88.03l3.36 3.14 2.23-2.06a.64.64 0 0 1 .87 0l2.52 2.97V4.5H3.2v10.12l3.71-4.08zm10.27-7.51c.6 0 1.09.47 1.09 1.05v11.84c0 .59-.49 1.06-1.09 1.06H2.79c-.6 0-1.09-.47-1.09-1.06V4.08c0-.58.49-1.05 1.1-1.05h14.38zm-5.22 5.56a1.96 1.96 0 1 1 3.4-1.96 1.96 1.96 0 0 1-3.4 1.96z"/></svg>',
          alignBottom: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="m9.239 13.938-2.88-1.663a.75.75 0 0 1 .75-1.3L9 12.067V4.75a.75.75 0 1 1 1.5 0v7.318l1.89-1.093a.75.75 0 0 1 .75 1.3l-2.879 1.663a.752.752 0 0 1-.511.187.752.752 0 0 1-.511-.187zM4.25 17a.75.75 0 1 1 0-1.5h10.5a.75.75 0 0 1 0 1.5H4.25z"/></svg>',
          alignMiddle: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M9.75 11.875a.752.752 0 0 1 .508.184l2.883 1.666a.75.75 0 0 1-.659 1.344l-.091-.044-1.892-1.093.001 4.318a.75.75 0 1 1-1.5 0v-4.317l-1.89 1.092a.75.75 0 0 1-.75-1.3l2.879-1.663a.752.752 0 0 1 .51-.187zM15.25 9a.75.75 0 1 1 0 1.5H4.75a.75.75 0 1 1 0-1.5h10.5zM9.75.375a.75.75 0 0 1 .75.75v4.318l1.89-1.093.092-.045a.75.75 0 0 1 .659 1.344l-2.883 1.667a.752.752 0 0 1-.508.184.752.752 0 0 1-.511-.187L6.359 5.65a.75.75 0 0 1 .75-1.299L9 5.442V1.125a.75.75 0 0 1 .75-.75z"/></svg>',
          alignTop: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="m10.261 7.062 2.88 1.663a.75.75 0 0 1-.75 1.3L10.5 8.933v7.317a.75.75 0 1 1-1.5 0V8.932l-1.89 1.093a.75.75 0 0 1-.75-1.3l2.879-1.663a.752.752 0 0 1 .511-.187.752.752 0 0 1 .511.187zM15.25 4a.75.75 0 1 1 0 1.5H4.75a.75.75 0 0 1 0-1.5h10.5z"/></svg>',
          alignLeft: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M2 3.75c0 .414.336.75.75.75h14.5a.75.75 0 1 0 0-1.5H2.75a.75.75 0 0 0-.75.75zm0 8c0 .414.336.75.75.75h14.5a.75.75 0 1 0 0-1.5H2.75a.75.75 0 0 0-.75.75zm0 4c0 .414.336.75.75.75h9.929a.75.75 0 1 0 0-1.5H2.75a.75.75 0 0 0-.75.75zm0-8c0 .414.336.75.75.75h9.929a.75.75 0 1 0 0-1.5H2.75a.75.75 0 0 0-.75.75z"/></svg>',
          alignCenter: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M2 3.75c0 .414.336.75.75.75h14.5a.75.75 0 1 0 0-1.5H2.75a.75.75 0 0 0-.75.75zm0 8c0 .414.336.75.75.75h14.5a.75.75 0 1 0 0-1.5H2.75a.75.75 0 0 0-.75.75zm2.286 4c0 .414.336.75.75.75h9.928a.75.75 0 1 0 0-1.5H5.036a.75.75 0 0 0-.75.75zm0-8c0 .414.336.75.75.75h9.928a.75.75 0 1 0 0-1.5H5.036a.75.75 0 0 0-.75.75z"/></svg>',
          alignRight: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M18 3.75a.75.75 0 0 1-.75.75H2.75a.75.75 0 1 1 0-1.5h14.5a.75.75 0 0 1 .75.75zm0 8a.75.75 0 0 1-.75.75H2.75a.75.75 0 1 1 0-1.5h14.5a.75.75 0 0 1 .75.75zm0 4a.75.75 0 0 1-.75.75H7.321a.75.75 0 1 1 0-1.5h9.929a.75.75 0 0 1 .75.75zm0-8a.75.75 0 0 1-.75.75H7.321a.75.75 0 1 1 0-1.5h9.929a.75.75 0 0 1 .75.75z"/></svg>',
          alignJustify: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M2 3.75c0 .414.336.75.75.75h14.5a.75.75 0 1 0 0-1.5H2.75a.75.75 0 0 0-.75.75zm0 8c0 .414.336.75.75.75h14.5a.75.75 0 1 0 0-1.5H2.75a.75.75 0 0 0-.75.75zm0 4c0 .414.336.75.75.75h9.929a.75.75 0 1 0 0-1.5H2.75a.75.75 0 0 0-.75.75zm0-8c0 .414.336.75.75.75h14.5a.75.75 0 1 0 0-1.5H2.75a.75.75 0 0 0-.75.75z"/></svg>',
          objectLeft: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path opacity=".5" d="M2 3h16v1.5H2zm11.5 9H18v1.5h-4.5zm0-3H18v1.5h-4.5zm0-3H18v1.5h-4.5zM2 15h16v1.5H2z"/><path d="M12.003 7v5.5a1 1 0 0 1-1 1H2.996a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h8.007a1 1 0 0 1 1 1zm-1.506.5H3.5V12h6.997V7.5z"/></svg>',
          objectCenter: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path opacity=".5" d="M2 3h16v1.5H2zm0 12h16v1.5H2z"/><path d="M15.003 7v5.5a1 1 0 0 1-1 1H5.996a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h8.007a1 1 0 0 1 1 1zm-1.506.5H6.5V12h6.997V7.5z"/></svg>',
          objectRight: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path opacity=".5" d="M2 3h16v1.5H2zm0 12h16v1.5H2zm0-9h5v1.5H2zm0 3h5v1.5H2zm0 3h5v1.5H2z"/><path d="M18.003 7v5.5a1 1 0 0 1-1 1H8.996a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h8.007a1 1 0 0 1 1 1zm-1.506.5H9.5V12h6.997V7.5z"/></svg>',
          objectFullWidth: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path opacity=".5" d="M2 3h16v1.5H2zm0 12h16v1.5H2z"/><path d="M18 7v5.5a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1zm-1.505.5H3.504V12h12.991V7.5z"/></svg>',
          objectInline: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path opacity=".5" d="M2 3h16v1.5H2zm11.5 9H18v1.5h-4.5zM2 15h16v1.5H2z"/><path d="M12.003 7v5.5a1 1 0 0 1-1 1H2.996a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h8.007a1 1 0 0 1 1 1zm-1.506.5H3.5V12h6.997V7.5z"/></svg>',
          objectBlockLeft: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path opacity=".5" d="M2 3h16v1.5H2zm0 12h16v1.5H2z"/><path d="M12.003 7v5.5a1 1 0 0 1-1 1H2.996a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h8.007a1 1 0 0 1 1 1zm-1.506.5H3.5V12h6.997V7.5z"/></svg>',
          objectBlockRight: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path opacity=".5" d="M2 3h16v1.5H2zm0 12h16v1.5H2z"/><path d="M18.003 7v5.5a1 1 0 0 1-1 1H8.996a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h8.007a1 1 0 0 1 1 1zm-1.506.5H9.5V12h6.997V7.5z"/></svg>',
          objectSizeFull: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M2.5 17v1h-1v-1h1zm2 0v1h-1v-1h1zm2 0v1h-1v-1h1zm2 0v1h-1v-1h1zm2 0v1h-1v-1h1zm2 0v1h-1v-1h1zm2 0v1h-1v-1h1zm2 0v1h-1v-1h1zm2 0v1h-1v-1h1zM1 15.5v1H0v-1h1zm19 0v1h-1v-1h1zm-19-2v1H0v-1h1zm19 0v1h-1v-1h1zm-19-2v1H0v-1h1zm19 0v1h-1v-1h1zm-19-2v1H0v-1h1zm19 0v1h-1v-1h1zm-19-2v1H0v-1h1zm19 0v1h-1v-1h1zm-19-2v1H0v-1h1zm19 0v1h-1v-1h1zm0-2v1h-1v-1h1zm-19 0v1H0v-1h1zM14.5 2v1h-1V2h1zm2 0v1h-1V2h1zm2 0v1h-1V2h1zm-8 0v1h-1V2h1zm-2 0v1h-1V2h1zm-2 0v1h-1V2h1zm-2 0v1h-1V2h1zm8 0v1h-1V2h1zm-10 0v1h-1V2h1z"/><path d="M18.095 2H1.905C.853 2 0 2.895 0 4v12c0 1.105.853 2 1.905 2h16.19C19.147 18 20 17.105 20 16V4c0-1.105-.853-2-1.905-2zm0 1.5c.263 0 .476.224.476.5v12c0 .276-.213.5-.476.5H1.905a.489.489 0 0 1-.476-.5V4c0-.276.213-.5.476-.5h16.19z"/></svg>',
          objectSizeLarge: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M2.5 17v1h-1v-1h1zm2 0v1h-1v-1h1zm2 0v1h-1v-1h1zm2 0v1h-1v-1h1zm2 0v1h-1v-1h1zm2 0v1h-1v-1h1zm2 0v1h-1v-1h1zm2 0v1h-1v-1h1zm2 0v1h-1v-1h1zM1 15.5v1H0v-1h1zm19 0v1h-1v-1h1zm-19-2v1H0v-1h1zm19 0v1h-1v-1h1zm-19-2v1H0v-1h1zm19 0v1h-1v-1h1zm-19-2v1H0v-1h1zm19 0v1h-1v-1h1zm-19-2v1H0v-1h1zm19 0v1h-1v-1h1zm-19-2v1H0v-1h1zm19 0v1h-1v-1h1zm0-2v1h-1v-1h1zm-19 0v1H0v-1h1zM14.5 2v1h-1V2h1zm2 0v1h-1V2h1zm2 0v1h-1V2h1zm-8 0v1h-1V2h1zm-2 0v1h-1V2h1zm-2 0v1h-1V2h1zm-2 0v1h-1V2h1zm8 0v1h-1V2h1zm-10 0v1h-1V2h1z"/><path d="M13 6H2a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h11a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2zm0 1.5a.5.5 0 0 1 .5.5v8a.5.5 0 0 1-.5.5H2a.5.5 0 0 1-.5-.5V8a.5.5 0 0 1 .5-.5h11z"/></svg>',
          objectSizeSmall: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M2.5 17v1h-1v-1h1zm2 0v1h-1v-1h1zm2 0v1h-1v-1h1zm2 0v1h-1v-1h1zm2 0v1h-1v-1h1zm2 0v1h-1v-1h1zm2 0v1h-1v-1h1zm2 0v1h-1v-1h1zm2 0v1h-1v-1h1zM1 15.5v1H0v-1h1zm19 0v1h-1v-1h1zm-19-2v1H0v-1h1zm19 0v1h-1v-1h1zm-19-2v1H0v-1h1zm19 0v1h-1v-1h1zm-19-2v1H0v-1h1zm19 0v1h-1v-1h1zm-19-2v1H0v-1h1zm19 0v1h-1v-1h1zm-19-2v1H0v-1h1zm19 0v1h-1v-1h1zm0-2v1h-1v-1h1zm-19 0v1H0v-1h1zM14.5 2v1h-1V2h1zm2 0v1h-1V2h1zm2 0v1h-1V2h1zm-8 0v1h-1V2h1zm-2 0v1h-1V2h1zm-2 0v1h-1V2h1zm-2 0v1h-1V2h1zm8 0v1h-1V2h1zm-10 0v1h-1V2h1z"/><path d="M7 10H2a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2h5a2 2 0 0 0 2-2v-4a2 2 0 0 0-2-2zm0 1.5a.5.5 0 0 1 .5.5v4a.5.5 0 0 1-.5.5H2a.5.5 0 0 1-.5-.5v-4a.5.5 0 0 1 .5-.5h5z"/></svg>',
          objectSizeMedium: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M2.5 17v1h-1v-1h1zm2 0v1h-1v-1h1zm2 0v1h-1v-1h1zm2 0v1h-1v-1h1zm2 0v1h-1v-1h1zm2 0v1h-1v-1h1zm2 0v1h-1v-1h1zm2 0v1h-1v-1h1zm2 0v1h-1v-1h1zM1 15.5v1H0v-1h1zm19 0v1h-1v-1h1zm-19-2v1H0v-1h1zm19 0v1h-1v-1h1zm-19-2v1H0v-1h1zm19 0v1h-1v-1h1zm-19-2v1H0v-1h1zm19 0v1h-1v-1h1zm-19-2v1H0v-1h1zm19 0v1h-1v-1h1zm-19-2v1H0v-1h1zm19 0v1h-1v-1h1zm0-2v1h-1v-1h1zm-19 0v1H0v-1h1zM14.5 2v1h-1V2h1zm2 0v1h-1V2h1zm2 0v1h-1V2h1zm-8 0v1h-1V2h1zm-2 0v1h-1V2h1zm-2 0v1h-1V2h1zm-2 0v1h-1V2h1zm8 0v1h-1V2h1zm-10 0v1h-1V2h1z"/><path d="M10 8H2a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2v-6a2 2 0 0 0-2-2zm0 1.5a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-.5.5H2a.5.5 0 0 1-.5-.5v-6a.5.5 0 0 1 .5-.5h8z"/></svg>',
          pencil: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="m7.3 17.37-.061.088a1.518 1.518 0 0 1-.934.535l-4.178.663-.806-4.153a1.495 1.495 0 0 1 .187-1.058l.056-.086L8.77 2.639c.958-1.351 2.803-1.076 4.296-.03 1.497 1.047 2.387 2.693 1.433 4.055L7.3 17.37zM9.14 4.728l-5.545 8.346 3.277 2.294 5.544-8.346L9.14 4.728zM6.07 16.512l-3.276-2.295.53 2.73 2.746-.435zM9.994 3.506 13.271 5.8c.316-.452-.16-1.333-1.065-1.966-.905-.634-1.895-.78-2.212-.328zM8 18.5 9.375 17H19v1.5H8z"/></svg>',
          pilcrow: F.Z,
          quote: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M3 10.423a6.5 6.5 0 0 1 6.056-6.408l.038.67C6.448 5.423 5.354 7.663 5.22 10H9c.552 0 .5.432.5.986v4.511c0 .554-.448.503-1 .503h-5c-.552 0-.5-.449-.5-1.003v-4.574zm8 0a6.5 6.5 0 0 1 6.056-6.408l.038.67c-2.646.739-3.74 2.979-3.873 5.315H17c.552 0 .5.432.5.986v4.511c0 .554-.448.503-1 .503h-5c-.552 0-.5-.449-.5-1.003v-4.574z"/></svg>',
          threeVerticalDots: L.Z
        };
      },
      "./src/engine.js": function _src_engineJs(e, t, s) {
        "use strict";

        s.r(t), s.d(t, {
          ClickObserver: function ClickObserver() {
            return V;
          },
          Conversion: function Conversion() {
            return _.Z;
          },
          DataController: function DataController() {
            return k.Z;
          },
          DocumentSelection: function DocumentSelection() {
            return P.Z;
          },
          DomConverter: function DomConverter() {
            return R.Z;
          },
          DomEventData: function DomEventData() {
            return J.Z;
          },
          DomEventObserver: function DomEventObserver() {
            return z.Z;
          },
          DowncastWriter: function DowncastWriter() {
            return B.Z;
          },
          EditingController: function EditingController() {
            return m.Z;
          },
          Element: function Element() {
            return E.Z;
          },
          History: function History() {
            return S.Z;
          },
          HtmlDataProcessor: function HtmlDataProcessor() {
            return b.Z;
          },
          InsertOperation: function InsertOperation() {
            return w.Z;
          },
          LivePosition: function LivePosition() {
            return A.Z;
          },
          LiveRange: function LiveRange() {
            return x.Z;
          },
          MarkerOperation: function MarkerOperation() {
            return v.Z;
          },
          Matcher: function Matcher() {
            return G.Z;
          },
          Model: function Model() {
            return T.Z;
          },
          MouseObserver: function MouseObserver() {
            return D.Z;
          },
          Observer: function Observer() {
            return I.Z;
          },
          OperationFactory: function OperationFactory() {
            return y.Z;
          },
          Range: function Range() {
            return j.Z;
          },
          Renderer: function Renderer() {
            return O.Z;
          },
          StylesProcessor: function StylesProcessor() {
            return X.A;
          },
          TreeWalker: function TreeWalker() {
            return C.Z;
          },
          UpcastWriter: function UpcastWriter() {
            return K;
          },
          ViewDocument: function ViewDocument() {
            return M.Z;
          },
          addBackgroundRules: function addBackgroundRules() {
            return Pe;
          },
          addBorderRules: function addBorderRules() {
            return xe;
          },
          addMarginRules: function addMarginRules() {
            return ze;
          },
          addPaddingRules: function addPaddingRules() {
            return Ve;
          },
          disablePlaceholder: function disablePlaceholder() {
            return l;
          },
          enablePlaceholder: function enablePlaceholder() {
            return c;
          },
          getBoxSidesShorthandValue: function getBoxSidesShorthandValue() {
            return ve;
          },
          getBoxSidesValueReducer: function getBoxSidesValueReducer() {
            return we;
          },
          getBoxSidesValues: function getBoxSidesValues() {
            return be;
          },
          getFillerOffset: function getFillerOffset() {
            return N.Y;
          },
          getPositionShorthandNormalizer: function getPositionShorthandNormalizer() {
            return ye;
          },
          getShorthandValues: function getShorthandValues() {
            return Ze;
          },
          hidePlaceholder: function hidePlaceholder() {
            return h;
          },
          isAttachment: function isAttachment() {
            return me;
          },
          isColor: function isColor() {
            return ie;
          },
          isLength: function isLength() {
            return ce;
          },
          isLineStyle: function isLineStyle() {
            return ne;
          },
          isPercentage: function isPercentage() {
            return de;
          },
          isPosition: function isPosition() {
            return pe;
          },
          isRepeat: function isRepeat() {
            return ue;
          },
          isURL: function isURL() {
            return _e;
          },
          needsPlaceholder: function needsPlaceholder() {
            return u;
          },
          showPlaceholder: function showPlaceholder() {
            return d;
          },
          transformSets: function transformSets() {
            return Z.R;
          }
        });
        var o = s("./node_modules/style-loader/dist/runtime/injectStylesIntoStyleTag.js"),
          i = s.n(o),
          r = s("./node_modules/css-loader/dist/cjs.js!./node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].use[2]!./packages/ckeditor5-engine/theme/placeholder.css"),
          n = {
            injectType: "singletonStyleTag",
            attributes: {
              "data-cke": !0
            },
            insert: "head",
            singleton: !0
          };
        i()(r.Z, n);
        r.Z.locals;
        var a = new WeakMap();
        function c(e) {
          var t = e.view,
            s = e.element,
            o = e.text,
            _e$isDirectHost = e.isDirectHost,
            i = _e$isDirectHost === void 0 ? !0 : _e$isDirectHost,
            _e$keepOnFocus = e.keepOnFocus,
            r = _e$keepOnFocus === void 0 ? !1 : _e$keepOnFocus,
            n = t.document;
          a.has(n) || (a.set(n, new Map()), n.registerPostFixer(function (e) {
            return g(n, e);
          })), a.get(n).set(s, {
            text: o,
            isDirectHost: i,
            keepOnFocus: r,
            hostElement: i ? s : null
          }), t.change(function (e) {
            return g(n, e);
          });
        }
        function l(e, t) {
          var s = t.document;
          e.change(function (e) {
            if (!a.has(s)) return;
            var o = a.get(s),
              i = o.get(t);
            e.removeAttribute("data-placeholder", i.hostElement), h(e, i.hostElement), o.delete(t);
          });
        }
        function d(e, t) {
          return !t.hasClass("ck-placeholder") && (e.addClass("ck-placeholder", t), !0);
        }
        function h(e, t) {
          return !!t.hasClass("ck-placeholder") && (e.removeClass("ck-placeholder", t), !0);
        }
        function u(e, t) {
          if (!e.isAttached()) return !1;
          var s = Array.from(e.getChildren()).some(function (e) {
            return !e.is("uiElement");
          });
          if (s) return !1;
          if (t) return !0;
          var o = e.document;
          if (!o.isFocused) return !0;
          var i = o.selection.anchor;
          return i && i.parent !== e;
        }
        function g(e, t) {
          var s = a.get(e),
            o = [];
          var i = !1;
          var _iterator320 = _createForOfIteratorHelper(s),
            _step320;
          try {
            for (_iterator320.s(); !(_step320 = _iterator320.n()).done;) {
              var _step320$value = _slicedToArray(_step320.value, 2),
                _e248 = _step320$value[0],
                _r55 = _step320$value[1];
              _r55.isDirectHost && (o.push(_e248), p(t, _e248, _r55) && (i = !0));
            }
          } catch (err) {
            _iterator320.e(err);
          } finally {
            _iterator320.f();
          }
          var _iterator321 = _createForOfIteratorHelper(s),
            _step321;
          try {
            for (_iterator321.s(); !(_step321 = _iterator321.n()).done;) {
              var _step321$value = _slicedToArray(_step321.value, 2),
                _e249 = _step321$value[0],
                _r56 = _step321$value[1];
              if (_r56.isDirectHost) continue;
              var _s220 = f(_e249);
              _s220 && (o.includes(_s220) || (_r56.hostElement = _s220, p(t, _e249, _r56) && (i = !0)));
            }
          } catch (err) {
            _iterator321.e(err);
          } finally {
            _iterator321.f();
          }
          return i;
        }
        function p(e, t, s) {
          var o = s.text,
            i = s.isDirectHost,
            r = s.hostElement;
          var n = !1;
          r.getAttribute("data-placeholder") !== o && (e.setAttribute("data-placeholder", o, r), n = !0);
          return (i || 1 == t.childCount) && u(r, s.keepOnFocus) ? d(e, r) && (n = !0) : h(e, r) && (n = !0), n;
        }
        function f(e) {
          if (e.childCount) {
            var _t226 = e.getChild(0);
            if (_t226.is("element") && !_t226.is("uiElement")) return _t226;
          }
          return null;
        }
        var m = s("./packages/ckeditor5-engine/src/controller/editingcontroller.js"),
          k = s("./packages/ckeditor5-engine/src/controller/datacontroller.js"),
          _ = s("./packages/ckeditor5-engine/src/conversion/conversion.js"),
          b = s("./packages/ckeditor5-engine/src/dataprocessor/htmldataprocessor.js"),
          w = s("./packages/ckeditor5-engine/src/model/operation/insertoperation.js"),
          v = s("./packages/ckeditor5-engine/src/model/operation/markeroperation.js"),
          y = s("./packages/ckeditor5-engine/src/model/operation/operationfactory.js"),
          Z = s("./packages/ckeditor5-engine/src/model/operation/transform.js"),
          P = s("./packages/ckeditor5-engine/src/model/documentselection.js"),
          j = s("./packages/ckeditor5-engine/src/model/range.js"),
          x = s("./packages/ckeditor5-engine/src/model/liverange.js"),
          A = s("./packages/ckeditor5-engine/src/model/liveposition.js"),
          T = s("./packages/ckeditor5-engine/src/model/model.js"),
          C = s("./packages/ckeditor5-engine/src/model/treewalker.js"),
          E = s("./packages/ckeditor5-engine/src/model/element.js"),
          S = s("./packages/ckeditor5-engine/src/model/history.js"),
          R = s("./packages/ckeditor5-engine/src/view/domconverter.js"),
          O = s("./packages/ckeditor5-engine/src/view/renderer.js"),
          M = s("./packages/ckeditor5-engine/src/view/document.js"),
          N = s("./packages/ckeditor5-engine/src/view/containerelement.js"),
          I = s("./packages/ckeditor5-engine/src/view/observer/observer.js"),
          z = s("./packages/ckeditor5-engine/src/view/observer/domeventobserver.js");
        var V = /*#__PURE__*/function (_z$Z) {
          _inherits(V, _z$Z);
          function V(e) {
            var _this158;
            _classCallCheck(this, V);
            _this158 = _possibleConstructorReturn(this, _getPrototypeOf(V).call(this, e)), _this158.domEventType = "click";
            return _this158;
          }
          _createClass(V, [{
            key: "onDomEvent",
            value: function onDomEvent(e) {
              this.fire(e.type, e);
            }
          }]);
          return V;
        }(z.Z);
        var D = s("./packages/ckeditor5-engine/src/view/observer/mouseobserver.js"),
          B = s("./packages/ckeditor5-engine/src/view/downcastwriter.js"),
          F = s("./packages/ckeditor5-engine/src/view/documentfragment.js"),
          L = s("./packages/ckeditor5-engine/src/view/element.js"),
          W = s("./packages/ckeditor5-engine/src/view/text.js"),
          q = s("./node_modules/lodash-es/isPlainObject.js"),
          H = s("./packages/ckeditor5-engine/src/view/position.js"),
          $ = s("./packages/ckeditor5-engine/src/view/range.js"),
          U = s("./packages/ckeditor5-engine/src/view/selection.js");
        var K = /*#__PURE__*/function () {
          function K(e) {
            _classCallCheck(this, K);
            this.document = e;
          }
          _createClass(K, [{
            key: "createDocumentFragment",
            value: function createDocumentFragment(e) {
              return new F.Z(this.document, e);
            }
          }, {
            key: "createElement",
            value: function createElement(e, t, s) {
              return new L.Z(this.document, e, t, s);
            }
          }, {
            key: "createText",
            value: function createText(e) {
              return new W.Z(this.document, e);
            }
          }, {
            key: "clone",
            value: function clone(e) {
              var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
              return e._clone(t);
            }
          }, {
            key: "appendChild",
            value: function appendChild(e, t) {
              return t._appendChild(e);
            }
          }, {
            key: "insertChild",
            value: function insertChild(e, t, s) {
              return s._insertChild(e, t);
            }
          }, {
            key: "removeChildren",
            value: function removeChildren(e, t, s) {
              return s._removeChildren(e, t);
            }
          }, {
            key: "remove",
            value: function remove(e) {
              var t = e.parent;
              return t ? this.removeChildren(t.getChildIndex(e), 1, t) : [];
            }
          }, {
            key: "replace",
            value: function replace(e, t) {
              var s = e.parent;
              if (s) {
                var _o143 = s.getChildIndex(e);
                return this.removeChildren(_o143, 1, s), this.insertChild(_o143, t, s), !0;
              }
              return !1;
            }
          }, {
            key: "unwrapElement",
            value: function unwrapElement(e) {
              var t = e.parent;
              if (t) {
                var _s221 = t.getChildIndex(e);
                this.remove(e), this.insertChild(_s221, e.getChildren(), t);
              }
            }
          }, {
            key: "rename",
            value: function rename(e, t) {
              var s = new L.Z(this.document, e, t.getAttributes(), t.getChildren());
              return this.replace(t, s) ? s : null;
            }
          }, {
            key: "setAttribute",
            value: function setAttribute(e, t, s) {
              s._setAttribute(e, t);
            }
          }, {
            key: "removeAttribute",
            value: function removeAttribute(e, t) {
              t._removeAttribute(e);
            }
          }, {
            key: "addClass",
            value: function addClass(e, t) {
              t._addClass(e);
            }
          }, {
            key: "removeClass",
            value: function removeClass(e, t) {
              t._removeClass(e);
            }
          }, {
            key: "setStyle",
            value: function setStyle(e, t, s) {
              (0, q.Z)(e) && void 0 === s && (s = t), s._setStyle(e, t);
            }
          }, {
            key: "removeStyle",
            value: function removeStyle(e, t) {
              t._removeStyle(e);
            }
          }, {
            key: "setCustomProperty",
            value: function setCustomProperty(e, t, s) {
              s._setCustomProperty(e, t);
            }
          }, {
            key: "removeCustomProperty",
            value: function removeCustomProperty(e, t) {
              return t._removeCustomProperty(e);
            }
          }, {
            key: "createPositionAt",
            value: function createPositionAt(e, t) {
              return H.Z._createAt(e, t);
            }
          }, {
            key: "createPositionAfter",
            value: function createPositionAfter(e) {
              return H.Z._createAfter(e);
            }
          }, {
            key: "createPositionBefore",
            value: function createPositionBefore(e) {
              return H.Z._createBefore(e);
            }
          }, {
            key: "createRange",
            value: function createRange(e, t) {
              return new $.Z(e, t);
            }
          }, {
            key: "createRangeOn",
            value: function createRangeOn(e) {
              return $.Z._createOn(e);
            }
          }, {
            key: "createRangeIn",
            value: function createRangeIn(e) {
              return $.Z._createIn(e);
            }
          }, {
            key: "createSelection",
            value: function createSelection(e, t, s) {
              return new U.Z(e, t, s);
            }
          }]);
          return K;
        }();
        var G = s("./packages/ckeditor5-engine/src/view/matcher.js"),
          J = s("./packages/ckeditor5-engine/src/view/observer/domeventdata.js"),
          X = s("./packages/ckeditor5-engine/src/view/stylesmap.js");
        var Q = /^#([0-9a-f]{3,4}|[0-9a-f]{6}|[0-9a-f]{8})$/i,
          Y = /^rgb\([ ]?([0-9]{1,3}[ %]?,[ ]?){2,3}[0-9]{1,3}[ %]?\)$/i,
          ee = /^rgba\([ ]?([0-9]{1,3}[ %]?,[ ]?){3}(1|[0-9]+%|[0]?\.?[0-9]+)\)$/i,
          te = /^hsl\([ ]?([0-9]{1,3}[ %]?[,]?[ ]*){3}(1|[0-9]+%|[0]?\.?[0-9]+)?\)$/i,
          se = /^hsla\([ ]?([0-9]{1,3}[ %]?,[ ]?){2,3}(1|[0-9]+%|[0]?\.?[0-9]+)\)$/i,
          oe = new Set(["black", "silver", "gray", "white", "maroon", "red", "purple", "fuchsia", "green", "lime", "olive", "yellow", "navy", "blue", "teal", "aqua", "orange", "aliceblue", "antiquewhite", "aquamarine", "azure", "beige", "bisque", "blanchedalmond", "blueviolet", "brown", "burlywood", "cadetblue", "chartreuse", "chocolate", "coral", "cornflowerblue", "cornsilk", "crimson", "cyan", "darkblue", "darkcyan", "darkgoldenrod", "darkgray", "darkgreen", "darkgrey", "darkkhaki", "darkmagenta", "darkolivegreen", "darkorange", "darkorchid", "darkred", "darksalmon", "darkseagreen", "darkslateblue", "darkslategray", "darkslategrey", "darkturquoise", "darkviolet", "deeppink", "deepskyblue", "dimgray", "dimgrey", "dodgerblue", "firebrick", "floralwhite", "forestgreen", "gainsboro", "ghostwhite", "gold", "goldenrod", "greenyellow", "grey", "honeydew", "hotpink", "indianred", "indigo", "ivory", "khaki", "lavender", "lavenderblush", "lawngreen", "lemonchiffon", "lightblue", "lightcoral", "lightcyan", "lightgoldenrodyellow", "lightgray", "lightgreen", "lightgrey", "lightpink", "lightsalmon", "lightseagreen", "lightskyblue", "lightslategray", "lightslategrey", "lightsteelblue", "lightyellow", "limegreen", "linen", "magenta", "mediumaquamarine", "mediumblue", "mediumorchid", "mediumpurple", "mediumseagreen", "mediumslateblue", "mediumspringgreen", "mediumturquoise", "mediumvioletred", "midnightblue", "mintcream", "mistyrose", "moccasin", "navajowhite", "oldlace", "olivedrab", "orangered", "orchid", "palegoldenrod", "palegreen", "paleturquoise", "palevioletred", "papayawhip", "peachpuff", "peru", "pink", "plum", "powderblue", "rosybrown", "royalblue", "saddlebrown", "salmon", "sandybrown", "seagreen", "seashell", "sienna", "skyblue", "slateblue", "slategray", "slategrey", "snow", "springgreen", "steelblue", "tan", "thistle", "tomato", "turquoise", "violet", "wheat", "whitesmoke", "yellowgreen", "activeborder", "activecaption", "appworkspace", "background", "buttonface", "buttonhighlight", "buttonshadow", "buttontext", "captiontext", "graytext", "highlight", "highlighttext", "inactiveborder", "inactivecaption", "inactivecaptiontext", "infobackground", "infotext", "menu", "menutext", "scrollbar", "threeddarkshadow", "threedface", "threedhighlight", "threedlightshadow", "threedshadow", "window", "windowframe", "windowtext", "rebeccapurple", "currentcolor", "transparent"]);
        function ie(e) {
          return e.startsWith("#") ? Q.test(e) : e.startsWith("rgb") ? Y.test(e) || ee.test(e) : e.startsWith("hsl") ? te.test(e) || se.test(e) : oe.has(e.toLowerCase());
        }
        var re = ["none", "hidden", "dotted", "dashed", "solid", "double", "groove", "ridge", "inset", "outset"];
        function ne(e) {
          return re.includes(e);
        }
        var ae = /^([+-]?[0-9]*([.][0-9]+)?(px|cm|mm|in|pc|pt|ch|em|ex|rem|vh|vw|vmin|vmax)|0)$/;
        function ce(e) {
          return ae.test(e);
        }
        var le = /^[+-]?[0-9]*([.][0-9]+)?%$/;
        function de(e) {
          return le.test(e);
        }
        var he = ["repeat-x", "repeat-y", "repeat", "space", "round", "no-repeat"];
        function ue(e) {
          return he.includes(e);
        }
        var ge = ["center", "top", "bottom", "left", "right"];
        function pe(e) {
          return ge.includes(e);
        }
        var fe = ["fixed", "scroll", "local"];
        function me(e) {
          return fe.includes(e);
        }
        var ke = /^url\(/;
        function _e(e) {
          return ke.test(e);
        }
        function be() {
          var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
          if ("" === e) return {
            top: void 0,
            right: void 0,
            bottom: void 0,
            left: void 0
          };
          var t = Ze(e),
            s = t[0],
            o = t[2] || s,
            i = t[1] || s;
          return {
            top: s,
            bottom: o,
            right: i,
            left: t[3] || i
          };
        }
        function we(e) {
          return function (t) {
            var s = t.top,
              o = t.right,
              i = t.bottom,
              r = t.left,
              n = [];
            return [s, o, r, i].every(function (e) {
              return !!e;
            }) ? n.push([e, ve(t)]) : (s && n.push([e + "-top", s]), o && n.push([e + "-right", o]), i && n.push([e + "-bottom", i]), r && n.push([e + "-left", r])), n;
          };
        }
        function ve(_ref47) {
          var e = _ref47.top,
            t = _ref47.right,
            s = _ref47.bottom,
            o = _ref47.left;
          var i = [];
          return o !== t ? i.push(e, t, s, o) : s !== e ? i.push(e, t, s) : t !== e ? i.push(e, t) : i.push(e), i.join(" ");
        }
        function ye(e) {
          return function (t) {
            return {
              path: e,
              value: be(t)
            };
          };
        }
        function Ze(e) {
          return e.replace(/, /g, ",").split(" ").map(function (e) {
            return e.replace(/,/g, ", ");
          });
        }
        function Pe(e) {
          e.setNormalizer("background", je), e.setNormalizer("background-color", function (e) {
            return {
              path: "background.color",
              value: e
            };
          }), e.setReducer("background", function (e) {
            var t = [];
            return t.push(["background-color", e.color]), t;
          }), e.setStyleRelation("background", ["background-color"]);
        }
        function je(e) {
          var t = {},
            s = Ze(e);
          var _iterator322 = _createForOfIteratorHelper(s),
            _step322;
          try {
            for (_iterator322.s(); !(_step322 = _iterator322.n()).done;) {
              var _e250 = _step322.value;
              ue(_e250) ? (t.repeat = t.repeat || [], t.repeat.push(_e250)) : pe(_e250) ? (t.position = t.position || [], t.position.push(_e250)) : me(_e250) ? t.attachment = _e250 : ie(_e250) ? t.color = _e250 : _e(_e250) && (t.image = _e250);
            }
          } catch (err) {
            _iterator322.e(err);
          } finally {
            _iterator322.f();
          }
          return {
            path: "background",
            value: t
          };
        }
        function xe(e) {
          e.setNormalizer("border", Ae), e.setNormalizer("border-top", Te("top")), e.setNormalizer("border-right", Te("right")), e.setNormalizer("border-bottom", Te("bottom")), e.setNormalizer("border-left", Te("left")), e.setNormalizer("border-color", Ce("color")), e.setNormalizer("border-width", Ce("width")), e.setNormalizer("border-style", Ce("style")), e.setNormalizer("border-top-color", Se("color", "top")), e.setNormalizer("border-top-style", Se("style", "top")), e.setNormalizer("border-top-width", Se("width", "top")), e.setNormalizer("border-right-color", Se("color", "right")), e.setNormalizer("border-right-style", Se("style", "right")), e.setNormalizer("border-right-width", Se("width", "right")), e.setNormalizer("border-bottom-color", Se("color", "bottom")), e.setNormalizer("border-bottom-style", Se("style", "bottom")), e.setNormalizer("border-bottom-width", Se("width", "bottom")), e.setNormalizer("border-left-color", Se("color", "left")), e.setNormalizer("border-left-style", Se("style", "left")), e.setNormalizer("border-left-width", Se("width", "left")), e.setExtractor("border-top", Re("top")), e.setExtractor("border-right", Re("right")), e.setExtractor("border-bottom", Re("bottom")), e.setExtractor("border-left", Re("left")), e.setExtractor("border-top-color", "border.color.top"), e.setExtractor("border-right-color", "border.color.right"), e.setExtractor("border-bottom-color", "border.color.bottom"), e.setExtractor("border-left-color", "border.color.left"), e.setExtractor("border-top-width", "border.width.top"), e.setExtractor("border-right-width", "border.width.right"), e.setExtractor("border-bottom-width", "border.width.bottom"), e.setExtractor("border-left-width", "border.width.left"), e.setExtractor("border-top-style", "border.style.top"), e.setExtractor("border-right-style", "border.style.right"), e.setExtractor("border-bottom-style", "border.style.bottom"), e.setExtractor("border-left-style", "border.style.left"), e.setReducer("border-color", we("border-color")), e.setReducer("border-style", we("border-style")), e.setReducer("border-width", we("border-width")), e.setReducer("border-top", Ne("top")), e.setReducer("border-right", Ne("right")), e.setReducer("border-bottom", Ne("bottom")), e.setReducer("border-left", Ne("left")), e.setReducer("border", function () {
            return function (t) {
              var s = Oe(t, "top"),
                o = Oe(t, "right"),
                i = Oe(t, "bottom"),
                r = Oe(t, "left"),
                n = [s, o, i, r],
                a = {
                  width: e(n, "width"),
                  style: e(n, "style"),
                  color: e(n, "color")
                },
                c = Ie(a, "all");
              if (c.length) return c;
              var l = Object.entries(a).reduce(function (e, _ref48) {
                var _ref49 = _slicedToArray(_ref48, 2),
                  t = _ref49[0],
                  s = _ref49[1];
                return s && (e.push(["border-".concat(t), s]), n.forEach(function (e) {
                  return e[t] = null;
                })), e;
              }, []);
              return [].concat(_toConsumableArray(l), _toConsumableArray(Ie(s, "top")), _toConsumableArray(Ie(o, "right")), _toConsumableArray(Ie(i, "bottom")), _toConsumableArray(Ie(r, "left")));
            };
            function e(e, t) {
              return e.map(function (e) {
                return e[t];
              }).reduce(function (e, t) {
                return e == t ? e : null;
              });
            }
          }()), e.setStyleRelation("border", ["border-color", "border-style", "border-width", "border-top", "border-right", "border-bottom", "border-left", "border-top-color", "border-right-color", "border-bottom-color", "border-left-color", "border-top-style", "border-right-style", "border-bottom-style", "border-left-style", "border-top-width", "border-right-width", "border-bottom-width", "border-left-width"]), e.setStyleRelation("border-color", ["border-top-color", "border-right-color", "border-bottom-color", "border-left-color"]), e.setStyleRelation("border-style", ["border-top-style", "border-right-style", "border-bottom-style", "border-left-style"]), e.setStyleRelation("border-width", ["border-top-width", "border-right-width", "border-bottom-width", "border-left-width"]), e.setStyleRelation("border-top", ["border-top-color", "border-top-style", "border-top-width"]), e.setStyleRelation("border-right", ["border-right-color", "border-right-style", "border-right-width"]), e.setStyleRelation("border-bottom", ["border-bottom-color", "border-bottom-style", "border-bottom-width"]), e.setStyleRelation("border-left", ["border-left-color", "border-left-style", "border-left-width"]);
        }
        function Ae(e) {
          var _Me = Me(e),
            t = _Me.color,
            s = _Me.style,
            o = _Me.width;
          return {
            path: "border",
            value: {
              color: be(t),
              style: be(s),
              width: be(o)
            }
          };
        }
        function Te(e) {
          return function (t) {
            var _Me2 = Me(t),
              s = _Me2.color,
              o = _Me2.style,
              i = _Me2.width,
              r = {};
            return void 0 !== s && (r.color = _defineProperty({}, e, s)), void 0 !== o && (r.style = _defineProperty({}, e, o)), void 0 !== i && (r.width = _defineProperty({}, e, i)), {
              path: "border",
              value: r
            };
          };
        }
        function Ce(e) {
          return function (t) {
            return {
              path: "border",
              value: Ee(t, e)
            };
          };
        }
        function Ee(e, t) {
          return _defineProperty({}, t, be(e));
        }
        function Se(e, t) {
          return function (s) {
            return {
              path: "border",
              value: _defineProperty({}, e, _defineProperty({}, t, s))
            };
          };
        }
        function Re(e) {
          return function (t, s) {
            if (s.border) return Oe(s.border, e);
          };
        }
        function Oe(e, t) {
          var s = {};
          return e.width && e.width[t] && (s.width = e.width[t]), e.style && e.style[t] && (s.style = e.style[t]), e.color && e.color[t] && (s.color = e.color[t]), s;
        }
        function Me(e) {
          var t = {},
            s = Ze(e);
          var _iterator323 = _createForOfIteratorHelper(s),
            _step323;
          try {
            for (_iterator323.s(); !(_step323 = _iterator323.n()).done;) {
              var _e252 = _step323.value;
              ce(_e252) || /thin|medium|thick/.test(_e252) ? t.width = _e252 : ne(_e252) ? t.style = _e252 : t.color = _e252;
            }
          } catch (err) {
            _iterator323.e(err);
          } finally {
            _iterator323.f();
          }
          return t;
        }
        function Ne(e) {
          return function (t) {
            return Ie(t, e);
          };
        }
        function Ie(e, t) {
          var s = [];
          if (e && e.width && s.push("width"), e && e.style && s.push("style"), e && e.color && s.push("color"), 3 == s.length) {
            var _o144 = s.map(function (t) {
              return e[t];
            }).join(" ");
            return ["all" == t ? ["border", _o144] : ["border-".concat(t), _o144]];
          }
          return "all" == t ? [] : s.map(function (s) {
            return ["border-".concat(t, "-").concat(s), e[s]];
          });
        }
        function ze(e) {
          e.setNormalizer("margin", ye("margin")), e.setNormalizer("margin-top", function (e) {
            return {
              path: "margin.top",
              value: e
            };
          }), e.setNormalizer("margin-right", function (e) {
            return {
              path: "margin.right",
              value: e
            };
          }), e.setNormalizer("margin-bottom", function (e) {
            return {
              path: "margin.bottom",
              value: e
            };
          }), e.setNormalizer("margin-left", function (e) {
            return {
              path: "margin.left",
              value: e
            };
          }), e.setReducer("margin", we("margin")), e.setStyleRelation("margin", ["margin-top", "margin-right", "margin-bottom", "margin-left"]);
        }
        function Ve(e) {
          e.setNormalizer("padding", ye("padding")), e.setNormalizer("padding-top", function (e) {
            return {
              path: "padding.top",
              value: e
            };
          }), e.setNormalizer("padding-right", function (e) {
            return {
              path: "padding.right",
              value: e
            };
          }), e.setNormalizer("padding-bottom", function (e) {
            return {
              path: "padding.bottom",
              value: e
            };
          }), e.setNormalizer("padding-left", function (e) {
            return {
              path: "padding.left",
              value: e
            };
          }), e.setReducer("padding", we("padding")), e.setStyleRelation("padding", ["padding-top", "padding-right", "padding-bottom", "padding-left"]);
        }
      },
      "./src/enter.js": function _src_enterJs(e, t, s) {
        "use strict";

        s.r(t), s.d(t, {
          Enter: function Enter() {
            return o.Z;
          },
          ShiftEnter: function ShiftEnter() {
            return h;
          }
        });
        var o = s("./packages/ckeditor5-enter/src/enter.js"),
          i = s("./packages/ckeditor5-core/src/command.js"),
          r = s("./packages/ckeditor5-enter/src/utils.js");
        var n = /*#__PURE__*/function (_i$Z7) {
          _inherits(n, _i$Z7);
          function n() {
            _classCallCheck(this, n);
            return _possibleConstructorReturn(this, _getPrototypeOf(n).apply(this, arguments));
          }
          _createClass(n, [{
            key: "execute",
            value: function execute() {
              var _this159 = this;
              var e = this.editor.model,
                t = e.document;
              e.change(function (s) {
                !function (e, t, s) {
                  var o = s.isCollapsed,
                    i = s.getFirstRange(),
                    n = i.start.parent,
                    c = i.end.parent,
                    l = n == c;
                  if (o) {
                    var _o145 = (0, r.G)(e.schema, s.getAttributes());
                    a(e, t, i.end), t.removeSelectionAttribute(s.getAttributeKeys()), t.setSelectionAttribute(_o145);
                  } else {
                    var _o146 = !(i.start.isAtStart && i.end.isAtEnd);
                    e.deleteContent(s, {
                      leaveUnmerged: _o146
                    }), l ? a(e, t, s.focus) : _o146 && t.setSelection(c, 0);
                  }
                }(e, s, t.selection), _this159.fire("afterExecute", {
                  writer: s
                });
              });
            }
          }, {
            key: "refresh",
            value: function refresh() {
              var e = this.editor.model,
                t = e.document;
              this.isEnabled = function (e, t) {
                if (t.rangeCount > 1) return !1;
                var s = t.anchor;
                if (!s || !e.checkChild(s, "softBreak")) return !1;
                var o = t.getFirstRange(),
                  i = o.start.parent,
                  r = o.end.parent;
                if ((c(i, e) || c(r, e)) && i !== r) return !1;
                return !0;
              }(e.schema, t.selection);
            }
          }]);
          return n;
        }(i.Z);
        function a(e, t, s) {
          var o = t.createElement("softBreak");
          e.insertContent(o, s), t.setSelection(o, "after");
        }
        function c(e, t) {
          return !e.is("rootElement") && (t.isLimit(e) || c(e.parent, t));
        }
        var l = s("./packages/ckeditor5-enter/src/enterobserver.js"),
          d = s("./packages/ckeditor5-core/src/plugin.js");
        var h = /*#__PURE__*/function (_d$Z2) {
          _inherits(h, _d$Z2);
          function h() {
            _classCallCheck(this, h);
            return _possibleConstructorReturn(this, _getPrototypeOf(h).apply(this, arguments));
          }
          _createClass(h, [{
            key: "init",
            value: function init() {
              var e = this.editor,
                t = e.model.schema,
                s = e.conversion,
                o = e.editing.view,
                i = o.document;
              t.register("softBreak", {
                allowWhere: "$text",
                isInline: !0
              }), s.for("upcast").elementToElement({
                model: "softBreak",
                view: "br"
              }), s.for("downcast").elementToElement({
                model: "softBreak",
                view: function view(e, _ref51) {
                  var t = _ref51.writer;
                  return t.createEmptyElement("br");
                }
              }), o.addObserver(l.Z), e.commands.add("shiftEnter", new n(e)), this.listenTo(i, "enter", function (t, s) {
                s.preventDefault(), s.isSoft && (e.execute("shiftEnter"), o.scrollToTheSelection());
              }, {
                priority: "low"
              });
            }
          }], [{
            key: "pluginName",
            get: function get() {
              return "ShiftEnter";
            }
          }]);
          return h;
        }(d.Z);
      },
      "./src/paragraph.js": function _src_paragraphJs(e, t, s) {
        "use strict";

        s.r(t), s.d(t, {
          Paragraph: function Paragraph() {
            return l;
          },
          ParagraphButtonUI: function ParagraphButtonUI() {
            return h;
          }
        });
        var o = s("./packages/ckeditor5-core/src/command.js"),
          i = s("./packages/ckeditor5-utils/src/first.js");
        var r = /*#__PURE__*/function (_o$Z48) {
          _inherits(r, _o$Z48);
          function r() {
            _classCallCheck(this, r);
            return _possibleConstructorReturn(this, _getPrototypeOf(r).apply(this, arguments));
          }
          _createClass(r, [{
            key: "refresh",
            value: function refresh() {
              var e = this.editor.model,
                t = e.document,
                s = (0, i.Z)(t.selection.getSelectedBlocks());
              this.value = !!s && s.is("element", "paragraph"), this.isEnabled = !!s && n(s, e.schema);
            }
          }, {
            key: "execute",
            value: function execute() {
              var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
              var t = this.editor.model,
                s = t.document;
              t.change(function (o) {
                var i = (e.selection || s.selection).getSelectedBlocks();
                var _iterator324 = _createForOfIteratorHelper(i),
                  _step324;
                try {
                  for (_iterator324.s(); !(_step324 = _iterator324.n()).done;) {
                    var _e253 = _step324.value;
                    !_e253.is("element", "paragraph") && n(_e253, t.schema) && o.rename(_e253, "paragraph");
                  }
                } catch (err) {
                  _iterator324.e(err);
                } finally {
                  _iterator324.f();
                }
              });
            }
          }]);
          return r;
        }(o.Z);
        function n(e, t) {
          return t.checkChild(e.parent, "paragraph") && !t.isObject(e);
        }
        var a = /*#__PURE__*/function (_o$Z49) {
          _inherits(a, _o$Z49);
          function a() {
            _classCallCheck(this, a);
            return _possibleConstructorReturn(this, _getPrototypeOf(a).apply(this, arguments));
          }
          _createClass(a, [{
            key: "execute",
            value: function execute(e) {
              var t = this.editor.model;
              var s = e.position;
              t.change(function (e) {
                var o = e.createElement("paragraph");
                if (!t.schema.checkChild(s.parent, o)) {
                  var _i117 = t.schema.findAllowedParent(s, o);
                  if (!_i117) return;
                  s = e.split(s, _i117).position;
                }
                t.insertContent(o, s), e.setSelection(o, "in");
              });
            }
          }]);
          return a;
        }(o.Z);
        var c = s("./packages/ckeditor5-core/src/plugin.js");
        var l = /*#__PURE__*/function (_c$Z4) {
          _inherits(l, _c$Z4);
          function l() {
            _classCallCheck(this, l);
            return _possibleConstructorReturn(this, _getPrototypeOf(l).apply(this, arguments));
          }
          _createClass(l, [{
            key: "init",
            value: function init() {
              var e = this.editor,
                t = e.model;
              e.commands.add("paragraph", new r(e)), e.commands.add("insertParagraph", new a(e)), t.schema.register("paragraph", {
                inheritAllFrom: "$block"
              }), e.conversion.elementToElement({
                model: "paragraph",
                view: "p"
              }), e.conversion.for("upcast").elementToElement({
                model: function model(e, _ref52) {
                  var t = _ref52.writer;
                  return l.paragraphLikeElements.has(e.name) ? e.isEmpty ? null : t.createElement("paragraph") : null;
                },
                view: /.+/,
                converterPriority: "low"
              });
            }
          }], [{
            key: "pluginName",
            get: function get() {
              return "Paragraph";
            }
          }]);
          return l;
        }(c.Z);
        l.paragraphLikeElements = new Set(["blockquote", "dd", "div", "dt", "h1", "h2", "h3", "h4", "h5", "h6", "li", "p", "td", "th"]);
        var d = s("./packages/ckeditor5-ui/src/button/buttonview.js");
        var h = /*#__PURE__*/function (_c$Z5) {
          _inherits(h, _c$Z5);
          function h() {
            _classCallCheck(this, h);
            return _possibleConstructorReturn(this, _getPrototypeOf(h).apply(this, arguments));
          }
          _createClass(h, [{
            key: "init",
            value: function init() {
              var e = this.editor,
                t = e.t;
              e.ui.componentFactory.add("paragraph", function (s) {
                var o = new d.Z(s),
                  i = e.commands.get("paragraph");
                return o.label = t("Paragraph"), o.icon = '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M10.5 5.5H7v5h3.5a2.5 2.5 0 1 0 0-5zM5 3h6.5v.025a5 5 0 0 1 0 9.95V13H7v4a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1z"/></svg>', o.tooltip = !0, o.isToggleable = !0, o.bind("isEnabled").to(i), o.bind("isOn").to(i, "value"), o.on("execute", function () {
                  e.execute("paragraph");
                }), o;
              });
            }
          }]);
          return h;
        }(c.Z);
      },
      "./src/select-all.js": function _src_selectAllJs(e, t, s) {
        "use strict";

        s.r(t), s.d(t, {
          SelectAll: function SelectAll() {
            return u;
          },
          SelectAllEditing: function SelectAllEditing() {
            return l;
          },
          SelectAllUI: function SelectAllUI() {
            return h;
          }
        });
        var o = s("./packages/ckeditor5-core/src/plugin.js"),
          i = s("./packages/ckeditor5-utils/src/keyboard.js"),
          r = s("./packages/ckeditor5-core/src/command.js");
        var n = /*#__PURE__*/function (_r$Z5) {
          _inherits(n, _r$Z5);
          function n(e) {
            var _this160;
            _classCallCheck(this, n);
            _this160 = _possibleConstructorReturn(this, _getPrototypeOf(n).call(this, e)), _this160.affectsData = !1;
            return _this160;
          }
          _createClass(n, [{
            key: "execute",
            value: function execute() {
              var e = this.editor.model,
                t = e.document.selection;
              var s = e.schema.getLimitElement(t);
              if (t.containsEntireContent(s) || !a(e.schema, s)) do {
                if (s = s.parent, !s) return;
              } while (!a(e.schema, s));
              e.change(function (e) {
                e.setSelection(s, "in");
              });
            }
          }]);
          return n;
        }(r.Z);
        function a(e, t) {
          return e.isLimit(t) && (e.checkChild(t, "$text") || e.checkChild(t, "paragraph"));
        }
        var c = (0, i.Zz)("Ctrl+A");
        var l = /*#__PURE__*/function (_o$Z50) {
          _inherits(l, _o$Z50);
          function l() {
            _classCallCheck(this, l);
            return _possibleConstructorReturn(this, _getPrototypeOf(l).apply(this, arguments));
          }
          _createClass(l, [{
            key: "init",
            value: function init() {
              var e = this.editor,
                t = e.editing.view.document;
              e.commands.add("selectAll", new n(e)), this.listenTo(t, "keydown", function (t, s) {
                (0, i.Cq)(s) === c && (e.execute("selectAll"), s.preventDefault());
              });
            }
          }], [{
            key: "pluginName",
            get: function get() {
              return "SelectAllEditing";
            }
          }]);
          return l;
        }(o.Z);
        var d = s("./packages/ckeditor5-ui/src/button/buttonview.js");
        var h = /*#__PURE__*/function (_o$Z51) {
          _inherits(h, _o$Z51);
          function h() {
            _classCallCheck(this, h);
            return _possibleConstructorReturn(this, _getPrototypeOf(h).apply(this, arguments));
          }
          _createClass(h, [{
            key: "init",
            value: function init() {
              var _this161 = this;
              var e = this.editor;
              e.ui.componentFactory.add("selectAll", function (t) {
                var s = e.commands.get("selectAll"),
                  o = new d.Z(t),
                  i = t.t;
                return o.set({
                  label: i("Select all"),
                  icon: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M.75 15.5a.75.75 0 0 1 .75.75V18l.008.09A.5.5 0 0 0 2 18.5h1.75a.75.75 0 1 1 0 1.5H1.5l-.144-.007a1.5 1.5 0 0 1-1.35-1.349L0 18.5v-2.25a.75.75 0 0 1 .75-.75zm18.5 0a.75.75 0 0 1 .75.75v2.25l-.007.144a1.5 1.5 0 0 1-1.349 1.35L18.5 20h-2.25a.75.75 0 1 1 0-1.5H18a.5.5 0 0 0 .492-.41L18.5 18v-1.75a.75.75 0 0 1 .75-.75zm-10.45 3c.11 0 .2.09.2.2v1.1a.2.2 0 0 1-.2.2H7.2a.2.2 0 0 1-.2-.2v-1.1c0-.11.09-.2.2-.2h1.6zm4 0c.11 0 .2.09.2.2v1.1a.2.2 0 0 1-.2.2h-1.6a.2.2 0 0 1-.2-.2v-1.1c0-.11.09-.2.2-.2h1.6zm.45-5.5a.75.75 0 1 1 0 1.5h-8.5a.75.75 0 1 1 0-1.5h8.5zM1.3 11c.11 0 .2.09.2.2v1.6a.2.2 0 0 1-.2.2H.2a.2.2 0 0 1-.2-.2v-1.6c0-.11.09-.2.2-.2h1.1zm18.5 0c.11 0 .2.09.2.2v1.6a.2.2 0 0 1-.2.2h-1.1a.2.2 0 0 1-.2-.2v-1.6c0-.11.09-.2.2-.2h1.1zm-4.55-2a.75.75 0 1 1 0 1.5H4.75a.75.75 0 1 1 0-1.5h10.5zM1.3 7c.11 0 .2.09.2.2v1.6a.2.2 0 0 1-.2.2H.2a.2.2 0 0 1-.2-.2V7.2c0-.11.09-.2.2-.2h1.1zm18.5 0c.11 0 .2.09.2.2v1.6a.2.2 0 0 1-.2.2h-1.1a.2.2 0 0 1-.2-.2V7.2c0-.11.09-.2.2-.2h1.1zm-4.55-2a.75.75 0 1 1 0 1.5h-2.5a.75.75 0 1 1 0-1.5h2.5zm-5 0a.75.75 0 1 1 0 1.5h-5.5a.75.75 0 0 1 0-1.5h5.5zm-6.5-5a.75.75 0 0 1 0 1.5H2a.5.5 0 0 0-.492.41L1.5 2v1.75a.75.75 0 0 1-1.5 0V1.5l.007-.144A1.5 1.5 0 0 1 1.356.006L1.5 0h2.25zM18.5 0l.144.007a1.5 1.5 0 0 1 1.35 1.349L20 1.5v2.25a.75.75 0 1 1-1.5 0V2l-.008-.09A.5.5 0 0 0 18 1.5h-1.75a.75.75 0 1 1 0-1.5h2.25zM8.8 0c.11 0 .2.09.2.2v1.1a.2.2 0 0 1-.2.2H7.2a.2.2 0 0 1-.2-.2V.2c0-.11.09-.2.2-.2h1.6zm4 0c.11 0 .2.09.2.2v1.1a.2.2 0 0 1-.2.2h-1.6a.2.2 0 0 1-.2-.2V.2c0-.11.09-.2.2-.2h1.6z"/></svg>',
                  keystroke: "Ctrl+A",
                  tooltip: !0
                }), o.bind("isOn", "isEnabled").to(s, "value", "isEnabled"), _this161.listenTo(o, "execute", function () {
                  e.execute("selectAll"), e.editing.view.focus();
                }), o;
              });
            }
          }], [{
            key: "pluginName",
            get: function get() {
              return "SelectAllUI";
            }
          }]);
          return h;
        }(o.Z);
        var u = /*#__PURE__*/function (_o$Z52) {
          _inherits(u, _o$Z52);
          function u() {
            _classCallCheck(this, u);
            return _possibleConstructorReturn(this, _getPrototypeOf(u).apply(this, arguments));
          }
          _createClass(u, null, [{
            key: "requires",
            get: function get() {
              return [l, h];
            }
          }, {
            key: "pluginName",
            get: function get() {
              return "SelectAll";
            }
          }]);
          return u;
        }(o.Z);
      },
      "./src/typing.js": function _src_typingJs(e, t, s) {
        "use strict";

        s.r(t), s.d(t, {
          Delete: function Delete() {
            return f.Z;
          },
          Input: function Input() {
            return p;
          },
          TextTransformation: function TextTransformation() {
            return M;
          },
          TextWatcher: function TextWatcher() {
            return w;
          },
          TwoStepCaretMovement: function TwoStepCaretMovement() {
            return y;
          },
          Typing: function Typing() {
            return m;
          },
          findAttributeRange: function findAttributeRange() {
            return D;
          },
          getLastTextLine: function getLastTextLine() {
            return b;
          },
          inlineHighlight: function inlineHighlight() {
            return F;
          },
          isNonTypingKeystroke: function isNonTypingKeystroke() {
            return a.u;
          }
        });
        var o = s("./packages/ckeditor5-core/src/plugin.js"),
          i = s("./packages/ckeditor5-core/src/command.js"),
          r = s("./packages/ckeditor5-typing/src/utils/changebuffer.js");
        var n = /*#__PURE__*/function (_i$Z8) {
          _inherits(n, _i$Z8);
          function n(e, t) {
            var _this162;
            _classCallCheck(this, n);
            _this162 = _possibleConstructorReturn(this, _getPrototypeOf(n).call(this, e)), _this162._buffer = new r.Z(e.model, t);
            return _this162;
          }
          _createClass(n, [{
            key: "destroy",
            value: function destroy() {
              _superPropGet(n, "destroy", this, 3)([]), this._buffer.destroy();
            }
          }, {
            key: "execute",
            value: function execute() {
              var _this163 = this;
              var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
              var t = this.editor.model,
                s = t.document,
                o = e.text || "",
                i = o.length,
                r = e.range ? t.createSelection(e.range) : s.selection,
                n = e.resultRange;
              t.enqueueChange(this._buffer.batch, function (e) {
                _this163._buffer.lock(), t.deleteContent(r), o && t.insertContent(e.createText(o, s.selection.getAttributes()), r), n ? e.setSelection(n) : r.is("documentSelection") || e.setSelection(r), _this163._buffer.unlock(), _this163._buffer.input(i);
              });
            }
          }, {
            key: "buffer",
            get: function get() {
              return this._buffer;
            }
          }]);
          return n;
        }(i.Z);
        var a = s("./packages/ckeditor5-typing/src/utils/injectunsafekeystrokeshandling.js"),
          c = s("./packages/ckeditor5-utils/src/diff.js"),
          l = s("./packages/ckeditor5-engine/src/view/domconverter.js"),
          d = s("./packages/ckeditor5-typing/src/utils/utils.js");
        var h = /*#__PURE__*/function () {
          function h(e) {
            _classCallCheck(this, h);
            this.editor = e, this.editing = this.editor.editing;
          }
          _createClass(h, [{
            key: "handle",
            value: function handle(e, t) {
              if ((0, d.E9)(e)) this._handleContainerChildrenMutations(e, t);else {
                var _iterator325 = _createForOfIteratorHelper(e),
                  _step325;
                try {
                  for (_iterator325.s(); !(_step325 = _iterator325.n()).done;) {
                    var _s222 = _step325.value;
                    this._handleTextMutation(_s222, t), this._handleTextNodeInsertion(_s222);
                  }
                } catch (err) {
                  _iterator325.e(err);
                } finally {
                  _iterator325.f();
                }
              }
            }
          }, {
            key: "_handleContainerChildrenMutations",
            value: function _handleContainerChildrenMutations(e, t) {
              var s = function (e) {
                var t = e.map(function (e) {
                  return e.node;
                }).reduce(function (e, t) {
                  return e.getCommonAncestor(t, {
                    includeSelf: !0
                  });
                });
                if (!t) return;
                return t.getAncestors({
                  includeSelf: !0,
                  parentFirst: !0
                }).find(function (e) {
                  return e.is("containerElement") || e.is("rootElement");
                });
              }(e);
              if (!s) return;
              var o = this.editor.editing.view.domConverter.mapViewToDom(s),
                i = new l.Z(this.editor.editing.view.document),
                r = this.editor.data.toModel(i.domToView(o)).getChild(0),
                n = this.editor.editing.mapper.toModelElement(s);
              if (!n) return;
              var a = Array.from(r.getChildren()),
                d = Array.from(n.getChildren()),
                h = a[a.length - 1],
                p = d[d.length - 1],
                f = h && h.is("element", "softBreak"),
                m = p && !p.is("element", "softBreak");
              f && m && a.pop();
              var k = this.editor.model.schema;
              if (!u(a, k) || !u(d, k)) return;
              var _ = a.map(function (e) {
                  return e.is("$text") ? e.data : "@";
                }).join("").replace(/\u00A0/g, " "),
                b = d.map(function (e) {
                  return e.is("$text") ? e.data : "@";
                }).join("").replace(/\u00A0/g, " ");
              if (b === _) return;
              var w = (0, c.Z)(b, _),
                _g3 = g(w),
                v = _g3.firstChangeAt,
                y = _g3.insertions,
                Z = _g3.deletions;
              var P = null;
              t && (P = this.editing.mapper.toModelRange(t.getFirstRange()));
              var j = _.substr(v, y),
                x = this.editor.model.createRange(this.editor.model.createPositionAt(n, v), this.editor.model.createPositionAt(n, v + Z));
              this.editor.execute("input", {
                text: j,
                range: x,
                resultRange: P
              });
            }
          }, {
            key: "_handleTextMutation",
            value: function _handleTextMutation(e, t) {
              if ("text" != e.type) return;
              var s = e.newText.replace(/\u00A0/g, " "),
                o = e.oldText.replace(/\u00A0/g, " ");
              if (o === s) return;
              var i = (0, c.Z)(o, s),
                _g4 = g(i),
                r = _g4.firstChangeAt,
                n = _g4.insertions,
                a = _g4.deletions;
              var l = null;
              t && (l = this.editing.mapper.toModelRange(t.getFirstRange()));
              var d = this.editing.view.createPositionAt(e.node, r),
                h = this.editing.mapper.toModelPosition(d),
                u = this.editor.model.createRange(h, h.getShiftedBy(a)),
                p = s.substr(r, n);
              this.editor.execute("input", {
                text: p,
                range: u,
                resultRange: l
              });
            }
          }, {
            key: "_handleTextNodeInsertion",
            value: function _handleTextNodeInsertion(e) {
              if ("children" != e.type) return;
              var t = (0, d.xG)(e),
                s = this.editing.view.createPositionAt(e.node, t.index),
                o = this.editing.mapper.toModelPosition(s),
                i = t.values[0].data;
              this.editor.execute("input", {
                text: i.replace(/\u00A0/g, " "),
                range: this.editor.model.createRange(o)
              });
            }
          }]);
          return h;
        }();
        function u(e, t) {
          return e.every(function (e) {
            return t.isInline(e);
          });
        }
        function g(e) {
          var t = null,
            s = null;
          for (var _o147 = 0; _o147 < e.length; _o147++) {
            "equal" != e[_o147] && (t = null === t ? _o147 : t, s = _o147);
          }
          var o = 0,
            i = 0;
          for (var _r57 = t; _r57 <= s; _r57++) "insert" != e[_r57] && o++, "delete" != e[_r57] && i++;
          return {
            insertions: i,
            deletions: o,
            firstChangeAt: t
          };
        }
        var p = /*#__PURE__*/function (_o$Z53) {
          _inherits(p, _o$Z53);
          function p() {
            _classCallCheck(this, p);
            return _possibleConstructorReturn(this, _getPrototypeOf(p).apply(this, arguments));
          }
          _createClass(p, [{
            key: "init",
            value: function init() {
              var e = this.editor,
                t = new n(e, e.config.get("typing.undoStep") || 20);
              e.commands.add("input", t), (0, a.Z)(e), function (e) {
                e.editing.view.document.on("mutations", function (t, s, o) {
                  new h(e).handle(s, o);
                });
              }(e);
            }
          }], [{
            key: "pluginName",
            get: function get() {
              return "Input";
            }
          }]);
          return p;
        }(o.Z);
        var f = s("./packages/ckeditor5-typing/src/delete.js");
        var m = /*#__PURE__*/function (_o$Z54) {
          _inherits(m, _o$Z54);
          function m() {
            _classCallCheck(this, m);
            return _possibleConstructorReturn(this, _getPrototypeOf(m).apply(this, arguments));
          }
          _createClass(m, null, [{
            key: "requires",
            get: function get() {
              return [p, f.Z];
            }
          }, {
            key: "pluginName",
            get: function get() {
              return "Typing";
            }
          }]);
          return m;
        }(o.Z);
        var k = s("./packages/ckeditor5-utils/src/mix.js"),
          _ = s("./packages/ckeditor5-utils/src/observablemixin.js");
        function b(e, t) {
          var s = e.start;
          return {
            text: Array.from(e.getItems()).reduce(function (e, o) {
              return o.is("$text") || o.is("$textProxy") ? e + o.data : (s = t.createPositionAfter(o), "");
            }, ""),
            range: t.createRange(s, e.end)
          };
        }
        var w = /*#__PURE__*/function () {
          function w(e, t) {
            var _this164 = this;
            _classCallCheck(this, w);
            this.model = e, this.testCallback = t, this.hasMatch = !1, this.set("isEnabled", !0), this.on("change:isEnabled", function () {
              _this164.isEnabled ? _this164._startListening() : (_this164.stopListening(e.document.selection), _this164.stopListening(e.document));
            }), this._startListening();
          }
          _createClass(w, [{
            key: "_startListening",
            value: function _startListening() {
              var _this165 = this;
              var e = this.model.document;
              this.listenTo(e.selection, "change:range", function (t, _ref53) {
                var s = _ref53.directChange;
                s && (e.selection.isCollapsed ? _this165._evaluateTextBeforeSelection("selection") : _this165.hasMatch && (_this165.fire("unmatched"), _this165.hasMatch = !1));
              }), this.listenTo(e, "change:data", function (e, t) {
                !t.isUndo && t.isLocal && _this165._evaluateTextBeforeSelection("data", {
                  batch: t
                });
              });
            }
          }, {
            key: "_evaluateTextBeforeSelection",
            value: function _evaluateTextBeforeSelection(e) {
              var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
              var s = this.model,
                o = s.document.selection,
                i = s.createRange(s.createPositionAt(o.focus.parent, 0), o.focus),
                _b = b(i, s),
                r = _b.text,
                n = _b.range,
                a = this.testCallback(r);
              if (!a && this.hasMatch && this.fire("unmatched"), this.hasMatch = !!a, a) {
                var _s223 = Object.assign(t, {
                  text: r,
                  range: n
                });
                "object" == typeof a && Object.assign(_s223, a), this.fire("matched:".concat(e), _s223);
              }
            }
          }]);
          return w;
        }();
        (0, k.Z)(w, _.Z);
        var v = s("./packages/ckeditor5-utils/src/keyboard.js");
        var y = /*#__PURE__*/function (_o$Z55) {
          _inherits(y, _o$Z55);
          _createClass(y, null, [{
            key: "pluginName",
            get: function get() {
              return "TwoStepCaretMovement";
            }
          }]);
          function y(e) {
            var _this166;
            _classCallCheck(this, y);
            _this166 = _possibleConstructorReturn(this, _getPrototypeOf(y).call(this, e)), _this166.attributes = new Set(), _this166._overrideUid = null;
            return _this166;
          }
          _createClass(y, [{
            key: "init",
            value: function init() {
              var _this167 = this;
              var e = this.editor,
                t = e.model,
                s = e.editing.view,
                o = e.locale,
                i = t.document.selection;
              this.listenTo(s.document, "arrowKey", function (e, t) {
                if (!i.isCollapsed) return;
                if (t.shiftKey || t.altKey || t.ctrlKey) return;
                var s = t.keyCode == v.Do.arrowright,
                  r = t.keyCode == v.Do.arrowleft;
                if (!s && !r) return;
                var n = o.contentLanguageDirection;
                var a = !1;
                a = "ltr" === n && s || "rtl" === n && r ? _this167._handleForwardMovement(t) : _this167._handleBackwardMovement(t), !0 === a && e.stop();
              }, {
                context: "$text",
                priority: "highest"
              }), this._isNextGravityRestorationSkipped = !1, this.listenTo(i, "change:range", function (e, t) {
                _this167._isNextGravityRestorationSkipped ? _this167._isNextGravityRestorationSkipped = !1 : _this167._isGravityOverridden && (!t.directChange && x(i.getFirstPosition(), _this167.attributes) || _this167._restoreGravity());
              });
            }
          }, {
            key: "registerAttribute",
            value: function registerAttribute(e) {
              this.attributes.add(e);
            }
          }, {
            key: "_handleForwardMovement",
            value: function _handleForwardMovement(e) {
              var t = this.attributes,
                s = this.editor.model.document.selection,
                o = s.getFirstPosition();
              return !this._isGravityOverridden && (!o.isAtStart || !Z(s, t)) && (x(o, t) ? (j(e), this._overrideGravity(), !0) : void 0);
            }
          }, {
            key: "_handleBackwardMovement",
            value: function _handleBackwardMovement(e) {
              var t = this.attributes,
                s = this.editor.model,
                o = s.document.selection,
                i = o.getFirstPosition();
              return this._isGravityOverridden ? (j(e), this._restoreGravity(), P(s, t, i), !0) : i.isAtStart ? !!Z(o, t) && (j(e), P(s, t, i), !0) : function (e, t) {
                return x(e.getShiftedBy(-1), t);
              }(i, t) ? i.isAtEnd && !Z(o, t) && x(i, t) ? (j(e), P(s, t, i), !0) : (this._isNextGravityRestorationSkipped = !0, this._overrideGravity(), !1) : void 0;
            }
          }, {
            key: "_overrideGravity",
            value: function _overrideGravity() {
              this._overrideUid = this.editor.model.change(function (e) {
                return e.overrideSelectionGravity();
              });
            }
          }, {
            key: "_restoreGravity",
            value: function _restoreGravity() {
              var _this168 = this;
              this.editor.model.change(function (e) {
                e.restoreSelectionGravity(_this168._overrideUid), _this168._overrideUid = null;
              });
            }
          }, {
            key: "_isGravityOverridden",
            get: function get() {
              return !!this._overrideUid;
            }
          }]);
          return y;
        }(o.Z);
        function Z(e, t) {
          var _iterator326 = _createForOfIteratorHelper(t),
            _step326;
          try {
            for (_iterator326.s(); !(_step326 = _iterator326.n()).done;) {
              var _s224 = _step326.value;
              if (e.hasAttribute(_s224)) return !0;
            }
          } catch (err) {
            _iterator326.e(err);
          } finally {
            _iterator326.f();
          }
          return !1;
        }
        function P(e, t, s) {
          var o = s.nodeBefore;
          e.change(function (e) {
            o ? e.setSelectionAttribute(o.getAttributes()) : e.removeSelectionAttribute(t);
          });
        }
        function j(e) {
          e.preventDefault();
        }
        function x(e, t) {
          var s = e.nodeBefore,
            o = e.nodeAfter;
          var _iterator327 = _createForOfIteratorHelper(t),
            _step327;
          try {
            for (_iterator327.s(); !(_step327 = _iterator327.n()).done;) {
              var _e254 = _step327.value;
              var _t227 = s ? s.getAttribute(_e254) : void 0;
              if ((o ? o.getAttribute(_e254) : void 0) !== _t227) return !0;
            }
          } catch (err) {
            _iterator327.e(err);
          } finally {
            _iterator327.f();
          }
          return !1;
        }
        var A = s("./node_modules/lodash-es/toString.js"),
          T = /[\\^$.*+?()[\]{}|]/g,
          C = RegExp(T.source);
        var E = function E(e) {
            return (e = (0, A.Z)(e)) && C.test(e) ? e.replace(T, "\\$&") : e;
          },
          S = {
            copyright: {
              from: "(c)",
              to: "©"
            },
            registeredTrademark: {
              from: "(r)",
              to: "®"
            },
            trademark: {
              from: "(tm)",
              to: "™"
            },
            oneHalf: {
              from: /(^|[^/a-z0-9])(1\/2)([^/a-z0-9])$/i,
              to: [null, "½", null]
            },
            oneThird: {
              from: /(^|[^/a-z0-9])(1\/3)([^/a-z0-9])$/i,
              to: [null, "⅓", null]
            },
            twoThirds: {
              from: /(^|[^/a-z0-9])(2\/3)([^/a-z0-9])$/i,
              to: [null, "⅔", null]
            },
            oneForth: {
              from: /(^|[^/a-z0-9])(1\/4)([^/a-z0-9])$/i,
              to: [null, "¼", null]
            },
            threeQuarters: {
              from: /(^|[^/a-z0-9])(3\/4)([^/a-z0-9])$/i,
              to: [null, "¾", null]
            },
            lessThanOrEqual: {
              from: "<=",
              to: "≤"
            },
            greaterThanOrEqual: {
              from: ">=",
              to: "≥"
            },
            notEqual: {
              from: "!=",
              to: "≠"
            },
            arrowLeft: {
              from: "<-",
              to: "←"
            },
            arrowRight: {
              from: "->",
              to: "→"
            },
            horizontalEllipsis: {
              from: "...",
              to: "…"
            },
            enDash: {
              from: /(^| )(--)( )$/,
              to: [null, "–", null]
            },
            emDash: {
              from: /(^| )(---)( )$/,
              to: [null, "—", null]
            },
            quotesPrimary: {
              from: V('"'),
              to: [null, "“", null, "”"]
            },
            quotesSecondary: {
              from: V("'"),
              to: [null, "‘", null, "’"]
            },
            quotesPrimaryEnGb: {
              from: V("'"),
              to: [null, "‘", null, "’"]
            },
            quotesSecondaryEnGb: {
              from: V('"'),
              to: [null, "“", null, "”"]
            },
            quotesPrimaryPl: {
              from: V('"'),
              to: [null, "„", null, "”"]
            },
            quotesSecondaryPl: {
              from: V("'"),
              to: [null, "‚", null, "’"]
            }
          },
          R = {
            symbols: ["copyright", "registeredTrademark", "trademark"],
            mathematical: ["oneHalf", "oneThird", "twoThirds", "oneForth", "threeQuarters", "lessThanOrEqual", "greaterThanOrEqual", "notEqual", "arrowLeft", "arrowRight"],
            typography: ["horizontalEllipsis", "enDash", "emDash"],
            quotes: ["quotesPrimary", "quotesSecondary"]
          },
          O = ["symbols", "mathematical", "typography", "quotes"];
        var M = /*#__PURE__*/function (_o$Z56) {
          _inherits(M, _o$Z56);
          _createClass(M, null, [{
            key: "requires",
            get: function get() {
              return ["Delete", "Input"];
            }
          }, {
            key: "pluginName",
            get: function get() {
              return "TextTransformation";
            }
          }]);
          function M(e) {
            var _this169;
            _classCallCheck(this, M);
            _this169 = _possibleConstructorReturn(this, _getPrototypeOf(M).call(this, e)), e.config.define("typing", {
              transformations: {
                include: O
              }
            });
            return _this169;
          }
          _createClass(M, [{
            key: "init",
            value: function init() {
              var _this170 = this;
              var e = this.editor.model.document.selection;
              e.on("change:range", function () {
                _this170.isEnabled = !e.anchor.parent.is("element", "codeBlock");
              }), this._enableTransformationWatchers();
            }
          }, {
            key: "_enableTransformationWatchers",
            value: function _enableTransformationWatchers() {
              var e = this.editor,
                t = e.model,
                s = e.plugins.get("Delete"),
                o = function (e) {
                  var t = e.extra || [],
                    s = e.remove || [],
                    o = function o(e) {
                      return !s.includes(e);
                    };
                  return function (e) {
                    var t = new Set();
                    var _iterator328 = _createForOfIteratorHelper(e),
                      _step328;
                    try {
                      for (_iterator328.s(); !(_step328 = _iterator328.n()).done;) {
                        var _s225 = _step328.value;
                        if (R[_s225]) {
                          var _iterator329 = _createForOfIteratorHelper(R[_s225]),
                            _step329;
                          try {
                            for (_iterator329.s(); !(_step329 = _iterator329.n()).done;) {
                              var _e255 = _step329.value;
                              t.add(_e255);
                            }
                          } catch (err) {
                            _iterator329.e(err);
                          } finally {
                            _iterator329.f();
                          }
                        } else t.add(_s225);
                      }
                    } catch (err) {
                      _iterator328.e(err);
                    } finally {
                      _iterator328.f();
                    }
                    return Array.from(t);
                  }(e.include.concat(t).filter(o)).filter(o).map(function (e) {
                    return S[e] || e;
                  }).filter(function (e) {
                    return "object" == typeof e;
                  }).map(function (e) {
                    return {
                      from: N(e.from),
                      to: I(e.to)
                    };
                  });
                }(e.config.get("typing.transformations")),
                i = new w(e.model, function (e) {
                  var _iterator330 = _createForOfIteratorHelper(o),
                    _step330;
                  try {
                    for (_iterator330.s(); !(_step330 = _iterator330.n()).done;) {
                      var _t228 = _step330.value;
                      if (_t228.from.test(e)) return {
                        normalizedTransformation: _t228
                      };
                    }
                  } catch (err) {
                    _iterator330.e(err);
                  } finally {
                    _iterator330.f();
                  }
                });
              i.on("matched:data", function (e, o) {
                if (!o.batch.isTyping) return;
                var _o$normalizedTransfor = o.normalizedTransformation,
                  i = _o$normalizedTransfor.from,
                  r = _o$normalizedTransfor.to,
                  n = i.exec(o.text),
                  a = r(n.slice(1)),
                  c = o.range;
                var l = n.index;
                t.enqueueChange(function (e) {
                  for (var _s226 = 1; _s226 < n.length; _s226++) {
                    var _o148 = n[_s226],
                      _i118 = a[_s226 - 1];
                    if (null == _i118) {
                      l += _o148.length;
                      continue;
                    }
                    var _r58 = c.start.getShiftedBy(l),
                      _d2 = t.createRange(_r58, _r58.getShiftedBy(_o148.length)),
                      _h2 = z(_r58);
                    t.insertContent(e.createText(_i118, _h2), _d2), l += _i118.length;
                  }
                  t.enqueueChange(function () {
                    s.requestUndoOnBackspace();
                  });
                });
              }), i.bind("isEnabled").to(this);
            }
          }]);
          return M;
        }(o.Z);
        function N(e) {
          return "string" == typeof e ? new RegExp("(".concat(E(e), ")$")) : e;
        }
        function I(e) {
          return "string" == typeof e ? function () {
            return [e];
          } : e instanceof Array ? function () {
            return e;
          } : e;
        }
        function z(e) {
          return (e.textNode ? e.textNode : e.nodeAfter).getAttributes();
        }
        function V(e) {
          return new RegExp("(^|\\s)(".concat(e, ")([^").concat(e, "]*)(").concat(e, ")$"));
        }
        function D(e, t, s, o) {
          return o.createRange(B(e, t, s, !0, o), B(e, t, s, !1, o));
        }
        function B(e, t, s, o, i) {
          var r = e.textNode || (o ? e.nodeBefore : e.nodeAfter),
            n = null;
          for (; r && r.getAttribute(t) == s;) n = r, r = o ? r.previousSibling : r.nextSibling;
          return n ? i.createPositionAt(n, o ? "before" : "after") : e;
        }
        function F(e, t, s, o) {
          var i = e.editing.view,
            r = new Set();
          i.document.registerPostFixer(function (i) {
            var n = e.model.document.selection;
            var a = !1;
            if (n.hasAttribute(t)) {
              var _c12 = D(n.getFirstPosition(), t, n.getAttribute(t), e.model),
                _l4 = e.editing.mapper.toViewRange(_c12);
              var _iterator331 = _createForOfIteratorHelper(_l4.getItems()),
                _step331;
              try {
                for (_iterator331.s(); !(_step331 = _iterator331.n()).done;) {
                  var _e256 = _step331.value;
                  _e256.is("element", s) && !_e256.hasClass(o) && (i.addClass(o, _e256), r.add(_e256), a = !0);
                }
              } catch (err) {
                _iterator331.e(err);
              } finally {
                _iterator331.f();
              }
            }
            return a;
          }), e.conversion.for("editingDowncast").add(function (e) {
            function t() {
              i.change(function (e) {
                var _iterator332 = _createForOfIteratorHelper(r.values()),
                  _step332;
                try {
                  for (_iterator332.s(); !(_step332 = _iterator332.n()).done;) {
                    var _t229 = _step332.value;
                    e.removeClass(o, _t229), r.delete(_t229);
                  }
                } catch (err) {
                  _iterator332.e(err);
                } finally {
                  _iterator332.f();
                }
              });
            }
            e.on("insert", t, {
              priority: "highest"
            }), e.on("remove", t, {
              priority: "highest"
            }), e.on("attribute", t, {
              priority: "highest"
            }), e.on("selection", t, {
              priority: "highest"
            });
          });
        }
      },
      "./src/ui.js": function _src_uiJs(e, t, s) {
        "use strict";

        s.r(t), s.d(t, {
          BalloonPanelView: function BalloonPanelView() {
            return he.Z;
          },
          BalloonToolbar: function BalloonToolbar() {
            return Ee;
          },
          BlockToolbar: function BlockToolbar() {
            return Ve;
          },
          BodyCollection: function BodyCollection() {
            return l;
          },
          BoxedEditorUIView: function BoxedEditorUIView() {
            return V;
          },
          ButtonView: function ButtonView() {
            return d.Z;
          },
          ColorGridView: function ColorGridView() {
            return P;
          },
          ColorTileView: function ColorTileView() {
            return m;
          },
          ContextualBalloon: function ContextualBalloon() {
            return ue.Z;
          },
          DropdownButtonView: function DropdownButtonView() {
            return j.Z;
          },
          EditorUIView: function EditorUIView() {
            return O;
          },
          FocusCycler: function FocusCycler() {
            return _.Z;
          },
          FormHeaderView: function FormHeaderView() {
            return W;
          },
          IconView: function IconView() {
            return q.Z;
          },
          IframeView: function IframeView() {
            return J;
          },
          InlineEditableUIView: function InlineEditableUIView() {
            return B;
          },
          InputNumberView: function InputNumberView() {
            return G;
          },
          InputTextView: function InputTextView() {
            return K;
          },
          InputView: function InputView() {
            return U;
          },
          LabelView: function LabelView() {
            return z;
          },
          LabeledFieldView: function LabeledFieldView() {
            return Y;
          },
          ListItemView: function ListItemView() {
            return oe.Z;
          },
          ListView: function ListView() {
            return ie.Z;
          },
          Model: function Model() {
            return de;
          },
          Notification: function Notification() {
            return ne;
          },
          SplitButtonView: function SplitButtonView() {
            return C;
          },
          StickyPanelView: function StickyPanelView() {
            return _e;
          },
          SwitchButtonView: function SwitchButtonView() {
            return h.Z;
          },
          Template: function Template() {
            return n.ZP;
          },
          ToolbarSeparatorView: function ToolbarSeparatorView() {
            return ve.Z;
          },
          ToolbarView: function ToolbarView() {
            return we.Z;
          },
          TooltipView: function TooltipView() {
            return be.Z;
          },
          View: function View() {
            return f.Z;
          },
          ViewCollection: function ViewCollection() {
            return a.Z;
          },
          addListToDropdown: function addListToDropdown() {
            return E.Pm;
          },
          addToolbarToDropdown: function addToolbarToDropdown() {
            return E.up;
          },
          clickOutsideHandler: function clickOutsideHandler() {
            return o.Z;
          },
          createDropdown: function createDropdown() {
            return E.t9;
          },
          createLabeledDropdown: function createLabeledDropdown() {
            return se;
          },
          createLabeledInputNumber: function createLabeledInputNumber() {
            return te;
          },
          createLabeledInputText: function createLabeledInputText() {
            return ee;
          },
          enableToolbarKeyboardFocus: function enableToolbarKeyboardFocus() {
            return ye;
          },
          getLocalizedColorOptions: function getLocalizedColorOptions() {
            return u;
          },
          injectCssTransitionDisabler: function injectCssTransitionDisabler() {
            return i;
          },
          normalizeColorOptions: function normalizeColorOptions() {
            return g;
          },
          normalizeSingleColorDefinition: function normalizeSingleColorDefinition() {
            return p;
          },
          normalizeToolbarConfig: function normalizeToolbarConfig() {
            return Ze.Z;
          },
          submitHandler: function submitHandler() {
            return r;
          }
        });
        var o = s("./packages/ckeditor5-ui/src/bindings/clickoutsidehandler.js");
        function i(e) {
          e.set("_isCssTransitionsDisabled", !1), e.disableCssTransitions = function () {
            e._isCssTransitionsDisabled = !0;
          }, e.enableCssTransitions = function () {
            e._isCssTransitionsDisabled = !1;
          }, e.extendTemplate({
            attributes: {
              class: [e.bindTemplate.if("_isCssTransitionsDisabled", "ck-transitions-disabled")]
            }
          });
        }
        function r(_ref54) {
          var e = _ref54.view;
          e.listenTo(e.element, "submit", function (t, s) {
            s.preventDefault(), e.fire("submit");
          }, {
            useCapture: !0
          });
        }
        var n = s("./packages/ckeditor5-ui/src/template.js"),
          a = s("./packages/ckeditor5-ui/src/viewcollection.js"),
          c = s("./packages/ckeditor5-utils/src/dom/createelement.js");
        var l = /*#__PURE__*/function (_a$Z) {
          _inherits(l, _a$Z);
          function l(e) {
            var _this171;
            var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
            _classCallCheck(this, l);
            _this171 = _possibleConstructorReturn(this, _getPrototypeOf(l).call(this, t)), _this171.locale = e;
            return _this171;
          }
          _createClass(l, [{
            key: "attachToDom",
            value: function attachToDom() {
              this._bodyCollectionContainer = new n.ZP({
                tag: "div",
                attributes: {
                  class: ["ck", "ck-reset_all", "ck-body", "ck-rounded-corners"],
                  dir: this.locale.uiLanguageDirection
                },
                children: this
              }).render();
              var e = document.querySelector(".ck-body-wrapper");
              e || (e = (0, c.Z)(document, "div", {
                class: "ck-body-wrapper"
              }), document.body.appendChild(e)), e.appendChild(this._bodyCollectionContainer);
            }
          }, {
            key: "detachFromDom",
            value: function detachFromDom() {
              _superPropGet(l, "destroy", this, 3)([]), this._bodyCollectionContainer && this._bodyCollectionContainer.remove();
              var e = document.querySelector(".ck-body-wrapper");
              e && 0 == e.childElementCount && e.remove();
            }
          }]);
          return l;
        }(a.Z);
        var d = s("./packages/ckeditor5-ui/src/button/buttonview.js"),
          h = s("./packages/ckeditor5-ui/src/button/switchbuttonview.js");
        function u(e, t) {
          var s = e.t,
            o = {
              Black: s("Black"),
              "Dim grey": s("Dim grey"),
              Grey: s("Grey"),
              "Light grey": s("Light grey"),
              White: s("White"),
              Red: s("Red"),
              Orange: s("Orange"),
              Yellow: s("Yellow"),
              "Light green": s("Light green"),
              Green: s("Green"),
              Aquamarine: s("Aquamarine"),
              Turquoise: s("Turquoise"),
              "Light blue": s("Light blue"),
              Blue: s("Blue"),
              Purple: s("Purple")
            };
          return t.map(function (e) {
            var t = o[e.label];
            return t && t != e.label && (e.label = t), e;
          });
        }
        function g(e) {
          return e.map(p).filter(function (e) {
            return !!e;
          });
        }
        function p(e) {
          return "string" == typeof e ? {
            model: e,
            label: e,
            hasBorder: !1,
            view: {
              name: "span",
              styles: {
                color: e
              }
            }
          } : {
            model: e.color,
            label: e.label || e.color,
            hasBorder: void 0 !== e.hasBorder && e.hasBorder,
            view: {
              name: "span",
              styles: {
                color: "".concat(e.color)
              }
            }
          };
        }
        var f = s("./packages/ckeditor5-ui/src/view.js");
        var m = /*#__PURE__*/function (_d$Z3) {
          _inherits(m, _d$Z3);
          function m(e) {
            var _this172;
            _classCallCheck(this, m);
            _this172 = _possibleConstructorReturn(this, _getPrototypeOf(m).call(this, e));
            var t = _this172.bindTemplate;
            _this172.set("color"), _this172.set("hasBorder"), _this172.icon = '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path class="ck-icon__fill" d="M16.935 5.328a2 2 0 0 1 0 2.829l-7.778 7.778a2 2 0 0 1-2.829 0L3.5 13.107a1.999 1.999 0 1 1 2.828-2.829l.707.707a1 1 0 0 0 1.414 0l5.658-5.657a2 2 0 0 1 2.828 0z"/><path d="M14.814 6.035 8.448 12.4a1 1 0 0 1-1.414 0l-1.413-1.415A1 1 0 1 0 4.207 12.4l2.829 2.829a1 1 0 0 0 1.414 0l7.778-7.778a1 1 0 1 0-1.414-1.415z"/></svg>', _this172.extendTemplate({
              attributes: {
                style: {
                  backgroundColor: t.to("color")
                },
                class: ["ck", "ck-color-grid__tile", t.if("hasBorder", "ck-color-table__color-tile_bordered")]
              }
            });
            return _this172;
          }
          _createClass(m, [{
            key: "render",
            value: function render() {
              _superPropGet(m, "render", this, 3)([]), this.iconView.fillColor = "hsl(0, 0%, 100%)";
            }
          }]);
          return m;
        }(d.Z);
        var k = s("./packages/ckeditor5-utils/src/focustracker.js"),
          _ = s("./packages/ckeditor5-ui/src/focuscycler.js"),
          b = s("./packages/ckeditor5-utils/src/keystrokehandler.js"),
          w = s("./node_modules/style-loader/dist/runtime/injectStylesIntoStyleTag.js"),
          v = s.n(w),
          y = s("./node_modules/css-loader/dist/cjs.js!./node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].use[2]!./packages/ckeditor5-ui/theme/components/colorgrid/colorgrid.css"),
          Z = {
            injectType: "singletonStyleTag",
            attributes: {
              "data-cke": !0
            },
            insert: "head",
            singleton: !0
          };
        v()(y.Z, Z);
        y.Z.locals;
        var P = /*#__PURE__*/function (_f$Z) {
          _inherits(P, _f$Z);
          function P(e, t) {
            var _this173;
            _classCallCheck(this, P);
            _this173 = _possibleConstructorReturn(this, _getPrototypeOf(P).call(this, e));
            var s = t && t.colorDefinitions || [],
              o = {};
            t && t.columns && (o.gridTemplateColumns = "repeat( ".concat(t.columns, ", 1fr)")), _this173.set("selectedColor"), _this173.items = _this173.createCollection(), _this173.focusTracker = new k.Z(), _this173.keystrokes = new b.Z(), _this173._focusCycler = new _.Z({
              focusables: _this173.items,
              focusTracker: _this173.focusTracker,
              keystrokeHandler: _this173.keystrokes,
              actions: {
                focusPrevious: "arrowleft",
                focusNext: "arrowright"
              }
            }), _this173.items.on("add", function (e, t) {
              t.isOn = t.color === _this173.selectedColor;
            }), s.forEach(function (e) {
              var t = new m();
              t.set({
                color: e.color,
                label: e.label,
                tooltip: !0,
                hasBorder: e.options.hasBorder
              }), t.on("execute", function () {
                _this173.fire("execute", {
                  value: e.color,
                  hasBorder: e.options.hasBorder,
                  label: e.label
                });
              }), _this173.items.add(t);
            }), _this173.setTemplate({
              tag: "div",
              children: _this173.items,
              attributes: {
                class: ["ck", "ck-color-grid"],
                style: o
              }
            }), _this173.on("change:selectedColor", function (e, t, s) {
              var _iterator333 = _createForOfIteratorHelper(_this173.items),
                _step333;
              try {
                for (_iterator333.s(); !(_step333 = _iterator333.n()).done;) {
                  var _e257 = _step333.value;
                  _e257.isOn = _e257.color === s;
                }
              } catch (err) {
                _iterator333.e(err);
              } finally {
                _iterator333.f();
              }
            });
            return _this173;
          }
          _createClass(P, [{
            key: "focus",
            value: function focus() {
              this.items.length && this.items.first.focus();
            }
          }, {
            key: "focusLast",
            value: function focusLast() {
              this.items.length && this.items.last.focus();
            }
          }, {
            key: "render",
            value: function render() {
              var _this174 = this;
              _superPropGet(P, "render", this, 3)([]);
              var _iterator334 = _createForOfIteratorHelper(this.items),
                _step334;
              try {
                for (_iterator334.s(); !(_step334 = _iterator334.n()).done;) {
                  var _e258 = _step334.value;
                  this.focusTracker.add(_e258.element);
                }
              } catch (err) {
                _iterator334.e(err);
              } finally {
                _iterator334.f();
              }
              this.items.on("add", function (e, t) {
                _this174.focusTracker.add(t.element);
              }), this.items.on("remove", function (e, t) {
                _this174.focusTracker.remove(t.element);
              }), this.keystrokes.listenTo(this.element);
            }
          }, {
            key: "destroy",
            value: function destroy() {
              _superPropGet(P, "destroy", this, 3)([]), this.focusTracker.destroy(), this.keystrokes.destroy();
            }
          }]);
          return P;
        }(f.Z);
        var j = s("./packages/ckeditor5-ui/src/dropdown/button/dropdownbuttonview.js"),
          x = s("./packages/ckeditor5-ui/theme/icons/dropdown-arrow.svg"),
          A = s("./node_modules/css-loader/dist/cjs.js!./node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].use[2]!./packages/ckeditor5-ui/theme/components/dropdown/splitbutton.css"),
          T = {
            injectType: "singletonStyleTag",
            attributes: {
              "data-cke": !0
            },
            insert: "head",
            singleton: !0
          };
        v()(A.Z, T);
        A.Z.locals;
        var C = /*#__PURE__*/function (_f$Z2) {
          _inherits(C, _f$Z2);
          function C(e) {
            var _this175;
            _classCallCheck(this, C);
            _this175 = _possibleConstructorReturn(this, _getPrototypeOf(C).call(this, e));
            var t = _this175.bindTemplate;
            _this175.set("class"), _this175.set("icon"), _this175.set("isEnabled", !0), _this175.set("isOn", !1), _this175.set("isToggleable", !1), _this175.set("isVisible", !0), _this175.set("keystroke"), _this175.set("label"), _this175.set("tabindex", -1), _this175.set("tooltip"), _this175.set("tooltipPosition", "s"), _this175.set("type", "button"), _this175.set("withText", !1), _this175.children = _this175.createCollection(), _this175.actionView = _this175._createActionView(), _this175.arrowView = _this175._createArrowView(), _this175.keystrokes = new b.Z(), _this175.focusTracker = new k.Z(), _this175.setTemplate({
              tag: "div",
              attributes: {
                class: ["ck", "ck-splitbutton", t.to("class"), t.if("isVisible", "ck-hidden", function (e) {
                  return !e;
                }), _this175.arrowView.bindTemplate.if("isOn", "ck-splitbutton_open")]
              },
              children: _this175.children
            });
            return _this175;
          }
          _createClass(C, [{
            key: "render",
            value: function render() {
              var _this176 = this;
              _superPropGet(C, "render", this, 3)([]), this.children.add(this.actionView), this.children.add(this.arrowView), this.focusTracker.add(this.actionView.element), this.focusTracker.add(this.arrowView.element), this.keystrokes.listenTo(this.element), this.keystrokes.set("arrowright", function (e, t) {
                _this176.focusTracker.focusedElement === _this176.actionView.element && (_this176.arrowView.focus(), t());
              }), this.keystrokes.set("arrowleft", function (e, t) {
                _this176.focusTracker.focusedElement === _this176.arrowView.element && (_this176.actionView.focus(), t());
              });
            }
          }, {
            key: "destroy",
            value: function destroy() {
              _superPropGet(C, "destroy", this, 3)([]), this.focusTracker.destroy(), this.keystrokes.destroy();
            }
          }, {
            key: "focus",
            value: function focus() {
              this.actionView.focus();
            }
          }, {
            key: "_createActionView",
            value: function _createActionView() {
              var e = new d.Z();
              return e.bind("icon", "isEnabled", "isOn", "isToggleable", "keystroke", "label", "tabindex", "tooltip", "tooltipPosition", "type", "withText").to(this), e.extendTemplate({
                attributes: {
                  class: "ck-splitbutton__action"
                }
              }), e.delegate("execute").to(this), e;
            }
          }, {
            key: "_createArrowView",
            value: function _createArrowView() {
              var e = new d.Z(),
                t = e.bindTemplate;
              return e.icon = x.Z, e.extendTemplate({
                attributes: {
                  class: "ck-splitbutton__arrow",
                  "aria-haspopup": !0,
                  "aria-expanded": t.to("isOn", function (e) {
                    return String(e);
                  })
                }
              }), e.bind("isEnabled").to(this), e.delegate("execute").to(this, "open"), e;
            }
          }]);
          return C;
        }(f.Z);
        var E = s("./packages/ckeditor5-ui/src/dropdown/utils.js"),
          S = s("./node_modules/css-loader/dist/cjs.js!./node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].use[2]!./packages/ckeditor5-ui/theme/components/editorui/editorui.css"),
          R = {
            injectType: "singletonStyleTag",
            attributes: {
              "data-cke": !0
            },
            insert: "head",
            singleton: !0
          };
        v()(S.Z, R);
        S.Z.locals;
        var O = /*#__PURE__*/function (_f$Z3) {
          _inherits(O, _f$Z3);
          function O(e) {
            var _this177;
            _classCallCheck(this, O);
            _this177 = _possibleConstructorReturn(this, _getPrototypeOf(O).call(this, e)), _this177.body = new l(e);
            return _this177;
          }
          _createClass(O, [{
            key: "render",
            value: function render() {
              _superPropGet(O, "render", this, 3)([]), this.body.attachToDom();
            }
          }, {
            key: "destroy",
            value: function destroy() {
              return this.body.detachFromDom(), _superPropGet(O, "destroy", this, 3)([]);
            }
          }]);
          return O;
        }(f.Z);
        var M = s("./packages/ckeditor5-utils/src/uid.js"),
          N = s("./node_modules/css-loader/dist/cjs.js!./node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].use[2]!./packages/ckeditor5-ui/theme/components/label/label.css"),
          I = {
            injectType: "singletonStyleTag",
            attributes: {
              "data-cke": !0
            },
            insert: "head",
            singleton: !0
          };
        v()(N.Z, I);
        N.Z.locals;
        var z = /*#__PURE__*/function (_f$Z4) {
          _inherits(z, _f$Z4);
          function z(e) {
            var _this178;
            _classCallCheck(this, z);
            _this178 = _possibleConstructorReturn(this, _getPrototypeOf(z).call(this, e)), _this178.set("text"), _this178.set("for"), _this178.id = "ck-editor__label_".concat((0, M.Z)());
            var t = _this178.bindTemplate;
            _this178.setTemplate({
              tag: "label",
              attributes: {
                class: ["ck", "ck-label"],
                id: _this178.id,
                for: t.to("for")
              },
              children: [{
                text: t.to("text")
              }]
            });
            return _this178;
          }
          return z;
        }(f.Z);
        var V = /*#__PURE__*/function (_O) {
          _inherits(V, _O);
          function V(e) {
            var _this179;
            _classCallCheck(this, V);
            _this179 = _possibleConstructorReturn(this, _getPrototypeOf(V).call(this, e)), _this179.top = _this179.createCollection(), _this179.main = _this179.createCollection(), _this179._voiceLabelView = _this179._createVoiceLabel(), _this179.setTemplate({
              tag: "div",
              attributes: {
                class: ["ck", "ck-reset", "ck-editor", "ck-rounded-corners"],
                role: "application",
                dir: e.uiLanguageDirection,
                lang: e.uiLanguage,
                "aria-labelledby": _this179._voiceLabelView.id
              },
              children: [_this179._voiceLabelView, {
                tag: "div",
                attributes: {
                  class: ["ck", "ck-editor__top", "ck-reset_all"],
                  role: "presentation"
                },
                children: _this179.top
              }, {
                tag: "div",
                attributes: {
                  class: ["ck", "ck-editor__main"],
                  role: "presentation"
                },
                children: _this179.main
              }]
            });
            return _this179;
          }
          _createClass(V, [{
            key: "_createVoiceLabel",
            value: function _createVoiceLabel() {
              var e = this.t,
                t = new z();
              return t.text = e("Rich Text Editor"), t.extendTemplate({
                attributes: {
                  class: "ck-voice-label"
                }
              }), t;
            }
          }]);
          return V;
        }(O);
        var D = /*#__PURE__*/function (_f$Z5) {
          _inherits(D, _f$Z5);
          function D(e, t, s) {
            var _this180;
            _classCallCheck(this, D);
            _this180 = _possibleConstructorReturn(this, _getPrototypeOf(D).call(this, e)), _this180.setTemplate({
              tag: "div",
              attributes: {
                class: ["ck", "ck-content", "ck-editor__editable", "ck-rounded-corners"],
                lang: e.contentLanguage,
                dir: e.contentLanguageDirection
              }
            }), _this180.name = null, _this180.set("isFocused", !1), _this180._editableElement = s, _this180._hasExternalElement = !!_this180._editableElement, _this180._editingView = t;
            return _this180;
          }
          _createClass(D, [{
            key: "render",
            value: function render() {
              var _this181 = this;
              _superPropGet(D, "render", this, 3)([]), this._hasExternalElement ? this.template.apply(this.element = this._editableElement) : this._editableElement = this.element, this.on("change:isFocused", function () {
                return _this181._updateIsFocusedClasses();
              }), this._updateIsFocusedClasses();
            }
          }, {
            key: "destroy",
            value: function destroy() {
              this._hasExternalElement && this.template.revert(this._editableElement), _superPropGet(D, "destroy", this, 3)([]);
            }
          }, {
            key: "_updateIsFocusedClasses",
            value: function _updateIsFocusedClasses() {
              var e = this._editingView;
              function t(t) {
                e.change(function (s) {
                  var o = e.document.getRoot(t.name);
                  s.addClass(t.isFocused ? "ck-focused" : "ck-blurred", o), s.removeClass(t.isFocused ? "ck-blurred" : "ck-focused", o);
                });
              }
              e.isRenderingInProgress ? function s(o) {
                e.once("change:isRenderingInProgress", function (e, i, r) {
                  r ? s(o) : t(o);
                });
              }(this) : t(this);
            }
          }]);
          return D;
        }(f.Z);
        var B = /*#__PURE__*/function (_D) {
          _inherits(B, _D);
          function B(e, t, s) {
            var _this182;
            _classCallCheck(this, B);
            _this182 = _possibleConstructorReturn(this, _getPrototypeOf(B).call(this, e, t, s)), _this182.extendTemplate({
              attributes: {
                role: "textbox",
                class: "ck-editor__editable_inline"
              }
            });
            return _this182;
          }
          _createClass(B, [{
            key: "render",
            value: function render() {
              var _this183 = this;
              _superPropGet(B, "render", this, 3)([]);
              var e = this._editingView,
                t = this.t;
              e.change(function (s) {
                var o = e.document.getRoot(_this183.name);
                s.setAttribute("aria-label", t("Rich Text Editor, %0", _this183.name), o);
              });
            }
          }]);
          return B;
        }(D);
        var F = s("./node_modules/css-loader/dist/cjs.js!./node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].use[2]!./packages/ckeditor5-ui/theme/components/formheader/formheader.css"),
          L = {
            injectType: "singletonStyleTag",
            attributes: {
              "data-cke": !0
            },
            insert: "head",
            singleton: !0
          };
        v()(F.Z, L);
        F.Z.locals;
        var W = /*#__PURE__*/function (_f$Z6) {
          _inherits(W, _f$Z6);
          function W(e) {
            var _this184;
            var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
            _classCallCheck(this, W);
            _this184 = _possibleConstructorReturn(this, _getPrototypeOf(W).call(this, e));
            var s = _this184.bindTemplate;
            _this184.set("label", t.label || ""), _this184.set("class", t.class || null), _this184.children = _this184.createCollection(), _this184.setTemplate({
              tag: "div",
              attributes: {
                class: ["ck", "ck-form__header", s.to("class")]
              },
              children: _this184.children
            });
            var o = new f.Z(e);
            o.setTemplate({
              tag: "span",
              attributes: {
                class: ["ck", "ck-form__header__label"]
              },
              children: [{
                text: s.to("label")
              }]
            }), _this184.children.add(o);
            return _this184;
          }
          return W;
        }(f.Z);
        var q = s("./packages/ckeditor5-ui/src/icon/iconview.js"),
          H = s("./node_modules/css-loader/dist/cjs.js!./node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].use[2]!./packages/ckeditor5-ui/theme/components/input/input.css"),
          $ = {
            injectType: "singletonStyleTag",
            attributes: {
              "data-cke": !0
            },
            insert: "head",
            singleton: !0
          };
        v()(H.Z, $);
        H.Z.locals;
        var U = /*#__PURE__*/function (_f$Z7) {
          _inherits(U, _f$Z7);
          function U(e) {
            var _this185;
            _classCallCheck(this, U);
            _this185 = _possibleConstructorReturn(this, _getPrototypeOf(U).call(this, e)), _this185.set("value"), _this185.set("id"), _this185.set("placeholder"), _this185.set("isReadOnly", !1), _this185.set("hasError", !1), _this185.set("ariaDescribedById"), _this185.focusTracker = new k.Z(), _this185.bind("isFocused").to(_this185.focusTracker), _this185.set("isEmpty", !0), _this185.set("inputMode", "text");
            var t = _this185.bindTemplate;
            _this185.setTemplate({
              tag: "input",
              attributes: {
                class: ["ck", "ck-input", t.if("isFocused", "ck-input_focused"), t.if("isEmpty", "ck-input-text_empty"), t.if("hasError", "ck-error")],
                id: t.to("id"),
                placeholder: t.to("placeholder"),
                readonly: t.to("isReadOnly"),
                inputmode: t.to("inputMode"),
                "aria-invalid": t.if("hasError", !0),
                "aria-describedby": t.to("ariaDescribedById")
              },
              on: {
                input: t.to(function () {
                  var _this186;
                  for (var _len21 = arguments.length, e = new Array(_len21), _key21 = 0; _key21 < _len21; _key21++) {
                    e[_key21] = arguments[_key21];
                  }
                  (_this186 = _this185).fire.apply(_this186, ["input"].concat(e)), _this185._updateIsEmpty();
                }),
                change: t.to(_this185._updateIsEmpty.bind(_assertThisInitialized(_assertThisInitialized(_this185))))
              }
            });
            return _this185;
          }
          _createClass(U, [{
            key: "render",
            value: function render() {
              var _this187 = this;
              _superPropGet(U, "render", this, 3)([]), this.focusTracker.add(this.element), this._setDomElementValue(this.value), this._updateIsEmpty(), this.on("change:value", function (e, t, s) {
                _this187._setDomElementValue(s), _this187._updateIsEmpty();
              });
            }
          }, {
            key: "destroy",
            value: function destroy() {
              _superPropGet(U, "destroy", this, 3)([]), this.focusTracker.destroy();
            }
          }, {
            key: "select",
            value: function select() {
              this.element.select();
            }
          }, {
            key: "focus",
            value: function focus() {
              this.element.focus();
            }
          }, {
            key: "_updateIsEmpty",
            value: function _updateIsEmpty() {
              this.isEmpty = !this.element.value;
            }
          }, {
            key: "_setDomElementValue",
            value: function _setDomElementValue(e) {
              this.element.value = e || 0 === e ? e : "";
            }
          }]);
          return U;
        }(f.Z);
        var K = /*#__PURE__*/function (_U) {
          _inherits(K, _U);
          function K(e) {
            var _this188;
            _classCallCheck(this, K);
            _this188 = _possibleConstructorReturn(this, _getPrototypeOf(K).call(this, e)), _this188.extendTemplate({
              attributes: {
                type: "text",
                class: ["ck-input-text"]
              }
            });
            return _this188;
          }
          return K;
        }(U);
        var G = /*#__PURE__*/function (_U2) {
          _inherits(G, _U2);
          function G(e) {
            var _this189;
            var _ref55 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
              t = _ref55.min,
              s = _ref55.max,
              o = _ref55.step;
            _classCallCheck(this, G);
            _this189 = _possibleConstructorReturn(this, _getPrototypeOf(G).call(this, e));
            var i = _this189.bindTemplate;
            _this189.set("min", t), _this189.set("max", s), _this189.set("step", o), _this189.extendTemplate({
              attributes: {
                type: "number",
                class: ["ck-input-number"],
                min: i.to("min"),
                max: i.to("max"),
                step: i.to("step")
              }
            });
            return _this189;
          }
          return G;
        }(U);
        var J = /*#__PURE__*/function (_f$Z8) {
          _inherits(J, _f$Z8);
          function J(e) {
            var _this190;
            _classCallCheck(this, J);
            _this190 = _possibleConstructorReturn(this, _getPrototypeOf(J).call(this, e));
            var t = _this190.bindTemplate;
            _this190.setTemplate({
              tag: "iframe",
              attributes: {
                class: ["ck", "ck-reset_all"],
                sandbox: "allow-same-origin allow-scripts"
              },
              on: {
                load: t.to("loaded")
              }
            });
            return _this190;
          }
          _createClass(J, [{
            key: "render",
            value: function render() {
              var _this191 = this;
              return new Promise(function (e) {
                _this191.on("loaded", e), _superPropGet(J, "render", _this191, 3)([]);
              });
            }
          }]);
          return J;
        }(f.Z);
        var X = s("./node_modules/css-loader/dist/cjs.js!./node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].use[2]!./packages/ckeditor5-ui/theme/components/labeledfield/labeledfieldview.css"),
          Q = {
            injectType: "singletonStyleTag",
            attributes: {
              "data-cke": !0
            },
            insert: "head",
            singleton: !0
          };
        v()(X.Z, Q);
        X.Z.locals;
        var Y = /*#__PURE__*/function (_f$Z9) {
          _inherits(Y, _f$Z9);
          function Y(e, t) {
            var _this192;
            _classCallCheck(this, Y);
            _this192 = _possibleConstructorReturn(this, _getPrototypeOf(Y).call(this, e));
            var s = "ck-labeled-field-view-".concat((0, M.Z)()),
              o = "ck-labeled-field-view-status-".concat((0, M.Z)());
            _this192.fieldView = t(_assertThisInitialized(_assertThisInitialized(_this192)), s, o), _this192.set("label"), _this192.set("isEnabled", !0), _this192.set("isEmpty", !0), _this192.set("isFocused", !1), _this192.set("errorText", null), _this192.set("infoText", null), _this192.set("class"), _this192.set("placeholder"), _this192.labelView = _this192._createLabelView(s), _this192.statusView = _this192._createStatusView(o), _this192.bind("_statusText").to(_assertThisInitialized(_assertThisInitialized(_this192)), "errorText", _assertThisInitialized(_assertThisInitialized(_this192)), "infoText", function (e, t) {
              return e || t;
            });
            var i = _this192.bindTemplate;
            _this192.setTemplate({
              tag: "div",
              attributes: {
                class: ["ck", "ck-labeled-field-view", i.to("class"), i.if("isEnabled", "ck-disabled", function (e) {
                  return !e;
                }), i.if("isEmpty", "ck-labeled-field-view_empty"), i.if("isFocused", "ck-labeled-field-view_focused"), i.if("placeholder", "ck-labeled-field-view_placeholder"), i.if("errorText", "ck-error")]
              },
              children: [{
                tag: "div",
                attributes: {
                  class: ["ck", "ck-labeled-field-view__input-wrapper"]
                },
                children: [_this192.fieldView, _this192.labelView]
              }, _this192.statusView]
            });
            return _this192;
          }
          _createClass(Y, [{
            key: "_createLabelView",
            value: function _createLabelView(e) {
              var t = new z(this.locale);
              return t.for = e, t.bind("text").to(this, "label"), t;
            }
          }, {
            key: "_createStatusView",
            value: function _createStatusView(e) {
              var t = new f.Z(this.locale),
                s = this.bindTemplate;
              return t.setTemplate({
                tag: "div",
                attributes: {
                  class: ["ck", "ck-labeled-field-view__status", s.if("errorText", "ck-labeled-field-view__status_error"), s.if("_statusText", "ck-hidden", function (e) {
                    return !e;
                  })],
                  id: e,
                  role: s.if("errorText", "alert")
                },
                children: [{
                  text: s.to("_statusText")
                }]
              }), t;
            }
          }, {
            key: "focus",
            value: function focus() {
              this.fieldView.focus();
            }
          }]);
          return Y;
        }(f.Z);
        function ee(e, t, s) {
          var o = new K(e.locale);
          return o.set({
            id: t,
            ariaDescribedById: s
          }), o.bind("isReadOnly").to(e, "isEnabled", function (e) {
            return !e;
          }), o.bind("hasError").to(e, "errorText", function (e) {
            return !!e;
          }), o.on("input", function () {
            e.errorText = null;
          }), e.bind("isEmpty", "isFocused", "placeholder").to(o), o;
        }
        function te(e, t, s) {
          var o = new G(e.locale);
          return o.set({
            id: t,
            ariaDescribedById: s,
            inputMode: "numeric"
          }), o.bind("isReadOnly").to(e, "isEnabled", function (e) {
            return !e;
          }), o.bind("hasError").to(e, "errorText", function (e) {
            return !!e;
          }), o.on("input", function () {
            e.errorText = null;
          }), e.bind("isEmpty", "isFocused", "placeholder").to(o), o;
        }
        function se(e, t, s) {
          var o = (0, E.t9)(e.locale);
          return o.set({
            id: t,
            ariaDescribedById: s
          }), o.bind("isEnabled").to(e), o;
        }
        var oe = s("./packages/ckeditor5-ui/src/list/listitemview.js"),
          ie = s("./packages/ckeditor5-ui/src/list/listview.js"),
          re = s("./packages/ckeditor5-core/src/contextplugin.js");
        var ne = /*#__PURE__*/function (_re$Z) {
          _inherits(ne, _re$Z);
          function ne() {
            _classCallCheck(this, ne);
            return _possibleConstructorReturn(this, _getPrototypeOf(ne).apply(this, arguments));
          }
          _createClass(ne, [{
            key: "init",
            value: function init() {
              this.on("show:warning", function (e, t) {
                window.alert(t.message);
              }, {
                priority: "lowest"
              });
            }
          }, {
            key: "showSuccess",
            value: function showSuccess(e) {
              var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
              this._showNotification({
                message: e,
                type: "success",
                namespace: t.namespace,
                title: t.title
              });
            }
          }, {
            key: "showInfo",
            value: function showInfo(e) {
              var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
              this._showNotification({
                message: e,
                type: "info",
                namespace: t.namespace,
                title: t.title
              });
            }
          }, {
            key: "showWarning",
            value: function showWarning(e) {
              var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
              this._showNotification({
                message: e,
                type: "warning",
                namespace: t.namespace,
                title: t.title
              });
            }
          }, {
            key: "_showNotification",
            value: function _showNotification(e) {
              var t = "show:".concat(e.type) + (e.namespace ? ":".concat(e.namespace) : "");
              this.fire(t, {
                message: e.message,
                type: e.type,
                title: e.title || ""
              });
            }
          }], [{
            key: "pluginName",
            get: function get() {
              return "Notification";
            }
          }]);
          return ne;
        }(re.Z);
        var ae = s("./packages/ckeditor5-utils/src/mix.js"),
          ce = s("./packages/ckeditor5-utils/src/observablemixin.js"),
          le = s("./node_modules/lodash-es/assignIn.js");
        var de = function de(e, t) {
          _classCallCheck(this, de);
          t && (0, le.Z)(this, t), e && this.set(e);
        };
        (0, ae.Z)(de, ce.Z);
        var he = s("./packages/ckeditor5-ui/src/panel/balloon/balloonpanelview.js"),
          ue = s("./packages/ckeditor5-ui/src/panel/balloon/contextualballoon.js"),
          ge = s("./packages/ckeditor5-utils/src/dom/global.js"),
          pe = s("./packages/ckeditor5-utils/src/dom/tounit.js"),
          fe = s("./node_modules/css-loader/dist/cjs.js!./node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].use[2]!./packages/ckeditor5-ui/theme/components/panel/stickypanel.css"),
          me = {
            injectType: "singletonStyleTag",
            attributes: {
              "data-cke": !0
            },
            insert: "head",
            singleton: !0
          };
        v()(fe.Z, me);
        fe.Z.locals;
        var ke = (0, pe.Z)("px");
        var _e = /*#__PURE__*/function (_f$Z10) {
          _inherits(_e, _f$Z10);
          function _e(e) {
            var _this193;
            _classCallCheck(this, _e);
            _this193 = _possibleConstructorReturn(this, _getPrototypeOf(_e).call(this, e));
            var t = _this193.bindTemplate;
            _this193.set("isActive", !1), _this193.set("isSticky", !1), _this193.set("limiterElement", null), _this193.set("limiterBottomOffset", 50), _this193.set("viewportTopOffset", 0), _this193.set("_marginLeft", null), _this193.set("_isStickyToTheLimiter", !1), _this193.set("_hasViewportTopOffset", !1), _this193.content = _this193.createCollection(), _this193._contentPanelPlaceholder = new n.ZP({
              tag: "div",
              attributes: {
                class: ["ck", "ck-sticky-panel__placeholder"],
                style: {
                  display: t.to("isSticky", function (e) {
                    return e ? "block" : "none";
                  }),
                  height: t.to("isSticky", function (e) {
                    return e ? ke(_this193._panelRect.height) : null;
                  })
                }
              }
            }).render(), _this193._contentPanel = new n.ZP({
              tag: "div",
              attributes: {
                class: ["ck", "ck-sticky-panel__content", t.if("isSticky", "ck-sticky-panel__content_sticky"), t.if("_isStickyToTheLimiter", "ck-sticky-panel__content_sticky_bottom-limit")],
                style: {
                  width: t.to("isSticky", function (e) {
                    return e ? ke(_this193._contentPanelPlaceholder.getBoundingClientRect().width) : null;
                  }),
                  top: t.to("_hasViewportTopOffset", function (e) {
                    return e ? ke(_this193.viewportTopOffset) : null;
                  }),
                  bottom: t.to("_isStickyToTheLimiter", function (e) {
                    return e ? ke(_this193.limiterBottomOffset) : null;
                  }),
                  marginLeft: t.to("_marginLeft")
                }
              },
              children: _this193.content
            }).render(), _this193.setTemplate({
              tag: "div",
              attributes: {
                class: ["ck", "ck-sticky-panel"]
              },
              children: [_this193._contentPanelPlaceholder, _this193._contentPanel]
            });
            return _this193;
          }
          _createClass(_e, [{
            key: "render",
            value: function render() {
              var _this194 = this;
              _superPropGet(_e, "render", this, 3)([]), this._checkIfShouldBeSticky(), this.listenTo(ge.Z.window, "scroll", function () {
                _this194._checkIfShouldBeSticky();
              }), this.listenTo(this, "change:isActive", function () {
                _this194._checkIfShouldBeSticky();
              });
            }
          }, {
            key: "_checkIfShouldBeSticky",
            value: function _checkIfShouldBeSticky() {
              var e = this._panelRect = this._contentPanel.getBoundingClientRect();
              var t;
              this.limiterElement ? (t = this._limiterRect = this.limiterElement.getBoundingClientRect(), this.isSticky = this.isActive && t.top < this.viewportTopOffset && this._panelRect.height + this.limiterBottomOffset < t.height) : this.isSticky = !1, this.isSticky ? (this._isStickyToTheLimiter = t.bottom < e.height + this.limiterBottomOffset + this.viewportTopOffset, this._hasViewportTopOffset = !this._isStickyToTheLimiter && !!this.viewportTopOffset, this._marginLeft = this._isStickyToTheLimiter ? null : ke(-ge.Z.window.scrollX)) : (this._isStickyToTheLimiter = !1, this._hasViewportTopOffset = !1, this._marginLeft = null);
            }
          }]);
          return _e;
        }(f.Z);
        var be = s("./packages/ckeditor5-ui/src/tooltip/tooltipview.js"),
          we = s("./packages/ckeditor5-ui/src/toolbar/toolbarview.js"),
          ve = s("./packages/ckeditor5-ui/src/toolbar/toolbarseparatorview.js");
        function ye(_ref56) {
          var e = _ref56.origin,
            t = _ref56.originKeystrokeHandler,
            s = _ref56.originFocusTracker,
            o = _ref56.toolbar,
            i = _ref56.beforeFocus,
            r = _ref56.afterBlur;
          s.add(o.element), t.set("Alt+F10", function (e, t) {
            s.isFocused && !o.focusTracker.isFocused && (i && i(), o.focus(), t());
          }), o.keystrokes.set("Esc", function (t, s) {
            o.focusTracker.isFocused && (e.focus(), r && r(), s());
          });
        }
        var Ze = s("./packages/ckeditor5-ui/src/toolbar/normalizetoolbarconfig.js"),
          Pe = s("./packages/ckeditor5-core/src/plugin.js"),
          je = s("./packages/ckeditor5-utils/src/dom/rect.js"),
          xe = s("./node_modules/lodash-es/debounce.js"),
          Ae = s("./packages/ckeditor5-utils/src/dom/resizeobserver.js"),
          Te = s("./packages/ckeditor5-utils/src/index.js");
        var Ce = (0, pe.Z)("px");
        var Ee = /*#__PURE__*/function (_Pe$Z) {
          _inherits(Ee, _Pe$Z);
          _createClass(Ee, null, [{
            key: "pluginName",
            get: function get() {
              return "BalloonToolbar";
            }
          }, {
            key: "requires",
            get: function get() {
              return [ue.Z];
            }
          }]);
          function Ee(e) {
            var _this195;
            _classCallCheck(this, Ee);
            _this195 = _possibleConstructorReturn(this, _getPrototypeOf(Ee).call(this, e)), _this195._balloonConfig = (0, Ze.Z)(e.config.get("balloonToolbar")), _this195.toolbarView = _this195._createToolbarView(), _this195.focusTracker = new k.Z(), e.ui.once("ready", function () {
              _this195.focusTracker.add(e.ui.getEditableElement()), _this195.focusTracker.add(_this195.toolbarView.element);
            }), _this195._resizeObserver = null, _this195._balloon = e.plugins.get(ue.Z), _this195._fireSelectionChangeDebounced = (0, xe.Z)(function () {
              return _this195.fire("_selectionChangeDebounced");
            }, 200), _this195.decorate("show");
            return _this195;
          }
          _createClass(Ee, [{
            key: "init",
            value: function init() {
              var _this196 = this;
              var e = this.editor,
                t = e.model.document.selection;
              this.listenTo(this.focusTracker, "change:isFocused", function (e, t, s) {
                var o = _this196._balloon.visibleView === _this196.toolbarView;
                !s && o ? _this196.hide() : s && _this196.show();
              }), this.listenTo(t, "change:range", function (e, s) {
                (s.directChange || t.isCollapsed) && _this196.hide(), _this196._fireSelectionChangeDebounced();
              }), this.listenTo(this, "_selectionChangeDebounced", function () {
                _this196.editor.editing.view.document.isFocused && _this196.show();
              }), this._balloonConfig.shouldNotGroupWhenFull || this.listenTo(e, "ready", function () {
                var t = e.ui.view.editable.element;
                _this196._resizeObserver = new Ae.Z(t, function () {
                  _this196.toolbarView.maxWidth = Ce(.9 * new je.Z(t).width);
                });
              }), this.listenTo(this.toolbarView, "groupedItemsUpdate", function () {
                _this196._updatePosition();
              });
            }
          }, {
            key: "afterInit",
            value: function afterInit() {
              var e = this.editor.ui.componentFactory;
              this.toolbarView.fillFromConfig(this._balloonConfig, e);
            }
          }, {
            key: "_createToolbarView",
            value: function _createToolbarView() {
              var e = !this._balloonConfig.shouldNotGroupWhenFull,
                t = new we.Z(this.editor.locale, {
                  shouldGroupWhenFull: e,
                  isFloating: !0
                });
              return t.render(), t;
            }
          }, {
            key: "show",
            value: function show() {
              var _this197 = this;
              var e = this.editor,
                t = e.model.document.selection,
                s = e.model.schema;
              this._balloon.hasView(this.toolbarView) || t.isCollapsed || function (e, t) {
                if (1 === e.rangeCount) return !1;
                return _toConsumableArray(e.getRanges()).every(function (e) {
                  var s = e.getContainedElement();
                  return s && t.isSelectable(s);
                });
              }(t, s) || Array.from(this.toolbarView.items).every(function (e) {
                return void 0 !== e.isEnabled && !e.isEnabled;
              }) || (this.listenTo(this.editor.ui, "update", function () {
                _this197._updatePosition();
              }), this._balloon.add({
                view: this.toolbarView,
                position: this._getBalloonPositionData(),
                balloonClassName: "ck-toolbar-container"
              }));
            }
          }, {
            key: "hide",
            value: function hide() {
              this._balloon.hasView(this.toolbarView) && (this.stopListening(this.editor.ui, "update"), this._balloon.remove(this.toolbarView));
            }
          }, {
            key: "_getBalloonPositionData",
            value: function _getBalloonPositionData() {
              var e = this.editor.editing.view,
                t = e.document,
                s = t.selection,
                o = t.selection.isBackward;
              return {
                target: function target() {
                  var t = o ? s.getFirstRange() : s.getLastRange(),
                    i = je.Z.getDomRangeRects(e.domConverter.viewRangeToDom(t));
                  return o ? i[0] : (i.length > 1 && 0 === i[i.length - 1].width && i.pop(), i[i.length - 1]);
                },
                positions: this._getBalloonPositions(o)
              };
            }
          }, {
            key: "_updatePosition",
            value: function _updatePosition() {
              this._balloon.updatePosition(this._getBalloonPositionData());
            }
          }, {
            key: "destroy",
            value: function destroy() {
              _superPropGet(Ee, "destroy", this, 3)([]), this.stopListening(), this._fireSelectionChangeDebounced.cancel(), this.toolbarView.destroy(), this.focusTracker.destroy(), this._resizeObserver && this._resizeObserver.destroy();
            }
          }, {
            key: "_getBalloonPositions",
            value: function _getBalloonPositions(e) {
              var t = Te.OB.isSafari && Te.OB.isiOS ? (0, he.M)({
                verticalOffset: Math.max(he.Z.arrowVerticalOffset, Math.round(20 / Te.CO.window.visualViewport.scale))
              }) : he.Z.defaultPositions;
              return e ? [t.northWestArrowSouth, t.northWestArrowSouthWest, t.northWestArrowSouthEast, t.northWestArrowSouthMiddleEast, t.northWestArrowSouthMiddleWest, t.southWestArrowNorth, t.southWestArrowNorthWest, t.southWestArrowNorthEast, t.southWestArrowNorthMiddleWest, t.southWestArrowNorthMiddleEast] : [t.southEastArrowNorth, t.southEastArrowNorthEast, t.southEastArrowNorthWest, t.southEastArrowNorthMiddleEast, t.southEastArrowNorthMiddleWest, t.northEastArrowSouth, t.northEastArrowSouthEast, t.northEastArrowSouthWest, t.northEastArrowSouthMiddleEast, t.northEastArrowSouthMiddleWest];
            }
          }]);
          return Ee;
        }(Pe.Z);
        var Se = s("./packages/ckeditor5-core/theme/icons/pilcrow.svg"),
          Re = s("./node_modules/css-loader/dist/cjs.js!./node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].use[2]!./packages/ckeditor5-ui/theme/components/toolbar/blocktoolbar.css"),
          Oe = {
            injectType: "singletonStyleTag",
            attributes: {
              "data-cke": !0
            },
            insert: "head",
            singleton: !0
          };
        v()(Re.Z, Oe);
        Re.Z.locals;
        var Me = (0, pe.Z)("px");
        var Ne = /*#__PURE__*/function (_d$Z4) {
          _inherits(Ne, _d$Z4);
          function Ne(e) {
            var _this198;
            _classCallCheck(this, Ne);
            _this198 = _possibleConstructorReturn(this, _getPrototypeOf(Ne).call(this, e));
            var t = _this198.bindTemplate;
            _this198.isVisible = !1, _this198.isToggleable = !0, _this198.set("top", 0), _this198.set("left", 0), _this198.extendTemplate({
              attributes: {
                class: "ck-block-toolbar-button",
                style: {
                  top: t.to("top", function (e) {
                    return Me(e);
                  }),
                  left: t.to("left", function (e) {
                    return Me(e);
                  })
                }
              }
            });
            return _this198;
          }
          return Ne;
        }(d.Z);
        var Ie = s("./packages/ckeditor5-utils/src/dom/position.js");
        var ze = (0, pe.Z)("px");
        var Ve = /*#__PURE__*/function (_Pe$Z2) {
          _inherits(Ve, _Pe$Z2);
          _createClass(Ve, null, [{
            key: "pluginName",
            get: function get() {
              return "BlockToolbar";
            }
          }]);
          function Ve(e) {
            var _this199;
            _classCallCheck(this, Ve);
            _this199 = _possibleConstructorReturn(this, _getPrototypeOf(Ve).call(this, e)), _this199._blockToolbarConfig = (0, Ze.Z)(_this199.editor.config.get("blockToolbar")), _this199.toolbarView = _this199._createToolbarView(), _this199.panelView = _this199._createPanelView(), _this199.buttonView = _this199._createButtonView(), _this199._resizeObserver = null, (0, o.Z)({
              emitter: _this199.panelView,
              contextElements: [_this199.panelView.element, _this199.buttonView.element],
              activator: function activator() {
                return _this199.panelView.isVisible;
              },
              callback: function callback() {
                return _this199._hidePanel();
              }
            });
            return _this199;
          }
          _createClass(Ve, [{
            key: "init",
            value: function init() {
              var _this200 = this;
              var e = this.editor;
              this.listenTo(e.model.document.selection, "change:range", function (e, t) {
                t.directChange && _this200._hidePanel();
              }), this.listenTo(e.ui, "update", function () {
                return _this200._updateButton();
              }), this.listenTo(e, "change:isReadOnly", function () {
                return _this200._updateButton();
              }, {
                priority: "low"
              }), this.listenTo(e.ui.focusTracker, "change:isFocused", function () {
                return _this200._updateButton();
              }), this.listenTo(this.buttonView, "change:isVisible", function (e, t, s) {
                s ? _this200.buttonView.listenTo(window, "resize", function () {
                  return _this200._updateButton();
                }) : (_this200.buttonView.stopListening(window, "resize"), _this200._hidePanel());
              });
            }
          }, {
            key: "afterInit",
            value: function afterInit() {
              var _this201 = this;
              var e = this.editor.ui.componentFactory,
                t = this._blockToolbarConfig;
              this.toolbarView.fillFromConfig(t, e);
              var _iterator335 = _createForOfIteratorHelper(this.toolbarView.items),
                _step335;
              try {
                for (_iterator335.s(); !(_step335 = _iterator335.n()).done;) {
                  var _e259 = _step335.value;
                  _e259.on("execute", function () {
                    return _this201._hidePanel(!0);
                  }, {
                    priority: "high"
                  });
                }
              } catch (err) {
                _iterator335.e(err);
              } finally {
                _iterator335.f();
              }
              t.shouldNotGroupWhenFull || this.listenTo(this.editor, "ready", function () {
                var e = _this201.editor.ui.view.editable.element;
                _this201._resizeObserver = new Ae.Z(e, function () {
                  _this201.toolbarView.maxWidth = _this201._getToolbarMaxWidth();
                });
              });
            }
          }, {
            key: "destroy",
            value: function destroy() {
              _superPropGet(Ve, "destroy", this, 3)([]), this.panelView.destroy(), this.buttonView.destroy(), this.toolbarView.destroy(), this._resizeObserver && this._resizeObserver.destroy();
            }
          }, {
            key: "_createToolbarView",
            value: function _createToolbarView() {
              var _this202 = this;
              var e = !this._blockToolbarConfig.shouldNotGroupWhenFull,
                t = new we.Z(this.editor.locale, {
                  shouldGroupWhenFull: e,
                  isFloating: !0
                });
              return t.focusTracker.on("change:isFocused", function (e, t, s) {
                s || _this202._hidePanel();
              }), t;
            }
          }, {
            key: "_createPanelView",
            value: function _createPanelView() {
              var _this203 = this;
              var e = this.editor,
                t = new he.Z(e.locale);
              return t.content.add(this.toolbarView), t.class = "ck-toolbar-container", e.ui.view.body.add(t), e.ui.focusTracker.add(t.element), this.toolbarView.keystrokes.set("Esc", function (e, t) {
                _this203._hidePanel(!0), t();
              }), t;
            }
          }, {
            key: "_createButtonView",
            value: function _createButtonView() {
              var _this204 = this;
              var e = this.editor,
                t = e.t,
                s = new Ne(e.locale);
              return s.set({
                label: t("Edit block"),
                icon: Se.Z,
                withText: !1
              }), s.bind("isOn").to(this.panelView, "isVisible"), s.bind("tooltip").to(this.panelView, "isVisible", function (e) {
                return !e;
              }), this.listenTo(s, "execute", function () {
                _this204.panelView.isVisible ? _this204._hidePanel(!0) : _this204._showPanel();
              }), e.ui.view.body.add(s), e.ui.focusTracker.add(s.element), s;
            }
          }, {
            key: "_updateButton",
            value: function _updateButton() {
              var e = this.editor,
                t = e.model,
                s = e.editing.view;
              if (!e.ui.focusTracker.isFocused) return void this._hideButton();
              if (e.isReadOnly) return void this._hideButton();
              var o = Array.from(t.document.selection.getSelectedBlocks())[0];
              if (!o || Array.from(this.toolbarView.items).every(function (e) {
                return !e.isEnabled;
              })) return void this._hideButton();
              var i = s.domConverter.mapViewToDom(e.editing.mapper.toViewElement(o));
              this.buttonView.isVisible = !0, this._attachButtonToElement(i), this.panelView.isVisible && this._showPanel();
            }
          }, {
            key: "_hideButton",
            value: function _hideButton() {
              this.buttonView.isVisible = !1;
            }
          }, {
            key: "_showPanel",
            value: function _showPanel() {
              var e = this.panelView.isVisible;
              this.panelView.show(), this.toolbarView.maxWidth = this._getToolbarMaxWidth(), this.panelView.pin({
                target: this.buttonView.element,
                limiter: this.editor.ui.getEditableElement()
              }), e || this.toolbarView.items.get(0).focus();
            }
          }, {
            key: "_hidePanel",
            value: function _hidePanel(e) {
              this.panelView.isVisible = !1, e && this.editor.editing.view.focus();
            }
          }, {
            key: "_attachButtonToElement",
            value: function _attachButtonToElement(e) {
              var _this205 = this;
              var t = window.getComputedStyle(e),
                s = new je.Z(this.editor.ui.getEditableElement()),
                o = parseInt(t.paddingTop, 10),
                i = parseInt(t.lineHeight, 10) || 1.2 * parseInt(t.fontSize, 10),
                r = (0, Ie.x)({
                  element: this.buttonView.element,
                  target: e,
                  positions: [function (e, t) {
                    var r;
                    return r = "ltr" === _this205.editor.locale.uiLanguageDirection ? s.left - t.width : s.right, {
                      top: e.top + o + (i - t.height) / 2,
                      left: r
                    };
                  }]
                });
              this.buttonView.top = r.top, this.buttonView.left = r.left;
            }
          }, {
            key: "_getToolbarMaxWidth",
            value: function _getToolbarMaxWidth() {
              var e = this.editor.ui.view.editable.element,
                t = new je.Z(e),
                s = new je.Z(this.buttonView.element),
                o = "rtl" === this.editor.locale.uiLanguageDirection ? s.left - t.right + s.width : t.left - s.left;
              return ze(t.width + o);
            }
          }]);
          return Ve;
        }(Pe.Z);
      },
      "./src/undo.js": function _src_undoJs(e, t, s) {
        "use strict";

        s.r(t), s.d(t, {
          Undo: function Undo() {
            return m;
          },
          UndoEditing: function UndoEditing() {
            return h;
          },
          UndoUi: function UndoUi() {
            return f;
          }
        });
        var o = s("./packages/ckeditor5-core/src/plugin.js"),
          i = s("./packages/ckeditor5-core/src/command.js"),
          r = s("./packages/ckeditor5-engine/src/model/operation/transform.js");
        var n = /*#__PURE__*/function (_i$Z9) {
          _inherits(n, _i$Z9);
          function n(e) {
            var _this206;
            _classCallCheck(this, n);
            _this206 = _possibleConstructorReturn(this, _getPrototypeOf(n).call(this, e)), _this206._stack = [], _this206._createdBatches = new WeakSet(), _this206.refresh(), _this206.listenTo(e.data, "set", function (e, t) {
              t[1] = _objectSpread({}, t[1]);
              var s = t[1];
              s.batchType || (s.batchType = {
                isUndoable: !1
              });
            }, {
              priority: "high"
            }), _this206.listenTo(e.data, "set", function (e, t) {
              t[1].batchType.isUndoable || _this206.clearStack();
            });
            return _this206;
          }
          _createClass(n, [{
            key: "refresh",
            value: function refresh() {
              this.isEnabled = this._stack.length > 0;
            }
          }, {
            key: "addBatch",
            value: function addBatch(e) {
              var t = this.editor.model.document.selection,
                s = {
                  ranges: t.hasOwnRange ? Array.from(t.getRanges()) : [],
                  isBackward: t.isBackward
                };
              this._stack.push({
                batch: e,
                selection: s
              }), this.refresh();
            }
          }, {
            key: "clearStack",
            value: function clearStack() {
              this._stack = [], this.refresh();
            }
          }, {
            key: "_restoreSelection",
            value: function _restoreSelection(e, t, s) {
              var o = this.editor.model,
                i = o.document,
                r = [],
                n = e.map(function (e) {
                  return e.getTransformedByOperations(s);
                }),
                l = n.flat();
              var _iterator336 = _createForOfIteratorHelper(n),
                _step336;
              try {
                for (_iterator336.s(); !(_step336 = _iterator336.n()).done;) {
                  var _e260 = _step336.value;
                  var _t230 = _e260.filter(function (e) {
                    return e.root != i.graveyard;
                  }).filter(function (e) {
                    return !c(e, l);
                  });
                  _t230.length && (a(_t230), r.push(_t230[0]));
                }
              } catch (err) {
                _iterator336.e(err);
              } finally {
                _iterator336.f();
              }
              r.length && o.change(function (e) {
                e.setSelection(r, {
                  backward: t
                });
              });
            }
          }, {
            key: "_undo",
            value: function _undo(e, t) {
              var s = this.editor.model,
                o = s.document;
              this._createdBatches.add(t);
              var i = e.operations.slice().filter(function (e) {
                return e.isDocumentOperation;
              });
              i.reverse();
              var _iterator337 = _createForOfIteratorHelper(i),
                _step337;
              try {
                for (_iterator337.s(); !(_step337 = _iterator337.n()).done;) {
                  var _e261 = _step337.value;
                  var _i119 = _e261.baseVersion + 1,
                    _n27 = Array.from(o.history.getOperations(_i119)),
                    _a17 = (0, r.R)([_e261.getReversed()], _n27, {
                      useRelations: !0,
                      document: this.editor.model.document,
                      padWithNoOps: !1,
                      forceWeakRemove: !0
                    }).operationsA;
                  var _iterator338 = _createForOfIteratorHelper(_a17),
                    _step338;
                  try {
                    for (_iterator338.s(); !(_step338 = _iterator338.n()).done;) {
                      var _i120 = _step338.value;
                      t.addOperation(_i120), s.applyOperation(_i120), o.history.setOperationAsUndone(_e261, _i120);
                    }
                  } catch (err) {
                    _iterator338.e(err);
                  } finally {
                    _iterator338.f();
                  }
                }
              } catch (err) {
                _iterator337.e(err);
              } finally {
                _iterator337.f();
              }
            }
          }]);
          return n;
        }(i.Z);
        function a(e) {
          e.sort(function (e, t) {
            return e.start.isBefore(t.start) ? -1 : 1;
          });
          for (var _t231 = 1; _t231 < e.length; _t231++) {
            var _s227 = e[_t231 - 1].getJoined(e[_t231], !0);
            _s227 && (_t231--, e.splice(_t231, 2, _s227));
          }
        }
        function c(e, t) {
          return t.some(function (t) {
            return t !== e && t.containsRange(e, !0);
          });
        }
        var l = /*#__PURE__*/function (_n28) {
          _inherits(l, _n28);
          function l() {
            _classCallCheck(this, l);
            return _possibleConstructorReturn(this, _getPrototypeOf(l).apply(this, arguments));
          }
          _createClass(l, [{
            key: "execute",
            value: function execute() {
              var _this207 = this;
              var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
              var t = e ? this._stack.findIndex(function (t) {
                  return t.batch == e;
                }) : this._stack.length - 1,
                s = this._stack.splice(t, 1)[0],
                o = this.editor.model.createBatch({
                  isUndo: !0
                });
              this.editor.model.enqueueChange(o, function () {
                _this207._undo(s.batch, o);
                var e = _this207.editor.model.document.history.getOperations(s.batch.baseVersion);
                _this207._restoreSelection(s.selection.ranges, s.selection.isBackward, e), _this207.fire("revert", s.batch, o);
              }), this.refresh();
            }
          }]);
          return l;
        }(n);
        var d = /*#__PURE__*/function (_n29) {
          _inherits(d, _n29);
          function d() {
            _classCallCheck(this, d);
            return _possibleConstructorReturn(this, _getPrototypeOf(d).apply(this, arguments));
          }
          _createClass(d, [{
            key: "execute",
            value: function execute() {
              var _this208 = this;
              var e = this._stack.pop(),
                t = this.editor.model.createBatch({
                  isUndo: !0
                });
              this.editor.model.enqueueChange(t, function () {
                var s = e.batch.operations[e.batch.operations.length - 1].baseVersion + 1,
                  o = _this208.editor.model.document.history.getOperations(s);
                _this208._restoreSelection(e.selection.ranges, e.selection.isBackward, o), _this208._undo(e.batch, t);
              }), this.refresh();
            }
          }]);
          return d;
        }(n);
        var h = /*#__PURE__*/function (_o$Z57) {
          _inherits(h, _o$Z57);
          _createClass(h, null, [{
            key: "pluginName",
            get: function get() {
              return "UndoEditing";
            }
          }]);
          function h(e) {
            var _this209;
            _classCallCheck(this, h);
            _this209 = _possibleConstructorReturn(this, _getPrototypeOf(h).call(this, e)), _this209._batchRegistry = new WeakSet();
            return _this209;
          }
          _createClass(h, [{
            key: "init",
            value: function init() {
              var _this210 = this;
              var e = this.editor;
              this._undoCommand = new l(e), this._redoCommand = new d(e), e.commands.add("undo", this._undoCommand), e.commands.add("redo", this._redoCommand), this.listenTo(e.model, "applyOperation", function (e, t) {
                var s = t[0];
                if (!s.isDocumentOperation) return;
                var o = s.batch,
                  i = _this210._redoCommand._createdBatches.has(o),
                  r = _this210._undoCommand._createdBatches.has(o);
                _this210._batchRegistry.has(o) || (_this210._batchRegistry.add(o), o.isUndoable && (i ? _this210._undoCommand.addBatch(o) : r || (_this210._undoCommand.addBatch(o), _this210._redoCommand.clearStack())));
              }, {
                priority: "highest"
              }), this.listenTo(this._undoCommand, "revert", function (e, t, s) {
                _this210._redoCommand.addBatch(s);
              }), e.keystrokes.set("CTRL+Z", "undo"), e.keystrokes.set("CTRL+Y", "redo"), e.keystrokes.set("CTRL+SHIFT+Z", "redo");
            }
          }]);
          return h;
        }(o.Z);
        var u = s("./packages/ckeditor5-ui/src/button/buttonview.js");
        var g = '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="m5.042 9.367 2.189 1.837a.75.75 0 0 1-.965 1.149l-3.788-3.18a.747.747 0 0 1-.21-.284.75.75 0 0 1 .17-.945L6.23 4.762a.75.75 0 1 1 .964 1.15L4.863 7.866h8.917A.75.75 0 0 1 14 7.9a4 4 0 1 1-1.477 7.718l.344-1.489a2.5 2.5 0 1 0 1.094-4.73l.008-.032H5.042z"/></svg>',
          p = '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="m14.958 9.367-2.189 1.837a.75.75 0 0 0 .965 1.149l3.788-3.18a.747.747 0 0 0 .21-.284.75.75 0 0 0-.17-.945L13.77 4.762a.75.75 0 1 0-.964 1.15l2.331 1.955H6.22A.75.75 0 0 0 6 7.9a4 4 0 1 0 1.477 7.718l-.344-1.489A2.5 2.5 0 1 1 6.039 9.4l-.008-.032h8.927z"/></svg>';
        var f = /*#__PURE__*/function (_o$Z58) {
          _inherits(f, _o$Z58);
          function f() {
            _classCallCheck(this, f);
            return _possibleConstructorReturn(this, _getPrototypeOf(f).apply(this, arguments));
          }
          _createClass(f, [{
            key: "init",
            value: function init() {
              var e = this.editor,
                t = e.locale,
                s = e.t,
                o = "ltr" == t.uiLanguageDirection ? g : p,
                i = "ltr" == t.uiLanguageDirection ? p : g;
              this._addButton("undo", s("Undo"), "CTRL+Z", o), this._addButton("redo", s("Redo"), "CTRL+Y", i);
            }
          }, {
            key: "_addButton",
            value: function _addButton(e, t, s, o) {
              var _this211 = this;
              var i = this.editor;
              i.ui.componentFactory.add(e, function (r) {
                var n = i.commands.get(e),
                  a = new u.Z(r);
                return a.set({
                  label: t,
                  icon: o,
                  keystroke: s,
                  tooltip: !0
                }), a.bind("isEnabled").to(n, "isEnabled"), _this211.listenTo(a, "execute", function () {
                  i.execute(e), i.editing.view.focus();
                }), a;
              });
            }
          }], [{
            key: "pluginName",
            get: function get() {
              return "UndoUI";
            }
          }]);
          return f;
        }(o.Z);
        var m = /*#__PURE__*/function (_o$Z59) {
          _inherits(m, _o$Z59);
          function m() {
            _classCallCheck(this, m);
            return _possibleConstructorReturn(this, _getPrototypeOf(m).apply(this, arguments));
          }
          _createClass(m, null, [{
            key: "requires",
            get: function get() {
              return [h, f];
            }
          }, {
            key: "pluginName",
            get: function get() {
              return "Undo";
            }
          }]);
          return m;
        }(o.Z);
      },
      "./src/upload.js": function _src_uploadJs(e, t, s) {
        "use strict";

        s.r(t), s.d(t, {
          Base64UploadAdapter: function Base64UploadAdapter() {
            return k;
          },
          FileDialogButtonView: function FileDialogButtonView() {
            return f;
          },
          FileRepository: function FileRepository() {
            return h;
          },
          SimpleUploadAdapter: function SimpleUploadAdapter() {
            return b;
          }
        });
        var o = s("./packages/ckeditor5-core/src/plugin.js"),
          i = s("./packages/ckeditor5-core/src/pendingactions.js"),
          r = s("./packages/ckeditor5-utils/src/ckeditorerror.js"),
          n = s("./packages/ckeditor5-utils/src/observablemixin.js"),
          a = s("./packages/ckeditor5-utils/src/collection.js"),
          c = s("./packages/ckeditor5-utils/src/mix.js");
        var l = /*#__PURE__*/function () {
          function l() {
            var _this212 = this;
            _classCallCheck(this, l);
            var e = new window.FileReader();
            this._reader = e, this._data = void 0, this.set("loaded", 0), e.onprogress = function (e) {
              _this212.loaded = e.loaded;
            };
          }
          _createClass(l, [{
            key: "read",
            value: function read(e) {
              var _this213 = this;
              var t = this._reader;
              return this.total = e.size, new Promise(function (s, o) {
                t.onload = function () {
                  var e = t.result;
                  _this213._data = e, s(e);
                }, t.onerror = function () {
                  o("error");
                }, t.onabort = function () {
                  o("aborted");
                }, _this213._reader.readAsDataURL(e);
              });
            }
          }, {
            key: "abort",
            value: function abort() {
              this._reader.abort();
            }
          }, {
            key: "error",
            get: function get() {
              return this._reader.error;
            }
          }, {
            key: "data",
            get: function get() {
              return this._data;
            }
          }]);
          return l;
        }();
        (0, c.Z)(l, n.Z);
        var d = s("./packages/ckeditor5-utils/src/uid.js");
        var h = /*#__PURE__*/function (_o$Z60) {
          _inherits(h, _o$Z60);
          function h() {
            _classCallCheck(this, h);
            return _possibleConstructorReturn(this, _getPrototypeOf(h).apply(this, arguments));
          }
          _createClass(h, [{
            key: "init",
            value: function init() {
              var _this214 = this;
              this.loaders = new a.Z(), this.loaders.on("add", function () {
                return _this214._updatePendingAction();
              }), this.loaders.on("remove", function () {
                return _this214._updatePendingAction();
              }), this._loadersMap = new Map(), this._pendingAction = null, this.set("uploaded", 0), this.set("uploadTotal", null), this.bind("uploadedPercent").to(this, "uploaded", this, "uploadTotal", function (e, t) {
                return t ? e / t * 100 : 0;
              });
            }
          }, {
            key: "getLoader",
            value: function getLoader(e) {
              return this._loadersMap.get(e) || null;
            }
          }, {
            key: "createLoader",
            value: function createLoader(e) {
              var _this215 = this;
              if (!this.createUploadAdapter) return (0, r.KE)("filerepository-no-upload-adapter"), null;
              var t = new u(Promise.resolve(e), this.createUploadAdapter);
              return this.loaders.add(t), this._loadersMap.set(e, t), e instanceof Promise && t.file.then(function (e) {
                _this215._loadersMap.set(e, t);
              }).catch(function () {}), t.on("change:uploaded", function () {
                var e = 0;
                var _iterator339 = _createForOfIteratorHelper(_this215.loaders),
                  _step339;
                try {
                  for (_iterator339.s(); !(_step339 = _iterator339.n()).done;) {
                    var _t232 = _step339.value;
                    e += _t232.uploaded;
                  }
                } catch (err) {
                  _iterator339.e(err);
                } finally {
                  _iterator339.f();
                }
                _this215.uploaded = e;
              }), t.on("change:uploadTotal", function () {
                var e = 0;
                var _iterator340 = _createForOfIteratorHelper(_this215.loaders),
                  _step340;
                try {
                  for (_iterator340.s(); !(_step340 = _iterator340.n()).done;) {
                    var _t233 = _step340.value;
                    _t233.uploadTotal && (e += _t233.uploadTotal);
                  }
                } catch (err) {
                  _iterator340.e(err);
                } finally {
                  _iterator340.f();
                }
                _this215.uploadTotal = e;
              }), t;
            }
          }, {
            key: "destroyLoader",
            value: function destroyLoader(e) {
              var _this216 = this;
              var t = e instanceof u ? e : this.getLoader(e);
              t._destroy(), this.loaders.remove(t), this._loadersMap.forEach(function (e, s) {
                e === t && _this216._loadersMap.delete(s);
              });
            }
          }, {
            key: "_updatePendingAction",
            value: function _updatePendingAction() {
              var e = this.editor.plugins.get(i.Z);
              if (this.loaders.length) {
                if (!this._pendingAction) {
                  var _t234 = this.editor.t,
                    _s228 = function _s228(e) {
                      return "".concat(_t234("Upload in progress"), " ").concat(parseInt(e), "%.");
                    };
                  this._pendingAction = e.add(_s228(this.uploadedPercent)), this._pendingAction.bind("message").to(this, "uploadedPercent", _s228);
                }
              } else e.remove(this._pendingAction), this._pendingAction = null;
            }
          }], [{
            key: "pluginName",
            get: function get() {
              return "FileRepository";
            }
          }, {
            key: "requires",
            get: function get() {
              return [i.Z];
            }
          }]);
          return h;
        }(o.Z);
        (0, c.Z)(h, n.Z);
        var u = /*#__PURE__*/function () {
          function u(e, t) {
            _classCallCheck(this, u);
            this.id = (0, d.Z)(), this._filePromiseWrapper = this._createFilePromiseWrapper(e), this._adapter = t(this), this._reader = new l(), this.set("status", "idle"), this.set("uploaded", 0), this.set("uploadTotal", null), this.bind("uploadedPercent").to(this, "uploaded", this, "uploadTotal", function (e, t) {
              return t ? e / t * 100 : 0;
            }), this.set("uploadResponse", null);
          }
          _createClass(u, [{
            key: "read",
            value: function read() {
              var _this217 = this;
              if ("idle" != this.status) throw new r.ZP("filerepository-read-wrong-status", this);
              return this.status = "reading", this.file.then(function (e) {
                return _this217._reader.read(e);
              }).then(function (e) {
                if ("reading" !== _this217.status) throw _this217.status;
                return _this217.status = "idle", e;
              }).catch(function (e) {
                if ("aborted" === e) throw _this217.status = "aborted", "aborted";
                throw _this217.status = "error", _this217._reader.error ? _this217._reader.error : e;
              });
            }
          }, {
            key: "upload",
            value: function upload() {
              var _this218 = this;
              if ("idle" != this.status) throw new r.ZP("filerepository-upload-wrong-status", this);
              return this.status = "uploading", this.file.then(function () {
                return _this218._adapter.upload();
              }).then(function (e) {
                return _this218.uploadResponse = e, _this218.status = "idle", e;
              }).catch(function (e) {
                if ("aborted" === _this218.status) throw "aborted";
                throw _this218.status = "error", e;
              });
            }
          }, {
            key: "abort",
            value: function abort() {
              var e = this.status;
              this.status = "aborted", this._filePromiseWrapper.isFulfilled ? "reading" == e ? this._reader.abort() : "uploading" == e && this._adapter.abort && this._adapter.abort() : (this._filePromiseWrapper.promise.catch(function () {}), this._filePromiseWrapper.rejecter("aborted")), this._destroy();
            }
          }, {
            key: "_destroy",
            value: function _destroy() {
              this._filePromiseWrapper = void 0, this._reader = void 0, this._adapter = void 0, this.uploadResponse = void 0;
            }
          }, {
            key: "_createFilePromiseWrapper",
            value: function _createFilePromiseWrapper(e) {
              var t = {};
              return t.promise = new Promise(function (s, o) {
                t.rejecter = o, t.isFulfilled = !1, e.then(function (e) {
                  t.isFulfilled = !0, s(e);
                }).catch(function (e) {
                  t.isFulfilled = !0, o(e);
                });
              }), t;
            }
          }, {
            key: "file",
            get: function get() {
              var _this219 = this;
              return this._filePromiseWrapper ? this._filePromiseWrapper.promise.then(function (e) {
                return _this219._filePromiseWrapper ? e : null;
              }) : Promise.resolve(null);
            }
          }, {
            key: "data",
            get: function get() {
              return this._reader.data;
            }
          }]);
          return u;
        }();
        (0, c.Z)(u, n.Z);
        var g = s("./packages/ckeditor5-ui/src/button/buttonview.js"),
          p = s("./packages/ckeditor5-ui/src/view.js");
        var f = /*#__PURE__*/function (_p$Z) {
          _inherits(f, _p$Z);
          function f(e) {
            var _this220;
            _classCallCheck(this, f);
            _this220 = _possibleConstructorReturn(this, _getPrototypeOf(f).call(this, e)), _this220.buttonView = new g.Z(e), _this220._fileInputView = new m(e), _this220._fileInputView.bind("acceptedType").to(_assertThisInitialized(_assertThisInitialized(_this220))), _this220._fileInputView.bind("allowMultipleFiles").to(_assertThisInitialized(_assertThisInitialized(_this220))), _this220._fileInputView.delegate("done").to(_assertThisInitialized(_assertThisInitialized(_this220))), _this220.setTemplate({
              tag: "span",
              attributes: {
                class: "ck-file-dialog-button"
              },
              children: [_this220.buttonView, _this220._fileInputView]
            }), _this220.buttonView.on("execute", function () {
              _this220._fileInputView.open();
            });
            return _this220;
          }
          _createClass(f, [{
            key: "focus",
            value: function focus() {
              this.buttonView.focus();
            }
          }]);
          return f;
        }(p.Z);
        var m = /*#__PURE__*/function (_p$Z2) {
          _inherits(m, _p$Z2);
          function m(e) {
            var _this221;
            _classCallCheck(this, m);
            _this221 = _possibleConstructorReturn(this, _getPrototypeOf(m).call(this, e)), _this221.set("acceptedType"), _this221.set("allowMultipleFiles", !1);
            var t = _this221.bindTemplate;
            _this221.setTemplate({
              tag: "input",
              attributes: {
                class: ["ck-hidden"],
                type: "file",
                tabindex: "-1",
                accept: t.to("acceptedType"),
                multiple: t.to("allowMultipleFiles")
              },
              on: {
                change: t.to(function () {
                  _this221.element && _this221.element.files && _this221.element.files.length && _this221.fire("done", _this221.element.files), _this221.element.value = "";
                })
              }
            });
            return _this221;
          }
          _createClass(m, [{
            key: "open",
            value: function open() {
              this.element.click();
            }
          }]);
          return m;
        }(p.Z);
        var k = /*#__PURE__*/function (_o$Z61) {
          _inherits(k, _o$Z61);
          function k() {
            _classCallCheck(this, k);
            return _possibleConstructorReturn(this, _getPrototypeOf(k).apply(this, arguments));
          }
          _createClass(k, [{
            key: "init",
            value: function init() {
              this.editor.plugins.get(h).createUploadAdapter = function (e) {
                return new _(e);
              };
            }
          }], [{
            key: "requires",
            get: function get() {
              return [h];
            }
          }, {
            key: "pluginName",
            get: function get() {
              return "Base64UploadAdapter";
            }
          }]);
          return k;
        }(o.Z);
        var _ = /*#__PURE__*/function () {
          function _(e) {
            _classCallCheck(this, _);
            this.loader = e;
          }
          _createClass(_, [{
            key: "upload",
            value: function upload() {
              var _this222 = this;
              return new Promise(function (e, t) {
                var s = _this222.reader = new window.FileReader();
                s.addEventListener("load", function () {
                  e({
                    default: s.result
                  });
                }), s.addEventListener("error", function (e) {
                  t(e);
                }), s.addEventListener("abort", function () {
                  t();
                }), _this222.loader.file.then(function (e) {
                  s.readAsDataURL(e);
                });
              });
            }
          }, {
            key: "abort",
            value: function abort() {
              this.reader.abort();
            }
          }]);
          return _;
        }();
        var b = /*#__PURE__*/function (_o$Z62) {
          _inherits(b, _o$Z62);
          function b() {
            _classCallCheck(this, b);
            return _possibleConstructorReturn(this, _getPrototypeOf(b).apply(this, arguments));
          }
          _createClass(b, [{
            key: "init",
            value: function init() {
              var e = this.editor.config.get("simpleUpload");
              e && (e.uploadUrl ? this.editor.plugins.get(h).createUploadAdapter = function (t) {
                return new w(t, e);
              } : (0, r.KE)("simple-upload-adapter-missing-uploadurl"));
            }
          }], [{
            key: "requires",
            get: function get() {
              return [h];
            }
          }, {
            key: "pluginName",
            get: function get() {
              return "SimpleUploadAdapter";
            }
          }]);
          return b;
        }(o.Z);
        var w = /*#__PURE__*/function () {
          function w(e, t) {
            _classCallCheck(this, w);
            this.loader = e, this.options = t;
          }
          _createClass(w, [{
            key: "upload",
            value: function upload() {
              var _this223 = this;
              return this.loader.file.then(function (e) {
                return new Promise(function (t, s) {
                  _this223._initRequest(), _this223._initListeners(t, s, e), _this223._sendRequest(e);
                });
              });
            }
          }, {
            key: "abort",
            value: function abort() {
              this.xhr && this.xhr.abort();
            }
          }, {
            key: "_initRequest",
            value: function _initRequest() {
              var e = this.xhr = new XMLHttpRequest();
              e.open("POST", this.options.uploadUrl, !0), e.responseType = "json";
            }
          }, {
            key: "_initListeners",
            value: function _initListeners(e, t, s) {
              var o = this.xhr,
                i = this.loader,
                r = "Couldn't upload file: ".concat(s.name, ".");
              o.addEventListener("error", function () {
                return t(r);
              }), o.addEventListener("abort", function () {
                return t();
              }), o.addEventListener("load", function () {
                var s = o.response;
                if (!s || s.error) return t(s && s.error && s.error.message ? s.error.message : r);
                var i = s.url ? {
                  default: s.url
                } : s.urls;
                e(_objectSpread({}, s, {
                  urls: i
                }));
              }), o.upload && o.upload.addEventListener("progress", function (e) {
                e.lengthComputable && (i.uploadTotal = e.total, i.uploaded = e.loaded);
              });
            }
          }, {
            key: "_sendRequest",
            value: function _sendRequest(e) {
              var t = this.options.headers || {},
                s = this.options.withCredentials || !1;
              for (var _i121 = 0, _Object$keys4 = Object.keys(t); _i121 < _Object$keys4.length; _i121++) {
                var _e262 = _Object$keys4[_i121];
                this.xhr.setRequestHeader(_e262, t[_e262]);
              }
              this.xhr.withCredentials = s;
              var o = new FormData();
              o.append("upload", e), this.xhr.send(o);
            }
          }]);
          return w;
        }();
      },
      "./src/utils.js": function _src_utilsJs(e, t, s) {
        "use strict";

        s.r(t), s.d(t, {
          CKEditorError: function CKEditorError() {
            return o.Bb;
          },
          Collection: function Collection() {
            return o.FE;
          },
          DomEmitterMixin: function DomEmitterMixin() {
            return o.Xu;
          },
          ElementReplacer: function ElementReplacer() {
            return o.a6;
          },
          EmitterMixin: function EmitterMixin() {
            return o.ln;
          },
          FocusTracker: function FocusTracker() {
            return o.Rh;
          },
          KeystrokeHandler: function KeystrokeHandler() {
            return o.VD;
          },
          Locale: function Locale() {
            return o.go;
          },
          ObservableMixin: function ObservableMixin() {
            return o.Re;
          },
          Rect: function Rect() {
            return o.UL;
          },
          ResizeObserver: function ResizeObserver() {
            return o.do;
          },
          createElement: function createElement() {
            return o.az;
          },
          diff: function diff() {
            return o.Hg;
          },
          env: function env() {
            return o.OB;
          },
          first: function first() {
            return o.Ps;
          },
          getCode: function getCode() {
            return o.Cq;
          },
          getDataFromElement: function getDataFromElement() {
            return o.yy;
          },
          getEnvKeystrokeText: function getEnvKeystrokeText() {
            return o.XU;
          },
          getLanguageDirection: function getLanguageDirection() {
            return o.j9;
          },
          getLocalizedArrowKeyCodeDirection: function getLocalizedArrowKeyCodeDirection() {
            return o.mA;
          },
          global: function global() {
            return o.CO;
          },
          isArrowKeyCode: function isArrowKeyCode() {
            return o.dj;
          },
          isForwardArrowKeyCode: function isForwardArrowKeyCode() {
            return o.Zt;
          },
          isVisible: function isVisible() {
            return o.pn;
          },
          keyCodes: function keyCodes() {
            return o.Do;
          },
          logError: function logError() {
            return o.H;
          },
          logWarning: function logWarning() {
            return o.KE;
          },
          mix: function mix() {
            return o.CD;
          },
          parseKeystroke: function parseKeystroke() {
            return o.Zz;
          },
          priorities: function priorities() {
            return o.tA;
          },
          setDataInElement: function setDataInElement() {
            return o.jS;
          },
          toArray: function toArray() {
            return o.qo;
          },
          toMap: function toMap() {
            return o.qL;
          },
          toUnit: function toUnit() {
            return o.nn;
          },
          uid: function uid() {
            return o.hQ;
          },
          version: function version() {
            return o.i8;
          }
        });
        var o = s("./packages/ckeditor5-utils/src/index.js");
      },
      "./src/widget.js": function _src_widgetJs(e, t, s) {
        "use strict";

        s.r(t), s.d(t, {
          WIDGET_CLASS_NAME: function WIDGET_CLASS_NAME() {
            return c.s4;
          },
          WIDGET_SELECTED_CLASS_NAME: function WIDGET_SELECTED_CLASS_NAME() {
            return c.Uo;
          },
          Widget: function Widget() {
            return o.Z;
          },
          WidgetResize: function WidgetResize() {
            return S;
          },
          WidgetToolbarRepository: function WidgetToolbarRepository() {
            return d;
          },
          WidgetTypeAround: function WidgetTypeAround() {
            return R.Z;
          },
          findOptimalInsertionRange: function findOptimalInsertionRange() {
            return c.KT;
          },
          getLabel: function getLabel() {
            return c.id;
          },
          isWidget: function isWidget() {
            return c.Qd;
          },
          setHighlightHandling: function setHighlightHandling() {
            return c.em;
          },
          setLabel: function setLabel() {
            return c.l6;
          },
          toWidget: function toWidget() {
            return c.XC;
          },
          toWidgetEditable: function toWidgetEditable() {
            return c.sC;
          },
          viewToModelPositionOutsideModelElement: function viewToModelPositionOutsideModelElement() {
            return c.$n;
          }
        });
        var o = s("./packages/ckeditor5-widget/src/widget.js"),
          i = s("./packages/ckeditor5-core/src/plugin.js"),
          r = s("./packages/ckeditor5-ui/src/panel/balloon/contextualballoon.js"),
          n = s("./packages/ckeditor5-ui/src/toolbar/toolbarview.js"),
          a = s("./packages/ckeditor5-ui/src/panel/balloon/balloonpanelview.js"),
          c = s("./packages/ckeditor5-widget/src/utils.js"),
          l = s("./packages/ckeditor5-utils/src/ckeditorerror.js");
        var d = /*#__PURE__*/function (_i$Z10) {
          _inherits(d, _i$Z10);
          function d() {
            _classCallCheck(this, d);
            return _possibleConstructorReturn(this, _getPrototypeOf(d).apply(this, arguments));
          }
          _createClass(d, [{
            key: "init",
            value: function init() {
              var _this224 = this;
              var e = this.editor;
              if (e.plugins.has("BalloonToolbar")) {
                var _t235 = e.plugins.get("BalloonToolbar");
                this.listenTo(_t235, "show", function (t) {
                  (function (e) {
                    var t = e.getSelectedElement();
                    return !(!t || !(0, c.Qd)(t));
                  })(e.editing.view.document.selection) && t.stop();
                }, {
                  priority: "high"
                });
              }
              this._toolbarDefinitions = new Map(), this._balloon = this.editor.plugins.get("ContextualBalloon"), this.on("change:isEnabled", function () {
                _this224._updateToolbarsVisibility();
              }), this.listenTo(e.ui, "update", function () {
                _this224._updateToolbarsVisibility();
              }), this.listenTo(e.ui.focusTracker, "change:isFocused", function () {
                _this224._updateToolbarsVisibility();
              }, {
                priority: "low"
              });
            }
          }, {
            key: "destroy",
            value: function destroy() {
              _superPropGet(d, "destroy", this, 3)([]);
              var _iterator341 = _createForOfIteratorHelper(this._toolbarDefinitions.values()),
                _step341;
              try {
                for (_iterator341.s(); !(_step341 = _iterator341.n()).done;) {
                  var _e263 = _step341.value;
                  _e263.view.destroy();
                }
              } catch (err) {
                _iterator341.e(err);
              } finally {
                _iterator341.f();
              }
            }
          }, {
            key: "register",
            value: function register(e, _ref57) {
              var t = _ref57.ariaLabel,
                s = _ref57.items,
                o = _ref57.getRelatedElement,
                _ref57$balloonClassNa = _ref57.balloonClassName,
                i = _ref57$balloonClassNa === void 0 ? "ck-toolbar-container" : _ref57$balloonClassNa;
              if (!s.length) return void (0, l.KE)("widget-toolbar-no-items", {
                toolbarId: e
              });
              var r = this.editor,
                a = r.t,
                c = new n.Z(r.locale);
              if (c.ariaLabel = t || a("Widget toolbar"), this._toolbarDefinitions.has(e)) throw new l.ZP("widget-toolbar-duplicated", this, {
                toolbarId: e
              });
              c.fillFromConfig(s, r.ui.componentFactory), this._toolbarDefinitions.set(e, {
                view: c,
                getRelatedElement: o,
                balloonClassName: i
              });
            }
          }, {
            key: "_updateToolbarsVisibility",
            value: function _updateToolbarsVisibility() {
              var e = 0,
                t = null,
                s = null;
              var _iterator342 = _createForOfIteratorHelper(this._toolbarDefinitions.values()),
                _step342;
              try {
                for (_iterator342.s(); !(_step342 = _iterator342.n()).done;) {
                  var _o149 = _step342.value;
                  var _i122 = _o149.getRelatedElement(this.editor.editing.view.document.selection);
                  if (this.isEnabled && _i122) {
                    if (this.editor.ui.focusTracker.isFocused) {
                      var _r59 = _i122.getAncestors().length;
                      _r59 > e && (e = _r59, t = _i122, s = _o149);
                    } else this._isToolbarVisible(_o149) && this._hideToolbar(_o149);
                  } else this._isToolbarInBalloon(_o149) && this._hideToolbar(_o149);
                }
              } catch (err) {
                _iterator342.e(err);
              } finally {
                _iterator342.f();
              }
              s && this._showToolbar(s, t);
            }
          }, {
            key: "_hideToolbar",
            value: function _hideToolbar(e) {
              this._balloon.remove(e.view), this.stopListening(this._balloon, "change:visibleView");
            }
          }, {
            key: "_showToolbar",
            value: function _showToolbar(e, t) {
              var _this225 = this;
              this._isToolbarVisible(e) ? h(this.editor, t) : this._isToolbarInBalloon(e) || (this._balloon.add({
                view: e.view,
                position: u(this.editor, t),
                balloonClassName: e.balloonClassName
              }), this.listenTo(this._balloon, "change:visibleView", function () {
                var _iterator343 = _createForOfIteratorHelper(_this225._toolbarDefinitions.values()),
                  _step343;
                try {
                  for (_iterator343.s(); !(_step343 = _iterator343.n()).done;) {
                    var _e264 = _step343.value;
                    if (_this225._isToolbarVisible(_e264)) {
                      var _t236 = _e264.getRelatedElement(_this225.editor.editing.view.document.selection);
                      h(_this225.editor, _t236);
                    }
                  }
                } catch (err) {
                  _iterator343.e(err);
                } finally {
                  _iterator343.f();
                }
              }));
            }
          }, {
            key: "_isToolbarVisible",
            value: function _isToolbarVisible(e) {
              return this._balloon.visibleView === e.view;
            }
          }, {
            key: "_isToolbarInBalloon",
            value: function _isToolbarInBalloon(e) {
              return this._balloon.hasView(e.view);
            }
          }], [{
            key: "requires",
            get: function get() {
              return [r.Z];
            }
          }, {
            key: "pluginName",
            get: function get() {
              return "WidgetToolbarRepository";
            }
          }]);
          return d;
        }(i.Z);
        function h(e, t) {
          var s = e.plugins.get("ContextualBalloon"),
            o = u(e, t);
          s.updatePosition(o);
        }
        function u(e, t) {
          var s = e.editing.view,
            o = a.Z.defaultPositions;
          return {
            target: s.domConverter.mapViewToDom(t),
            positions: [o.northArrowSouth, o.northArrowSouthWest, o.northArrowSouthEast, o.southArrowNorth, o.southArrowNorthWest, o.southArrowNorthEast, o.viewportStickyNorth]
          };
        }
        var g = s("./packages/ckeditor5-ui/src/template.js"),
          p = s("./packages/ckeditor5-utils/src/dom/rect.js"),
          f = s("./packages/ckeditor5-utils/src/comparearrays.js"),
          m = s("./packages/ckeditor5-utils/src/observablemixin.js"),
          k = s("./packages/ckeditor5-utils/src/mix.js");
        var _ = /*#__PURE__*/function () {
          function _(e) {
            _classCallCheck(this, _);
            this.set("activeHandlePosition", null), this.set("proposedWidthPercents", null), this.set("proposedWidth", null), this.set("proposedHeight", null), this.set("proposedHandleHostWidth", null), this.set("proposedHandleHostHeight", null), this._options = e, this._referenceCoordinates = null;
          }
          _createClass(_, [{
            key: "begin",
            value: function begin(e, t, s) {
              var o = new p.Z(t);
              this.activeHandlePosition = function (e) {
                var t = ["top-left", "top-right", "bottom-right", "bottom-left"];
                for (var _i123 = 0, _t237 = t; _i123 < _t237.length; _i123++) {
                  var _s229 = _t237[_i123];
                  if (e.classList.contains(b(_s229))) return _s229;
                }
              }(e), this._referenceCoordinates = function (e, t) {
                var s = new p.Z(e),
                  o = t.split("-"),
                  i = {
                    x: "right" == o[1] ? s.right : s.left,
                    y: "bottom" == o[0] ? s.bottom : s.top
                  };
                return i.x += e.ownerDocument.defaultView.scrollX, i.y += e.ownerDocument.defaultView.scrollY, i;
              }(t, function (e) {
                var t = e.split("-"),
                  s = {
                    top: "bottom",
                    bottom: "top",
                    left: "right",
                    right: "left"
                  };
                return "".concat(s[t[0]], "-").concat(s[t[1]]);
              }(this.activeHandlePosition)), this.originalWidth = o.width, this.originalHeight = o.height, this.aspectRatio = o.width / o.height;
              var i = s.style.width;
              i && i.match(/^\d+(\.\d*)?%$/) ? this.originalWidthPercents = parseFloat(i) : this.originalWidthPercents = function (e, t) {
                var s = e.parentElement,
                  o = parseFloat(s.ownerDocument.defaultView.getComputedStyle(s).width);
                return t.width / o * 100;
              }(s, o);
            }
          }, {
            key: "update",
            value: function update(e) {
              this.proposedWidth = e.width, this.proposedHeight = e.height, this.proposedWidthPercents = e.widthPercents, this.proposedHandleHostWidth = e.handleHostWidth, this.proposedHandleHostHeight = e.handleHostHeight;
            }
          }]);
          return _;
        }();
        function b(e) {
          return "ck-widget__resizer__handle-".concat(e);
        }
        (0, k.Z)(_, m.Z);
        var w = s("./packages/ckeditor5-ui/src/view.js");
        var v = /*#__PURE__*/function (_w$Z) {
          _inherits(v, _w$Z);
          function v() {
            var _this226;
            _classCallCheck(this, v);
            _this226 = _possibleConstructorReturn(this, _getPrototypeOf(v).call(this));
            var e = _this226.bindTemplate;
            _this226.setTemplate({
              tag: "div",
              attributes: {
                class: ["ck", "ck-size-view", e.to("_viewPosition", function (e) {
                  return e ? "ck-orientation-".concat(e) : "";
                })],
                style: {
                  display: e.if("_isVisible", "none", function (e) {
                    return !e;
                  })
                }
              },
              children: [{
                text: e.to("_label")
              }]
            });
            return _this226;
          }
          _createClass(v, [{
            key: "_bindToState",
            value: function _bindToState(e, t) {
              this.bind("_isVisible").to(t, "proposedWidth", t, "proposedHeight", function (e, t) {
                return null !== e && null !== t;
              }), this.bind("_label").to(t, "proposedHandleHostWidth", t, "proposedHandleHostHeight", t, "proposedWidthPercents", function (t, s, o) {
                return "px" === e.unit ? "".concat(t, "\xD7").concat(s) : "".concat(o, "%");
              }), this.bind("_viewPosition").to(t, "activeHandlePosition", t, "proposedHandleHostWidth", t, "proposedHandleHostHeight", function (e, t, s) {
                return t < 50 || s < 50 ? "above-center" : e;
              });
            }
          }, {
            key: "_dismiss",
            value: function _dismiss() {
              this.unbind(), this._isVisible = !1;
            }
          }]);
          return v;
        }(w.Z);
        var y = /*#__PURE__*/function () {
          function y(e) {
            var _this227 = this;
            _classCallCheck(this, y);
            this._options = e, this._viewResizerWrapper = null, this.set("isEnabled", !0), this.decorate("begin"), this.decorate("cancel"), this.decorate("commit"), this.decorate("updateSize"), this.on("commit", function (e) {
              _this227.state.proposedWidth || _this227.state.proposedWidthPercents || (_this227._cleanup(), e.stop());
            }, {
              priority: "high"
            }), this.on("change:isEnabled", function () {
              _this227.isEnabled && _this227.redraw();
            });
          }
          _createClass(y, [{
            key: "attach",
            value: function attach() {
              var _this228 = this;
              var e = this,
                t = this._options.viewElement;
              this._options.editor.editing.view.change(function (s) {
                var o = s.createUIElement("div", {
                  class: "ck ck-reset_all ck-widget__resizer"
                }, function (t) {
                  var s = this.toDomElement(t);
                  return e._appendHandles(s), e._appendSizeUI(s), e.on("change:isEnabled", function (e, t, o) {
                    s.style.display = o ? "" : "none";
                  }), s.style.display = e.isEnabled ? "" : "none", s;
                });
                s.insert(s.createPositionAt(t, "end"), o), s.addClass("ck-widget_with-resizer", t), _this228._viewResizerWrapper = o;
              });
            }
          }, {
            key: "begin",
            value: function begin(e) {
              this.state = new _(this._options), this._sizeView._bindToState(this._options, this.state), this._initialViewWidth = this._options.viewElement.getStyle("width"), this.state.begin(e, this._getHandleHost(), this._getResizeHost());
            }
          }, {
            key: "updateSize",
            value: function updateSize(e) {
              var _this229 = this;
              var t = this._proposeNewSize(e);
              this._options.editor.editing.view.change(function (e) {
                var s = _this229._options.unit || "%",
                  o = ("%" === s ? t.widthPercents : t.width) + s;
                e.setStyle("width", o, _this229._options.viewElement);
              });
              var s = this._getHandleHost(),
                o = new p.Z(s);
              t.handleHostWidth = Math.round(o.width), t.handleHostHeight = Math.round(o.height);
              var i = new p.Z(s);
              t.width = Math.round(i.width), t.height = Math.round(i.height), this.redraw(o), this.state.update(t);
            }
          }, {
            key: "commit",
            value: function commit() {
              var _this230 = this;
              var e = this._options.unit || "%",
                t = ("%" === e ? this.state.proposedWidthPercents : this.state.proposedWidth) + e;
              this._options.editor.editing.view.change(function () {
                _this230._cleanup(), _this230._options.onCommit(t);
              });
            }
          }, {
            key: "cancel",
            value: function cancel() {
              this._cleanup();
            }
          }, {
            key: "destroy",
            value: function destroy() {
              this.cancel();
            }
          }, {
            key: "redraw",
            value: function redraw(e) {
              var t = this._domResizerWrapper;
              if (!((s = t) && s.ownerDocument && s.ownerDocument.contains(s))) return;
              var s;
              var o = t.parentElement,
                i = this._getHandleHost(),
                r = this._viewResizerWrapper,
                n = [r.getStyle("width"), r.getStyle("height"), r.getStyle("left"), r.getStyle("top")];
              var a;
              if (o.isSameNode(i)) {
                var _t238 = e || new p.Z(i);
                a = [_t238.width + "px", _t238.height + "px", void 0, void 0];
              } else a = [i.offsetWidth + "px", i.offsetHeight + "px", i.offsetLeft + "px", i.offsetTop + "px"];
              "same" !== (0, f.Z)(n, a) && this._options.editor.editing.view.change(function (e) {
                e.setStyle({
                  width: a[0],
                  height: a[1],
                  left: a[2],
                  top: a[3]
                }, r);
              });
            }
          }, {
            key: "containsHandle",
            value: function containsHandle(e) {
              return this._domResizerWrapper.contains(e);
            }
          }, {
            key: "_cleanup",
            value: function _cleanup() {
              var _this231 = this;
              this._sizeView._dismiss();
              this._options.editor.editing.view.change(function (e) {
                e.setStyle("width", _this231._initialViewWidth, _this231._options.viewElement);
              });
            }
          }, {
            key: "_proposeNewSize",
            value: function _proposeNewSize(e) {
              var t = this.state,
                s = {
                  x: (o = e).pageX,
                  y: o.pageY
                };
              var o;
              var i = !this._options.isCentered || this._options.isCentered(this),
                r = {
                  x: t._referenceCoordinates.x - (s.x + t.originalWidth),
                  y: s.y - t.originalHeight - t._referenceCoordinates.y
                };
              i && t.activeHandlePosition.endsWith("-right") && (r.x = s.x - (t._referenceCoordinates.x + t.originalWidth)), i && (r.x *= 2);
              var n = {
                width: Math.abs(t.originalWidth + r.x),
                height: Math.abs(t.originalHeight + r.y)
              };
              n.dominant = n.width / t.aspectRatio > n.height ? "width" : "height", n.max = n[n.dominant];
              var a = {
                width: n.width,
                height: n.height
              };
              return "width" == n.dominant ? a.height = a.width / t.aspectRatio : a.width = a.height * t.aspectRatio, {
                width: Math.round(a.width),
                height: Math.round(a.height),
                widthPercents: Math.min(Math.round(t.originalWidthPercents / t.originalWidth * a.width * 100) / 100, 100)
              };
            }
          }, {
            key: "_getResizeHost",
            value: function _getResizeHost() {
              var e = this._domResizerWrapper.parentElement;
              return this._options.getResizeHost(e);
            }
          }, {
            key: "_getHandleHost",
            value: function _getHandleHost() {
              var e = this._domResizerWrapper.parentElement;
              return this._options.getHandleHost(e);
            }
          }, {
            key: "_appendHandles",
            value: function _appendHandles(e) {
              var t = ["top-left", "top-right", "bottom-right", "bottom-left"];
              for (var _i124 = 0, _t239 = t; _i124 < _t239.length; _i124++) {
                var _o150 = _t239[_i124];
                e.appendChild(new g.ZP({
                  tag: "div",
                  attributes: {
                    class: "ck-widget__resizer__handle " + (s = _o150, "ck-widget__resizer__handle-".concat(s))
                  }
                }).render());
              }
              var s;
            }
          }, {
            key: "_appendSizeUI",
            value: function _appendSizeUI(e) {
              this._sizeView = new v(), this._sizeView.render(), e.appendChild(this._sizeView.element);
            }
          }, {
            key: "_domResizerWrapper",
            get: function get() {
              return this._options.editor.editing.view.domConverter.mapViewToDom(this._viewResizerWrapper);
            }
          }], [{
            key: "isResizeHandle",
            value: function isResizeHandle(e) {
              return e.classList.contains("ck-widget__resizer__handle");
            }
          }]);
          return y;
        }();
        (0, k.Z)(y, m.Z);
        var Z = s("./packages/ckeditor5-utils/src/dom/emittermixin.js"),
          P = s("./packages/ckeditor5-utils/src/dom/global.js"),
          j = s("./packages/ckeditor5-engine/src/view/observer/mouseobserver.js"),
          x = s("./node_modules/lodash-es/throttle.js"),
          A = s("./node_modules/style-loader/dist/runtime/injectStylesIntoStyleTag.js"),
          T = s.n(A),
          C = s("./node_modules/css-loader/dist/cjs.js!./node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].use[2]!./packages/ckeditor5-widget/theme/widgetresize.css"),
          E = {
            injectType: "singletonStyleTag",
            attributes: {
              "data-cke": !0
            },
            insert: "head",
            singleton: !0
          };
        T()(C.Z, E);
        C.Z.locals;
        var S = /*#__PURE__*/function (_i$Z11) {
          _inherits(S, _i$Z11);
          function S() {
            _classCallCheck(this, S);
            return _possibleConstructorReturn(this, _getPrototypeOf(S).apply(this, arguments));
          }
          _createClass(S, [{
            key: "init",
            value: function init() {
              var _this232 = this;
              var e = this.editor.editing,
                t = P.Z.window.document;
              this.set("visibleResizer", null), this.set("_activeResizer", null), this._resizers = new Map(), e.view.addObserver(j.Z), this._observer = Object.create(Z.Z), this.listenTo(e.view.document, "mousedown", this._mouseDownListener.bind(this), {
                priority: "high"
              }), this._observer.listenTo(t, "mousemove", this._mouseMoveListener.bind(this)), this._observer.listenTo(t, "mouseup", this._mouseUpListener.bind(this));
              var s = function s() {
                _this232.visibleResizer && _this232.visibleResizer.redraw();
              };
              this._redrawFocusedResizerThrottled = (0, x.Z)(s, 200), this.on("change:visibleResizer", s), this.editor.ui.on("update", this._redrawFocusedResizerThrottled), this.editor.model.document.on("change", function () {
                var _iterator344 = _createForOfIteratorHelper(_this232._resizers),
                  _step344;
                try {
                  for (_iterator344.s(); !(_step344 = _iterator344.n()).done;) {
                    var _step344$value = _slicedToArray(_step344.value, 2),
                      _e265 = _step344$value[0],
                      _t240 = _step344$value[1];
                    _e265.isAttached() || (_this232._resizers.delete(_e265), _t240.destroy());
                  }
                } catch (err) {
                  _iterator344.e(err);
                } finally {
                  _iterator344.f();
                }
              }, {
                priority: "lowest"
              }), this._observer.listenTo(P.Z.window, "resize", this._redrawFocusedResizerThrottled);
              var o = this.editor.editing.view.document.selection;
              o.on("change", function () {
                var e = o.getSelectedElement();
                _this232.visibleResizer = _this232.getResizerByViewElement(e) || null;
              });
            }
          }, {
            key: "destroy",
            value: function destroy() {
              this._observer.stopListening();
              var _iterator345 = _createForOfIteratorHelper(this._resizers.values()),
                _step345;
              try {
                for (_iterator345.s(); !(_step345 = _iterator345.n()).done;) {
                  var _e266 = _step345.value;
                  _e266.destroy();
                }
              } catch (err) {
                _iterator345.e(err);
              } finally {
                _iterator345.f();
              }
              this._redrawFocusedResizerThrottled.cancel();
            }
          }, {
            key: "attachTo",
            value: function attachTo(e) {
              var t = new y(e),
                s = this.editor.plugins;
              if (t.attach(), s.has("WidgetToolbarRepository")) {
                var _e267 = s.get("WidgetToolbarRepository");
                t.on("begin", function () {
                  _e267.forceDisabled("resize");
                }, {
                  priority: "lowest"
                }), t.on("cancel", function () {
                  _e267.clearForceDisabled("resize");
                }, {
                  priority: "highest"
                }), t.on("commit", function () {
                  _e267.clearForceDisabled("resize");
                }, {
                  priority: "highest"
                });
              }
              this._resizers.set(e.viewElement, t);
              var o = this.editor.editing.view.document.selection.getSelectedElement();
              return this.getResizerByViewElement(o) == t && (this.visibleResizer = t), t;
            }
          }, {
            key: "getResizerByViewElement",
            value: function getResizerByViewElement(e) {
              return this._resizers.get(e);
            }
          }, {
            key: "_getResizerByHandle",
            value: function _getResizerByHandle(e) {
              var _iterator346 = _createForOfIteratorHelper(this._resizers.values()),
                _step346;
              try {
                for (_iterator346.s(); !(_step346 = _iterator346.n()).done;) {
                  var _t241 = _step346.value;
                  if (_t241.containsHandle(e)) return _t241;
                }
              } catch (err) {
                _iterator346.e(err);
              } finally {
                _iterator346.f();
              }
            }
          }, {
            key: "_mouseDownListener",
            value: function _mouseDownListener(e, t) {
              var s = t.domTarget;
              y.isResizeHandle(s) && (this._activeResizer = this._getResizerByHandle(s), this._activeResizer && (this._activeResizer.begin(s), e.stop(), t.preventDefault()));
            }
          }, {
            key: "_mouseMoveListener",
            value: function _mouseMoveListener(e, t) {
              this._activeResizer && this._activeResizer.updateSize(t);
            }
          }, {
            key: "_mouseUpListener",
            value: function _mouseUpListener() {
              this._activeResizer && (this._activeResizer.commit(), this._activeResizer = null);
            }
          }], [{
            key: "pluginName",
            get: function get() {
              return "WidgetResize";
            }
          }]);
          return S;
        }(i.Z);
        (0, k.Z)(S, m.Z);
        var R = s("./packages/ckeditor5-widget/src/widgettypearound/widgettypearound.js");
      },
      "?7cdd": function cdd(e, t, s) {
        e.exports = s;
      },
      "./node_modules/lodash-es/_ListCache.js": function _node_modules_lodashEs__ListCacheJs(e, t, s) {
        "use strict";

        s.d(t, {
          Z: function Z() {
            return u;
          }
        });
        var o = function o() {
          this.__data__ = [], this.size = 0;
        };
        var i = s("./node_modules/lodash-es/eq.js");
        var r = function r(e, t) {
          for (var s = e.length; s--;) if ((0, i.Z)(e[s][0], t)) return s;
          return -1;
        };
        var n = Array.prototype.splice;
        var a = function a(e) {
          var t = this.__data__,
            s = r(t, e);
          return !(s < 0) && (s == t.length - 1 ? t.pop() : n.call(t, s, 1), --this.size, !0);
        };
        var c = function c(e) {
          var t = this.__data__,
            s = r(t, e);
          return s < 0 ? void 0 : t[s][1];
        };
        var l = function l(e) {
          return r(this.__data__, e) > -1;
        };
        var d = function d(e, t) {
          var s = this.__data__,
            o = r(s, e);
          return o < 0 ? (++this.size, s.push([e, t])) : s[o][1] = t, this;
        };
        function h(e) {
          var t = -1,
            s = null == e ? 0 : e.length;
          for (this.clear(); ++t < s;) {
            var o = e[t];
            this.set(o[0], o[1]);
          }
        }
        h.prototype.clear = o, h.prototype.delete = a, h.prototype.get = c, h.prototype.has = l, h.prototype.set = d;
        var u = h;
      },
      "./node_modules/lodash-es/_Map.js": function _node_modules_lodashEs__MapJs(e, t, s) {
        "use strict";

        s.d(t, {
          Z: function Z() {
            return r;
          }
        });
        var o = s("./node_modules/lodash-es/_getNative.js"),
          i = s("./node_modules/lodash-es/_root.js");
        var r = (0, o.Z)(i.Z, "Map");
      },
      "./node_modules/lodash-es/_MapCache.js": function _node_modules_lodashEs__MapCacheJs(e, t, s) {
        "use strict";

        s.d(t, {
          Z: function Z() {
            return _Z2;
          }
        });
        var o = (0, s("./node_modules/lodash-es/_getNative.js").Z)(Object, "create");
        var i = function i() {
          this.__data__ = o ? o(null) : {}, this.size = 0;
        };
        var r = function r(e) {
          var t = this.has(e) && delete this.__data__[e];
          return this.size -= t ? 1 : 0, t;
        };
        var n = Object.prototype.hasOwnProperty;
        var a = function a(e) {
          var t = this.__data__;
          if (o) {
            var s = t[e];
            return "__lodash_hash_undefined__" === s ? void 0 : s;
          }
          return n.call(t, e) ? t[e] : void 0;
        };
        var c = Object.prototype.hasOwnProperty;
        var l = function l(e) {
          var t = this.__data__;
          return o ? void 0 !== t[e] : c.call(t, e);
        };
        var d = function d(e, t) {
          var s = this.__data__;
          return this.size += this.has(e) ? 0 : 1, s[e] = o && void 0 === t ? "__lodash_hash_undefined__" : t, this;
        };
        function h(e) {
          var t = -1,
            s = null == e ? 0 : e.length;
          for (this.clear(); ++t < s;) {
            var o = e[t];
            this.set(o[0], o[1]);
          }
        }
        h.prototype.clear = i, h.prototype.delete = r, h.prototype.get = a, h.prototype.has = l, h.prototype.set = d;
        var u = h;
        var g = s("./node_modules/lodash-es/_ListCache.js"),
          p = s("./node_modules/lodash-es/_Map.js");
        var f = function f() {
          this.size = 0, this.__data__ = {
            hash: new u(),
            map: new (p.Z || g.Z)(),
            string: new u()
          };
        };
        var m = function m(e) {
          var t = typeof e;
          return "string" == t || "number" == t || "symbol" == t || "boolean" == t ? "__proto__" !== e : null === e;
        };
        var k = function k(e, t) {
          var s = e.__data__;
          return m(t) ? s["string" == typeof t ? "string" : "hash"] : s.map;
        };
        var _ = function _(e) {
          var t = k(this, e).delete(e);
          return this.size -= t ? 1 : 0, t;
        };
        var b = function b(e) {
          return k(this, e).get(e);
        };
        var w = function w(e) {
          return k(this, e).has(e);
        };
        var v = function v(e, t) {
          var s = k(this, e),
            o = s.size;
          return s.set(e, t), this.size += s.size == o ? 0 : 1, this;
        };
        function y(e) {
          var t = -1,
            s = null == e ? 0 : e.length;
          for (this.clear(); ++t < s;) {
            var o = e[t];
            this.set(o[0], o[1]);
          }
        }
        y.prototype.clear = f, y.prototype.delete = _, y.prototype.get = b, y.prototype.has = w, y.prototype.set = v;
        var _Z2 = y;
      },
      "./node_modules/lodash-es/_Stack.js": function _node_modules_lodashEs__StackJs(e, t, s) {
        "use strict";

        s.d(t, {
          Z: function Z() {
            return u;
          }
        });
        var o = s("./node_modules/lodash-es/_ListCache.js");
        var i = function i() {
          this.__data__ = new o.Z(), this.size = 0;
        };
        var r = function r(e) {
          var t = this.__data__,
            s = t.delete(e);
          return this.size = t.size, s;
        };
        var n = function n(e) {
          return this.__data__.get(e);
        };
        var a = function a(e) {
          return this.__data__.has(e);
        };
        var c = s("./node_modules/lodash-es/_Map.js"),
          l = s("./node_modules/lodash-es/_MapCache.js");
        var d = function d(e, t) {
          var s = this.__data__;
          if (s instanceof o.Z) {
            var i = s.__data__;
            if (!c.Z || i.length < 199) return i.push([e, t]), this.size = ++s.size, this;
            s = this.__data__ = new l.Z(i);
          }
          return s.set(e, t), this.size = s.size, this;
        };
        function h(e) {
          var t = this.__data__ = new o.Z(e);
          this.size = t.size;
        }
        h.prototype.clear = i, h.prototype.delete = r, h.prototype.get = n, h.prototype.has = a, h.prototype.set = d;
        var u = h;
      },
      "./node_modules/lodash-es/_Symbol.js": function _node_modules_lodashEs__SymbolJs(e, t, s) {
        "use strict";

        s.d(t, {
          Z: function Z() {
            return o;
          }
        });
        var o = s("./node_modules/lodash-es/_root.js").Z.Symbol;
      },
      "./node_modules/lodash-es/_Uint8Array.js": function _node_modules_lodashEs__Uint8ArrayJs(e, t, s) {
        "use strict";

        s.d(t, {
          Z: function Z() {
            return o;
          }
        });
        var o = s("./node_modules/lodash-es/_root.js").Z.Uint8Array;
      },
      "./node_modules/lodash-es/_arrayLikeKeys.js": function _node_modules_lodashEs__arrayLikeKeysJs(e, t, s) {
        "use strict";

        s.d(t, {
          Z: function Z() {
            return d;
          }
        });
        var o = function o(e, t) {
          for (var s = -1, o = Array(e); ++s < e;) o[s] = t(s);
          return o;
        };
        var i = s("./node_modules/lodash-es/isArguments.js"),
          r = s("./node_modules/lodash-es/isArray.js"),
          n = s("./node_modules/lodash-es/isBuffer.js"),
          a = s("./node_modules/lodash-es/_isIndex.js"),
          c = s("./node_modules/lodash-es/isTypedArray.js"),
          l = Object.prototype.hasOwnProperty;
        var d = function d(e, t) {
          var s = (0, r.Z)(e),
            d = !s && (0, i.Z)(e),
            h = !s && !d && (0, n.Z)(e),
            u = !s && !d && !h && (0, c.Z)(e),
            g = s || d || h || u,
            p = g ? o(e.length, String) : [],
            f = p.length;
          for (var m in e) !t && !l.call(e, m) || g && ("length" == m || h && ("offset" == m || "parent" == m) || u && ("buffer" == m || "byteLength" == m || "byteOffset" == m) || (0, a.Z)(m, f)) || p.push(m);
          return p;
        };
      },
      "./node_modules/lodash-es/_arrayPush.js": function _node_modules_lodashEs__arrayPushJs(e, t, s) {
        "use strict";

        s.d(t, {
          Z: function Z() {
            return o;
          }
        });
        var o = function o(e, t) {
          for (var s = -1, o = t.length, i = e.length; ++s < o;) e[i + s] = t[s];
          return e;
        };
      },
      "./node_modules/lodash-es/_assignValue.js": function _node_modules_lodashEs__assignValueJs(e, t, s) {
        "use strict";

        s.d(t, {
          Z: function Z() {
            return n;
          }
        });
        var o = s("./node_modules/lodash-es/_baseAssignValue.js"),
          i = s("./node_modules/lodash-es/eq.js"),
          r = Object.prototype.hasOwnProperty;
        var n = function n(e, t, s) {
          var n = e[t];
          r.call(e, t) && (0, i.Z)(n, s) && (void 0 !== s || t in e) || (0, o.Z)(e, t, s);
        };
      },
      "./node_modules/lodash-es/_baseAssignValue.js": function _node_modules_lodashEs__baseAssignValueJs(e, t, s) {
        "use strict";

        s.d(t, {
          Z: function Z() {
            return i;
          }
        });
        var o = s("./node_modules/lodash-es/_defineProperty.js");
        var i = function i(e, t, s) {
          "__proto__" == t && o.Z ? (0, o.Z)(e, t, {
            configurable: !0,
            enumerable: !0,
            value: s,
            writable: !0
          }) : e[t] = s;
        };
      },
      "./node_modules/lodash-es/_baseClone.js": function _node_modules_lodashEs__baseCloneJs(e, t, s) {
        "use strict";

        s.d(t, {
          Z: function Z() {
            return Y;
          }
        });
        var o = s("./node_modules/lodash-es/_Stack.js");
        var i = function i(e, t) {
          for (var s = -1, o = null == e ? 0 : e.length; ++s < o && !1 !== t(e[s], s, e););
          return e;
        };
        var r = s("./node_modules/lodash-es/_assignValue.js"),
          n = s("./node_modules/lodash-es/_copyObject.js"),
          a = s("./node_modules/lodash-es/keys.js");
        var c = function c(e, t) {
          return e && (0, n.Z)(t, (0, a.Z)(t), e);
        };
        var l = s("./node_modules/lodash-es/keysIn.js");
        var d = function d(e, t) {
          return e && (0, n.Z)(t, (0, l.Z)(t), e);
        };
        var h = s("./node_modules/lodash-es/_cloneBuffer.js"),
          u = s("./node_modules/lodash-es/_copyArray.js"),
          g = s("./node_modules/lodash-es/_getSymbols.js");
        var p = function p(e, t) {
          return (0, n.Z)(e, (0, g.Z)(e), t);
        };
        var f = s("./node_modules/lodash-es/_arrayPush.js"),
          m = s("./node_modules/lodash-es/_getPrototype.js"),
          k = s("./node_modules/lodash-es/stubArray.js");
        var _ = Object.getOwnPropertySymbols ? function (e) {
          for (var t = []; e;) (0, f.Z)(t, (0, g.Z)(e)), e = (0, m.Z)(e);
          return t;
        } : k.Z;
        var b = function b(e, t) {
          return (0, n.Z)(e, _(e), t);
        };
        var w = s("./node_modules/lodash-es/_getAllKeys.js"),
          v = s("./node_modules/lodash-es/_baseGetAllKeys.js");
        var y = function y(e) {
          return (0, v.Z)(e, l.Z, _);
        };
        var Z = s("./node_modules/lodash-es/_getTag.js"),
          P = Object.prototype.hasOwnProperty;
        var j = function j(e) {
          var t = e.length,
            s = new e.constructor(t);
          return t && "string" == typeof e[0] && P.call(e, "index") && (s.index = e.index, s.input = e.input), s;
        };
        var x = s("./node_modules/lodash-es/_cloneArrayBuffer.js");
        var A = function A(e, t) {
          var s = t ? (0, x.Z)(e.buffer) : e.buffer;
          return new e.constructor(s, e.byteOffset, e.byteLength);
        };
        var T = /\w*$/;
        var C = function C(e) {
          var t = new e.constructor(e.source, T.exec(e));
          return t.lastIndex = e.lastIndex, t;
        };
        var E = s("./node_modules/lodash-es/_Symbol.js"),
          S = E.Z ? E.Z.prototype : void 0,
          R = S ? S.valueOf : void 0;
        var O = function O(e) {
          return R ? Object(R.call(e)) : {};
        };
        var M = s("./node_modules/lodash-es/_cloneTypedArray.js");
        var N = function N(e, t, s) {
          var o = e.constructor;
          switch (t) {
            case "[object ArrayBuffer]":
              return (0, x.Z)(e);
            case "[object Boolean]":
            case "[object Date]":
              return new o(+e);
            case "[object DataView]":
              return A(e, s);
            case "[object Float32Array]":
            case "[object Float64Array]":
            case "[object Int8Array]":
            case "[object Int16Array]":
            case "[object Int32Array]":
            case "[object Uint8Array]":
            case "[object Uint8ClampedArray]":
            case "[object Uint16Array]":
            case "[object Uint32Array]":
              return (0, M.Z)(e, s);
            case "[object Map]":
            case "[object Set]":
              return new o();
            case "[object Number]":
            case "[object String]":
              return new o(e);
            case "[object RegExp]":
              return C(e);
            case "[object Symbol]":
              return O(e);
          }
        };
        var I = s("./node_modules/lodash-es/_initCloneObject.js"),
          z = s("./node_modules/lodash-es/isArray.js"),
          V = s("./node_modules/lodash-es/isBuffer.js"),
          D = s("./node_modules/lodash-es/isObjectLike.js");
        var B = function B(e) {
          return (0, D.Z)(e) && "[object Map]" == (0, Z.Z)(e);
        };
        var F = s("./node_modules/lodash-es/_baseUnary.js"),
          L = s("./node_modules/lodash-es/_nodeUtil.js"),
          W = L.Z && L.Z.isMap;
        var q = W ? (0, F.Z)(W) : B;
        var H = s("./node_modules/lodash-es/isObject.js");
        var $ = function $(e) {
          return (0, D.Z)(e) && "[object Set]" == (0, Z.Z)(e);
        };
        var U = L.Z && L.Z.isSet;
        var K = U ? (0, F.Z)(U) : $;
        var G = "[object Arguments]",
          J = "[object Function]",
          X = "[object Object]",
          Q = {};
        Q[G] = Q["[object Array]"] = Q["[object ArrayBuffer]"] = Q["[object DataView]"] = Q["[object Boolean]"] = Q["[object Date]"] = Q["[object Float32Array]"] = Q["[object Float64Array]"] = Q["[object Int8Array]"] = Q["[object Int16Array]"] = Q["[object Int32Array]"] = Q["[object Map]"] = Q["[object Number]"] = Q[X] = Q["[object RegExp]"] = Q["[object Set]"] = Q["[object String]"] = Q["[object Symbol]"] = Q["[object Uint8Array]"] = Q["[object Uint8ClampedArray]"] = Q["[object Uint16Array]"] = Q["[object Uint32Array]"] = !0, Q["[object Error]"] = Q[J] = Q["[object WeakMap]"] = !1;
        var Y = function e(t, s, n, g, f, m) {
          var k,
            _ = 1 & s,
            v = 2 & s,
            P = 4 & s;
          if (n && (k = f ? n(t, g, f, m) : n(t)), void 0 !== k) return k;
          if (!(0, H.Z)(t)) return t;
          var x = (0, z.Z)(t);
          if (x) {
            if (k = j(t), !_) return (0, u.Z)(t, k);
          } else {
            var A = (0, Z.Z)(t),
              T = A == J || "[object GeneratorFunction]" == A;
            if ((0, V.Z)(t)) return (0, h.Z)(t, _);
            if (A == X || A == G || T && !f) {
              if (k = v || T ? {} : (0, I.Z)(t), !_) return v ? b(t, d(k, t)) : p(t, c(k, t));
            } else {
              if (!Q[A]) return f ? t : {};
              k = N(t, A, _);
            }
          }
          m || (m = new o.Z());
          var C = m.get(t);
          if (C) return C;
          m.set(t, k), K(t) ? t.forEach(function (o) {
            k.add(e(o, s, n, o, t, m));
          }) : q(t) && t.forEach(function (o, i) {
            k.set(i, e(o, s, n, i, t, m));
          });
          var E = P ? v ? y : w.Z : v ? l.Z : a.Z,
            S = x ? void 0 : E(t);
          return i(S || t, function (o, i) {
            S && (o = t[i = o]), (0, r.Z)(k, i, e(o, s, n, i, t, m));
          }), k;
        };
      },
      "./node_modules/lodash-es/_baseGetAllKeys.js": function _node_modules_lodashEs__baseGetAllKeysJs(e, t, s) {
        "use strict";

        s.d(t, {
          Z: function Z() {
            return r;
          }
        });
        var o = s("./node_modules/lodash-es/_arrayPush.js"),
          i = s("./node_modules/lodash-es/isArray.js");
        var r = function r(e, t, s) {
          var r = t(e);
          return (0, i.Z)(e) ? r : (0, o.Z)(r, s(e));
        };
      },
      "./node_modules/lodash-es/_baseGetTag.js": function _node_modules_lodashEs__baseGetTagJs(e, t, s) {
        "use strict";

        s.d(t, {
          Z: function Z() {
            return u;
          }
        });
        var o = s("./node_modules/lodash-es/_Symbol.js"),
          i = Object.prototype,
          r = i.hasOwnProperty,
          n = i.toString,
          a = o.Z ? o.Z.toStringTag : void 0;
        var c = function c(e) {
          var t = r.call(e, a),
            s = e[a];
          try {
            e[a] = void 0;
            var o = !0;
          } catch (e) {}
          var i = n.call(e);
          return o && (t ? e[a] = s : delete e[a]), i;
        };
        var l = Object.prototype.toString;
        var d = function d(e) {
          return l.call(e);
        };
        var h = o.Z ? o.Z.toStringTag : void 0;
        var u = function u(e) {
          return null == e ? void 0 === e ? "[object Undefined]" : "[object Null]" : h && h in Object(e) ? c(e) : d(e);
        };
      },
      "./node_modules/lodash-es/_baseIsEqual.js": function _node_modules_lodashEs__baseIsEqualJs(e, t, s) {
        "use strict";

        s.d(t, {
          Z: function Z() {
            return O;
          }
        });
        var o = s("./node_modules/lodash-es/_Stack.js"),
          i = s("./node_modules/lodash-es/_MapCache.js");
        var r = function r(e) {
          return this.__data__.set(e, "__lodash_hash_undefined__"), this;
        };
        var n = function n(e) {
          return this.__data__.has(e);
        };
        function a(e) {
          var t = -1,
            s = null == e ? 0 : e.length;
          for (this.__data__ = new i.Z(); ++t < s;) this.add(e[t]);
        }
        a.prototype.add = a.prototype.push = r, a.prototype.has = n;
        var c = a;
        var l = function l(e, t) {
          for (var s = -1, o = null == e ? 0 : e.length; ++s < o;) if (t(e[s], s, e)) return !0;
          return !1;
        };
        var d = function d(e, t) {
          return e.has(t);
        };
        var h = function h(e, t, s, o, i, r) {
          var n = 1 & s,
            a = e.length,
            h = t.length;
          if (a != h && !(n && h > a)) return !1;
          var u = r.get(e),
            g = r.get(t);
          if (u && g) return u == t && g == e;
          var p = -1,
            f = !0,
            m = 2 & s ? new c() : void 0;
          for (r.set(e, t), r.set(t, e); ++p < a;) {
            var k = e[p],
              _ = t[p];
            if (o) var b = n ? o(_, k, p, t, e, r) : o(k, _, p, e, t, r);
            if (void 0 !== b) {
              if (b) continue;
              f = !1;
              break;
            }
            if (m) {
              if (!l(t, function (e, t) {
                if (!d(m, t) && (k === e || i(k, e, s, o, r))) return m.push(t);
              })) {
                f = !1;
                break;
              }
            } else if (k !== _ && !i(k, _, s, o, r)) {
              f = !1;
              break;
            }
          }
          return r.delete(e), r.delete(t), f;
        };
        var u = s("./node_modules/lodash-es/_Symbol.js"),
          g = s("./node_modules/lodash-es/_Uint8Array.js"),
          p = s("./node_modules/lodash-es/eq.js");
        var f = function f(e) {
          var t = -1,
            s = Array(e.size);
          return e.forEach(function (e, o) {
            s[++t] = [o, e];
          }), s;
        };
        var m = function m(e) {
          var t = -1,
            s = Array(e.size);
          return e.forEach(function (e) {
            s[++t] = e;
          }), s;
        };
        var k = u.Z ? u.Z.prototype : void 0,
          _ = k ? k.valueOf : void 0;
        var b = function b(e, t, s, o, i, r, n) {
          switch (s) {
            case "[object DataView]":
              if (e.byteLength != t.byteLength || e.byteOffset != t.byteOffset) return !1;
              e = e.buffer, t = t.buffer;
            case "[object ArrayBuffer]":
              return !(e.byteLength != t.byteLength || !r(new g.Z(e), new g.Z(t)));
            case "[object Boolean]":
            case "[object Date]":
            case "[object Number]":
              return (0, p.Z)(+e, +t);
            case "[object Error]":
              return e.name == t.name && e.message == t.message;
            case "[object RegExp]":
            case "[object String]":
              return e == t + "";
            case "[object Map]":
              var a = f;
            case "[object Set]":
              var c = 1 & o;
              if (a || (a = m), e.size != t.size && !c) return !1;
              var l = n.get(e);
              if (l) return l == t;
              o |= 2, n.set(e, t);
              var d = h(a(e), a(t), o, i, r, n);
              return n.delete(e), d;
            case "[object Symbol]":
              if (_) return _.call(e) == _.call(t);
          }
          return !1;
        };
        var w = s("./node_modules/lodash-es/_getAllKeys.js"),
          v = Object.prototype.hasOwnProperty;
        var y = function y(e, t, s, o, i, r) {
          var n = 1 & s,
            a = (0, w.Z)(e),
            c = a.length;
          if (c != (0, w.Z)(t).length && !n) return !1;
          for (var l = c; l--;) {
            var d = a[l];
            if (!(n ? d in t : v.call(t, d))) return !1;
          }
          var h = r.get(e),
            u = r.get(t);
          if (h && u) return h == t && u == e;
          var g = !0;
          r.set(e, t), r.set(t, e);
          for (var p = n; ++l < c;) {
            var f = e[d = a[l]],
              m = t[d];
            if (o) var k = n ? o(m, f, d, t, e, r) : o(f, m, d, e, t, r);
            if (!(void 0 === k ? f === m || i(f, m, s, o, r) : k)) {
              g = !1;
              break;
            }
            p || (p = "constructor" == d);
          }
          if (g && !p) {
            var _ = e.constructor,
              b = t.constructor;
            _ == b || !("constructor" in e) || !("constructor" in t) || "function" == typeof _ && _ instanceof _ && "function" == typeof b && b instanceof b || (g = !1);
          }
          return r.delete(e), r.delete(t), g;
        };
        var Z = s("./node_modules/lodash-es/_getTag.js"),
          P = s("./node_modules/lodash-es/isArray.js"),
          j = s("./node_modules/lodash-es/isBuffer.js"),
          x = s("./node_modules/lodash-es/isTypedArray.js"),
          A = "[object Arguments]",
          T = "[object Array]",
          C = "[object Object]",
          E = Object.prototype.hasOwnProperty;
        var S = function S(e, t, s, i, r, n) {
          var a = (0, P.Z)(e),
            c = (0, P.Z)(t),
            l = a ? T : (0, Z.Z)(e),
            d = c ? T : (0, Z.Z)(t),
            u = (l = l == A ? C : l) == C,
            g = (d = d == A ? C : d) == C,
            p = l == d;
          if (p && (0, j.Z)(e)) {
            if (!(0, j.Z)(t)) return !1;
            a = !0, u = !1;
          }
          if (p && !u) return n || (n = new o.Z()), a || (0, x.Z)(e) ? h(e, t, s, i, r, n) : b(e, t, l, s, i, r, n);
          if (!(1 & s)) {
            var f = u && E.call(e, "__wrapped__"),
              m = g && E.call(t, "__wrapped__");
            if (f || m) {
              var k = f ? e.value() : e,
                _ = m ? t.value() : t;
              return n || (n = new o.Z()), r(k, _, s, i, n);
            }
          }
          return !!p && (n || (n = new o.Z()), y(e, t, s, i, r, n));
        };
        var R = s("./node_modules/lodash-es/isObjectLike.js");
        var O = function e(t, s, o, i, r) {
          return t === s || (null == t || null == s || !(0, R.Z)(t) && !(0, R.Z)(s) ? t != t && s != s : S(t, s, o, i, e, r));
        };
      },
      "./node_modules/lodash-es/_baseUnary.js": function _node_modules_lodashEs__baseUnaryJs(e, t, s) {
        "use strict";

        s.d(t, {
          Z: function Z() {
            return o;
          }
        });
        var o = function o(e) {
          return function (t) {
            return e(t);
          };
        };
      },
      "./node_modules/lodash-es/_cloneArrayBuffer.js": function _node_modules_lodashEs__cloneArrayBufferJs(e, t, s) {
        "use strict";

        s.d(t, {
          Z: function Z() {
            return i;
          }
        });
        var o = s("./node_modules/lodash-es/_Uint8Array.js");
        var i = function i(e) {
          var t = new e.constructor(e.byteLength);
          return new o.Z(t).set(new o.Z(e)), t;
        };
      },
      "./node_modules/lodash-es/_cloneBuffer.js": function _node_modules_lodashEs__cloneBufferJs(e, t, s) {
        "use strict";

        s.d(t, {
          Z: function Z() {
            return c;
          }
        });
        var o = s("./node_modules/lodash-es/_root.js"),
          i = "object" == typeof exports && exports && !exports.nodeType && exports,
          r = i && "object" == typeof module && module && !module.nodeType && module,
          n = r && r.exports === i ? o.Z.Buffer : void 0,
          a = n ? n.allocUnsafe : void 0;
        var c = function c(e, t) {
          if (t) return e.slice();
          var s = e.length,
            o = a ? a(s) : new e.constructor(s);
          return e.copy(o), o;
        };
      },
      "./node_modules/lodash-es/_cloneTypedArray.js": function _node_modules_lodashEs__cloneTypedArrayJs(e, t, s) {
        "use strict";

        s.d(t, {
          Z: function Z() {
            return i;
          }
        });
        var o = s("./node_modules/lodash-es/_cloneArrayBuffer.js");
        var i = function i(e, t) {
          var s = t ? (0, o.Z)(e.buffer) : e.buffer;
          return new e.constructor(s, e.byteOffset, e.length);
        };
      },
      "./node_modules/lodash-es/_copyArray.js": function _node_modules_lodashEs__copyArrayJs(e, t, s) {
        "use strict";

        s.d(t, {
          Z: function Z() {
            return o;
          }
        });
        var o = function o(e, t) {
          var s = -1,
            o = e.length;
          for (t || (t = Array(o)); ++s < o;) t[s] = e[s];
          return t;
        };
      },
      "./node_modules/lodash-es/_copyObject.js": function _node_modules_lodashEs__copyObjectJs(e, t, s) {
        "use strict";

        s.d(t, {
          Z: function Z() {
            return r;
          }
        });
        var o = s("./node_modules/lodash-es/_assignValue.js"),
          i = s("./node_modules/lodash-es/_baseAssignValue.js");
        var r = function r(e, t, s, _r60) {
          var n = !s;
          s || (s = {});
          for (var a = -1, c = t.length; ++a < c;) {
            var l = t[a],
              d = _r60 ? _r60(s[l], e[l], l, s, e) : void 0;
            void 0 === d && (d = e[l]), n ? (0, i.Z)(s, l, d) : (0, o.Z)(s, l, d);
          }
          return s;
        };
      },
      "./node_modules/lodash-es/_createAssigner.js": function _node_modules_lodashEs__createAssignerJs(e, t, s) {
        "use strict";

        s.d(t, {
          Z: function Z() {
            return _;
          }
        });
        var o = function o(e) {
          return e;
        };
        var i = function i(e, t, s) {
          switch (s.length) {
            case 0:
              return e.call(t);
            case 1:
              return e.call(t, s[0]);
            case 2:
              return e.call(t, s[0], s[1]);
            case 3:
              return e.call(t, s[0], s[1], s[2]);
          }
          return e.apply(t, s);
        };
        var r = Math.max;
        var n = function n(e, t, s) {
          return t = r(void 0 === t ? e.length - 1 : t, 0), function () {
            for (var o = arguments, n = -1, a = r(o.length - t, 0), c = Array(a); ++n < a;) c[n] = o[t + n];
            n = -1;
            for (var l = Array(t + 1); ++n < t;) l[n] = o[n];
            return l[t] = s(c), i(e, this, l);
          };
        };
        var a = function a(e) {
          return function () {
            return e;
          };
        };
        var c = s("./node_modules/lodash-es/_defineProperty.js");
        var l = c.Z ? function (e, t) {
          return (0, c.Z)(e, "toString", {
            configurable: !0,
            enumerable: !1,
            value: a(t),
            writable: !0
          });
        } : o;
        var d = Date.now;
        var h = function (e) {
          var t = 0,
            s = 0;
          return function () {
            var o = d(),
              i = 16 - (o - s);
            if (s = o, i > 0) {
              if (++t >= 800) return arguments[0];
            } else t = 0;
            return e.apply(void 0, arguments);
          };
        }(l);
        var u = function u(e, t) {
          return h(n(e, t, o), e + "");
        };
        var g = s("./node_modules/lodash-es/eq.js"),
          p = s("./node_modules/lodash-es/isArrayLike.js"),
          f = s("./node_modules/lodash-es/_isIndex.js"),
          m = s("./node_modules/lodash-es/isObject.js");
        var k = function k(e, t, s) {
          if (!(0, m.Z)(s)) return !1;
          var o = typeof t;
          return !!("number" == o ? (0, p.Z)(s) && (0, f.Z)(t, s.length) : "string" == o && t in s) && (0, g.Z)(s[t], e);
        };
        var _ = function _(e) {
          return u(function (t, s) {
            var o = -1,
              i = s.length,
              r = i > 1 ? s[i - 1] : void 0,
              n = i > 2 ? s[2] : void 0;
            for (r = e.length > 3 && "function" == typeof r ? (i--, r) : void 0, n && k(s[0], s[1], n) && (r = i < 3 ? void 0 : r, i = 1), t = Object(t); ++o < i;) {
              var a = s[o];
              a && e(t, a, o, r);
            }
            return t;
          });
        };
      },
      "./node_modules/lodash-es/_defineProperty.js": function _node_modules_lodashEs__definePropertyJs(e, t, s) {
        "use strict";

        s.d(t, {
          Z: function Z() {
            return i;
          }
        });
        var o = s("./node_modules/lodash-es/_getNative.js");
        var i = function () {
          try {
            var e = (0, o.Z)(Object, "defineProperty");
            return e({}, "", {}), e;
          } catch (e) {}
        }();
      },
      "./node_modules/lodash-es/_freeGlobal.js": function _node_modules_lodashEs__freeGlobalJs(e, t, s) {
        "use strict";

        s.d(t, {
          Z: function Z() {
            return o;
          }
        });
        var o = "object" == typeof global && global && global.Object === Object && global;
      },
      "./node_modules/lodash-es/_getAllKeys.js": function _node_modules_lodashEs__getAllKeysJs(e, t, s) {
        "use strict";

        s.d(t, {
          Z: function Z() {
            return n;
          }
        });
        var o = s("./node_modules/lodash-es/_baseGetAllKeys.js"),
          i = s("./node_modules/lodash-es/_getSymbols.js"),
          r = s("./node_modules/lodash-es/keys.js");
        var n = function n(e) {
          return (0, o.Z)(e, r.Z, i.Z);
        };
      },
      "./node_modules/lodash-es/_getNative.js": function _node_modules_lodashEs__getNativeJs(e, t, s) {
        "use strict";

        s.d(t, {
          Z: function Z() {
            return _;
          }
        });
        var o = s("./node_modules/lodash-es/isFunction.js");
        var i = s("./node_modules/lodash-es/_root.js").Z["__core-js_shared__"];
        var r,
          n = (r = /[^.]+$/.exec(i && i.keys && i.keys.IE_PROTO || "")) ? "Symbol(src)_1." + r : "";
        var a = function a(e) {
          return !!n && n in e;
        };
        var c = s("./node_modules/lodash-es/isObject.js"),
          l = s("./node_modules/lodash-es/_toSource.js"),
          d = /^\[object .+?Constructor\]$/,
          h = Function.prototype,
          u = Object.prototype,
          g = h.toString,
          p = u.hasOwnProperty,
          f = RegExp("^" + g.call(p).replace(/[\\^$.*+?()[\]{}|]/g, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");
        var m = function m(e) {
          return !(!(0, c.Z)(e) || a(e)) && ((0, o.Z)(e) ? f : d).test((0, l.Z)(e));
        };
        var k = function k(e, t) {
          return null == e ? void 0 : e[t];
        };
        var _ = function _(e, t) {
          var s = k(e, t);
          return m(s) ? s : void 0;
        };
      },
      "./node_modules/lodash-es/_getPrototype.js": function _node_modules_lodashEs__getPrototypeJs(e, t, s) {
        "use strict";

        s.d(t, {
          Z: function Z() {
            return o;
          }
        });
        var o = (0, s("./node_modules/lodash-es/_overArg.js").Z)(Object.getPrototypeOf, Object);
      },
      "./node_modules/lodash-es/_getSymbols.js": function _node_modules_lodashEs__getSymbolsJs(e, t, s) {
        "use strict";

        s.d(t, {
          Z: function Z() {
            return a;
          }
        });
        var o = function o(e, t) {
          for (var s = -1, o = null == e ? 0 : e.length, i = 0, r = []; ++s < o;) {
            var n = e[s];
            t(n, s, e) && (r[i++] = n);
          }
          return r;
        };
        var i = s("./node_modules/lodash-es/stubArray.js"),
          r = Object.prototype.propertyIsEnumerable,
          n = Object.getOwnPropertySymbols;
        var a = n ? function (e) {
          return null == e ? [] : (e = Object(e), o(n(e), function (t) {
            return r.call(e, t);
          }));
        } : i.Z;
      },
      "./node_modules/lodash-es/_getTag.js": function _node_modules_lodashEs__getTagJs(e, t, s) {
        "use strict";

        s.d(t, {
          Z: function Z() {
            return _Z3;
          }
        });
        var o = s("./node_modules/lodash-es/_getNative.js"),
          i = s("./node_modules/lodash-es/_root.js");
        var r = (0, o.Z)(i.Z, "DataView");
        var n = s("./node_modules/lodash-es/_Map.js");
        var a = (0, o.Z)(i.Z, "Promise");
        var c = (0, o.Z)(i.Z, "Set");
        var l = (0, o.Z)(i.Z, "WeakMap");
        var d = s("./node_modules/lodash-es/_baseGetTag.js"),
          h = s("./node_modules/lodash-es/_toSource.js"),
          u = "[object Map]",
          g = "[object Promise]",
          p = "[object Set]",
          f = "[object WeakMap]",
          m = "[object DataView]",
          k = (0, h.Z)(r),
          _ = (0, h.Z)(n.Z),
          b = (0, h.Z)(a),
          w = (0, h.Z)(c),
          v = (0, h.Z)(l),
          y = d.Z;
        (r && y(new r(new ArrayBuffer(1))) != m || n.Z && y(new n.Z()) != u || a && y(a.resolve()) != g || c && y(new c()) != p || l && y(new l()) != f) && (y = function y(e) {
          var t = (0, d.Z)(e),
            s = "[object Object]" == t ? e.constructor : void 0,
            o = s ? (0, h.Z)(s) : "";
          if (o) switch (o) {
            case k:
              return m;
            case _:
              return u;
            case b:
              return g;
            case w:
              return p;
            case v:
              return f;
          }
          return t;
        });
        var _Z3 = y;
      },
      "./node_modules/lodash-es/_initCloneObject.js": function _node_modules_lodashEs__initCloneObjectJs(e, t, s) {
        "use strict";

        s.d(t, {
          Z: function Z() {
            return c;
          }
        });
        var o = s("./node_modules/lodash-es/isObject.js"),
          i = Object.create;
        var r = function () {
          function e() {}
          return function (t) {
            if (!(0, o.Z)(t)) return {};
            if (i) return i(t);
            e.prototype = t;
            var s = new e();
            return e.prototype = void 0, s;
          };
        }();
        var n = s("./node_modules/lodash-es/_getPrototype.js"),
          a = s("./node_modules/lodash-es/_isPrototype.js");
        var c = function c(e) {
          return "function" != typeof e.constructor || (0, a.Z)(e) ? {} : r((0, n.Z)(e));
        };
      },
      "./node_modules/lodash-es/_isIndex.js": function _node_modules_lodashEs__isIndexJs(e, t, s) {
        "use strict";

        s.d(t, {
          Z: function Z() {
            return i;
          }
        });
        var o = /^(?:0|[1-9]\d*)$/;
        var i = function i(e, t) {
          var s = typeof e;
          return !!(t = null == t ? 9007199254740991 : t) && ("number" == s || "symbol" != s && o.test(e)) && e > -1 && e % 1 == 0 && e < t;
        };
      },
      "./node_modules/lodash-es/_isPrototype.js": function _node_modules_lodashEs__isPrototypeJs(e, t, s) {
        "use strict";

        s.d(t, {
          Z: function Z() {
            return i;
          }
        });
        var o = Object.prototype;
        var i = function i(e) {
          var t = e && e.constructor;
          return e === ("function" == typeof t && t.prototype || o);
        };
      },
      "./node_modules/lodash-es/_nodeUtil.js": function _node_modules_lodashEs__nodeUtilJs(e, t, s) {
        "use strict";

        s.d(t, {
          Z: function Z() {
            return a;
          }
        });
        var o = s("./node_modules/lodash-es/_freeGlobal.js"),
          i = "object" == typeof exports && exports && !exports.nodeType && exports,
          r = i && "object" == typeof module && module && !module.nodeType && module,
          n = r && r.exports === i && o.Z.process;
        var a = function () {
          try {
            var e = r && r.require && r.require("util").types;
            return e || n && n.binding && n.binding("util");
          } catch (e) {}
        }();
      },
      "./node_modules/lodash-es/_overArg.js": function _node_modules_lodashEs__overArgJs(e, t, s) {
        "use strict";

        s.d(t, {
          Z: function Z() {
            return o;
          }
        });
        var o = function o(e, t) {
          return function (s) {
            return e(t(s));
          };
        };
      },
      "./node_modules/lodash-es/_root.js": function _node_modules_lodashEs__rootJs(e, t, s) {
        "use strict";

        s.d(t, {
          Z: function Z() {
            return r;
          }
        });
        var o = s("./node_modules/lodash-es/_freeGlobal.js"),
          i = "object" == typeof self && self && self.Object === Object && self;
        var r = o.Z || i || Function("return this")();
      },
      "./node_modules/lodash-es/_toSource.js": function _node_modules_lodashEs__toSourceJs(e, t, s) {
        "use strict";

        s.d(t, {
          Z: function Z() {
            return i;
          }
        });
        var o = Function.prototype.toString;
        var i = function i(e) {
          if (null != e) {
            try {
              return o.call(e);
            } catch (e) {}
            try {
              return e + "";
            } catch (e) {}
          }
          return "";
        };
      },
      "./node_modules/lodash-es/assignIn.js": function _node_modules_lodashEs_assignInJs(e, t, s) {
        "use strict";

        s.d(t, {
          Z: function Z() {
            return n;
          }
        });
        var o = s("./node_modules/lodash-es/_copyObject.js"),
          i = s("./node_modules/lodash-es/_createAssigner.js"),
          r = s("./node_modules/lodash-es/keysIn.js");
        var n = (0, i.Z)(function (e, t) {
          (0, o.Z)(t, (0, r.Z)(t), e);
        });
      },
      "./node_modules/lodash-es/clone.js": function _node_modules_lodashEs_cloneJs(e, t, s) {
        "use strict";

        s.d(t, {
          Z: function Z() {
            return i;
          }
        });
        var o = s("./node_modules/lodash-es/_baseClone.js");
        var i = function i(e) {
          return (0, o.Z)(e, 4);
        };
      },
      "./node_modules/lodash-es/cloneDeep.js": function _node_modules_lodashEs_cloneDeepJs(e, t, s) {
        "use strict";

        s.d(t, {
          Z: function Z() {
            return i;
          }
        });
        var o = s("./node_modules/lodash-es/_baseClone.js");
        var i = function i(e) {
          return (0, o.Z)(e, 5);
        };
      },
      "./node_modules/lodash-es/cloneDeepWith.js": function _node_modules_lodashEs_cloneDeepWithJs(e, t, s) {
        "use strict";

        s.d(t, {
          Z: function Z() {
            return i;
          }
        });
        var o = s("./node_modules/lodash-es/_baseClone.js");
        var i = function i(e, t) {
          return t = "function" == typeof t ? t : void 0, (0, o.Z)(e, 5, t);
        };
      },
      "./node_modules/lodash-es/debounce.js": function _node_modules_lodashEs_debounceJs(e, t, s) {
        "use strict";

        s.d(t, {
          Z: function Z() {
            return _;
          }
        });
        var o = s("./node_modules/lodash-es/isObject.js"),
          i = s("./node_modules/lodash-es/_root.js");
        var r = function r() {
          return i.Z.Date.now();
        };
        var n = /\s/;
        var a = function a(e) {
          for (var t = e.length; t-- && n.test(e.charAt(t)););
          return t;
        };
        var c = /^\s+/;
        var l = function l(e) {
          return e ? e.slice(0, a(e) + 1).replace(c, "") : e;
        };
        var d = s("./node_modules/lodash-es/isSymbol.js"),
          h = /^[-+]0x[0-9a-f]+$/i,
          u = /^0b[01]+$/i,
          g = /^0o[0-7]+$/i,
          p = parseInt;
        var f = function f(e) {
          if ("number" == typeof e) return e;
          if ((0, d.Z)(e)) return NaN;
          if ((0, o.Z)(e)) {
            var t = "function" == typeof e.valueOf ? e.valueOf() : e;
            e = (0, o.Z)(t) ? t + "" : t;
          }
          if ("string" != typeof e) return 0 === e ? e : +e;
          e = l(e);
          var s = u.test(e);
          return s || g.test(e) ? p(e.slice(2), s ? 2 : 8) : h.test(e) ? NaN : +e;
        };
        var m = Math.max,
          k = Math.min;
        var _ = function _(e, t, s) {
          var i,
            n,
            a,
            c,
            l,
            d,
            h = 0,
            u = !1,
            g = !1,
            p = !0;
          if ("function" != typeof e) throw new TypeError("Expected a function");
          function _(t) {
            var s = i,
              o = n;
            return i = n = void 0, h = t, c = e.apply(o, s);
          }
          function b(e) {
            return h = e, l = setTimeout(v, t), u ? _(e) : c;
          }
          function w(e) {
            var s = e - d;
            return void 0 === d || s >= t || s < 0 || g && e - h >= a;
          }
          function v() {
            var e = r();
            if (w(e)) return y(e);
            l = setTimeout(v, function (e) {
              var s = t - (e - d);
              return g ? k(s, a - (e - h)) : s;
            }(e));
          }
          function y(e) {
            return l = void 0, p && i ? _(e) : (i = n = void 0, c);
          }
          function Z() {
            var e = r(),
              s = w(e);
            if (i = arguments, n = this, d = e, s) {
              if (void 0 === l) return b(d);
              if (g) return clearTimeout(l), l = setTimeout(v, t), _(d);
            }
            return void 0 === l && (l = setTimeout(v, t)), c;
          }
          return t = f(t) || 0, (0, o.Z)(s) && (u = !!s.leading, a = (g = "maxWait" in s) ? m(f(s.maxWait) || 0, t) : a, p = "trailing" in s ? !!s.trailing : p), Z.cancel = function () {
            void 0 !== l && clearTimeout(l), h = 0, i = d = n = l = void 0;
          }, Z.flush = function () {
            return void 0 === l ? c : y(r());
          }, Z;
        };
      },
      "./node_modules/lodash-es/eq.js": function _node_modules_lodashEs_eqJs(e, t, s) {
        "use strict";

        s.d(t, {
          Z: function Z() {
            return o;
          }
        });
        var o = function o(e, t) {
          return e === t || e != e && t != t;
        };
      },
      "./node_modules/lodash-es/isArguments.js": function _node_modules_lodashEs_isArgumentsJs(e, t, s) {
        "use strict";

        s.d(t, {
          Z: function Z() {
            return l;
          }
        });
        var o = s("./node_modules/lodash-es/_baseGetTag.js"),
          i = s("./node_modules/lodash-es/isObjectLike.js");
        var r = function r(e) {
          return (0, i.Z)(e) && "[object Arguments]" == (0, o.Z)(e);
        };
        var n = Object.prototype,
          a = n.hasOwnProperty,
          c = n.propertyIsEnumerable;
        var l = r(function () {
          return arguments;
        }()) ? r : function (e) {
          return (0, i.Z)(e) && a.call(e, "callee") && !c.call(e, "callee");
        };
      },
      "./node_modules/lodash-es/isArray.js": function _node_modules_lodashEs_isArrayJs(e, t, s) {
        "use strict";

        s.d(t, {
          Z: function Z() {
            return o;
          }
        });
        var o = Array.isArray;
      },
      "./node_modules/lodash-es/isArrayLike.js": function _node_modules_lodashEs_isArrayLikeJs(e, t, s) {
        "use strict";

        s.d(t, {
          Z: function Z() {
            return r;
          }
        });
        var o = s("./node_modules/lodash-es/isFunction.js"),
          i = s("./node_modules/lodash-es/isLength.js");
        var r = function r(e) {
          return null != e && (0, i.Z)(e.length) && !(0, o.Z)(e);
        };
      },
      "./node_modules/lodash-es/isBuffer.js": function _node_modules_lodashEs_isBufferJs(e, t, s) {
        "use strict";

        s.d(t, {
          Z: function Z() {
            return c;
          }
        });
        var o = s("./node_modules/lodash-es/_root.js");
        var i = function i() {
          return !1;
        };
        var r = "object" == typeof exports && exports && !exports.nodeType && exports,
          n = r && "object" == typeof module && module && !module.nodeType && module,
          a = n && n.exports === r ? o.Z.Buffer : void 0;
        var c = (a ? a.isBuffer : void 0) || i;
      },
      "./node_modules/lodash-es/isElement.js": function _node_modules_lodashEs_isElementJs(e, t, s) {
        "use strict";

        s.d(t, {
          Z: function Z() {
            return r;
          }
        });
        var o = s("./node_modules/lodash-es/isObjectLike.js"),
          i = s("./node_modules/lodash-es/isPlainObject.js");
        var r = function r(e) {
          return (0, o.Z)(e) && 1 === e.nodeType && !(0, i.Z)(e);
        };
      },
      "./node_modules/lodash-es/isFunction.js": function _node_modules_lodashEs_isFunctionJs(e, t, s) {
        "use strict";

        s.d(t, {
          Z: function Z() {
            return r;
          }
        });
        var o = s("./node_modules/lodash-es/_baseGetTag.js"),
          i = s("./node_modules/lodash-es/isObject.js");
        var r = function r(e) {
          if (!(0, i.Z)(e)) return !1;
          var t = (0, o.Z)(e);
          return "[object Function]" == t || "[object GeneratorFunction]" == t || "[object AsyncFunction]" == t || "[object Proxy]" == t;
        };
      },
      "./node_modules/lodash-es/isLength.js": function _node_modules_lodashEs_isLengthJs(e, t, s) {
        "use strict";

        s.d(t, {
          Z: function Z() {
            return o;
          }
        });
        var o = function o(e) {
          return "number" == typeof e && e > -1 && e % 1 == 0 && e <= 9007199254740991;
        };
      },
      "./node_modules/lodash-es/isObject.js": function _node_modules_lodashEs_isObjectJs(e, t, s) {
        "use strict";

        s.d(t, {
          Z: function Z() {
            return o;
          }
        });
        var o = function o(e) {
          var t = typeof e;
          return null != e && ("object" == t || "function" == t);
        };
      },
      "./node_modules/lodash-es/isObjectLike.js": function _node_modules_lodashEs_isObjectLikeJs(e, t, s) {
        "use strict";

        s.d(t, {
          Z: function Z() {
            return o;
          }
        });
        var o = function o(e) {
          return null != e && "object" == typeof e;
        };
      },
      "./node_modules/lodash-es/isPlainObject.js": function _node_modules_lodashEs_isPlainObjectJs(e, t, s) {
        "use strict";

        s.d(t, {
          Z: function Z() {
            return h;
          }
        });
        var o = s("./node_modules/lodash-es/_baseGetTag.js"),
          i = s("./node_modules/lodash-es/_getPrototype.js"),
          r = s("./node_modules/lodash-es/isObjectLike.js"),
          n = Function.prototype,
          a = Object.prototype,
          c = n.toString,
          l = a.hasOwnProperty,
          d = c.call(Object);
        var h = function h(e) {
          if (!(0, r.Z)(e) || "[object Object]" != (0, o.Z)(e)) return !1;
          var t = (0, i.Z)(e);
          if (null === t) return !0;
          var s = l.call(t, "constructor") && t.constructor;
          return "function" == typeof s && s instanceof s && c.call(s) == d;
        };
      },
      "./node_modules/lodash-es/isSymbol.js": function _node_modules_lodashEs_isSymbolJs(e, t, s) {
        "use strict";

        s.d(t, {
          Z: function Z() {
            return r;
          }
        });
        var o = s("./node_modules/lodash-es/_baseGetTag.js"),
          i = s("./node_modules/lodash-es/isObjectLike.js");
        var r = function r(e) {
          return "symbol" == typeof e || (0, i.Z)(e) && "[object Symbol]" == (0, o.Z)(e);
        };
      },
      "./node_modules/lodash-es/isTypedArray.js": function _node_modules_lodashEs_isTypedArrayJs(e, t, s) {
        "use strict";

        s.d(t, {
          Z: function Z() {
            return h;
          }
        });
        var o = s("./node_modules/lodash-es/_baseGetTag.js"),
          i = s("./node_modules/lodash-es/isLength.js"),
          r = s("./node_modules/lodash-es/isObjectLike.js"),
          n = {};
        n["[object Float32Array]"] = n["[object Float64Array]"] = n["[object Int8Array]"] = n["[object Int16Array]"] = n["[object Int32Array]"] = n["[object Uint8Array]"] = n["[object Uint8ClampedArray]"] = n["[object Uint16Array]"] = n["[object Uint32Array]"] = !0, n["[object Arguments]"] = n["[object Array]"] = n["[object ArrayBuffer]"] = n["[object Boolean]"] = n["[object DataView]"] = n["[object Date]"] = n["[object Error]"] = n["[object Function]"] = n["[object Map]"] = n["[object Number]"] = n["[object Object]"] = n["[object RegExp]"] = n["[object Set]"] = n["[object String]"] = n["[object WeakMap]"] = !1;
        var a = function a(e) {
          return (0, r.Z)(e) && (0, i.Z)(e.length) && !!n[(0, o.Z)(e)];
        };
        var c = s("./node_modules/lodash-es/_baseUnary.js"),
          l = s("./node_modules/lodash-es/_nodeUtil.js"),
          d = l.Z && l.Z.isTypedArray;
        var h = d ? (0, c.Z)(d) : a;
      },
      "./node_modules/lodash-es/keys.js": function _node_modules_lodashEs_keysJs(e, t, s) {
        "use strict";

        s.d(t, {
          Z: function Z() {
            return l;
          }
        });
        var o = s("./node_modules/lodash-es/_arrayLikeKeys.js"),
          i = s("./node_modules/lodash-es/_isPrototype.js");
        var r = (0, s("./node_modules/lodash-es/_overArg.js").Z)(Object.keys, Object);
        var n = Object.prototype.hasOwnProperty;
        var a = function a(e) {
          if (!(0, i.Z)(e)) return r(e);
          var t = [];
          for (var s in Object(e)) n.call(e, s) && "constructor" != s && t.push(s);
          return t;
        };
        var c = s("./node_modules/lodash-es/isArrayLike.js");
        var l = function l(e) {
          return (0, c.Z)(e) ? (0, o.Z)(e) : a(e);
        };
      },
      "./node_modules/lodash-es/keysIn.js": function _node_modules_lodashEs_keysInJs(e, t, s) {
        "use strict";

        s.d(t, {
          Z: function Z() {
            return d;
          }
        });
        var o = s("./node_modules/lodash-es/_arrayLikeKeys.js"),
          i = s("./node_modules/lodash-es/isObject.js"),
          r = s("./node_modules/lodash-es/_isPrototype.js");
        var n = function n(e) {
          var t = [];
          if (null != e) for (var s in Object(e)) t.push(s);
          return t;
        };
        var a = Object.prototype.hasOwnProperty;
        var c = function c(e) {
          if (!(0, i.Z)(e)) return n(e);
          var t = (0, r.Z)(e),
            s = [];
          for (var o in e) ("constructor" != o || !t && a.call(e, o)) && s.push(o);
          return s;
        };
        var l = s("./node_modules/lodash-es/isArrayLike.js");
        var d = function d(e) {
          return (0, l.Z)(e) ? (0, o.Z)(e, !0) : c(e);
        };
      },
      "./node_modules/lodash-es/stubArray.js": function _node_modules_lodashEs_stubArrayJs(e, t, s) {
        "use strict";

        s.d(t, {
          Z: function Z() {
            return o;
          }
        });
        var o = function o() {
          return [];
        };
      },
      "./node_modules/lodash-es/throttle.js": function _node_modules_lodashEs_throttleJs(e, t, s) {
        "use strict";

        s.d(t, {
          Z: function Z() {
            return r;
          }
        });
        var o = s("./node_modules/lodash-es/debounce.js"),
          i = s("./node_modules/lodash-es/isObject.js");
        var r = function r(e, t, s) {
          var r = !0,
            n = !0;
          if ("function" != typeof e) throw new TypeError("Expected a function");
          return (0, i.Z)(s) && (r = "leading" in s ? !!s.leading : r, n = "trailing" in s ? !!s.trailing : n), (0, o.Z)(e, t, {
            leading: r,
            maxWait: t,
            trailing: n
          });
        };
      },
      "./node_modules/lodash-es/toString.js": function _node_modules_lodashEs_toStringJs(e, t, s) {
        "use strict";

        s.d(t, {
          Z: function Z() {
            return d;
          }
        });
        var o = s("./node_modules/lodash-es/_Symbol.js");
        var i = function i(e, t) {
          for (var s = -1, o = null == e ? 0 : e.length, i = Array(o); ++s < o;) i[s] = t(e[s], s, e);
          return i;
        };
        var r = s("./node_modules/lodash-es/isArray.js"),
          n = s("./node_modules/lodash-es/isSymbol.js"),
          a = o.Z ? o.Z.prototype : void 0,
          c = a ? a.toString : void 0;
        var l = function e(t) {
          if ("string" == typeof t) return t;
          if ((0, r.Z)(t)) return i(t, e) + "";
          if ((0, n.Z)(t)) return c ? c.call(t) : "";
          var s = t + "";
          return "0" == s && 1 / t == -Infinity ? "-0" : s;
        };
        var d = function d(e) {
          return null == e ? "" : l(e);
        };
      }
    },
    t = {};
  function s(o) {
    var i = t[o];
    if (void 0 !== i) return i.exports;
    var r = t[o] = {
      id: o,
      exports: {}
    };
    return e[o](r, r.exports, s), r.exports;
  }
  s.n = function (e) {
    var t = e && e.__esModule ? function () {
      return e.default;
    } : function () {
      return e;
    };
    return s.d(t, {
      a: t
    }), t;
  }, s.d = function (e, t) {
    for (var o in t) s.o(t, o) && !s.o(e, o) && Object.defineProperty(e, o, {
      enumerable: !0,
      get: t[o]
    });
  }, s.g = function () {
    if ("object" == typeof globalThis) return globalThis;
    try {
      return this || new Function("return this")();
    } catch (e) {
      if ("object" == typeof window) return window;
    }
  }(), s.o = function (e, t) {
    return Object.prototype.hasOwnProperty.call(e, t);
  }, s.r = function (e) {
    "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
      value: "Module"
    }), Object.defineProperty(e, "__esModule", {
      value: !0
    });
  };
  var o = s("?7cdd");
  (window.CKEditor5 = window.CKEditor5 || {}).dll = o;
}(), function (e) {
  e.CKEditor5 = e.CKEditor5 || {};
  var t = ["utils", "core", "engine", "ui", "clipboard", "enter", "paragraph", "select-all", "typing", "undo", "upload", "widget"];
  for (var _i125 = 0, _t242 = t; _i125 < _t242.length; _i125++) {
    var s = _t242[_i125];
    var _t243 = s.replace(/-([a-z])/g, function (e, t) {
      return t.toUpperCase();
    });
    e.CKEditor5[_t243] = e.CKEditor5.dll("./src/".concat(s, ".js"));
  }
}(window);